import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date */
  Date: any;
  /** A hash */
  Hash: any;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: Date;
  /** Represents untyped JSON */
  JSON: any;
  /** A timestamp that should not include a time zone. Example: "2022-01-19T16:00". */
  TimeWithoutZone: string;
  /** A time zone, named in the form "Eastern Time (US & Canada)" or "America/New_York". */
  TimeZone: string;
};

/** Autogenerated input type of AcceptTermsOfService */
export type AcceptTermsOfServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the terms of service being accepted. */
  termsOfServiceId: Scalars['ID'];
};

/** Autogenerated return type of AcceptTermsOfService. */
export type AcceptTermsOfServicePayload = {
  __typename?: 'AcceptTermsOfServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** Whether the terms of service was accepted. */
  termsOfServiceUserAgreement?: Maybe<TermsOfServiceUserAgreement>;
};

/** A subscription, via Stripe, to a plan which grants access (unlimited usage for a single user) to a set of courses. */
export type AccessSubscription = RelayNode & StripeSubscriptionInterface & {
  __typename?: 'AccessSubscription';
  /** Whether the subscription is paid for continuous access to content. */
  accessControlled: Scalars['Boolean'];
  /** The courses associated with your subscription. */
  courses: CourseConnection;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The grants provided by the subscription. */
  grants: GrantConnection;
  /** The integer ID. */
  id: Scalars['Int'];
  /** Any paths for this subscription. */
  paths: StripeSubscriptionPaths;
  /** The number of seconds until the subscription will go into delinquency and be unusable. Is null while payment is in good standing. */
  secondsRemainingInArrears?: Maybe<Scalars['Int']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The status of the stripe subscription. */
  status: StripeSubscriptionStatusEnum;
  /** The Stripe customer. */
  stripeCustomer: StripeCustomer;
  /** The Stripe payment method which will be charged every billing period. */
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  /** The Stripe plan. */
  stripePlan: StripePlan;
  /** The Stripe ID for this subscription. */
  stripeSubscriptionId: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Whether the subscription is paid depending on usage during the time period. */
  usageControlled: Scalars['Boolean'];
};


/** A subscription, via Stripe, to a plan which grants access (unlimited usage for a single user) to a set of courses. */
export type AccessSubscriptionCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A subscription, via Stripe, to a plan which grants access (unlimited usage for a single user) to a set of courses. */
export type AccessSubscriptionGrantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of AddCourseToStorefront */
export type AddCourseToStorefrontInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of course to add. */
  courseId: Scalars['ID'];
  /** The ID of the storefront the course will be added to. */
  storefrontId: Scalars['ID'];
};

/** Autogenerated return type of AddCourseToStorefront. */
export type AddCourseToStorefrontPayload = {
  __typename?: 'AddCourseToStorefrontPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course provided. */
  course: Course;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The product that was created. */
  product?: Maybe<Product>;
};

/** Autogenerated input type of AddExamToCourse */
export type AddExamToCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the course to add the exam to. */
  courseId: Scalars['Int'];
  /** Settings for the exam. */
  examSettings: AddExamToCourseSettings;
};

/** Autogenerated return type of AddExamToCourse. */
export type AddExamToCoursePayload = {
  __typename?: 'AddExamToCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course that was updated. */
  course: Course;
  /** The new course item. */
  courseItem: CourseItem;
};

/** Settings needed to add an exam to a course. */
export type AddExamToCourseSettings = {
  /** The number of attempts the learner is allowed. */
  attempts?: InputMaybe<Scalars['Int']>;
  /** The ID of the exam (a NitoExam). */
  examId: Scalars['ID'];
  /** Allows the user to continue to access the exam after passing. Allows total attempts up to the number of attempts allowed (if any). */
  practiceable?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of AddGradedAssignmentToCourse */
export type AddGradedAssignmentToCourseInput = {
  /** Attributes to attach assignment */
  assignmentAttributes: GradedAssignmentAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the course to add the exam to. */
  courseId: Scalars['ID'];
};

/** Autogenerated return type of AddGradedAssignmentToCourse. */
export type AddGradedAssignmentToCoursePayload = {
  __typename?: 'AddGradedAssignmentToCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course that was updated. */
  course: Course;
  /** The new course item. */
  courseItem?: Maybe<CourseItem>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of AddILCourseToCourse */
export type AddIlCourseToCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the course to add the instructor-led course to. */
  courseId: Scalars['ID'];
  /** The ID of the instructor-led course to add the regular course. */
  ilCourseId: Scalars['ID'];
};

/** Autogenerated return type of AddILCourseToCourse. */
export type AddIlCourseToCoursePayload = {
  __typename?: 'AddILCourseToCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course that was updated. */
  course?: Maybe<Course>;
  /** The new instructor-led course item. */
  courseItem?: Maybe<CourseItem>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of AddItemToCourse */
export type AddItemToCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the course to add the item to. */
  courseId: Scalars['ID'];
  /** Properties that define a course item. */
  itemAttributes: CourseItemAttributes;
  /** Properties that define a course item to replace. */
  replaceCourseItem?: InputMaybe<CourseItemReplacementAttributes>;
};

/** Autogenerated return type of AddItemToCourse. */
export type AddItemToCoursePayload = {
  __typename?: 'AddItemToCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course that was updated. */
  course: Course;
  /** The new course item. */
  courseItem?: Maybe<CourseItem>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of AddLinkToCourse */
export type AddLinkToCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the course to add the exam to. */
  courseId: Scalars['Int'];
  /** The name of the course item */
  name: Scalars['String'];
  /** The url of the course item */
  url: Scalars['String'];
};

/** Autogenerated return type of AddLinkToCourse. */
export type AddLinkToCoursePayload = {
  __typename?: 'AddLinkToCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course that was updated. */
  course: Course;
  /** The new course item. */
  courseItem?: Maybe<CourseItem>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to add a product to a shopping cart. */
export type AddProductToCartAttributes = {
  /** The integer ID of the product to add to the cart */
  productId: Scalars['Int'];
  /** The quantity of the product to add to the cart */
  quantity: Scalars['Int'];
};

/** Autogenerated input type of AddProductToCart */
export type AddProductToCartInput = {
  /** The attributes to add an item into the cart */
  cartItem: AddProductToCartAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AddProductToCart. */
export type AddProductToCartPayload = {
  __typename?: 'AddProductToCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The created cart item. */
  shoppingCart: ShoppingCart;
};

/** An address. */
export type Address = RelayNode & {
  __typename?: 'Address';
  /** First line of the address. */
  address1: Scalars['String'];
  /** Second line of the address. */
  address2?: Maybe<Scalars['String']>;
  /** The city. */
  city: Scalars['String'];
  /** The country, with an ISO code and name. */
  country: Country;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The postal code. */
  postalCode: Scalars['String'];
  /** The province, with an ISO code and name. */
  province?: Maybe<Location>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes to update a user address. */
export type AddressAttributes = {
  /** First line of the address. */
  address1?: InputMaybe<Scalars['String']>;
  /** Second line of the address. */
  address2?: InputMaybe<Scalars['String']>;
  /** The city. */
  city?: InputMaybe<Scalars['String']>;
  /** The ISO code of the country. */
  country?: InputMaybe<CodedLocation>;
  /** The ID for the Address record we are updating. */
  id?: InputMaybe<Scalars['Int']>;
  /** The postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** The ISO code of the province. */
  province?: InputMaybe<CodedLocation>;
};

/** A requirement specified by a course for an address to be added to the user's account. */
export type AddressCourseRequirement = CourseRequirementInterface & RelayNode & {
  __typename?: 'AddressCourseRequirement';
  /** The course which has the requirement. */
  course: Course;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Has the user satisfied this requirement? */
  satisfied: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The kind of requirement specified by the course. */
  type: CourseRequirementsTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A requirement specified by a course for an address to be added to the user's account. */
export type AddressCourseRequirementSatisfiedArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};

/** Options for address */
export enum AddressKindEnum {
  /** Billing address */
  Billing = 'billing',
  /** Shipping address */
  Shipping = 'shipping'
}

/** Autogenerated input type of AgreeToCourseAgreement */
export type AgreeToCourseAgreementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The course agreement you are agreeing to. */
  courseUserAgreementId: Scalars['ID'];
};

/** Autogenerated return type of AgreeToCourseAgreement. */
export type AgreeToCourseAgreementPayload = {
  __typename?: 'AgreeToCourseAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The updated course agreement. */
  courseUserAgreement?: Maybe<CourseUserAgreement>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of ApplyTrainingRole */
export type ApplyTrainingRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the learner to update. */
  learnerId: Scalars['ID'];
  /** ID of the training role to apply. */
  trainingRole: Scalars['ID'];
};

/** Autogenerated return type of ApplyTrainingRole. */
export type ApplyTrainingRolePayload = {
  __typename?: 'ApplyTrainingRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created training role application */
  trainingRoleApplication?: Maybe<TrainingRoleApplication>;
};

/** An ApplicationRecord that imports Archivable. */
export type Archivable = {
  /** The archive state of the record. */
  archived: Scalars['Boolean'];
  /** The date this record was archived. */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID of this record. */
  gid: Scalars['ID'];
  /** The ID of this record. */
  id: Scalars['Int'];
};

/** Autogenerated input type of AssignMatrixTraining */
export type AssignMatrixTrainingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the learner to update. */
  learnerIds: Array<Scalars['ID']>;
  /** The ID of the training competency to be assigned. */
  trainingCompetencyId?: InputMaybe<Scalars['ID']>;
  /** Array of training role IDs */
  trainingRoles: Array<Scalars['ID']>;
};

/** Autogenerated return type of AssignMatrixTraining. */
export type AssignMatrixTrainingPayload = {
  __typename?: 'AssignMatrixTrainingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** Assign service has queued and mutation was successful. */
  ok: Scalars['Boolean'];
};

/** Autogenerated input type of AssignTraining */
export type AssignTrainingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of an ILClass to book the learner into. */
  ilClassIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The global ID of the learner to update. */
  learnerId: Scalars['ID'];
  /** The ID of the license or license group to grant the learners with. */
  licenseId: Scalars['ID'];
  /** Tags to add to the invite. */
  tags?: InputMaybe<Array<TagAttributes>>;
};

/** Autogenerated return type of AssignTraining. */
export type AssignTrainingPayload = {
  __typename?: 'AssignTrainingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The created invite. */
  invite?: Maybe<Invite>;
  /** The CommonLicense you used. */
  license: CommonLicense;
};

/** Details about an attache file */
export type AttacheFile = {
  __typename?: 'AttacheFile';
  /** The file size in bytes. */
  bytes: Scalars['Int'];
  /** The file's MIME type. */
  contentType: Scalars['String'];
  /** An image file's original geometry (i.e. 300x300). */
  geometry?: Maybe<Scalars['String']>;
  /** A substring of the URL, relative to Attache's configured view URL. */
  path: Scalars['String'];
  /** The attache server's signature of the file, verifying authenticity. */
  signature: Scalars['String'];
  /** Where to access the file. */
  url: Scalars['String'];
};

/** The url and params needed to upload a file to the Attache server. */
export type AttacheOptions = {
  __typename?: 'AttacheOptions';
  /** The base url where the file may be retrieved after upload via GET. */
  downloadUrl: Scalars['String'];
  /** Time that these credentials will no longer be valid (seconds since the epoch). */
  expiration: Scalars['Int'];
  /** An authorization key for uploads to the Attache server. */
  hmac: Scalars['String'];
  /** The url where the file should be uploaded via PUT. Add the other attributes here as url params as well as the filename using "file" as the param key. */
  uploadUrl: Scalars['String'];
  /** A randomly generated UUID. */
  uuid: Scalars['String'];
};

/** Attributes needed to connect to a file uploaded to the attache file server */
export type AttacheUploadFile = {
  /** The size of the file, in bytes. */
  bytes: Scalars['Int'];
  /** The MIME type of the file uploaded. */
  contentType: Scalars['String'];
  /** If the file is an image; this is the image's original geometry (i.e. 300x300). */
  geometry?: InputMaybe<Scalars['String']>;
  /** The URL path to the file on attache (following the configured download URL). */
  path: Scalars['String'];
  /** A signature returned by the Attache server prooving the validity of the attachment. */
  signature: Scalars['String'];
  /** The URL for viewing this file. Not necessary for update but allowed for convenience. */
  url?: InputMaybe<Scalars['String']>;
};

/** Valid audiences used for Saved Queries. */
export enum AudienceEnum {
  /** An audience representing authors */
  Author = 'author',
  /** An audience representing graders */
  Grader = 'grader',
  /** An audience representing IL managers */
  IlManager = 'il_manager',
  /** An audience representing instructors */
  Instructor = 'instructor',
  /** An audience representing training managers */
  TrainingManager = 'training_manager',
  /** An audience representing vendors */
  Vendor = 'vendor'
}

/** A constant value to use in automation workflows. */
export type AutomationConstant = RelayNode & {
  __typename?: 'AutomationConstant';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of this constant. */
  name: Scalars['String'];
  /** Whether this constant is secret or not. */
  secret: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The value of this constant, or <redacted> if it's secret. */
  value: Scalars['String'];
};

/** Find automation constants you can manage. */
export type AutomationConstantsNamespace = {
  __typename?: 'AutomationConstantsNamespace';
  /** Find a single automationconstant by its string ID. */
  findByGid?: Maybe<AutomationConstant>;
  /** Find a single automationconstant by its integer ID. */
  findById: AutomationConstant;
  /** Find a single automationconstant by its signed ID. */
  findBySgid?: Maybe<AutomationConstant>;
};


/** Find automation constants you can manage. */
export type AutomationConstantsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find automation constants you can manage. */
export type AutomationConstantsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find automation constants you can manage. */
export type AutomationConstantsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** Valid event types for automations. */
export enum AutomationEvent {
  /** When a user is certified */
  CertificationCreated = 'certification_created',
  /** When a user finishes a course on your storefront */
  CourseCompleted = 'course_completed',
  /** When a user completes a course item */
  CourseItemCompleted = 'course_item_completed',
  /** When a user starts a course item */
  CourseItemStarted = 'course_item_started',
  /** When a user starts a course */
  CourseStarted = 'course_started',
  /** When a user completes an exam */
  ExamCompleted = 'exam_completed',
  /** When a user is granted a course */
  GrantCreated = 'grant_created',
  /** When triggered from another script */
  Manual = 'manual',
  /** When a support agent submits an order on behalf of a client */
  OfflineOrderCreated = 'offline_order_created',
  /** When an order is created */
  OrderCreated = 'order_created',
  /** When an order is refunded */
  OrderRefunded = 'order_refunded',
  /** When a user signs into your storefront */
  UserSignedIn = 'user_signed_in',
  /** When a user signs up */
  UserSignedUp = 'user_signed_up'
}

/** Logs for automation scripts. */
export type AutomationLog = RelayNode & {
  __typename?: 'AutomationLog';
  /** The child logs for this log. */
  childLogs: Array<AutomationLog>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The message of the log. */
  message: Scalars['String'];
  /** The parent log id, used for log grouping. */
  parentLogId?: Maybe<Scalars['ID']>;
  /** The severity of the log. */
  severity: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The sidekiq job id. */
  sidekiqJobId?: Maybe<Scalars['String']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A script used for automating things when certain events happen in your organization. */
export type AutomationScript = RelayNode & {
  __typename?: 'AutomationScript';
  /** The logs for this automation script. */
  automationLogs: Array<AutomationLog>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Whether this script is enabled or not. */
  enabled: Scalars['Boolean'];
  /** The event that this script is triggered from. */
  event: AutomationEvent;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The LUA script to execute. */
  lua: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The title of this script. */
  title: Scalars['String'];
  /** The translated version of the event. */
  translatedEvent: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Find automation scripts you can manage. */
export type AutomationScriptsNamespace = {
  __typename?: 'AutomationScriptsNamespace';
  /** The kinds of events automation scripts can be for. */
  eventTypes: Array<DescribedAutomationEvent>;
  /** Find a single automationscript by its string ID. */
  findByGid?: Maybe<AutomationScript>;
  /** Find a single automationscript by its integer ID. */
  findById: AutomationScript;
  /** Find a single automationscript by its signed ID. */
  findBySgid?: Maybe<AutomationScript>;
};


/** Find automation scripts you can manage. */
export type AutomationScriptsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find automation scripts you can manage. */
export type AutomationScriptsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find automation scripts you can manage. */
export type AutomationScriptsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** Autogenerated input type of AvalaraSyncProducts */
export type AvalaraSyncProductsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the integration to sync. */
  integrationGid: Scalars['ID'];
};

/** Autogenerated return type of AvalaraSyncProducts. */
export type AvalaraSyncProductsPayload = {
  __typename?: 'AvalaraSyncProductsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** If the background jobs to sync products was queued. */
  ok: Scalars['Boolean'];
};

/** The billing address associated with an order. */
export type BillingAddress = {
  __typename?: 'BillingAddress';
  /** The first line of the address (usually number and street). */
  address1?: Maybe<Scalars['String']>;
  /** The optional second line of the address. */
  address2?: Maybe<Scalars['String']>;
  /** The city of purchase. */
  city?: Maybe<Scalars['String']>;
  /** The country of purchase. */
  country: Country;
  /** The integer ID. */
  id?: Maybe<Scalars['Int']>;
  /** The postal code of purchase. */
  postalCode?: Maybe<Scalars['String']>;
  /** The province of purchase. */
  province?: Maybe<Location>;
};

/** Options for booking on purchase. */
export enum BookDuringPurchaseEnum {
  /** Booking during purchase is disallowed. */
  Disallowed = 'disallowed',
  /** Booking during purchase is enforced. */
  Enforced = 'enforced',
  /** Booking during purchase is optional. */
  Optional = 'optional'
}

export type BookingWindow = {
  __typename?: 'BookingWindow';
  endsAt: Scalars['Date'];
  startsAt?: Maybe<Scalars['Date']>;
};

/** Options for Bulk Discounts. */
export type BulkDiscountOptions = {
  __typename?: 'BulkDiscountOptions';
  /** has custom pricing. */
  hasCustomPricing: Scalars['Boolean'];
  /** Discount levels for this product. */
  levels: Array<DiscountLevel>;
};

/** Attributes for bulk discounts on product default. */
export type BulkDiscountOptionsAttributes = {
  /** Show sales contact information for custom pricing? */
  hasCustomPricing: Scalars['Boolean'];
  /** The discount levels available. */
  levels: Array<DiscountLevelAttributes>;
};

/** A union type representing the types that can be calculables. */
export type CalculableUnion = DynamicContract | MonthlyActiveUsersRateContract | MonthlyCourseDistributionRateContract | OneTimeFeeContract | RecurringFlatFeeContract | ScormCourseRateContract | StripeTransactionFeeContract;

/** Autogenerated input type of CancelILBooking */
export type CancelIlBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the instructor-led booking */
  ilBookingId: Scalars['ID'];
};

/** Autogenerated return type of CancelILBooking. */
export type CancelIlBookingPayload = {
  __typename?: 'CancelILBookingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The new instructor-led booking. */
  ilBooking?: Maybe<IlBooking>;
};

/** Autogenerated input type of CancelOfflineOrder */
export type CancelOfflineOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CancelOfflineOrder. */
export type CancelOfflineOrderPayload = {
  __typename?: 'CancelOfflineOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** A truthy value if things go as planned */
  success: Scalars['Boolean'];
};

/** A representation of cart item */
export type CartItem = RelayNode & {
  __typename?: 'CartItem';
  /** If there is a discount level applied for the quantity of this item. */
  bulkDiscountApplied: Scalars['Boolean'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The full price of this cart item with split promo code */
  fullPrice: Scalars['Float'];
  /** The full price of this cart item with split promo code */
  fullPriceFormatted: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The pending bookings for IL Classes */
  pendingIlBookingReservations: Array<PendingIlBookingReservation>;
  /** The price of this cart item */
  price: Scalars['Float'];
  /** The price of this cart item */
  priceFormatted: Scalars['String'];
  /** The product of the cart item */
  product: Product;
  /** The promo code associated to this claim */
  promoCode?: Maybe<PromoCode>;
  /** The promo code claim applied to this cart item */
  promoCodeClaim?: Maybe<PromoCodeClaim>;
  /** The quantity */
  promoPriceQuantity?: Maybe<Scalars['Int']>;
  /** The quantity */
  quantity: Scalars['Int'];
  /** The quantity reminder for the split promo */
  quantityRemainder?: Maybe<Scalars['Int']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Whether this item is a split promo */
  splitPromo: Scalars['Boolean'];
  /** The total price of this cart item. */
  total: Scalars['Float'];
  /** The total price of this cart item. */
  totalFormatted: Scalars['String'];
  /** The total taxed of this cart item. */
  totalTaxed: Scalars['Float'];
  /** The total taxed of this cart item. */
  totalTaxedFormatted: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A representation of cart item */
export type CartItemFullPriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A representation of cart item */
export type CartItemPriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A representation of cart item */
export type CartItemTotalFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A representation of cart item */
export type CartItemTotalTaxedFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for CartItem. */
export type CartItemConnection = {
  __typename?: 'CartItemConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CartItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CartItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CartItemEdge = {
  __typename?: 'CartItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CartItem>;
};

/** Access your cart items. */
export type CartItemsNamespace = {
  __typename?: 'CartItemsNamespace';
  /** Get all your cart items for the current storefront. */
  all: CartItemConnection;
  /** Find a single cartitem by its string ID. */
  findByGid?: Maybe<CartItem>;
  /** Find a single cartitem by its integer ID. */
  findById: CartItem;
  /** Find a single cartitem by its signed ID. */
  findBySgid?: Maybe<CartItem>;
};


/** Access your cart items. */
export type CartItemsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Access your cart items. */
export type CartItemsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Access your cart items. */
export type CartItemsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Access your cart items. */
export type CartItemsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** A certification awarded to a user. */
export type Certification = Archivable & LearnerVerifiable & RelayNode & Taggable & {
  __typename?: 'Certification';
  /** The archive state of the record. */
  archived: Scalars['Boolean'];
  /** The date this record was archived. */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The badge image for this certification. */
  badgeUrl: Scalars['String'];
  /** Any permissions you have relevant to the Certification. */
  can: CertificationPermissions;
  /** The course that this certification was from. */
  course?: Maybe<Course>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The description of this certification. */
  description?: Maybe<Scalars['String']>;
  /** When this certification expires. */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The grant that this certification is from. */
  grant?: Maybe<Grant>;
  /** The integer ID. */
  id: Scalars['Int'];
  /** The address of the issuer. */
  issuerAddress?: Maybe<Address>;
  /** The entity that issued this certification. */
  issuerName: Scalars['String'];
  /** The status of LV services for this item. */
  learnerVerifiedStatus: Scalars['String'];
  /** The name of the certification. */
  name: Scalars['String'];
  /** The number of this certification, which can be used to validate it. */
  number: Scalars['String'];
  /** The URL to display this certification in the browser. */
  publicUrl: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The tags on this object. */
  tags: Array<Tag>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** If this certification was manually uploaded. */
  uploaded?: Maybe<Scalars['Boolean']>;
  /** The user that owns this certification. */
  user?: Maybe<User>;
  /** The first name that appears on this certification. */
  userFirstName: Scalars['String'];
  /** The primary key of the user that owns this certification. */
  userId: Scalars['Int'];
  /** The last name that appears on this certification. */
  userLastName: Scalars['String'];
  /** If this certification has been exported to a Verifiable Credential wallet. */
  verifiedCredentialExported: Scalars['Boolean'];
  /** The verified credential issuer for this certification. */
  verifiedCredentialIssuer?: Maybe<VerifiedCredentialIssuer>;
  /** The full status of this certification including any errors relating to whether the owner of the certification can request a verified credential. */
  verifiedCredentialStatus: VerifiedCredentialStatusEnum;
  /** The URL to verify this certification. */
  verifyUrl: Scalars['String'];
  /** The wall certificate PDF for this certification. */
  wallCertificateUrl?: Maybe<Scalars['String']>;
  /** The wallet card PDF for this certification. */
  walletCardUrl?: Maybe<Scalars['String']>;
};


/** A certification awarded to a user. */
export type CertificationBadgeUrlArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};

/** A certification awarded to a user. */
export type CertificationChangeRequest = RelayNode & {
  __typename?: 'CertificationChangeRequest';
  /** When the change request was approved. */
  approvedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Permissions on this certification change request. */
  can: CertificationChangeRequestPermissions;
  /** The certification this change request is for. */
  certification: Certification;
  /** The ID of the certification we want to to change. */
  certificationId: Scalars['Int'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who has request this change */
  createdBy?: Maybe<LightUser>;
  /** When the change request was declined. */
  declinedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The address that should appear on this certification. */
  issuerAddress?: Maybe<Address>;
  /** The issuer name that should appear on this certification. */
  issuerName: Scalars['String'];
  /** The reason for the changes. */
  reason: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The first name that should appear on this certification. */
  userFirstName: Scalars['String'];
  /** The last name that should appear on this certification. */
  userLastName: Scalars['String'];
  /** The verified credentials that have been issued for this change request. */
  verifiedCredential?: Maybe<VerifiedCredential>;
};

/** The connection type for CertificationChangeRequest. */
export type CertificationChangeRequestConnection = {
  __typename?: 'CertificationChangeRequestConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CertificationChangeRequestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CertificationChangeRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CertificationChangeRequestEdge = {
  __typename?: 'CertificationChangeRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CertificationChangeRequest>;
};

/** Permissions on this certification change request. */
export type CertificationChangeRequestPermissions = {
  __typename?: 'CertificationChangeRequestPermissions';
  /** Whether you can approve this change request. */
  approve: Scalars['Boolean'];
  /** Whether you can decline this change request. */
  decline: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
};

/** The statuses a certification change request can be updated with. */
export enum CertificationChangeRequestStatus {
  /** Approve the request and persist changes to the certification. */
  Approved = 'approved',
  /** Decline the request and reject the changes. */
  Declined = 'declined'
}

/** Active Certification Change Requests. */
export type CertificationChangeRequestsNamespace = {
  __typename?: 'CertificationChangeRequestsNamespace';
  /** All your Certification Change Requests that require attention. */
  all: CertificationChangeRequestConnection;
};


/** Active Certification Change Requests. */
export type CertificationChangeRequestsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Certification. */
export type CertificationConnection = {
  __typename?: 'CertificationConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CertificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Certification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An instance of a certification default which belongs to a User. */
export type CertificationDefault = RelayNode & {
  __typename?: 'CertificationDefault';
  /** The organization address that will be added to certificates. */
  address?: Maybe<Address>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The organization logo that will be added to certificates. */
  customLogo?: Maybe<AttacheFile>;
  /** The signature that will be added to certificates. */
  customSignature?: Maybe<AttacheFile>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name that will be credited as the issuer on certificates. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** An instance of a certification default which belongs to a User. */
export type CertificationDefaultCustomLogoArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};


/** An instance of a certification default which belongs to a User. */
export type CertificationDefaultCustomSignatureArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};

/** An edge in a connection. */
export type CertificationEdge = {
  __typename?: 'CertificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Certification>;
};

/** Permissions for a Certification. */
export type CertificationPermissions = {
  __typename?: 'CertificationPermissions';
  /** Whether you can archive this certification. */
  archive: Scalars['Boolean'];
  /** Whether you can destroy this certification. */
  destroy: Scalars['Boolean'];
  /** Whether you are able to export this certification as a verifiable credential. */
  exportVerifiedCredential: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can post this certification to credivera. */
  postToCredivera: Scalars['Boolean'];
  /** Whether you can request an update to information on this certification. */
  requestChange: Scalars['Boolean'];
  /** Whether you are able to share this certification to socials. */
  shareToSocial: Scalars['Boolean'];
  /** Whether you can see this certification. */
  show: Scalars['Boolean'];
  /** Whether you can unarchive this certification. */
  unarchive: Scalars['Boolean'];
  /** Whether this credential is elligible to be a verified credential. */
  verifiedCredential: Scalars['Boolean'];
};

/** A representation of a certification for a course. */
export type CertificationTemplate = RelayNode & {
  __typename?: 'CertificationTemplate';
  /** Any permissions you have relevant to the Certification Template. */
  can: CertificationTemplatePermissions;
  /** The course witch this certification template belongs to */
  course?: Maybe<Course>;
  /** The course item used to determine the issue date of the certification */
  courseItem?: Maybe<CourseItem>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The credential configuration for this certification template */
  credentialConfiguration?: Maybe<CredentialConfiguration>;
  /** The number of days the certification will be valid after issuance */
  daysValid?: Maybe<Scalars['Int']>;
  /** The description of the generated certification. */
  description?: Maybe<Scalars['String']>;
  /** File details for the certification badge. */
  digitalBadgeImage: AttacheFile;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the certification */
  name: Scalars['String'];
  /** Whether reminder notifications are disabled on the certification */
  remindersDisabled: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The issuer of verified credentials for this certification template */
  verifiedCredentialIssuer?: Maybe<VerifiedCredentialIssuer>;
  /** The template for generated wall certificates. */
  wallCertificateOptions?: Maybe<WallCertificateOptions>;
  /** The template for generated wallet cards. */
  walletCardOptions?: Maybe<WalletCardOptions>;
};


/** A representation of a certification for a course. */
export type CertificationTemplateDigitalBadgeImageArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};

/** The connection type for CertificationTemplate. */
export type CertificationTemplateConnection = {
  __typename?: 'CertificationTemplateConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CertificationTemplateEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CertificationTemplate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CertificationTemplateEdge = {
  __typename?: 'CertificationTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CertificationTemplate>;
};

/** Valid methods of managing certification templates. */
export enum CertificationTemplateEditor {
  /** A custom created HTML template using special named elements to fill in user/course/certification data */
  Expert = 'expert'
}

/** Permissions for a Certification Template. */
export type CertificationTemplatePermissions = {
  __typename?: 'CertificationTemplatePermissions';
  /** Whether you can create an Entra manifest for a certification template */
  createEntraManifest: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
};

/** Find standalone certification templates you can manage. */
export type CertificationTemplatesNamespace = {
  __typename?: 'CertificationTemplatesNamespace';
  /** Standalone certification templates you have access to. */
  all: CertificationTemplateConnection;
  /** Find a single certificationtemplate by its string ID. */
  findByGid?: Maybe<CertificationTemplate>;
  /** Find a single certificationtemplate by its integer ID. */
  findById: CertificationTemplate;
  /** Find a single certificationtemplate by its signed ID. */
  findBySgid?: Maybe<CertificationTemplate>;
};


/** Find standalone certification templates you can manage. */
export type CertificationTemplatesNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Find standalone certification templates you can manage. */
export type CertificationTemplatesNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find standalone certification templates you can manage. */
export type CertificationTemplatesNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find standalone certification templates you can manage. */
export type CertificationTemplatesNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** Find certifications you can manage. */
export type CertificationsNamespace = {
  __typename?: 'CertificationsNamespace';
  /** Get all certifications. */
  all: CertificationConnection;
  /** The number of certifications that expire in the next month. */
  expiresSoonCount: Scalars['Int'];
  /** Find a single certification by its integer ID. */
  findById?: Maybe<Certification>;
  /** Find certifications for a user with a given name. */
  findByName: Array<Certification>;
  /** Find certifications with a given tag. */
  findByTag?: Maybe<Array<Certification>>;
  /** Verify a certification. */
  verify?: Maybe<Certification>;
};


/** Find certifications you can manage. */
export type CertificationsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyMine?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Find certifications you can manage. */
export type CertificationsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
  includeExpired?: InputMaybe<Scalars['Boolean']>;
};


/** Find certifications you can manage. */
export type CertificationsNamespaceFindByNameArgs = {
  certification: Scalars['String'];
  firstName: Scalars['String'];
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
};


/** Find certifications you can manage. */
export type CertificationsNamespaceFindByTagArgs = {
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  key: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};


/** Find certifications you can manage. */
export type CertificationsNamespaceVerifyArgs = {
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  number: Scalars['String'];
};

/** Autogenerated input type of ChangePassword */
export type ChangePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the user whose password to change. */
  id: Scalars['Int'];
  /** New password for the user. */
  password: Scalars['String'];
  /** Re-confirm password change. */
  passwordConfirmation: Scalars['String'];
};

/** Autogenerated return type of ChangePassword. */
export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** Whether the password was changed. */
  user?: Maybe<User>;
};

/** Data used to subscribe to an Ably channel */
export type ChannelData = {
  __typename?: 'ChannelData';
  /** Channel name for Ably. */
  channel: Scalars['String'];
  /** Client ID for Ably. */
  clientId: Scalars['String'];
  /** Token for Ably. */
  token: Scalars['String'];
};

/** Autogenerated input type of ClaimPromoCode */
export type ClaimPromoCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The promo code value */
  code: Scalars['String'];
};

/** Autogenerated return type of ClaimPromoCode. */
export type ClaimPromoCodePayload = {
  __typename?: 'ClaimPromoCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** A representation of shopping cart */
  shoppingCart?: Maybe<ShoppingCart>;
};

/** Autogenerated input type of ClearImpersonation */
export type ClearImpersonationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ClearImpersonation. */
export type ClearImpersonationPayload = {
  __typename?: 'ClearImpersonationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Are we back to normal? */
  success: Scalars['Boolean'];
  /** The URL to redirect to when we stop impersonating. */
  url: Scalars['String'];
};

/** For a country or province that is identified by a code. */
export type CodedLocation = {
  /** The code of the location, such as a country code. */
  code: Scalars['String'];
};

/** A documentation for a column in RapidQL. */
export type ColumnDocumentation = {
  __typename?: 'ColumnDocumentation';
  /** A description of what the column is. */
  comment: Scalars['String'];
  /** The name of the column. */
  name: Scalars['String'];
};

/** A comment on a commentable. */
export type Comment = RelayNode & {
  __typename?: 'Comment';
  /** The user who made the comment. */
  author: LightUser;
  /** Any permissions that may be relevant to this comment. */
  can: CommentPermissions;
  /** The record the comment is for. */
  commentable: Commentable;
  /** The actual comment. */
  content: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The organization the comment is for. */
  organization: Organization;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Comment. */
export type CommentConnection = {
  __typename?: 'CommentConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CommentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Comment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CommentEdge = {
  __typename?: 'CommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Comment>;
};

/** Permissions this user has. */
export type CommentPermissions = {
  __typename?: 'CommentPermissions';
  /** Whether the user can destroy a comment */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
};

/** An ApplicationRecord that has comments. */
export type Commentable = {
  /** The comments on this record. */
  comments?: Maybe<CommentConnection>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** An ApplicationRecord that has comments. */
export type CommentableCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Get comments for a commentable. */
export type CommentsNamespace = {
  __typename?: 'CommentsNamespace';
  /** Get all comments for a commentable. */
  all: CommentConnection;
};


/** Get comments for a commentable. */
export type CommentsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  commentableId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Common interface between a License and a LicenseGroup. */
export type CommonLicense = {
  /** The number of available seats the CommonLicense has, or null if an open CommonLicense. */
  availableSeats?: Maybe<Scalars['Int']>;
  /** Any permissions you have relevant to the CommonLicense. */
  can: LicensePermissions;
  /** The course this CommonLicense is for. */
  course: Course;
  /** Any enrolment keys on this CommonLicense. */
  enrolmentKeys: EnrolmentKeyConnection;
  /** The number of granted seats the CommonLicense has. */
  grantedSeats: Scalars['Int'];
  /** The number of pending invitations to the CommonLicense. */
  invitedSeats: Scalars['Int'];
  /** Invites for this CommonLicense. */
  invites: InviteConnection;
  /** The number of seats the CommonLicense has, or null if it's an open CommonLicense. */
  seats?: Maybe<Scalars['Int']>;
  /** The number of use seats the CommonLicense has. */
  usedSeats: Scalars['Int'];
  /** Any CommonLicense usage details. */
  uses: Array<LicenseUse>;
  /** Any LearnerVerified services enabled on the CommonLicense. */
  verificationServices: Scalars['String'];
};


/** Common interface between a License and a LicenseGroup. */
export type CommonLicenseEnrolmentKeysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Common interface between a License and a LicenseGroup. */
export type CommonLicenseInvitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Attributes needed to configure an integration. */
export type ConfigureIntegrationAttributes = {
  /** The options of the integration. */
  integrationOptions: Scalars['Hash'];
  /** The type of the integration. */
  type: IntegrationTypeEnum;
};

/** Autogenerated input type of ConfigureIntegration */
export type ConfigureIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The GID of the integratable. */
  integratableGid: Scalars['ID'];
  /** The integration to configure. */
  integration: ConfigureIntegrationAttributes;
};

/** Autogenerated return type of ConfigureIntegration. */
export type ConfigureIntegrationPayload = {
  __typename?: 'ConfigureIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The integration that was updated. */
  integration?: Maybe<Integration>;
};

/** Autogenerated input type of ConfirmContactMethod */
export type ConfirmContactMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The confirmation code. */
  confirmationCode: Scalars['String'];
  /** ID of the contact method to confirm. */
  contactMethodId: Scalars['ID'];
};

/** Autogenerated return type of ConfirmContactMethod. */
export type ConfirmContactMethodPayload = {
  __typename?: 'ConfirmContactMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The contact method if it was confirmed. */
  contactMethod?: Maybe<ContactMethod>;
  /** Any validation errors returned. */
  errors?: Maybe<Array<ValidationError>>;
};

/** A connected stripe account. */
export type ConnectedStripeAccount = RelayNode & {
  __typename?: 'ConnectedStripeAccount';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The currency of the stripe account. */
  currency: Currency;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The stripe user id of the stripe account. */
  stripeUserId: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A contact method for notifying the user. */
export type ContactMethod = RelayNode & {
  __typename?: 'ContactMethod';
  /** Whether this contact method has been confirmed. */
  confirmed: Scalars['Boolean'];
  /** The date that the contact method was confirmed. */
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The type of notification to send. */
  notificationType: NotificationTypeEnum;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The value of the method */
  value: Scalars['String'];
};

/** Valid types for a contact method on sign up. */
export enum ContactMethodOnSignUpTypeEnum {
  /** E-mail AND mobile number. */
  EmailAndMobileNumber = 'email_and_mobile_number',
  /** E-mail Only. */
  EmailOnly = 'email_only',
  /** E-mail OR mobile number. */
  EmailOrMobileNumber = 'email_or_mobile_number'
}

/** A contract tracking platform billing. */
export type Contract = RelayNode & {
  __typename?: 'Contract';
  /** Wether this contract is active or not. */
  active: Scalars['Boolean'];
  /** Contract calculable */
  calculable: CalculableUnion;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Currency of the contract. */
  currency: Scalars['String'];
  /** Customer type for the contract. */
  customerType: ContractCustomerTypeEnum;
  /** Date when the contract expires. */
  endDate?: Maybe<Scalars['ISO8601Date']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The contract name. */
  name: Scalars['String'];
  /** The contract notes. */
  notes?: Maybe<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Date when contract starts to be charged. */
  startDate: Scalars['ISO8601Date'];
  /** Storefront that owns this contract. */
  storefront: Storefront;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Base interface for contract calculables. */
export type ContractCalculable = {
  /** Type of contract, snake_case. */
  type: Scalars['String'];
};

/** Valid customer types for a contract. */
export enum ContractCustomerTypeEnum {
  /** A customer type for a contract that is Existing client. */
  ExistingClient = 'existing_client',
  /** A customer type for a contract that is New client. */
  NewClient = 'new_client'
}

/** A record tracking revenue from a contract. */
export type ContractRevenue = RelayNode & {
  __typename?: 'ContractRevenue';
  /** The where the revenue is calculated. */
  calculatedDay: Scalars['ISO8601Date'];
  /** The contract that originated this revenue. */
  contract: Contract;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The quantity. */
  quantity: Scalars['Int'];
  /** The day where the revenue is presented. */
  reportedDay: Scalars['ISO8601Date'];
  /** The amount per item. */
  revenue: Scalars['Float'];
  /** The amount per item. */
  revenueFormatted: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A record tracking revenue from a contract. */
export type ContractRevenueRevenueFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ContractRevenue. */
export type ContractRevenueConnection = {
  __typename?: 'ContractRevenueConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContractRevenueEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ContractRevenue>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContractRevenueEdge = {
  __typename?: 'ContractRevenueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ContractRevenue>;
};

/** A country with provinces/states. */
export type Country = {
  __typename?: 'Country';
  /** The ISO code for the location. */
  code: Scalars['String'];
  /** The name of the location. */
  name: Scalars['String'];
  /** Any provinces within this one. */
  provinces?: Maybe<Array<Location>>;
};

/** A course that a learner takes. */
export type Course = Discussable & HasCustomAttributes & Ownable & RelayNode & Taggable & {
  __typename?: 'Course';
  /** The author of the course. */
  authorName: Scalars['String'];
  /** Any permissions you have relevant to the Course. */
  can: CoursePermissions;
  /** The categories this course is in. */
  categories: Array<Scalars['String']>;
  /** Our certification template */
  certificationTemplate?: Maybe<CertificationTemplate>;
  /** The syllabus/description of the course contents. */
  contents?: Maybe<Scalars['String']>;
  /** The course agreements on this course. */
  courseAgreements: Array<CourseAgreement>;
  /** The course items on this course. */
  courseItems: Array<CourseItem>;
  /** The security prompts to use with this course. */
  coursePrompt?: Maybe<CoursePrompt>;
  /** The requirements to take this course. */
  courseRequirements: Array<CourseRequirement>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Custom attributes for the record. */
  customAttributes: Array<CustomAttribute>;
  /** The date when the course was deprecated. */
  deprecatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The long, full description shown on product pages for this course. */
  description?: Maybe<Scalars['String']>;
  /** Whether this course has discussion forums enabled. */
  discussionForums: Scalars['Boolean'];
  /** Discussion topics for this discussable. */
  discussionMessages?: Maybe<DiscussionMessageConnection>;
  /** The estimated completion time for this course, in minutes. */
  estimatedCompletionTime?: Maybe<Scalars['Int']>;
  /** The number of days after a grant has been issued that the content will become inaccessible. */
  expireGrantsAfterDays?: Maybe<Scalars['Int']>;
  /** The number of days after as license has been issued that the content will become inaccessible. */
  expireLicensesAfterDays?: Maybe<Scalars['Int']>;
  /** The date when the course content will become inaccessible. */
  expireLicensesAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The locale (language code) the course is in. */
  locale: Scalars['String'];
  /** Whether or not this course is mobile friendly. */
  mobile: Scalars['Boolean'];
  /** The name of the course. */
  name: Scalars['String'];
  /** Whether the items should be completed in order. */
  ordered: Scalars['Boolean'];
  /** The owner of the record. */
  owner: Owner;
  ownerId: Scalars['String'];
  /** Any paths for this course. */
  paths: CoursePaths;
  /** The photo for the course. */
  photo?: Maybe<AttacheFile>;
  /**
   * The photo for the course.
   * @deprecated Use photo.url instead
   */
  photoUrl?: Maybe<Scalars['String']>;
  /** The default pricing and settings of products created for this course. */
  productDefault?: Maybe<ProductDefault>;
  /** The course that replaces this course if it was deprecated. */
  replacementCourse?: Maybe<Course>;
  /** The resource links on this course. */
  resourceLinks: Array<ResourceLink>;
  /** The Attache details for connecting to the uploaded resources. */
  resources?: Maybe<Array<AttacheFile>>;
  sellCourse: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The short, SEO friendly description for this course. */
  shortDescription?: Maybe<Scalars['String']>;
  /** The SKU for this course if configured. */
  sku?: Maybe<Scalars['String']>;
  /** The summary of the course. */
  summary?: Maybe<Scalars['String']>;
  /** Course completion survey */
  surveySchema?: Maybe<SurveySchema>;
  /** The ID of the survey schema. */
  surveySchemaId?: Maybe<Scalars['Int']>;
  /** The tags on this object. */
  tags: Array<Tag>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The usage information for this course. */
  usageInformation: CourseUsage;
  /** Any LearnerVerified options enabled on the course. */
  verificationOptions?: Maybe<CourseVerificationOptions>;
  /** Any LearnerVerified services enabled on the course. */
  verificationServices: Scalars['String'];
};


/** A course that a learner takes. */
export type CourseDiscussionMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A course that a learner takes. */
export type CoursePhotoArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};


/** A course that a learner takes. */
export type CoursePhotoUrlArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};

/** A course agreement which needs to be agreed upon before the course starts. */
export type CourseAgreement = RelayNode & {
  __typename?: 'CourseAgreement';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The URL to the PDF course agreement. */
  fileUrl: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the course agreement. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes for a course agreement. */
export type CourseAgreementAttributes = {
  /** The Attache details for connecting to the uploaded file. */
  file: AttacheUploadFile;
  /** The display name of the course agreement. */
  name: Scalars['String'];
};

/** The connection type for Course. */
export type CourseConnection = {
  __typename?: 'CourseConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CourseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Course>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** A course deprecation record. */
export type CourseDeprecation = RelayNode & {
  __typename?: 'CourseDeprecation';
  /** The deprecated course. */
  course: Course;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** When the course was deprecated. */
  deprecatedAt: Scalars['ISO8601DateTime'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The replacement course. */
  replacementCourse?: Maybe<Course>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** An edge in a connection. */
export type CourseEdge = {
  __typename?: 'CourseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Course>;
};

/** Course items that can run. */
export type CourseItem = RelayNode & {
  __typename?: 'CourseItem';
  /** The number of attempts allowed. */
  attempts: Scalars['Int'];
  /** Any permissions that may be relevant to this course item. */
  can: CourseItemPermissions;
  /** The certification templates triggered by this course item. */
  certificationTemplates: Array<CertificationTemplate>;
  /** The content-type for this item. */
  contentType: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The file associated with this course item. */
  file?: Maybe<AttacheFile>;
  /**
   * The content-type for this item.
   * @deprecated Can return the course item type or file content type depending on situation. Use the content_type field for the course item type or the file field to get the file content type
   */
  fileContentType: Scalars['String'];
  /**
   * URL to the file.
   * @deprecated Use the file attribute instead.
   */
  fileUrl?: Maybe<Scalars['String']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The instructor-led course. */
  ilCourse?: Maybe<IlCourse>;
  /** The name of this item. */
  name: Scalars['String'];
  /** The position of this course item. */
  position: Scalars['Int'];
  /** Whether this item is practiceable. */
  practiceable: Scalars['Boolean'];
  /** URL of the preview only for scorm */
  scormPreviewLink?: Maybe<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The type of this course item. */
  type: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** URL of the link */
  url?: Maybe<Scalars['String']>;
};

/** Attributes for a course item. */
export type CourseItemAttributes = {
  /** The Attache details for connecting to the uploaded file. */
  file: AttacheUploadFile;
  /** The display name of the course item. */
  name: Scalars['String'];
};

/** Permissions this user has. */
export type CourseItemPermissions = {
  __typename?: 'CourseItemPermissions';
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether the user can preview this content */
  preview: Scalars['Boolean'];
};

/** A representation of an items progress a learner makes through a course. */
export type CourseItemProgression = Discussable & RelayNode & {
  __typename?: 'CourseItemProgression';
  /** The number of additional attempts allowed. */
  attemptsRemaining?: Maybe<Scalars['Int']>;
  /** Permissions on this course item progression. */
  can: CourseItemProgressionPermissions;
  /** Whether the item has been completed. */
  completed: Scalars['Boolean'];
  /** When the item was completed. */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The item to run. */
  courseItem: CourseItem;
  /** The parent progression for this item. */
  courseProgression: CourseProgression;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Discussion topics for this discussable. */
  discussionMessages?: Maybe<DiscussionMessageConnection>;
  /** When the item was failed. */
  failedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The settings for this assignment (graded assignment course items only). */
  gradedAssignmentSettings?: Maybe<GradedAssignmentSettings>;
  /** The submissions for this assignment (graded assignment course items only). */
  gradedAssignmentSubmissions: Array<GradedAssignmentSubmission>;
  /** When submissions will close. */
  gradedAssignmentSubmissionsClosedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The integer ID. */
  id: Scalars['Int'];
  /** The booking for for this progression. */
  ilBooking?: Maybe<IlBooking>;
  /** The most recent submission for this assignment (graded assignment course items only). */
  latestGradedAssignmentSubmission?: Maybe<GradedAssignmentSubmission>;
  /** The name of this item. */
  name: Scalars['String'];
  /** Whether the item can be opened or is no longer available (completed exams). */
  openable: Scalars['Boolean'];
  /** Whether an exam item is practiceable or not. */
  practiceable: Scalars['Boolean'];
  /** The progress of this item. */
  progress: Scalars['Float'];
  /** Whether the item is ready. */
  ready: Scalars['Boolean'];
  /** Whether the item can be reviewed. */
  reviewable: Scalars['Boolean'];
  /** Whether the item is runnable. */
  runnable: Scalars['Boolean'];
  /** The score received for this item from the SCORM module, graded assignment, or exam, if available. */
  score?: Maybe<Scalars['Float']>;
  /** The SCORM data from the last course item. */
  scorm?: Maybe<Scorm>;
  /** The url to launch the scorm object. */
  scormLaunchLink?: Maybe<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the item was started. */
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The status for this item. */
  status: CourseItemProgressionStatusEnum;
  /** The file type for this item. */
  type: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The URL to display if the course item is a link. */
  url?: Maybe<Scalars['String']>;
};


/** A representation of an items progress a learner makes through a course. */
export type CourseItemProgressionDiscussionMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Permissions on this course item progression. */
export type CourseItemProgressionPermissions = {
  __typename?: 'CourseItemProgressionPermissions';
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can review this item. */
  review: Scalars['Boolean'];
  /** Whether you can submit this item. */
  submitGradedAssignment: Scalars['Boolean'];
};

/** The possible statuses of a course item progression */
export enum CourseItemProgressionStatusEnum {
  /** A course item progression that is completed. */
  Completed = 'completed',
  /** A course item progression that is failed. */
  Failed = 'failed',
  /** A course item progression that is in progress. */
  InProgress = 'in_progress',
  /** A course item progression that is not started. */
  NotStarted = 'not_started'
}

/** CourseItemProgressions you can access. */
export type CourseItemProgressionsNamespace = {
  __typename?: 'CourseItemProgressionsNamespace';
  /** Find a single CourseItemProgression. */
  findById?: Maybe<CourseItemProgression>;
};


/** CourseItemProgressions you can access. */
export type CourseItemProgressionsNamespaceFindByIdArgs = {
  id: Scalars['ID'];
};

/** Attributes for replacing a course item. */
export type CourseItemReplacementAttributes = {
  /** The ID of the course item you want to replace. */
  courseItemId: Scalars['ID'];
  /** When replacing a course, do you want to update the learners who have not finshed the course? */
  updateLearners?: Scalars['Boolean'];
};

/** Attributes needed to reorder / rename a course item. */
export type CourseItemUpdate = {
  /** The name of the course item. */
  name?: InputMaybe<Scalars['String']>;
  /** The position of the course item (1-indexed). */
  position?: InputMaybe<Scalars['Int']>;
};

/** Paths on this course. */
export type CoursePaths = {
  __typename?: 'CoursePaths';
  /** Path to edit this course if permitted. */
  edit: Scalars['String'];
  /** The ID of the record these paths are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these paths are for. */
  id: Scalars['Int'];
  /** The URL for the product on the given or current storefront, null if the storefront does not sell this course. */
  productUrl?: Maybe<Scalars['String']>;
};


/** Paths on this course. */
export type CoursePathsProductUrlArgs = {
  storefrontId?: InputMaybe<Scalars['ID']>;
};

/** Permissions for a Course. */
export type CoursePermissions = {
  __typename?: 'CoursePermissions';
  /** Whether you can deprecate this course. */
  deprecate: Scalars['Boolean'];
  /** Whether you can destroy this course. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can create licenses for this course. */
  license: Scalars['Boolean'];
  /** Whether you can update this course. */
  update: Scalars['Boolean'];
};

/** A representation of the progress a learner makes through a course. */
export type CourseProgression = RelayNode & {
  __typename?: 'CourseProgression';
  /** When the course was completed. */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The course that this completion is for. */
  course: Course;
  /** The items available for this course. */
  courseItemProgressions: Array<CourseItemProgression>;
  /** The list of resources avaialbe for the course. */
  courseResources: Array<CourseProgressionResource>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Estimated time to complete the course. */
  estimatedCompletionTime?: Maybe<Scalars['Int']>;
  /** When the course was failed, if applicable. */
  failedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The grant this completion came from. */
  grant: Grant;
  /** The integer ID. */
  id: Scalars['Int'];
  /** Whether the items should be completed in order. */
  ordered: Scalars['Boolean'];
  /** How much progress has been made on this progression. */
  percentComplete: Scalars['Float'];
  /** The score of this progression (from the last SCORM item or exam), if available. */
  score?: Maybe<Scalars['Float']>;
  /**
   * The SCORM data from the last course item.
   * @deprecated Use the scorm attribute on an individual CourseItemProgression
   */
  scorm?: Maybe<Scorm>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the course was started. */
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The status of this progression. */
  status: CourseProgressionStatusEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user that owns this progression. */
  user: User;
};

/** The connection type for CourseProgression. */
export type CourseProgressionConnection = {
  __typename?: 'CourseProgressionConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CourseProgressionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CourseProgression>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CourseProgressionEdge = {
  __typename?: 'CourseProgressionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CourseProgression>;
};

/** A representation of a course progression resource. */
export type CourseProgressionResource = RelayNode & {
  __typename?: 'CourseProgressionResource';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of this item. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The URL for this item. */
  url: Scalars['String'];
};

/** The possible statuses of a course progression */
export enum CourseProgressionStatusEnum {
  /** A course progression that is completed. */
  Completed = 'completed',
  /** A course progression that is failed. */
  Failed = 'failed',
  /** A course progression that is in progress. */
  InProgress = 'in_progress',
  /** A course progression that is not started. */
  NotStarted = 'not_started'
}

/** A course prompt record. */
export type CoursePrompt = RelayNode & {
  __typename?: 'CoursePrompt';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The custom fields course requrierments to use with this course prompt. */
  customFieldCourseRequirements?: Maybe<Array<CustomFieldCourseRequirement>>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Maximum time between prompts in seconds. */
  maximumTime: Scalars['Int'];
  /** Minimum time between prompts in seconds. */
  minimumTime: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** An account information requirement specified by a course. */
export type CourseRequirement = AddressCourseRequirement | CustomFieldCourseRequirement | EmailCourseRequirement | PrerequisiteCourseRequirement;

/** Attributes for a course requirement. */
export type CourseRequirementAttributes = {
  /** The type of the requirement. */
  type: CourseRequirementTypeEnum;
};

/** An account information requirement for a course. */
export type CourseRequirementInterface = {
  /** The course which has the requirement. */
  course: Course;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Has the user satisfied this requirement? */
  satisfied: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The kind of requirement specified by the course. */
  type: CourseRequirementsTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** An account information requirement for a course. */
export type CourseRequirementInterfaceSatisfiedArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};

/** Valid types used for Course Requirements. */
export enum CourseRequirementTypeEnum {
  /** A course requirement that requires the user's address. */
  AddressCourseRequirement = 'AddressCourseRequirement',
  /** A course requirement that requires the user's email address. */
  EmailCourseRequirement = 'EmailCourseRequirement'
}

/** The kinds of requirements that a course may specify. */
export enum CourseRequirementsTypeEnum {
  /** A course requirement for a user address. */
  AddressCourseRequirement = 'AddressCourseRequirement',
  /** A course requirement associated with a custom field. */
  CustomFieldCourseRequirement = 'CustomFieldCourseRequirement',
  /** A course requirement for a confirmed email address. */
  EmailCourseRequirement = 'EmailCourseRequirement',
  /** A course requirement for a completed course. */
  PrerequisiteCourseRequirement = 'PrerequisiteCourseRequirement'
}

/** Usage counts for things associated with this course. */
export type CourseUsage = {
  __typename?: 'CourseUsage';
  /** The number of active grants for this course. */
  grantCount: Scalars['Int'];
  /** The number of pending invites for this course. */
  inviteCount: Scalars['Int'];
  /** The number of licenses for this course. */
  licenseCount: Scalars['Int'];
  /** The number of products for this course. */
  productCount: Scalars['Int'];
};

/** A course agreement which a user has viewed and/or agreed to. */
export type CourseUserAgreement = RelayNode & {
  __typename?: 'CourseUserAgreement';
  /** The timestamp when you accepted the agreement. */
  agreedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The course agreeemnt document you should view and accept. */
  courseAgreement: CourseAgreement;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The first time that you viewed this course agreement. */
  viewedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Usage counts for things associated with this course. */
export type CourseVerificationOptions = {
  __typename?: 'CourseVerificationOptions';
  /** Enabled a maximum number of absences. */
  enableMaximumAbsent: Scalars['Boolean'];
  /** Enable a maxiunm number of external assistance. */
  enableMaximumAssistance: Scalars['Boolean'];
  /** Enable a minimum time requirement. */
  enableMinimumTime: Scalars['Boolean'];
  /**  Take a new face/ID photo every time. */
  forceNewIdentification: Scalars['Boolean'];
  /** If LV says you failed, keep the cert locked until it's been passed. */
  holdCertIfUnderReview: Scalars['Boolean'];
  /** Maximum number of absence anomalies you're allowed to have. */
  maximumAbsent: Scalars['Int'];
  /** Maximum number of assistance anomalies you're allowed to have. */
  maximumAssistance: Scalars['Int'];
  /** Minimum amount of time you must spend in the course */
  minimumTime: Scalars['Int'];
  /** Give it away for free */
  optionalDuringCheckout: Scalars['Boolean'];
  /** Keep all reviews to yourself */
  reviewsPerformedByAuthor: Scalars['Boolean'];
};

/** Find courses can manage. */
export type CoursesNamespace = {
  __typename?: 'CoursesNamespace';
  /** Courses you have direct access to. */
  all: CourseConnection;
  /** Courses available to be configured for Regulator Submission. */
  availableForRegulatorSubmission: CourseConnection;
  /** Courses available to be configured for Regulator Submission. */
  availableForTrainingMatrices: CourseConnection;
  /** Courses that contain the specified IL class. */
  bookableForIlClass: CourseConnection;
  /** Courses configured for Regulator Submission. */
  configuredForRegulatorSubmission: CourseConnection;
  /** Find a single course by its string ID. */
  findByGid?: Maybe<Course>;
  /** Find a single course by its integer ID. */
  findById: Course;
  /** Find a single course by its signed ID. */
  findBySgid?: Maybe<Course>;
};


/** Find courses can manage. */
export type CoursesNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  openlyLicensed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Find courses can manage. */
export type CoursesNamespaceAvailableForRegulatorSubmissionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
};


/** Find courses can manage. */
export type CoursesNamespaceAvailableForTrainingMatricesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
};


/** Find courses can manage. */
export type CoursesNamespaceBookableForIlClassArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ilClassId: Scalars['ID'];
  last?: InputMaybe<Scalars['Int']>;
};


/** Find courses can manage. */
export type CoursesNamespaceConfiguredForRegulatorSubmissionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds: Array<Scalars['ID']>;
};


/** Find courses can manage. */
export type CoursesNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find courses can manage. */
export type CoursesNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find courses can manage. */
export type CoursesNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** Attributes needed to create a new constant. */
export type CreateAutomationConstantAttributes = {
  /** The name of this constant. */
  name: Scalars['String'];
  /** Whether or not this constant should be considered secret. */
  secret: Scalars['Boolean'];
  /** The value of this constant. */
  value: Scalars['String'];
};

/** Autogenerated input type of CreateAutomationConstant */
export type CreateAutomationConstantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes for the new constant. */
  constant: CreateAutomationConstantAttributes;
  /** The ID of the Organization the constant is created on. */
  organizationId: Scalars['ID'];
};

/** Autogenerated return type of CreateAutomationConstant. */
export type CreateAutomationConstantPayload = {
  __typename?: 'CreateAutomationConstantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created constant. */
  constant?: Maybe<AutomationConstant>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The organization the constant is created on. */
  organization: Organization;
};

/** Attributes needed to create a new script. */
export type CreateAutomationScriptAttributes = {
  /** Whether or not this script should be enabled right away. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** When this script is triggered. */
  event: AutomationEvent;
  /** The LUA script to execute. */
  lua?: InputMaybe<Scalars['String']>;
  /** The title of this script. */
  title: Scalars['String'];
};

/** Autogenerated input type of CreateAutomationScript */
export type CreateAutomationScriptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the Organization to create the  */
  organizationId: Scalars['ID'];
  /** Attributes for the new script. */
  script: CreateAutomationScriptAttributes;
};

/** Autogenerated return type of CreateAutomationScript. */
export type CreateAutomationScriptPayload = {
  __typename?: 'CreateAutomationScriptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The organization the script is created on. */
  organization: Organization;
  /** The created script. */
  script?: Maybe<AutomationScript>;
};

/** Attributes needed to create a certification. */
export type CreateCertificationAttributes = {
  /** The base64 image string of the certification. */
  base64Image: Scalars['String'];
  /** The date this certification was issued on. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The description of this certification. */
  description: Scalars['String'];
  /** The date this certification will expire on. */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The issuer name for this certification. */
  issuerName: Scalars['String'];
  /** The name of the certification. */
  name: Scalars['String'];
};

/** Attributes needed for a certification change request. */
export type CreateCertificationChangeRequestAttributes = {
  /** The issuer address of this certification. */
  issuerAddress?: InputMaybe<NewAddressAttributes>;
  /** The issuer name of this certification. */
  issuerName: Scalars['String'];
  /** The reason for the change of information. */
  reason?: InputMaybe<Scalars['String']>;
  /** The first name of the certification owner. */
  userFirstName: Scalars['String'];
  /** The last name of the certification owner. */
  userLastName: Scalars['String'];
};

/** Autogenerated input type of CreateCertificationChangeRequest */
export type CreateCertificationChangeRequestInput = {
  /** The attributes for the change request. */
  attributes: CreateCertificationChangeRequestAttributes;
  /** The ID of the certification we are requesting changes for. */
  certificationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateCertificationChangeRequest. */
export type CreateCertificationChangeRequestPayload = {
  __typename?: 'CreateCertificationChangeRequestPayload';
  /** The change request. */
  changeRequest: CertificationChangeRequest;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to create a certification. */
export type CreateCertificationFromTemplateAttributes = {
  /** The date this certification was issued on. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The date this certification will expire on. */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Tags to add to the certification. */
  tags?: InputMaybe<Array<TagAttributes>>;
  /** The ID of the user to issue the certification to. */
  userId: Scalars['ID'];
};

/** Autogenerated input type of CreateCertificationFromTemplate */
export type CreateCertificationFromTemplateInput = {
  /** The certification details. */
  certification: CreateCertificationFromTemplateAttributes;
  /** The ID of the certification template to use. */
  certificationTemplateId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateCertificationFromTemplate. */
export type CreateCertificationFromTemplatePayload = {
  __typename?: 'CreateCertificationFromTemplatePayload';
  /** The newly created certification. */
  certification: Certification;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of CreateCertification */
export type CreateCertificationInput = {
  /** The certification to create. */
  certification: CreateCertificationAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateCertification. */
export type CreateCertificationPayload = {
  __typename?: 'CreateCertificationPayload';
  /** The newly created certification. */
  certification: Certification;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to create a certification template. */
export type CreateCertificationTemplateAttributes = {
  /** The course item to use as reference to the certification issue date. */
  courseItemId?: InputMaybe<Scalars['ID']>;
  /** The number of days since the certification is issued until it expires. */
  daysValid?: InputMaybe<Scalars['Int']>;
  /** The description of this certification. */
  description?: InputMaybe<Scalars['String']>;
  /** The Attache details for connecting to the uploaded file. */
  digitalBadgeImage: AttacheUploadFile;
  /** The name of the certification */
  name: Scalars['String'];
  /** Whether reminder notifications are disabled on the certification */
  remindersDisabled?: InputMaybe<Scalars['Boolean']>;
  /** The design of the wall certificate */
  wallCertificateOptions?: InputMaybe<WallCertificateAttributes>;
  /** The design of the wallet card */
  walletCardOptions?: InputMaybe<WalletCardAttributes>;
};

/** Autogenerated input type of CreateCertificationTemplate */
export type CreateCertificationTemplateInput = {
  /** The form params which will create the certification template */
  certificationTemplate: CreateCertificationTemplateAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The course which the certification will belong to. */
  parentId: Scalars['ID'];
};

/** Autogenerated return type of CreateCertificationTemplate. */
export type CreateCertificationTemplatePayload = {
  __typename?: 'CreateCertificationTemplatePayload';
  /** The created certification template. */
  certificationTemplate: CertificationTemplate;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errrors returned. */
  errors: Array<ValidationError>;
};

/** The comment attributes. */
export type CreateCommentAttributes = {
  /** The HTML content for the comment. */
  content: Scalars['String'];
  /** The Organization to link the comment to. */
  organizationId: Scalars['ID'];
};

/** Autogenerated input type of CreateComment */
export type CreateCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment attributes. */
  comment: CreateCommentAttributes;
  /** The commentable ID to create the comment on. */
  commentableId: Scalars['ID'];
};

/** Autogenerated return type of CreateComment. */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created comment. */
  comment?: Maybe<Comment>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of CreateCourseAgreement */
export type CreateCourseAgreementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Properties that define a course agreement. */
  courseAgreement: CourseAgreementAttributes;
  /** The course associated with the agreement. */
  courseId: Scalars['ID'];
};

/** Autogenerated return type of CreateCourseAgreement. */
export type CreateCourseAgreementPayload = {
  __typename?: 'CreateCourseAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created course agreement. */
  courseAgreement?: Maybe<CourseAgreement>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to create a course. */
export type CreateCourseAttributes = {
  /** The course items on this course. */
  courseItemFiles?: InputMaybe<Array<AttacheUploadFile>>;
  /** The locale (language code) the course is in. */
  locale: Scalars['String'];
  /** The name of the course. */
  name: Scalars['String'];
  /** The ID of the User or Organization which the course will belong to. */
  ownerId: Scalars['ID'];
  /** The feature image for this course. */
  photo?: InputMaybe<AttacheUploadFile>;
  /** The SEO friendly short description of the course. */
  shortDescription: Scalars['String'];
};

/** Autogenerated input type of CreateCourse */
export type CreateCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a course. */
  course: CreateCourseAttributes;
};

/** Autogenerated return type of CreateCourse. */
export type CreateCoursePayload = {
  __typename?: 'CreateCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The newly created course. */
  course?: Maybe<Course>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to create a course prompt. */
export type CreateCoursePromptAttributes = {
  /** The maximum time in seconds */
  maximumTime: Scalars['Int'];
  /** The minimum time in seconds */
  minimumTime: Scalars['Int'];
};

/** Autogenerated input type of CreateCoursePrompt */
export type CreateCoursePromptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the course. */
  courseId: Scalars['ID'];
  /** Attributes needed to create a course prompt. */
  coursePrompt: CreateCoursePromptAttributes;
};

/** Autogenerated return type of CreateCoursePrompt. */
export type CreateCoursePromptPayload = {
  __typename?: 'CreateCoursePromptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The newly created course prompt. */
  coursePrompt?: Maybe<CoursePrompt>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of CreateCourseRequirement */
export type CreateCourseRequirementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The course associated with the requirement. */
  courseId: Scalars['ID'];
  /** Properties that define a course requirement. */
  courseRequirement: CourseRequirementAttributes;
};

/** Autogenerated return type of CreateCourseRequirement. */
export type CreateCourseRequirementPayload = {
  __typename?: 'CreateCourseRequirementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created course requirement. */
  courseRequirement?: Maybe<CourseRequirement>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of CreateCourseResourceLink */
export type CreateCourseResourceLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The course that will get the resource link. */
  courseId: Scalars['ID'];
  /** The resource link to create. */
  resourceLink: ResourceLinkAttributes;
};

/** Autogenerated return type of CreateCourseResourceLink. */
export type CreateCourseResourceLinkPayload = {
  __typename?: 'CreateCourseResourceLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The resource link record. */
  resourceLink?: Maybe<ResourceLink>;
};

/** Attributes needed to create a custom attribute */
export type CreateCustomAttributeAttributes = {
  /** The content of the custom attribute. */
  content?: InputMaybe<Scalars['String']>;
  /** The kind of custom attribute. */
  kind: CustomAttributeKindEnum;
  /** The name of the custom attribute. */
  name: Scalars['String'];
};

/** Autogenerated input type of CreateCustomAttribute */
export type CreateCustomAttributeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The custom attribute object. */
  customAttribute: CreateCustomAttributeAttributes;
  /** The ID of the record to add the custom attribute to. */
  recordId: Scalars['ID'];
};

/** Autogenerated return type of CreateCustomAttribute. */
export type CreateCustomAttributePayload = {
  __typename?: 'CreateCustomAttributePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The newly created custom attribute. */
  customAttribute?: Maybe<CustomAttribute>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to create a custom domain. */
export type CreateCustomDomainAttributes = {
  /** The domain name. */
  name: Scalars['String'];
  /** Should this domain be made the storefronts primary domain. */
  primary?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateCustomDomain */
export type CreateCustomDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The custom domain to create. */
  customDomain: CreateCustomDomainAttributes;
  /** The ID of the parent storefront. */
  storefrontId: Scalars['ID'];
};

/** Autogenerated return type of CreateCustomDomain. */
export type CreateCustomDomainPayload = {
  __typename?: 'CreateCustomDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The custom domain that was updated. */
  customDomain?: Maybe<CustomDomain>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes for a custom field. */
export type CreateCustomFieldAttributes = {
  /** The options available in the case of this field being a dropdown. */
  customFieldOptions?: InputMaybe<Array<CustomFieldOptionAttributes>>;
  /** The type of this field. */
  fieldType: CustomFieldFieldTypeTypeEnum;
  /** The name of the custom field. */
  name: Scalars['String'];
  /** Whether this field is required or not. */
  required: Scalars['Boolean'];
  /** Whether this field should be shown on the signup form. */
  showOnSignup: Scalars['Boolean'];
};

/** Autogenerated input type of CreateCustomFieldCourseRequirement */
export type CreateCustomFieldCourseRequirementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The course that needs a prerequisite. */
  courseId: Scalars['ID'];
  /** The custom field required for this course. */
  customFieldId: Scalars['ID'];
};

/** Autogenerated return type of CreateCustomFieldCourseRequirement. */
export type CreateCustomFieldCourseRequirementPayload = {
  __typename?: 'CreateCustomFieldCourseRequirementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created prerequisite course requirement. */
  customFieldCourseRequirement?: Maybe<CustomFieldCourseRequirement>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of CreateCustomField */
export type CreateCustomFieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a custom field. */
  customField: CreateCustomFieldAttributes;
  /** The ID of the storefront to create a custom field. */
  storefrontId: Scalars['ID'];
};

/** Autogenerated return type of CreateCustomField. */
export type CreateCustomFieldPayload = {
  __typename?: 'CreateCustomFieldPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The newly created Custom Field. */
  customField?: Maybe<CustomField>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to create a discussion reply. */
export type CreateDiscussionReplyAttributes = {
  /** The content of the post. */
  content: Scalars['String'];
  /** Any files to attach to the reply. */
  files?: InputMaybe<Array<AttacheUploadFile>>;
};

/** Autogenerated input type of CreateDiscussionReply */
export type CreateDiscussionReplyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The reply object. */
  reply: CreateDiscussionReplyAttributes;
  /** The topic on which to create the reply. */
  topicId: Scalars['ID'];
};

/** Autogenerated return type of CreateDiscussionReply. */
export type CreateDiscussionReplyPayload = {
  __typename?: 'CreateDiscussionReplyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created discussion message. */
  reply?: Maybe<DiscussionMessage>;
};

/** Attributes needed to create a discussion topic. */
export type CreateDiscussionTopicAttributes = {
  /** The content for the main post. */
  content: Scalars['String'];
  /** Any files to attach to the topic. */
  files?: InputMaybe<Array<AttacheUploadFile>>;
  /** The title of the topic. */
  title: Scalars['String'];
};

/** Autogenerated input type of CreateDiscussionTopic */
export type CreateDiscussionTopicInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the discussable to create the topic on. */
  discussableId: Scalars['ID'];
  /** The topic object. */
  topic: CreateDiscussionTopicAttributes;
};

/** Autogenerated return type of CreateDiscussionTopic. */
export type CreateDiscussionTopicPayload = {
  __typename?: 'CreateDiscussionTopicPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created discussion message. */
  topic?: Maybe<DiscussionMessage>;
};

/** Attributes for a downloadable file. */
export type CreateDownloadableFileAttributes = {
  /** The file itself. */
  file: AttacheUploadFile;
};

/** Autogenerated input type of CreateDownloadableFile */
export type CreateDownloadableFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a downloadable file. */
  downloadableFile: CreateDownloadableFileAttributes;
  /** The ID of the storefront to create a downloadable file. */
  storefrontId: Scalars['ID'];
};

/** Autogenerated return type of CreateDownloadableFile. */
export type CreateDownloadableFilePayload = {
  __typename?: 'CreateDownloadableFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The newly created Downloadable File. */
  downloadableFile?: Maybe<DownloadableFile>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of CreateEnrolmentKey */
export type CreateEnrolmentKeyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the License or License Group to create the key on. If a License Group ID is provided, the key will be universal. */
  licenseId: Scalars['ID'];
};

/** Autogenerated return type of CreateEnrolmentKey. */
export type CreateEnrolmentKeyPayload = {
  __typename?: 'CreateEnrolmentKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The enrolment key that was created. */
  enrolmentKey?: Maybe<EnrolmentKey>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The License or LicenseGroup the enrolment key was created on. */
  license: CommonLicense;
};

/** Autogenerated input type of CreateEntraManifest */
export type CreateEntraManifestInput = {
  /** The background hex color code for the manifest */
  backgroundColor: Scalars['String'];
  /** The certification template to create a manifest for */
  certificationTemplateId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The text hex color code for the manifest */
  textColor: Scalars['String'];
};

/** Autogenerated return type of CreateEntraManifest. */
export type CreateEntraManifestPayload = {
  __typename?: 'CreateEntraManifestPayload';
  /** The certification template with the new manifest */
  certificationTemplate?: Maybe<CertificationTemplate>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered while creating the manifest */
  errors: Array<Scalars['String']>;
};

/** Attributes needed to create a grader. */
export type CreateGraderAttributes = {
  /** Grader email. */
  email: Scalars['String'];
  /** Grader first name. */
  firstName: Scalars['String'];
  /** Grader last name. */
  lastName: Scalars['String'];
};

/** Autogenerated input type of CreateGrader */
export type CreateGraderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a grader. */
  grader: CreateGraderAttributes;
  /** The organization which the grader will belong to. */
  organizationId: Scalars['ID'];
};

/** Autogenerated return type of CreateGrader. */
export type CreateGraderPayload = {
  __typename?: 'CreateGraderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created grader. */
  grader?: Maybe<Grader>;
};

/** Autogenerated input type of CreateILBookingForUser */
export type CreateIlBookingForUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The GID of the Grant to book. */
  grantId: Scalars['ID'];
  /** The instructor-led class which the user is being enrolled into. */
  ilClassId: Scalars['ID'];
};

/** Autogenerated return type of CreateILBookingForUser. */
export type CreateIlBookingForUserPayload = {
  __typename?: 'CreateILBookingForUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The new instructor-led booking. */
  ilBooking?: Maybe<IlBooking>;
};

/** Autogenerated input type of CreateILBooking */
export type CreateIlBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The course item progression which the booking will belong to. */
  courseItemProgressionId: Scalars['ID'];
  /** The instructor-led class which the booking will belong to. */
  ilClassId: Scalars['ID'];
};

/** Autogenerated return type of CreateILBooking. */
export type CreateIlBookingPayload = {
  __typename?: 'CreateILBookingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The new instructor-led booking. */
  ilBooking?: Maybe<IlBooking>;
};

/** Attributes needed to create an instructor-led class. */
export type CreateIlClassAttributes = {
  /** Who has access to book this class. */
  access: IlClassAccessEnum;
  /** The date when learners are no longer allow to book into the class, or change their booking. */
  bookingEndsAt?: InputMaybe<Scalars['TimeWithoutZone']>;
  /** The date when learners can start booking into the class. */
  bookingStartsAt?: InputMaybe<Scalars['TimeWithoutZone']>;
  /** The ID of the course which the instructor-led class belongs to. */
  ilCourseId: Scalars['ID'];
  /** The collection of instructor-led class sessions. */
  ilSessions: Array<CreateIlSessionAttributes>;
  /** The IDs of the instructors who will instruct this instructor-led class. */
  instructorIds: Array<Scalars['ID']>;
  /** The max capacity of the instructor-led class. */
  maxCapacity: Scalars['Int'];
  /** The recurrence rules for this class. */
  rrule?: InputMaybe<Scalars['String']>;
  /** The status of the instructor-led class. Initial status must be either draft or active. */
  status: IlClassStatusEnum;
  /** The max capacity of the waitlist. 0 to disable waitlist. */
  waitlistSize?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of CreateILClass */
export type CreateIlClassInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The attributes needed to create an instructor-led class. */
  ilClass: CreateIlClassAttributes;
};

/** Autogenerated return type of CreateILClass. */
export type CreateIlClassPayload = {
  __typename?: 'CreateILClassPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The new instructor-led class. */
  ilClass?: Maybe<IlClass>;
  /** The new recurrences of the class (if any). */
  recurrences?: Maybe<Array<IlClass>>;
};

/** Attributes needed to create a instructor-led course. */
export type CreateIlCourseAttributes = {
  /** The collection of instructor-led course items. */
  ilCourseItemsAttributes?: InputMaybe<Array<CreateIlCourseItemAttributes>>;
  /** The Attache details for connecting to the uploaded file. */
  instructorFiles?: InputMaybe<Array<AttacheUploadFile>>;
  /** The Attache details for connecting to the uploaded file. */
  learnerFiles?: InputMaybe<Array<AttacheUploadFile>>;
  /** The name of the instructor-led course. */
  name: Scalars['String'];
  /** The organization which the instructor-led course will belong to. */
  ownerId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of CreateILCourse */
export type CreateIlCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a instructor-led course. */
  ilCourse: CreateIlCourseAttributes;
};

/** Attributes needed to create a instructor-led course item. */
export type CreateIlCourseItemAttributes = {
  /** The name of the instructor-led course item. */
  name: Scalars['String'];
  /** Whether this course item should track attendance. */
  trackAttendance?: InputMaybe<Scalars['Boolean']>;
  /** Whether this course item should track a grade. */
  trackGrade?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateILCourseItem */
export type CreateIlCourseItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The instructor-led course which the item will belong to. */
  ilCourseId: Scalars['ID'];
  /** Attributes needed to create an instructor-led course item. */
  ilCourseItem: CreateIlCourseItemAttributes;
};

/** Autogenerated return type of CreateILCourseItem. */
export type CreateIlCourseItemPayload = {
  __typename?: 'CreateILCourseItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created instructor-led course item. */
  ilCourseItem?: Maybe<IlCourseItem>;
};

/** Autogenerated return type of CreateILCourse. */
export type CreateIlCoursePayload = {
  __typename?: 'CreateILCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created instructor-led course. */
  ilCourse?: Maybe<IlCourse>;
};

/** Attributes needed to create an instructor-led location. */
export type CreateIlLocationAttributes = {
  /** The address of the new location. */
  address?: InputMaybe<NewAddressAttributes>;
  /** The name of the instructor-led location. */
  name: Scalars['String'];
  /** The organization which the location will belong to. */
  ownerId: Scalars['ID'];
  /** The type of the instructor-led location. */
  type: IlLocationTypeEnum;
  /** The url of the instructor-led location. */
  url?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateILLocation */
export type CreateIlLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a location. */
  ilLocation: CreateIlLocationAttributes;
};

/** Autogenerated return type of CreateILLocation. */
export type CreateIlLocationPayload = {
  __typename?: 'CreateILLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The new instructor-led location. */
  ilLocation?: Maybe<IlLocationInterface>;
};

/** Attributes needed to create an instructor-led session. */
export type CreateIlSessionAttributes = {
  /** The date when the session will end. */
  endsAt: Scalars['TimeWithoutZone'];
  /** The ID of the location which the instructor-led class will be taught. */
  ilLocationId: Scalars['ID'];
  /** The date when the session will start. */
  startsAt: Scalars['TimeWithoutZone'];
  /** The time zone of the session. */
  timeZone: Scalars['TimeZone'];
};

/** Autogenerated input type of CreateILSession */
export type CreateIlSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The instructor-led class which the session will belong to. */
  ilClassId: Scalars['ID'];
  /** Attributes needed to create an instructor-led session. */
  ilSession: CreateIlSessionAttributes;
};

/** Autogenerated return type of CreateILSession. */
export type CreateIlSessionPayload = {
  __typename?: 'CreateILSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created instructor-led session. */
  ilSession?: Maybe<IlSession>;
};

/** Attributes needed to create an instructor. */
export type CreateInstructorAttributes = {
  /** Instructor email. */
  email: Scalars['String'];
  /** Instructor first name. */
  firstName: Scalars['String'];
  /** Instructor last name. */
  lastName: Scalars['String'];
};

/** Autogenerated input type of CreateInstructorCredential */
export type CreateInstructorCredentialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes for the credential. */
  instructorCredential: InstructorCredentialAttributes;
  /** The ID of the instructor to add the credential to. */
  instructorId: Scalars['ID'];
};

/** Autogenerated return type of CreateInstructorCredential. */
export type CreateInstructorCredentialPayload = {
  __typename?: 'CreateInstructorCredentialPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The new credential. */
  credential?: Maybe<InstructorCredential>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The instructor associated with the new credential. */
  instructor: Instructor;
};

/** Autogenerated input type of CreateInstructorILCoursePermission */
export type CreateInstructorIlCoursePermissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the course that the instructor can create classes for. */
  ilCourseId: Scalars['ID'];
  /** The ID of the instructor that can create classes with the associated ILCourse. */
  instructorId: Scalars['ID'];
};

/** Autogenerated return type of CreateInstructorILCoursePermission. */
export type CreateInstructorIlCoursePermissionPayload = {
  __typename?: 'CreateInstructorILCoursePermissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The created permission record. */
  instructorIlCoursePermission?: Maybe<InstructorIlCoursePermission>;
};

/** Autogenerated input type of CreateInstructor */
export type CreateInstructorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create an instructor. */
  instructor: CreateInstructorAttributes;
  /** The organization to which the instructor belongs. */
  organizationId: Scalars['ID'];
};

/** Autogenerated return type of CreateInstructor. */
export type CreateInstructorPayload = {
  __typename?: 'CreateInstructorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created instructor. */
  instructor?: Maybe<Instructor>;
};

/** Attributes to create a new invitee. */
export type CreateInviteeAttributes = {
  /** Invitee email. */
  email?: InputMaybe<Scalars['String']>;
  /** Invitee first name. */
  firstName: Scalars['String'];
  /** Invitee last name. */
  lastName: Scalars['String'];
  /** Invitee mobile number. */
  mobileNumber?: InputMaybe<Scalars['String']>;
  /** Organization IDs to share invitee with. */
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated input type of CreateInvitee */
export type CreateInviteeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The Invitee attributes. */
  invitee: CreateInviteeAttributes;
};

/** Autogenerated return type of CreateInvitee. */
export type CreateInviteePayload = {
  __typename?: 'CreateInviteePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The created learner. */
  learner?: Maybe<Learner>;
};

/** Attributes needed to create a license. */
export type CreateLicenseAttributes = {
  /** The ID of the course to license. */
  courseId: Scalars['ID'];
  /** If this license should be granted immediately. */
  grant: Scalars['Boolean'];
  /** Any note to attach to the license for later reference. */
  note?: InputMaybe<Scalars['String']>;
  /** The number of seats to issue for this license or nil for an open license. */
  seats?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of CreateLicense */
export type CreateLicenseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to issue a license. */
  license: CreateLicenseAttributes;
  /** The ID of the user to issue the license for. */
  userId: Scalars['ID'];
};

/** Autogenerated return type of CreateLicense. */
export type CreateLicensePayload = {
  __typename?: 'CreateLicensePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created license. */
  license?: Maybe<License>;
};

/** Attributes needed to create a multi-factor authentication method. */
export type CreateMfaMethodAttributes = {
  /** The ID of the contact method to use for MFA. */
  contactMethodId: Scalars['ID'];
  /** The type of MFA method to create. */
  methodType: Scalars['String'];
};

/** Autogenerated input type of CreateMFAMethod */
export type CreateMfaMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The MFA method to create. */
  mfaMethod: CreateMfaMethodAttributes;
};

/** Autogenerated return type of CreateMFAMethod. */
export type CreateMfaMethodPayload = {
  __typename?: 'CreateMFAMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created MFA method. */
  mfaMethod?: Maybe<MfaMethod>;
};

/** Attributes for a menu item. */
export type CreateMenuItemAttributes = {
  /** The feature image placed at the left of the menu item. */
  featureImageLeft?: InputMaybe<AttacheUploadFile>;
  /** The feature image placed at the right of the menu item. */
  featureImageRight?: InputMaybe<AttacheUploadFile>;
  /** The page this menu item links to. */
  pageId?: InputMaybe<Scalars['ID']>;
  /** The title of this menu item. */
  title?: InputMaybe<Scalars['String']>;
  /** The URL this menu item links to. */
  url?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateMenuItem */
export type CreateMenuItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a menu item. */
  menuItem: CreateMenuItemAttributes;
  /** The ID of the storefront to create a menu item. */
  storefrontId: Scalars['ID'];
};

/** Autogenerated return type of CreateMenuItem. */
export type CreateMenuItemPayload = {
  __typename?: 'CreateMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created Menu Item. */
  menuItem?: Maybe<MenuItem>;
};

/** Attributes needed to create a Nito-based item bank. */
export type CreateNitoBankAttributes = {
  /** The name of the bank. */
  name: Scalars['String'];
};

/** Autogenerated input type of CreateNitoBank */
export type CreateNitoBankInput = {
  /** The bank to create. */
  bank: CreateNitoBankAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The organization to which the bank belongs. */
  organizationId: Scalars['ID'];
};

/** Autogenerated return type of CreateNitoBank. */
export type CreateNitoBankPayload = {
  __typename?: 'CreateNitoBankPayload';
  /** The newly created Nito based exam. */
  bank?: Maybe<NitoBank>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to create a Nito-based exam. */
export type CreateNitoExamAttributes = {
  /** The name of the exam. */
  name: Scalars['String'];
};

/** Autogenerated input type of CreateNitoExam */
export type CreateNitoExamInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The exam to create. */
  exam: CreateNitoExamAttributes;
  /** The organization to which the exam belongs. */
  organizationId: Scalars['ID'];
};

/** Autogenerated return type of CreateNitoExam. */
export type CreateNitoExamPayload = {
  __typename?: 'CreateNitoExamPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created Nito based exam. */
  exam?: Maybe<NitoExam>;
};

/** Attributes for a OIDC provider. */
export type CreateOidcProviderAttributes = {
  /** The automation claim path of the OIDC provider. */
  automationClaimPath?: InputMaybe<Scalars['String']>;
  /** The client ID of the OIDC provider. */
  clientId: Scalars['String'];
  /** The client secret of the OIDC provider. */
  clientSecret: Scalars['String'];
  /** The configuration URL of the OIDC provider. */
  configurationUrl: Scalars['String'];
  /** Whether to confirm email during signup. */
  confirmEmailDuringSignup: Scalars['Boolean'];
  /** The name of the OIDC provider. */
  name: Scalars['String'];
  /** The promo code claim path of the OIDC provider. */
  promoCodeClaimPath?: InputMaybe<Scalars['String']>;
  /** The scopes of the OIDC provider. */
  scope: Scalars['String'];
};

/** Autogenerated input type of CreateOIDCProvider */
export type CreateOidcProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a OIDC Provider. */
  oidcProvider: CreateOidcProviderAttributes;
  /** The ID of the organization to create a OIDC Provider. */
  organizationId: Scalars['ID'];
};

/** Autogenerated return type of CreateOIDCProvider. */
export type CreateOidcProviderPayload = {
  __typename?: 'CreateOIDCProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created OIDC Provider. */
  oidcProvider?: Maybe<OidcProvider>;
};

/** Autogenerated input type of CreateOrder */
export type CreateOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The Stripe details to charge the order. */
  gatewayInfo: GatewayInfoAttributes;
};

/** Autogenerated return type of CreateOrder. */
export type CreateOrderPayload = {
  __typename?: 'CreateOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** A representation of shopping cart */
  gatewayInfo?: Maybe<GatewayInfo>;
  /** The completed order (if no errors) */
  order?: Maybe<Order>;
  /** A representation of shopping cart */
  shoppingCart: ShoppingCart;
};

/** Attributes needed to create an Organization. */
export type CreateOrganizationAttributes = {
  /** The address of the Organization. */
  address: NewAddressAttributes;
  /** Whether to allow platform developers to collect analytics. */
  analyticsOptIn: Scalars['Boolean'];
  /** The email for billing related issues. */
  billingEmail: Scalars['String'];
  /** The name of the Organization. */
  name: Scalars['String'];
  /** The email for notifications about orders including shipped products. */
  shippingNotificationEmail?: InputMaybe<Scalars['String']>;
  /** A URL for the organization. */
  url?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateOrganization */
export type CreateOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create an Organization. */
  organization: CreateOrganizationAttributes;
};

/** Autogenerated return type of CreateOrganization. */
export type CreateOrganizationPayload = {
  __typename?: 'CreateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created Organization. */
  organization?: Maybe<Organization>;
};

/** Attributes for a page. */
export type CreatePageAttributes = {
  /** CSS classes to apply to the page. */
  cssClass?: InputMaybe<Scalars['String']>;
  /** A description of the page. */
  description?: InputMaybe<Scalars['String']>;
  /** The feature image for this page. */
  featureImage?: InputMaybe<AttacheUploadFile>;
  /** Meta tags for the page. */
  metaTags?: InputMaybe<Array<MetaTagAttributes>>;
  /** The name of the page. */
  name: Scalars['String'];
  /** A password to access the page. If not provided, the page is public. */
  password?: InputMaybe<Scalars['String']>;
  /** Whether the page is published or not. */
  published: Scalars['Boolean'];
  /** Whether the user must be logged in to access the page. */
  requireLoggedInUser?: InputMaybe<Scalars['Boolean']>;
  /** Whether the page is the home page or not. Only one page may be the home page. */
  root: Scalars['Boolean'];
  /** How the page will looks on the URL. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreatePage */
export type CreatePageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a page. */
  page: CreatePageAttributes;
  /** The ID of the storefront to create a page. */
  storefrontId: Scalars['ID'];
};

/** Autogenerated return type of CreatePage. */
export type CreatePagePayload = {
  __typename?: 'CreatePagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created Page. */
  page?: Maybe<Page>;
};

/** Autogenerated input type of CreatePendingILBookingReservation */
export type CreatePendingIlBookingReservationInput = {
  /** The ID of the cart item with the booking. */
  cartItemId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the course item. */
  courseItemId: Scalars['ID'];
  /** The ID of the instructor-led class to book into. */
  ilClassId: Scalars['ID'];
};

/** Autogenerated return type of CreatePendingILBookingReservation. */
export type CreatePendingIlBookingReservationPayload = {
  __typename?: 'CreatePendingILBookingReservationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The created instructor-led booking. */
  pendingIlBookingReservation?: Maybe<PendingIlBookingReservation>;
};

/** Attributes for a prerequisite. */
export type CreatePrerequisiteCourseRequirementAttributes = {
  /** The courses that are a prerequisite for this course. */
  requiredCourseIds: Array<Scalars['ID']>;
  /** The number of courses that must be completed for this prerequisite. */
  requirementQuantity: Scalars['Int'];
};

/** Autogenerated input type of CreatePrerequisiteCourseRequirement */
export type CreatePrerequisiteCourseRequirementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The course that needs a prerequisite. */
  courseId: Scalars['ID'];
  /** The prerequisite to create. */
  prerequisite: CreatePrerequisiteCourseRequirementAttributes;
};

/** Autogenerated return type of CreatePrerequisiteCourseRequirement. */
export type CreatePrerequisiteCourseRequirementPayload = {
  __typename?: 'CreatePrerequisiteCourseRequirementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The created prerequisite course requirement. */
  prerequisiteCourseRequirement?: Maybe<PrerequisiteCourseRequirement>;
};

/** Attributes for a product. */
export type CreateProductAttributes = {
  /** Whether the product is available for individual purchase. */
  availableForIndividualPurchase: Scalars['Boolean'];
  /** Settings for bulk discounts. */
  bulkDiscountOptions?: InputMaybe<BulkDiscountOptionsAttributes>;
  /** Whether the product has bulk discounts. */
  bulkDiscounts: Scalars['Boolean'];
  /** Media for the product page carousel. */
  carouselMedia?: InputMaybe<Array<AttacheUploadFile>>;
  /** The categories this course is in. */
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** A description of the product. */
  description?: InputMaybe<Scalars['String']>;
  /** Whether the product is hidden. */
  hidden: Scalars['Boolean'];
  /** Meta Tags for the product page. */
  metaTags?: InputMaybe<Array<MetaTagAttributes>>;
  /** The name of the product. */
  name: Scalars['String'];
  /** The feature image for this product. */
  photo?: InputMaybe<AttacheUploadFile>;
  /** The price of the product. */
  price: Scalars['Float'];
  /** Products that are bundled with this product. */
  products?: InputMaybe<Array<Scalars['ID']>>;
  /** Whether the product requires shipping. */
  requiresShipping: Scalars['Boolean'];
  /** A short description of the product. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** The SKU of the product. */
  sku?: InputMaybe<Scalars['String']>;
  /** A text summary of the product. */
  summary?: InputMaybe<Scalars['String']>;
  /** Tags to add to the product. */
  tags?: InputMaybe<Array<TagAttributes>>;
  /** Whether the product charges taxes. */
  taxesEnabled?: Scalars['Boolean'];
};

/** Autogenerated input type of CreateProduct */
export type CreateProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a product. */
  product: CreateProductAttributes;
  /** The ID of the storefront to create a product. */
  storefrontId: Scalars['ID'];
};

/** Autogenerated return type of CreateProduct. */
export type CreateProductPayload = {
  __typename?: 'CreateProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created Product. */
  product?: Maybe<Product>;
};

/** Attributes needed to create a promo code. */
export type CreatePromoCodeAttributes = {
  /** The code that will be distributed and applied to get the discount. */
  code?: InputMaybe<Scalars['String']>;
  /** The discounts that will be applied when the promo code is used. */
  discounts?: InputMaybe<Array<PromoCodeDiscountAttributes>>;
  /** An end time for the promo code to stop working. */
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The maximum number of times a customer is allowed to use this promo code. */
  maxUses?: InputMaybe<Scalars['Int']>;
  /** Internal notes for managing promo codes. */
  notes?: InputMaybe<Scalars['String']>;
  /** A persistent promo code applies to future purchases until it is manually removed. */
  persistent?: InputMaybe<Scalars['Boolean']>;
  /** The number of seats or quantity that a customer can receive a discount on while using this promo code. The remaining quantity is full price. */
  quantityLimit?: InputMaybe<Scalars['Int']>;
  /** A promo code that can only be applied through SAML SSO. */
  ssoOnly?: InputMaybe<Scalars['Boolean']>;
  /** A start time for the promo code to become active. */
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of CreatePromoCode */
export type CreatePromoCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a promo code. */
  promoCode: CreatePromoCodeAttributes;
  /** The Storefront to create the promo code under. */
  storefrontId: Scalars['ID'];
};

/** Autogenerated return type of CreatePromoCode. */
export type CreatePromoCodePayload = {
  __typename?: 'CreatePromoCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The new promo code. */
  promoCode?: Maybe<PromoCode>;
};

/** Attributes needed to create a RapidQL schedule. */
export type CreateRapidqlScheduleAttributes = {
  /** The week day or calendar day that schedule will run. */
  day?: InputMaybe<RapidqlScheduleDayEnum>;
  /** Choose the first day, last day, or middle of the month schedule will run. */
  dayModifier?: InputMaybe<RapidqlScheduleDayModifierEnum>;
  /** Whether the report will be delivered when there are no results. */
  dontSendIfNoResults?: InputMaybe<Scalars['Boolean']>;
  /** List of emails to BCC */
  emailBcc?: InputMaybe<Array<Scalars['String']>>;
  /** List of emails to CC */
  emailCc?: InputMaybe<Array<Scalars['String']>>;
  /** List of emails to send report to */
  emailTo: Array<Scalars['String']>;
  /** Whether the report is enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The filters to apply when running the report. */
  filters?: InputMaybe<Scalars['JSON']>;
  /** Hour that schedule will run */
  hourOfDay: Scalars['Int'];
  /** How often the report will be sent. */
  interval: RapidqlScheduleIntervalEnum;
  /** Time zone that schedule will run the schedulable */
  timeZone: Scalars['String'];
};

/** Autogenerated input type of CreateRapidqlSchedule */
export type CreateRapidqlScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The schedule to create. */
  rapidqlSchedule: CreateRapidqlScheduleAttributes;
  /** The ID of the schedulable to schedule. */
  schedulableId: Scalars['ID'];
};

/** Autogenerated return type of CreateRapidqlSchedule. */
export type CreateRapidqlSchedulePayload = {
  __typename?: 'CreateRapidqlSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The rapidql schedule */
  rapidqlSchedule?: Maybe<RapidqlSchedule>;
};

/** Attributes for a redirect. */
export type CreateRedirectAttributes = {
  /** The URL that triggers the redirection. */
  redirectFrom: Scalars['String'];
  /** The object that the redirect points to. */
  redirectTo: Scalars['ID'];
};

/** Autogenerated input type of CreateRedirect */
export type CreateRedirectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a redirect. */
  redirect: CreateRedirectAttributes;
  /** The ID of the storefront to create a redirect. */
  storefrontId: Scalars['ID'];
};

/** Autogenerated return type of CreateRedirect. */
export type CreateRedirectPayload = {
  __typename?: 'CreateRedirectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created Redirect. */
  redirect?: Maybe<Redirect>;
};

/** Attributes for a refund. */
export type CreateRefundAttributes = {
  /** The amount to refund when it is a custom refund. */
  amount?: InputMaybe<Scalars['Float']>;
  /** The expected shipping. */
  expectedShipping: Scalars['Float'];
  /** The expected subtotal. */
  expectedSubtotal: Scalars['Float'];
  /** The expected tax. */
  expectedTax: Scalars['Float'];
  /** The expected total. */
  expectedTotal: Scalars['Float'];
  /** The order item IDs to refund when it is a regular refund. */
  items?: InputMaybe<Array<RefundItemAttributes>>;
  /** The reason for the refund. */
  reason: Scalars['String'];
  /** The type of refund. */
  type: RefundTypeEnum;
};

/** Autogenerated input type of CreateRefund */
export type CreateRefundInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The order ID to refund. */
  orderId: Scalars['ID'];
  /** Attributes needed to create a refund. */
  refund: CreateRefundAttributes;
};

/** Autogenerated return type of CreateRefund. */
export type CreateRefundPayload = {
  __typename?: 'CreateRefundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The created refund. */
  refund?: Maybe<Refund>;
};

/** Attributes needed to create a regulator submission record. */
export type CreateRegulatorSubmissionAttributes = {
  /** Any notes you want to track. */
  notes?: InputMaybe<Scalars['String']>;
  /** The reference ID provided by the regulator. */
  regulatorReferenceId: Scalars['String'];
  /** When the completion was submitted to the regulator. */
  submittedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of CreateRegulatorSubmission */
export type CreateRegulatorSubmissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the completion to track the submission of. */
  completionId: Scalars['ID'];
  /** The regulator submission record to create. */
  regulatorSubmission: CreateRegulatorSubmissionAttributes;
};

/** Autogenerated return type of CreateRegulatorSubmission. */
export type CreateRegulatorSubmissionPayload = {
  __typename?: 'CreateRegulatorSubmissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created regulator submission record. */
  submission: RegulatorSubmission;
};

/** Attributes for a SAML provider. */
export type CreateSamlProviderAttributes = {
  /** The automation mapping of the SAML provider. */
  automationMapping?: InputMaybe<Scalars['String']>;
  /** The cert fingerprint of the SAML provider. */
  certFingerprint: Scalars['String'];
  /** The cert fingerprint algorithm of the SAML provider. */
  certFingerprintAlgorithm: SamlProviderEncryptionAlgorithmsTypeEnum;
  /** Whether to confirm email during signup. */
  confirmEmailDuringSignup: Scalars['Boolean'];
  /** The email mapping of the SAML provider. */
  emailMapping?: InputMaybe<Scalars['String']>;
  /** The first name mapping of the SAML provider. */
  firstNameMapping: Scalars['String'];
  /** The issuer URL of the SAML provider. */
  issuerUrl?: InputMaybe<Scalars['String']>;
  /** The last name mapping of the SAML provider. */
  lastNameMapping: Scalars['String'];
  /** The name of the SAML provider. */
  name: Scalars['String'];
  /** The promo codes mapping of the SAML provider. */
  promoCodesMapping?: InputMaybe<Scalars['String']>;
  /** The SLO target URL of the SAML provider. */
  sloTargetUrl?: InputMaybe<Scalars['String']>;
  /** The target URL of the SAML provider. */
  targetUrl: Scalars['String'];
  /** Whether to trigger IDP logout. */
  triggerIdpLogout: Scalars['Boolean'];
  /** The UID mapping of the SAML provider. */
  uidMapping?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateSAMLProvider */
export type CreateSamlProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the organization to create a SAML Provider. */
  organizationId: Scalars['ID'];
  /** Attributes needed to create a SAML Provider. */
  samlProvider: CreateSamlProviderAttributes;
};

/** Autogenerated return type of CreateSAMLProvider. */
export type CreateSamlProviderPayload = {
  __typename?: 'CreateSAMLProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created SAML Provider. */
  samlProvider?: Maybe<SamlProvider>;
};

/** The saved query attributes. */
export type CreateSavedQueryAttributes = {
  /** The audience of the query. */
  audience: AudienceEnum;
  /** The name of the saved query. */
  name: Scalars['String'];
  /** The RQL code. */
  query: Scalars['String'];
};

/** Autogenerated input type of CreateSavedQuery */
export type CreateSavedQueryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the owner to own the saved query. */
  ownerId: Scalars['ID'];
  /** The saved query attributes. */
  savedQuery: CreateSavedQueryAttributes;
};

/** Autogenerated return type of CreateSavedQuery. */
export type CreateSavedQueryPayload = {
  __typename?: 'CreateSavedQueryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The saved query. */
  savedQuery?: Maybe<SavedQuery>;
};

/** Autogenerated input type of CreateSharedProduct */
export type CreateSharedProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a shared product. */
  sharedProduct: SharedProductAttributes;
};

/** Autogenerated return type of CreateSharedProduct. */
export type CreateSharedProductPayload = {
  __typename?: 'CreateSharedProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created shared product. */
  sharedProduct?: Maybe<SharedProduct>;
};

/** Attributes needed to create a survey result. */
export type CreateSurveyResultAttributes = {
  /** The results of the survey. */
  content: Scalars['JSON'];
};

/** Autogenerated input type of CreateSurveyResult */
export type CreateSurveyResultInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The survey result data. */
  surveyResult: CreateSurveyResultAttributes;
  /** The ID of the survey to create the results on. */
  surveySchemaId: Scalars['ID'];
};

/** Autogenerated return type of CreateSurveyResult. */
export type CreateSurveyResultPayload = {
  __typename?: 'CreateSurveyResultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the survey result was created. */
  ok: Scalars['Boolean'];
};

/** Attributes needed to create a new survey. */
export type CreateSurveySchemaAttributes = {
  /** Whether the survey can be closed or not. */
  closeable?: InputMaybe<Scalars['Boolean']>;
  /** The contents of the survey. */
  content?: InputMaybe<Scalars['JSON']>;
  /** The description of this survey. */
  description?: InputMaybe<Scalars['String']>;
  /** The name of this survey. */
  name: Scalars['String'];
  /** The theme of the survey. */
  theme?: InputMaybe<Scalars['JSON']>;
};

/** Autogenerated input type of CreateSurveySchema */
export type CreateSurveySchemaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the Organization the survey is created on. */
  organizationId: Scalars['ID'];
  /** Attributes for the new survey. */
  surveySchema: CreateSurveySchemaAttributes;
};

/** Autogenerated return type of CreateSurveySchema. */
export type CreateSurveySchemaPayload = {
  __typename?: 'CreateSurveySchemaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The created survey. */
  surveySchema?: Maybe<SurveySchema>;
};

/** Attributes for a theme. */
export type CreateThemeAttributes = {
  /** The background color of the theme. */
  backgroundColor: Scalars['String'];
  /** Custom CSS for the theme. */
  customLess?: InputMaybe<Scalars['String']>;
  /** The font name of the theme. */
  fontName: Scalars['String'];
  /** Header liquid for the theme. */
  headerLiquid?: InputMaybe<Scalars['String']>;
  /** The name of the theme. */
  name: Scalars['String'];
  /** The text color of the theme. */
  textColor: Scalars['String'];
};

/** Autogenerated input type of CreateTheme */
export type CreateThemeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the storefront to create a theme. */
  storefrontId: Scalars['ID'];
  /** Attributes needed to create a theme. */
  theme: CreateThemeAttributes;
};

/** Autogenerated return type of CreateTheme. */
export type CreateThemePayload = {
  __typename?: 'CreateThemePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created Theme. */
  theme?: Maybe<Theme>;
};

/** Attributes needed to create a training competency. */
export type CreateTrainingCompetencyAttributes = {
  /** The IDs of the courses for this training competency */
  courseIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Training competency description */
  description?: InputMaybe<Scalars['String']>;
  /** Training competency name */
  name: Scalars['String'];
};

/** Autogenerated input type of CreateTrainingCompetency */
export type CreateTrainingCompetencyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The organization which the Training Competency will belong to. */
  organizationId: Scalars['ID'];
  /** Attributes needed to create a Training competency. */
  trainingCompetency: CreateTrainingCompetencyAttributes;
};

/** Autogenerated return type of CreateTrainingCompetency. */
export type CreateTrainingCompetencyPayload = {
  __typename?: 'CreateTrainingCompetencyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created Training competency. */
  trainingCompetency?: Maybe<TrainingCompetency>;
};

/** Attributes needed to create a training role */
export type CreateTrainingRoleAttributes = {
  /** Training role description */
  description?: InputMaybe<Scalars['String']>;
  /** Training role name */
  name: Scalars['String'];
  /** The training competencies attached to the training role */
  trainingCompetencyIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated input type of CreateTrainingRole */
export type CreateTrainingRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The organization which the training role will belong to */
  organizationId: Scalars['ID'];
  /** Attributes needed to create a training role */
  trainingRole: CreateTrainingRoleAttributes;
};

/** Autogenerated return type of CreateTrainingRole. */
export type CreateTrainingRolePayload = {
  __typename?: 'CreateTrainingRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created training role */
  trainingRole?: Maybe<TrainingRole>;
};

/** Attributes needed to create a user */
export type CreateUserAttributes = {
  /** User email */
  email?: InputMaybe<Scalars['String']>;
  /** User first name */
  firstName: Scalars['String'];
  /** User last name */
  lastName: Scalars['String'];
  /** User language preference */
  locale?: InputMaybe<Scalars['String']>;
  /** User phone number */
  mobileNumber?: InputMaybe<Scalars['String']>;
  /** Tags to add to the user. */
  tags?: InputMaybe<Array<TagAttributes>>;
  /** User timezone */
  timeZone?: InputMaybe<Scalars['TimeZone']>;
};

/** Autogenerated input type of CreateUser */
export type CreateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to create a user memory record */
  user: CreateUserAttributes;
};

/** Attributes needed to create a user memory record */
export type CreateUserMemoryAttributes = {
  /** Name of the memory */
  name: Scalars['String'];
  /** Value of the memory */
  value: Scalars['String'];
};

/** Autogenerated input type of CreateUserMemory */
export type CreateUserMemoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** User to create the memory on */
  userId: Scalars['ID'];
  /** Attributes needed to create a user memory record */
  userMemory: CreateUserMemoryAttributes;
};

/** Autogenerated return type of CreateUserMemory. */
export type CreateUserMemoryPayload = {
  __typename?: 'CreateUserMemoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The user memory record */
  userMemory?: Maybe<UserMemory>;
};

/** Autogenerated return type of CreateUser. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The user */
  user?: Maybe<User>;
};

/** Union type for different credential configurations */
export type CredentialConfiguration = MicrosoftEntraCredentialConfiguration | TractionCredentialConfiguration;

/** A currency in the system. */
export type Currency = {
  __typename?: 'Currency';
  /** The ISO code of this currency. */
  isoCode: Scalars['String'];
  /** The name of this currency. */
  name: Scalars['String'];
};

/** A custom attribute on a record. */
export type CustomAttribute = RelayNode & {
  __typename?: 'CustomAttribute';
  /** The content of the custom attribute. */
  content: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The kind of custom attribute. */
  kind: CustomAttributeKindEnum;
  /** The name of the custom attribute. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Options for custom attributes */
export enum CustomAttributeKindEnum {
  /** html */
  Html = 'html',
  /** text */
  Text = 'text'
}

/** A custom domain for a storefront */
export type CustomDomain = RelayNode & {
  __typename?: 'CustomDomain';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The domain for the storefront. */
  name: Scalars['String'];
  /** Whether this domain is the current primary domain for the storefront. */
  primary: Scalars['Boolean'];
  /** A date to manage if, and when this domain was made the primary domain. */
  primaryAt?: Maybe<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A custom field on a storefront. */
export type CustomField = RelayNode & {
  __typename?: 'CustomField';
  /** Any permissions you have relevant to the custom field. */
  can: CustomFieldPermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The options available in the case of this field being a dropdown. */
  customFieldOptions?: Maybe<Array<CustomFieldOption>>;
  /** The type of this field. */
  fieldType?: Maybe<CustomFieldFieldTypeTypeEnum>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the custom field. */
  name: Scalars['String'];
  /** Whether this field is required or not. */
  required: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Whether this field should be shown on the signup form. */
  showOnSignup: Scalars['Boolean'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A custom field on a storefront. */
export type CustomFieldRequiredArgs = {
  applyCourseRequirements?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for CustomField. */
export type CustomFieldConnection = {
  __typename?: 'CustomFieldConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomFieldEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CustomField>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** A requirement specified by a course for a certain custom field to be provided by the user. */
export type CustomFieldCourseRequirement = CourseRequirementInterface & RelayNode & {
  __typename?: 'CustomFieldCourseRequirement';
  /** The course which has the requirement. */
  course: Course;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The custom fields which satisfy this requirement. */
  customFields: Array<CustomField>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Has the user satisfied this requirement? */
  satisfied: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The kind of requirement specified by the course. */
  type: CourseRequirementsTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A requirement specified by a course for a certain custom field to be provided by the user. */
export type CustomFieldCourseRequirementCustomFieldsArgs = {
  onlyRelevant?: InputMaybe<Scalars['Boolean']>;
};


/** A requirement specified by a course for a certain custom field to be provided by the user. */
export type CustomFieldCourseRequirementSatisfiedArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};

/** An edge in a connection. */
export type CustomFieldEdge = {
  __typename?: 'CustomFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CustomField>;
};

/** Valid types for a field type of a custom field. */
export enum CustomFieldFieldTypeTypeEnum {
  /** A field type which is a checkbox. */
  Checkbox = 'checkbox',
  /** A field type which is a date. */
  Date = 'date',
  /** A field type which is an email. */
  Email = 'email',
  /** A field type which is a number. */
  Number = 'number',
  /** A field type which is plain. */
  Plain = 'plain',
  /** A field type which is a select dropdown. */
  SelectDropdown = 'select_dropdown'
}

/** An available option of a dropdown custom field on a storefront. */
export type CustomFieldOption = RelayNode & {
  __typename?: 'CustomFieldOption';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The value of the selected dropdown option. */
  value: Scalars['String'];
};

/** Attributes for a custom field option. */
export type CustomFieldOptionAttributes = {
  /** The value of the custom field option. */
  value: Scalars['String'];
};

/** Whether you have permission to perform certain actions on this custom field. */
export type CustomFieldPermissions = {
  __typename?: 'CustomFieldPermissions';
  /** Whether you can destroy this custom field. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this custom field. */
  update: Scalars['Boolean'];
};

/** Custom fields. */
export type CustomFieldsNamespace = {
  __typename?: 'CustomFieldsNamespace';
  /** Custom fields you have access to. */
  all: CustomFieldConnection;
  /** Find a single customfield by its string ID. */
  findByGid?: Maybe<CustomField>;
  /** Find a single customfield by its integer ID. */
  findById: CustomField;
  /** Find a single customfield by its signed ID. */
  findBySgid?: Maybe<CustomField>;
};


/** Custom fields. */
export type CustomFieldsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Custom fields. */
export type CustomFieldsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Custom fields. */
export type CustomFieldsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Custom fields. */
export type CustomFieldsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** A custom field value. */
export type CustomValue = RelayNode & {
  __typename?: 'CustomValue';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The custom field to which this belongs */
  customField: CustomField;
  /** The ID of the custom field. */
  customFieldId: Scalars['Int'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Whether the user is required to provide this value or not. */
  required: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The value of the field. */
  value?: Maybe<Scalars['String']>;
};

/** Attributes to update a CustomValue for the user. */
export type CustomValueAttributes = {
  /** The ID of the CustomField record this value is for. */
  customFieldId?: InputMaybe<Scalars['Int']>;
  /** The ID for the CustomValue record we are updating. */
  id?: InputMaybe<Scalars['Int']>;
  /** The value of the field. */
  value: Scalars['String'];
};

/** A FAQ item, with title and its URL. */
export type DashboardFaq = {
  __typename?: 'DashboardFaq';
  /** Title of the FAQ. */
  title: Scalars['String'];
  /** URL to the FAQ. */
  url: Scalars['String'];
};

/** Data for dashboards */
export type DashboardNamespace = {
  __typename?: 'DashboardNamespace';
  /** Report IDs from dynamic settings. */
  reports: ReportDashboard;
  /** Values to customize the Selling dashboard */
  selling: SellingDashboard;
};


/** Data for dashboards */
export type DashboardNamespaceSellingArgs = {
  storefrontId: Scalars['ID'];
};

/** Autogenerated input type of DeprecateCourse */
export type DeprecateCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of course to deprecate. */
  courseId: Scalars['ID'];
  /** ID of the optional replacement course. */
  replacementCourseId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of DeprecateCourse. */
export type DeprecateCoursePayload = {
  __typename?: 'DeprecateCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course that was deprecated. */
  course: Course;
  /** The deprecation record. */
  courseDeprecation?: Maybe<CourseDeprecation>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
};

/** An automation event and its description. */
export type DescribedAutomationEvent = {
  __typename?: 'DescribedAutomationEvent';
  /** A description of the event. */
  description: Scalars['String'];
  /** The event. */
  event: AutomationEvent;
};

/** Autogenerated input type of DestroyNode */
export type DestroyNodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the node to destroy. */
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroyNode. */
export type DestroyNodePayload = {
  __typename?: 'DestroyNodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred while processing the request. */
  errors?: Maybe<Array<ValidationError>>;
  /** The node, null if not destroyed. */
  node?: Maybe<RelayNode>;
  /** Whether the record was destroyed or not. Some require you to use specialized mutations. */
  ok: Scalars['Boolean'];
};

/** Autogenerated input type of DestroyUser */
export type DestroyUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of DestroyUser. */
export type DestroyUserPayload = {
  __typename?: 'DestroyUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Did you destroy yourself? */
  success: Scalars['Boolean'];
};

/** A discount level. */
export type DiscountLevel = {
  __typename?: 'DiscountLevel';
  /** Dollar amount of discount. */
  dollar: Scalars['Float'];
  /** Maximum units purchased. */
  max?: Maybe<Scalars['Int']>;
  /** Minimum units purchased. */
  min?: Maybe<Scalars['Int']>;
  /** Percent amount of discount. */
  percent: Scalars['Float'];
  /** Dollar or percent discount toggle. */
  useDollarDiscount: Scalars['Boolean'];
};

/** Attributes for discount levels on bulk discounts. */
export type DiscountLevelAttributes = {
  /** Dollar amount of the discount. */
  dollar: Scalars['Float'];
  /** Minimum number of products. */
  max?: InputMaybe<Scalars['Int']>;
  /** Max number of products. */
  min: Scalars['Int'];
  /** Percent amount of the discount */
  percent: Scalars['Float'];
  /** Toggle for using a dollar or percent based discount. */
  useDollarDiscount: Scalars['Boolean'];
};

/** An record that can be discussed. */
export type Discussable = {
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Discussion topics for this discussable. */
  discussionMessages?: Maybe<DiscussionMessageConnection>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** An record that can be discussed. */
export type DiscussableDiscussionMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A discussion message. */
export type DiscussionMessage = RelayNode & {
  __typename?: 'DiscussionMessage';
  /** The user who posted the discussion message. */
  author: LightUser;
  /** Any permissions you have on this discussion message. */
  can: DiscussionMessagePermissions;
  /** The actual discussion message content (HTML). */
  content: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The discussable this message is for. */
  discussable: Discussable;
  /** Any files attached to the message. */
  files: Array<AttacheFile>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** A short preview of the content (no HTML). */
  preview: Scalars['String'];
  /** The replies to this message if it's a topic. */
  replies: DiscussionMessageConnection;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The title of the topic, if this message is a topic. */
  title?: Maybe<Scalars['String']>;
  /** The topic of this message, if it's a reply. */
  topic?: Maybe<DiscussionMessage>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A discussion message. */
export type DiscussionMessagePreviewArgs = {
  length?: InputMaybe<Scalars['Int']>;
};


/** A discussion message. */
export type DiscussionMessageRepliesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for DiscussionMessage. */
export type DiscussionMessageConnection = {
  __typename?: 'DiscussionMessageConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DiscussionMessageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DiscussionMessage>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DiscussionMessageEdge = {
  __typename?: 'DiscussionMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DiscussionMessage>;
};

/** Permissions on a discussion message. */
export type DiscussionMessagePermissions = {
  __typename?: 'DiscussionMessagePermissions';
  /** Whether you can destroy this discussion message. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
};

/** Find discussion messages for things you can discuss. */
export type DiscussionMessagesNamespace = {
  __typename?: 'DiscussionMessagesNamespace';
  /** Find discussion topics for a discussable. */
  all: DiscussionMessageConnection;
  /** Find graded assignment feedback that hasn't been replied to */
  graderInbox: DiscussionMessageConnection;
  /** Find replies to a topic */
  replies: DiscussionMessageConnection;
};


/** Find discussion messages for things you can discuss. */
export type DiscussionMessagesNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  discussableId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


/** Find discussion messages for things you can discuss. */
export type DiscussionMessagesNamespaceGraderInboxArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Find discussion messages for things you can discuss. */
export type DiscussionMessagesNamespaceRepliesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  topicId: Scalars['ID'];
};

/** A downloadable file. */
export type DownloadableFile = RelayNode & {
  __typename?: 'DownloadableFile';
  /** Any permissions you have relevant to the file. */
  can: DownloadableFilePermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The number of downloads. */
  downloads: Scalars['Int'];
  /** The file itself. */
  file: AttacheFile;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the file. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The generated static ID of the file. */
  staticId: Scalars['String'];
  /** The direct URL to the file. */
  staticUrl: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The URL to the application handle the file download. */
  url: Scalars['String'];
};

/** Whether you have permission to perform certain actions on this downloadable file. */
export type DownloadableFilePermissions = {
  __typename?: 'DownloadableFilePermissions';
  /** Whether you can destroy this file. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can preview this file. */
  preview: Scalars['Boolean'];
  /** Whether you can update this file. */
  update: Scalars['Boolean'];
};

/** A calculable for a dynamic contract. */
export type DynamicContract = ContractCalculable & RelayNode & {
  __typename?: 'DynamicContract';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Logic that generates data. */
  logic: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Type of contract, snake_case. */
  type: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of EditNitoBanks */
export type EditNitoBanksInput = {
  /** The GIDs of the banks to edit. */
  bankIds: Array<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of EditNitoBanks. */
export type EditNitoBanksPayload = {
  __typename?: 'EditNitoBanksPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The URL to open. */
  url: Scalars['String'];
};

/** Autogenerated input type of EditNitoExams */
export type EditNitoExamsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The GIDs of the exams to edit. */
  examIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of EditNitoExams. */
export type EditNitoExamsPayload = {
  __typename?: 'EditNitoExamsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The URL to open. */
  url: Scalars['String'];
};

/** A requirement specified by a course for a confirmed email address to be added to the user's account. */
export type EmailCourseRequirement = CourseRequirementInterface & RelayNode & {
  __typename?: 'EmailCourseRequirement';
  /** The course which has the requirement. */
  course: Course;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Has the user satisfied this requirement? */
  satisfied: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The kind of requirement specified by the course. */
  type: CourseRequirementsTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A requirement specified by a course for a confirmed email address to be added to the user's account. */
export type EmailCourseRequirementSatisfiedArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of EmptyUserCart */
export type EmptyUserCartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of EmptyUserCart. */
export type EmptyUserCartPayload = {
  __typename?: 'EmptyUserCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Did the users cart items get deleted? */
  success: Scalars['Boolean'];
};

/** An enrolment key created by a training manager, on a license to easily distribute a course. */
export type EnrolmentKey = RelayNode & SoftDestroyable & {
  __typename?: 'EnrolmentKey';
  /** Any permissions you have relevant to this enrolment key. */
  can: EnrolmentKeyPermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** When this record was destroyed. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** When this enrolment key expires. */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The grants created by using this enrolment key. */
  grants: GrantConnection;
  /** The integer ID. */
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** The number of times the enrolment key may be used (null if unlimited uses). */
  maxUses?: Maybe<Scalars['Int']>;
  /** How many remaining uses this key has (null if unlimited). */
  remainingUses?: Maybe<Scalars['Int']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The token to claim an enrolment key. */
  token: Scalars['String'];
  /** Whether the enrolment key applies to all licenses within the License Group the License is a part of. */
  universal: Scalars['Boolean'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The number of times the enrolment key has been used. */
  uses: Scalars['Int'];
};


/** An enrolment key created by a training manager, on a license to easily distribute a course. */
export type EnrolmentKeyGrantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for EnrolmentKey. */
export type EnrolmentKeyConnection = {
  __typename?: 'EnrolmentKeyConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnrolmentKeyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnrolmentKey>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EnrolmentKeyEdge = {
  __typename?: 'EnrolmentKeyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EnrolmentKey>;
};

/** Permissions on an EnrolmentKey */
export type EnrolmentKeyPermissions = {
  __typename?: 'EnrolmentKeyPermissions';
  /** Whether you can destroy (deactivate) this enrolment key. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can restore (activate) this enrolment key. */
  restore: Scalars['Boolean'];
  /** Whether you can update this enrolment key. */
  update: Scalars['Boolean'];
};

/** A font. */
export type Font = {
  __typename?: 'Font';
  /** The CSS class of the font. */
  cssClass: Scalars['String'];
  /** The name of the font. */
  name: Scalars['String'];
  /** The sizes of the font. */
  sizes: Array<Scalars['Int']>;
  /** The URL of the font. */
  url: Scalars['String'];
};

/** Autogenerated input type of ForcePassILClassResult */
export type ForcePassIlClassResultInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the instructor-led class result to update. */
  ilClassResultId: Scalars['ID'];
};

/** Autogenerated return type of ForcePassILClassResult. */
export type ForcePassIlClassResultPayload = {
  __typename?: 'ForcePassILClassResultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The set of instructor-led class results that was updated. */
  ilClassResult?: Maybe<IlClassResult>;
};

/** Autogenerated input type of ForcePromoteILBooking */
export type ForcePromoteIlBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the instructor-led booking to force booking. */
  ilBookingId: Scalars['ID'];
};

/** Autogenerated return type of ForcePromoteILBooking. */
export type ForcePromoteIlBookingPayload = {
  __typename?: 'ForcePromoteILBookingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The updated instructor-led booking. */
  ilBooking?: Maybe<IlBooking>;
};

/** The gateway info necessary to finish the checkout */
export type GatewayInfo = {
  __typename?: 'GatewayInfo';
  /** Client secret to confirm a payment intent */
  clientSecret?: Maybe<Scalars['String']>;
  /** Status of the payment intent on Stripe */
  status?: Maybe<Scalars['String']>;
  /** Stripe charge Id */
  stripeChargeId?: Maybe<Scalars['String']>;
};

/** Attributes needed to send payment info to Stripe. */
export type GatewayInfoAttributes = {
  /** Whether is the intent payment */
  intent?: InputMaybe<Scalars['Boolean']>;
  /** Stripe token relate to the payment intent  */
  token?: InputMaybe<Scalars['String']>;
};

/** Settings for graded assignments */
export type GradedAssignmentAttributes = {
  /** The IDs of the graders who will be grading this assignment */
  graderIds: Array<Scalars['ID']>;
  /** The max points of the course item */
  maxPoints: Scalars['Float'];
  /** The name of the course item */
  name: Scalars['String'];
  /** The passing grade for this course item. */
  passingGrade: Scalars['Float'];
  /** The Attache details for connecting to the uploaded file. */
  uploadedFile: AttacheUploadFile;
};

/** Settings for a graded assignment. */
export type GradedAssignmentSettings = RelayNode & {
  __typename?: 'GradedAssignmentSettings';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The graders for this assignment. */
  graders: Array<Grader>;
  /** The integer ID. */
  id: Scalars['Int'];
  /** The maximum points a learner can earn on this assignment. */
  maxPoints: Scalars['Float'];
  /** The passing grade a learner requires. */
  passingGrade: Scalars['Float'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A learner's submitted assignment. */
export type GradedAssignmentSubmission = RelayNode & {
  __typename?: 'GradedAssignmentSubmission';
  /** The course item this submission came from. */
  courseItemProgression: CourseItemProgression;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The date and time the learner received a failing grade. */
  failedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The Attache details for connecting to the uploaded file. */
  file: AttacheFile;
  /** The global ID. */
  gid: Scalars['ID'];
  /** Whom is assigned to grade this assignment. */
  grader?: Maybe<Grader>;
  /** The integer ID. */
  id: Scalars['Int'];
  /** The date and time the learner achieved a passing grade. */
  passedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Number of points the grader has given. */
  points?: Maybe<Scalars['Float']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes of an assignment submission. */
export type GradedAssignmentSubmissionAttributes = {
  /** The Attache details for connecting to the uploaded file. */
  file: AttacheUploadFile;
};

/** The connection type for GradedAssignmentSubmission. */
export type GradedAssignmentSubmissionConnection = {
  __typename?: 'GradedAssignmentSubmissionConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GradedAssignmentSubmissionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GradedAssignmentSubmission>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GradedAssignmentSubmissionEdge = {
  __typename?: 'GradedAssignmentSubmissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GradedAssignmentSubmission>;
};

/** Assignment submissions you can grade. */
export type GradedAssignmentSubmissionsNamespace = {
  __typename?: 'GradedAssignmentSubmissionsNamespace';
  /** Assignment submissions you can grade. */
  all: GradedAssignmentSubmissionConnection;
  /** Find a single gradedassignmentsubmission by its string ID. */
  findByGid?: Maybe<GradedAssignmentSubmission>;
  /** Find a single gradedassignmentsubmission by its integer ID. */
  findById: GradedAssignmentSubmission;
  /** Find a single gradedassignmentsubmission by its signed ID. */
  findBySgid?: Maybe<GradedAssignmentSubmission>;
};


/** Assignment submissions you can grade. */
export type GradedAssignmentSubmissionsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  ungraded?: InputMaybe<Scalars['Boolean']>;
};


/** Assignment submissions you can grade. */
export type GradedAssignmentSubmissionsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Assignment submissions you can grade. */
export type GradedAssignmentSubmissionsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Assignment submissions you can grade. */
export type GradedAssignmentSubmissionsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** A grader who grades a graded assignment course item. */
export type Grader = RelayNode & {
  __typename?: 'Grader';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The email address used to invite the grader. */
  email?: Maybe<Scalars['String']>;
  /** The first name of the grader. */
  firstName: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The last name of the grader. */
  lastName: Scalars['String'];
  /** The organization that this grader is tied to. */
  organization: Organization;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The status of the grader record. */
  status: GraderStatusEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user that this grader is tied to. */
  user?: Maybe<User>;
};

/** The connection type for Grader. */
export type GraderConnection = {
  __typename?: 'GraderConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Grader>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GraderEdge = {
  __typename?: 'GraderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Grader>;
};

/** Valid types for grader status. */
export enum GraderStatusEnum {
  /** A grader who is accepted. */
  Accepted = 'accepted',
  /** A grader who is declined. */
  Declined = 'declined',
  /** A grader who is pending. */
  Pending = 'pending'
}

/** Find graders you have access to. */
export type GradersNamespace = {
  __typename?: 'GradersNamespace';
  /** Graders you have access to. */
  all: GraderConnection;
  /** Find a single grader by its string ID. */
  findByGid?: Maybe<Grader>;
  /** Find a single grader by its integer ID. */
  findById: Grader;
  /** Find a single grader by its signed ID. */
  findBySgid?: Maybe<Grader>;
};


/** Find graders you have access to. */
export type GradersNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Find graders you have access to. */
export type GradersNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find graders you have access to. */
export type GradersNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find graders you have access to. */
export type GradersNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** A Grant a user has to a License to take a Course. */
export type Grant = Archivable & LearnerVerifiable & RelayNode & SoftDestroyable & {
  __typename?: 'Grant';
  /** The archive state of the record. */
  archived: Scalars['Boolean'];
  /** The date this record was archived. */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** A preview of the badge */
  badgePreviewUrl?: Maybe<Scalars['String']>;
  /** Any permissions you have relevant to the grant. */
  can: GrantPermissions;
  /** The certification awarded by this grant. */
  certification?: Maybe<Certification>;
  /** Channel data for Ably subscriptions. */
  channelData?: Maybe<ChannelData>;
  /** The last activity of the consumer. */
  consumersLastActivity?: Maybe<Scalars['ISO8601DateTime']>;
  /** The course the grant is for. */
  course: Course;
  /** The progression for this grants course. */
  courseProgression?: Maybe<CourseProgression>;
  /** The course user agreements associated with the grant */
  courseUserAgreements?: Maybe<Array<CourseUserAgreement>>;
  /** When the grant was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** When this record was destroyed. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  /** The global ID of this record. */
  gid: Scalars['ID'];
  /** The type of the grantable. */
  grantableType: Scalars['String'];
  /** The ID of this record. */
  id: Scalars['Int'];
  lastName: Scalars['String'];
  /** LearnerVerified session data to enable verification. */
  learnerVerifiedSession?: Maybe<LearnerVerifiedSession>;
  /** The status of LV services for this item. */
  learnerVerifiedStatus: Scalars['String'];
  /** The license the grant is attached to. */
  license?: Maybe<License>;
  mobileNumber: Scalars['String'];
  /** The organization that this grant is tied to. */
  organization?: Maybe<Organization>;
  /** Presence data for Ably. */
  presence?: Maybe<PresenceData>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Whether the grant is not_started, in_progress, license_expired, grant_expired or completed, etc. */
  status: GrantStatusEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user that the grant belongs to. */
  user?: Maybe<User>;
};


/** A Grant a user has to a License to take a Course. */
export type GrantLearnerVerifiedSessionArgs = {
  url: Scalars['String'];
};

/** The connection type for Grant. */
export type GrantConnection = {
  __typename?: 'GrantConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GrantEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Grant>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Autogenerated input type of GrantCourseViaSubscription */
export type GrantCourseViaSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the course to start. */
  courseId: Scalars['ID'];
  /** Whether or not to start the course. */
  start?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the subscription granting access (should be an access subscription type). */
  subscriptionId: Scalars['ID'];
};

/** Autogenerated return type of GrantCourseViaSubscription. */
export type GrantCourseViaSubscriptionPayload = {
  __typename?: 'GrantCourseViaSubscriptionPayload';
  /** The updated Stripe Subscription that was just used. */
  accessSubscription: AccessSubscription;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Grant you're starting. */
  grant: Grant;
};

/** An edge in a connection. */
export type GrantEdge = {
  __typename?: 'GrantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Grant>;
};

/** Permissions on this grant. */
export type GrantPermissions = {
  __typename?: 'GrantPermissions';
  /** Whether you can archive this grant. */
  archive: Scalars['Boolean'];
  /** Whether you can revoke/cancel this grant. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can override the LearnerVerified™ status. */
  overrideLearnerVerifiedStatus: Scalars['Boolean'];
  /** Whether you can run this grant. */
  run: Scalars['Boolean'];
  /** Whether you can unarchive this grant. */
  unarchive: Scalars['Boolean'];
};

/** Valid statuses for a grant (a learner's course). */
export enum GrantStatusEnum {
  /** A grant that is completed. */
  Completed = 'completed',
  /** A grant that is delinquent in payment. */
  Delinquent = 'delinquent',
  /** A grant that is failed. */
  Failed = 'failed',
  /** A grant that is grant expired. */
  GrantExpired = 'grant_expired',
  /** A grant that is in progress. */
  InProgress = 'in_progress',
  /** A grant that is license expired. */
  LicenseExpired = 'license_expired',
  /** A grant that is not started. */
  NotStarted = 'not_started',
  /** A grant that is revoked. */
  Revoked = 'revoked'
}

/** Access your grants. */
export type GrantsNamespace = {
  __typename?: 'GrantsNamespace';
  /** Get all your grants. */
  all: Array<Grant>;
  /** The number of completed grants. */
  completedCount: Scalars['Int'];
  /** Find a single grant by its string ID. */
  findByGid?: Maybe<Grant>;
  /** Find a single grant by its integer ID. */
  findById: Grant;
  /** Find a single grant by its signed ID. */
  findBySgid?: Maybe<Grant>;
  /** The number of uncompleted grants. */
  incompleteCount: Scalars['Int'];
};


/** Access your grants. */
export type GrantsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Access your grants. */
export type GrantsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Access your grants. */
export type GrantsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** Autogenerated input type of HandleInvite */
export type HandleInviteInput = {
  /** Whether we are accepting or declining the invite. */
  accepted: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the invite we are handling. */
  id: Scalars['Int'];
};

/** Autogenerated return type of HandleInvite. */
export type HandleInvitePayload = {
  __typename?: 'HandleInvitePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The invite we have handled. */
  invite?: Maybe<Invite>;
};

/** An ApplicationRecord that has custom attributes. */
export type HasCustomAttributes = {
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Custom attributes for the record. */
  customAttributes: Array<CustomAttribute>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A booking for an instructor-led class. */
export type IlBooking = Commentable & RelayNode & {
  __typename?: 'ILBooking';
  /** Any permissions that may be relevant to this instructor-led booking. */
  can: IlBookingPermissions;
  /** The certification related to this booking, if applicable. */
  certification?: Maybe<Certification>;
  /** The comments on this record. */
  comments?: Maybe<CommentConnection>;
  /** The course item progression for this booking. */
  courseItemProgression: CourseItemProgression;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The instructor-led class for this booking. */
  ilClass: IlClass;
  /** The instructor-led class results for this booking. */
  ilClassResults: Array<IlClassResult>;
  /** The course item progressions that exist on the grant before this IL course. */
  previousCourseItemProgressions: Array<CourseItemProgression>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The status of the instructor-led booking. */
  status: IlBookingStatusEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user for this booking. */
  user: LightUser;
  /** The position where the il booking is on the waitlist */
  waitlistPosition?: Maybe<Scalars['Int']>;
};


/** A booking for an instructor-led class. */
export type IlBookingCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for ILBooking. */
export type IlBookingConnection = {
  __typename?: 'ILBookingConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IlBookingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IlBooking>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IlBookingEdge = {
  __typename?: 'ILBookingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IlBooking>;
};

/** Permissions this user has. */
export type IlBookingPermissions = {
  __typename?: 'ILBookingPermissions';
  /** Whether this user can cancel this booking. */
  cancel: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether this user can force promote this booking. */
  promoteBooking: Scalars['Boolean'];
};

/** Valid types for an instructor-led booking status. */
export enum IlBookingStatusEnum {
  /** An instructor-led booking that is booked. */
  Booked = 'booked',
  /** An instructor-led booking that is waitlist. */
  Waitlist = 'waitlist'
}

/** Access instructor-led bookings you can manage. */
export type IlBookingsNamespace = {
  __typename?: 'ILBookingsNamespace';
  /** Find a single ilbooking by its string ID. */
  findByGid?: Maybe<IlBooking>;
  /** Find a single ilbooking by its integer ID. */
  findById: IlBooking;
  /** Find a single ilbooking by its signed ID. */
  findBySgid?: Maybe<IlBooking>;
};


/** Access instructor-led bookings you can manage. */
export type IlBookingsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Access instructor-led bookings you can manage. */
export type IlBookingsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Access instructor-led bookings you can manage. */
export type IlBookingsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** An instructor-led class that a learner attends. */
export type IlClass = Discussable & RelayNode & {
  __typename?: 'ILClass';
  /** Who can see this class. */
  access: IlClassAccessEnum;
  /** The number of available seats left to book. */
  availableSeats: Scalars['Int'];
  /** The date when learners are no longer allow to book into the class, or change their booking. */
  bookingEndsAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date when learners can start booking into the class. */
  bookingStartsAt?: Maybe<Scalars['ISO8601DateTime']>;
  bookingWindow: BookingWindow;
  /** Any permissions that may be relevant to this instructor-led class. */
  can: IlClassPermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Discussion topics for this discussable. */
  discussionMessages?: Maybe<DiscussionMessageConnection>;
  /** The first instructor-led class of the recurrence (if recurring and not already the first). */
  firstRecurrence?: Maybe<IlClass>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** A collection of instructor-led bookings for this instructor-led class. */
  ilBookings?: Maybe<IlBookingConnection>;
  /** The instructor-led course for this instructor-led class. */
  ilCourse: IlCourse;
  /** The instructor-led course items relevant for this class. Will have all items at the time it was started, even if they were later deleted from the ILCourse itself. */
  ilCourseItems: Array<IlCourseItem>;
  /** A collection of instructor-led class sessions for this instructor-led class. */
  ilSessions: Array<IlSession>;
  /** A collection of instructors who will instruct this instructor-led class. */
  instructors: Array<Instructor>;
  /** Returns true if this is the first class of the recurrence. */
  isFirstRecurrence: Scalars['Boolean'];
  /** The max capacity of the instructor-led class. */
  maxCapacity: Scalars['Int'];
  /** The count of the bookings in a class */
  numberOfBookings: Scalars['Int'];
  /** The count of the waitlist in a class */
  numberOfWaitlist: Scalars['Int'];
  /** Any paths for this instructor-led class. */
  paths: IlClassPaths;
  /** The recurrence rule for this class (if any). */
  rrule?: Maybe<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  startsAt: Scalars['ISO8601DateTime'];
  /** The status of the instructor-led class. */
  status: IlClassStatusEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** A collection of instructor-led waitlist for this instructor-led class. */
  waitlist?: Maybe<IlBookingConnection>;
  /** The max capacity of the waitlist. */
  waitlistSize: Scalars['Int'];
};


/** An instructor-led class that a learner attends. */
export type IlClassDiscussionMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** An instructor-led class that a learner attends. */
export type IlClassIlBookingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** An instructor-led class that a learner attends. */
export type IlClassWaitlistArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Who can access an instructor-led class */
export enum IlClassAccessEnum {
  /** Only instructor-led admins may book sessions for learners */
  IlPrivate = 'il_private',
  /** Learners may book sessions themselves */
  IlPublic = 'il_public'
}

/** The connection type for ILClass. */
export type IlClassConnection = {
  __typename?: 'ILClassConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IlClassEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IlClass>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IlClassEdge = {
  __typename?: 'ILClassEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IlClass>;
};

/** Paths on this instructor-led class. */
export type IlClassPaths = {
  __typename?: 'ILClassPaths';
  /** The URL to export all wall certificates into a single PDF for easy printing */
  bulkWallCertificates?: Maybe<Scalars['String']>;
  /** The URL to export all wallet cards into a single PDF for easy printing */
  bulkWalletCards?: Maybe<Scalars['String']>;
  /** The URL for the exported spreadsheet of booked students in the instructor-led class */
  exportBookedStudents?: Maybe<Scalars['String']>;
  /** The URL for the exported spreadsheet of waitlisted students in the instructor-led class */
  exportWaitlistedStudents?: Maybe<Scalars['String']>;
  /** The ID of the record these paths are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these paths are for. */
  id: Scalars['Int'];
};

/** Permissions this user has. */
export type IlClassPermissions = {
  __typename?: 'ILClassPermissions';
  /** Whether this user can mark in ILClassResults for this instructor-led class. */
  adjustMarks: Scalars['Boolean'];
  /** Whether this user can book into this instructor-led class. */
  bookInto: Scalars['Boolean'];
  /** Whether this user can destroy this instructor-led class. */
  destroy: Scalars['Boolean'];
  /** Whether this user can book learners directly into the class without learner involvement. */
  distributeWithoutPurchase: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether this user can overwrite a finalized mark. */
  overrideFailedMark: Scalars['Boolean'];
  /** Whether the current user can view this instructor-led class. */
  show: Scalars['Boolean'];
  /** Whether this user can update this instructor-led class. */
  update: Scalars['Boolean'];
  /** Wheter this user can update the status of this instructor-led class. */
  updateStatus: Scalars['Boolean'];
  /** Whether this user can interact with certain features for this complete instructor-led class. */
  updateWithRestrictions: Scalars['Boolean'];
};

/** A result for an instructor-led class. */
export type IlClassResult = RelayNode & {
  __typename?: 'ILClassResult';
  /** Whether the instructor-led class was attended or not. */
  attendance?: Maybe<Scalars['Boolean']>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The grade for this instructor-led class result. */
  grade?: Maybe<Scalars['String']>;
  /** The integer ID. */
  id: Scalars['Int'];
  /** The instructor-led booking for this class result. */
  ilBooking: IlBooking;
  /** The instructor-led class for this class result. */
  ilClass: IlClass;
  /** The instructor-led course item for this class result. */
  ilCourseItem: IlCourseItem;
  /** Whether the learner has passed, or not, the instructor-led class. */
  passed?: Maybe<Scalars['Boolean']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Valid types for an instructor-led class status. */
export enum IlClassStatusEnum {
  /** An instructor-led class that is active. */
  Active = 'active',
  /** An instructor-led class that is cancelled. */
  Cancelled = 'cancelled',
  /** An instructor-led class that is draft. */
  Draft = 'draft',
  /** An instructor-led class that is finished. */
  Finished = 'finished',
  /** An instructor-led class that is running. */
  Running = 'running'
}

/** Find instructor-led classes you have access to. */
export type IlClassesNamespace = {
  __typename?: 'ILClassesNamespace';
  /** Find all your instructor-led classes. */
  all: IlClassConnection;
  /** All the instructor-led classes available to be booked into. */
  bookable: IlClassConnection;
  /** Find a single ilclass by its string ID. */
  findByGid?: Maybe<IlClass>;
  /** Find a single ilclass by its integer ID. */
  findById: IlClass;
  /** Find a single ilclass by its signed ID. */
  findBySgid?: Maybe<IlClass>;
};


/** Find instructor-led classes you have access to. */
export type IlClassesNamespaceAllArgs = {
  access?: InputMaybe<Array<IlClassAccessEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endsBefore?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  forTrainingManager?: InputMaybe<Scalars['Boolean']>;
  ilCourseIds?: InputMaybe<Array<Scalars['ID']>>;
  instructorIds?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  startsAfter?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Array<IlClassStatusEnum>>;
};


/** Find instructor-led classes you have access to. */
export type IlClassesNamespaceBookableArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ilCourseId: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  reservable?: InputMaybe<Scalars['Boolean']>;
};


/** Find instructor-led classes you have access to. */
export type IlClassesNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find instructor-led classes you have access to. */
export type IlClassesNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find instructor-led classes you have access to. */
export type IlClassesNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** An instructor-led course that a learner takes. */
export type IlCourse = Ownable & RelayNode & {
  __typename?: 'ILCourse';
  /** Any permissions you have relevant to the course. */
  can: IlCoursePermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The instructor-led course items on this instructor-led course. */
  ilCourseItems: Array<IlCourseItem>;
  /** The Attache details for connecting to the uploaded file. */
  instructorFiles?: Maybe<Array<AttacheFile>>;
  /** The Attache details for connecting to the uploaded file. */
  learnerFiles?: Maybe<Array<AttacheFile>>;
  /** The name of the instructor-led course. */
  name: Scalars['String'];
  /** The owner of the record. */
  owner: Owner;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ILCourse. */
export type IlCourseConnection = {
  __typename?: 'ILCourseConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IlCourseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IlCourse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IlCourseEdge = {
  __typename?: 'ILCourseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IlCourse>;
};

/** Instructor led course items that can run. */
export type IlCourseItem = RelayNode & {
  __typename?: 'ILCourseItem';
  /** Any permissions you have relevant to the IL Course Item. */
  can: IlCourseItemPermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of this instructor-led course item. */
  name: Scalars['String'];
  /** The position of this instructor-led course item. */
  position: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Whether this course item has attendance tracking enabled. */
  trackAttendance: Scalars['Boolean'];
  /** Whether this course item has grade tracking enabled. */
  trackGrade: Scalars['Boolean'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Permissions for a IL Course Item. */
export type IlCourseItemPermissions = {
  __typename?: 'ILCourseItemPermissions';
  /** Whether you can remove this instructor-led course item. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this instructor-led course item. */
  update: Scalars['Boolean'];
};

/** Permissions on this instructor-led course. */
export type IlCoursePermissions = {
  __typename?: 'ILCoursePermissions';
  /** Whether you can destroy this instructor-led course. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
};

/** Find instructor-led courses you can manage. */
export type IlCoursesNamespace = {
  __typename?: 'ILCoursesNamespace';
  /** Instructor-led courses you have direct access to. */
  all: IlCourseConnection;
  /** Find a single ilcourse by its string ID. */
  findByGid?: Maybe<IlCourse>;
  /** Find a single ilcourse by its integer ID. */
  findById: IlCourse;
  /** Find a single ilcourse by its signed ID. */
  findBySgid?: Maybe<IlCourse>;
};


/** Find instructor-led courses you can manage. */
export type IlCoursesNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Find instructor-led courses you can manage. */
export type IlCoursesNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find instructor-led courses you can manage. */
export type IlCoursesNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find instructor-led courses you can manage. */
export type IlCoursesNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** An location where instructor-led courses are taught. */
export type IlLocation = IlLocationInterface & RelayNode & {
  __typename?: 'ILLocation';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the location. */
  name: Scalars['String'];
  /** The owner of the record. */
  owner: Owner;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The type of the location. */
  type: IlLocationTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A location where instructor-led courses are taught. */
export type IlLocationInterface = {
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the location. */
  name: Scalars['String'];
  /** The owner of the record. */
  owner: Owner;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The type of the location. */
  type: IlLocationTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ILLocationInterface. */
export type IlLocationInterfaceConnection = {
  __typename?: 'ILLocationInterfaceConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IlLocationInterfaceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IlLocationInterface>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IlLocationInterfaceEdge = {
  __typename?: 'ILLocationInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IlLocationInterface>;
};

/** Valid types for instructor-led location type. */
export enum IlLocationTypeEnum {
  /** Instructor-led online location. */
  IlOnlineLocation = 'ILOnlineLocation',
  /** Instructor-led physical location. */
  IlPhysicalLocation = 'ILPhysicalLocation'
}

/** Find instructor-led locations you have access to. */
export type IlLocationsNamespace = {
  __typename?: 'ILLocationsNamespace';
  /** Instructor-led locations you have access to. */
  all: IlLocationInterfaceConnection;
  /** Find a single illocation by its string ID. */
  findByGid?: Maybe<IlLocation>;
  /** Find a single ILLocation by its integer ID. */
  findById: IlLocationInterface;
  /** Find a single illocation by its signed ID. */
  findBySgid?: Maybe<IlLocation>;
};


/** Find instructor-led locations you have access to. */
export type IlLocationsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Find instructor-led locations you have access to. */
export type IlLocationsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find instructor-led locations you have access to. */
export type IlLocationsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find instructor-led locations you have access to. */
export type IlLocationsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** An online location where instructor-led courses are taught. */
export type IlOnlineLocation = IlLocationInterface & RelayNode & {
  __typename?: 'ILOnlineLocation';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the location. */
  name: Scalars['String'];
  /** The owner of the record. */
  owner: Owner;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The type of the location. */
  type: IlLocationTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The URL of the online location. */
  url?: Maybe<Scalars['String']>;
};

/** A physical location where instructor-led courses are taught. */
export type IlPhysicalLocation = IlLocationInterface & RelayNode & {
  __typename?: 'ILPhysicalLocation';
  /** The address of the physical location. */
  address: Address;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the location. */
  name: Scalars['String'];
  /** The owner of the record. */
  owner: Owner;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The type of the location. */
  type: IlLocationTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** When a specific chunk of the course content will be covered. */
export type IlSession = RelayNode & {
  __typename?: 'ILSession';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The date when the session will end. */
  endsAt: Scalars['ISO8601DateTime'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The The location where the session will be taught. */
  ilLocation: IlLocationInterface;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The date when the session will start. */
  startsAt: Scalars['ISO8601DateTime'];
  /** The time zone of the session. */
  timeZone: Scalars['TimeZone'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of ImpersonateUser */
export type ImpersonateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the user to impersonate. */
  userId: Scalars['ID'];
};

/** Autogenerated return type of ImpersonateUser. */
export type ImpersonateUserPayload = {
  __typename?: 'ImpersonateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Are we impersonating the user now? */
  success: Scalars['Boolean'];
};

/** Autogenerated input type of InitializeRapidql */
export type InitializeRapidqlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of InitializeRapidql. */
export type InitializeRapidqlPayload = {
  __typename?: 'InitializeRapidqlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the initialization is queued. */
  ok: Scalars['Boolean'];
};

/** Autogenerated input type of InitiateOfflineOrder */
export type InitiateOfflineOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the user who we are creating an order for */
  userId: Scalars['ID'];
};

/** Autogenerated return type of InitiateOfflineOrder. */
export type InitiateOfflineOrderPayload = {
  __typename?: 'InitiateOfflineOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** A truthy value if things go as planned */
  success: Scalars['Boolean'];
};

/** A instructor who instructs an instructor-led course. */
export type Instructor = RelayNode & {
  __typename?: 'Instructor';
  /** Whether the instructor is allowed to access learner contact details. */
  accessLearnerContactDetails: Scalars['Boolean'];
  /** Any permissions you have relevant to the instructor. */
  can: InstructorPermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The credentials this instructor has. */
  credentials: InstructorCredentialConnection;
  /** Whether the instructor is allowed to distribute class access without learner purchase. */
  distributeWithoutPurchase: Scalars['Boolean'];
  /** The email address used to invite the instructor. */
  email?: Maybe<Scalars['String']>;
  /** The first name of the instructor. */
  firstName: Scalars['String'];
  /** The full name (first name + last name) of the instructor. */
  fullName: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The classes the instructor has. */
  ilClasses: IlClassConnection;
  /** The courses the instructor has permissions to make */
  instructorIlCoursePermissions: Array<InstructorIlCoursePermission>;
  /** The last name of the instructor. */
  lastName: Scalars['String'];
  /** The mobile number of the instructor. */
  mobileNumber?: Maybe<Scalars['String']>;
  /** The organization that this instructor is tied to. */
  organization: Organization;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The status of the instructor record. */
  status: InstructorStatusEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user that this instructor is tied to. */
  user?: Maybe<User>;
};


/** A instructor who instructs an instructor-led course. */
export type InstructorCredentialsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A instructor who instructs an instructor-led course. */
export type InstructorIlClassesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Instructor. */
export type InstructorConnection = {
  __typename?: 'InstructorConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InstructorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Instructor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** A credential for an instructor. */
export type InstructorCredential = RelayNode & {
  __typename?: 'InstructorCredential';
  /** Any permissions that may be relevant to this instructor credentials. */
  can: InstructorCredentialPermissions;
  /** The comment on the credential. */
  comment?: Maybe<Scalars['String']>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The date this credential will expire on. */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The Attache details for connecting to the credential file. */
  file: AttacheFile;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The date this credential was issued. */
  issuedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The name of the credential. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Settings for credential */
export type InstructorCredentialAttributes = {
  /** The comments on the credential. */
  comment?: InputMaybe<Scalars['String']>;
  /** The date this credential will expire on. */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The Attache details for connecting to the credential file. */
  file: AttacheUploadFile;
  /** The date this credential was issued. */
  issuedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The name of the credential. */
  name: Scalars['String'];
};

/** The connection type for InstructorCredential. */
export type InstructorCredentialConnection = {
  __typename?: 'InstructorCredentialConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InstructorCredentialEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InstructorCredential>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InstructorCredentialEdge = {
  __typename?: 'InstructorCredentialEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<InstructorCredential>;
};

/** Permissions the current user has. */
export type InstructorCredentialPermissions = {
  __typename?: 'InstructorCredentialPermissions';
  /** Whether the current user can destroy this credential. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
};

/** An edge in a connection. */
export type InstructorEdge = {
  __typename?: 'InstructorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Instructor>;
};

/** Permissions for instructors to manage their own classes. */
export type InstructorIlCoursePermission = RelayNode & {
  __typename?: 'InstructorILCoursePermission';
  /** Any permissions that may be relevant to the instructor ILCoursePermissions. */
  can: InstructorIlCoursePermissionPermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The courses the instructor has permissions to manage their classes for. */
  ilCourse: IlCourse;
  /** The instructor that can create classes with the associated ILCourse. */
  instructor: Instructor;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Permissions the current user has. */
export type InstructorIlCoursePermissionPermissions = {
  __typename?: 'InstructorILCoursePermissionPermissions';
  /** Whether the current user can destroy the instructors permission to manage classes of a specific course. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
};

/** Permissions on this instructor. */
export type InstructorPermissions = {
  __typename?: 'InstructorPermissions';
  /** Whether you can revoke this instructor. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can resend the invitation for this instructor. */
  resendInvitation: Scalars['Boolean'];
};

/** Valid types for instructor status. */
export enum InstructorStatusEnum {
  /** An instructor who is accepted. */
  Accepted = 'accepted',
  /** An instructor who is declined. */
  Declined = 'declined',
  /** An instructor who is pending. */
  Pending = 'pending'
}

/** Find instructors you have access to. */
export type InstructorsNamespace = {
  __typename?: 'InstructorsNamespace';
  /** Instructors you have access to. */
  all: InstructorConnection;
  /** Find a single instructor by its string ID. */
  findByGid?: Maybe<Instructor>;
  /** Find a single instructor by its integer ID. */
  findById: Instructor;
  /** Find a single instructor by its signed ID. */
  findBySgid?: Maybe<Instructor>;
};


/** Find instructors you have access to. */
export type InstructorsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Find instructors you have access to. */
export type InstructorsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find instructors you have access to. */
export type InstructorsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find instructors you have access to. */
export type InstructorsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** A integration for storefronts or organizations */
export type Integration = RelayNode & {
  __typename?: 'Integration';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The type of the integration. */
  integratableGid: Scalars['ID'];
  /** The options of the integration. */
  integrationOptions: Scalars['Hash'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The type of the integration. */
  type: IntegrationTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Valid types for integrations. */
export enum IntegrationTypeEnum {
  /** Avalara AvaTax */
  AvalaraIntegration = 'AvalaraIntegration',
  /** Regulator Submission Report */
  RegulatorSubmissionIntegration = 'RegulatorSubmissionIntegration',
  /** Reviews.io */
  ReviewsioIntegration = 'ReviewsioIntegration'
}

/** Integrations you can access. */
export type IntegrationsNamespace = {
  __typename?: 'IntegrationsNamespace';
  /** Find a single integration by type. */
  findByIntegratable?: Maybe<Array<Integration>>;
};


/** Integrations you can access. */
export type IntegrationsNamespaceFindByIntegratableArgs = {
  integratableGid: Scalars['ID'];
  type?: InputMaybe<IntegrationTypeEnum>;
};

/** An invite for this user. */
export type Invite = RelayNode & {
  __typename?: 'Invite';
  /** Any permissions you have relevant to the invite. */
  can: InvitePermissions;
  /** The last activity of the consumer. */
  consumersLastActivity?: Maybe<Scalars['ISO8601DateTime']>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  email: Scalars['String'];
  /** The friendly, shorter, status message relating to the email. */
  emailShortStatusMessage: Scalars['String'];
  /** The status of the email. */
  emailStatus: Scalars['String'];
  /** A friendly status message relating to the email. */
  emailStatusMessage: Scalars['String'];
  firstName: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** Whether this invite has been handled, accepted or declined. */
  handled: Scalars['Boolean'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The user who has sent the invite. */
  inviter: LightUser;
  lastName: Scalars['String'];
  /** The learner associated with the invite. */
  learner?: Maybe<Learner>;
  mobileNumber: Scalars['String'];
  /** The name of the course that this invite is for. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The status of this invite. */
  status: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Invite. */
export type InviteConnection = {
  __typename?: 'InviteConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InviteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Invite>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InviteEdge = {
  __typename?: 'InviteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Invite>;
};

/** Autogenerated input type of InviteOrganizationMember */
export type InviteOrganizationMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The email to send the invite to. */
  email: Scalars['String'];
  /** The ID of the Organization to invite the new member to. */
  organizationId: Scalars['ID'];
};

/** Autogenerated return type of InviteOrganizationMember. */
export type InviteOrganizationMemberPayload = {
  __typename?: 'InviteOrganizationMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the invite was sent. */
  ok: Scalars['Boolean'];
};

/** Permissions on this invite. */
export type InvitePermissions = {
  __typename?: 'InvitePermissions';
  /** Whether you can cancel this invite. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can resend this invite. */
  resend: Scalars['Boolean'];
};

/** Find invites you can manage. */
export type InvitesNamespace = {
  __typename?: 'InvitesNamespace';
  /** Total count of all pending invites. */
  pendingCount: Scalars['Int'];
};

/** Autogenerated input type of IssueVerifiedCredential */
export type IssueVerifiedCredentialInput = {
  /** The certification to issue a verified credential for. */
  certificationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether to reuse an existing connection to push the verified credential. */
  reuseConnection?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of IssueVerifiedCredential. */
export type IssueVerifiedCredentialPayload = {
  __typename?: 'IssueVerifiedCredentialPayload';
  /** A URL to allow deep-linkining into a wallet application. */
  appUrl?: Maybe<Scalars['String']>;
  /** Channel data for Ably subscriptions. */
  channelData: ChannelData;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The URL to render the QR code. */
  url?: Maybe<Scalars['String']>;
};

/** A row for the Sales Report Order Items report. */
export type LitSalesReportOrderItem = RelayNode & {
  __typename?: 'LITSalesReportOrderItem';
  /** The billing address. */
  billingAddress: Address;
  /** All custom fields for a user within the storefront of the sale. */
  consumerCustomValues: Array<CustomValue>;
  /** The email of the person who made the purchase. */
  consumerEmail?: Maybe<Scalars['String']>;
  /** The first name of the person who made the purchase. */
  consumerFirstName: Scalars['String'];
  /** The full name of the person who made the purchase. */
  consumerFullName: Scalars['String'];
  /** The last name of the person who made the purchase. */
  consumerLastName: Scalars['String'];
  /** The phone number of the person who made the purchase. */
  consumerPhoneNumber?: Maybe<Scalars['String']>;
  /** The course associated with this line item. */
  course?: Maybe<Course>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The currency the order is in. */
  currency: Currency;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The GST/HST for this line item. */
  gst: Scalars['Float'];
  /** The GST/HST for this line item. */
  gstFormatted: Scalars['String'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The description of the line item. */
  lineItem: Scalars['String'];
  /** The order ID related to this line item. */
  orderId: Scalars['Int'];
  /** The order item ID related to this line item. */
  orderItemId?: Maybe<Scalars['Int']>;
  /** The Stripe transaction ID for the order. */
  orderStripeChargeId?: Maybe<Scalars['String']>;
  /** The Organization that owns the Storefront this sale happened on. */
  organization: Owner;
  /** The other tax for this line item. */
  otherTax: Scalars['Float'];
  /** The other tax for this line item. */
  otherTaxFormatted: Scalars['String'];
  /** The price before the promo code was applied (if there is a promo code involved). */
  prePromoUnitPrice?: Maybe<Scalars['Float']>;
  /** The price before the promo code was applied (if there is a promo code involved). */
  prePromoUnitPriceFormatted?: Maybe<Scalars['String']>;
  /** The promo code used on this item. */
  promoCode?: Maybe<PromoCode>;
  /** The savings afforded by the promo code. */
  promoCodeSavings?: Maybe<Scalars['Float']>;
  /** The savings afforded by the promo code. */
  promoCodeSavingsFormatted?: Maybe<Scalars['String']>;
  /** The PST for this line item. */
  pst: Scalars['Float'];
  /** The PST for this line item. */
  pstFormatted: Scalars['String'];
  /** The quantity of this line item. */
  quantity: Scalars['Int'];
  /** The refund ID related to this line item. */
  refundId?: Maybe<Scalars['Int']>;
  /** The Stripe transaction ID for the refund. */
  refundStripeId?: Maybe<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The shipping address. */
  shippingAddress?: Maybe<Address>;
  /** The SKU of the line item. */
  sku: Scalars['String'];
  /** The storefront this line item was on. */
  storefrontName: Scalars['String'];
  /** The subtotal for this line item (pre-tax). */
  subtotal: Scalars['Float'];
  /** The subtotal for this line item (pre-tax). */
  subtotalFormatted: Scalars['String'];
  /** The total for this line item (incl tax). */
  total: Scalars['Float'];
  /** The total for this line item (incl tax). */
  totalFormatted: Scalars['String'];
  /** The per-item unit price of this line item. */
  unitPrice: Scalars['Float'];
  /** The per-item unit price of this line item. */
  unitPriceFormatted: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A row for the Sales Report Order Items report. */
export type LitSalesReportOrderItemGstFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A row for the Sales Report Order Items report. */
export type LitSalesReportOrderItemOtherTaxFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A row for the Sales Report Order Items report. */
export type LitSalesReportOrderItemPrePromoUnitPriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A row for the Sales Report Order Items report. */
export type LitSalesReportOrderItemPromoCodeSavingsFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A row for the Sales Report Order Items report. */
export type LitSalesReportOrderItemPstFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A row for the Sales Report Order Items report. */
export type LitSalesReportOrderItemSubtotalFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A row for the Sales Report Order Items report. */
export type LitSalesReportOrderItemTotalFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A row for the Sales Report Order Items report. */
export type LitSalesReportOrderItemUnitPriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for LITSalesReportOrderItem. */
export type LitSalesReportOrderItemConnection = {
  __typename?: 'LITSalesReportOrderItemConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LitSalesReportOrderItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LitSalesReportOrderItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LitSalesReportOrderItemEdge = {
  __typename?: 'LITSalesReportOrderItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LitSalesReportOrderItem>;
};

/** Launch information for a CourseItemProgression */
export type LaunchInformation = {
  __typename?: 'LaunchInformation';
  /** An error code that occurred trying to launch. */
  error?: Maybe<Scalars['String']>;
  /** The URL to launch. */
  url?: Maybe<Scalars['String']>;
};

/** A Learner is an abstract view to a person that can take your training. They may or may not be tied to a User in the system. */
export type Learner = {
  __typename?: 'Learner';
  /** Whether this learner is active or not. */
  active: Scalars['Boolean'];
  /** Permissions on this learner. */
  can: LearnerPermissions;
  /** All the learner's certifications. */
  certifications: Array<Certification>;
  /** When the learner was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The email of the learner. */
  email?: Maybe<Scalars['String']>;
  /** The first name of the learner. */
  firstName: Scalars['String'];
  /** The full name of the learner. */
  fullName: Scalars['String'];
  /** The global ID of this learner. */
  gid: Scalars['ID'];
  /** All the learner's grants. */
  grants: Array<Grant>;
  /** The ID of this learner. */
  id: Scalars['ID'];
  /** All the learner's invites. */
  invites: Array<Invite>;
  /** The last name of the learner. */
  lastName: Scalars['String'];
  /** The login token the user can use to get into the system and linked up to their training manager. */
  loginToken?: Maybe<Scalars['String']>;
  /** The mobile number of the learner. */
  mobileNumber?: Maybe<Scalars['String']>;
  /** The learner's desired method of notification. */
  notificationType: NotificationTypeEnum;
  /** The organizations this learner is a part of. */
  organizations: Array<Organization>;
  /** Training roles applied to the learner */
  trainingRoleApplications: Array<TrainingRoleApplication>;
};

/** Attributes needed to create a learner. */
export type LearnerAttributes = {
  /** Learner email. Either mobile number or this is required as a notification method. */
  email?: InputMaybe<Scalars['String']>;
  /** Learner first name. */
  firstName: Scalars['String'];
  /** Learner last name. */
  lastName: Scalars['String'];
  /** Learner mobile phone number. Either email or this is required as a notification method. */
  mobileNumber?: InputMaybe<Scalars['String']>;
};

/** The connection type for Learner. */
export type LearnerConnection = {
  __typename?: 'LearnerConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LearnerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Learner>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LearnerEdge = {
  __typename?: 'LearnerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Learner>;
};

/** Permissions on this learner. */
export type LearnerPermissions = {
  __typename?: 'LearnerPermissions';
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The ID of this learner. */
  id: Scalars['ID'];
  /** Whether you are able to send a request to login. */
  sendLearnerInviteNotification: Scalars['Boolean'];
  /** Whether you are able to send a password reset request. */
  sendResetPasswordInstructions: Scalars['Boolean'];
  /** Whether you can update this learner. */
  update: Scalars['Boolean'];
  /** Whether you can update the contact methods on this learner. */
  updateContactMethods: Scalars['Boolean'];
};

/** Something that has LearnerVerified services attached. */
export type LearnerVerifiable = {
  /** The status of LV services for this item. */
  learnerVerifiedStatus: Scalars['String'];
};

/** Access LearnerVerified related things. */
export type LearnerVerifiedNamespace = {
  __typename?: 'LearnerVerifiedNamespace';
  /** All Grants that have LearnerVerified on them and can be reviewed. */
  reviewableGrants: GrantConnection;
};


/** Access LearnerVerified related things. */
export type LearnerVerifiedNamespaceReviewableGrantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter: ReviewableGrantsFilterEnum;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Valid LearnerVerified™ statuses for override. */
export enum LearnerVerifiedOverrideStatus {
  /** Override the Grant as failed. */
  Failed = 'failed',
  /** Override the Grant as passed. */
  Passed = 'passed'
}

/** A LearnerVerified session */
export type LearnerVerifiedSession = RelayNode & {
  __typename?: 'LearnerVerifiedSession';
  /** URL for the client library. */
  client: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Whether or not to resume instead of starting. */
  resume: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When this session was started. */
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The status of LV services for this item. */
  status: Scalars['String'];
  /** Session token to connect to LearnerVerified. */
  token: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Access learners you can manage. */
export type LearnersNamespace = {
  __typename?: 'LearnersNamespace';
  /** Count of learners who are active. */
  activeCount: Scalars['Int'];
  /** Get all your learners. */
  all: LearnerConnection;
  /** Find a single learner. */
  find: Learner;
  /** Count of learners who are not linked to their Invitee record. */
  unregisteredCount: Scalars['Int'];
  /** Count of learners who have outstanding training. */
  withOutstandingTrainingCount: Scalars['Int'];
};


/** Access learners you can manage. */
export type LearnersNamespaceAllArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Access learners you can manage. */
export type LearnersNamespaceFindArgs = {
  id: Scalars['ID'];
};

/** A view uniting order items and refund items. */
export type LedgerOrderItemRecord = {
  __typename?: 'LedgerOrderItemRecord';
  /** Payout amount, author's part. */
  authorAmount?: Maybe<Scalars['Float']>;
  /** Payout amount, author's part. */
  authorAmountFormatted?: Maybe<Scalars['String']>;
  /** The id of the course, when it exists. */
  courseId?: Maybe<Scalars['Int']>;
  /** The course owner name, if product is a course. */
  courseOwnerName?: Maybe<Scalars['String']>;
  /** The course owner type, if product is a course. */
  courseOwnerType?: Maybe<Scalars['String']>;
  /** When the grant was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The order currency. */
  currency: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The generated unique ID composed by item_id:item_type. */
  id: Scalars['String'];
  /** The polymorphic instance id. */
  itemId: Scalars['Int'];
  /** The polymorphic instance type. */
  itemType: Scalars['String'];
  /** If the product has learner verified option enabled. */
  lvEnabled: Scalars['Boolean'];
  /** The id of the order. */
  orderId: Scalars['Int'];
  /** The id of the order item, when it exists. */
  orderItemId?: Maybe<Scalars['Int']>;
  /** The order total amount, except taxes. */
  orderSubtotal: Scalars['Float'];
  /** The order total amount, except taxes. */
  orderSubtotalFormatted: Scalars['String'];
  /** The order total of taxes. */
  orderTax: Scalars['Float'];
  /** The order total of taxes. */
  orderTaxFormatted: Scalars['String'];
  /** Payout amount, WKT's part. */
  platformAmount?: Maybe<Scalars['Float']>;
  /** Payout amount, WKT's part. */
  platformAmountFormatted?: Maybe<Scalars['String']>;
  /** The unit price of this item. */
  price: Scalars['Float'];
  /** The unit price of this item. */
  priceFormatted: Scalars['String'];
  /** The id of the product. */
  productId?: Maybe<Scalars['Int']>;
  /** The product name. */
  productName: Scalars['String'];
  /** The product S.K.U. */
  productSku?: Maybe<Scalars['String']>;
  /** The promo code applied, if any. */
  promoCodeCode?: Maybe<Scalars['String']>;
  /** The id of the promo code, when it exists. */
  promoCodeId?: Maybe<Scalars['Int']>;
  /** Amount saved with promo code usage. */
  promoCodeSavings: Scalars['Float'];
  /** Amount saved with promo code usage. */
  promoCodeSavingsFormatted: Scalars['String'];
  /** The quantity for this item. */
  quantity: Scalars['Int'];
  /** The id of the refund, when it exists. */
  refundId?: Maybe<Scalars['Int']>;
  /** The id of the refund item, when it exists. */
  refundItemId?: Maybe<Scalars['Int']>;
  /** If the product needs to be shipped. */
  requiresShipping: Scalars['Boolean'];
  /** Payout amount, seller's part. */
  sellerAmount?: Maybe<Scalars['Float']>;
  /** Payout amount, seller's part. */
  sellerAmountFormatted?: Maybe<Scalars['String']>;
  /** Whether the organization owns the Stripe account. */
  stripeSelfManaged: Scalars['Boolean'];
  /** The id of the user who is the owner the order. */
  userId: Scalars['Int'];
};


/** A view uniting order items and refund items. */
export type LedgerOrderItemRecordAuthorAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A view uniting order items and refund items. */
export type LedgerOrderItemRecordOrderSubtotalFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A view uniting order items and refund items. */
export type LedgerOrderItemRecordOrderTaxFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A view uniting order items and refund items. */
export type LedgerOrderItemRecordPlatformAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A view uniting order items and refund items. */
export type LedgerOrderItemRecordPriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A view uniting order items and refund items. */
export type LedgerOrderItemRecordPromoCodeSavingsFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A view uniting order items and refund items. */
export type LedgerOrderItemRecordSellerAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for LedgerOrderItemRecord. */
export type LedgerOrderItemRecordConnection = {
  __typename?: 'LedgerOrderItemRecordConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LedgerOrderItemRecordEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LedgerOrderItemRecord>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LedgerOrderItemRecordEdge = {
  __typename?: 'LedgerOrderItemRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LedgerOrderItemRecord>;
};

/** A view uniting refund_items and stripe_refunds. */
export type LedgerRefundRecord = {
  __typename?: 'LedgerRefundRecord';
  /** The unitary amount. */
  amount: Scalars['Float'];
  /** The unitary amount. */
  amountFormatted: Scalars['String'];
  /** Payout amount, author's part. */
  authorAmount: Scalars['Float'];
  /** Payout amount, author's part. */
  authorAmountFormatted: Scalars['String'];
  /** The id of the course, when there is a order_item tied to that. */
  courseId?: Maybe<Scalars['Int']>;
  /** When the grant was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The order currency. */
  currency: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The generated unique ID composed by item_id:item_type. */
  id: Scalars['String'];
  /** The polymorphic instance id. */
  itemId: Scalars['Int'];
  /** The polymorphic instance type. */
  itemType: Scalars['String'];
  /** If the product has learner verified option enabled. */
  lvEnabled: Scalars['Boolean'];
  /** The id of the order. */
  orderId: Scalars['Int'];
  /** Payout amount, WKT's part. */
  platformAmount: Scalars['Float'];
  /** Payout amount, WKT's part. */
  platformAmountFormatted: Scalars['String'];
  /** The id of the product, when there is a order_item tied to that. */
  productId?: Maybe<Scalars['Int']>;
  /** The product name, when there is a order_item tied to that. */
  productName?: Maybe<Scalars['String']>;
  /** The product S.K.U, when there is a order_item tied to that. */
  productSku?: Maybe<Scalars['String']>;
  /** The quantity of items originally purchased, when there is a order item tied to that. */
  purchasedQuantity?: Maybe<Scalars['Int']>;
  /** The quantity for this item. */
  quantity: Scalars['Int'];
  /** The reason for the refund. */
  reason: Scalars['String'];
  /** If the product needs to be shipped. */
  requiresShipping: Scalars['Boolean'];
  /** Payout amount, seller's part. */
  sellerAmount: Scalars['Float'];
  /** Payout amount, seller's part. */
  sellerAmountFormatted: Scalars['String'];
  /** The stripe identification for the refunded order. */
  stripeChargeId?: Maybe<Scalars['String']>;
  /** The stripe identification for this refund. */
  stripeRefundToken?: Maybe<Scalars['String']>;
  /** Taxes. */
  tax: Scalars['Float'];
  /** Taxes. */
  taxFormatted: Scalars['String'];
  /** Unitary amount times quantity. */
  totalRefundedAmount: Scalars['Int'];
};


/** A view uniting refund_items and stripe_refunds. */
export type LedgerRefundRecordAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A view uniting refund_items and stripe_refunds. */
export type LedgerRefundRecordAuthorAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A view uniting refund_items and stripe_refunds. */
export type LedgerRefundRecordPlatformAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A view uniting refund_items and stripe_refunds. */
export type LedgerRefundRecordSellerAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A view uniting refund_items and stripe_refunds. */
export type LedgerRefundRecordTaxFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for LedgerRefundRecord. */
export type LedgerRefundRecordConnection = {
  __typename?: 'LedgerRefundRecordConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LedgerRefundRecordEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LedgerRefundRecord>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LedgerRefundRecordEdge = {
  __typename?: 'LedgerRefundRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LedgerRefundRecord>;
};

/** A view uniting taxes and refund taxes. */
export type LedgerTaxRecord = {
  __typename?: 'LedgerTaxRecord';
  /** The tax amount. */
  amount: Scalars['Float'];
  /** The tax amount. */
  amountFormatted: Scalars['String'];
  /** When the grant was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The description of the tax. */
  description: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The generated unique ID composed by item_id:item_type. */
  id: Scalars['String'];
  /** The polymorphic instance id. */
  itemId: Scalars['Int'];
  /** The polymorphic instance type. */
  itemType: Scalars['String'];
  /** The kind of tax. */
  kind: Scalars['String'];
  /** The id of the order. */
  orderId: Scalars['Int'];
  /** The tax rate. */
  rate: Scalars['Float'];
  /** The id of the taxable item. */
  taxableId: Scalars['Int'];
  /** The type of the taxable item. */
  taxableType: Scalars['String'];
};


/** A view uniting taxes and refund taxes. */
export type LedgerTaxRecordAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for LedgerTaxRecord. */
export type LedgerTaxRecordConnection = {
  __typename?: 'LedgerTaxRecordConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LedgerTaxRecordEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LedgerTaxRecord>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LedgerTaxRecordEdge = {
  __typename?: 'LedgerTaxRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LedgerTaxRecord>;
};

/** A license to take a course */
export type License = CommonLicense & Ownable & RelayNode & {
  __typename?: 'License';
  /** The number of available seats the CommonLicense has, or null if an open CommonLicense. */
  availableSeats?: Maybe<Scalars['Int']>;
  /** Any permissions you have relevant to the CommonLicense. */
  can: LicensePermissions;
  /** The course this CommonLicense is for. */
  course: Course;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Any enrolment keys on this CommonLicense. */
  enrolmentKeys: EnrolmentKeyConnection;
  /** When this license expires. */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The number of granted seats the CommonLicense has. */
  grantedSeats: Scalars['Int'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The number of pending invitations to the CommonLicense. */
  invitedSeats: Scalars['Int'];
  /** Invites for this CommonLicense. */
  invites: InviteConnection;
  isOpen: Scalars['Boolean'];
  /** The order that resulted in this license. */
  order?: Maybe<Order>;
  /** The owner of the record. */
  owner: Owner;
  /** Any paths for this license. */
  paths: LicensePaths;
  /**
   * The photo for the license.
   * @deprecated Use course.photo instead.
   */
  photoUrl?: Maybe<Scalars['String']>;
  /** The number of seats the CommonLicense has, or null if it's an open CommonLicense. */
  seats?: Maybe<Scalars['Int']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The Stripe Subscription record, if it exists, that was used to obtain this license. */
  stripeSubscription?: Maybe<StripeSubscription>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The number of use seats the CommonLicense has. */
  usedSeats: Scalars['Int'];
  /** Any CommonLicense usage details. */
  uses: Array<LicenseUse>;
  /** Any LearnerVerified services enabled on the CommonLicense. */
  verificationServices: Scalars['String'];
};


/** A license to take a course */
export type LicenseEnrolmentKeysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** A license to take a course */
export type LicenseInvitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A license to take a course */
export type LicensePhotoUrlArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};

/** The connection type for License. */
export type LicenseConnection = {
  __typename?: 'LicenseConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LicenseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<License>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LicenseEdge = {
  __typename?: 'LicenseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<License>;
};

/** A LicenseGroup abstracting many Licenses. Licenses are grouped by owner, course, verification services, and whether it's open (unlimited seats) or limited. Each open license is it's own group, and limited licenses are grouped together. */
export type LicenseGroup = CommonLicense & Ownable & RelayNode & {
  __typename?: 'LicenseGroup';
  /** The number of available seats the CommonLicense has, or null if an open CommonLicense. */
  availableSeats?: Maybe<Scalars['Int']>;
  /** Any permissions you have relevant to the CommonLicense. */
  can: LicensePermissions;
  /** The course this CommonLicense is for. */
  course: Course;
  /** When the group was created (the created_at of the oldest license). */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Any enrolment keys on this CommonLicense. */
  enrolmentKeys: EnrolmentKeyConnection;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The number of granted seats the CommonLicense has. */
  grantedSeats: Scalars['Int'];
  /** The integer ID. */
  id: Scalars['String'];
  /** The number of pending invitations to the CommonLicense. */
  invitedSeats: Scalars['Int'];
  /** Invites for this CommonLicense. */
  invites: InviteConnection;
  isOpen: Scalars['Boolean'];
  /** All the individual licenses. */
  licenses: LicenseConnection;
  /** The owner of the record. */
  owner: Owner;
  /** The number of seats the CommonLicense has, or null if it's an open CommonLicense. */
  seats?: Maybe<Scalars['Int']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated (the most recent updated_at time). */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The number of use seats the CommonLicense has. */
  usedSeats: Scalars['Int'];
  /** Any CommonLicense usage details. */
  uses: Array<LicenseUse>;
  /** Any LearnerVerified services enabled on the CommonLicense. */
  verificationServices: Scalars['String'];
};


/** A LicenseGroup abstracting many Licenses. Licenses are grouped by owner, course, verification services, and whether it's open (unlimited seats) or limited. Each open license is it's own group, and limited licenses are grouped together. */
export type LicenseGroupEnrolmentKeysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** A LicenseGroup abstracting many Licenses. Licenses are grouped by owner, course, verification services, and whether it's open (unlimited seats) or limited. Each open license is it's own group, and limited licenses are grouped together. */
export type LicenseGroupInvitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A LicenseGroup abstracting many Licenses. Licenses are grouped by owner, course, verification services, and whether it's open (unlimited seats) or limited. Each open license is it's own group, and limited licenses are grouped together. */
export type LicenseGroupLicensesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for LicenseGroup. */
export type LicenseGroupConnection = {
  __typename?: 'LicenseGroupConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LicenseGroupEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LicenseGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LicenseGroupEdge = {
  __typename?: 'LicenseGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LicenseGroup>;
};

/** Find License Groups you can manage. */
export type LicenseGroupsNamespace = {
  __typename?: 'LicenseGroupsNamespace';
  /** All your License Groups. */
  all: LicenseGroupConnection;
  /** Find a single licensegroup by its string ID. */
  findByGid?: Maybe<LicenseGroup>;
  /** Find a single licensegroup by its integer ID. */
  findById: LicenseGroup;
  /** Find a single licensegroup by its signed ID. */
  findBySgid?: Maybe<LicenseGroup>;
  /** Find licenseGroups that are ordered by popular purchases and low seat count. */
  lowSeats?: Maybe<Array<LicenseGroup>>;
};


/** Find License Groups you can manage. */
export type LicenseGroupsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Find License Groups you can manage. */
export type LicenseGroupsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find License Groups you can manage. */
export type LicenseGroupsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find License Groups you can manage. */
export type LicenseGroupsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};


/** Find License Groups you can manage. */
export type LicenseGroupsNamespaceLowSeatsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** A pre-paid license pack for discounted reseller inventory. */
export type LicensePack = RelayNode & {
  __typename?: 'LicensePack';
  /** The numer of available seats on this license pack. */
  availableSeats: Scalars['Int'];
  /** The course this license pack is for. */
  course: Course;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The percentage of this license pack that is used. */
  percentageUsed: Scalars['Float'];
  /** The agreed upon per-seat price for this license pack. */
  price: Scalars['Float'];
  /** The agreed upon per-seat price for this license pack. */
  priceFormatted: Scalars['String'];
  /** The reseller agreement this pack is tied to. */
  resellerAgreement: ResellerAgreement;
  /** The number of seats this license pack has. */
  seats: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The numer of used seats on this license pack. */
  usedSeats: Scalars['Int'];
};


/** A pre-paid license pack for discounted reseller inventory. */
export type LicensePackPriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** An instance of usage tied to a license pack. */
export type LicensePackUse = RelayNode & {
  __typename?: 'LicensePackUse';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The license that triggered this use. */
  license: License;
  /** The license pack this use is tied to. */
  licensePack: LicensePack;
  /** The price level (regular or discounted) this use tracked. */
  priceLevel: Scalars['String'];
  /** The number of seats tracked by this use. */
  seats: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for LicensePackUse. */
export type LicensePackUseConnection = {
  __typename?: 'LicensePackUseConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LicensePackUseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LicensePackUse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LicensePackUseEdge = {
  __typename?: 'LicensePackUseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LicensePackUse>;
};

/** Paths on this license. */
export type LicensePaths = {
  __typename?: 'LicensePaths';
  /** The ID of the record these paths are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these paths are for. */
  id: Scalars['Int'];
  /** URL to the product page on the storefront this license was purchased from, if it was purchased. */
  storefrontPage?: Maybe<Scalars['String']>;
};

/** Permission on this CommonLicense. */
export type LicensePermissions = {
  __typename?: 'LicensePermissions';
  /** Whether you can assign training to a learner. */
  assignTraining: Scalars['Boolean'];
  /** Whether you can create an enrolment key on this CommonLicense. */
  createEnrolmentKey: Scalars['Boolean'];
  /** Whether you can revoke this CommonLicense. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['String'];
  /** Whether you can change the settings on this CommonLicense. */
  settings: Scalars['Boolean'];
  /** Whether you can share this CommonLicense. */
  share: Scalars['Boolean'];
  /** Whether you can take this course yoruself. */
  take: Scalars['Boolean'];
  /** Whether you can upgrade this CommonLicense with LearnerVerified. */
  upgrade: Scalars['Boolean'];
};

/** A union type representing different kinds of license usage. */
export type LicenseUse = Grant | Invite;

/** Find Licenses you can manage. */
export type LicensesNamespace = {
  __typename?: 'LicensesNamespace';
  /** All your Licenses. */
  all: LicenseConnection;
  /** Find a single license by its string ID. */
  findByGid?: Maybe<License>;
  /** Find a single license by its integer ID. */
  findById: License;
  /** Find a single license by its signed ID. */
  findBySgid?: Maybe<License>;
};


/** Find Licenses you can manage. */
export type LicensesNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Find Licenses you can manage. */
export type LicensesNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find Licenses you can manage. */
export type LicensesNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find Licenses you can manage. */
export type LicensesNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** A light version of a User, with minimal fields. */
export type LightUser = RelayNode & {
  __typename?: 'LightUser';
  /** The gravatar url for this user. */
  avatarUrl: Scalars['String'];
  /** The certification default of the User. */
  certificationDefault?: Maybe<CertificationDefault>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The email address of the User. */
  email?: Maybe<Scalars['String']>;
  /** The first name of the User. */
  firstName: Scalars['String'];
  /** The full name (first name + last name) of the User. */
  fullName: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The last name of the User. */
  lastName: Scalars['String'];
  /** The desired language for User. */
  locale: Scalars['String'];
  /** The mobile number of the User. */
  mobileNumber?: Maybe<Scalars['String']>;
  /** The full name of the User. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The time zone of the User. */
  timeZone: Scalars['TimeZone'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A light version of a User, with minimal fields. */
export type LightUserAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']>;
};

/** A location (country or province). */
export type Location = {
  __typename?: 'Location';
  /** The ISO code for the location. */
  code: Scalars['String'];
  /** The name of the location. */
  name: Scalars['String'];
};

/** Autogenerated input type of LoginInvite */
export type LoginInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Learner ID. */
  learnerId: Scalars['ID'];
  /** Learner email or mobile number. */
  login: Scalars['String'];
};

/** Autogenerated return type of LoginInvite. */
export type LoginInvitePayload = {
  __typename?: 'LoginInvitePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the login invite was handled. */
  ok: Scalars['Boolean'];
};

/** A multi-factor authentication method for a user. */
export type MfaMethod = RelayNode & {
  __typename?: 'MFAMethod';
  /** Any permissions you have relevant to the MFA Method. */
  can: MfaMethodPermissions;
  /** The contact method associated with this MFA method. */
  contactMethod: ContactMethod;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Whether this MFA method is enabled. */
  enabled: Scalars['Boolean'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The last time this MFA method was used. */
  lastUsedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The type of MFA method. */
  methodType: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user who owns this MFA method. */
  user: User;
  /** The time this MFA method was verified. */
  verifiedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Permissions for a MFA Method. */
export type MfaMethodPermissions = {
  __typename?: 'MFAMethodPermissions';
  /** Whether you can remove this MFA method. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can verify this MFA method. */
  verify: Scalars['Boolean'];
};

/** A multi-factor authentication trusted device for a user. */
export type MfaTrustedDevice = RelayNode & {
  __typename?: 'MFATrustedDevice';
  /** Any permissions you have relevant to the MFA Trusted Device. */
  can: MfaTrustedDevicePermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The description for this trusted device. */
  description: Scalars['String'];
  /** The time this trusted device expires. */
  expiresAt: Scalars['ISO8601DateTime'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The last time this trusted device was used. */
  lastUsedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Permissions for a MFA Trusted Device. */
export type MfaTrustedDevicePermissions = {
  __typename?: 'MFATrustedDevicePermissions';
  /** Whether you can remove this trusted device. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
};

/** Autogenerated input type of MakeTrainingManager */
export type MakeTrainingManagerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The name of the company the user is a training manager for. */
  companyName: Scalars['String'];
  /** The ID of the user being made a training manager. */
  userId: Scalars['ID'];
};

/** Autogenerated return type of MakeTrainingManager. */
export type MakeTrainingManagerPayload = {
  __typename?: 'MakeTrainingManagerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The user */
  user?: Maybe<User>;
};

/** Autogenerated input type of MarkCourseItemProgressionComplete */
export type MarkCourseItemProgressionCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of item to update. */
  itemId: Scalars['ID'];
  /** The note stating the reasoning behind the manual completion */
  note: Scalars['String'];
};

/** Autogenerated return type of MarkCourseItemProgressionComplete. */
export type MarkCourseItemProgressionCompletePayload = {
  __typename?: 'MarkCourseItemProgressionCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The CourseItemProgression to be marked completed. */
  item?: Maybe<CourseItemProgression>;
};

/** A storefront menu item */
export type MenuItem = RelayNode & {
  __typename?: 'MenuItem';
  /** Any permissions you have relevant to the menu item. */
  can: MenuItemPermissions;
  /** The children of this menu item. */
  children?: Maybe<Array<MenuItem>>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The feature image on the left of menu item. */
  featureImageLeft?: Maybe<AttacheFile>;
  /** The feature image on the right of menu item. */
  featureImageRight?: Maybe<AttacheFile>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The page this menu item links to. */
  page?: Maybe<Page>;
  /** The parent menu item. */
  parent?: Maybe<MenuItem>;
  /** The position of this menu item. */
  position: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The title of this menu item. */
  title?: Maybe<Scalars['String']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The URL this menu item links to. */
  url?: Maybe<Scalars['String']>;
};


/** A storefront menu item */
export type MenuItemFeatureImageLeftArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};


/** A storefront menu item */
export type MenuItemFeatureImageRightArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};

/** Whether you have permission to perform certain actions on this menu item. */
export type MenuItemPermissions = {
  __typename?: 'MenuItemPermissions';
  /** Whether you can destroy this menu item. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this menu item. */
  update: Scalars['Boolean'];
};

/** Autogenerated input type of MergeUsers */
export type MergeUsersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The source user IDs to merge into the target. */
  sourceIds: Array<Scalars['Int']>;
  /** The target user ID to merge all sources into. */
  targetId: Scalars['Int'];
};

/** Autogenerated return type of MergeUsers. */
export type MergeUsersPayload = {
  __typename?: 'MergeUsersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Are we back to normal? */
  success: Scalars['Boolean'];
  /** The target user. */
  user: User;
};

/** Attributes for a meta tag. */
export type MetaTagAttributes = {
  /** The content of the meta tag. */
  content: Scalars['String'];
  /** The name of the meta tag. */
  name: Scalars['String'];
};

/** Options for Meta Tags. */
export type MetaTags = {
  __typename?: 'MetaTags';
  /** Tag contents. */
  content: Scalars['String'];
  /** Tag name. */
  name: Scalars['String'];
};

/** Microsoft Entra credential configuration */
export type MicrosoftEntraCredentialConfiguration = RelayNode & {
  __typename?: 'MicrosoftEntraCredentialConfiguration';
  /** The background color for Microsoft Entra credentials */
  backgroundColor: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The manifest URL for Microsoft Entra credentials */
  manifestUrl: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The text color for Microsoft Entra credentials */
  textColor: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A calculable for a monthly active users rate contract. */
export type MonthlyActiveUsersRateContract = ContractCalculable & RelayNode & {
  __typename?: 'MonthlyActiveUsersRateContract';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Flat rate for active user tier. */
  flatRate: Scalars['Float'];
  /** Flat rate for active user tier. */
  flatRateFormatted: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Rate per active user. */
  rate: Scalars['Float'];
  /** Rate per active user. */
  rateFormatted: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Maximum tier. */
  tierMax?: Maybe<Scalars['Int']>;
  /** Minimum tier. */
  tierMin?: Maybe<Scalars['Int']>;
  /** Type of contract, snake_case. */
  type: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A calculable for a monthly active users rate contract. */
export type MonthlyActiveUsersRateContractFlatRateFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A calculable for a monthly active users rate contract. */
export type MonthlyActiveUsersRateContractRateFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** A calculable for a monthly course distribution rate contract. */
export type MonthlyCourseDistributionRateContract = ContractCalculable & RelayNode & {
  __typename?: 'MonthlyCourseDistributionRateContract';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Flat rate for active user tier. */
  flatRate: Scalars['Float'];
  /** Flat rate for active user tier. */
  flatRateFormatted: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Rate per active user. */
  rate: Scalars['Float'];
  /** Rate per active user. */
  rateFormatted: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Maximum tier. */
  tierMax?: Maybe<Scalars['Int']>;
  /** Minimum tier. */
  tierMin?: Maybe<Scalars['Int']>;
  /** Type of contract, snake_case. */
  type: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A calculable for a monthly course distribution rate contract. */
export type MonthlyCourseDistributionRateContractFlatRateFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A calculable for a monthly course distribution rate contract. */
export type MonthlyCourseDistributionRateContractRateFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Root mutation entrypoint. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Accept a terms of service for the current user. */
  acceptTermsOfService?: Maybe<AcceptTermsOfServicePayload>;
  /** Adds this course as a product on a storefront. */
  addCourseToStorefront?: Maybe<AddCourseToStorefrontPayload>;
  /** Add an exam to a course. */
  addExamToCourse?: Maybe<AddExamToCoursePayload>;
  /** Add a graded assignment to a course. */
  addGradedAssignmentToCourse?: Maybe<AddGradedAssignmentToCoursePayload>;
  /** Add an instructor-led course to a course. */
  addIlCourseToCourse?: Maybe<AddIlCourseToCoursePayload>;
  /** Add an item to a course. */
  addItemToCourse?: Maybe<AddItemToCoursePayload>;
  /** Add a link to a course. */
  addLinkToCourse?: Maybe<AddLinkToCoursePayload>;
  /** Add a product to your cart */
  addProductToCart?: Maybe<AddProductToCartPayload>;
  /** Agree to a course agreement. */
  agreeToCourseAgreement?: Maybe<AgreeToCourseAgreementPayload>;
  /** Apply training role to learner (creates a training role application record). */
  applyTrainingRole?: Maybe<ApplyTrainingRolePayload>;
  /** Assigns course(s) from training roles for learner(s). */
  assignMatrixTraining?: Maybe<AssignMatrixTrainingPayload>;
  /** Assign training to a learner. */
  assignTraining?: Maybe<AssignTrainingPayload>;
  /** Update products in Avalara based on what's on your storefronts, so you can configure appropriate tax codes for it in Avalara. */
  avalaraSyncProducts?: Maybe<AvalaraSyncProductsPayload>;
  /** Destroy a booking given a GID. */
  cancelIlBooking?: Maybe<CancelIlBookingPayload>;
  /** Remove a session variable for a new offline order. */
  cancelOfflineOrder?: Maybe<CancelOfflineOrderPayload>;
  /** Change your password for the platform while logged in. */
  changePassword?: Maybe<ChangePasswordPayload>;
  /** Claim a promo code for the shopping cart */
  claimPromoCode?: Maybe<ClaimPromoCodePayload>;
  /** Clear impersonation status. */
  clearImpersonation?: Maybe<ClearImpersonationPayload>;
  /** Create or update an integration. */
  configureIntegration?: Maybe<ConfigureIntegrationPayload>;
  /** Confirms a contact method for a user on the platform. */
  confirmContactMethod?: Maybe<ConfirmContactMethodPayload>;
  /** Create a constant used in automation workflows. */
  createAutomationConstant?: Maybe<CreateAutomationConstantPayload>;
  /** Create an automation script. */
  createAutomationScript?: Maybe<CreateAutomationScriptPayload>;
  /** Create a certification. */
  createCertification?: Maybe<CreateCertificationPayload>;
  /** Request a change of information for a certification. */
  createCertificationChangeRequest?: Maybe<CreateCertificationChangeRequestPayload>;
  /** Issue a certification to a learner from a certification template. */
  createCertificationFromTemplate?: Maybe<CreateCertificationFromTemplatePayload>;
  /** Create a certification template. */
  createCertificationTemplate?: Maybe<CreateCertificationTemplatePayload>;
  /** Create a comment on a commentable. */
  createComment?: Maybe<CreateCommentPayload>;
  /** Creates a Course. */
  createCourse?: Maybe<CreateCoursePayload>;
  /** Add a course agreement to a course. */
  createCourseAgreement?: Maybe<CreateCourseAgreementPayload>;
  /** Add a course prompt to the course. */
  createCoursePrompt?: Maybe<CreateCoursePromptPayload>;
  /** Add a course requirement to a course. */
  createCourseRequirement?: Maybe<CreateCourseRequirementPayload>;
  /** Add a resource link to a course's resources. */
  createCourseResourceLink?: Maybe<CreateCourseResourceLinkPayload>;
  /** Create a new custom attribute. */
  createCustomAttribute?: Maybe<CreateCustomAttributePayload>;
  /** Create a custom domain. */
  createCustomDomain?: Maybe<CreateCustomDomainPayload>;
  /** Create a custom field for a storefront. */
  createCustomField?: Maybe<CreateCustomFieldPayload>;
  /** Add a custom field requirement to a course. */
  createCustomFieldCourseRequirement?: Maybe<CreateCustomFieldCourseRequirementPayload>;
  /** Create a reply to a discussion topic. */
  createDiscussionReply?: Maybe<CreateDiscussionReplyPayload>;
  /** Create a new discussion topic. */
  createDiscussionTopic?: Maybe<CreateDiscussionTopicPayload>;
  /** Create a downloadable file for a storefront. */
  createDownloadableFile?: Maybe<CreateDownloadableFilePayload>;
  /** Create an enrolment key. */
  createEnrolmentKey?: Maybe<CreateEnrolmentKeyPayload>;
  /** Create a manifest for a certification template. */
  createEntraManifest?: Maybe<CreateEntraManifestPayload>;
  /** Create a grader within an associated organization. */
  createGrader?: Maybe<CreateGraderPayload>;
  /** Create an instructor-led booking. */
  createIlBooking?: Maybe<CreateIlBookingPayload>;
  /** Create an instructor-led booking for a user. */
  createIlBookingForUser?: Maybe<CreateIlBookingForUserPayload>;
  /** Create an instructor-led class. */
  createIlClass?: Maybe<CreateIlClassPayload>;
  /** Create an instructor-led course so that it can be attached to a regular course */
  createIlCourse?: Maybe<CreateIlCoursePayload>;
  /** Create an instructor-led course item */
  createIlCourseItem?: Maybe<CreateIlCourseItemPayload>;
  /** Create an instructor-led location. */
  createIlLocation?: Maybe<CreateIlLocationPayload>;
  /** Create an instructor-led session */
  createIlSession?: Maybe<CreateIlSessionPayload>;
  /** Create an instructor within an associated organization. */
  createInstructor?: Maybe<CreateInstructorPayload>;
  /** Create a credential on an instructor. */
  createInstructorCredential?: Maybe<CreateInstructorCredentialPayload>;
  /** Create a class as an instructor for a given ILCourse. */
  createInstructorIlCoursePermission?: Maybe<CreateInstructorIlCoursePermissionPayload>;
  /** Create a invitee to assign training to. */
  createInvitee?: Maybe<CreateInviteePayload>;
  /** Creates a license and optionally grants it. */
  createLicense?: Maybe<CreateLicensePayload>;
  /** Create a menu item for a storefront. */
  createMenuItem?: Maybe<CreateMenuItemPayload>;
  /** Creates a multi-factor authentication method for a user on the platform. */
  createMfaMethod?: Maybe<CreateMfaMethodPayload>;
  /** Create an item bank in the Nito exam engine. */
  createNitoBank?: Maybe<CreateNitoBankPayload>;
  /** Create an exam in the Nito exam engine. */
  createNitoExam?: Maybe<CreateNitoExamPayload>;
  /** Create a OIDC provider for an organization. */
  createOidcProvider?: Maybe<CreateOidcProviderPayload>;
  /** Create an order with the shopping cart and submit it to Stripe */
  createOrder?: Maybe<CreateOrderPayload>;
  /** Create an Organization. */
  createOrganization?: Maybe<CreateOrganizationPayload>;
  /** Create a page for a storefront. */
  createPage?: Maybe<CreatePagePayload>;
  /** Create or replace a pending IL booking reservation. */
  createPendingIlBookingReservation?: Maybe<CreatePendingIlBookingReservationPayload>;
  /** Create a prerequisite as a requirement for a course. */
  createPrerequisiteCourseRequirement?: Maybe<CreatePrerequisiteCourseRequirementPayload>;
  /** Create a product for a storefront. */
  createProduct?: Maybe<CreateProductPayload>;
  /** Create a promo code. */
  createPromoCode?: Maybe<CreatePromoCodePayload>;
  /** Schedule a RapidQL report to run regularly. */
  createRapidqlSchedule?: Maybe<CreateRapidqlSchedulePayload>;
  /** Create a redirect for a storefront. */
  createRedirect?: Maybe<CreateRedirectPayload>;
  /** Create a refund for an order */
  createRefund?: Maybe<CreateRefundPayload>;
  /** Create a regulator submission record. */
  createRegulatorSubmission?: Maybe<CreateRegulatorSubmissionPayload>;
  /** Create a SAML provider for an organization. */
  createSamlProvider?: Maybe<CreateSamlProviderPayload>;
  /** Save a RapidQL query to run later. */
  createSavedQuery?: Maybe<CreateSavedQueryPayload>;
  /** Create a product to share among storefronts. */
  createSharedProduct?: Maybe<CreateSharedProductPayload>;
  /** Create a survey result. */
  createSurveyResult?: Maybe<CreateSurveyResultPayload>;
  /** Create a new survey. */
  createSurveySchema?: Maybe<CreateSurveySchemaPayload>;
  /** Create a theme for a storefront. */
  createTheme?: Maybe<CreateThemePayload>;
  /** Create a training competency within an organization. */
  createTrainingCompetency?: Maybe<CreateTrainingCompetencyPayload>;
  /** Create a training role within an organization. */
  createTrainingRole?: Maybe<CreateTrainingRolePayload>;
  /** Creates a new user. Enabled on a storefront-by-storefront basis. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a new user memory record */
  createUserMemory?: Maybe<CreateUserMemoryPayload>;
  /** Marks a course as deprecated. */
  deprecateCourse?: Maybe<DeprecateCoursePayload>;
  /** Destroy a node. */
  destroyNode?: Maybe<DestroyNodePayload>;
  /** Deletes the currently logged in user. */
  destroyUser?: Maybe<DestroyUserPayload>;
  /** Get a URL to edit Nito-based item banks. */
  editNitoBanks?: Maybe<EditNitoBanksPayload>;
  /** Get a URL to edit Nito-based exams. */
  editNitoExams?: Maybe<EditNitoExamsPayload>;
  /** Deletes cart items for the authenticated user. */
  emptyUserCart?: Maybe<EmptyUserCartPayload>;
  /** Force pass a student il class result. */
  forcePassIlClassResult?: Maybe<ForcePassIlClassResultPayload>;
  /** Force an existing waitlisted instructor-led booking to a booked state. */
  forcePromoteIlBooking?: Maybe<ForcePromoteIlBookingPayload>;
  /** Start a course as a learner who has subscription access to the course. */
  grantCourseViaSubscription?: Maybe<GrantCourseViaSubscriptionPayload>;
  /** Handle an invite with accept or decline boolean. */
  handleInvite?: Maybe<HandleInvitePayload>;
  /** Impersonate a user. */
  impersonateUser?: Maybe<ImpersonateUserPayload>;
  /** Initialize RapidQL for the current user. Runs in the background. */
  initializeRapidql?: Maybe<InitializeRapidqlPayload>;
  /** Set up a session variable for a new offline order. */
  initiateOfflineOrder?: Maybe<InitiateOfflineOrderPayload>;
  /** Invite a member to your organization. */
  inviteOrganizationMember?: Maybe<InviteOrganizationMemberPayload>;
  /** Issue a verified credential from one of your certifications. */
  issueVerifiedCredential?: Maybe<IssueVerifiedCredentialPayload>;
  /** Invite a learner to login. */
  loginInvite?: Maybe<LoginInvitePayload>;
  /** Makes a user a training manager */
  makeTrainingManager?: Maybe<MakeTrainingManagerPayload>;
  /** Mark a particular course item complete. */
  markCourseItemProgressionComplete?: Maybe<MarkCourseItemProgressionCompletePayload>;
  /** Merge users into another user. */
  mergeUsers?: Maybe<MergeUsersPayload>;
  /** Override the LearnerVerified™ status on a Grant */
  overrideLearnerVerifiedStatus?: Maybe<OverrideLearnerVerifiedStatusPayload>;
  /** Post a certification to Credivera. */
  postCertificationToCredivera?: Maybe<PostCertificationToCrediveraPayload>;
  /** Refresh the RapidQL tables for the current user. Runs in the background with a delayed start. This allows you to run both the initializeRapidql and refreshRapidql mutations in the same request. */
  refreshRapidql?: Maybe<RefreshRapidqlPayload>;
  /** Removes this course as a product from a storefront. */
  removeCourseFromStorefront?: Maybe<RemoveCourseFromStorefrontPayload>;
  /** Removes a custom field as course requirement for the current storefront. */
  removeCustomFieldCourseRequirement?: Maybe<RemoveCustomFieldCourseRequirementPayload>;
  /** Reorder instructor-led course items */
  reorderIlCourseItems?: Maybe<ReorderIlCourseItemsPayload>;
  /** Request a password reset for a user on the platform. */
  requestPasswordReset?: Maybe<RequestPasswordResetPayload>;
  /** Request a presentation of a verified credential to verify the user. */
  requestVerifiedCredentialPresentation?: Maybe<RequestVerifiedCredentialPresentationPayload>;
  /** Resends a code to the contact method provided. */
  resendConfirmationCode?: Maybe<ResendConfirmationCodePayload>;
  /** Resend invitation to an instructor. */
  resendInstructorInvitation?: Maybe<ResendInstructorInvitationPayload>;
  /** Resend an invite. */
  resendInvite?: Maybe<ResendInvitePayload>;
  /** Restore a soft-destroyed node. */
  restoreNode?: Maybe<RestoreNodePayload>;
  /** Review a particular course item on the platform. */
  reviewCourseItemProgression?: Maybe<ReviewCourseItemProgressionPayload>;
  /** Get a URL to review LearnerVerified sessions for a verifiable. */
  reviewLearnerVerifiedSessions?: Maybe<ReviewLearnerVerifiedSessionsPayload>;
  /** Run a particular course item on the platform. */
  runCourseItemProgression?: Maybe<RunCourseItemProgressionPayload>;
  /** Send a report without scheduling it */
  sendReportNow?: Maybe<SendReportNowPayload>;
  /** Share learners to multiple organizations. */
  shareLearners?: Maybe<ShareLearnersPayload>;
  /** Share a license to a new owner. */
  shareLicense?: Maybe<ShareLicensePayload>;
  /** Authenticate a user and retrieve a JWT to use the API. */
  signIn?: Maybe<SignInPayload>;
  /** Sign out the current user. */
  signOut?: Maybe<SignOutPayload>;
  /** Sign up a user on the platform. */
  signUp?: Maybe<SignUpPayload>;
  /** Start a course so our progression items are available. */
  startCourse?: Maybe<StartCoursePayload>;
  /** Destroys all products for this course and it's product default. */
  stopSellingCourse?: Maybe<StopSellingCoursePayload>;
  /** As a learner, submit an assignment for grading. */
  submitGradedAssignment?: Maybe<SubmitGradedAssignmentPayload>;
  /** Grant license to the current user and start the course. */
  takeCourse?: Maybe<TakeCoursePayload>;
  /** Tear down the RapidQL tables for the current user. Runs in the background. */
  tearDownRapidql?: Maybe<TearDownRapidqlPayload>;
  /** Update archived state of many nodes. */
  updateArchivedNodes?: Maybe<UpdateArchivedNodesPayload>;
  /** Update a constant used in automation workflows. */
  updateAutomationConstant?: Maybe<UpdateAutomationConstantPayload>;
  /** Update an automation script. */
  updateAutomationScript?: Maybe<UpdateAutomationScriptPayload>;
  /** Update an item in your cart */
  updateCartItem?: Maybe<UpdateCartItemPayload>;
  /**
   * Update a certification.
   * @deprecated Delete and re-upload your certification or request a change of information.
   */
  updateCertification?: Maybe<UpdateCertificationPayload>;
  /** Approve or decline a change of information for a certification. */
  updateCertificationChangeRequest?: Maybe<UpdateCertificationChangeRequestPayload>;
  /** Update a certification default. */
  updateCertificationDefault?: Maybe<UpdateCertificationDefaultPayload>;
  /** Update a certification template. */
  updateCertificationTemplate?: Maybe<UpdateCertificationTemplatePayload>;
  /** Update a course. */
  updateCourse?: Maybe<UpdateCoursePayload>;
  /** Update a course items position and/or name. */
  updateCourseItem?: Maybe<UpdateCourseItemPayload>;
  /** Update a particular course items progress. */
  updateCourseItemProgressionProgress?: Maybe<UpdateCourseItemProgressionProgressPayload>;
  /** Update a course prompt to the course. */
  updateCoursePrompt?: Maybe<UpdateCoursePromptPayload>;
  /** Update a custom attribute. */
  updateCustomAttribute?: Maybe<UpdateCustomAttributePayload>;
  /** Update a custom domain. */
  updateCustomDomain?: Maybe<UpdateCustomDomainPayload>;
  /** Update a custom field for a storefront. */
  updateCustomField?: Maybe<UpdateCustomFieldPayload>;
  /** Update a downloadable file for a storefront. */
  updateDownloadableFile?: Maybe<UpdateDownloadableFilePayload>;
  /** Update an enrolment key. */
  updateEnrolmentKey?: Maybe<UpdateEnrolmentKeyPayload>;
  /** As a grader, mark a submission with a score. */
  updateGradedAssignmentSubmission?: Maybe<UpdateGradedAssignmentSubmissionPayload>;
  /** Update a particular instructor-led class. */
  updateIlClass?: Maybe<UpdateIlClassPayload>;
  /** Update a set of instructor-led class results. */
  updateIlClassResults?: Maybe<UpdateIlClassResultsPayload>;
  /** Update an instructor-led course */
  updateIlCourse?: Maybe<UpdateIlCoursePayload>;
  /** Update a ILCourseItem record */
  updateIlCourseItem?: Maybe<UpdateIlCourseItemPayload>;
  /** Update an instructor-led location. */
  updateIlLocation?: Maybe<UpdateIlLocationPayload>;
  /** Update an instructor. */
  updateInstructor?: Maybe<UpdateInstructorPayload>;
  /** Update a learner. */
  updateLearner?: Maybe<UpdateLearnerPayload>;
  /** Update a LearnerVerifiedSession. */
  updateLearnerVerifiedSession?: Maybe<UpdateLearnerVerifiedSessionPayload>;
  /** Toggle a set of learners active state. */
  updateLearnersActive?: Maybe<UpdateLearnersActivePayload>;
  /** Update a license. */
  updateLicense?: Maybe<UpdateLicensePayload>;
  /** Update a menu item for a storefront. */
  updateMenuItem?: Maybe<UpdateMenuItemPayload>;
  /** Update a OIDC provider for an organization. */
  updateOidcProvider?: Maybe<UpdateOidcProviderPayload>;
  /** Update an Organization. */
  updateOrganization?: Maybe<UpdateOrganizationPayload>;
  /** Update a page for a storefront. */
  updatePage?: Maybe<UpdatePagePayload>;
  /** Update a user's password for the platform using a reset token generated by Devise. */
  updatePassword?: Maybe<UpdatePasswordPayload>;
  /** Update a prerequisite as a requirement for a course. */
  updatePrerequisiteCourseRequirement?: Maybe<UpdatePrerequisiteCourseRequirementPayload>;
  /** Update a product for a storefront. */
  updateProduct?: Maybe<UpdateProductPayload>;
  /** Update a promo code. */
  updatePromoCode?: Maybe<UpdatePromoCodePayload>;
  /** Update a RapidQL report schedule. */
  updateRapidqlSchedule?: Maybe<UpdateRapidqlSchedulePayload>;
  /** Update a redirect for a storefront. */
  updateRedirect?: Maybe<UpdateRedirectPayload>;
  /** Update a regulator submission record. */
  updateRegulatorSubmission?: Maybe<UpdateRegulatorSubmissionPayload>;
  /** Update a SAML provider for an organization. */
  updateSamlProvider?: Maybe<UpdateSamlProviderPayload>;
  /** Upate a saved RapidQL query. */
  updateSavedQuery?: Maybe<UpdateSavedQueryPayload>;
  /** Update a product shared among storefronts. */
  updateSharedProduct?: Maybe<UpdateSharedProductPayload>;
  /** Update address for shopping cart */
  updateShoppingCartAddress?: Maybe<UpdateShoppingCartAddressPayload>;
  /** Update shipping information */
  updateShoppingCartShippingInformation?: Maybe<UpdateShoppingCartShippingInformationPayload>;
  /** Update settings for a storefront. */
  updateStorefront?: Maybe<UpdateStorefrontPayload>;
  /** Update a Stripe Subscription. */
  updateStripeSubscription?: Maybe<UpdateStripeSubscriptionPayload>;
  /** Update an existing survey. */
  updateSurveySchema?: Maybe<UpdateSurveySchemaPayload>;
  /** Update a theme for a storefront. */
  updateTheme?: Maybe<UpdateThemePayload>;
  /** Update a training competency within an organization. */
  updateTrainingCompetency?: Maybe<UpdateTrainingCompetencyPayload>;
  /** Update a training role within an organization. */
  updateTrainingRole?: Maybe<UpdateTrainingRolePayload>;
  /** Update your settings on the platform. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Update a verified credential issuer. */
  updateVerifiedCredentialIssuer?: Maybe<UpdateVerifiedCredentialIssuerPayload>;
  /** Upload a certification. */
  uploadCertification?: Maybe<UploadCertificationPayload>;
  /** Upload a student roster for an instructor-led class. An instructor needs the distribute without purchase permission granted by the instructor-led manager to do this. */
  uploadIlClassRosterLearner?: Maybe<UploadIlClassRosterLearnerPayload>;
  /** Use an activation code to tie the learner to a training manager. */
  useActivationCode?: Maybe<UseActivationCodePayload>;
  /** Claim a token for a course. */
  useEnrolmentKey?: Maybe<UseEnrolmentKeyPayload>;
  /** View a course agreement. */
  viewCourseAgreement?: Maybe<ViewCourseAgreementPayload>;
};


/** Root mutation entrypoint. */
export type MutationAcceptTermsOfServiceArgs = {
  input: AcceptTermsOfServiceInput;
};


/** Root mutation entrypoint. */
export type MutationAddCourseToStorefrontArgs = {
  input: AddCourseToStorefrontInput;
};


/** Root mutation entrypoint. */
export type MutationAddExamToCourseArgs = {
  input: AddExamToCourseInput;
};


/** Root mutation entrypoint. */
export type MutationAddGradedAssignmentToCourseArgs = {
  input: AddGradedAssignmentToCourseInput;
};


/** Root mutation entrypoint. */
export type MutationAddIlCourseToCourseArgs = {
  input: AddIlCourseToCourseInput;
};


/** Root mutation entrypoint. */
export type MutationAddItemToCourseArgs = {
  input: AddItemToCourseInput;
};


/** Root mutation entrypoint. */
export type MutationAddLinkToCourseArgs = {
  input: AddLinkToCourseInput;
};


/** Root mutation entrypoint. */
export type MutationAddProductToCartArgs = {
  input: AddProductToCartInput;
};


/** Root mutation entrypoint. */
export type MutationAgreeToCourseAgreementArgs = {
  input: AgreeToCourseAgreementInput;
};


/** Root mutation entrypoint. */
export type MutationApplyTrainingRoleArgs = {
  input: ApplyTrainingRoleInput;
};


/** Root mutation entrypoint. */
export type MutationAssignMatrixTrainingArgs = {
  input: AssignMatrixTrainingInput;
};


/** Root mutation entrypoint. */
export type MutationAssignTrainingArgs = {
  input: AssignTrainingInput;
};


/** Root mutation entrypoint. */
export type MutationAvalaraSyncProductsArgs = {
  input: AvalaraSyncProductsInput;
};


/** Root mutation entrypoint. */
export type MutationCancelIlBookingArgs = {
  input: CancelIlBookingInput;
};


/** Root mutation entrypoint. */
export type MutationCancelOfflineOrderArgs = {
  input: CancelOfflineOrderInput;
};


/** Root mutation entrypoint. */
export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


/** Root mutation entrypoint. */
export type MutationClaimPromoCodeArgs = {
  input: ClaimPromoCodeInput;
};


/** Root mutation entrypoint. */
export type MutationClearImpersonationArgs = {
  input: ClearImpersonationInput;
};


/** Root mutation entrypoint. */
export type MutationConfigureIntegrationArgs = {
  input: ConfigureIntegrationInput;
};


/** Root mutation entrypoint. */
export type MutationConfirmContactMethodArgs = {
  input: ConfirmContactMethodInput;
};


/** Root mutation entrypoint. */
export type MutationCreateAutomationConstantArgs = {
  input: CreateAutomationConstantInput;
};


/** Root mutation entrypoint. */
export type MutationCreateAutomationScriptArgs = {
  input: CreateAutomationScriptInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCertificationArgs = {
  input: CreateCertificationInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCertificationChangeRequestArgs = {
  input: CreateCertificationChangeRequestInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCertificationFromTemplateArgs = {
  input: CreateCertificationFromTemplateInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCertificationTemplateArgs = {
  input: CreateCertificationTemplateInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCourseArgs = {
  input: CreateCourseInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCourseAgreementArgs = {
  input: CreateCourseAgreementInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCoursePromptArgs = {
  input: CreateCoursePromptInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCourseRequirementArgs = {
  input: CreateCourseRequirementInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCourseResourceLinkArgs = {
  input: CreateCourseResourceLinkInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCustomAttributeArgs = {
  input: CreateCustomAttributeInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCustomDomainArgs = {
  input: CreateCustomDomainInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCustomFieldArgs = {
  input: CreateCustomFieldInput;
};


/** Root mutation entrypoint. */
export type MutationCreateCustomFieldCourseRequirementArgs = {
  input: CreateCustomFieldCourseRequirementInput;
};


/** Root mutation entrypoint. */
export type MutationCreateDiscussionReplyArgs = {
  input: CreateDiscussionReplyInput;
};


/** Root mutation entrypoint. */
export type MutationCreateDiscussionTopicArgs = {
  input: CreateDiscussionTopicInput;
};


/** Root mutation entrypoint. */
export type MutationCreateDownloadableFileArgs = {
  input: CreateDownloadableFileInput;
};


/** Root mutation entrypoint. */
export type MutationCreateEnrolmentKeyArgs = {
  input: CreateEnrolmentKeyInput;
};


/** Root mutation entrypoint. */
export type MutationCreateEntraManifestArgs = {
  input: CreateEntraManifestInput;
};


/** Root mutation entrypoint. */
export type MutationCreateGraderArgs = {
  input: CreateGraderInput;
};


/** Root mutation entrypoint. */
export type MutationCreateIlBookingArgs = {
  input: CreateIlBookingInput;
};


/** Root mutation entrypoint. */
export type MutationCreateIlBookingForUserArgs = {
  input: CreateIlBookingForUserInput;
};


/** Root mutation entrypoint. */
export type MutationCreateIlClassArgs = {
  input: CreateIlClassInput;
};


/** Root mutation entrypoint. */
export type MutationCreateIlCourseArgs = {
  input: CreateIlCourseInput;
};


/** Root mutation entrypoint. */
export type MutationCreateIlCourseItemArgs = {
  input: CreateIlCourseItemInput;
};


/** Root mutation entrypoint. */
export type MutationCreateIlLocationArgs = {
  input: CreateIlLocationInput;
};


/** Root mutation entrypoint. */
export type MutationCreateIlSessionArgs = {
  input: CreateIlSessionInput;
};


/** Root mutation entrypoint. */
export type MutationCreateInstructorArgs = {
  input: CreateInstructorInput;
};


/** Root mutation entrypoint. */
export type MutationCreateInstructorCredentialArgs = {
  input: CreateInstructorCredentialInput;
};


/** Root mutation entrypoint. */
export type MutationCreateInstructorIlCoursePermissionArgs = {
  input: CreateInstructorIlCoursePermissionInput;
};


/** Root mutation entrypoint. */
export type MutationCreateInviteeArgs = {
  input: CreateInviteeInput;
};


/** Root mutation entrypoint. */
export type MutationCreateLicenseArgs = {
  input: CreateLicenseInput;
};


/** Root mutation entrypoint. */
export type MutationCreateMenuItemArgs = {
  input: CreateMenuItemInput;
};


/** Root mutation entrypoint. */
export type MutationCreateMfaMethodArgs = {
  input: CreateMfaMethodInput;
};


/** Root mutation entrypoint. */
export type MutationCreateNitoBankArgs = {
  input: CreateNitoBankInput;
};


/** Root mutation entrypoint. */
export type MutationCreateNitoExamArgs = {
  input: CreateNitoExamInput;
};


/** Root mutation entrypoint. */
export type MutationCreateOidcProviderArgs = {
  input: CreateOidcProviderInput;
};


/** Root mutation entrypoint. */
export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


/** Root mutation entrypoint. */
export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


/** Root mutation entrypoint. */
export type MutationCreatePageArgs = {
  input: CreatePageInput;
};


/** Root mutation entrypoint. */
export type MutationCreatePendingIlBookingReservationArgs = {
  input: CreatePendingIlBookingReservationInput;
};


/** Root mutation entrypoint. */
export type MutationCreatePrerequisiteCourseRequirementArgs = {
  input: CreatePrerequisiteCourseRequirementInput;
};


/** Root mutation entrypoint. */
export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


/** Root mutation entrypoint. */
export type MutationCreatePromoCodeArgs = {
  input: CreatePromoCodeInput;
};


/** Root mutation entrypoint. */
export type MutationCreateRapidqlScheduleArgs = {
  input: CreateRapidqlScheduleInput;
};


/** Root mutation entrypoint. */
export type MutationCreateRedirectArgs = {
  input: CreateRedirectInput;
};


/** Root mutation entrypoint. */
export type MutationCreateRefundArgs = {
  input: CreateRefundInput;
};


/** Root mutation entrypoint. */
export type MutationCreateRegulatorSubmissionArgs = {
  input: CreateRegulatorSubmissionInput;
};


/** Root mutation entrypoint. */
export type MutationCreateSamlProviderArgs = {
  input: CreateSamlProviderInput;
};


/** Root mutation entrypoint. */
export type MutationCreateSavedQueryArgs = {
  input: CreateSavedQueryInput;
};


/** Root mutation entrypoint. */
export type MutationCreateSharedProductArgs = {
  input: CreateSharedProductInput;
};


/** Root mutation entrypoint. */
export type MutationCreateSurveyResultArgs = {
  input: CreateSurveyResultInput;
};


/** Root mutation entrypoint. */
export type MutationCreateSurveySchemaArgs = {
  input: CreateSurveySchemaInput;
};


/** Root mutation entrypoint. */
export type MutationCreateThemeArgs = {
  input: CreateThemeInput;
};


/** Root mutation entrypoint. */
export type MutationCreateTrainingCompetencyArgs = {
  input: CreateTrainingCompetencyInput;
};


/** Root mutation entrypoint. */
export type MutationCreateTrainingRoleArgs = {
  input: CreateTrainingRoleInput;
};


/** Root mutation entrypoint. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** Root mutation entrypoint. */
export type MutationCreateUserMemoryArgs = {
  input: CreateUserMemoryInput;
};


/** Root mutation entrypoint. */
export type MutationDeprecateCourseArgs = {
  input: DeprecateCourseInput;
};


/** Root mutation entrypoint. */
export type MutationDestroyNodeArgs = {
  input: DestroyNodeInput;
};


/** Root mutation entrypoint. */
export type MutationDestroyUserArgs = {
  input: DestroyUserInput;
};


/** Root mutation entrypoint. */
export type MutationEditNitoBanksArgs = {
  input: EditNitoBanksInput;
};


/** Root mutation entrypoint. */
export type MutationEditNitoExamsArgs = {
  input: EditNitoExamsInput;
};


/** Root mutation entrypoint. */
export type MutationEmptyUserCartArgs = {
  input: EmptyUserCartInput;
};


/** Root mutation entrypoint. */
export type MutationForcePassIlClassResultArgs = {
  input: ForcePassIlClassResultInput;
};


/** Root mutation entrypoint. */
export type MutationForcePromoteIlBookingArgs = {
  input: ForcePromoteIlBookingInput;
};


/** Root mutation entrypoint. */
export type MutationGrantCourseViaSubscriptionArgs = {
  input: GrantCourseViaSubscriptionInput;
};


/** Root mutation entrypoint. */
export type MutationHandleInviteArgs = {
  input: HandleInviteInput;
};


/** Root mutation entrypoint. */
export type MutationImpersonateUserArgs = {
  input: ImpersonateUserInput;
};


/** Root mutation entrypoint. */
export type MutationInitializeRapidqlArgs = {
  input: InitializeRapidqlInput;
};


/** Root mutation entrypoint. */
export type MutationInitiateOfflineOrderArgs = {
  input: InitiateOfflineOrderInput;
};


/** Root mutation entrypoint. */
export type MutationInviteOrganizationMemberArgs = {
  input: InviteOrganizationMemberInput;
};


/** Root mutation entrypoint. */
export type MutationIssueVerifiedCredentialArgs = {
  input: IssueVerifiedCredentialInput;
};


/** Root mutation entrypoint. */
export type MutationLoginInviteArgs = {
  input: LoginInviteInput;
};


/** Root mutation entrypoint. */
export type MutationMakeTrainingManagerArgs = {
  input: MakeTrainingManagerInput;
};


/** Root mutation entrypoint. */
export type MutationMarkCourseItemProgressionCompleteArgs = {
  input: MarkCourseItemProgressionCompleteInput;
};


/** Root mutation entrypoint. */
export type MutationMergeUsersArgs = {
  input: MergeUsersInput;
};


/** Root mutation entrypoint. */
export type MutationOverrideLearnerVerifiedStatusArgs = {
  input: OverrideLearnerVerifiedStatusInput;
};


/** Root mutation entrypoint. */
export type MutationPostCertificationToCrediveraArgs = {
  input: PostCertificationToCrediveraInput;
};


/** Root mutation entrypoint. */
export type MutationRefreshRapidqlArgs = {
  input: RefreshRapidqlInput;
};


/** Root mutation entrypoint. */
export type MutationRemoveCourseFromStorefrontArgs = {
  input: RemoveCourseFromStorefrontInput;
};


/** Root mutation entrypoint. */
export type MutationRemoveCustomFieldCourseRequirementArgs = {
  input: RemoveCustomFieldCourseRequirementInput;
};


/** Root mutation entrypoint. */
export type MutationReorderIlCourseItemsArgs = {
  input: ReorderIlCourseItemsInput;
};


/** Root mutation entrypoint. */
export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


/** Root mutation entrypoint. */
export type MutationRequestVerifiedCredentialPresentationArgs = {
  input: RequestVerifiedCredentialPresentationInput;
};


/** Root mutation entrypoint. */
export type MutationResendConfirmationCodeArgs = {
  input: ResendConfirmationCodeInput;
};


/** Root mutation entrypoint. */
export type MutationResendInstructorInvitationArgs = {
  input: ResendInstructorInvitationInput;
};


/** Root mutation entrypoint. */
export type MutationResendInviteArgs = {
  input: ResendInviteInput;
};


/** Root mutation entrypoint. */
export type MutationRestoreNodeArgs = {
  input: RestoreNodeInput;
};


/** Root mutation entrypoint. */
export type MutationReviewCourseItemProgressionArgs = {
  input: ReviewCourseItemProgressionInput;
};


/** Root mutation entrypoint. */
export type MutationReviewLearnerVerifiedSessionsArgs = {
  input: ReviewLearnerVerifiedSessionsInput;
};


/** Root mutation entrypoint. */
export type MutationRunCourseItemProgressionArgs = {
  input: RunCourseItemProgressionInput;
};


/** Root mutation entrypoint. */
export type MutationSendReportNowArgs = {
  input: SendReportNowInput;
};


/** Root mutation entrypoint. */
export type MutationShareLearnersArgs = {
  input: ShareLearnersInput;
};


/** Root mutation entrypoint. */
export type MutationShareLicenseArgs = {
  input: ShareLicenseInput;
};


/** Root mutation entrypoint. */
export type MutationSignInArgs = {
  input: SignInInput;
};


/** Root mutation entrypoint. */
export type MutationSignOutArgs = {
  input: SignOutInput;
};


/** Root mutation entrypoint. */
export type MutationSignUpArgs = {
  input: SignUpInput;
};


/** Root mutation entrypoint. */
export type MutationStartCourseArgs = {
  input: StartCourseInput;
};


/** Root mutation entrypoint. */
export type MutationStopSellingCourseArgs = {
  input: StopSellingCourseInput;
};


/** Root mutation entrypoint. */
export type MutationSubmitGradedAssignmentArgs = {
  input: SubmitGradedAssignmentInput;
};


/** Root mutation entrypoint. */
export type MutationTakeCourseArgs = {
  input: TakeCourseInput;
};


/** Root mutation entrypoint. */
export type MutationTearDownRapidqlArgs = {
  input: TearDownRapidqlInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateArchivedNodesArgs = {
  input: UpdateArchivedNodesInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateAutomationConstantArgs = {
  input: UpdateAutomationConstantInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateAutomationScriptArgs = {
  input: UpdateAutomationScriptInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCartItemArgs = {
  input: UpdateCartItemInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCertificationArgs = {
  input: UpdateCertificationInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCertificationChangeRequestArgs = {
  input: UpdateCertificationChangeRequestInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCertificationDefaultArgs = {
  input: UpdateCertificationDefaultInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCertificationTemplateArgs = {
  input: UpdateCertificationTemplateInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCourseArgs = {
  input: UpdateCourseInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCourseItemArgs = {
  input: UpdateCourseItemInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCourseItemProgressionProgressArgs = {
  input: UpdateCourseItemProgressionProgressInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCoursePromptArgs = {
  input: UpdateCoursePromptInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCustomAttributeArgs = {
  input: UpdateCustomAttributeInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCustomDomainArgs = {
  input: UpdateCustomDomainInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateCustomFieldArgs = {
  input: UpdateCustomFieldInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateDownloadableFileArgs = {
  input: UpdateDownloadableFileInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateEnrolmentKeyArgs = {
  input: UpdateEnrolmentKeyInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateGradedAssignmentSubmissionArgs = {
  input: UpdateGradedAssignmentSubmissionInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateIlClassArgs = {
  input: UpdateIlClassInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateIlClassResultsArgs = {
  input: UpdateIlClassResultsInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateIlCourseArgs = {
  input: UpdateIlCourseInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateIlCourseItemArgs = {
  input: UpdateIlCourseItemInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateIlLocationArgs = {
  input: UpdateIlLocationInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateInstructorArgs = {
  input: UpdateInstructorInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateLearnerArgs = {
  input: UpdateLearnerInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateLearnerVerifiedSessionArgs = {
  input: UpdateLearnerVerifiedSessionInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateLearnersActiveArgs = {
  input: UpdateLearnersActiveInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateLicenseArgs = {
  input: UpdateLicenseInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateMenuItemArgs = {
  input: UpdateMenuItemInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateOidcProviderArgs = {
  input: UpdateOidcProviderInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


/** Root mutation entrypoint. */
export type MutationUpdatePageArgs = {
  input: UpdatePageInput;
};


/** Root mutation entrypoint. */
export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


/** Root mutation entrypoint. */
export type MutationUpdatePrerequisiteCourseRequirementArgs = {
  input: UpdatePrerequisiteCourseRequirementInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


/** Root mutation entrypoint. */
export type MutationUpdatePromoCodeArgs = {
  input: UpdatePromoCodeInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateRapidqlScheduleArgs = {
  input: UpdateRapidqlScheduleInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateRedirectArgs = {
  input: UpdateRedirectInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateRegulatorSubmissionArgs = {
  input: UpdateRegulatorSubmissionInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateSamlProviderArgs = {
  input: UpdateSamlProviderInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateSavedQueryArgs = {
  input: UpdateSavedQueryInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateSharedProductArgs = {
  input: UpdateSharedProductInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateShoppingCartAddressArgs = {
  input: UpdateShoppingCartAddressInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateShoppingCartShippingInformationArgs = {
  input: UpdateShoppingCartShippingInformationInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateStorefrontArgs = {
  input: UpdateStorefrontInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateStripeSubscriptionArgs = {
  input: UpdateStripeSubscriptionInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateSurveySchemaArgs = {
  input: UpdateSurveySchemaInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateThemeArgs = {
  input: UpdateThemeInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateTrainingCompetencyArgs = {
  input: UpdateTrainingCompetencyInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateTrainingRoleArgs = {
  input: UpdateTrainingRoleInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** Root mutation entrypoint. */
export type MutationUpdateVerifiedCredentialIssuerArgs = {
  input: UpdateVerifiedCredentialIssuerInput;
};


/** Root mutation entrypoint. */
export type MutationUploadCertificationArgs = {
  input: UploadCertificationInput;
};


/** Root mutation entrypoint. */
export type MutationUploadIlClassRosterLearnerArgs = {
  input: UploadIlClassRosterLearnerInput;
};


/** Root mutation entrypoint. */
export type MutationUseActivationCodeArgs = {
  input: UseActivationCodeInput;
};


/** Root mutation entrypoint. */
export type MutationUseEnrolmentKeyArgs = {
  input: UseEnrolmentKeyInput;
};


/** Root mutation entrypoint. */
export type MutationViewCourseAgreementArgs = {
  input: ViewCourseAgreementInput;
};

/** Attributes for creating an address. */
export type NewAddressAttributes = {
  /** First line of the address. */
  address1: Scalars['String'];
  /** Second line of the address. */
  address2?: InputMaybe<Scalars['String']>;
  /** The city. */
  city: Scalars['String'];
  /** The province, if required, identified by an ISO code. */
  country?: InputMaybe<CodedLocation>;
  /** The postal code. */
  postalCode: Scalars['String'];
  /** The country, identified by an ISO code. */
  province?: InputMaybe<CodedLocation>;
};

/** An item bank in the Nito exam engine. */
export type NitoBank = Ownable & RelayNode & {
  __typename?: 'NitoBank';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the item bank. */
  name: Scalars['String'];
  /** The Nito engine ID of the item bank. */
  nitoId: Scalars['String'];
  /** The owner of the record. */
  owner: Owner;
  /** The rules this bank is tied to. */
  rules: Array<Rule>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for NitoBank. */
export type NitoBankConnection = {
  __typename?: 'NitoBankConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NitoBankEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NitoBank>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NitoBankEdge = {
  __typename?: 'NitoBankEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<NitoBank>;
};

/** Find item banks using the Nito engine you can manage. */
export type NitoBanksNamespace = {
  __typename?: 'NitoBanksNamespace';
  /** Nito banks you have direct access to. */
  all: NitoBankConnection;
  /** Find a single nitobank by its string ID. */
  findByGid?: Maybe<NitoBank>;
  /** Find a single nitobank by its integer ID. */
  findById: NitoBank;
  /** Find a single nitobank by its signed ID. */
  findBySgid?: Maybe<NitoBank>;
};


/** Find item banks using the Nito engine you can manage. */
export type NitoBanksNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Find item banks using the Nito engine you can manage. */
export type NitoBanksNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find item banks using the Nito engine you can manage. */
export type NitoBanksNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find item banks using the Nito engine you can manage. */
export type NitoBanksNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** An exam form in the Nito exam engine. */
export type NitoExam = Ownable & RelayNode & {
  __typename?: 'NitoExam';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the exam. */
  name: Scalars['String'];
  /** The Nito engine ID of the form backing this exam. */
  nitoId: Scalars['String'];
  /** The owner of the record. */
  owner: Owner;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for NitoExam. */
export type NitoExamConnection = {
  __typename?: 'NitoExamConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NitoExamEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NitoExam>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NitoExamEdge = {
  __typename?: 'NitoExamEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<NitoExam>;
};

/** Find exams using the Nito engine you can manage. */
export type NitoExamsNamespace = {
  __typename?: 'NitoExamsNamespace';
  /** Nito exams you have direct access to. */
  all: NitoExamConnection;
  /** Find a single nitoexam by its string ID. */
  findByGid?: Maybe<NitoExam>;
  /** Find a single nitoexam by its integer ID. */
  findById: NitoExam;
  /** Find a single nitoexam by its signed ID. */
  findBySgid?: Maybe<NitoExam>;
};


/** Find exams using the Nito engine you can manage. */
export type NitoExamsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Find exams using the Nito engine you can manage. */
export type NitoExamsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find exams using the Nito engine you can manage. */
export type NitoExamsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find exams using the Nito engine you can manage. */
export type NitoExamsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** Notification type options */
export enum NotificationTypeEnum {
  /** Send via email */
  Email = 'email',
  /** Send via none */
  None = 'none',
  /** Send via sms */
  Sms = 'sms'
}

/** An OIDC provider. */
export type OidcProvider = RelayNode & {
  __typename?: 'OIDCProvider';
  /** The automation claim path of the OIDC provider. */
  automationClaimPath?: Maybe<Scalars['String']>;
  /** Any permissions you have relevant to the OIDC Provider. */
  can: OidcProviderPermissions;
  /** The client ID of the OIDC provider. */
  clientId: Scalars['String'];
  /** The client secret of the OIDC provider. */
  clientSecret: Scalars['String'];
  /** The configuration URL of the OIDC provider. */
  configurationUrl: Scalars['String'];
  /** Whether to confirm email during signup. */
  confirmEmailDuringSignup: Scalars['Boolean'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the OIDC provider. */
  name: Scalars['String'];
  /** The promo code claim path of the OIDC provider. */
  promoCodeClaimPath?: Maybe<Scalars['String']>;
  /** The scopes of the OIDC provider. */
  scope: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Permissions for a OIDC Provider. */
export type OidcProviderPermissions = {
  __typename?: 'OIDCProviderPermissions';
  /** Whether you can destroy this OIDC provider. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this OIDC provider. */
  update: Scalars['Boolean'];
};

/** An instance of an offline order. */
export type OfflineOrder = RelayNode & {
  __typename?: 'OfflineOrder';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The customer number of the recipient. */
  customerNumber?: Maybe<Scalars['String']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** An optional note entered by the order person. */
  note?: Maybe<Scalars['String']>;
  /** The order related to this offline order. */
  order: Order;
  /** The user who filled out the form to complete the order. */
  orderPerson: User;
  /** The purchase order number specified by the recipient. */
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  /** The name of the person who acted as a commissionable sales person for the order. */
  salesPersonName?: Maybe<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Whether the offline order should be invoiced or not. */
  withoutPayment: Scalars['Boolean'];
};

/** The connection type for OfflineOrder. */
export type OfflineOrderConnection = {
  __typename?: 'OfflineOrderConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OfflineOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OfflineOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OfflineOrderEdge = {
  __typename?: 'OfflineOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<OfflineOrder>;
};

/** Find offline orders you can manage. */
export type OfflineOrdersNamespace = {
  __typename?: 'OfflineOrdersNamespace';
  /** Offline orders you have access to. */
  all: OfflineOrderConnection;
  /** Find a single offlineorder by its string ID. */
  findByGid?: Maybe<OfflineOrder>;
  /** Find a single offlineorder by its integer ID. */
  findById: OfflineOrder;
  /** Find a single offlineorder by its signed ID. */
  findBySgid?: Maybe<OfflineOrder>;
};


/** Find offline orders you can manage. */
export type OfflineOrdersNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  storefrontId?: InputMaybe<Scalars['Int']>;
};


/** Find offline orders you can manage. */
export type OfflineOrdersNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find offline orders you can manage. */
export type OfflineOrdersNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find offline orders you can manage. */
export type OfflineOrdersNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** A calculable for a one time fee contract. */
export type OneTimeFeeContract = ContractCalculable & RelayNode & {
  __typename?: 'OneTimeFeeContract';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Fee type of the calculable. */
  feeType: OneTimeFeeFeeTypeEnum;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Fee price. */
  price: Scalars['Float'];
  /** Fee price. */
  priceFormatted: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Type of contract, snake_case. */
  type: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A calculable for a one time fee contract. */
export type OneTimeFeeContractPriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Valid fee types for one time fee contracts. */
export enum OneTimeFeeFeeTypeEnum {
  /** A fee type for a one time fee that is Adjustment. */
  Adjustment = 'adjustment',
  /** A fee type for a one time fee that is Commission. */
  Commission = 'commission',
  /** A fee type for a one time fee that is Custom development. */
  CustomDevelopment = 'custom_development',
  /** A fee type for a one time fee that is Other. */
  Other = 'other',
  /** A fee type for a one time fee that is Scorm. */
  Scorm = 'scorm',
  /** A fee type for a one time fee that is Setup. */
  Setup = 'setup'
}

/** An order on a storefront. */
export type Order = RelayNode & {
  __typename?: 'Order';
  /** The billing address. */
  billingAddress: BillingAddress;
  /** Any permissions you have relevant to the order. */
  can: OrderPermissions;
  /** Channel data for Ably subscriptions. */
  channelData?: Maybe<ChannelData>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The currency the order is in. */
  currency: Currency;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The items ordered. */
  orderItems: Array<OrderItem>;
  /** The payment method. */
  paymentMethod: Scalars['String'];
  /** The promotional codes used. */
  promoCodeUses: Array<PromoCodeUse>;
  /** The savings this user received based on promotional codes. */
  promotionalSavings: Scalars['Float'];
  /** The savings this user received based on promotional codes. */
  promotionalSavingsFormatted: Scalars['String'];
  /** The total refundable amount for this order. */
  refundableAmount: Scalars['Float'];
  /** The total refundable amount for this order. */
  refundableAmountFormatted: Scalars['String'];
  /** The total refunded amount for this order. */
  refundedAmount: Scalars['Float'];
  /** The total refunded amount for this order. */
  refundedAmountFormatted: Scalars['String'];
  /** Any refunds associated with this order */
  refunds: Array<Refund>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The shipping for this order. */
  shipping: Scalars['Float'];
  /** The shipping address. */
  shippingAddress?: Maybe<Address>;
  /** The shipping for this order. */
  shippingFormatted: Scalars['String'];
  /** The shipping information. */
  shippingInformation?: Maybe<ShippingInformation>;
  /** The shipping items for this order. */
  shippingItems: Array<ShippingItem>;
  /** The storefront this order was on. */
  storefront: Storefront;
  /** Any Stripe refunds associated with this order. */
  stripeRefunds: Array<StripeRefund>;
  /** The subtotal for this order. */
  subtotal: Scalars['Float'];
  /** The subtotal for this order. */
  subtotalFormatted: Scalars['String'];
  /** The tax for this order. */
  tax: Scalars['Float'];
  /** The tax for this order. */
  taxFormatted: Scalars['String'];
  /** Flatten taxes for this order. To get individual items, go through the order_items and their tax_items. */
  taxItems: Array<TaxItem>;
  /** The total for this order. */
  total: Scalars['Float'];
  /** The total for this order. */
  totalFormatted: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The licenses that have been used. */
  usedLicenses: Array<License>;
  /** The user that made this order. */
  user: User;
};


/** An order on a storefront. */
export type OrderPromotionalSavingsFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** An order on a storefront. */
export type OrderRefundableAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** An order on a storefront. */
export type OrderRefundedAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** An order on a storefront. */
export type OrderShippingFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** An order on a storefront. */
export type OrderSubtotalFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** An order on a storefront. */
export type OrderTaxFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** An order on a storefront. */
export type OrderTotalFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

/** An order item on an order. */
export type OrderItem = RelayNode & {
  __typename?: 'OrderItem';
  /** Any permissions you have relevant to the order item. */
  can: OrderItemPermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The Order this item is on. */
  order: Order;
  /** The product this order item was for as it was during purchase. */
  originalProduct: OriginalProduct;
  /** The unit price of this order item. */
  price: Scalars['Float'];
  /** The unit price of this order item. */
  priceFormatted: Scalars['String'];
  /** The product this order item was for as it currently is. */
  product: Product;
  /** The promo code used on this order item. */
  promoCode?: Maybe<PromoCode>;
  /** Savings from a promo code on this order item. */
  promotionalSavings: Scalars['Float'];
  /** Savings from a promo code on this order item. */
  promotionalSavingsFormatted: Scalars['String'];
  /** The quantity. */
  quantity: Scalars['Int'];
  /** Any refund items associated with this order */
  refundItems?: Maybe<Array<RefundItem>>;
  /** The amount that can be refunded. */
  refundableAmount: Scalars['Float'];
  /** The amount that can be refunded. */
  refundableAmountFormatted: Scalars['String'];
  /** The quantity that can be refunded. */
  refundableQuantity: Scalars['Int'];
  /** Whether this order item requires shipping. */
  requiresShipping: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Taxes for this order item. */
  taxItems: Array<TaxItem>;
  /** The total price of this order item, taking into account the quantity. */
  total: Scalars['Float'];
  /** The total price of this order item, taking into account the quantity. */
  totalFormatted: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** An order item on an order. */
export type OrderItemPriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** An order item on an order. */
export type OrderItemPromotionalSavingsFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** An order item on an order. */
export type OrderItemRefundableAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** An order item on an order. */
export type OrderItemTotalFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** A pair of OrderItem ID and quantity to calculate taxes to refund. */
export type OrderItemPairAttributes = {
  /** The amount to calculate. */
  amountCents: Scalars['Int'];
  /** The ID of the Order Item. */
  orderItemId: Scalars['Int'];
  /** The quantity to calculate. */
  quantity: Scalars['Int'];
};

/** Permissions on this order item. */
export type OrderItemPermissions = {
  __typename?: 'OrderItemPermissions';
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can refund this order item. */
  refund: Scalars['Boolean'];
};

/** Permissions on this order. */
export type OrderPermissions = {
  __typename?: 'OrderPermissions';
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can refund this order. */
  refund: Scalars['Boolean'];
};

/** Find orders you can manage. */
export type OrdersNamespace = {
  __typename?: 'OrdersNamespace';
  /** Find a single order by its string ID. */
  findByGid?: Maybe<Order>;
  /** Find a single order by its integer ID. */
  findById: Order;
  /** Find a single order by its signed ID. */
  findBySgid?: Maybe<Order>;
  /** Orders you have placed. */
  mine: OrderConnection;
};


/** Find orders you can manage. */
export type OrdersNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find orders you can manage. */
export type OrdersNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find orders you can manage. */
export type OrdersNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};


/** Find orders you can manage. */
export type OrdersNamespaceMineArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** An Organiation owns storefronts, courses, and licenses, and allows members to share access to all its resources. */
export type Organization = RelayNode & {
  __typename?: 'Organization';
  /** The address of the organization. */
  address: Address;
  /** Whether to allow platform analytics on storefronts. */
  analyticsOptIn: Scalars['Boolean'];
  /** Get any automation constants on this organization. */
  automationConstants?: Maybe<Array<AutomationConstant>>;
  /** Get any automation scripts on this organization. */
  automationScripts?: Maybe<Array<AutomationScript>>;
  /** The billing email of the organization. */
  billingEmail?: Maybe<Scalars['String']>;
  /** Any permissions you have relevant to the organization. */
  can: OrganizationPermissions;
  /** The certification default of the Organization. */
  certificationDefault?: Maybe<CertificationDefault>;
  /** Connected stripe accounts for this organization. */
  connectedStripeAccounts?: Maybe<Array<ConnectedStripeAccount>>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Members of this organization. */
  memberships?: Maybe<Array<OrganizationMembership>>;
  /** Name of the organization. */
  name: Scalars['String'];
  /** OIDC providers for this organization. */
  oidcProviders?: Maybe<Array<OidcProvider>>;
  /** The owner of the organization. The owner of an organization is always a user. */
  owner?: Maybe<User>;
  /** Any paths relevant to the organization. */
  paths: OrganizationPaths;
  /** Organization revenue for a month / year */
  revenues?: Maybe<OrganizationRevenues>;
  /** SAML providers for this organization. */
  samlProviders?: Maybe<Array<SamlProvider>>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The shipping notification email of the organization. */
  shippingNotificationEmail?: Maybe<Scalars['String']>;
  /** Storefronts for this organization. */
  storefronts?: Maybe<Array<Storefront>>;
  /** Paths to connect a stripe account to the organization. */
  stripeConnectPaths?: Maybe<Array<OrganizationStripePath>>;
  /** Whether the Stripe Account is managed by the organization. */
  stripeSelfManaged: Scalars['Boolean'];
  /** The Canadian tax codes this organization charges. */
  taxCodes: Array<TaxCodeEnum>;
  /** Training competencies for training matrices owned by this organization. */
  trainingCompetencies?: Maybe<Array<TrainingCompetency>>;
  /** Channel data for Ably subscriptions. */
  trainingMatrixChannelData: ChannelData;
  /** Training roles for training matrices owned by this organization. */
  trainingRoles?: Maybe<Array<TrainingRole>>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** A URL for the organization. */
  url?: Maybe<Scalars['String']>;
  /** Verified credential issuers for this organization. */
  verifiedCredentialIssuers?: Maybe<Array<VerifiedCredentialIssuer>>;
  /** Whether this organization is owned by WKT. */
  wktOwned: Scalars['Boolean'];
};


/** An Organiation owns storefronts, courses, and licenses, and allows members to share access to all its resources. */
export type OrganizationRevenuesArgs = {
  currency?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** An Organiation owns storefronts, courses, and licenses, and allows members to share access to all its resources. */
export type OrganizationStorefrontsArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

/** Commissions revenue */
export type OrganizationCommissionsRevenue = Revenue & {
  __typename?: 'OrganizationCommissionsRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The payout records contributing to this revenue. */
  records: PayoutConnection;
};


/** Commissions revenue */
export type OrganizationCommissionsRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Commissions revenue */
export type OrganizationCommissionsRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Organization. */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Course distribution from all storefronts owned by the organization */
export type OrganizationCourseDistributionRevenue = Revenue & {
  __typename?: 'OrganizationCourseDistributionRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The contract revenue records contributing to this revenue */
  records: ContractRevenueConnection;
};


/** Course distribution from all storefronts owned by the organization */
export type OrganizationCourseDistributionRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Course distribution from all storefronts owned by the organization */
export type OrganizationCourseDistributionRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Organization>;
};

/** GST/HST taxes */
export type OrganizationFederalTaxesRevenue = {
  __typename?: 'OrganizationFederalTaxesRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
};


/** GST/HST taxes */
export type OrganizationFederalTaxesRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Represents a user membership in an Organization. */
export type OrganizationMembership = RelayNode & {
  __typename?: 'OrganizationMembership';
  /** Any permissions you have relevant to this membership. */
  can: OrganizationMembershipPermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The organization. */
  organization: Organization;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user. */
  user: User;
};

/** Your permissions on this organization membership. */
export type OrganizationMembershipPermissions = {
  __typename?: 'OrganizationMembershipPermissions';
  /** Whether you can remove this person from the organization. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
};

/** URL paths in the application to do things with this organization. */
export type OrganizationPaths = {
  __typename?: 'OrganizationPaths';
  /** Path to edit the organization. */
  edit: Scalars['String'];
  /** The ID of the record these paths are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these paths are for. */
  id: Scalars['Int'];
  /** Path to create an invite to the organization. */
  newInvite: Scalars['String'];
};

/** Whether you have permission to perform certain actions on this organization. */
export type OrganizationPermissions = {
  __typename?: 'OrganizationPermissions';
  /** whether you can access automation. */
  automation: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** whether you can access integrations. */
  integrate: Scalars['Boolean'];
  /** Whether you can invite new members to this organization. */
  invite: Scalars['Boolean'];
  /** Whether you can manage SSO settings on this organization. */
  manageSso: Scalars['Boolean'];
  /** Whether you can manage surveys on this organization. */
  manageSurveys: Scalars['Boolean'];
  /** Whether this organization is enabled to use training matrix. */
  manageTrainingMatrix: Scalars['Boolean'];
  /** Whether you can manage verified credential settings on this organization. */
  manageVerifiedCredentials: Scalars['Boolean'];
  /** Whether you can access stripe_connect things on this organization. */
  stripeConnect: Scalars['Boolean'];
  /** Whether you can access update things on this organization. */
  update: Scalars['Boolean'];
};

/** Platform Licenses from all the storefronts owned by the organization */
export type OrganizationPlatformLicensesRevenue = Revenue & {
  __typename?: 'OrganizationPlatformLicensesRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The contract revenue records contributing to this revenue */
  records: ContractRevenueConnection;
};


/** Platform Licenses from all the storefronts owned by the organization */
export type OrganizationPlatformLicensesRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Platform Licenses from all the storefronts owned by the organization */
export type OrganizationPlatformLicensesRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The revenue for a organization in a period */
export type OrganizationRevenues = {
  __typename?: 'OrganizationRevenues';
  /** The commissions revenue for this period. */
  commissions: OrganizationCommissionsRevenue;
  /** The course distribution revenue for this period. */
  courseDistribution: OrganizationCourseDistributionRevenue;
  /** The currency that the revenue is filtered by. */
  currency: Currency;
  /** Period end date */
  endPeriod: Scalars['ISO8601Date'];
  /** The GST/HST taxes revenue for this period. */
  federalTaxes: OrganizationFederalTaxesRevenue;
  /** The platform licenses revenue for this period. */
  platformLicenses: OrganizationPlatformLicensesRevenue;
  /** The royalties revenue for this period. */
  royalties: OrganizationRoyaltiesRevenue;
  /** The royalties taxes revenue for this period. */
  royaltiesTaxes: OrganizationRoyaltiesTaxesRevenue;
  /** Period start date */
  startPeriod: Scalars['ISO8601Date'];
  /** The transaction fees revenue for this period. */
  transactionFees: OrganizationTransactionFeesRevenue;
};

/** Royalties revenue */
export type OrganizationRoyaltiesRevenue = Revenue & {
  __typename?: 'OrganizationRoyaltiesRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The payout records contributing to this revenue. */
  records: PayoutConnection;
};


/** Royalties revenue */
export type OrganizationRoyaltiesRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Royalties revenue */
export type OrganizationRoyaltiesRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Taxes on royalties revenue */
export type OrganizationRoyaltiesTaxesRevenue = Revenue & {
  __typename?: 'OrganizationRoyaltiesTaxesRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The tax record items contributing to this revenue. */
  records: LedgerTaxRecordConnection;
};


/** Taxes on royalties revenue */
export type OrganizationRoyaltiesTaxesRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Taxes on royalties revenue */
export type OrganizationRoyaltiesTaxesRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A path to connect a stripe account to the organization. */
export type OrganizationStripePath = {
  __typename?: 'OrganizationStripePath';
  /** The ISO code of the currency. */
  isoCode: Scalars['String'];
  /** The name of the currency. */
  name: Scalars['String'];
  /** The path to connect a stripe account to the organization. */
  path: Scalars['String'];
};

/** Transaction fees from all the storefronts owned by the organization */
export type OrganizationTransactionFeesRevenue = Revenue & {
  __typename?: 'OrganizationTransactionFeesRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The contract revenue records contributing to this revenue */
  records: ContractRevenueConnection;
};


/** Transaction fees from all the storefronts owned by the organization */
export type OrganizationTransactionFeesRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Transaction fees from all the storefronts owned by the organization */
export type OrganizationTransactionFeesRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Access organizations you are in or are instructing for. */
export type OrganizationsNamespace = {
  __typename?: 'OrganizationsNamespace';
  /** Get all your organizations. */
  all: OrganizationConnection;
  /** Get all organizations for the current user as an instructor. */
  allForInstructor: OrganizationConnection;
  /** Get all organizations with storefronts or with courses for sale. */
  allForTheLedger: OrganizationConnection;
  /** Find a single organization by its string ID. */
  findByGid?: Maybe<Organization>;
  /** Find a single organization by its integer ID. */
  findById: Organization;
  /** Find a single organization by its signed ID. */
  findBySgid?: Maybe<Organization>;
};


/** Access organizations you are in or are instructing for. */
export type OrganizationsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Access organizations you are in or are instructing for. */
export type OrganizationsNamespaceAllForInstructorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Access organizations you are in or are instructing for. */
export type OrganizationsNamespaceAllForTheLedgerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Access organizations you are in or are instructing for. */
export type OrganizationsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Access organizations you are in or are instructing for. */
export type OrganizationsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Access organizations you are in or are instructing for. */
export type OrganizationsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** An historical product on a storefront with no id. */
export type OriginalProduct = {
  __typename?: 'OriginalProduct';
  /** The name of this product. */
  name: Scalars['String'];
  /** The unit price of this product. */
  price: Scalars['Float'];
  /** The unit price of this product. */
  priceFormatted: Scalars['String'];
  /** The SKU of this product. */
  sku?: Maybe<Scalars['String']>;
};


/** An historical product on a storefront with no id. */
export type OriginalProductPriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of OverrideLearnerVerifiedStatus */
export type OverrideLearnerVerifiedStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the Grant to override the status on. */
  grantId: Scalars['ID'];
  /** The status to override with. */
  status: LearnerVerifiedOverrideStatus;
};

/** Autogenerated return type of OverrideLearnerVerifiedStatus. */
export type OverrideLearnerVerifiedStatusPayload = {
  __typename?: 'OverrideLearnerVerifiedStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Grant that was updated. */
  grant: Grant;
};

/** Something that has an owner. */
export type Ownable = {
  /** The owner of the record. */
  owner: Owner;
};

/** A record that owns another thing. Typically this is a User or Organization that owns a Storefront, Course, etc. */
export type Owner = RelayNode & {
  __typename?: 'Owner';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The kind of the owner. */
  kind: Scalars['String'];
  /** A name to display for the owner. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A storefront page */
export type Page = RelayNode & {
  __typename?: 'Page';
  /** Any permissions you have relevant to the page. */
  can: PagePermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** A CSS class to apply to the page. */
  cssClass?: Maybe<Scalars['String']>;
  /** A description of the page. */
  description?: Maybe<Scalars['String']>;
  /** The feature image of the page. */
  featureImage?: Maybe<AttacheFile>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Any custom meta tags for the page. */
  metaTags: Array<MetaTags>;
  /** The name of the page. */
  name: Scalars['String'];
  /** A password to access the page. If not provided, the page is public. */
  password?: Maybe<Scalars['String']>;
  /** Whether the page is published or not. */
  published: Scalars['Boolean'];
  /** Whether the user must be logged in to access the page. */
  requireLoggedInUser: Scalars['Boolean'];
  /** Whether the page is the home page or not. Only one page may be the home page. */
  root: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** How he page will looks on the URL. */
  slug: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The full URL to the page. */
  url: Scalars['String'];
};


/** A storefront page */
export type PageFeatureImageArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};

/** Valid types for product page version. */
export enum PageHeaderVersionTypeEnum {
  /** The custom liquid page header version. */
  Liquid = 'liquid',
  /** The original page header version. */
  Original = 'original'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Valid printable page orientations. */
export enum PageOrientation {
  /** A page that is wider than it is tall. */
  Landscape = 'landscape',
  /** A page that is taller than it is wide. */
  Portrait = 'portrait'
}

/** Whether you have permission to perform certain actions on this page. */
export type PagePermissions = {
  __typename?: 'PagePermissions';
  /** Whether you can destroy this page. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this page. */
  update: Scalars['Boolean'];
};

/** Valid password reset context options */
export enum PasswordResetContextEnum {
  /** When the password reset request is coming from anywhere other than the Satchel mobile application. */
  Devise = 'devise',
  /** When the password reset request is coming from the Satchel mobile application. */
  Satchel = 'satchel'
}

/** A Payout. */
export type Payout = RelayNode & {
  __typename?: 'Payout';
  /** The amount of the payout. */
  amount: Scalars['Float'];
  /** The amount of the payout. */
  amountFormatted: Scalars['String'];
  /** Contract that generates this payout. */
  contract: Contract;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Order item that this payout is related to. */
  orderItem?: Maybe<OrderItem>;
  /** Organization that owns the payout. If null, payout is to the platform owner (WKT). */
  organization?: Maybe<Organization>;
  /** The refunded object, if it exists. */
  refundable?: Maybe<PayoutRefundable>;
  /** Which party the payout is for. */
  revenuePart: PayoutRevenuePartEnum;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A Payout. */
export type PayoutAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for Payout. */
export type PayoutConnection = {
  __typename?: 'PayoutConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PayoutEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Payout>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PayoutEdge = {
  __typename?: 'PayoutEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Payout>;
};

/** An object that has been refunded. */
export type PayoutRefundable = RefundItem | StripeRefund;

/** Valid parts for a payout. */
export enum PayoutRevenuePartEnum {
  /** A payout for author. */
  Author = 'author',
  /** A payout for platform. */
  Platform = 'platform',
  /** A payout for seller. */
  Seller = 'seller'
}

/** A pending IL booking reservation */
export type PendingIlBookingReservation = RelayNode & {
  __typename?: 'PendingILBookingReservation';
  /** The course item for this pending booking. */
  courseItem: CourseItem;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The IL Class for this pending booking. */
  ilClass: IlClass;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The start date and time of the instructor-led class. */
  startsAt: Scalars['ISO8601DateTime'];
  /** The time zone of the session. */
  timeZone: Scalars['TimeZone'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents a billable unit of usage in the platform. */
export type PlatformUsageItem = Ownable & RelayNode & {
  __typename?: 'PlatformUsageItem';
  /** The course related to this usage. */
  course: Course;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The grant, if applicable, related to this usage. */
  grant?: Maybe<Grant>;
  /** The integer ID. */
  id: Scalars['Int'];
  /** Whether or not the usage is "internal" to the owner. */
  internal: Scalars['Boolean'];
  /** The license related to this usage. */
  license: License;
  /** The order, if applicable, related to this usage. */
  order?: Maybe<Order>;
  /** The order item, if applicable, related to this usage. */
  orderItem?: Maybe<OrderItem>;
  /** The owner of the record. */
  owner: Owner;
  /** The quantity tied to the usage, 1 in the case of a Grant, or delegate to the OrderItem. */
  quantity: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The storefront, if applicable, related to this usage. */
  storefront?: Maybe<Storefront>;
  /** The Stripe charge ID related to this usage. */
  stripeChargeId?: Maybe<Scalars['String']>;
  /** The type of the usage, whether related to an OrderItem or a Grant. */
  type?: Maybe<Scalars['String']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user related to this usage. The user that made the purchase or has the grant. */
  user: User;
};

/** The connection type for PlatformUsageItem. */
export type PlatformUsageItemConnection = {
  __typename?: 'PlatformUsageItemConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlatformUsageItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PlatformUsageItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlatformUsageItemEdge = {
  __typename?: 'PlatformUsageItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PlatformUsageItem>;
};

/** Autogenerated input type of PostCertificationToCredivera */
export type PostCertificationToCrediveraInput = {
  /** The ID of the certification to post. */
  certificationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PostCertificationToCredivera. */
export type PostCertificationToCrediveraPayload = {
  __typename?: 'PostCertificationToCrediveraPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any message. */
  message?: Maybe<Scalars['String']>;
  /** Whether the certification was posted to Credivera. */
  ok: Scalars['Boolean'];
};

/** A requirement specified by a course for other course(s). */
export type PrerequisiteCourseRequirement = CourseRequirementInterface & RelayNode & {
  __typename?: 'PrerequisiteCourseRequirement';
  /** The course which has the requirement. */
  course: Course;
  /** The courses that are required to be completed before starting this course. */
  courses: Array<Course>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The number of courses that must be completed. */
  requirementQuantity: Scalars['Int'];
  /** Whether it needs all associated courses or at least some of them to be completed. */
  requirementType: PrerequisiteCourseRequirementRequirementTypeEnum;
  /** Has the user satisfied this requirement? */
  satisfied: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The kind of requirement specified by the course. */
  type: CourseRequirementsTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A requirement specified by a course for other course(s). */
export type PrerequisiteCourseRequirementSatisfiedArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};

/** Valid completed course requirement definition requirement types. */
export enum PrerequisiteCourseRequirementRequirementTypeEnum {
  /** A completed course requirement that needs all of a certain set of courses. */
  AllItems = 'all_items',
  /** A completed course requirement that needs at least a certain number of courses. */
  AtLeast = 'at_least'
}

/** Presence data to uniquely track a learner and ensure they don't have a course open across multiple windows. */
export type PresenceData = {
  __typename?: 'PresenceData';
  /** Channel name for Ably. */
  channel: Scalars['String'];
  /** Client ID for Ably. */
  clientId: Scalars['String'];
  /** Token for Ably. */
  token: Scalars['String'];
  /** A unique UID. */
  uuid: Scalars['String'];
};

/** The price of a product. */
export type Price = RelayNode & {
  __typename?: 'Price';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The currency of the price. */
  currency: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The type of the price. */
  priceableType: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The dollar amount of the price. */
  value: Scalars['Float'];
  /** The dollar amount of the price. */
  valueFormatted: Scalars['String'];
};


/** The price of a product. */
export type PriceValueFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Attributes for the price of priceable. */
export type PriceAttributes = {
  /** The currency of the price. */
  currency?: InputMaybe<Scalars['String']>;
  /** The id of the price to update. */
  id?: InputMaybe<Scalars['Int']>;
  /** The price. */
  value?: InputMaybe<Scalars['Float']>;
};

/** A product on a storefront. */
export type Product = HasCustomAttributes & RelayNode & Taggable & {
  __typename?: 'Product';
  /** Whether this product is available for individual purchase */
  availableForIndividualPurchase: Scalars['Boolean'];
  /** The options for booking during purchase. */
  bookDuringPurchase: BookDuringPurchaseEnum;
  /** The brand of this product. */
  brand?: Maybe<Scalars['String']>;
  /** Settings for bulk discounts. */
  bulkDiscountOptions?: Maybe<BulkDiscountOptions>;
  /** Toggle for bulk discounts. */
  bulkDiscounts: Scalars['Boolean'];
  /** The products included in this bundle. */
  bundledProducts: Array<Product>;
  /** Any permissions you have relevant to the Product. */
  can: ProductPermissions;
  /** Media for the product page. */
  carouselMedia: Array<AttacheFile>;
  /** The categories of this product. */
  categories: Array<Scalars['String']>;
  /** The course for this product. */
  course?: Maybe<Course>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The currency this product is priced in. */
  currency: Currency;
  /** Custom attributes for the record. */
  customAttributes: Array<CustomAttribute>;
  /** The description of this product. */
  description?: Maybe<Scalars['String']>;
  /** The discount amount for this product due to promo codes. */
  discount: Scalars['Float'];
  /** The discount amount for this product due to promo codes. */
  discountFormatted: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** Whether this product is hidden or not. */
  hidden: Scalars['Boolean'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Whether this product is an IL course. */
  isInstructorLed: Scalars['Boolean'];
  /** Any custom meta tags for the page. */
  metaTags: Array<MetaTags>;
  /** The name of this product. */
  name: Scalars['String'];
  /** The number of orders for the product. */
  ordersCount: Scalars['Int'];
  /** The photo for the product. */
  photo?: Maybe<AttacheFile>;
  /**
   * The photo of this product.
   * @deprecated Use photo.url instead
   */
  photoUrl?: Maybe<Scalars['String']>;
  /** The unit price of this product. */
  price: Scalars['Float'];
  /** The unit price of this product. */
  priceFormatted: Scalars['String'];
  /** The discounted price of this product. Based on the promo code claims for the current user. */
  priceWithDiscount: Scalars['Float'];
  /** The discounted price of this product. Based on the promo code claims for the current user. */
  priceWithDiscountFormatted: Scalars['String'];
  /** Whether this product requires shipping. */
  requiresShipping: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The short description of this product. */
  shortDescription?: Maybe<Scalars['String']>;
  /** The SKU of this product. */
  sku?: Maybe<Scalars['String']>;
  /** The summary of this product. */
  summary?: Maybe<Scalars['String']>;
  /** The tags on this object. */
  tags: Array<Tag>;
  /** Whether taxes are enabled for this product. */
  taxesEnabled: Scalars['Boolean'];
  /** The type of this product. */
  type?: Maybe<Scalars['String']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The full URL to the product. */
  url: Scalars['String'];
};


/** A product on a storefront. */
export type ProductDiscountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A product on a storefront. */
export type ProductPhotoArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};


/** A product on a storefront. */
export type ProductPhotoUrlArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};


/** A product on a storefront. */
export type ProductPriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A product on a storefront. */
export type ProductPriceWithDiscountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** A product on a storefront which is a collection of courses sold for one price. */
export type ProductBundle = HasCustomAttributes & RelayNode & Taggable & {
  __typename?: 'ProductBundle';
  /** Whether this product is available for individual purchase */
  availableForIndividualPurchase: Scalars['Boolean'];
  /** The options for booking during purchase. */
  bookDuringPurchase: BookDuringPurchaseEnum;
  /** The brand of this product. */
  brand?: Maybe<Scalars['String']>;
  /** Settings for bulk discounts. */
  bulkDiscountOptions?: Maybe<BulkDiscountOptions>;
  /** Toggle for bulk discounts. */
  bulkDiscounts: Scalars['Boolean'];
  /** The products included in this bundle. */
  bundledProducts: Array<Product>;
  /** Any permissions you have relevant to the Product. */
  can: ProductPermissions;
  /** Media for the product page. */
  carouselMedia: Array<AttacheFile>;
  /** The categories of this product. */
  categories: Array<Scalars['String']>;
  /** The course for this product. */
  course?: Maybe<Course>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The currency this product is priced in. */
  currency: Currency;
  /** Custom attributes for the record. */
  customAttributes: Array<CustomAttribute>;
  /** The description of this product. */
  description?: Maybe<Scalars['String']>;
  /** The discount amount for this product due to promo codes. */
  discount: Scalars['Float'];
  /** The discount amount for this product due to promo codes. */
  discountFormatted: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** Whether this product is hidden or not. */
  hidden: Scalars['Boolean'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Whether this product is an IL course. */
  isInstructorLed: Scalars['Boolean'];
  /** Any custom meta tags for the page. */
  metaTags: Array<MetaTags>;
  /** The name of this product. */
  name: Scalars['String'];
  /** The number of orders for the product. */
  ordersCount: Scalars['Int'];
  /** The photo for the product. */
  photo?: Maybe<AttacheFile>;
  /**
   * The photo of this product.
   * @deprecated Use photo.url instead
   */
  photoUrl?: Maybe<Scalars['String']>;
  /** The unit price of this product. */
  price: Scalars['Float'];
  /** The unit price of this product. */
  priceFormatted: Scalars['String'];
  /** The discounted price of this product. Based on the promo code claims for the current user. */
  priceWithDiscount: Scalars['Float'];
  /** The discounted price of this product. Based on the promo code claims for the current user. */
  priceWithDiscountFormatted: Scalars['String'];
  /** Whether this product requires shipping. */
  requiresShipping: Scalars['Boolean'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The short description of this product. */
  shortDescription?: Maybe<Scalars['String']>;
  /** The SKU of this product. */
  sku?: Maybe<Scalars['String']>;
  /** The summary of this product. */
  summary?: Maybe<Scalars['String']>;
  /** The tags on this object. */
  tags: Array<Tag>;
  /** Whether taxes are enabled for this product. */
  taxesEnabled: Scalars['Boolean'];
  /** The type of this product. */
  type?: Maybe<Scalars['String']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The full URL to the product. */
  url: Scalars['String'];
};


/** A product on a storefront which is a collection of courses sold for one price. */
export type ProductBundleDiscountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A product on a storefront which is a collection of courses sold for one price. */
export type ProductBundlePhotoArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};


/** A product on a storefront which is a collection of courses sold for one price. */
export type ProductBundlePhotoUrlArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};


/** A product on a storefront which is a collection of courses sold for one price. */
export type ProductBundlePriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A product on a storefront which is a collection of courses sold for one price. */
export type ProductBundlePriceWithDiscountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Show products available for sale on the current storefront */
export type ProductCatalog = {
  __typename?: 'ProductCatalog';
  /** List of product categories available */
  categories: Array<Scalars['String']>;
  /** List of products available for sale on the current storefront */
  products: Array<Product>;
};

/** The product defaults for a course. Used as a template to populate products. */
export type ProductDefault = RelayNode & {
  __typename?: 'ProductDefault';
  /** The options for booking during purchase. */
  bookDuringPurchase: BookDuringPurchaseEnum;
  /** Settings for bulk discounts. */
  bulkDiscountOptions?: Maybe<BulkDiscountOptions>;
  /** Toggle for bulk discounts. */
  bulkDiscounts: Scalars['Boolean'];
  /** Media for the product page. */
  carouselMedia: Array<AttacheFile>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Any custom meta tags for the product page. */
  metaTags: Array<MetaTags>;
  /** The unit price of this product. */
  prices: Array<Price>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The SKU of the course. */
  sku?: Maybe<Scalars['String']>;
  /** Toggle for charging taxes. Ignored when Avatax integration is enabled. */
  taxesEnabled: Scalars['Boolean'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes for the default product settings for a course. */
export type ProductDefaultAttributes = {
  /** If a user can book while purchasing their course. */
  bookDuringPurchase?: InputMaybe<BookDuringPurchaseEnum>;
  /** Settings for bulk discounts. */
  bulkDiscountOptions?: InputMaybe<BulkDiscountOptionsAttributes>;
  /** Toggle for bulk discounts. */
  bulkDiscounts?: InputMaybe<Scalars['Boolean']>;
  /** Media for the product page carousel. */
  carouselMedia?: InputMaybe<Array<AttacheUploadFile>>;
  /** The id of the product default. Required to update. */
  id?: InputMaybe<Scalars['Int']>;
  /** Meta Tags for the product page. */
  metaTags?: InputMaybe<Array<MetaTagAttributes>>;
  /** Prices for this course. */
  prices?: InputMaybe<Array<PriceAttributes>>;
  /** The SKU of the course. */
  sku?: InputMaybe<Scalars['String']>;
  /** Toggle for charging taxes. Ignored when Avatax integration is enabled. */
  taxesEnabled?: InputMaybe<Scalars['Boolean']>;
};

/** Valid types for a product page version. */
export enum ProductPageVersionTypeEnum {
  /** Liquid Product Page. */
  Liquid = 'liquid',
  /** Original Product Page. */
  Original = 'original',
  /** Reduxed Product Page. */
  Reduxed = 'reduxed',
  /** Revised Product Page. */
  Revised = 'revised'
}

/** Permissions for a Product. */
export type ProductPermissions = {
  __typename?: 'ProductPermissions';
  /** Whether you can destroy this product. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this product. */
  update: Scalars['Boolean'];
};

/** Find products you can manage. */
export type ProductsNamespace = {
  __typename?: 'ProductsNamespace';
  /** Products you have direct access to. */
  all: Array<Product>;
  /** Show products available for sale on the current storefront */
  catalog: ProductCatalog;
  /** Find a single product by its string ID. */
  findByGid?: Maybe<Product>;
  /** Find a single product by its integer ID. */
  findById: Product;
  /** Find a single product by its signed ID. */
  findBySgid?: Maybe<Product>;
};


/** Find products you can manage. */
export type ProductsNamespaceAllArgs = {
  storefrontId?: InputMaybe<Scalars['Int']>;
};


/** Find products you can manage. */
export type ProductsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find products you can manage. */
export type ProductsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find products you can manage. */
export type ProductsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** An instance of a promotional code which belongs to a strefront. */
export type PromoCode = RelayNode & {
  __typename?: 'PromoCode';
  /** The code which is entered on checkout. */
  code: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** A description of the promotion's effect */
  description: Scalars['String'];
  /** The list of discounts that this promo code provides. */
  discounts: Array<PromoCodeDiscount>;
  /** An end time for the promo code to stop working. */
  endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The maximum number of times a customer is allowed to use this promo code. */
  maxUses?: Maybe<Scalars['Int']>;
  /** The notes for this promo code. */
  notes?: Maybe<Scalars['String']>;
  /** A persistent promo code applies to future purchases until it is manually removed. */
  persistent: Scalars['Boolean'];
  /** The number of seats or quantity that a customer can receive a discount on while using this promo code. The remaining quantity is full price. */
  quantityLimit?: Maybe<Scalars['Int']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** A promo code that can only be applied through SAML SSO. */
  ssoOnly: Scalars['Boolean'];
  /** A start time for the promo code to become active. */
  startsAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The storefront where this promotional code may be used. */
  storefront: Storefront;
  /** The type of promo code this is. */
  type: PromoCodeTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The discount amount */
  value: Scalars['Int'];
};

/** Attributes needed to update a promo code. */
export type PromoCodeAttributes = {
  /** The code that will be distributed and applied to get the discount. */
  code?: InputMaybe<Scalars['String']>;
  /** The discounts that will be applied when the promo code is used. */
  discounts?: InputMaybe<Array<PromoCodeDiscountAttributes>>;
  /** An end time for the promo code to stop working. */
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The maximum number of times a customer is allowed to use this promo code. */
  maxUses?: InputMaybe<Scalars['Int']>;
  /** Internal notes for managing promo codes. */
  notes?: InputMaybe<Scalars['String']>;
  /** A persistent promo code applies to future purchases until it is manually removed. */
  persistent?: InputMaybe<Scalars['Boolean']>;
  /** The number of seats or quantity that a customer can receive a discount on while using this promo code. The remaining quantity is full price. */
  quantityLimit?: InputMaybe<Scalars['Int']>;
  /** A promo code that can only be applied through SAML SSO. */
  ssoOnly?: InputMaybe<Scalars['Boolean']>;
  /** A start time for the promo code to become active. */
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** The promo code claim */
export type PromoCodeClaim = RelayNode & {
  __typename?: 'PromoCodeClaim';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for PromoCode. */
export type PromoCodeConnection = {
  __typename?: 'PromoCodeConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PromoCodeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PromoCode>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An individual discount on a promo code. */
export type PromoCodeDiscount = RelayNode & {
  __typename?: 'PromoCodeDiscount';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The products that the discount applies to. */
  products: Array<Product>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The type of promo code. */
  type: PromoCodeTypeEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The amount saved ($ or % depending on `type`). */
  value: Scalars['Int'];
};

/** Attributes needed to update or add a promo code discount. */
export type PromoCodeDiscountAttributes = {
  /** The ID of the promo code being updated */
  gid?: InputMaybe<Scalars['ID']>;
  /** The database id of the promo code being updated */
  id?: InputMaybe<Scalars['Int']>;
  /** The products that you want the discount to apply to. */
  productIds: Array<Scalars['ID']>;
  /** The type of promo code to create. */
  type: PromoCodeTypeEnum;
  /** The amount saved ($ or % depending on `type`). */
  value: Scalars['Int'];
};

/** An edge in a connection. */
export type PromoCodeEdge = {
  __typename?: 'PromoCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PromoCode>;
};

/** Valid types for promo code type. */
export enum PromoCodeTypeEnum {
  /** Amount off per unit */
  AmountPerUnitPromoCode = 'AmountPerUnitPromoCode',
  /** Percentage off entire line item */
  PercentPromoCode = 'PercentPromoCode'
}

/** An instance of use tied to a promotional code. */
export type PromoCodeUse = RelayNode & {
  __typename?: 'PromoCodeUse';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The order item related to this promotional code use. */
  orderItem?: Maybe<OrderItem>;
  /** The promo code this use is tied to */
  promoCode: PromoCode;
  /** The amount of savings on the order item granted by this promo code. */
  savings: Scalars['Float'];
  /** The amount of savings on the order item granted by this promo code. */
  savingsFormatted: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** An instance of use tied to a promotional code. */
export type PromoCodeUseSavingsFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PromoCodeUse. */
export type PromoCodeUseConnection = {
  __typename?: 'PromoCodeUseConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PromoCodeUseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PromoCodeUse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PromoCodeUseEdge = {
  __typename?: 'PromoCodeUseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PromoCodeUse>;
};

/** Access promo codes you can manage. */
export type PromoCodesNamespace = {
  __typename?: 'PromoCodesNamespace';
  /** All promo codes on storefronts you have access to. */
  all: PromoCodeConnection;
  /** Find a single promocode by its string ID. */
  findByGid?: Maybe<PromoCode>;
  /** Find a single promocode by its integer ID. */
  findById: PromoCode;
  /** Find a single promocode by its signed ID. */
  findBySgid?: Maybe<PromoCode>;
};


/** Access promo codes you can manage. */
export type PromoCodesNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  storefrontId: Scalars['ID'];
};


/** Access promo codes you can manage. */
export type PromoCodesNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Access promo codes you can manage. */
export type PromoCodesNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Access promo codes you can manage. */
export type PromoCodesNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** Root query entrypoint. */
export type Query = {
  __typename?: 'Query';
  /** Auth options and upload url for Attache files */
  attacheOptions?: Maybe<AttacheOptions>;
  /** Constants to use in automation workflows. */
  automationConstants?: Maybe<AutomationConstantsNamespace>;
  /** Scripts to automate your learner and storefront workflows. */
  automationScripts?: Maybe<AutomationScriptsNamespace>;
  /** Access you cart items. */
  cartItems?: Maybe<CartItemsNamespace>;
  /** Find any Certification Change Requests you can manage. */
  certificationChangeRequests?: Maybe<CertificationChangeRequestsNamespace>;
  /** Certification templates you've created. */
  certificationTemplates?: Maybe<CertificationTemplatesNamespace>;
  /** Find certifications you can manage. */
  certifications: CertificationsNamespace;
  /** Comments for things you can comment on. */
  comments?: Maybe<CommentsNamespace>;
  /** The list of countries and subregions. */
  countries?: Maybe<Array<Country>>;
  /** Learner completions you have access to. */
  courseCompletions?: Maybe<CourseProgressionConnection>;
  /** All course item progressions you have access to. */
  courseItemProgressions: CourseItemProgressionsNamespace;
  /** Find courses you can manage. */
  courses?: Maybe<CoursesNamespace>;
  /** The current storefront. */
  currentStorefront?: Maybe<Storefront>;
  /** The authenticated user */
  currentUser?: Maybe<User>;
  /** All the custom fields you have access to. */
  customFields: CustomFieldsNamespace;
  /** The dashboard namespace */
  dashboard?: Maybe<DashboardNamespace>;
  /** Discussion messages for things you can discuss. */
  discussionMessages?: Maybe<DiscussionMessagesNamespace>;
  /** Check if a feature is enable for you */
  featureEnabled: Scalars['Boolean'];
  /** The available fonts. */
  fonts?: Maybe<Array<Font>>;
  /** Assignment submissions you can grade. */
  gradedAssignmentSubmissions: GradedAssignmentSubmissionsNamespace;
  /** Graders you have access to. */
  graders?: Maybe<GradersNamespace>;
  /** Your grants. */
  grants?: Maybe<GrantsNamespace>;
  /** Instructor-led bookings you have access to. */
  ilBookings?: Maybe<IlBookingsNamespace>;
  /** Instructor-led classes you have access to. */
  ilClasses?: Maybe<IlClassesNamespace>;
  /** Instructor-led courses you have access to. */
  ilCourses?: Maybe<IlCoursesNamespace>;
  /** Instructor-led locations you have access to. */
  ilLocations?: Maybe<IlLocationsNamespace>;
  /** Instructors you have access to. */
  instructors?: Maybe<InstructorsNamespace>;
  /** Integrations you have access to. */
  integrations?: Maybe<IntegrationsNamespace>;
  /** Invites you have access to */
  invites?: Maybe<InvitesNamespace>;
  /** Access LearnerVerified related things. */
  learnerVerified?: Maybe<LearnerVerifiedNamespace>;
  /** Your learners. */
  learners?: Maybe<LearnersNamespace>;
  /** LicenseGroups you have access to. */
  licenseGroups?: Maybe<LicenseGroupsNamespace>;
  /** License pack uses you have access to. */
  licensePackUses?: Maybe<LicensePackUseConnection>;
  /** Licenses you have access to. */
  licenses?: Maybe<LicensesNamespace>;
  /** The supported locales for the platform. */
  locales?: Maybe<Array<Scalars['String']>>;
  /** The MFA methods for the current user */
  mfaMethods: Array<MfaMethod>;
  /** The MFA trusted devices for the current user */
  mfaTrustedDevices: Array<MfaTrustedDevice>;
  /** The minimum password complexity required for the platform. */
  minimumPasswordComplexity?: Maybe<Scalars['Int']>;
  /** The nito_banks namespace */
  nitoBanks?: Maybe<NitoBanksNamespace>;
  /** The nito_exams namespace */
  nitoExams?: Maybe<NitoExamsNamespace>;
  /** Fetches an object given its ID. */
  node?: Maybe<RelayNode>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<RelayNode>>;
  /** Your offline orders. */
  offlineOrders?: Maybe<OfflineOrdersNamespace>;
  /** An order on a storefront. */
  orders?: Maybe<OrdersNamespace>;
  /** Your organizations. */
  organizations?: Maybe<OrganizationsNamespace>;
  /** Find products you can manage. */
  products?: Maybe<ProductsNamespace>;
  /** Promotional code uses you have access to. */
  promoCodeUses?: Maybe<PromoCodeUseConnection>;
  /** Promo codes you have access to. */
  promoCodes?: Maybe<PromoCodesNamespace>;
  /** Provide support to a user by accessing all relevant and permitted data in one easy place. */
  provideSupport?: Maybe<SupportedUser>;
  /** The rapidql namespace */
  rapidql?: Maybe<RapidqlNamespace>;
  /** Report related data. */
  reports?: Maybe<ReportsNamespace>;
  /** Any reseller agreements you are a part of. */
  resellerAgreements?: Maybe<Array<ResellerAgreement>>;
  /** Sales report order items you have access to. */
  salesReportOrderItems?: Maybe<SalesReportOrderItemConnection>;
  /** Saved RapidQL queries */
  savedQueries?: Maybe<SavedQueriesNamespace>;
  /** Search for a user in your world */
  searchUsers?: Maybe<Array<User>>;
  /** Find shared products you can manage. */
  sharedProducts?: Maybe<SharedProductsNamespace>;
  /** A representation of shopping cart */
  shoppingCart?: Maybe<ShoppingCart>;
  /** The static paths for the current storefront */
  staticPaths: Array<StaticPath>;
  /** View all storefront templates */
  storefrontTemplates?: Maybe<StorefrontTemplatesNamespace>;
  /** Your storefronts. */
  storefronts?: Maybe<StorefrontsNamespace>;
  /** Stripe-managed plans for subscriptions. */
  stripePlans?: Maybe<StripePlansNamespace>;
  /** Stripe-managed products for subscriptions. */
  stripeProducts?: Maybe<StripeProductsNamespace>;
  /** Stripe-managed subscriptions */
  stripeSubscriptions?: Maybe<StripeSubscriptionsNamespace>;
  /** Access your surveys. */
  surveySchemas?: Maybe<SurveySchemasNamespace>;
  /** The taxes namespace */
  taxes?: Maybe<TaxesNamespace>;
  /** Names of the supported time zones. */
  timeZones?: Maybe<Array<Scalars['String']>>;
  /** Any platform usage details you have access to. */
  usage?: Maybe<PlatformUsageItemConnection>;
  /** Users you have access to. */
  users?: Maybe<UsersNamespace>;
  /** The authenticated user */
  viewer?: Maybe<User>;
};


/** Root query entrypoint. */
export type QueryCourseCompletionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  completedAfter?: InputMaybe<Scalars['Date']>;
  completedBefore?: InputMaybe<Scalars['Date']>;
  courses?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  learnerQuery?: InputMaybe<Scalars['String']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyCompleted?: InputMaybe<Scalars['Boolean']>;
  organizations?: InputMaybe<Array<Scalars['Int']>>;
};


/** Root query entrypoint. */
export type QueryFeatureEnabledArgs = {
  name: Scalars['String'];
};


/** Root query entrypoint. */
export type QueryLicensePackUsesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizations?: InputMaybe<Array<Scalars['Int']>>;
  priceLevel?: InputMaybe<Scalars['String']>;
  resellers?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['Date']>;
};


/** Root query entrypoint. */
export type QueryNodeArgs = {
  id: Scalars['ID'];
};


/** Root query entrypoint. */
export type QueryNodesArgs = {
  ids: Array<Scalars['ID']>;
};


/** Root query entrypoint. */
export type QueryPromoCodeUsesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  promoCodes?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['Date']>;
};


/** Root query entrypoint. */
export type QueryProvideSupportArgs = {
  id: Scalars['Int'];
};


/** Root query entrypoint. */
export type QuerySalesReportOrderItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  courses?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizations?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['Date']>;
  storefronts?: InputMaybe<Array<Scalars['Int']>>;
};


/** Root query entrypoint. */
export type QuerySearchUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


/** Root query entrypoint. */
export type QueryUsageArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  internal?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  organizations?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['Date']>;
  storefronts?: InputMaybe<Array<Scalars['Int']>>;
};

/** Find automation constants you can manage. */
export type RapidqlNamespace = {
  __typename?: 'RapidqlNamespace';
  /** Documentation for the provided tables. */
  documentation: Array<TableDocumentation>;
  /** The available tables in RapidQL. */
  tables: Array<Scalars['String']>;
  /** RapidQL views for the current user. */
  views: Array<View>;
};


/** Find automation constants you can manage. */
export type RapidqlNamespaceDocumentationArgs = {
  tables?: InputMaybe<Array<TableName>>;
};

/** A RapidQL saved report schedule */
export type RapidqlSchedule = RelayNode & {
  __typename?: 'RapidqlSchedule';
  /** Permissions on this schedule. */
  can: RapidqlSchedulePermission;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The week day or calendar day that schedule will run. */
  day: RapidqlScheduleDayEnum;
  /** Choose the first week day, last week day, or middle of the month schedule will run. */
  dayModifier: RapidqlScheduleDayModifierEnum;
  /** Whether the report will send if there are no results. */
  dontSendIfNoResults: Scalars['Boolean'];
  /** List of emails to send as bcc */
  emailBcc: Array<Scalars['String']>;
  /** List of emails to send as cc */
  emailCc: Array<Scalars['String']>;
  /** List of emails to send as addressee */
  emailTo: Array<Scalars['String']>;
  /** If the report is enabled */
  enabled: Scalars['Boolean'];
  /** The reports filter applied in schedulable */
  filters: Scalars['JSON'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** Hour that schedule will run */
  hourOfDay: Scalars['Int'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** How often the report will be sent. */
  interval: RapidqlScheduleIntervalEnum;
  /** The object the schedule was referenced */
  schedulable: SchedulableUnion;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Time zone that the report will run in. */
  timeZone: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Valid types for a RapidQL schedule day modifier. */
export enum RapidqlScheduleDayEnum {
  /** A RapidQL scheduled day for calendar_day. */
  CalendarDay = 'calendar_day',
  /** A RapidQL scheduled day for friday. */
  Friday = 'friday',
  /** A RapidQL scheduled day for monday. */
  Monday = 'monday',
  /** A RapidQL scheduled day for saturday. */
  Saturday = 'saturday',
  /** A RapidQL scheduled day for sunday. */
  Sunday = 'sunday',
  /** A RapidQL scheduled day for thursday. */
  Thursday = 'thursday',
  /** A RapidQL scheduled day for tuesday. */
  Tuesday = 'tuesday',
  /** A RapidQL scheduled day for wednesday. */
  Wednesday = 'wednesday'
}

/** Valid types for a RapidQL schedule day modifier. */
export enum RapidqlScheduleDayModifierEnum {
  /** First day */
  FirstDay = 'first_day',
  /** Last day */
  LastDay = 'last_day',
  /** 15th day of the month */
  Middle = 'middle'
}

/** Valid types for a rapidql schedule interval. */
export enum RapidqlScheduleIntervalEnum {
  /** A RapidQL schedule interval that is daily. */
  Daily = 'daily',
  /** A RapidQL schedule interval that is monthly. */
  Monthly = 'monthly',
  /** A RapidQL schedule interval that is weekly. */
  Weekly = 'weekly'
}

/** Permissions on this schedule. */
export type RapidqlSchedulePermission = {
  __typename?: 'RapidqlSchedulePermission';
  /** Whether you can destroy this schedule. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this schedule. */
  update: Scalars['Boolean'];
};

/** A calculable for a recurring flat fee contract. */
export type RecurringFlatFeeContract = ContractCalculable & RelayNode & {
  __typename?: 'RecurringFlatFeeContract';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Period of fee. */
  period: RecurringFlatFeePeriodEnum;
  /** Fee price. */
  price: Scalars['Float'];
  /** Fee price. */
  priceFormatted: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Type of contract, snake_case. */
  type: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A calculable for a recurring flat fee contract. */
export type RecurringFlatFeeContractPriceFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Valid period for recurring flat fee contracts. */
export enum RecurringFlatFeePeriodEnum {
  /** A period for a recurring flat fee that is Month. */
  Month = 'month',
  /** A period for a recurring flat fee that is Year. */
  Year = 'year'
}

/** A storefront redirect */
export type Redirect = RelayNode & {
  __typename?: 'Redirect';
  /** Any permissions you have relevant to the redirect. */
  can: RedirectPermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The URL that triggers the redirection. */
  redirectFrom: Scalars['String'];
  /** The destination of the redirection. */
  redirectTo: RedirectTo;
  /** The type of the object that the redirection points to. */
  redirectionType: Scalars['String'];
  /** The URL of the object that the redirection points to. */
  redirectionUrl: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Whether you have permission to perform certain actions on this redirect. */
export type RedirectPermissions = {
  __typename?: 'RedirectPermissions';
  /** Whether you can destroy this redirect. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this redirect. */
  update: Scalars['Boolean'];
};

/** A destination of a redirect. */
export type RedirectTo = DownloadableFile | Page | Product | ProductBundle | StaticPath;

/** Autogenerated input type of RefreshRapidql */
export type RefreshRapidqlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RefreshRapidql. */
export type RefreshRapidqlPayload = {
  __typename?: 'RefreshRapidqlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the refresh is queued. */
  ok: Scalars['Boolean'];
};

/** A refund associated with an order. */
export type Refund = RelayNode & {
  __typename?: 'Refund';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The reason this refund was issued. */
  reason: Scalars['String'];
  /** Line items of the refund each associated with a specific order item. */
  refundItems: Array<RefundItem>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The total value of this refund (including refunded tax). */
  total: Scalars['Float'];
  /** The total value of this refund (including refunded tax). */
  totalFormatted: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A refund associated with an order. */
export type RefundTotalFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Refund details associated with a specific order item. */
export type RefundItem = RelayNode & {
  __typename?: 'RefundItem';
  /** The amount refunded for this item. */
  amount: Scalars['Float'];
  /** The amount refunded for this item. */
  amountFormatted: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The order item associated with this portion of the refund. */
  orderItem: OrderItem;
  /** The quantity of items refunded. */
  quantity: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Refund details associated with a specific order item. */
export type RefundItemAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Attributes for a refund item. */
export type RefundItemAttributes = {
  /** The amount to refund. */
  amount: Scalars['Float'];
  /** The order item ID to refund. */
  orderItemId: Scalars['ID'];
  /** The quantity to refund. */
  quantity: Scalars['Int'];
};

/** Valid types for refund type. */
export enum RefundTypeEnum {
  /** Custom refund, it does not have refund items and it is not tied to order items. */
  Custom = 'custom',
  /** Regular refund, it has refund items tied to order items. */
  Regular = 'regular'
}

/** A record of submission of a completion to a regulator. */
export type RegulatorSubmission = RelayNode & {
  __typename?: 'RegulatorSubmission';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Any notes added. */
  notes?: Maybe<Scalars['String']>;
  /** The reference ID provided by the regulator. */
  regulatorReferenceId: Scalars['String'];
  /** The completion record for this submission. */
  regulatorSubmissionCompletion: RegulatorSubmissionCompletion;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the completion was submitted to the regulator. */
  submittedAt: Scalars['ISO8601DateTime'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A row for the Regulator Submission report. */
export type RegulatorSubmissionCompletion = RelayNode & {
  __typename?: 'RegulatorSubmissionCompletion';
  /** The Certification tied to this completion, if there is one. */
  certification?: Maybe<Certification>;
  /** The time this record was completed. */
  completedAt: Scalars['ISO8601DateTime'];
  /** The course this completion is for. */
  course: Course;
  /** The course progression record for this completion. */
  courseProgression: CourseProgression;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The grant record for this completion. */
  grant: Grant;
  /** The integer ID. */
  id: Scalars['Int'];
  /** The license number of the student if they have one. */
  licenseNumber?: Maybe<Scalars['String']>;
  /** The Organization this completion record is for. */
  organization: Organization;
  /** The record of submission, after it has been created. */
  regulatorSubmission?: Maybe<RegulatorSubmission>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The Storefront this completion record is for. */
  storefront?: Maybe<Storefront>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The learner who achieved this completion. */
  user: User;
};

/** The connection type for RegulatorSubmissionCompletion. */
export type RegulatorSubmissionCompletionConnection = {
  __typename?: 'RegulatorSubmissionCompletionConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RegulatorSubmissionCompletionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RegulatorSubmissionCompletion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RegulatorSubmissionCompletionEdge = {
  __typename?: 'RegulatorSubmissionCompletionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<RegulatorSubmissionCompletion>;
};

/** An object with an ID. */
export type RelayNode = {
  /** ID of the object. */
  gid: Scalars['ID'];
};

/** Autogenerated input type of RemoveCourseFromStorefront */
export type RemoveCourseFromStorefrontInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of course to remove. */
  courseId: Scalars['ID'];
  /** The ID of the storefront the course will be removed from. */
  storefrontId: Scalars['ID'];
};

/** Autogenerated return type of RemoveCourseFromStorefront. */
export type RemoveCourseFromStorefrontPayload = {
  __typename?: 'RemoveCourseFromStorefrontPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course that was added. */
  course: Course;
  /** Any validation errors. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of RemoveCustomFieldCourseRequirement */
export type RemoveCustomFieldCourseRequirementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of custom_field_course_requirement to remove. */
  customFieldCourseRequirementId: Scalars['ID'];
};

/** Autogenerated return type of RemoveCustomFieldCourseRequirement. */
export type RemoveCustomFieldCourseRequirementPayload = {
  __typename?: 'RemoveCustomFieldCourseRequirementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course being affected. */
  course: Course;
  /** Any validation errors. */
  errors: Array<ValidationError>;
};

/** Attributes needed to reorder instructor-led course items. */
export type ReorderIlCourseItem = {
  /** The ID of the instructor-led course item. */
  id: Scalars['Int'];
};

/** Autogenerated input type of ReorderILCourseItems */
export type ReorderIlCourseItemsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The instructor-led course which the item will belong to. */
  ilCourseId: Scalars['ID'];
  /** The instructor-led course items. */
  ilCourseItems: Array<ReorderIlCourseItem>;
};

/** Autogenerated return type of ReorderILCourseItems. */
export type ReorderIlCourseItemsPayload = {
  __typename?: 'ReorderILCourseItemsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The reordered instructor-led course items. */
  ilCourseItems: Array<IlCourseItem>;
};

/** Report IDs */
export type ReportDashboard = {
  __typename?: 'ReportDashboard';
  /** Saved Report ID to use for active learners */
  activeLearnersReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for certifications */
  certificationsReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for completed courses */
  completedCoursesReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for expiring certifications */
  expiringCertificationsReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for incomplete courses */
  incompleteCoursesReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for learner training */
  learnerTrainingReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for learners pending signup */
  learnersPendingSignupReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for learners with outstanding training */
  learnersWithOutstandingTrainingReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for new learners. */
  newLearnersReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for new training managers. */
  newTrainingManagersReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for pending invites */
  pendingInvitesReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for week's revenue. */
  thisWeekRevenueReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for today's revenue. */
  todayRevenueReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for the total of training managers. */
  totalTrainingManagersReportId?: Maybe<Scalars['Int']>;
  /** Saved Report ID to use for yesterday's revenue. */
  yesterdayRevenueReportId?: Maybe<Scalars['Int']>;
};

/** Run built-in reports. */
export type ReportsNamespace = {
  __typename?: 'ReportsNamespace';
  /** Items for the Regulator Submission report. */
  regulatorSubmissionReport?: Maybe<RegulatorSubmissionCompletionConnection>;
  /** Items for the sales report. */
  salesReport?: Maybe<LitSalesReportOrderItemConnection>;
};


/** Run built-in reports. */
export type ReportsNamespaceRegulatorSubmissionReportArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  completedAfter?: InputMaybe<Scalars['Date']>;
  completedBefore?: InputMaybe<Scalars['Date']>;
  courses?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  includeSubmitted?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  learnerQuery?: InputMaybe<Scalars['String']>;
  learnerQueryLimit?: InputMaybe<Scalars['Int']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  regulatorReferenceId?: InputMaybe<Scalars['String']>;
  submittedAfter?: InputMaybe<Scalars['Date']>;
  submittedBefore?: InputMaybe<Scalars['Date']>;
};


/** Run built-in reports. */
export type ReportsNamespaceSalesReportArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  courses?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate?: InputMaybe<Scalars['Date']>;
  storefrontIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated input type of RequestPasswordReset */
export type RequestPasswordResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Context to use */
  context?: PasswordResetContextEnum;
  /** User email or mobile number */
  login: Scalars['String'];
};

/** Autogenerated return type of RequestPasswordReset. */
export type RequestPasswordResetPayload = {
  __typename?: 'RequestPasswordResetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the password reset request was handled. */
  ok: Scalars['Boolean'];
};

/** Autogenerated input type of RequestVerifiedCredentialPresentation */
export type RequestVerifiedCredentialPresentationInput = {
  /** The certification to push automatically when the credential is verified. */
  certificationId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The verified credential issuer to request the presentation through. */
  verifiedCredentialIssuerId: Scalars['ID'];
};

/** Autogenerated return type of RequestVerifiedCredentialPresentation. */
export type RequestVerifiedCredentialPresentationPayload = {
  __typename?: 'RequestVerifiedCredentialPresentationPayload';
  /** A URL to allow deep-linkining into a wallet application. */
  appUrl?: Maybe<Scalars['String']>;
  /** Channel data for Ably subscriptions. */
  channelData: ChannelData;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The URL to render the QR code. */
  url?: Maybe<Scalars['String']>;
};

/** A reseller agreement, allowing certain reseller actions. */
export type ResellerAgreement = RelayNode & {
  __typename?: 'ResellerAgreement';
  /** The courses which come from this reseller agreement. */
  courses: Array<Course>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Key used to create licenses from this agreement. */
  licenseKey: Scalars['String'];
  /** The organization which owns the courses the reseller is gaining access to. */
  organization: Organization;
  /** The reseller organization gaining access to the courses. */
  reseller: Organization;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of ResendConfirmationCode */
export type ResendConfirmationCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The integer ID of the contact method. */
  id: Scalars['Int'];
};

/** Autogenerated return type of ResendConfirmationCode. */
export type ResendConfirmationCodePayload = {
  __typename?: 'ResendConfirmationCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the code was successfully resent. */
  ok: Scalars['Boolean'];
};

/** Autogenerated input type of ResendInstructorInvitation */
export type ResendInstructorInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Instructor email. */
  email: Scalars['String'];
  /** The ID for the instructor that will be updated. */
  instructorId: Scalars['ID'];
};

/** Autogenerated return type of ResendInstructorInvitation. */
export type ResendInstructorInvitationPayload = {
  __typename?: 'ResendInstructorInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The updated instructor. */
  instructor?: Maybe<Instructor>;
};

/** Autogenerated input type of ResendInvite */
export type ResendInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the invite to resend. */
  inviteId: Scalars['ID'];
};

/** Autogenerated return type of ResendInvite. */
export type ResendInvitePayload = {
  __typename?: 'ResendInvitePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The invite */
  invite: Invite;
};

/** A link to an online course resource. */
export type ResourceLink = RelayNode & {
  __typename?: 'ResourceLink';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The display name of the link. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The URL of the resource. */
  url: Scalars['String'];
};

/** Settings for a resource link */
export type ResourceLinkAttributes = {
  /** The display name of the link. */
  name: Scalars['String'];
  /** The URL of the resource. */
  url: Scalars['String'];
};

/** Autogenerated input type of RestoreNode */
export type RestoreNodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the node to restore. */
  id: Scalars['ID'];
};

/** Autogenerated return type of RestoreNode. */
export type RestoreNodePayload = {
  __typename?: 'RestoreNodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The node, null if not restored. */
  node?: Maybe<SoftDestroyable>;
  /** Whether the record was restored or not. Some require you to use specialized mutations. */
  ok: Scalars['Boolean'];
};

/** Base interface for revenues */
export type Revenue = {
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
};


/** Base interface for revenues */
export type RevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of ReviewCourseItemProgression */
export type ReviewCourseItemProgressionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of item to review. */
  itemId: Scalars['ID'];
};

/** Autogenerated return type of ReviewCourseItemProgression. */
export type ReviewCourseItemProgressionPayload = {
  __typename?: 'ReviewCourseItemProgressionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The typed course item to run. */
  item: CourseItemProgression;
  /** Any launch information. */
  review: LaunchInformation;
};

/** Autogenerated input type of ReviewLearnerVerifiedSessions */
export type ReviewLearnerVerifiedSessionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the verifiable (usually a Grant) to review the LearnerVerified sessions for. */
  verifiableId: Scalars['ID'];
};

/** Autogenerated return type of ReviewLearnerVerifiedSessions. */
export type ReviewLearnerVerifiedSessionsPayload = {
  __typename?: 'ReviewLearnerVerifiedSessionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The URL to open or display with an iframe. */
  url?: Maybe<Scalars['String']>;
};

/** Valid audiences used for Saved Queries. */
export enum ReviewableGrantsFilterEnum {
  /** Load only grants needing a review. */
  Pending = 'pending',
  /** Load only grants that have been passed automatically by LearnerVerified. */
  ReviewNotRequired = 'review_not_required',
  /** Load only grants that have been already reviewed */
  Reviewed = 'reviewed'
}

/** A rule on a Nito exam form. */
export type Rule = RelayNode & {
  __typename?: 'Rule';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The name of the exam form this rule is on. */
  formName: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The number of items this rule will select. */
  numberOfItems: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of RunCourseItemProgression */
export type RunCourseItemProgressionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of item to run. */
  itemId: Scalars['ID'];
};

/** Autogenerated return type of RunCourseItemProgression. */
export type RunCourseItemProgressionPayload = {
  __typename?: 'RunCourseItemProgressionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The typed course item to run. */
  item: CourseItemProgression;
  /** Any launch information. */
  launch: LaunchInformation;
};

/** A SAML provider. */
export type SamlProvider = RelayNode & {
  __typename?: 'SAMLProvider';
  /** The Assertion Consumer Service URL of the SAML provider. */
  acsUrl: Scalars['String'];
  /** The automation mapping of the SAML provider. */
  automationMapping?: Maybe<Scalars['String']>;
  /** Any permissions you have relevant to the SAML Provider. */
  can: SamlProviderPermissions;
  /** The cert fingerprint of the SAML provider. */
  certFingerprint: Scalars['String'];
  /** The cert fingerprint algorithm of the SAML provider. */
  certFingerprintAlgorithm: SamlProviderEncryptionAlgorithmsTypeEnum;
  /** Whether to confirm email during signup. */
  confirmEmailDuringSignup: Scalars['Boolean'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The email mapping of the SAML provider. */
  emailMapping?: Maybe<Scalars['String']>;
  /** The first name mapping of the SAML provider. */
  firstNameMapping: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The issuer URL of the SAML provider. */
  issuerUrl?: Maybe<Scalars['String']>;
  /** The last name mapping of the SAML provider. */
  lastNameMapping: Scalars['String'];
  /** The name of the SAML provider. */
  name: Scalars['String'];
  /** The promo codes mapping of the SAML provider. */
  promoCodesMapping?: Maybe<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The SLO target URL of the SAML provider. */
  sloTargetUrl?: Maybe<Scalars['String']>;
  /** The Single Logout URL of the SAML provider. */
  sloUrl: Scalars['String'];
  /** The target URL of the SAML provider. */
  targetUrl: Scalars['String'];
  /** Whether to trigger IDP logout. */
  triggerIdpLogout: Scalars['Boolean'];
  /** The UID mapping of the SAML provider. */
  uidMapping?: Maybe<Scalars['String']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Valid algorithms to encrypt cert fingerprints. */
export enum SamlProviderEncryptionAlgorithmsTypeEnum {
  /** sha1 encryption algorithm. */
  Sha1 = 'sha1',
  /** sha256 encryption algorithm. */
  Sha256 = 'sha256',
  /** sha384 encryption algorithm. */
  Sha384 = 'sha384',
  /** sha512 encryption algorithm. */
  Sha512 = 'sha512'
}

/** Permissions for a SAML Provider. */
export type SamlProviderPermissions = {
  __typename?: 'SAMLProviderPermissions';
  /** Whether you can destroy this SAML provider. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this SAML provider. */
  update: Scalars['Boolean'];
};

/** An instance of a Sales report order item. */
export type SalesReportOrderItem = RelayNode & {
  __typename?: 'SalesReportOrderItem';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The description of the line item */
  lineItem: Scalars['String'];
  /** The order ID related to this order item. */
  orderId: Scalars['Int'];
  /** The stripe transaction ID for this order item */
  orderStripeChargeId?: Maybe<Scalars['String']>;
  /** The quantity. */
  quantity: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The storefront this order item was on. */
  storefrontName: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for SalesReportOrderItem. */
export type SalesReportOrderItemConnection = {
  __typename?: 'SalesReportOrderItemConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SalesReportOrderItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SalesReportOrderItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SalesReportOrderItemEdge = {
  __typename?: 'SalesReportOrderItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SalesReportOrderItem>;
};

/** Find saved queries you can manage. */
export type SavedQueriesNamespace = {
  __typename?: 'SavedQueriesNamespace';
  /** All saved queries you have access to. */
  all: SavedQueryConnection;
  /** Find a single savedquery by its string ID. */
  findByGid?: Maybe<SavedQuery>;
  /** Find a single savedquery by its integer ID. */
  findById: SavedQuery;
  /** Find a single savedquery by its signed ID. */
  findBySgid?: Maybe<SavedQuery>;
};


/** Find saved queries you can manage. */
export type SavedQueriesNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  audience: AudienceEnum;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Find saved queries you can manage. */
export type SavedQueriesNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find saved queries you can manage. */
export type SavedQueriesNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find saved queries you can manage. */
export type SavedQueriesNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** A saved RapidQL query. */
export type SavedQuery = RelayNode & {
  __typename?: 'SavedQuery';
  /** The audience of the query. */
  audience: AudienceEnum;
  /** Any permissions you have relevant to this saved query. */
  can: SavedQueryPermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The description of this query. */
  description?: Maybe<Scalars['String']>;
  /** The filters on this saved query. */
  filters: Array<SavedQueryFilter>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the saved query, to help differentiate it from other saved queries. */
  name: Scalars['String'];
  /** The owner of this saved query. */
  owner: Owner;
  /** Whether the query has pagination */
  pagination?: Maybe<Scalars['Boolean']>;
  /** The RapidQL query code. */
  query: Scalars['String'];
  /** The schedules of this saved query */
  rapidqlSchedules: Array<RapidqlSchedule>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Whether the query is provided by the system or a custom query. */
  system: Scalars['Boolean'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for SavedQuery. */
export type SavedQueryConnection = {
  __typename?: 'SavedQueryConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SavedQueryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SavedQuery>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SavedQueryEdge = {
  __typename?: 'SavedQueryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SavedQuery>;
};

/** A filter on a SavedQuery */
export type SavedQueryFilter = {
  __typename?: 'SavedQueryFilter';
  /** The value used in the query to reference this filter. */
  key: Scalars['String'];
  /** The display name of this filter. */
  label: Scalars['String'];
  /** Whether this filter input runs using a selected time zone. */
  local: Scalars['Boolean'];
  /** Whether this filter input allows multiple values or not. */
  multiple: Scalars['Boolean'];
  /** If this is a filter of type select, the query to run to generate values. */
  query?: Maybe<Scalars['String']>;
  /** Whether this filter is optional or not. */
  required: Scalars['Boolean'];
  /** The ID of the SavedQuery this filter belongs to. */
  savedQueryId?: Maybe<Scalars['ID']>;
  /** The type of this filter. */
  type: SavedQueryFilterTypeEnum;
};

/** Types of filters on a SavedQuery. */
export enum SavedQueryFilterTypeEnum {
  /** A date filter. */
  Date = 'date',
  /** A email filter. */
  Email = 'email',
  /** A number filter. */
  Number = 'number',
  /** A select filter. */
  Select = 'select',
  /** A text filter. */
  Text = 'text'
}

/** Permissions on this saved query. */
export type SavedQueryPermissions = {
  __typename?: 'SavedQueryPermissions';
  /** Whether you can destroy this saved query. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this saved query. */
  update: Scalars['Boolean'];
};

/** A union type representing the types that can be schedulables. */
export type SchedulableUnion = SavedQuery;

/** A representation of the SCORM progress information sent back to the LMS from the SCORM engine. */
export type Scorm = {
  __typename?: 'Scorm';
  /** The interactions for this SCORM module */
  interactions: Array<ScormInteraction>;
  /** Whether this SCORM module is passed or not. */
  passed?: Maybe<Scalars['Boolean']>;
  /** When the registration was created in the SCORM engine. */
  registeredAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The score received in this SCORM module. */
  score?: Maybe<Scalars['Float']>;
  /** The total number of seconds spent in this SCORM module. */
  totalSeconds?: Maybe<Scalars['Int']>;
};

/** A calculable for a scorm course rate contract. */
export type ScormCourseRateContract = ContractCalculable & RelayNode & {
  __typename?: 'ScormCourseRateContract';
  /** Name of the course as it appears on SCORM Cloud. */
  courseTitle: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Name of the organization as it appears on SCORM Cloud. */
  destinationName: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Rate price. */
  rate: Scalars['Float'];
  /** Rate price. */
  rateFormatted: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Type of contract, snake_case. */
  type: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A calculable for a scorm course rate contract. */
export type ScormCourseRateContractRateFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** A representation of the SCORM interaction information sent back to the LMS from the SCORM engine. */
export type ScormInteraction = {
  __typename?: 'ScormInteraction';
  /** An array of the correct responses. */
  correctResponses: Array<Scalars['String']>;
  /** The description of the question for this interaction */
  description?: Maybe<Scalars['String']>;
  /** The time it took the user to complete this interaction */
  latency?: Maybe<Scalars['String']>;
  /** The learners response in this interaction */
  learnerResponse?: Maybe<Scalars['String']>;
  /** The outcome of the learners response compared to the correct response */
  result: Scalars['String'];
  /** When the interaction occured. */
  timestamp: Scalars['ISO8601DateTime'];
  /** The typing of the question. */
  type: Scalars['String'];
};

/** Values to customize the Selling dashboard. */
export type SellingDashboard = {
  __typename?: 'SellingDashboard';
  /** URLs to the FAQ. */
  faqs?: Maybe<Array<DashboardFaq>>;
  /** URL to the knowledge base. */
  knowledgeBaseUrl?: Maybe<Scalars['String']>;
  /** Number of new learners in the previous 7 days. */
  newLearners: Scalars['Int'];
  /** Number of new training managers in the previous 7 days. */
  newTrainingManagers: Scalars['Int'];
  /** URL to submit a bug. */
  submitBugUrl?: Maybe<Scalars['String']>;
  /** Gross revenue of orders performed this week. */
  thisWeekAmount: Scalars['Float'];
  /** Gross revenue of orders performed this week. */
  thisWeekAmountFormatted: Scalars['String'];
  /** Gross revenue of orders performed today. */
  todayAmount: Scalars['Float'];
  /** Gross revenue of orders performed today. */
  todayAmountFormatted: Scalars['String'];
  /** Total of training managers. */
  totalTrainingManagers: Scalars['Int'];
  /** Gross revenue of orders performed yesterday. */
  yesterdayAmount: Scalars['Float'];
  /** Gross revenue of orders performed yesterday. */
  yesterdayAmountFormatted: Scalars['String'];
};


/** Values to customize the Selling dashboard. */
export type SellingDashboardThisWeekAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Values to customize the Selling dashboard. */
export type SellingDashboardTodayAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Values to customize the Selling dashboard. */
export type SellingDashboardYesterdayAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of SendReportNow */
export type SendReportNowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the RapidQL schedule to send. */
  rapidqlScheduleId: Scalars['ID'];
};

/** Autogenerated return type of SendReportNow. */
export type SendReportNowPayload = {
  __typename?: 'SendReportNowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the ScheduleReport is queued. Always true. */
  ok: Scalars['Boolean'];
};

/** An email the platform has sent. */
export type SentEmail = RelayNode & {
  __typename?: 'SentEmail';
  /** The body contents of this email. */
  body?: Maybe<Scalars['String']>;
  /** Any permissions that may be relevant to this sent email. */
  can: SentEmailPermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** When the last status update to the email was. */
  emailStatusAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The address this email was sent from. */
  from: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The status of this email */
  status: Scalars['String'];
  /** The subject of the sent email. */
  subject: Scalars['String'];
  /** The addresses this email was sent to. */
  to: Array<Scalars['String']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for SentEmail. */
export type SentEmailConnection = {
  __typename?: 'SentEmailConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SentEmailEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SentEmail>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SentEmailEdge = {
  __typename?: 'SentEmailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SentEmail>;
};

/** Permissions the current user has on a SentEmail. */
export type SentEmailPermissions = {
  __typename?: 'SentEmailPermissions';
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether the current user can view the contents of the email. */
  show: Scalars['Boolean'];
};

/** Autogenerated input type of ShareLearners */
export type ShareLearnersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The IDs of the learners to share. */
  learnerIds: Array<Scalars['ID']>;
  /** The IDs of the organizations to share the learners with. */
  organizationIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of ShareLearners. */
export type ShareLearnersPayload = {
  __typename?: 'ShareLearnersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The shared learners. */
  learners?: Maybe<Array<Learner>>;
};

/** Attributes needed to share a license. */
export type ShareLicenseAttributes = {
  /** The ID of the organization to share the license to. */
  ownerId: Scalars['ID'];
  /** The number of seats to share of this license. */
  seats?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of ShareLicense */
export type ShareLicenseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the license to update. */
  licenseId: Scalars['ID'];
  /** Attributes needed to change a license ownership. */
  patch: ShareLicenseAttributes;
};

/** Autogenerated return type of ShareLicense. */
export type ShareLicensePayload = {
  __typename?: 'ShareLicensePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The original license that was provided for sharing with updated seats. */
  originalLicense?: Maybe<License>;
  /** The license that was shared. */
  sharedLicense?: Maybe<License>;
};

/** A shared product. */
export type SharedProduct = RelayNode & {
  __typename?: 'SharedProduct';
  /** Settings for bulk discounts. */
  bulkDiscountOptions?: Maybe<BulkDiscountOptions>;
  /** Toggle for bulk discounts. */
  bulkDiscounts: Scalars['Boolean'];
  /** Any permissions you have relevant to the Shared Product. */
  can: SharedProductPermissions;
  /** Media for the shared product page. */
  carouselMedia: Array<AttacheFile>;
  /** The categories of this shared product. */
  categories: Array<Scalars['String']>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The description of this shared product. */
  description?: Maybe<Scalars['String']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of this shared product. */
  name: Scalars['String'];
  /** The owner of the shared product. */
  owner?: Maybe<Owner>;
  /** The photo of this shared product. */
  photo?: Maybe<AttacheFile>;
  /** The unit price of this shared product. */
  prices: Array<Price>;
  /** The products that are based on this shared product. */
  products: Array<Product>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The short description of this shared product. */
  shortDescription?: Maybe<Scalars['String']>;
  /** The SKU of this shared product. */
  sku?: Maybe<Scalars['String']>;
  /** The storefronts that have this shared product. */
  storefronts: Array<Storefront>;
  /** A summary of the shared product, for the reduxed product page. */
  summary?: Maybe<Scalars['String']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A shared product. */
export type SharedProductPhotoArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};

/** Attributes for a shared product. */
export type SharedProductAttributes = {
  /** Settings for bulk discounts. */
  bulkDiscountOptions?: InputMaybe<BulkDiscountOptionsAttributes>;
  /** Whether the shared product has bulk discounts. */
  bulkDiscounts?: InputMaybe<Scalars['Boolean']>;
  /** Media for the shared product page carousel. */
  carouselMedia?: InputMaybe<Array<AttacheUploadFile>>;
  /** The categories this shared product is in. */
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** The description of the shared product. */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the shared product. */
  name: Scalars['String'];
  /** The owner of the shared product. */
  ownerId: Scalars['ID'];
  /** The feature image for this shared product. */
  photo?: InputMaybe<AttacheUploadFile>;
  /** The price of the shared product. */
  prices: Array<PriceAttributes>;
  /** The short description of the shared product. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** The SKU of the shared product. */
  sku?: InputMaybe<Scalars['String']>;
  /** Storefronts that will sell this shared product. */
  storefrontIds?: InputMaybe<Array<Scalars['ID']>>;
  /** A text summary of the shared product. */
  summary?: InputMaybe<Scalars['String']>;
};

/** The connection type for SharedProduct. */
export type SharedProductConnection = {
  __typename?: 'SharedProductConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SharedProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SharedProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SharedProductEdge = {
  __typename?: 'SharedProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SharedProduct>;
};

/** Permissions for a Shared Product. */
export type SharedProductPermissions = {
  __typename?: 'SharedProductPermissions';
  /** Whether you can create a shared product. */
  create: Scalars['Boolean'];
  /** Whether you can destroy this shared product. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this shared product. */
  update: Scalars['Boolean'];
};

/** Find shared products you can manage. */
export type SharedProductsNamespace = {
  __typename?: 'SharedProductsNamespace';
  /** Shared products you have direct access to. */
  all: SharedProductConnection;
  /** Find a single sharedproduct by its string ID. */
  findByGid?: Maybe<SharedProduct>;
  /** Find a single sharedproduct by its integer ID. */
  findById: SharedProduct;
  /** Find a single sharedproduct by its signed ID. */
  findBySgid?: Maybe<SharedProduct>;
};


/** Find shared products you can manage. */
export type SharedProductsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Find shared products you can manage. */
export type SharedProductsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find shared products you can manage. */
export type SharedProductsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find shared products you can manage. */
export type SharedProductsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** Shipping information from an order. */
export type ShippingInformation = RelayNode & {
  __typename?: 'ShippingInformation';
  /** The company name to put on the package. */
  companyName?: Maybe<Scalars['String']>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The email address to notify about shipping details. */
  email: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name to put on the package. */
  name: Scalars['String'];
  /** The phone number to notify about shipping logistics. */
  phoneNumber: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A shipping item for an order. */
export type ShippingItem = RelayNode & {
  __typename?: 'ShippingItem';
  /** The amount of the shipping item. */
  amount: Scalars['Float'];
  /** The amount of the shipping item. */
  amountFormatted: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The kind of shipping item. */
  kind: Scalars['String'];
  /** The name of the shipping item. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Taxes for this order. */
  taxItems: Array<TaxItem>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A shipping item for an order. */
export type ShippingItemAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The representation of ShoppingCart */
export type ShoppingCart = {
  __typename?: 'ShoppingCart';
  /** Billing address */
  billingAddress?: Maybe<Address>;
  /** Cart Item list */
  cartItems: Array<CartItem>;
  /** Expected shipping */
  expectedShipping: Scalars['Float'];
  /** Expected shipping */
  expectedShippingFormatted: Scalars['String'];
  /** Expected subtotal */
  expectedSubtotal: Scalars['Float'];
  /** Expected subtotal */
  expectedSubtotalFormatted: Scalars['String'];
  /** Expected total */
  expectedTax: Scalars['Float'];
  /** Expected total */
  expectedTaxFormatted: Scalars['String'];
  /** Expected total */
  expectedTotal: Scalars['Float'];
  /** Expected total cents */
  expectedTotalCents: Scalars['Int'];
  /** Expected total */
  expectedTotalFormatted: Scalars['String'];
  /** Whether this requires shipping */
  requiresShipping: Scalars['Boolean'];
  /** Shipping address */
  shippingAddress?: Maybe<Address>;
  /** The Shipping Information */
  shippingInformation?: Maybe<ShoppingCartShippingInformation>;
  /** The Storefront the this cart belongs to */
  storefront: Storefront;
  /** Taxes */
  taxes: Array<TaxItemBase>;
  /** The integer ID. */
  userId: Scalars['Int'];
};


/** The representation of ShoppingCart */
export type ShoppingCartExpectedShippingFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** The representation of ShoppingCart */
export type ShoppingCartExpectedSubtotalFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** The representation of ShoppingCart */
export type ShoppingCartExpectedTaxFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** The representation of ShoppingCart */
export type ShoppingCartExpectedTotalFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Shipping information from an shopping cart. */
export type ShoppingCartShippingInformation = RelayNode & {
  __typename?: 'ShoppingCartShippingInformation';
  /** The company name to put on the package. */
  companyName?: Maybe<Scalars['String']>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The email address to notify about shipping details. */
  email: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name to put on the package. */
  name: Scalars['String'];
  /** The phone number to notify about shipping logistics. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of SignIn */
export type SignInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** User email or mobile number */
  login: Scalars['String'];
  /** User password */
  password: Scalars['String'];
};

/** Autogenerated return type of SignIn. */
export type SignInPayload = {
  __typename?: 'SignInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The JWT, null if the authentication failed. */
  token?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SignOut */
export type SignOutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the user to sign out. */
  id: Scalars['Int'];
};

/** Autogenerated return type of SignOut. */
export type SignOutPayload = {
  __typename?: 'SignOutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The URL to redirect to when we are signed out. */
  redirectTo: Scalars['String'];
  /** Successfully signed out? */
  success: Scalars['Boolean'];
};

/** Attributes to create a user on the platform */
export type SignUpAttributes = {
  /** User first name */
  firstName: Scalars['String'];
  /** User last name */
  lastName: Scalars['String'];
  /** User language preference */
  locale?: InputMaybe<Scalars['String']>;
  /** User email or mobile number */
  login: Scalars['String'];
  /** User password */
  password: Scalars['String'];
  /** User timezone */
  timeZone?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of SignUp */
export type SignUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The user to sign up. */
  user: SignUpAttributes;
};

/** Autogenerated return type of SignUp. */
export type SignUpPayload = {
  __typename?: 'SignUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The signed up user. */
  user?: Maybe<User>;
};

/** An address that is not in the platform's database. */
export type SimpleAddress = {
  __typename?: 'SimpleAddress';
  /** First line of the address. */
  address1?: Maybe<Scalars['String']>;
  /** Second line of the address. */
  address2?: Maybe<Scalars['String']>;
  /** The city. */
  city?: Maybe<Scalars['String']>;
  /** The country. */
  country?: Maybe<Scalars['String']>;
  /** The postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** The province. */
  province?: Maybe<Scalars['String']>;
};

/** Common fields for a soft-destroyable record. */
export type SoftDestroyable = {
  /** When this record was destroyed. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of StartCourse */
export type StartCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The int ID of Grant to start. */
  grantId: Scalars['Int'];
};

/** Autogenerated return type of StartCourse. */
export type StartCoursePayload = {
  __typename?: 'StartCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The CourseProgression for the Grant. */
  courseProgression: CourseProgression;
  /** The Grant you're starting. */
  grant: Grant;
};

/** A static path. */
export type StaticPath = RelayNode & {
  __typename?: 'StaticPath';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The helper of the static path. */
  helper: Scalars['String'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The path of the static path. */
  path: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of StopSellingCourse */
export type StopSellingCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of course to remove. */
  courseId: Scalars['ID'];
};

/** Autogenerated return type of StopSellingCourse. */
export type StopSellingCoursePayload = {
  __typename?: 'StopSellingCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course that was removed from sale. */
  course: Course;
  /** Any validation errors. */
  errors: Array<ValidationError>;
};

/** A storefront that sells training. */
export type Storefront = Ownable & RelayNode & {
  __typename?: 'Storefront';
  /** The contracts related with this storefront. */
  activeContracts: Array<Contract>;
  /** The storefront mailing address. */
  address: Address;
  /** Whether address fields are present on signup. */
  addressOnSignup: Scalars['Boolean'];
  /** Whether address is required for this storefront. */
  addressRequired: Scalars['Boolean'];
  /** Whether to allow MFA trusted devices on this storefront. */
  allowMfaTrustedDevices: Scalars['Boolean'];
  /** Whether to allow platform analytics on this storefront. */
  analyticsOptIn: Scalars['Boolean'];
  /** The GST/HST number for this storefront. */
  businessNumber?: Maybe<Scalars['String']>;
  /** Any permissions you have relevant to the Storefront. */
  can: StorefrontPermissions;
  /** The contact method on signup for this storefront. */
  contactMethodOnSignup?: Maybe<ContactMethodOnSignUpTypeEnum>;
  /** The contracts related with this storefront. */
  contracts: Array<Contract>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The currency this storefront operates in. */
  currency: Currency;
  /** Storefront domains. */
  customDomains: Array<CustomDomain>;
  /** A list of custom fields for this storefront. */
  customFields: Array<CustomField>;
  /** The description of this storefront. */
  description?: Maybe<Scalars['String']>;
  /** The domain this storefront is accessed from. */
  domain: Scalars['String'];
  /** The downloadable files for this storefront. */
  downloadableFiles: Array<DownloadableFile>;
  /** The contact email for this storefront. */
  email?: Maybe<Scalars['String']>;
  /** The email logo for this storefront. */
  emailLogo?: Maybe<AttacheFile>;
  /** The Facebook profile of this storefront. */
  facebook?: Maybe<Scalars['String']>;
  /** The favicon for this storefront. */
  favicon?: Maybe<AttacheFile>;
  /** The favicon path for this storefront. */
  faviconPath?: Maybe<Scalars['String']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The Google Adsense ID for this storefront. */
  googleAdsenseId?: Maybe<Scalars['String']>;
  /** The Google Analytics tracking ID for this storefront. */
  googleAnalyticsTrackingId?: Maybe<Scalars['String']>;
  /** The Google Webmaster Tools Site Verification ID for this storefront. */
  googleSiteVerificationId?: Maybe<Scalars['String']>;
  /** The Google Tag Manager ID for this storefront. */
  googleTagManagerId?: Maybe<Scalars['String']>;
  /** Whether the storefront has any stripe plans you can subscribe to */
  hasSubscriptions: Scalars['Boolean'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Ledger notes from the financial team. */
  ledgerNotes?: Maybe<Scalars['String']>;
  /** Whether the storefront has been reviewed by the financial team. */
  ledgerReviewed?: Maybe<Scalars['Boolean']>;
  /** The locale this storefront operates in. */
  locale: Scalars['String'];
  /** The logo url for this storefront. */
  logoUrl?: Maybe<Scalars['String']>;
  /** The menu items for this storefront. */
  menuItems: Array<MenuItem>;
  /** The name of this storefront. */
  name: Scalars['String'];
  /** The users who receive order notifications for this storefront. */
  orderNotificationSubscribers: Array<User>;
  /** The orders for this storefront. */
  orders: OrderConnection;
  /** The owner of the record. */
  owner: Owner;
  /** The version of the page header for this storefront. */
  pageHeaderVersion: PageHeaderVersionTypeEnum;
  /** The pages for this storefront. */
  pages: Array<Page>;
  /** The contact phone number for this storefront. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** The logo for this storefront. */
  photo?: Maybe<AttacheFile>;
  /** The version of the product page for this storefront. */
  productPageVersion: ProductPageVersionTypeEnum;
  /** The redirects for this storefront. */
  redirects: Array<Redirect>;
  /** Storefront revenue for a month / year */
  revenues?: Maybe<StorefrontRevenues>;
  /** The sector for this storefront. */
  sector: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Whether Single Sign-On is required for this storefront. */
  ssoOnly: Scalars['Boolean'];
  /** The stripe publishable key for this Storefront */
  stripePublishableKey: Scalars['String'];
  /** The subdomain this storefront is accessed from. */
  subdomain: Scalars['String'];
  /** The tag fields for this storefront. */
  tagFields: Array<TagField>;
  /** The themes for this storefront. */
  themes: Array<Theme>;
  /** The menu items with no parent for this storefront. */
  topLevelMenuItems: Array<MenuItem>;
  /** The X profile of this storefront. */
  twitter?: Maybe<Scalars['String']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The full URL this storefront is accessed from. */
  url: Scalars['String'];
  /** The YouTube channel of this storefront. */
  youtube?: Maybe<Scalars['String']>;
};


/** A storefront that sells training. */
export type StorefrontActiveContractsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A storefront that sells training. */
export type StorefrontEmailLogoArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};


/** A storefront that sells training. */
export type StorefrontFaviconArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};


/** A storefront that sells training. */
export type StorefrontOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A storefront that sells training. */
export type StorefrontPhotoArgs = {
  geometry?: InputMaybe<Scalars['String']>;
};


/** A storefront that sells training. */
export type StorefrontRevenuesArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A storefront that sells training. */
export type StorefrontTagFieldsArgs = {
  scope?: InputMaybe<TagFieldScopeEnum>;
};

/** Course Distribution Fees. */
export type StorefrontCourseDistributionRevenue = Revenue & {
  __typename?: 'StorefrontCourseDistributionRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The contract revenue records contributing to this revenue */
  records: ContractRevenueConnection;
};


/** Course Distribution Fees. */
export type StorefrontCourseDistributionRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Course Distribution Fees. */
export type StorefrontCourseDistributionRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Federal tax revenue */
export type StorefrontFederalTaxRevenue = Revenue & {
  __typename?: 'StorefrontFederalTaxRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The tax records contributing to this revenue */
  records: LedgerTaxRecordConnection;
};


/** Federal tax revenue */
export type StorefrontFederalTaxRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Federal tax revenue */
export type StorefrontFederalTaxRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Instructor-led training revenue */
export type StorefrontIlTrainingRevenue = Revenue & {
  __typename?: 'StorefrontILTrainingRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The order item records contributing to this revenue */
  records: LedgerOrderItemRecordConnection;
};


/** Instructor-led training revenue */
export type StorefrontIlTrainingRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Instructor-led training revenue */
export type StorefrontIlTrainingRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Online training revenue */
export type StorefrontOnlineTrainingRevenue = Revenue & {
  __typename?: 'StorefrontOnlineTrainingRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The order item records contributing to this revenue */
  records: LedgerOrderItemRecordConnection;
};


/** Online training revenue */
export type StorefrontOnlineTrainingRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Online training revenue */
export type StorefrontOnlineTrainingRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Permissions for a Storefront. */
export type StorefrontPermissions = {
  __typename?: 'StorefrontPermissions';
  /** Whether you can create custom fields for this storefront. */
  createCustomFields: Scalars['Boolean'];
  /** Whether the storefront is allowed to create orders. */
  createOrder: Scalars['Boolean'];
  /** Whether you can create pages for this storefront. */
  createPages: Scalars['Boolean'];
  /** Whether you can create products for this storefront. */
  createProducts: Scalars['Boolean'];
  /** Whether you can create redirects for this storefront. */
  createRedirects: Scalars['Boolean'];
  /** Whether you can create themes for this storefront. */
  createThemes: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can access update things on this storefront. */
  update: Scalars['Boolean'];
  /** Whether you can upload files to this storefront. */
  uploadFiles: Scalars['Boolean'];
};

/** Physical product revenue */
export type StorefrontPhysicalProductRevenue = Revenue & {
  __typename?: 'StorefrontPhysicalProductRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The order item records contributing to this revenue */
  records: LedgerOrderItemRecordConnection;
};


/** Physical product revenue */
export type StorefrontPhysicalProductRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Physical product revenue */
export type StorefrontPhysicalProductRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Set-up fee revenue. */
export type StorefrontPlatformSetupRevenue = Revenue & {
  __typename?: 'StorefrontPlatformSetupRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The contract revenue records contributing to this revenue */
  records: ContractRevenueConnection;
};


/** Set-up fee revenue. */
export type StorefrontPlatformSetupRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Set-up fee revenue. */
export type StorefrontPlatformSetupRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Promo code savings product revenue */
export type StorefrontPromoCodeSavingRevenue = Revenue & {
  __typename?: 'StorefrontPromoCodeSavingRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The order item records contributing to this revenue */
  records: LedgerOrderItemRecordConnection;
};


/** Promo code savings product revenue */
export type StorefrontPromoCodeSavingRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Promo code savings product revenue */
export type StorefrontPromoCodeSavingRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Provincial tax revenue */
export type StorefrontProvincialTaxRevenue = Revenue & {
  __typename?: 'StorefrontProvincialTaxRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The tax records contributing to this revenue */
  records: LedgerTaxRecordConnection;
};


/** Provincial tax revenue */
export type StorefrontProvincialTaxRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Provincial tax revenue */
export type StorefrontProvincialTaxRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Recurring flat fee revenue. */
export type StorefrontRecurringFlatFeeRevenue = Revenue & {
  __typename?: 'StorefrontRecurringFlatFeeRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The contract revenue records contributing to this revenue */
  records: ContractRevenueConnection;
};


/** Recurring flat fee revenue. */
export type StorefrontRecurringFlatFeeRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Recurring flat fee revenue. */
export type StorefrontRecurringFlatFeeRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The revenue from refunds. */
export type StorefrontRefundRevenue = Revenue & {
  __typename?: 'StorefrontRefundRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The refund records contributing to this revenue */
  records: LedgerRefundRecordConnection;
};


/** The revenue from refunds. */
export type StorefrontRefundRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** The revenue from refunds. */
export type StorefrontRefundRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The revenue for a storefront in a period */
export type StorefrontRevenues = {
  __typename?: 'StorefrontRevenues';
  /** Course distribution revenue for this period. */
  courseDistribution: StorefrontCourseDistributionRevenue;
  /** Period end date */
  endPeriod: Scalars['ISO8601Date'];
  /** Federal tax revenue for this period. */
  federalTaxes: StorefrontFederalTaxRevenue;
  /** ILT revenue for this period. */
  ilTraining: StorefrontIlTrainingRevenue;
  /** Online training revenue for this period. */
  onlineTraining: StorefrontOnlineTrainingRevenue;
  /** Physical product revenue for this period. */
  physicalProduct: StorefrontPhysicalProductRevenue;
  /** Recurring flat fee revenue for this period. */
  platformLicenses: StorefrontRecurringFlatFeeRevenue;
  /** Physical product revenue for this period. */
  platformSetup: StorefrontPlatformSetupRevenue;
  /** Promo code savings revenue for this period. */
  promoCodeSaving: StorefrontPromoCodeSavingRevenue;
  /** Provincial tax revenue for this period. */
  provincialTaxes: StorefrontProvincialTaxRevenue;
  /** Revenue from refunds performed on this period. */
  refunds: StorefrontRefundRevenue;
  /** Shipping revenue for this period. */
  shipping: StorefrontShippingRevenue;
  /** Period start date */
  startPeriod: Scalars['ISO8601Date'];
  /** Subscriptions revenue for this period. */
  subscription: StorefrontSubscriptionRevenue;
  /** Third party payouts revenue. */
  thirdPartyPayout: StorefrontThirdPartyPayoutRevenue;
  /** Transaction fee revenue for this period. */
  transactionFees: StorefrontTransactionFeesRevenue;
};

/** Valid sectors for a storefront. */
export enum StorefrontSectorsEnum {
  /** A storefront sector that is Aviation. */
  Aviation = 'aviation',
  /** A storefront sector that is Cannabis and alcohol. */
  CannabisAndAlcohol = 'cannabis_and_alcohol',
  /** A storefront sector that is Demo. */
  Demo = 'demo',
  /** A storefront sector that is Finance and insurance. */
  FinanceAndInsurance = 'finance_and_insurance',
  /** A storefront sector that is Platform partnership. */
  PlatformPartnership = 'platform_partnership',
  /** A storefront sector that is Real estate and mortgage. */
  RealEstateAndMortgage = 'real_estate_and_mortgage',
  /** A storefront sector that is Retail and hospitality. */
  RetailAndHospitality = 'retail_and_hospitality',
  /** A storefront sector that is Safety and security. */
  SafetyAndSecurity = 'safety_and_security',
  /** A storefront sector that is Sandbox. */
  Sandbox = 'sandbox',
  /** A storefront sector that is Unknown. */
  Unknown = 'unknown',
  /** A storefront sector that is Wkt. */
  Wkt = 'wkt'
}

/** Shipping revenue */
export type StorefrontShippingRevenue = Revenue & {
  __typename?: 'StorefrontShippingRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The order item records contributing to this revenue */
  records: LedgerOrderItemRecordConnection;
};


/** Shipping revenue */
export type StorefrontShippingRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Shipping revenue */
export type StorefrontShippingRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Subscriptions revenue. */
export type StorefrontSubscriptionRevenue = Revenue & {
  __typename?: 'StorefrontSubscriptionRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The contract revenue records contributing to this revenue */
  records: StripeInvoicePaymentConnection;
};


/** Subscriptions revenue. */
export type StorefrontSubscriptionRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Subscriptions revenue. */
export type StorefrontSubscriptionRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A storefront template is a pre-designed and themed template that can be applied to a storefront. */
export type StorefrontTemplate = RelayNode & {
  __typename?: 'StorefrontTemplate';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The page(s) of the template constructed in YAML. */
  dataYaml: Scalars['String'];
  /** The description of the template. */
  description?: Maybe<Scalars['String']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the template. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The CSS styling of the template. */
  theme: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Access storefront templates */
export type StorefrontTemplatesNamespace = {
  __typename?: 'StorefrontTemplatesNamespace';
  /** View all storefront templates. */
  all: Array<StorefrontTemplate>;
};

/** Third party payouts revenue. */
export type StorefrontThirdPartyPayoutRevenue = Revenue & {
  __typename?: 'StorefrontThirdPartyPayoutRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The payout records */
  records: PayoutConnection;
};


/** Third party payouts revenue. */
export type StorefrontThirdPartyPayoutRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Third party payouts revenue. */
export type StorefrontThirdPartyPayoutRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Transaction Fees. */
export type StorefrontTransactionFeesRevenue = Revenue & {
  __typename?: 'StorefrontTransactionFeesRevenue';
  /** Amount of revenue for this period */
  amount: Scalars['Float'];
  /** Amount of revenue for this period */
  amountFormatted: Scalars['String'];
  /** Number of items considered to calculate this revenue. */
  count: Scalars['Int'];
  /** The contract revenue records contributing to this revenue */
  records: ContractRevenueConnection;
};


/** Transaction Fees. */
export type StorefrontTransactionFeesRevenueAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Transaction Fees. */
export type StorefrontTransactionFeesRevenueRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Access your storefronts. */
export type StorefrontsNamespace = {
  __typename?: 'StorefrontsNamespace';
  /** Get all your storefronts. */
  all: Array<Storefront>;
  /** Find a single storefront by its string ID. */
  findByGid?: Maybe<Storefront>;
  /** Find a single storefront by its integer ID. */
  findById: Storefront;
  /** Find a single storefront by its signed ID. */
  findBySgid?: Maybe<Storefront>;
};


/** Access your storefronts. */
export type StorefrontsNamespaceAllArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  courseId?: InputMaybe<Scalars['ID']>;
  currency?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<StorefrontSectorsEnum>;
  showAll?: InputMaybe<Scalars['Boolean']>;
};


/** Access your storefronts. */
export type StorefrontsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Access your storefronts. */
export type StorefrontsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Access your storefronts. */
export type StorefrontsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** Generic data relating to a Stripe payment method (a credit card in our case). */
export type StripeBillingDetails = {
  __typename?: 'StripeBillingDetails';
  /** The address associated with the credit card. */
  address?: Maybe<SimpleAddress>;
  /** The customer's name (as it appears on the credit card). */
  name?: Maybe<Scalars['String']>;
};

/** Details about the credit card used for payments through Stripe. */
export type StripeCreditCard = {
  __typename?: 'StripeCreditCard';
  /** The brand. */
  brand: StripeCreditCardBrandEnum;
  /** The expiration month. */
  expMonth: Scalars['Int'];
  /** The expiration year. */
  expYear: Scalars['Int'];
  /** The last four digits of the credit card number. */
  last4: Scalars['Int'];
};

/** Credit Card brands supported by Stripe. */
export enum StripeCreditCardBrandEnum {
  /** American Express */
  Amex = 'amex',
  /** Diners Club International */
  Diners = 'diners',
  /** Discover */
  Discover = 'discover',
  /** Japan Credit Bureau */
  Jcb = 'jcb',
  /** Mastercard */
  Mastercard = 'mastercard',
  /** UnionPay International (China) */
  Unionpay = 'unionpay',
  /** Unknown credit card brand */
  Unknown = 'unknown',
  /** Visa */
  Visa = 'visa'
}

/** A customer in Stripe that can have subscriptions. */
export type StripeCustomer = RelayNode & {
  __typename?: 'StripeCustomer';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The user record that this customer is for. */
  owner: User;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The Stripe ID for the customer. */
  stripeCustomerId: Scalars['String'];
  /** All the subscriptions this customer has. */
  stripeSubscriptions: Array<StripeSubscription>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A Stripe invoice payment for a subscription. */
export type StripeInvoicePayment = RelayNode & {
  __typename?: 'StripeInvoicePayment';
  /** Amount paid. */
  amountPaid: Scalars['Float'];
  /** Amount paid. */
  amountPaidFormatted: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Stripe internal charge id. */
  stripeChargeId?: Maybe<Scalars['String']>;
  /** Stripe internal invoice id. */
  stripeInvoiceId: Scalars['String'];
  /** Stripe Subscription that this invoice belongs. */
  stripeSubscription: StripeSubscription;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A Stripe invoice payment for a subscription. */
export type StripeInvoicePaymentAmountPaidFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for StripeInvoicePayment. */
export type StripeInvoicePaymentConnection = {
  __typename?: 'StripeInvoicePaymentConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StripeInvoicePaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<StripeInvoicePayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type StripeInvoicePaymentEdge = {
  __typename?: 'StripeInvoicePaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<StripeInvoicePayment>;
};

/** A partial representation of the Stripe API PaymentMethod object. */
export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  /** The name, address, and other generic data. */
  billingDetails?: Maybe<StripeBillingDetails>;
  /** The credit card being used. */
  card?: Maybe<StripeCreditCard>;
};

/** A pricing plan in Stripe for a product. */
export type StripePlan = RelayNode & {
  __typename?: 'StripePlan';
  /** Whether this plan is active or not. */
  active: Scalars['Boolean'];
  /** The method to aggregate usage when usage_type=metered */
  aggregateUsage?: Maybe<StripePlanAggregateUsageEnum>;
  /** The amount this plan is for. */
  amount?: Maybe<Scalars['Float']>;
  /** The amount this plan is for. */
  amountFormatted?: Maybe<Scalars['String']>;
  /** The name of this plan. */
  confirmation: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The currency this plan is using. */
  currency: Currency;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The billing interval this plan has. */
  interval: StripePlanIntervalEnum;
  /** The number of intervals that makes up a billing period. */
  intervalCount: Scalars['Int'];
  /** The name of this plan. */
  name: Scalars['String'];
  /** The owner of this Plan. */
  organization: Owner;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The SKU for this plan. */
  sku: Scalars['String'];
  /** The Stripe ID for this plan. */
  stripePlanId: Scalars['String'];
  /** The Stripe product this plan is for. */
  stripeProduct: StripeProduct;
  /** The tiers for this plan, if there are any. */
  tiers: Array<StripePlanTier>;
  /** The tiering mode when usage_type=metered, if tiers are used. */
  tiersMode?: Maybe<StripePlanTiersModeEnum>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The usage type for this plan. */
  usageType: StripePlanUsageTypeEnum;
};


/** A pricing plan in Stripe for a product. */
export type StripePlanAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The supported ways to aggregate usage for a Stripe Plan. */
export enum StripePlanAggregateUsageEnum {
  /** Sum up usage */
  Total = 'total'
}

/** The connection type for StripePlan. */
export type StripePlanConnection = {
  __typename?: 'StripePlanConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StripePlanEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<StripePlan>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type StripePlanEdge = {
  __typename?: 'StripePlanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<StripePlan>;
};

/** The supported intervals for Stripe subscription billing. */
export enum StripePlanIntervalEnum {
  /** Daily billing */
  Day = 'day',
  /** Monthly billing */
  Month = 'month',
  /** Weekly billing */
  Week = 'week',
  /** Yearly billing */
  Year = 'year'
}

/** A tier on a Stripe plan */
export type StripePlanTier = {
  __typename?: 'StripePlanTier';
  /** The flat amount for this tier. */
  flatAmount?: Maybe<Scalars['Float']>;
  /** The flat amount for this tier. */
  flatAmountFormatted?: Maybe<Scalars['String']>;
  /** The per-unit amount for this tier. */
  unitAmount?: Maybe<Scalars['Float']>;
  /** The per-unit amount for this tier. */
  unitAmountFormatted?: Maybe<Scalars['String']>;
  /** The max usage for this tier before advancing to the next tier. */
  upTo?: Maybe<Scalars['Int']>;
};


/** A tier on a Stripe plan */
export type StripePlanTierFlatAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** A tier on a Stripe plan */
export type StripePlanTierUnitAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The various methods for tiering Stripe plans. */
export enum StripePlanTiersModeEnum {
  /** Use different tiers as usage increases. */
  Graduated = 'graduated',
  /** Use the interval volume to select a tier. */
  Volume = 'volume'
}

/** The supported usage types for Stripe Plans. */
export enum StripePlanUsageTypeEnum {
  /** Flat billing */
  Licensed = 'licensed',
  /** Usage-based billing */
  Metered = 'metered'
}

/** Find Stripe plans for your organizations. */
export type StripePlansNamespace = {
  __typename?: 'StripePlansNamespace';
  /** All Stripe plans for your organizations. */
  all: StripePlanConnection;
  /** Find a single stripeplan by its string ID. */
  findByGid?: Maybe<StripePlan>;
  /** Find a single stripeplan by its integer ID. */
  findById: StripePlan;
  /** Find a single stripeplan by its signed ID. */
  findBySgid?: Maybe<StripePlan>;
};


/** Find Stripe plans for your organizations. */
export type StripePlansNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Find Stripe plans for your organizations. */
export type StripePlansNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find Stripe plans for your organizations. */
export type StripePlansNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find Stripe plans for your organizations. */
export type StripePlansNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** A product in Stripe that you can have pricing plans and subscriptions for. */
export type StripeProduct = RelayNode & {
  __typename?: 'StripeProduct';
  /** Whether this product is active or not. */
  active: Scalars['Boolean'];
  /** The courses this product will provide access to. */
  courses: Array<Course>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The currency this product is using. */
  currency: Currency;
  /** The description of this product. */
  description: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of this product. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The pricing plans for this product. */
  stripePlans?: Maybe<Array<StripePlan>>;
  /** The Stripe ID for this product. */
  stripeProductId?: Maybe<Scalars['String']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for StripeProduct. */
export type StripeProductConnection = {
  __typename?: 'StripeProductConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StripeProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<StripeProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type StripeProductEdge = {
  __typename?: 'StripeProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<StripeProduct>;
};

/** Find Stripe products for your organizations. */
export type StripeProductsNamespace = {
  __typename?: 'StripeProductsNamespace';
  /** All Stripe products for your organizations. */
  all: StripeProductConnection;
  /** Find a single stripeproduct by its string ID. */
  findByGid?: Maybe<StripeProduct>;
  /** Find a single stripeproduct by its integer ID. */
  findById: StripeProduct;
  /** Find a single stripeproduct by its signed ID. */
  findBySgid?: Maybe<StripeProduct>;
};


/** Find Stripe products for your organizations. */
export type StripeProductsNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Find Stripe products for your organizations. */
export type StripeProductsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find Stripe products for your organizations. */
export type StripeProductsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find Stripe products for your organizations. */
export type StripeProductsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};

/** A Stripe refund for an object, that can be an Order or a Stripe Subscription. */
export type StripeRefund = RelayNode & {
  __typename?: 'StripeRefund';
  /** The refunded amount. */
  amount: Scalars['Float'];
  /** The refunded amount. */
  amountFormatted: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The refund object. */
  refund?: Maybe<Refund>;
  /** The object that was refunded. */
  refundable: StripeRefundRefundable;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Stripe internal charge id. */
  stripeChargeId: Scalars['String'];
  /** Stripe internal refund id. */
  stripeRefundId: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A Stripe refund for an object, that can be an Order or a Stripe Subscription. */
export type StripeRefundAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** An object that has been refunded. */
export type StripeRefundRefundable = Order | StripeSubscription;

/** A subscription in Stripe to a plan/product. */
export type StripeSubscription = RelayNode & StripeSubscriptionInterface & {
  __typename?: 'StripeSubscription';
  /** Whether the subscription is paid for continuous access to content. */
  accessControlled: Scalars['Boolean'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Any paths for this subscription. */
  paths: StripeSubscriptionPaths;
  /** The number of seconds until the subscription will go into delinquency and be unusable. Is null while payment is in good standing. */
  secondsRemainingInArrears?: Maybe<Scalars['Int']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The status of the stripe subscription. */
  status: StripeSubscriptionStatusEnum;
  /** The Stripe customer. */
  stripeCustomer: StripeCustomer;
  /** The Stripe payment method which will be charged every billing period. */
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  /** The Stripe plan. */
  stripePlan: StripePlan;
  /** The Stripe ID for this subscription. */
  stripeSubscriptionId: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Whether the subscription is paid depending on usage during the time period. */
  usageControlled: Scalars['Boolean'];
};

/** Something that is backed by a `StripeSubscription` record. */
export type StripeSubscriptionInterface = {
  /** Whether the subscription is paid for continuous access to content. */
  accessControlled: Scalars['Boolean'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Any paths for this subscription. */
  paths: StripeSubscriptionPaths;
  /** The number of seconds until the subscription will go into delinquency and be unusable. Is null while payment is in good standing. */
  secondsRemainingInArrears?: Maybe<Scalars['Int']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The status of the stripe subscription. */
  status: StripeSubscriptionStatusEnum;
  /** The Stripe customer. */
  stripeCustomer: StripeCustomer;
  /** The Stripe payment method which will be charged every billing period. */
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  /** The Stripe plan. */
  stripePlan: StripePlan;
  /** The Stripe ID for this subscription. */
  stripeSubscriptionId: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Whether the subscription is paid depending on usage during the time period. */
  usageControlled: Scalars['Boolean'];
};

/** Paths on this subscription. */
export type StripeSubscriptionPaths = {
  __typename?: 'StripeSubscriptionPaths';
  /** Path to begin updating the subscription's payment method through Stripe. */
  editPaymentMethod: Scalars['String'];
  /** The ID of the record these paths are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these paths are for. */
  id: Scalars['Int'];
};

/** Valid types for a Stripe subscription status. */
export enum StripeSubscriptionStatusEnum {
  /** A Stripe subscription that is active. */
  Active = 'active',
  /** A Stripe subscription that is in payment arrears. */
  Arrears = 'arrears',
  /** A Stripe subscription that is cancel_at_period_end. */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** A Stripe subscription that is cancelled. */
  Cancelled = 'cancelled',
  /** A Stripe subscription that is in payment delinquency. */
  Delinquent = 'delinquent'
}

/** Find any Stripe-managed Subscriptions. */
export type StripeSubscriptionsNamespace = {
  __typename?: 'StripeSubscriptionsNamespace';
  /** Find a single stripesubscription by its string ID. */
  findByGid?: Maybe<StripeSubscription>;
  /** Find a single stripesubscription by its integer ID. */
  findById: StripeSubscription;
  /** Find a single stripesubscription by its signed ID. */
  findBySgid?: Maybe<StripeSubscription>;
  /** All of your Subscriptions. */
  mine: Array<StripeSubscriptionInterface>;
};


/** Find any Stripe-managed Subscriptions. */
export type StripeSubscriptionsNamespaceFindByGidArgs = {
  id: Scalars['ID'];
};


/** Find any Stripe-managed Subscriptions. */
export type StripeSubscriptionsNamespaceFindByIdArgs = {
  id: Scalars['Int'];
};


/** Find any Stripe-managed Subscriptions. */
export type StripeSubscriptionsNamespaceFindBySgidArgs = {
  id: Scalars['ID'];
};


/** Find any Stripe-managed Subscriptions. */
export type StripeSubscriptionsNamespaceMineArgs = {
  includeCancelled?: InputMaybe<Scalars['Boolean']>;
};

/** A calculable for a stripe transaction fee contract. */
export type StripeTransactionFeeContract = ContractCalculable & RelayNode & {
  __typename?: 'StripeTransactionFeeContract';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Fee related to the transaction. */
  transactionFee: Scalars['Float'];
  /** Type of contract, snake_case. */
  type: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of SubmitGradedAssignment */
export type SubmitGradedAssignmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The course item progression this submission belongs to. */
  courseItemProgressionId: Scalars['ID'];
  /** Attributes needed to submit an assignment. */
  gradedAssignmentSubmission: GradedAssignmentSubmissionAttributes;
};

/** Autogenerated return type of SubmitGradedAssignment. */
export type SubmitGradedAssignmentPayload = {
  __typename?: 'SubmitGradedAssignmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The new graded assignment submission. */
  gradedAssignmentSubmission?: Maybe<GradedAssignmentSubmission>;
};

/** A Course when providing support to a user. */
export type SupportCourse = RelayNode & {
  __typename?: 'SupportCourse';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the course. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The SKU for this course if configured. */
  sku?: Maybe<Scalars['String']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A representation of an items progress a supported user makes through a course. */
export type SupportCourseItemProgression = RelayNode & {
  __typename?: 'SupportCourseItemProgression';
  /** Whether the item has been completed. */
  completed: Scalars['Boolean'];
  /** When the item was completed. */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The settings for this assignment (graded assignment course items only). */
  gradedAssignmentSettings?: Maybe<GradedAssignmentSettings>;
  /** The submissions for this assignment (graded assignment course items only). */
  gradedAssignmentSubmissions: Array<GradedAssignmentSubmission>;
  /** The integer ID. */
  id: Scalars['Int'];
  /** The booking for for this progression. */
  ilBooking?: Maybe<IlBooking>;
  /** The most recent submission for this assignment (graded assignment course items only). */
  latestGradedAssignmentSubmission?: Maybe<GradedAssignmentSubmission>;
  /** The name of this item. */
  name: Scalars['String'];
  /** The progress of this item. */
  progress: Scalars['Float'];
  /** The score received for this item from the SCORM module, graded assignment, or exam, if available. */
  score?: Maybe<Scalars['Float']>;
  /** The SCORM data from the last course item. */
  scorm?: Maybe<Scorm>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the item was started. */
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The status for this item. */
  status: Scalars['String'];
  /** The file type for this item. */
  type: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A representation of the progress a supported user makes through a course. */
export type SupportCourseProgression = RelayNode & {
  __typename?: 'SupportCourseProgression';
  /** When the course was completed. */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The items available for this course. */
  courseItemProgressions: Array<SupportCourseItemProgression>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** When the course was failed, if applicable. */
  failedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** How much progress has been made on this progression. */
  percentComplete: Scalars['Float'];
  /** The score of this progression (from the last SCORM item, graded assignment, or exam), if available. */
  score?: Maybe<Scalars['Float']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the course was started. */
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The status of this progression. */
  status: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A Grant a supported user has. */
export type SupportGrant = RelayNode & {
  __typename?: 'SupportGrant';
  /** Any permissions you have relevant to this grant. */
  can: GrantPermissions;
  /** The progression for this Grant. */
  courseProgression?: Maybe<SupportCourseProgression>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The License this Grant is from. */
  license: SupportLicense;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Whether the grant is not_started, in_progress, or completed. */
  status: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for SupportGrant. */
export type SupportGrantConnection = {
  __typename?: 'SupportGrantConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SupportGrantEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SupportGrant>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SupportGrantEdge = {
  __typename?: 'SupportGrantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SupportGrant>;
};

/** A License a supported user has. */
export type SupportLicense = RelayNode & {
  __typename?: 'SupportLicense';
  /** The number of available seats the license has, or null if an open license. */
  availableSeats?: Maybe<Scalars['Int']>;
  /** Any permissions you have relevant to the license. */
  can: LicensePermissions;
  /** The Course this License is for. */
  course: SupportCourse;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Any enrolment keys on this license. */
  enrolmentKeys: EnrolmentKeyConnection;
  /** When this license expires. */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The number of granted seats the license has. */
  grantedSeats: Scalars['Int'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The number of pending invitations to the license. */
  invitedSeats: Scalars['Int'];
  /** Whether the license is open or not. */
  isOpen: Scalars['Boolean'];
  /** The number of seats the license has, or null if it's an open license. */
  seats?: Maybe<Scalars['Int']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The number of use seats the license has. */
  usedSeats: Scalars['Int'];
  /** Any license usage details. */
  uses: Array<LicenseUse>;
  /** Any LearnerVerified services enabled on the license. */
  verificationServices: Scalars['String'];
};


/** A License a supported user has. */
export type SupportLicenseEnrolmentKeysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for SupportLicense. */
export type SupportLicenseConnection = {
  __typename?: 'SupportLicenseConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SupportLicenseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SupportLicense>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SupportLicenseEdge = {
  __typename?: 'SupportLicenseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SupportLicense>;
};

/** A user you are supporting. */
export type SupportedUser = RelayNode & {
  __typename?: 'SupportedUser';
  /** The user's primary address */
  address?: Maybe<Address>;
  /** The gravatar url for this user. */
  avatarUrl: Scalars['String'];
  /** Any permissions you have relevant to the Supported User. */
  can: SupportedUserPermissions;
  /** The Certifications the user has. */
  certifications: CertificationConnection;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The last time the user signed in. */
  currentSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** All custom fields for a user within the current storefront */
  customValues: Array<CustomValue>;
  /** The email address of the User. */
  email?: Maybe<Scalars['String']>;
  /** The first name of the User. */
  firstName: Scalars['String'];
  /** The full name (first name + last name) of the User. */
  fullName: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The Grants the user has. */
  grants: SupportGrantConnection;
  /** The integer ID. */
  id: Scalars['Int'];
  /** The Invites the user has. */
  invites: InviteConnection;
  /** The last name of the User. */
  lastName: Scalars['String'];
  /** The storefront that the user last viewed */
  lastViewedStorefront?: Maybe<Storefront>;
  /** The Learners the user has. */
  learners: Array<Learner>;
  /** The Licenses the user has. */
  licenses: SupportLicenseConnection;
  /** The desired language for User. */
  locale: Scalars['String'];
  /** The mobile number of the User. */
  mobileNumber?: Maybe<Scalars['String']>;
  /** The supported users desired method of notificaiton. */
  notificationType: NotificationTypeEnum;
  /** The Orders the user has. */
  orders: OrderConnection;
  /** Emails sent to this user. */
  sentEmails: SentEmailConnection;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The storefront that the user is registered at */
  storefrontRegisteredAt?: Maybe<Storefront>;
  /** The time zone of the User. */
  timeZone: Scalars['TimeZone'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The browser user agent used last. */
  userAgent?: Maybe<UserAgent>;
};


/** A user you are supporting. */
export type SupportedUserAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


/** A user you are supporting. */
export type SupportedUserCertificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A user you are supporting. */
export type SupportedUserGrantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A user you are supporting. */
export type SupportedUserInvitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A user you are supporting. */
export type SupportedUserLicensesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A user you are supporting. */
export type SupportedUserOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A user you are supporting. */
export type SupportedUserSentEmailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Permissions for a Supported User. */
export type SupportedUserPermissions = {
  __typename?: 'SupportedUserPermissions';
  /** Whether the current user can create an offline order for this user. */
  createOfflineOrder: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether the current user can impersonate this user. */
  impersonate: Scalars['Boolean'];
  /** Whether the current user can merge this user with others. */
  merge: Scalars['Boolean'];
  /** Whether the current user can reset the password for this user. */
  sendResetPasswordInstructions: Scalars['Boolean'];
  /** Whether the current user can update this user. */
  update: Scalars['Boolean'];
};

/** A completed survey result. */
export type SurveyResult = RelayNode & {
  __typename?: 'SurveyResult';
  /** The contents of the survey result. */
  content: Scalars['JSON'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A survey. */
export type SurveySchema = RelayNode & {
  __typename?: 'SurveySchema';
  /** Permissions on this survey. */
  can: SurveySchemaPermissions;
  /** Whether the survey can be closed or not. */
  closeable: Scalars['Boolean'];
  /** The contents of the survey. */
  content: Scalars['JSON'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The description of the survey. */
  description?: Maybe<Scalars['String']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the survey. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Results of completed surveys */
  surveyResults: Array<SurveyResult>;
  /** The theme of the survey. */
  theme: Scalars['JSON'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for SurveySchema. */
export type SurveySchemaConnection = {
  __typename?: 'SurveySchemaConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SurveySchemaEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SurveySchema>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SurveySchemaEdge = {
  __typename?: 'SurveySchemaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SurveySchema>;
};

/** Permissions on this survey. */
export type SurveySchemaPermissions = {
  __typename?: 'SurveySchemaPermissions';
  /** Whether you can delete this survey. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this survey. */
  update: Scalars['Boolean'];
};

/** Find surveys you have access to. */
export type SurveySchemasNamespace = {
  __typename?: 'SurveySchemasNamespace';
  /** Find all your surveys. */
  all: SurveySchemaConnection;
};


/** Find surveys you have access to. */
export type SurveySchemasNamespaceAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds: Array<Scalars['ID']>;
};

/** A documentation for a table in RapidQL. */
export type TableDocumentation = {
  __typename?: 'TableDocumentation';
  /** The columns on this table. */
  columns: Array<ColumnDocumentation>;
  /** A description of what the table is. */
  comment: Scalars['String'];
  /** The name of the table. */
  name: Scalars['String'];
  /** When the view was last updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Tables in RapidQL. */
export enum TableName {
  /** certifications */
  Certifications = 'certifications',
  /** course_events */
  CourseEvents = 'course_events',
  /** course_item_progressions */
  CourseItemProgressions = 'course_item_progressions',
  /** courses */
  Courses = 'courses',
  /** custom_fields */
  CustomFields = 'custom_fields',
  /** custom_values */
  CustomValues = 'custom_values',
  /** enrolment_keys */
  EnrolmentKeys = 'enrolment_keys',
  /** exam_results */
  ExamResults = 'exam_results',
  /** grants */
  Grants = 'grants',
  /** il_bookings */
  IlBookings = 'il_bookings',
  /** il_class_instructors */
  IlClassInstructors = 'il_class_instructors',
  /** il_class_results */
  IlClassResults = 'il_class_results',
  /** il_classes */
  IlClasses = 'il_classes',
  /** il_courses */
  IlCourses = 'il_courses',
  /** il_locations */
  IlLocations = 'il_locations',
  /** il_sessions */
  IlSessions = 'il_sessions',
  /** instructors */
  Instructors = 'instructors',
  /** invitees */
  Invitees = 'invitees',
  /** invites */
  Invites = 'invites',
  /** learner_organizations */
  LearnerOrganizations = 'learner_organizations',
  /** license_groups */
  LicenseGroups = 'license_groups',
  /** licenses */
  Licenses = 'licenses',
  /** lit_sales_report_order_items */
  LitSalesReportOrderItems = 'lit_sales_report_order_items',
  /** order_items */
  OrderItems = 'order_items',
  /** orders */
  Orders = 'orders',
  /** organizations */
  Organizations = 'organizations',
  /** platform_events */
  PlatformEvents = 'platform_events',
  /** platform_usage_items */
  PlatformUsageItems = 'platform_usage_items',
  /** products */
  Products = 'products',
  /** refund_items */
  RefundItems = 'refund_items',
  /** refunds */
  Refunds = 'refunds',
  /** storefronts */
  Storefronts = 'storefronts',
  /** trainings_report_items */
  TrainingsReportItems = 'trainings_report_items',
  /** users */
  Users = 'users'
}

/** A key-value pair that can be attached to any object. */
export type Tag = {
  __typename?: 'Tag';
  /** The name of the tag. */
  key: Scalars['String'];
  /** The value of the tag. */
  value: Scalars['String'];
};

/** Attributes for tags. */
export type TagAttributes = {
  /** The name of the tag. */
  key: Scalars['String'];
  /** The value of the meta. */
  value: Scalars['String'];
};

/** Tag fields. */
export type TagField = RelayNode & {
  __typename?: 'TagField';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Tag name. */
  name: Scalars['String'];
  /** Whether the tag is required. */
  required: Scalars['Boolean'];
  /** The scope for the tag, or where it can apply. */
  scope: TagFieldScopeEnum;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Valid scopes for tag fields. */
export enum TagFieldScopeEnum {
  /** Tag field for training reporting. */
  TrainingReporting = 'training_reporting'
}

/** Something that can be tagged with key-value pairs. */
export type Taggable = {
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The tags on this object. */
  tags: Array<Tag>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of TakeCourse */
export type TakeCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the license or license group to take. */
  licenseId: Scalars['ID'];
};

/** Autogenerated return type of TakeCourse. */
export type TakeCoursePayload = {
  __typename?: 'TakeCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created grant. */
  grant?: Maybe<Grant>;
  /** The CommonLicense */
  license: CommonLicense;
};

/** Valid Canadian tax codes for an Organization. */
export enum TaxCodeEnum {
  /** British Columbia PST */
  Cabcpst = 'CABCPST',
  /** Canadian Federal Tax (GST + HST) */
  Cahst = 'CAHST',
  /** Manitoba PST */
  Cambpst = 'CAMBPST',
  /** Quebec QST */
  Caqcqst = 'CAQCQST',
  /** Saskatchewan PST */
  Caskpst = 'CASKPST'
}

/** A tax item with a rate, description, and other things. */
export type TaxItem = RelayNode & {
  __typename?: 'TaxItem';
  /** The dollar amount of this item. */
  amount: Scalars['Float'];
  /** The dollar amount of this item. */
  amountFormatted: Scalars['String'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** A user friendly description. */
  description: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The rate of this tax item. */
  rate: Scalars['Float'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A tax item with a rate, description, and other things. */
export type TaxItemAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** A tax item with a rate, description, and other things. */
export type TaxItemBase = {
  __typename?: 'TaxItemBase';
  /** The dollar amount of this item. */
  amount: Scalars['Float'];
  /** The dollar amount of this item. */
  amountFormatted: Scalars['String'];
  /** A user friendly description. */
  description: Scalars['String'];
  /** The rate of this tax item. */
  rate: Scalars['Float'];
};


/** A tax item with a rate, description, and other things. */
export type TaxItemBaseAmountFormattedArgs = {
  withCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** Calculate taxes. */
export type TaxesNamespace = {
  __typename?: 'TaxesNamespace';
  /** Estimate taxes for refunds */
  estimateForRefund: Array<TaxItem>;
};


/** Calculate taxes. */
export type TaxesNamespaceEstimateForRefundArgs = {
  orderId: Scalars['Int'];
  orderItems: Array<OrderItemPairAttributes>;
  refundShipping: Scalars['Boolean'];
};

/** Autogenerated input type of TearDownRapidql */
export type TearDownRapidqlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of TearDownRapidql. */
export type TearDownRapidqlPayload = {
  __typename?: 'TearDownRapidqlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the tear down is queued. Always true. */
  ok: Scalars['Boolean'];
};

/** A terms of service for users to review and accept. */
export type TermsOfService = RelayNode & {
  __typename?: 'TermsOfService';
  /** Whether the terms of service are active. */
  active: Scalars['Boolean'];
  agreed: Scalars['Boolean'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The file for the terms of service. */
  file: AttacheFile;
  /** URL to the file. */
  fileUrl: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of the terms of service. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user agreements for the terms of service. */
  userAgreements: Array<TermsOfServiceUserAgreement>;
};


/** A terms of service for users to review and accept. */
export type TermsOfServiceUserAgreementsArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};

/** Something that potentially has terms of service. */
export type TermsOfServiceAgreeable = {
  /** The applicable Terms of Service records tied to this object. */
  termsOfService: Array<TermsOfService>;
};

/** A terms of service agreement for a user and a terms of service. */
export type TermsOfServiceUserAgreement = RelayNode & {
  __typename?: 'TermsOfServiceUserAgreement';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The terms of service being accepted. */
  termsOfService: TermsOfService;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user accepting the terms of service. */
  user: User;
};

/** A storefront theme */
export type Theme = RelayNode & {
  __typename?: 'Theme';
  /** The background color of this theme. */
  backgroundColor: Scalars['String'];
  /** Any permissions you have relevant to the Theme. */
  can: ThemePermissions;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The custom less of this theme. */
  customLess?: Maybe<Scalars['String']>;
  /** The font name of this theme. */
  fontName: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** The header liquid of this theme. */
  headerLiquid?: Maybe<Scalars['String']>;
  /** The integer ID. */
  id: Scalars['Int'];
  /** The name of this theme. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The text color of this theme. */
  textColor: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Permissions for a Theme. */
export type ThemePermissions = {
  __typename?: 'ThemePermissions';
  /** Whether you can destroy this theme. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether you can update this theme. */
  update: Scalars['Boolean'];
};

/** Traction credential configuration */
export type TractionCredentialConfiguration = RelayNode & {
  __typename?: 'TractionCredentialConfiguration';
  /** The claims configuration for Traction credentials */
  claimsConfiguration: Scalars['JSON'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A collection of courses to satisfy a competency */
export type TrainingCompetency = RelayNode & {
  __typename?: 'TrainingCompetency';
  /** Any permissions you have relevant to the training competency. */
  can?: Maybe<TrainingCompetencyPermissions>;
  /** The courses associated with the training competency */
  courses: Array<Course>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The training competency description */
  description?: Maybe<Scalars['String']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The training competency name */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Training competency applications associated with training role application, training competency and learner */
export type TrainingCompetencyApplication = RelayNode & {
  __typename?: 'TrainingCompetencyApplication';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The learner object. */
  learner: Learner;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Training competency status */
  status: TrainingCompetencyApplicationStatusEnum;
  /** Associated training competency */
  trainingCompetency: TrainingCompetency;
  /** An array of associated training competency compliance records */
  trainingCompetencyCompliances: Array<TrainingCompetencyCompliance>;
  /** Associated training role application */
  trainingRoleApplication: TrainingRoleApplication;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Valid types for training competency application status. */
export enum TrainingCompetencyApplicationStatusEnum {
  /** A training competency application which is compliant. */
  Compliant = 'compliant',
  /** A training competency application which is expired. */
  Expired = 'expired',
  /** A training competency application which is expiring_soon. */
  ExpiringSoon = 'expiring_soon',
  /** A training competency application which is in_progress. */
  InProgress = 'in_progress',
  /** A training competency application which is invited. */
  Invited = 'invited',
  /** A training competency application which is non_compliant. */
  NonCompliant = 'non_compliant',
  /** A training competency application which is unassigned. */
  Unassigned = 'unassigned'
}

/** Training competency compliance record associated with training competency application and learner */
export type TrainingCompetencyCompliance = RelayNode & {
  __typename?: 'TrainingCompetencyCompliance';
  /** When the training competency compliance course was completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Associated course object */
  course: Course;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** When the training competency compliance course expires */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The learner object */
  learner: Learner;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the training competency compliance course was started */
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Training competency compliance status */
  status: TrainingCompetencyComplianceStatusEnum;
  /** Associated training competency application */
  trainingCompetencyApplication: TrainingCompetencyApplication;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Valid types for training competency compliance status. */
export enum TrainingCompetencyComplianceStatusEnum {
  /** A training competency compliance which is accepted. */
  Accepted = 'accepted',
  /** A training competency compliance which is certification_expired. */
  CertificationExpired = 'certification_expired',
  /** A training competency compliance which is certification_expiring_soon. */
  CertificationExpiringSoon = 'certification_expiring_soon',
  /** A training competency compliance which is certification_failed. */
  CertificationFailed = 'certification_failed',
  /** A training competency compliance which is certification_pending. */
  CertificationPending = 'certification_pending',
  /** A training competency compliance which is certified. */
  Certified = 'certified',
  /** A training competency compliance which is completed. */
  Completed = 'completed',
  /** A training competency compliance which is declined. */
  Declined = 'declined',
  /** A training competency compliance which is delinquent. */
  Delinquent = 'delinquent',
  /** A training competency compliance which is failed. */
  Failed = 'failed',
  /** A training competency compliance which is grant_expired. */
  GrantExpired = 'grant_expired',
  /** A training competency compliance which is in_progress. */
  InProgress = 'in_progress',
  /** A training competency compliance which is license_expired. */
  LicenseExpired = 'license_expired',
  /** A training competency compliance which is not_started. */
  NotStarted = 'not_started',
  /** A training competency compliance which is pending. */
  Pending = 'pending',
  /** A training competency compliance which is resent. */
  Resent = 'resent',
  /** A training competency compliance which is revoked. */
  Revoked = 'revoked',
  /** A training competency compliance which is sent. */
  Sent = 'sent',
  /** A training competency compliance which is unsendable. */
  Unsendable = 'unsendable'
}

/** Permissions on this training competency. */
export type TrainingCompetencyPermissions = {
  __typename?: 'TrainingCompetencyPermissions';
  /** Whether you can destroy this training competency. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
};

/** A role to associate with a training competency that can be assigned to learners */
export type TrainingRole = RelayNode & {
  __typename?: 'TrainingRole';
  /** Any permissions you have relevant to the training role. */
  can?: Maybe<TrainingRolePermissions>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The training role description */
  description?: Maybe<Scalars['String']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The training role name */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The training competencies associated with the training role */
  trainingCompetencies: Array<TrainingCompetency>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** An array of training role and learner associations */
export type TrainingRoleApplication = RelayNode & {
  __typename?: 'TrainingRoleApplication';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The learner object. */
  learner?: Maybe<Learner>;
  /** Organization associated with the training role */
  organization: Organization;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Training role status */
  status: TrainingRoleApplicationStatusEnum;
  /** Associated training competency applications */
  trainingCompetencyApplications?: Maybe<Array<TrainingCompetencyApplication>>;
  /** Associated training role */
  trainingRole: TrainingRole;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Valid types for training role application status. */
export enum TrainingRoleApplicationStatusEnum {
  /** A training role application which is compliant. */
  Compliant = 'compliant',
  /** A training role application which is expired. */
  Expired = 'expired',
  /** A training role application which is expiring_soon. */
  ExpiringSoon = 'expiring_soon',
  /** A training role application which is in_progress. */
  InProgress = 'in_progress',
  /** A training role application which is non_compliant. */
  NonCompliant = 'non_compliant'
}

/** Permissions on this training role. */
export type TrainingRolePermissions = {
  __typename?: 'TrainingRolePermissions';
  /** Whether you can destroy this training role. */
  destroy: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
};

/** Attributes for updating an address. */
export type UpdateAddressAttributes = {
  /** The new first line of the address. */
  address1?: InputMaybe<Scalars['String']>;
  /** The new second line of the address. */
  address2?: InputMaybe<Scalars['String']>;
  /** The new city. */
  city?: InputMaybe<Scalars['String']>;
  /** The province, if required, identified by an ISO code. */
  country?: InputMaybe<CodedLocation>;
  /** The new postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** The country, identified by an ISO code. */
  province?: InputMaybe<CodedLocation>;
};

/** Autogenerated input type of UpdateArchivedNodes */
export type UpdateArchivedNodesInput = {
  /** The value to set the node's archived state to. */
  archived: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The GIDs of the nodes to update. */
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of UpdateArchivedNodes. */
export type UpdateArchivedNodesPayload = {
  __typename?: 'UpdateArchivedNodesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The nodes that were updated. */
  nodes: Array<Archivable>;
};

/** Attributes needed to update a new constant. */
export type UpdateAutomationConstantAttributes = {
  /** The name of this constant. */
  name?: InputMaybe<Scalars['String']>;
  /** The value of this constant. */
  value?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateAutomationConstant */
export type UpdateAutomationConstantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the constant to update. */
  id: Scalars['Int'];
  /** The patch of updates. */
  patch: UpdateAutomationConstantAttributes;
};

/** Autogenerated return type of UpdateAutomationConstant. */
export type UpdateAutomationConstantPayload = {
  __typename?: 'UpdateAutomationConstantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The updated constant. */
  constant?: Maybe<AutomationConstant>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
};

/** Attributes available to update an automation script. */
export type UpdateAutomationScriptAttributes = {
  /** Whether or not this script is enabled. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The event that triggers this script. */
  event?: InputMaybe<AutomationEvent>;
  /** The LUA script to execute. */
  lua?: InputMaybe<Scalars['String']>;
  /** The title of the script. */
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateAutomationScript */
export type UpdateAutomationScriptInput = {
  /** The ID of the automation script to update. */
  automationScriptId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The patch of updates. */
  patch: UpdateAutomationScriptAttributes;
};

/** Autogenerated return type of UpdateAutomationScript. */
export type UpdateAutomationScriptPayload = {
  __typename?: 'UpdateAutomationScriptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The updated script, null if there are any validation errors. */
  script?: Maybe<AutomationScript>;
};

/** Attributes needed to update an item of shopping cart */
export type UpdateCartItemAttributes = {
  /** The new quantity of the item in the cart */
  quantity: Scalars['Int'];
};

/** Autogenerated input type of UpdateCartItem */
export type UpdateCartItemInput = {
  /** The ID of cart item */
  cartItem: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The params which will update the cart item */
  patch: UpdateCartItemAttributes;
};

/** Autogenerated return type of UpdateCartItem. */
export type UpdateCartItemPayload = {
  __typename?: 'UpdateCartItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The updated cart item. */
  shoppingCart: ShoppingCart;
};

/** Attributes needed to update a certification. */
export type UpdateCertificationAttributes = {
  /** The base64 image string of the certification. */
  base64Image?: InputMaybe<Scalars['String']>;
  /** The date this certification was issued on. */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The description of this certification. */
  description?: InputMaybe<Scalars['String']>;
  /** The date this certification will expire on. */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The issuer name for this certification. */
  issuerName?: InputMaybe<Scalars['String']>;
  /** The name of the certification. */
  name?: InputMaybe<Scalars['String']>;
};

/** Attributes available to update an automation script. */
export type UpdateCertificationChangeRequestAttributes = {
  /** The new status of the change request. */
  status?: InputMaybe<CertificationChangeRequestStatus>;
};

/** Autogenerated input type of UpdateCertificationChangeRequest */
export type UpdateCertificationChangeRequestInput = {
  /** The ID of the change request to update. */
  certificationChangeRequestId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The patch of updates. */
  patch: UpdateCertificationChangeRequestAttributes;
};

/** Autogenerated return type of UpdateCertificationChangeRequest. */
export type UpdateCertificationChangeRequestPayload = {
  __typename?: 'UpdateCertificationChangeRequestPayload';
  /** The updated change request, null if there are any validation errors. */
  certificationChangeRequest?: Maybe<CertificationChangeRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
};

/** Attributes needed to update a certification default record. */
export type UpdateCertificationDefaultAttributes = {
  /** The address attributes. */
  address?: InputMaybe<NewAddressAttributes>;
  /** The Attache details for connecting to the uploaded file. */
  customLogo?: InputMaybe<AttacheUploadFile>;
  /** The Attache details for connecting to the uploaded file. */
  customSignature?: InputMaybe<AttacheUploadFile>;
  /** The name displayed on learner’s certifications to identify your organization (or you) as the training manager. */
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCertificationDefault */
export type UpdateCertificationDefaultInput = {
  /** Attributes to update your certification default record. */
  certificationDefault: UpdateCertificationDefaultAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCertificationDefault. */
export type UpdateCertificationDefaultPayload = {
  __typename?: 'UpdateCertificationDefaultPayload';
  /** The updated certificiation default record. */
  certificationDefault?: Maybe<CertificationDefault>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of UpdateCertification */
export type UpdateCertificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the certification to update. */
  id: Scalars['Int'];
  /** The form params which will update the certification. */
  patch: UpdateCertificationAttributes;
};

/** Autogenerated return type of UpdateCertification. */
export type UpdateCertificationPayload = {
  __typename?: 'UpdateCertificationPayload';
  /** The certification that was updated. */
  certification?: Maybe<Certification>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to update a CertificationTemplate record */
export type UpdateCertificationTemplateAttributes = {
  /** The course item to use as reference to the certification issue date. */
  courseItemId?: InputMaybe<Scalars['ID']>;
  /** The number of days since the certification is issued until it expires. */
  daysValid?: InputMaybe<Scalars['Int']>;
  /** The description of this certification. */
  description?: InputMaybe<Scalars['String']>;
  /** The Attache details for connecting to the uploaded file. */
  digitalBadgeImage?: InputMaybe<AttacheUploadFile>;
  /** The name of the certification */
  name?: InputMaybe<Scalars['String']>;
  /** Whether reminder notifications are disabled on the certification */
  remindersDisabled?: InputMaybe<Scalars['Boolean']>;
  /** The design of the wall certificate */
  wallCertificateOptions?: InputMaybe<WallCertificateAttributes>;
  /** The design of the wallet card */
  walletCardOptions?: InputMaybe<WalletCardAttributes>;
};

/** Autogenerated input type of UpdateCertificationTemplate */
export type UpdateCertificationTemplateInput = {
  /** The ID of the CertificationTemplate to update */
  certificationTemplateId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to update a CertificationTemplate record */
  patch: UpdateCertificationTemplateAttributes;
};

/** Autogenerated return type of UpdateCertificationTemplate. */
export type UpdateCertificationTemplatePayload = {
  __typename?: 'UpdateCertificationTemplatePayload';
  /** The CertificationTemplate that was updated. */
  certificationTemplate?: Maybe<CertificationTemplate>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to update an instructor-led class result. */
export type UpdateClassResultAttributes = {
  /** Whether the instructor-led class was attended or not. */
  attendance?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the instructor-led class result to update. */
  gid: Scalars['ID'];
  /** The grade assigned to this result. */
  grade?: InputMaybe<Scalars['String']>;
  /** Whether the learner has passed, or not, the instructor-led class. */
  passed?: InputMaybe<Scalars['Boolean']>;
};

/** Attributes needed to update a course. */
export type UpdateCourseAttributes = {
  /** The categories this course is in. */
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** The syllabus/description of the course. */
  contents?: InputMaybe<Scalars['String']>;
  /** The rich text description of the course. */
  description?: InputMaybe<Scalars['String']>;
  /** Whether discussion forums are enabled for this course. */
  discussionForums?: InputMaybe<Scalars['Boolean']>;
  /** Estimated time to ocmplete the course. */
  estimatedCompletionTime?: InputMaybe<Scalars['Int']>;
  /** The number of days after a grant has been issued that the content will become inaccessible. */
  expireGrantsAfterDays?: InputMaybe<Scalars['Int']>;
  /** The number of days after a license has been issued that the content will become inaccessible. */
  expireLicensesAfterDays?: InputMaybe<Scalars['Int']>;
  /** The date at which the course content will become inaccessible. */
  expireLicensesAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The language of the course. */
  locale?: InputMaybe<Scalars['String']>;
  /** Whether this course is mobile friendly. */
  mobile?: InputMaybe<Scalars['Boolean']>;
  /** The name of the course. */
  name?: InputMaybe<Scalars['String']>;
  /** Whether the items should be completed in order. */
  ordered?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the owner to own the course. */
  ownerId?: InputMaybe<Scalars['ID']>;
  /** The feature image for this course. */
  photo?: InputMaybe<AttacheUploadFile>;
  /** The default settings for a product. */
  productDefault?: InputMaybe<ProductDefaultAttributes>;
  /** The Attache details for connecting to the uploaded resources. */
  resources?: InputMaybe<Array<AttacheUploadFile>>;
  /** The short, SEO friendly description of the course. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** The rich text summary of the course. */
  summary?: InputMaybe<Scalars['String']>;
  /** The ID of the survey to be triggered on course completion. */
  surveySchemaId?: InputMaybe<Scalars['Int']>;
  /** Tags to add to the course. */
  tags?: InputMaybe<Array<TagAttributes>>;
  /** The LearnerVerified options for this course. */
  verificationOptions?: InputMaybe<VerificationOptionAttributes>;
  /** The LearnerVerified service level for this course. */
  verificationServices?: InputMaybe<VerificationServiceTypeEnum>;
};

/** Autogenerated input type of UpdateCourse */
export type UpdateCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the course to update. */
  courseId: Scalars['ID'];
  /** The patch of updates. */
  patch: UpdateCourseAttributes;
};

/** Autogenerated input type of UpdateCourseItem */
export type UpdateCourseItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of course item to update. */
  courseItemId: Scalars['ID'];
  /** The ID of the course item and position and/or name to update. */
  patch: CourseItemUpdate;
};

/** Autogenerated return type of UpdateCourseItem. */
export type UpdateCourseItemPayload = {
  __typename?: 'UpdateCourseItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course that had an it item updated. */
  courseItem?: Maybe<CourseItem>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of UpdateCourseItemProgressionProgress */
export type UpdateCourseItemProgressionProgressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of item to update. */
  itemId: Scalars['ID'];
  /** The updated progress value to apply to this item. */
  progress: Scalars['Int'];
};

/** Autogenerated return type of UpdateCourseItemProgressionProgress. */
export type UpdateCourseItemProgressionProgressPayload = {
  __typename?: 'UpdateCourseItemProgressionProgressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The updated progression item. */
  item?: Maybe<CourseItemProgression>;
};

/** Autogenerated return type of UpdateCourse. */
export type UpdateCoursePayload = {
  __typename?: 'UpdateCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The course that was updated. */
  course?: Maybe<Course>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to update a course prompt. */
export type UpdateCoursePromptAttributes = {
  /** The ids of the custom field course requirements to sync */
  customFieldCourseRequirementIds: Array<Scalars['ID']>;
  /** The maximum time in seconds */
  maximumTime: Scalars['Int'];
  /** The minimum time in seconds */
  minimumTime: Scalars['Int'];
};

/** Autogenerated input type of UpdateCoursePrompt */
export type UpdateCoursePromptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of the course prompt. */
  coursePromptId: Scalars['ID'];
  /** Attributes needed to update a course prompt. */
  patch: UpdateCoursePromptAttributes;
};

/** Autogenerated return type of UpdateCoursePrompt. */
export type UpdateCoursePromptPayload = {
  __typename?: 'UpdateCoursePromptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The updated course prompt. */
  coursePrompt?: Maybe<CoursePrompt>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to update a CustomAttribute record */
export type UpdateCustomAttributeAttributes = {
  /** The content of the custom attribute. */
  content?: InputMaybe<Scalars['String']>;
  /** The kind of custom attribute. */
  kind?: InputMaybe<CustomAttributeKindEnum>;
  /** The name of the custom attribute. */
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCustomAttribute */
export type UpdateCustomAttributeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the CustomAttribute to update */
  customAttributeId: Scalars['ID'];
  /** Attributes needed to update a CustomAttribute record */
  patch: UpdateCustomAttributeAttributes;
};

/** Autogenerated return type of UpdateCustomAttribute. */
export type UpdateCustomAttributePayload = {
  __typename?: 'UpdateCustomAttributePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The CustomAttribute that was updated. */
  customAttribute?: Maybe<CustomAttribute>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to update a custom domain. */
export type UpdateCustomDomainAttributes = {
  /** The domain name. */
  name?: InputMaybe<Scalars['String']>;
  /** Should this domain be made the storefronts primary domain. */
  primary?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateCustomDomain */
export type UpdateCustomDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the custom domain to update. */
  id: Scalars['ID'];
  /** The patch of updates. */
  patch: UpdateCustomDomainAttributes;
};

/** Autogenerated return type of UpdateCustomDomain. */
export type UpdateCustomDomainPayload = {
  __typename?: 'UpdateCustomDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The custom domain that was updated. */
  customDomain?: Maybe<CustomDomain>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to update a CustomField record */
export type UpdateCustomFieldAttributes = {
  /** The options available in the case of this field being a dropdown. */
  customFieldOptions?: InputMaybe<Array<UpdateCustomFieldOptionAttributes>>;
  /** The type of this field. */
  fieldType?: InputMaybe<CustomFieldFieldTypeTypeEnum>;
  /** The name of the custom field. */
  name?: InputMaybe<Scalars['String']>;
  /** Whether this field is required or not. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Whether this field should be shown on the signup form. */
  showOnSignup?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateCustomField */
export type UpdateCustomFieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the CustomField to update */
  customFieldId: Scalars['ID'];
  /** Attributes needed to update a CustomField record */
  patch: UpdateCustomFieldAttributes;
};

/** Attributes available to update a custom field option. */
export type UpdateCustomFieldOptionAttributes = {
  /** The ID of the custom field option. */
  id?: InputMaybe<Scalars['Int']>;
  /** The value of the custom field option. */
  value: Scalars['String'];
};

/** Autogenerated return type of UpdateCustomField. */
export type UpdateCustomFieldPayload = {
  __typename?: 'UpdateCustomFieldPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The CustomField that was updated. */
  customField?: Maybe<CustomField>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to update a DownloadableFile record */
export type UpdateDownloadableFileAttributes = {
  /** The static id of the file. */
  staticId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateDownloadableFile */
export type UpdateDownloadableFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the DownloadableFile to update */
  downloadableFileId: Scalars['ID'];
  /** Attributes needed to update a DownloadableFile record */
  patch: UpdateDownloadableFileAttributes;
};

/** Autogenerated return type of UpdateDownloadableFile. */
export type UpdateDownloadableFilePayload = {
  __typename?: 'UpdateDownloadableFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The DownloadableFile that was updated. */
  downloadableFile?: Maybe<DownloadableFile>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes needed to update an enrolment key. */
export type UpdateEnrolmentKeyAttributes = {
  /** When the enrolment key expires. */
  expiresAt?: InputMaybe<Scalars['Date']>;
  /** The max uses available for this enrolment key. */
  maxUses?: InputMaybe<Scalars['Int']>;
  /** The token learners will use to redeem the enrolment key. */
  token?: InputMaybe<Scalars['String']>;
  /** Does this enrolment key take from entire pool of licences? */
  universal?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateEnrolmentKey */
export type UpdateEnrolmentKeyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the License or License Group to create the key on. If a License Group ID is provided, the key will be universal. */
  id: Scalars['ID'];
  /** Attributes needed to update an enrolment key. */
  patch: UpdateEnrolmentKeyAttributes;
};

/** Autogenerated return type of UpdateEnrolmentKey. */
export type UpdateEnrolmentKeyPayload = {
  __typename?: 'UpdateEnrolmentKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The updated enrolment key. */
  enrolmentKey?: Maybe<EnrolmentKey>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Attributes of a graded submission. */
export type UpdateGradedAssignmentSubmissionAttributes = {
  /** Any feedback provided to start a discussion with the learner. */
  feedback?: InputMaybe<Scalars['String']>;
  /** The points awarded by the grader. */
  points: Scalars['Float'];
};

/** Autogenerated input type of UpdateGradedAssignmentSubmission */
export type UpdateGradedAssignmentSubmissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The graded assignment submission you wish to update. */
  gradedAssignmentSubmissionId: Scalars['ID'];
  /** Attributes needed to grade the assignment. */
  patch: UpdateGradedAssignmentSubmissionAttributes;
};

/** Autogenerated return type of UpdateGradedAssignmentSubmission. */
export type UpdateGradedAssignmentSubmissionPayload = {
  __typename?: 'UpdateGradedAssignmentSubmissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The updated graded assignment submission. */
  gradedAssignmentSubmission?: Maybe<GradedAssignmentSubmission>;
};

/** Attributes needed to update a instructor-led class. */
export type UpdateIlClassAttributes = {
  /** Who has access to book this class. */
  access?: InputMaybe<IlClassAccessEnum>;
  /** The date when learners are no longer allow to book into the class, or change their booking. */
  bookingEndsAt?: InputMaybe<Scalars['TimeWithoutZone']>;
  /** The date when learners can start booking into the class. */
  bookingStartsAt?: InputMaybe<Scalars['TimeWithoutZone']>;
  /** The ID of the course which the instructor-led class belongs to. */
  ilCourseId?: InputMaybe<Scalars['ID']>;
  /** The attributes to update an instructor-led session. */
  ilSessions?: InputMaybe<Array<UpdateIlSessionAttributes>>;
  /** The IDs of the instructors who will instruct this instructor-led class. */
  instructorIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The max capacity of the instructor-led class. */
  maxCapacity?: InputMaybe<Scalars['Int']>;
  /** Whether the marking instructor agrees to all pending class results being marked passed (must be true). */
  passAll?: InputMaybe<Scalars['Boolean']>;
  /** The status of the instructor-led class. */
  status: IlClassStatusEnum;
  /** The max capacity of the waitlist. 0 to disable the waitlist. */
  waitlistSize?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UpdateILClass */
export type UpdateIlClassInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of instructor-led class to update. */
  ilClassId: Scalars['ID'];
  /** The params which will update the instructor-led class */
  patch: UpdateIlClassAttributes;
  /** A value whether the class is notified by email of changes or not */
  sendNotification?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UpdateILClass. */
export type UpdateIlClassPayload = {
  __typename?: 'UpdateILClassPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The instructor-led class you're updating. */
  ilClass?: Maybe<IlClass>;
};

/** Autogenerated input type of UpdateILClassResults */
export type UpdateIlClassResultsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A set of instructor-led class results to update. */
  ilClassResults: Array<UpdateClassResultAttributes>;
};

/** Autogenerated return type of UpdateILClassResults. */
export type UpdateIlClassResultsPayload = {
  __typename?: 'UpdateILClassResultsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The set of instructor-led class results that was updated. */
  ilClassResults?: Maybe<Array<IlClassResult>>;
};

/** Attributes needed to update an instructor-led course. */
export type UpdateIlCourseAttributes = {
  /** The Attache details for connecting to the uploaded file. */
  instructorFiles?: InputMaybe<Array<AttacheUploadFile>>;
  /** The Attache details for connecting to the uploaded file. */
  learnerFiles?: InputMaybe<Array<AttacheUploadFile>>;
  /** The name of the instructor-led course. */
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateILCourse */
export type UpdateIlCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the instructor-led course to update. */
  ilCourseId: Scalars['ID'];
  /** The patch of updates. */
  patch: UpdateIlCourseAttributes;
};

/** Attributes needed to update a ILCourseItem record */
export type UpdateIlCourseItemAttributes = {
  /** The name of the instructor-led course item. */
  name: Scalars['String'];
  /** Whether this course item should track attendance. */
  trackAttendance: Scalars['Boolean'];
  /** Whether this course item should track a grade. */
  trackGrade: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateILCourseItem */
export type UpdateIlCourseItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the ILCourseItem to update */
  ilCourseItemId: Scalars['ID'];
  /** Attributes needed to update a ILCourseItem record */
  patch: UpdateIlCourseItemAttributes;
};

/** Autogenerated return type of UpdateILCourseItem. */
export type UpdateIlCourseItemPayload = {
  __typename?: 'UpdateILCourseItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The ILCourseItem that was updated. */
  ilCourseItem?: Maybe<IlCourseItem>;
};

/** Autogenerated return type of UpdateILCourse. */
export type UpdateIlCoursePayload = {
  __typename?: 'UpdateILCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The updated instructor-led course. */
  ilCourse?: Maybe<IlCourse>;
};

/** Attributes needed to update an instructor-led location. */
export type UpdateIlLocationAttributes = {
  /** The address attributes. */
  address?: InputMaybe<UpdateAddressAttributes>;
  /** The name of the instructor-led location. */
  name?: InputMaybe<Scalars['String']>;
  /** The url of the instructor-led location. */
  url?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateILLocation */
export type UpdateIlLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The location to be updated. */
  ilLocationId: Scalars['ID'];
  /** Attributes needed to create a location. */
  patch: UpdateIlLocationAttributes;
  /** Whether all of instructors/learners of future classes associated with the location will be notified of changes or not */
  sendNotification?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UpdateILLocation. */
export type UpdateIlLocationPayload = {
  __typename?: 'UpdateILLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The new instructor-led location. */
  ilLocation?: Maybe<IlLocationInterface>;
};

/** Attributes needed to update an instructor-led session. */
export type UpdateIlSessionAttributes = {
  /** The datetime when the session will end. Will be coerced into the time zone given which is required if this is provided. */
  endsAt?: InputMaybe<Scalars['TimeWithoutZone']>;
  /** The ID of the instructor-led session. */
  id: Scalars['Int'];
  /** The ID of the location which the instructor-led class will be taught. */
  ilLocationId?: InputMaybe<Scalars['ID']>;
  /** The datetime when the session will start. Will be coerced into the time zone given which is required if this is provided. */
  startsAt?: InputMaybe<Scalars['TimeWithoutZone']>;
  /** The time zone of the session. */
  timeZone?: InputMaybe<Scalars['TimeZone']>;
};

/** Attributes needed to update an instructor. */
export type UpdateInstructorAttributes = {
  /** Whether the instructor is allowed to view learner contact details. */
  accessLearnerContactDetails?: InputMaybe<Scalars['Boolean']>;
  /** Whether the instructor is allowed to distribute class access without learner purchase. */
  distributeWithoutPurchase?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateInstructor */
export type UpdateInstructorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID for the instructor that will be updated. */
  instructorId: Scalars['ID'];
  /** Attributes needed to update an instructor. */
  patch: UpdateInstructorAttributes;
};

/** Autogenerated return type of UpdateInstructor. */
export type UpdateInstructorPayload = {
  __typename?: 'UpdateInstructorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The updated instructor. */
  instructor?: Maybe<Instructor>;
};

/** Attributes to update on a learner. */
export type UpdateLearnerAttributes = {
  /** Learner email. Only applied if the learner is not linked to a User record. */
  email?: InputMaybe<Scalars['String']>;
  /** Learner first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Learner last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Learner mobile number. Only applied if the learner is not linked to a User record. */
  mobileNumber?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateLearner */
export type UpdateLearnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The global ID of the learner to update. */
  learnerId: Scalars['ID'];
  /** The Invitee attributes. */
  patch: UpdateLearnerAttributes;
};

/** Autogenerated return type of UpdateLearner. */
export type UpdateLearnerPayload = {
  __typename?: 'UpdateLearnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The created learner. */
  learner?: Maybe<Learner>;
};

/** Attributes needed to update a LearnerVerifiedSession. */
export type UpdateLearnerVerifiedSessionAttributes = {
  /** When the session was. */
  startedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of UpdateLearnerVerifiedSession */
export type UpdateLearnerVerifiedSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the session to update. */
  id: Scalars['Int'];
  /** The patch of updates. */
  patch: UpdateLearnerVerifiedSessionAttributes;
};

/** Autogenerated return type of UpdateLearnerVerifiedSession. */
export type UpdateLearnerVerifiedSessionPayload = {
  __typename?: 'UpdateLearnerVerifiedSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The session that was updated. */
  session?: Maybe<LearnerVerifiedSession>;
};

/** Autogenerated input type of UpdateLearnersActive */
export type UpdateLearnersActiveInput = {
  /** The value to set the learners active state to. */
  active: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether this will affect all TMs or one. */
  global?: InputMaybe<Scalars['Boolean']>;
  /** The IDs of the learners to update. */
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of UpdateLearnersActive. */
export type UpdateLearnersActivePayload = {
  __typename?: 'UpdateLearnersActivePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The learners that were updated. */
  learners?: Maybe<Array<Learner>>;
};

/** Attributes needed to update a license. */
export type UpdateLicenseAttributes = {
  /** The new number of seats for the license. */
  seats?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UpdateLicense */
export type UpdateLicenseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the license to update. */
  licenseId: Scalars['ID'];
  /** Attributes needed to update a license. */
  patch: UpdateLicenseAttributes;
};

/** Autogenerated return type of UpdateLicense. */
export type UpdateLicensePayload = {
  __typename?: 'UpdateLicensePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The license that was updated. */
  license?: Maybe<License>;
};

/** Attributes needed to update a MenuItem record */
export type UpdateMenuItemAttributes = {
  /** The feature image placed at the left of the menu item. */
  featureImageLeft?: InputMaybe<AttacheUploadFile>;
  /** The feature image placed at the right of the menu item. */
  featureImageRight?: InputMaybe<AttacheUploadFile>;
  /** The parent ID of this menu item. */
  parentId?: InputMaybe<Scalars['ID']>;
  /** The position of this menu item. */
  position?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UpdateMenuItem */
export type UpdateMenuItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the MenuItem to update */
  menuItemId: Scalars['ID'];
  /** Attributes needed to update a MenuItem record */
  patch: UpdateMenuItemAttributes;
};

/** Autogenerated return type of UpdateMenuItem. */
export type UpdateMenuItemPayload = {
  __typename?: 'UpdateMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The MenuItem that was updated. */
  menuItem?: Maybe<MenuItem>;
};

/** Attributes needed to update a OIDCProvider record */
export type UpdateOidcProviderAttributes = {
  /** The automation claim path of the OIDC provider. */
  automationClaimPath?: InputMaybe<Scalars['String']>;
  /** The client ID of the OIDC provider. */
  clientId?: InputMaybe<Scalars['String']>;
  /** The client secret of the OIDC provider. */
  clientSecret?: InputMaybe<Scalars['String']>;
  /** The configuration URL of the OIDC provider. */
  configurationUrl?: InputMaybe<Scalars['String']>;
  /** Whether to confirm email during signup. */
  confirmEmailDuringSignup?: InputMaybe<Scalars['Boolean']>;
  /** The name of the OIDC provider. */
  name?: InputMaybe<Scalars['String']>;
  /** The promo code claim path of the OIDC provider. */
  promoCodeClaimPath?: InputMaybe<Scalars['String']>;
  /** The scopes of the OIDC provider. */
  scope?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateOIDCProvider */
export type UpdateOidcProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the OIDCProvider to update */
  oidcProviderId: Scalars['ID'];
  /** Attributes needed to update a OIDCProvider record */
  patch: UpdateOidcProviderAttributes;
};

/** Autogenerated return type of UpdateOIDCProvider. */
export type UpdateOidcProviderPayload = {
  __typename?: 'UpdateOIDCProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The OIDCProvider that was updated. */
  oidcProvider?: Maybe<OidcProvider>;
};

/** Attributes needed to create an Organization. */
export type UpdateOrganizationAttributes = {
  /** The address of the Organization. */
  address?: InputMaybe<UpdateAddressAttributes>;
  /** Whether to allow platform developers to collect analytics. */
  analyticsOptIn?: InputMaybe<Scalars['Boolean']>;
  /** The email for billing related issues. */
  billingEmail?: InputMaybe<Scalars['String']>;
  /** The certification default of the Organization. */
  certificationDefault?: InputMaybe<UpdateCertificationDefaultAttributes>;
  /** The name of the Organization. */
  name?: InputMaybe<Scalars['String']>;
  /** The email for notifications about orders including shipped products. */
  shippingNotificationEmail?: InputMaybe<Scalars['String']>;
  /** The Canadian tax codes to charge. */
  taxCodes?: InputMaybe<Array<TaxCodeEnum>>;
  /** A URL for the organization. */
  url?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateOrganization */
export type UpdateOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the organization to update. */
  organizationId: Scalars['ID'];
  /** The attributes to update. */
  patch: UpdateOrganizationAttributes;
};

/** Autogenerated return type of UpdateOrganization. */
export type UpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The updated Organization. */
  organization?: Maybe<Organization>;
};

/** Attributes needed to update a Page record */
export type UpdatePageAttributes = {
  /** CSS classes to apply to the page. */
  cssClass?: InputMaybe<Scalars['String']>;
  /** A description of the page. */
  description?: InputMaybe<Scalars['String']>;
  /** The feature image of the page. */
  featureImage?: InputMaybe<AttacheUploadFile>;
  /** Meta tags for the page. */
  metaTags?: InputMaybe<Array<MetaTagAttributes>>;
  /** The name of the page. */
  name?: InputMaybe<Scalars['String']>;
  /** A password to access the page. If not provided, the page is public. */
  password?: InputMaybe<Scalars['String']>;
  /** Whether the page is published or not. */
  published?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user must be logged in to access the page. */
  requireLoggedInUser?: InputMaybe<Scalars['Boolean']>;
  /** Whether the page is the home page or not. Only one page may be the home page. */
  root?: InputMaybe<Scalars['Boolean']>;
  /** How the page will looks on the URL. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdatePage */
export type UpdatePageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the Page to update */
  pageId: Scalars['ID'];
  /** Attributes needed to update a Page record */
  patch: UpdatePageAttributes;
};

/** Autogenerated return type of UpdatePage. */
export type UpdatePagePayload = {
  __typename?: 'UpdatePagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The Page that was updated. */
  page?: Maybe<Page>;
};

/** Autogenerated input type of UpdatePassword */
export type UpdatePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** New password for user. */
  password: Scalars['String'];
  /** Token to validate password update. */
  resetPasswordToken: Scalars['String'];
};

/** Autogenerated return type of UpdatePassword. */
export type UpdatePasswordPayload = {
  __typename?: 'UpdatePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The user after the successful password update. */
  user?: Maybe<User>;
};

/** Attributes for a prerequisite. */
export type UpdatePrerequisiteCourseRequirementAttributes = {
  /** The courses that are a prerequisite for this course. */
  requiredCourseIds: Array<Scalars['ID']>;
  /** The number of courses that must be completed for this prerequisite. */
  requirementQuantity: Scalars['Int'];
};

/** Autogenerated input type of UpdatePrerequisiteCourseRequirement */
export type UpdatePrerequisiteCourseRequirementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The patch of updates. */
  patch: UpdatePrerequisiteCourseRequirementAttributes;
  /** The prerequisite course requirement that is being updated. */
  prerequisiteCourseRequirementId: Scalars['ID'];
};

/** Autogenerated return type of UpdatePrerequisiteCourseRequirement. */
export type UpdatePrerequisiteCourseRequirementPayload = {
  __typename?: 'UpdatePrerequisiteCourseRequirementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The updated prerequisite course requirement. */
  prerequisiteCourseRequirement?: Maybe<PrerequisiteCourseRequirement>;
};

/** Attributes available to update a product. */
export type UpdateProductAttributes = {
  /** Whether the product is available for individual purchase. */
  availableForIndividualPurchase?: InputMaybe<Scalars['Boolean']>;
  /** Settings for bulk discounts. */
  bulkDiscountOptions?: InputMaybe<BulkDiscountOptionsAttributes>;
  /** Whether the product has bulk discounts. */
  bulkDiscounts?: InputMaybe<Scalars['Boolean']>;
  /** Media for the product page carousel. */
  carouselMedia?: InputMaybe<Array<AttacheUploadFile>>;
  /** The categories this course is in. */
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** A description of the product. */
  description?: InputMaybe<Scalars['String']>;
  /** Whether the product is hidden. */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Meta Tags for the product page. */
  metaTags?: InputMaybe<Array<MetaTagAttributes>>;
  /** The name of the product. */
  name?: InputMaybe<Scalars['String']>;
  /** The feature image for this product. */
  photo?: InputMaybe<AttacheUploadFile>;
  /** The price of the product. */
  price?: InputMaybe<Scalars['Float']>;
  /** Products that are bundled with this product. */
  products?: InputMaybe<Array<Scalars['ID']>>;
  /** Whether the product requires shipping. */
  requiresShipping?: InputMaybe<Scalars['Boolean']>;
  /** A short description of the product. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** The SKU of the product. */
  sku?: InputMaybe<Scalars['String']>;
  /** A rich text summary of the product. */
  summary?: InputMaybe<Scalars['String']>;
  /** Tags to add to the product. */
  tags?: InputMaybe<Array<TagAttributes>>;
  /** Whether the product charges taxes. */
  taxesEnabled?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateProduct */
export type UpdateProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes to update. */
  patch: UpdateProductAttributes;
  /** The ID of the product. */
  productId: Scalars['ID'];
};

/** Autogenerated return type of UpdateProduct. */
export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The product that was updated. */
  product?: Maybe<Product>;
};

/** Autogenerated input type of UpdatePromoCode */
export type UpdatePromoCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The new properties of the promo code. */
  patch: PromoCodeAttributes;
  /** The ID of the promo code to be updated. */
  promoCodeId: Scalars['ID'];
};

/** Autogenerated return type of UpdatePromoCode. */
export type UpdatePromoCodePayload = {
  __typename?: 'UpdatePromoCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The updated promo code. */
  promoCode?: Maybe<PromoCode>;
};

/** Attributes needed to update a RapidQL schedule. */
export type UpdateRapidqlScheduleAttributes = {
  /** The week day or calendar day that schedule will run. */
  day?: InputMaybe<RapidqlScheduleDayEnum>;
  /** Choose the first day, last day, or middle of the month schedule will run. */
  dayModifier?: InputMaybe<RapidqlScheduleDayModifierEnum>;
  /** Whether the report will be delivered when there are no results. */
  dontSendIfNoResults?: InputMaybe<Scalars['Boolean']>;
  /** List of emails to BCC */
  emailBcc?: InputMaybe<Array<Scalars['String']>>;
  /** List of emails to CC */
  emailCc?: InputMaybe<Array<Scalars['String']>>;
  /** List of emails to send report to */
  emailTo?: InputMaybe<Array<Scalars['String']>>;
  /** Whether the report is enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The filters to apply when running the report. */
  filters?: InputMaybe<Scalars['JSON']>;
  /** Hour that schedule will run */
  hourOfDay?: InputMaybe<Scalars['Int']>;
  /** How often the report will be sent. */
  interval?: InputMaybe<RapidqlScheduleIntervalEnum>;
  /** Time zone that schedule will run the schedulable */
  timeZone?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateRapidqlSchedule */
export type UpdateRapidqlScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The params which will update the saved query. */
  patch: UpdateRapidqlScheduleAttributes;
  /** The ID of RapidQL schedule to update. */
  rapidqlScheduleId: Scalars['ID'];
};

/** Autogenerated return type of UpdateRapidqlSchedule. */
export type UpdateRapidqlSchedulePayload = {
  __typename?: 'UpdateRapidqlSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The RapidQL schedule */
  rapidqlSchedule?: Maybe<RapidqlSchedule>;
};

/** Attributes needed to update a Redirect record */
export type UpdateRedirectAttributes = {
  /** The URL that triggers the redirection. */
  redirectFrom?: InputMaybe<Scalars['String']>;
  /** The object that the redirect points to. */
  redirectTo?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of UpdateRedirect */
export type UpdateRedirectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to update a Redirect record */
  patch: UpdateRedirectAttributes;
  /** The ID of the Redirect to update */
  redirectId: Scalars['ID'];
};

/** Autogenerated return type of UpdateRedirect. */
export type UpdateRedirectPayload = {
  __typename?: 'UpdateRedirectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The Redirect that was updated. */
  redirect?: Maybe<Redirect>;
};

/** Attributes needed to update a regulator submission record. */
export type UpdateRegulatorSubmissionAttributes = {
  /** Any notes you want to track. */
  notes?: InputMaybe<Scalars['String']>;
  /** The reference ID provided by the regulator. */
  regulatorReferenceId?: InputMaybe<Scalars['String']>;
  /** When the completion was submitted to the regulator. */
  submittedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of UpdateRegulatorSubmission */
export type UpdateRegulatorSubmissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the submission to update. */
  id: Scalars['ID'];
  /** The patch of updates. */
  patch: UpdateRegulatorSubmissionAttributes;
};

/** Autogenerated return type of UpdateRegulatorSubmission. */
export type UpdateRegulatorSubmissionPayload = {
  __typename?: 'UpdateRegulatorSubmissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The updated regulator submission record. */
  submission: RegulatorSubmission;
};

/** Attributes needed to update a SAMLProvider record */
export type UpdateSamlProviderAttributes = {
  /** The automation mapping of the SAML provider. */
  automationMapping?: InputMaybe<Scalars['String']>;
  /** The cert fingerprint of the SAML provider. */
  certFingerprint?: InputMaybe<Scalars['String']>;
  /** The cert fingerprint algorithm of the SAML provider. */
  certFingerprintAlgorithm?: InputMaybe<Scalars['String']>;
  /** Whether to confirm email during signup. */
  confirmEmailDuringSignup?: InputMaybe<Scalars['Boolean']>;
  /** The email mapping of the SAML provider. */
  emailMapping?: InputMaybe<Scalars['String']>;
  /** The first name mapping of the SAML provider. */
  firstNameMapping?: InputMaybe<Scalars['String']>;
  /** The issuer URL of the SAML provider. */
  issuerUrl?: InputMaybe<Scalars['String']>;
  /** The last name mapping of the SAML provider. */
  lastNameMapping?: InputMaybe<Scalars['String']>;
  /** The name of the SAML provider. */
  name?: InputMaybe<Scalars['String']>;
  /** The promo codes mapping of the SAML provider. */
  promoCodesMapping?: InputMaybe<Scalars['String']>;
  /** The SLO target URL of the SAML provider. */
  sloTargetUrl?: InputMaybe<Scalars['String']>;
  /** The target URL of the SAML provider. */
  targetUrl?: InputMaybe<Scalars['String']>;
  /** Whether to trigger IDP logout. */
  triggerIdpLogout?: InputMaybe<Scalars['Boolean']>;
  /** The UID mapping of the SAML provider. */
  uidMapping?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateSAMLProvider */
export type UpdateSamlProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to update a SAMLProvider record */
  patch: UpdateSamlProviderAttributes;
  /** The ID of the SAMLProvider to update */
  samlProviderId: Scalars['ID'];
};

/** Autogenerated return type of UpdateSAMLProvider. */
export type UpdateSamlProviderPayload = {
  __typename?: 'UpdateSAMLProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The SAMLProvider that was updated. */
  samlProvider?: Maybe<SamlProvider>;
};

/** The saved query attributes. */
export type UpdateSavedQueryAttributes = {
  /** The description of the saved query. */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the saved query. */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the owner to own the saved query. */
  ownerId?: InputMaybe<Scalars['ID']>;
  /** The RQL code. */
  query?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateSavedQuery */
export type UpdateSavedQueryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The params which will update the saved query. */
  patch: UpdateSavedQueryAttributes;
  /** The ID of saved query to update. */
  savedQueryId: Scalars['ID'];
};

/** Autogenerated return type of UpdateSavedQuery. */
export type UpdateSavedQueryPayload = {
  __typename?: 'UpdateSavedQueryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The saved query. */
  savedQuery?: Maybe<SavedQuery>;
};

/** Autogenerated input type of UpdateSharedProduct */
export type UpdateSharedProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes to update. */
  patch: SharedProductAttributes;
  /** The ID of the shared product. */
  sharedProductId: Scalars['ID'];
};

/** Autogenerated return type of UpdateSharedProduct. */
export type UpdateSharedProductPayload = {
  __typename?: 'UpdateSharedProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The shared product that was updated. */
  sharedProduct?: Maybe<SharedProduct>;
};

/** Shipping information from an order. */
export type UpdateShippingInformationAttributes = {
  /** The company name to put on the package. */
  companyName?: InputMaybe<Scalars['String']>;
  /** The email address to notify about shipping details. */
  email: Scalars['String'];
  /** The name to put on the package. */
  name: Scalars['String'];
  /** The phone number to notify about shipping logistics. */
  phoneNumber: Scalars['String'];
};

/** The address attributew attributes. */
export type UpdateShoppingCartAddressAttributes = {
  /** The description of the saved query. */
  address: AddressAttributes;
  /** The name of the saved query. */
  kind: AddressKindEnum;
  /** Whether the shipping address is the same as billing */
  sameAddress?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateShoppingCartAddress */
export type UpdateShoppingCartAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The params which will update the address. */
  patch: UpdateShoppingCartAddressAttributes;
};

/** Autogenerated return type of UpdateShoppingCartAddress. */
export type UpdateShoppingCartAddressPayload = {
  __typename?: 'UpdateShoppingCartAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** A representation of shopping cart */
  shoppingCart?: Maybe<ShoppingCart>;
};

/** Autogenerated input type of UpdateShoppingCartShippingInformation */
export type UpdateShoppingCartShippingInformationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The params which will update the address. */
  patch: UpdateShippingInformationAttributes;
};

/** Autogenerated return type of UpdateShoppingCartShippingInformation. */
export type UpdateShoppingCartShippingInformationPayload = {
  __typename?: 'UpdateShoppingCartShippingInformationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** A representation of shopping cart */
  shoppingCart?: Maybe<ShoppingCart>;
};

/** Attributes needed to update a Storefront record */
export type UpdateStorefrontAttributes = {
  /** The address attributes. */
  address?: InputMaybe<UpdateAddressAttributes>;
  /** Whether address fields are present on signup. */
  addressOnSignup?: InputMaybe<Scalars['Boolean']>;
  /** Whether address fields are required on signup. */
  addressRequired?: InputMaybe<Scalars['Boolean']>;
  /** Whether to allow MFA trusted devices. */
  allowMfaTrustedDevices?: InputMaybe<Scalars['Boolean']>;
  /** The GST/HST number for the storefront. */
  businessNumber?: InputMaybe<Scalars['String']>;
  /** The contact method on signup for the storefront. */
  contactMethodOnSignup?: InputMaybe<Scalars['String']>;
  /** The description of the storefront. */
  description?: InputMaybe<Scalars['String']>;
  /** The contact email for the storefront. */
  email?: InputMaybe<Scalars['String']>;
  /** The email logo for the storefront. */
  emailLogo?: InputMaybe<AttacheUploadFile>;
  /** The Facebook profile of the storefront. */
  facebook?: InputMaybe<Scalars['String']>;
  /** The favicon for the storefront. */
  favicon?: InputMaybe<AttacheUploadFile>;
  /** The Google Adsense ID for the storefront. */
  googleAdsenseId?: InputMaybe<Scalars['String']>;
  /** The Google Analytics tracking ID for the storefront. */
  googleAnalyticsTrackingId?: InputMaybe<Scalars['String']>;
  /** The Google Webmaster Tools Site Verification ID for the storefront. */
  googleSiteVerificationId?: InputMaybe<Scalars['String']>;
  /** The Google Tag Manager ID for the storefront. */
  googleTagManagerId?: InputMaybe<Scalars['String']>;
  /** The locale of the storefront. */
  locale?: InputMaybe<Scalars['String']>;
  /** The name of the storefront. */
  name?: InputMaybe<Scalars['String']>;
  /** The order notification subscribers for the storefront. */
  orderNotificationSubscriberIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The owner of the storefront. */
  ownerId?: InputMaybe<Scalars['ID']>;
  /** The version of the page header for the storefront. */
  pageHeaderVersion?: InputMaybe<PageHeaderVersionTypeEnum>;
  /** The contact phone number for the storefront. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** The photo for the storefront. */
  photo?: InputMaybe<AttacheUploadFile>;
  /** The version of the product page for the storefront. */
  productPageVersion?: InputMaybe<ProductPageVersionTypeEnum>;
  /** The subdomain URL of the storefront. */
  subdomain?: InputMaybe<Scalars['String']>;
  /** The X profile of the storefront. */
  twitter?: InputMaybe<Scalars['String']>;
  /** The YouTube channel of the storefront. */
  youtube?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateStorefront */
export type UpdateStorefrontInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to update a Storefront record */
  patch: UpdateStorefrontAttributes;
  /** The ID of the Storefront to update */
  storefrontId: Scalars['ID'];
};

/** Autogenerated return type of UpdateStorefront. */
export type UpdateStorefrontPayload = {
  __typename?: 'UpdateStorefrontPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The Storefront that was updated. */
  storefront?: Maybe<Storefront>;
};

/** Attributes to update on a Stripe Subscription */
export type UpdateStripeSubscriptionAttributes = {
  /** Whether to cancel the subscription when the current period ends. */
  cancelAtPeriodEnd: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateStripeSubscription */
export type UpdateStripeSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes to update */
  patch: UpdateStripeSubscriptionAttributes;
  /** The ID of the subscription to cancel. */
  subscriptionId: Scalars['ID'];
};

/** Autogenerated return type of UpdateStripeSubscription. */
export type UpdateStripeSubscriptionPayload = {
  __typename?: 'UpdateStripeSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The updated stripe subscription. */
  stripeSubscription: StripeSubscriptionInterface;
  /** Whether the subscription was updated or not. */
  success: Scalars['Boolean'];
};

/** Attributes needed to update a survey. */
export type UpdateSurveySchemaAttributes = {
  /** Whether the survey can be closed or not. */
  closeable?: InputMaybe<Scalars['Boolean']>;
  /** The contents of the survey. */
  content?: InputMaybe<Scalars['JSON']>;
  /** The description of this survey. */
  description?: InputMaybe<Scalars['String']>;
  /** The name of this survey. */
  name?: InputMaybe<Scalars['String']>;
  /** The theme of the survey. */
  theme?: InputMaybe<Scalars['JSON']>;
};

/** Autogenerated input type of UpdateSurveySchema */
export type UpdateSurveySchemaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The patch of updates. */
  patch: UpdateSurveySchemaAttributes;
  /** The ID of the survey to update. */
  surveySchemaId: Scalars['ID'];
};

/** Autogenerated return type of UpdateSurveySchema. */
export type UpdateSurveySchemaPayload = {
  __typename?: 'UpdateSurveySchemaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
  /** The updated survey. */
  surveySchema?: Maybe<SurveySchema>;
};

/** Attributes needed to update a Theme record */
export type UpdateThemeAttributes = {
  /** The background color of the theme. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Custom CSS for the theme. */
  customLess?: InputMaybe<Scalars['String']>;
  /** The font name of the theme. */
  fontName?: InputMaybe<Scalars['String']>;
  /** Header liquid for the theme. */
  headerLiquid?: InputMaybe<Scalars['String']>;
  /** The name of the theme. */
  name?: InputMaybe<Scalars['String']>;
  /** The text color of the theme. */
  textColor?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateTheme */
export type UpdateThemeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Attributes needed to update a Theme record */
  patch: UpdateThemeAttributes;
  /** The ID of the Theme to update */
  themeId: Scalars['ID'];
};

/** Autogenerated return type of UpdateTheme. */
export type UpdateThemePayload = {
  __typename?: 'UpdateThemePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The Theme that was updated. */
  theme?: Maybe<Theme>;
};

/** Update training competency needs at lease one argument */
export type UpdateTrainingCompetencyAttributes = {
  /** The IDs of the courses for this training competency */
  courseIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Training competency description */
  description?: InputMaybe<Scalars['String']>;
  /** Training competency name */
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateTrainingCompetency */
export type UpdateTrainingCompetencyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The patch of updates. */
  patch: UpdateTrainingCompetencyAttributes;
  /** The ID of the training competency to be updated. */
  trainingCompetencyId: Scalars['ID'];
};

/** Autogenerated return type of UpdateTrainingCompetency. */
export type UpdateTrainingCompetencyPayload = {
  __typename?: 'UpdateTrainingCompetencyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The training competency. */
  trainingCompetency?: Maybe<TrainingCompetency>;
};

/** Update training role needs at lease one argument */
export type UpdateTrainingRoleAttributes = {
  /** Training role description */
  description?: InputMaybe<Scalars['String']>;
  /** Training role name */
  name?: InputMaybe<Scalars['String']>;
  /** The training competencies attached to the training role */
  trainingCompetencyIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated input type of UpdateTrainingRole */
export type UpdateTrainingRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The patch of updates. */
  patch: UpdateTrainingRoleAttributes;
  /** The ID of the training role to be updated */
  trainingRoleId: Scalars['ID'];
};

/** Autogenerated return type of UpdateTrainingRole. */
export type UpdateTrainingRolePayload = {
  __typename?: 'UpdateTrainingRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned */
  errors: Array<ValidationError>;
  /** The training role */
  trainingRole?: Maybe<TrainingRole>;
};

/** Attributes to update a user on the platform. */
export type UpdateUserAttributes = {
  /** A set of address values. */
  address?: InputMaybe<AddressAttributes>;
  /** A set of updated custom values. */
  customValues?: InputMaybe<Array<CustomValueAttributes>>;
  /** User email */
  email?: InputMaybe<Scalars['String']>;
  /** User first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** User last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** User language preference */
  locale?: InputMaybe<Scalars['String']>;
  /** User phone number */
  mobileNumber?: InputMaybe<Scalars['String']>;
  /** User notification method preference. */
  notificationType?: InputMaybe<NotificationTypeEnum>;
  /** User timezone */
  timeZone?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the user you want to update. */
  id: Scalars['Int'];
  /** The user attributes. */
  patch: UpdateUserAttributes;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors?: Maybe<Array<ValidationError>>;
  /** The updated user. */
  user?: Maybe<User>;
};

/** Attributes needed to update a Verified Credential Issuer. */
export type UpdateVerifiedCredentialIssuerAttributes = {
  /** Optional unique identifier to use when tracking analytics. */
  analyticsId?: InputMaybe<Scalars['String']>;
  /** Optional URL for a suggested Android wallet application. */
  androidAppUrl?: InputMaybe<Scalars['String']>;
  /** Optional content to allow deep linking into a wallet application. */
  appLinkPattern?: InputMaybe<Scalars['String']>;
  /** Optional content to help users get their course verified credential. */
  courseHtml?: InputMaybe<Scalars['String']>;
  /** Optional content to help users with the required prerequisites to get a verified credential. */
  helpHtml?: InputMaybe<Scalars['String']>;
  /** Optional URL for a suggested iOS wallet application. */
  iosAppUrl?: InputMaybe<Scalars['String']>;
  /** Name of the issuer. */
  name?: InputMaybe<Scalars['String']>;
  /** Optional content to help users verify their person verified credential. */
  personHtml?: InputMaybe<Scalars['String']>;
  /** The label for the button to launch the wizard. */
  preambleButtonLabel: Scalars['String'];
  /** The content to help users understand what verifiable credentials are. */
  preambleHtml: Scalars['String'];
  /** Optional content to show to help users get their initial credential to present for verification. */
  requiredPresentationHelpHtml?: InputMaybe<Scalars['String']>;
  /** Optional content to convince users why they should get a verified credential. */
  valuePropositionHtml?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateVerifiedCredentialIssuer */
export type UpdateVerifiedCredentialIssuerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The patch of updates. */
  patch: UpdateVerifiedCredentialIssuerAttributes;
  /** The ID of the issuer to update. */
  verifiedCredentialIssuerId: Scalars['ID'];
};

/** Autogenerated return type of UpdateVerifiedCredentialIssuer. */
export type UpdateVerifiedCredentialIssuerPayload = {
  __typename?: 'UpdateVerifiedCredentialIssuerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The issuer that was updated. */
  verifiedCredentialIssuer?: Maybe<VerifiedCredentialIssuer>;
};

/** Attributes needed to upload a certification. */
export type UploadCertificationAttributes = {
  /** The description of this certification. */
  description?: InputMaybe<Scalars['String']>;
  /** The date this certification will expire on. */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The date this certification was issued on. */
  issuedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The issuer name for this certification. */
  issuerName: Scalars['String'];
  /** The name of the certification. */
  name: Scalars['String'];
  /** The Attache details for connecting to the uploaded file. */
  originalBadgeImage: AttacheUploadFile;
};

/** Autogenerated input type of UploadCertification */
export type UploadCertificationInput = {
  /** The certification to upload. */
  certification: UploadCertificationAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UploadCertification. */
export type UploadCertificationPayload = {
  __typename?: 'UploadCertificationPayload';
  /** The newly created certification. */
  certification?: Maybe<Certification>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
};

/** Autogenerated input type of UploadILClassRosterLearner */
export type UploadIlClassRosterLearnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** String */
  courseId: Scalars['ID'];
  /** The instructor-led class which the learners will be enrolled in. */
  ilClassId: Scalars['ID'];
  /** The details required to find or create a user account which will be booked into the instructor-led class. */
  learner: LearnerAttributes;
};

/** Autogenerated return type of UploadILClassRosterLearner. */
export type UploadIlClassRosterLearnerPayload = {
  __typename?: 'UploadILClassRosterLearnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The booking created for the learner to attend the class. */
  ilBooking?: Maybe<IlBooking>;
  /** The instructor-led class that the learners are now enrolled in. */
  ilClass?: Maybe<IlClass>;
  /** The learner which is now enrolled in the class. */
  learner?: Maybe<LightUser>;
};

/** A subscription, via Stripe, to a plan which charges for usage on open licenses for a set of courses. */
export type UsageSubscription = RelayNode & StripeSubscriptionInterface & {
  __typename?: 'UsageSubscription';
  /** Whether the subscription is paid for continuous access to content. */
  accessControlled: Scalars['Boolean'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The time when the current period ends. */
  currentPeriodEnd: Scalars['ISO8601DateTime'];
  /** The time when the current period started. */
  currentPeriodStart: Scalars['ISO8601DateTime'];
  /** The grants tracked as usage during the current period for this subscription. */
  currentPeriodUsage: Array<Grant>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The licenses tied to this subscription. */
  licenses: Array<License>;
  /** Any paths for this subscription. */
  paths: StripeSubscriptionPaths;
  /** The number of seconds until the subscription will go into delinquency and be unusable. Is null while payment is in good standing. */
  secondsRemainingInArrears?: Maybe<Scalars['Int']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The status of the stripe subscription. */
  status: StripeSubscriptionStatusEnum;
  /** The Stripe customer. */
  stripeCustomer: StripeCustomer;
  /** The Stripe payment method which will be charged every billing period. */
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  /** The Stripe plan. */
  stripePlan: StripePlan;
  /** The Stripe ID for this subscription. */
  stripeSubscriptionId: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Whether the subscription is paid depending on usage during the time period. */
  usageControlled: Scalars['Boolean'];
};

/** Autogenerated input type of UseActivationCode */
export type UseActivationCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The code used to acivate the learners account. */
  token: Scalars['String'];
};

/** Autogenerated return type of UseActivationCode. */
export type UseActivationCodePayload = {
  __typename?: 'UseActivationCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors returned. */
  errors?: Maybe<Array<ValidationError>>;
  /** The user that was activated. */
  user?: Maybe<User>;
};

/** Autogenerated input type of UseEnrolmentKey */
export type UseEnrolmentKeyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The token to claim a grant. */
  token: Scalars['String'];
};

/** Autogenerated return type of UseEnrolmentKey. */
export type UseEnrolmentKeyPayload = {
  __typename?: 'UseEnrolmentKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any validation errors. */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The Grant that was unlocked. */
  grant?: Maybe<Grant>;
};

/** A person that can log into the system, buy things, take courses, etc. */
export type User = Commentable & RelayNode & Taggable & {
  __typename?: 'User';
  /** The user's primary address */
  address?: Maybe<Address>;
  /** Whether the user is permitted to opt out of venom ui. */
  allowVenomOptOut: Scalars['Boolean'];
  /** The gravatar url for this user. */
  avatarUrl: Scalars['String'];
  /** Any permissions you have relevant to the User. */
  can: UserPermissions;
  /** The certification default of the User. */
  certificationDefault?: Maybe<CertificationDefault>;
  /** Any certifications from courses the user has earned. Sorted in the same way as on /app/certifications */
  certifications?: Maybe<Array<Certification>>;
  /** The comments on this record. */
  comments?: Maybe<CommentConnection>;
  /** All contact methods the user has available. */
  contactMethods?: Maybe<Array<ContactMethod>>;
  /** Account information requirements on courses this user has access to. */
  courseRequirements: Array<CourseRequirement>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The currencies associated with all connected stripe accounts. */
  currencies: Array<Scalars['String']>;
  /** The time the user signed in. */
  currentSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** All custom fields for a user within the current storefront */
  customValues?: Maybe<Array<CustomValue>>;
  /** The email address of the User. */
  email?: Maybe<Scalars['String']>;
  /** The first name of the User. */
  firstName: Scalars['String'];
  /** The full name (first name + last name) of the User. */
  fullName: Scalars['String'];
  /** The global ID. */
  gid: Scalars['ID'];
  /** Any grants to courses the user has available. Sorted in the same way as on /app/grants */
  grants?: Maybe<Array<Grant>>;
  /** Any grants the user has available for a particular class. */
  grantsAvailableForClass: Array<Grant>;
  /** Whether the user has any stripe subscriptions. */
  hasStripeSubscriptions: Scalars['Boolean'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** All instructor-led bookings for a user */
  ilBookings?: Maybe<Array<IlBooking>>;
  /** The support agent who is impersonating the current user. */
  impersonatedBy?: Maybe<User>;
  /** A JWT that you can use to access the API. */
  jwt?: Maybe<Scalars['String']>;
  /**
   * A JWT that you can use to access the API.
   * @deprecated Use jwt instead
   */
  jwtToken?: Maybe<Scalars['String']>;
  /** The last name of the User. */
  lastName: Scalars['String'];
  /** The last time the user signed in. */
  lastSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** All organizations that have added this user that are also accessible by you. */
  linkedOrganizations: Array<Organization>;
  /** The desired language for User. */
  locale: Scalars['String'];
  /** Memory records for the user. */
  memories?: Maybe<Array<UserMemory>>;
  /** Whether the user might be a training manager. */
  mightBeTrainingManager: Scalars['Boolean'];
  /** The mobile number of the User. */
  mobileNumber?: Maybe<Scalars['String']>;
  /** The full name of the User. */
  name: Scalars['String'];
  /** The users desired method of notificaiton. */
  notificationType: NotificationTypeEnum;
  /** Terms of service that the user has not yet accepted. */
  pendingTermsOfServices: Array<TermsOfService>;
  /** The persona of this user. */
  persona: Scalars['String'];
  /** A profile image to use for the user. */
  profileImage: Scalars['String'];
  /** All open invitations the user has available. */
  receivedInvites?: Maybe<Array<Invite>>;
  /** The roles this user has. */
  roles: Array<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The tags on this object. */
  tags: Array<Tag>;
  /** The time zone of the User. */
  timeZone: Scalars['TimeZone'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A person that can log into the system, buy things, take courses, etc. */
export type UserAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


/** A person that can log into the system, buy things, take courses, etc. */
export type UserCertificationsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};


/** A person that can log into the system, buy things, take courses, etc. */
export type UserCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A person that can log into the system, buy things, take courses, etc. */
export type UserGrantsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};


/** A person that can log into the system, buy things, take courses, etc. */
export type UserGrantsAvailableForClassArgs = {
  ilClassId: Scalars['ID'];
};


/** A person that can log into the system, buy things, take courses, etc. */
export type UserIlBookingsArgs = {
  ilClassId?: InputMaybe<Scalars['ID']>;
};


/** A person that can log into the system, buy things, take courses, etc. */
export type UserJwtArgs = {
  age?: InputMaybe<Scalars['Int']>;
};


/** A person that can log into the system, buy things, take courses, etc. */
export type UserJwtTokenArgs = {
  age?: InputMaybe<Scalars['Int']>;
};


/** A person that can log into the system, buy things, take courses, etc. */
export type UserReceivedInvitesArgs = {
  onlyUnhandled?: InputMaybe<Scalars['Boolean']>;
};

/** Detects browser specifics for users to assist with support */
export type UserAgent = {
  __typename?: 'UserAgent';
  /** The browser as found in the user agent */
  browser: VersionedObject;
  /** The operating system as found in the user agent */
  os: VersionedObject;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** Total number of records in the connection */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** A memory record for a user. */
export type UserMemory = RelayNode & {
  __typename?: 'UserMemory';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Memory record name. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Memory record value. */
  value: Scalars['String'];
};

/** Permissions for a User. */
export type UserPermissions = {
  __typename?: 'UserPermissions';
  /** Whether this user can access /admin. */
  admin: Scalars['Boolean'];
  /** Whether this user can sell on the platform. */
  author: Scalars['Boolean'];
  /** Whether the user has an editable password or not. */
  changePassword: Scalars['Boolean'];
  /** Whether this user can create an instructor-led class. */
  createIlClass: Scalars['Boolean'];
  /** Whether this user can create an instructor-led course. */
  createIlCourse: Scalars['Boolean'];
  /** Whether this user can create an instructor-led location. */
  createIlLocation: Scalars['Boolean'];
  /** Whether this user can create an instructor. */
  createInstructor: Scalars['Boolean'];
  /** Whether the user is able to create Organizations. */
  createOrganization: Scalars['Boolean'];
  /** Whether this user can upgrade to selling on the platform. */
  ecommerceUpgrade: Scalars['Boolean'];
  /** Whether the user is able to export the ledger. */
  exportLedger: Scalars['Boolean'];
  /** The ID of the record these permissions are for. */
  gid: Scalars['ID'];
  /** Whether this user can grade learner assignments on the platform. */
  grade: Scalars['Boolean'];
  /** Whether this user can access the grader UI. */
  grader: Scalars['Boolean'];
  /** The integer ID of the record these permissions are for. */
  id: Scalars['Int'];
  /** Whether this user can access the instructor-led dashboard UI. */
  ilManager: Scalars['Boolean'];
  /** Whether this user can access the instructor UI. */
  instructor: Scalars['Boolean'];
  /** Whether this user can manage payment information. */
  managePaymentInformation: Scalars['Boolean'];
  /** Whether the user is able to manage training matrices. */
  manageTrainingMatrices: Scalars['Boolean'];
  /** Whether this user can provide support to users. */
  provideSupport: Scalars['Boolean'];
  /** Whether this user can run reports on course completions. */
  reportOnCourseCompletions: Scalars['Boolean'];
  /** Whether this user can run reports on license pack usage. */
  reportOnLicensePackUsage: Scalars['Boolean'];
  /** Whether this user can run reports on platform usage. */
  reportOnPlatformUsage: Scalars['Boolean'];
  /** Whether this user can run reports on regulator submissions. */
  reportOnRegulatorSubmissions: Scalars['Boolean'];
  /** Whether this user can resell on the platform. */
  resell: Scalars['Boolean'];
  /** Whether this user can show the invoices report. */
  showInvoicesReport: Scalars['Boolean'];
  /** Whether the user is able to see the ledger. */
  showLedger: Scalars['Boolean'];
  /** Whether this user can access sidekiq. */
  sidekiq: Scalars['Boolean'];
  /** Whether this user can manage surveys on the platform. */
  survey: Scalars['Boolean'];
  /** Whether this user can access the training manager features on the platform. */
  trainingManager: Scalars['Boolean'];
  /** Whether this user can sell on the platform. */
  vend: Scalars['Boolean'];
  /** Whether the user can access the classic administration interface. */
  visitClassic: Scalars['Boolean'];
};

/** Access users you have access to. */
export type UsersNamespace = {
  __typename?: 'UsersNamespace';
  /** Get all users who have access to an instructor-led class. */
  searchByIlClassAccess: UserConnection;
};


/** Access users you have access to. */
export type UsersNamespaceSearchByIlClassAccessArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ilClassId: Scalars['ID'];
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};

/** A validation error. */
export type ValidationError = {
  __typename?: 'ValidationError';
  /** The attribute that has the problem. */
  attribute?: Maybe<Scalars['String']>;
  /** The human description of what went wrong. */
  message: Scalars['String'];
};

/** Attributes to update the verification options for this course. */
export type VerificationOptionAttributes = {
  /** Enabled a maximum number of absences. */
  enableMaximumAbsent?: InputMaybe<Scalars['Boolean']>;
  /** Enable a maxiunm number of external assistance. */
  enableMaximumAssistance?: InputMaybe<Scalars['Boolean']>;
  /** Enable a minimum time requirement. */
  enableMinimumTime?: InputMaybe<Scalars['Boolean']>;
  /** Force new identification photos (face and I.D.) when starting new sessions. */
  forceNewIdentification?: InputMaybe<Scalars['Boolean']>;
  /** Hold back certification if verification requires review. */
  holdCertIfUnderReview?: InputMaybe<Scalars['Boolean']>;
  /** Maximum number of absence anomalies you're allowed to have. */
  maximumAbsent?: InputMaybe<Scalars['Int']>;
  /** Maximum number of assistance anomalies you're allowed to have. */
  maximumAssistance?: InputMaybe<Scalars['Int']>;
  /** Minimum amount of time you must spend in the course */
  minimumTime?: InputMaybe<Scalars['Int']>;
  /** Give it away for free. */
  optionalDuringCheckout?: InputMaybe<Scalars['Boolean']>;
  /** Restrict verification reviews to course author. */
  reviewsPerformedByAuthor?: InputMaybe<Scalars['Boolean']>;
};

/** The service level types for LearnerVerified */
export enum VerificationServiceTypeEnum {
  /** Automated Attendance */
  AutomatedAttendance = 'automated_attendance',
  /** Live ID Verification */
  LiveIdVerification = 'live_id_verification',
  /** LearnerVerified not enabled */
  NoVerification = 'no_verification'
}

/** A verified credential that has been issued. */
export type VerifiedCredential = RelayNode & {
  __typename?: 'VerifiedCredential';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The first name on the credential. Only valid for a "person"-type credential when the issuer is configured. */
  firstName?: Maybe<Scalars['String']>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** The last name on the credential. Only valid for a "person"-type credential when the issuer is configured. */
  lastName?: Maybe<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A verified credential issuer allows an organization to issue verified credentials. */
export type VerifiedCredentialIssuer = RelayNode & TermsOfServiceAgreeable & {
  __typename?: 'VerifiedCredentialIssuer';
  /** Unique identifier to use when tracking analytics. */
  analyticsId?: Maybe<Scalars['String']>;
  /** Optional URL for a suggested Android wallet application. */
  androidAppUrl?: Maybe<Scalars['String']>;
  /** Optional content to allow deep linking into a wallet application. */
  appLinkPattern?: Maybe<Scalars['String']>;
  /** Optional content to help users get their course verified credential. */
  courseHtml?: Maybe<Scalars['String']>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** Verification information for the current user. */
  currentUserVerification: VerifiedCredentialVerification;
  /** The global ID. */
  gid: Scalars['ID'];
  /** Optional content to help users with the required prerequisites to get a verified credential. */
  helpHtml?: Maybe<Scalars['String']>;
  /** The integer ID. */
  id: Scalars['Int'];
  /** The type of implementation for this issuer. */
  implementationType: Scalars['String'];
  /** Optional URL for a suggested iOS wallet application. */
  iosAppUrl?: Maybe<Scalars['String']>;
  /** Name of the issuer. */
  name: Scalars['String'];
  /** Optional content to help users verify their person credential. */
  personHtml?: Maybe<Scalars['String']>;
  /** The label for the button to launch the wizard. */
  preambleButtonLabel: Scalars['String'];
  /** The content to help users understand what verifiable credentials are. */
  preambleHtml: Scalars['String'];
  /** Optional content to show to help users get their initial credential to present for verification. */
  requiredPresentationHelpHtml?: Maybe<Scalars['String']>;
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** The applicable Terms of Service records tied to this object. */
  termsOfService: Array<TermsOfService>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Optional content to convince users why they should get a verified credential. */
  valuePropositionHtml?: Maybe<Scalars['String']>;
};

/** Valid statuses for a certification verified credential. */
export enum VerifiedCredentialStatusEnum {
  /** When the credential requires a separate person credential presentation but hasn't done so yet. */
  CredentialMissing = 'credential_missing',
  /** When the user does not have a confirmed email. */
  EmailMissing = 'email_missing',
  /** When the user has presented a person credential but the first name does not match. */
  FirstNameMismatch = 'first_name_mismatch',
  /** When the certification is configured for verified credentials but the issuer is not configured. */
  IssuerMissing = 'issuer_missing',
  /** When the user has presented a person credential but the last name does not match. */
  LastNameMismatch = 'last_name_mismatch',
  /** When the name on the certification does not match the user. */
  NameMismatch = 'name_mismatch',
  /** When the user has presented a person credential but a name field is missing. */
  NameMissing = 'name_missing',
  /** When the certification is not configured for verified credentials. */
  NotVerifiedCredential = 'not_verified_credential',
  /** When everything is good. */
  Ok = 'ok',
  /** When the current user is not the same as the user on the certification. */
  UserMismatch = 'user_mismatch'
}

/** The verification status of a user on a verified credential issuer. */
export type VerifiedCredentialVerification = {
  __typename?: 'VerifiedCredentialVerification';
  /** An error code if there was an error verifying the user. */
  error?: Maybe<Scalars['String']>;
  /** Whether the user is required to be verified. */
  verificationRequired: Scalars['Boolean'];
  /** Whether the user is verified. */
  verified: Scalars['Boolean'];
  /** The verified credential that was used to verify the user. */
  verifiedCredential?: Maybe<VerifiedCredential>;
};

/** A versioned object */
export type VersionedObject = {
  __typename?: 'VersionedObject';
  /** The name of the versioned object */
  name: Scalars['String'];
  /** The version of the versioned object */
  version: Scalars['String'];
};

/** A RapidQL view */
export type View = RelayNode & {
  __typename?: 'View';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created this record. */
  createdBy?: Maybe<LightUser>;
  /** The global ID. */
  gid: Scalars['ID'];
  /** The integer ID. */
  id: Scalars['Int'];
  /** Name of the view. */
  name: Scalars['String'];
  /** The signed global ID of this record. */
  sgid: Scalars['String'];
  /** Time to build the view. */
  timeToBuild?: Maybe<Scalars['Float']>;
  /** Time to index the view. */
  timeToIndex?: Maybe<Scalars['Float']>;
  /** Time to refresh the view. */
  timeToRefresh?: Maybe<Scalars['Float']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of ViewCourseAgreement */
export type ViewCourseAgreementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The course agreement you are viewing. */
  courseUserAgreementId: Scalars['ID'];
};

/** Autogenerated return type of ViewCourseAgreement. */
export type ViewCourseAgreementPayload = {
  __typename?: 'ViewCourseAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The updated course agreement. */
  courseUserAgreement?: Maybe<CourseUserAgreement>;
  /** Any validation errors. */
  errors: Array<ValidationError>;
};

/** Attributes needed for printable wall certificates on certification templates */
export type WallCertificateAttributes = {
  /** The HTML which will go on the certificate */
  front: Scalars['String'];
  /** The page orientation of the certificate */
  orientation: PageOrientation;
  /** The template to generate the wall certification (i.e. expert) */
  template: CertificationTemplateEditor;
};

/** Data used to build HTML and other representations of a wall certificate. */
export type WallCertificateOptions = {
  __typename?: 'WallCertificateOptions';
  /** The html which will go on the certificate */
  front?: Maybe<Scalars['String']>;
  /** The page orientation of the certificate */
  orientation: PageOrientation;
  /** The template type to generate the wall certificate (i.e. expert) */
  template: CertificationTemplateEditor;
};

/** Attributes needed for printable wallet cards on certification templates */
export type WalletCardAttributes = {
  /** The HTML which will go on the back of the card */
  back?: InputMaybe<Scalars['String']>;
  /** The HTML which will go on the front of the card */
  front: Scalars['String'];
  /** The template type to generate the wallet card (i.e. expert) */
  template: CertificationTemplateEditor;
};

/** Data used to build HTML and other representations of a wallet card certificate. */
export type WalletCardOptions = {
  __typename?: 'WalletCardOptions';
  /** The html which will go on the back of the card */
  back?: Maybe<Scalars['String']>;
  /** The html which will go on the front of the card */
  front?: Maybe<Scalars['String']>;
  /** The template type to generate the wallet card (i.e. expert) */
  template: CertificationTemplateEditor;
};

export type AddProductToCartMutationVariables = Exact<{
  input: AddProductToCartInput;
}>;


export type AddProductToCartMutationResult = { __typename?: 'Mutation', addProductToCart?: { __typename?: 'AddProductToCartPayload', shoppingCart: { __typename?: 'ShoppingCart', expectedTotal: number, expectedTotalCents: number, expectedShipping: number, expectedTax: number, expectedSubtotal: number, requiresShipping: boolean, userId: number, cartItems: Array<{ __typename?: 'CartItem', id: number, gid: string, bulkDiscountApplied: boolean, quantity: number, total: number, fullPrice: number, splitPromo: boolean, price: number, totalTaxed: number, promoPriceQuantity?: number | null, quantityRemainder?: number | null, product: { __typename?: 'Product', isInstructorLed: boolean, id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }, promoCodeClaim?: { __typename?: 'PromoCodeClaim', id: number, gid: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, description: string, code: string } | null, pendingIlBookingReservations: Array<{ __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } }> }>, taxes: Array<{ __typename?: 'TaxItemBase', amount: number, rate: number, description: string }>, billingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, shippingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string, stripePublishableKey: string, currency: { __typename?: 'Currency', isoCode: string, name: string } }, shippingInformation?: { __typename?: 'ShoppingCartShippingInformation', name: string, email: string, phoneNumber?: string | null, companyName?: string | null } | null }, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type LoadCartItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadCartItemsQueryResult = { __typename?: 'Query', cartItems?: { __typename?: 'CartItemsNamespace', all: { __typename?: 'CartItemConnection', nodes?: Array<{ __typename?: 'CartItem', id: number, gid: string, bulkDiscountApplied: boolean, quantity: number, total: number, fullPrice: number, splitPromo: boolean, price: number, totalTaxed: number, promoPriceQuantity?: number | null, quantityRemainder?: number | null, product: { __typename?: 'Product', isInstructorLed: boolean, id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }, promoCodeClaim?: { __typename?: 'PromoCodeClaim', id: number, gid: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, description: string, code: string } | null, pendingIlBookingReservations: Array<{ __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } }> } | null> | null } } | null };

export type UpdateCartItemMutationVariables = Exact<{
  input: UpdateCartItemInput;
}>;


export type UpdateCartItemMutationResult = { __typename?: 'Mutation', updateCartItem?: { __typename?: 'UpdateCartItemPayload', shoppingCart: { __typename?: 'ShoppingCart', expectedTotal: number, expectedTotalCents: number, expectedShipping: number, expectedTax: number, expectedSubtotal: number, requiresShipping: boolean, userId: number, cartItems: Array<{ __typename?: 'CartItem', id: number, gid: string, bulkDiscountApplied: boolean, quantity: number, total: number, fullPrice: number, splitPromo: boolean, price: number, totalTaxed: number, promoPriceQuantity?: number | null, quantityRemainder?: number | null, product: { __typename?: 'Product', isInstructorLed: boolean, id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }, promoCodeClaim?: { __typename?: 'PromoCodeClaim', id: number, gid: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, description: string, code: string } | null, pendingIlBookingReservations: Array<{ __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } }> }>, taxes: Array<{ __typename?: 'TaxItemBase', amount: number, rate: number, description: string }>, billingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, shippingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string, stripePublishableKey: string, currency: { __typename?: 'Currency', isoCode: string, name: string } }, shippingInformation?: { __typename?: 'ShoppingCartShippingInformation', name: string, email: string, phoneNumber?: string | null, companyName?: string | null } | null }, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type LoadChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadChangeRequestsQueryResult = { __typename?: 'Query', certificationChangeRequests?: { __typename?: 'CertificationChangeRequestsNamespace', all: { __typename?: 'CertificationChangeRequestConnection', count: number, nodes?: Array<{ __typename?: 'CertificationChangeRequest', id: number, gid: string, userFirstName: string, userLastName: string, issuerName: string, reason: string, issuerAddress?: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } | null, can: { __typename?: 'CertificationChangeRequestPermissions', id: number, gid: string, approve: boolean, decline: boolean }, certification: { __typename?: 'Certification', id: number, gid: string, name: string, userFirstName: string, userLastName: string, issuerName: string, badgeUrl: string, issuerAddress?: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } | null }, createdBy?: { __typename?: 'LightUser', id: number, gid: string, fullName: string } | null, verifiedCredential?: { __typename?: 'VerifiedCredential', id: number, gid: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } } | null };

export type LoadPendingChangeRequestsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadPendingChangeRequestsCountQueryResult = { __typename?: 'Query', certificationChangeRequests?: { __typename?: 'CertificationChangeRequestsNamespace', all: { __typename?: 'CertificationChangeRequestConnection', count: number } } | null };

export type UpdateCertificationChangeRequestMutationVariables = Exact<{
  input: UpdateCertificationChangeRequestInput;
}>;


export type UpdateCertificationChangeRequestMutationResult = { __typename?: 'Mutation', updateCertificationChangeRequest?: { __typename?: 'UpdateCertificationChangeRequestPayload', certificationChangeRequest?: { __typename?: 'CertificationChangeRequest', id: number, gid: string } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreateCertificationTemplateMutationVariables = Exact<{
  input: CreateCertificationTemplateInput;
}>;


export type CreateCertificationTemplateMutationResult = { __typename?: 'Mutation', createCertificationTemplate?: { __typename?: 'CreateCertificationTemplatePayload', certificationTemplate: { __typename?: 'CertificationTemplate', id: number, gid: string, name: string, description?: string | null, daysValid?: number | null, remindersDisabled: boolean, digitalBadgeImage: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, contentType: string, geometry?: string | null, signature: string } }, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateEntraManifestMutationVariables = Exact<{
  input: CreateEntraManifestInput;
}>;


export type CreateEntraManifestMutationResult = { __typename?: 'Mutation', createEntraManifest?: { __typename?: 'CreateEntraManifestPayload', errors: Array<string>, certificationTemplate?: { __typename?: 'CertificationTemplate', id: number, gid: string, name: string, description?: string | null, credentialConfiguration?: { __typename?: 'MicrosoftEntraCredentialConfiguration', id: number, gid: string, manifestUrl: string, textColor: string, backgroundColor: string } | { __typename?: 'TractionCredentialConfiguration' } | null, verifiedCredentialIssuer?: { __typename?: 'VerifiedCredentialIssuer', id: number, gid: string, name: string, implementationType: string } | null } | null } | null };

export type LoadCertificationTemplateDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadCertificationTemplateDetailsQueryResult = { __typename?: 'Query', certificationTemplates?: { __typename?: 'CertificationTemplatesNamespace', findById: { __typename?: 'CertificationTemplate', id: number, gid: string, name: string, description?: string | null, daysValid?: number | null, remindersDisabled: boolean, digitalBadgeImage: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, contentType: string, geometry?: string | null, signature: string }, walletCardOptions?: { __typename?: 'WalletCardOptions', template: CertificationTemplateEditor, front?: string | null, back?: string | null } | null, wallCertificateOptions?: { __typename?: 'WallCertificateOptions', template: CertificationTemplateEditor, orientation: PageOrientation, front?: string | null } | null, credentialConfiguration?: { __typename?: 'MicrosoftEntraCredentialConfiguration', id: number, gid: string, manifestUrl: string, textColor: string, backgroundColor: string } | { __typename?: 'TractionCredentialConfiguration' } | null, verifiedCredentialIssuer?: { __typename?: 'VerifiedCredentialIssuer', id: number, gid: string, name: string, implementationType: string } | null, can: { __typename?: 'CertificationTemplatePermissions', id: number, gid: string, createEntraManifest: boolean } } } | null };

export type LoadCertificationTemplateListQueryVariables = Exact<{
  organizationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LoadCertificationTemplateListQueryResult = { __typename?: 'Query', certificationTemplates?: { __typename?: 'CertificationTemplatesNamespace', all: { __typename?: 'CertificationTemplateConnection', nodes?: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string, description?: string | null, daysValid?: number | null, remindersDisabled: boolean, digitalBadgeImage: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, contentType: string, geometry?: string | null, signature: string } } | null> | null } } | null };

export type UpdateCertificationTemplateMutationVariables = Exact<{
  input: UpdateCertificationTemplateInput;
}>;


export type UpdateCertificationTemplateMutationResult = { __typename?: 'Mutation', updateCertificationTemplate?: { __typename?: 'UpdateCertificationTemplatePayload', certificationTemplate?: { __typename?: 'CertificationTemplate', id: number, gid: string, name: string, description?: string | null, daysValid?: number | null, remindersDisabled: boolean, digitalBadgeImage: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, contentType: string, geometry?: string | null, signature: string }, walletCardOptions?: { __typename?: 'WalletCardOptions', template: CertificationTemplateEditor, front?: string | null, back?: string | null } | null, wallCertificateOptions?: { __typename?: 'WallCertificateOptions', template: CertificationTemplateEditor, orientation: PageOrientation, front?: string | null } | null, courseItem?: { __typename?: 'CourseItem', id: number, gid: string } | null } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CertificationPartsFragment = { __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } };

export type CreateCertificationChangeRequestMutationVariables = Exact<{
  input: CreateCertificationChangeRequestInput;
}>;


export type CreateCertificationChangeRequestMutationResult = { __typename?: 'Mutation', createCertificationChangeRequest?: { __typename?: 'CreateCertificationChangeRequestPayload', changeRequest: { __typename?: 'CertificationChangeRequest', id: number, gid: string, certificationId: number, userFirstName: string, userLastName: string, issuerName: string, reason: string, issuerAddress?: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } | null }, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type LoadCertificationDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadCertificationDetailsQueryResult = { __typename?: 'Query', certifications: { __typename?: 'CertificationsNamespace', findById?: { __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, verifiedCredentialIssuer?: { __typename?: 'VerifiedCredentialIssuer', id: number, gid: string, name: string, analyticsId?: string | null, valuePropositionHtml?: string | null, requiredPresentationHelpHtml?: string | null, helpHtml?: string | null, iosAppUrl?: string | null, androidAppUrl?: string | null, preambleButtonLabel: string, preambleHtml: string, personHtml?: string | null, courseHtml?: string | null, appLinkPattern?: string | null, currentUserVerification: { __typename?: 'VerifiedCredentialVerification', verificationRequired: boolean, verified: boolean, error?: string | null, verifiedCredential?: { __typename?: 'VerifiedCredential', id: number, gid: string, firstName?: string | null, lastName?: string | null } | null }, termsOfService: Array<{ __typename?: 'TermsOfService', id: number, gid: string, name: string, agreed: boolean, fileUrl: string, userAgreements: Array<{ __typename?: 'TermsOfServiceUserAgreement', id: number, gid: string, createdAt: Date }> }> } | null, issuerAddress?: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } | null, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } } | null } };

export type LoadLearnerCertificationListQueryVariables = Exact<{
  includeArchived: Scalars['Boolean'];
}>;


export type LoadLearnerCertificationListQueryResult = { __typename?: 'Query', viewer?: { __typename?: 'User', id: number, certifications?: Array<{ __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } }> | null } | null };

export type LoadTrainingManagerCertificationListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadTrainingManagerCertificationListQueryResult = { __typename?: 'Query', certifications: { __typename?: 'CertificationsNamespace', all: { __typename?: 'CertificationConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, user?: { __typename?: 'User', id: number, sgid: string, fullName: string, email?: string | null, mobileNumber?: string | null } | null, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } } | null> | null } } };

export type PostCertificationToCrediveraMutationVariables = Exact<{
  input: PostCertificationToCrediveraInput;
}>;


export type PostCertificationToCrediveraMutationResult = { __typename?: 'Mutation', postCertificationToCredivera?: { __typename?: 'PostCertificationToCrediveraPayload', ok: boolean, message?: string | null } | null };

export type UploadCertificationMutationVariables = Exact<{
  input: UploadCertificationInput;
}>;


export type UploadCertificationMutationResult = { __typename?: 'Mutation', uploadCertification?: { __typename?: 'UploadCertificationPayload', certification?: { __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

type Comments_IlBooking_Fragment = { __typename?: 'ILBooking', id: number, gid: string, comments?: { __typename?: 'CommentConnection', nodes?: Array<{ __typename?: 'Comment', id: number, gid: string } | null> | null } | null };

type Comments_User_Fragment = { __typename?: 'User', id: number, gid: string, comments?: { __typename?: 'CommentConnection', nodes?: Array<{ __typename?: 'Comment', id: number, gid: string } | null> | null } | null };

export type CommentsFragment = Comments_IlBooking_Fragment | Comments_User_Fragment;

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutationResult = { __typename?: 'Mutation', createComment?: { __typename?: 'CreateCommentPayload', errors: Array<{ __typename?: 'ValidationError', message: string }>, comment?: { __typename?: 'Comment', id: number, gid: string, content: string, createdAt: Date, can: { __typename?: 'CommentPermissions', id: number, gid: string, destroy: boolean }, author: { __typename?: 'LightUser', id: number, gid: string, fullName: string, avatarUrl: string }, organization: { __typename?: 'Organization', id: number, gid: string, name: string } } | null } | null };

export type LoadCommentsForCommentableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadCommentsForCommentableQueryResult = { __typename?: 'Query', comments?: { __typename?: 'CommentsNamespace', all: { __typename?: 'CommentConnection', nodes?: Array<{ __typename?: 'Comment', id: number, gid: string, content: string, createdAt: Date, author: { __typename?: 'LightUser', id: number, gid: string, fullName: string, avatarUrl: string }, organization: { __typename?: 'Organization', id: number, gid: string, name: string }, can: { __typename?: 'CommentPermissions', id: number, gid: string, destroy: boolean } } | null> | null } } | null };

export type LoadCourseItemProgressionQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type LoadCourseItemProgressionQueryResult = { __typename?: 'Query', courseItemProgressions: { __typename?: 'CourseItemProgressionsNamespace', findById?: { __typename?: 'CourseItemProgression', id: number, gid: string, name: string, status: CourseItemProgressionStatusEnum, type: string, ready: boolean, runnable: boolean, openable: boolean, practiceable: boolean, reviewable: boolean, attemptsRemaining?: number | null, progress: number, completed: boolean, score?: number | null, url?: string | null, gradedAssignmentSubmissionsClosedAt?: Date | null, can: { __typename?: 'CourseItemProgressionPermissions', submitGradedAssignment: boolean }, ilBooking?: { __typename?: 'ILBooking', id: number, gid: string, can: { __typename?: 'ILBookingPermissions', id: number, gid: string, cancel: boolean }, ilClassResults: Array<{ __typename?: 'ILClassResult', id: number, gid: string, attendance?: boolean | null, passed?: boolean | null, grade?: string | null, ilCourseItem: { __typename?: 'ILCourseItem', id: number, gid: string, name: string, position: number, trackAttendance: boolean, trackGrade: boolean } }>, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, bookingStartsAt?: Date | null, bookingEndsAt?: Date | null, bookingWindow: { __typename?: 'BookingWindow', startsAt?: any | null, endsAt: any }, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string, learnerFiles?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null }, instructors: Array<{ __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, email?: string | null }>, ilSessions: Array<{ __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string, ilLocation: { __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILOnlineLocation', url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILPhysicalLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } } }> } } | null, courseItem: { __typename?: 'CourseItem', id: number, gid: string, contentType: string, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null }, gradedAssignmentSettings?: { __typename?: 'GradedAssignmentSettings', id: number, gid: string, maxPoints: number, passingGrade: number } | null, gradedAssignmentSubmissions: Array<{ __typename?: 'GradedAssignmentSubmission', id: number, gid: string, createdAt: Date, passedAt?: Date | null, failedAt?: Date | null, points?: number | null, file: { __typename?: 'AttacheFile', url: string, contentType: string } }>, latestGradedAssignmentSubmission?: { __typename?: 'GradedAssignmentSubmission', id: number, gid: string, points?: number | null, file: { __typename?: 'AttacheFile', url: string, contentType: string } } | null, courseProgression: { __typename?: 'CourseProgression', id: number, gid: string, status: CourseProgressionStatusEnum, percentComplete: number, grant: { __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, certification?: { __typename?: 'Certification', id: number, gid: string, badgeUrl: string } | null } } } | null } };

export type MarkCourseItemProgressionCompleteMutationVariables = Exact<{
  input: MarkCourseItemProgressionCompleteInput;
}>;


export type MarkCourseItemProgressionCompleteMutationResult = { __typename?: 'Mutation', markCourseItemProgressionComplete?: { __typename?: 'MarkCourseItemProgressionCompletePayload', item?: { __typename?: 'CourseItemProgression', id: number, gid: string, runnable: boolean, progress: number, status: CourseItemProgressionStatusEnum, completed: boolean, courseProgression: { __typename?: 'CourseProgression', id: number, percentComplete: number, grant: { __typename?: 'Grant', id: number, certification?: { __typename?: 'Certification', id: number, gid: string, badgeUrl: string } | null } } } | null } | null };

export type ReviewCourseItemProgressionMutationVariables = Exact<{
  input: ReviewCourseItemProgressionInput;
}>;


export type ReviewCourseItemProgressionMutationResult = { __typename?: 'Mutation', reviewCourseItemProgression?: { __typename?: 'ReviewCourseItemProgressionPayload', review: { __typename?: 'LaunchInformation', url?: string | null, error?: string | null } } | null };

export type RunCourseItemProgressionMutationVariables = Exact<{
  input: RunCourseItemProgressionInput;
}>;


export type RunCourseItemProgressionMutationResult = { __typename?: 'Mutation', runCourseItemProgression?: { __typename?: 'RunCourseItemProgressionPayload', launch: { __typename?: 'LaunchInformation', url?: string | null, error?: string | null }, item: { __typename?: 'CourseItemProgression', id: number, gid: string, runnable: boolean, openable: boolean, attemptsRemaining?: number | null, practiceable: boolean, reviewable: boolean, progress: number, status: CourseItemProgressionStatusEnum, completed: boolean, courseProgression: { __typename?: 'CourseProgression', id: number, percentComplete: number, grant: { __typename?: 'Grant', id: number, status: GrantStatusEnum, certification?: { __typename?: 'Certification', id: number, gid: string, badgeUrl: string } | null } } } } | null };

export type UpdateCourseItemProgressionProgressMutationVariables = Exact<{
  input: UpdateCourseItemProgressionProgressInput;
}>;


export type UpdateCourseItemProgressionProgressMutationResult = { __typename?: 'Mutation', updateCourseItemProgressionProgress?: { __typename?: 'UpdateCourseItemProgressionProgressPayload', item?: { __typename?: 'CourseItemProgression', id: number, gid: string, runnable: boolean, progress: number, status: CourseItemProgressionStatusEnum, completed: boolean, courseProgression: { __typename?: 'CourseProgression', id: number, percentComplete: number, grant: { __typename?: 'Grant', id: number, certification?: { __typename?: 'Certification', id: number, gid: string, badgeUrl: string } | null } } } | null } | null };

export type AddCourseToStorefrontMutationVariables = Exact<{
  input: AddCourseToStorefrontInput;
}>;


export type AddCourseToStorefrontMutationResult = { __typename?: 'Mutation', addCourseToStorefront?: { __typename?: 'AddCourseToStorefrontPayload', course: { __typename?: 'Course', id: number, gid: string, name: string }, product?: { __typename?: 'Product', id: number, gid: string, name: string } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type AddExamToCourseMutationVariables = Exact<{
  input: AddExamToCourseInput;
}>;


export type AddExamToCourseMutationResult = { __typename?: 'Mutation', addExamToCourse?: { __typename?: 'AddExamToCoursePayload', course: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> }> } } | null };

export type AddGradedAssignmentToCourseMutationVariables = Exact<{
  input: AddGradedAssignmentToCourseInput;
}>;


export type AddGradedAssignmentToCourseMutationResult = { __typename?: 'Mutation', addGradedAssignmentToCourse?: { __typename?: 'AddGradedAssignmentToCoursePayload', course: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> }> }, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type AddItemToCourseMutationVariables = Exact<{
  input: AddItemToCourseInput;
}>;


export type AddItemToCourseMutationResult = { __typename?: 'Mutation', addItemToCourse?: { __typename?: 'AddItemToCoursePayload', course: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> }> }, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type AddLinkToCourseMutationVariables = Exact<{
  input: AddLinkToCourseInput;
}>;


export type AddLinkToCourseMutationResult = { __typename?: 'Mutation', addLinkToCourse?: { __typename?: 'AddLinkToCoursePayload', course: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> }> }, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type AgreeToCourseAgreementMutationVariables = Exact<{
  input: AgreeToCourseAgreementInput;
}>;


export type AgreeToCourseAgreementMutationResult = { __typename?: 'Mutation', agreeToCourseAgreement?: { __typename?: 'AgreeToCourseAgreementPayload', courseUserAgreement?: { __typename?: 'CourseUserAgreement', id: number, gid: string, viewedAt?: Date | null, agreedAt?: Date | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CourseAgreementsFragment = { __typename?: 'Course', id: number, courseAgreements: Array<{ __typename?: 'CourseAgreement', id: number, gid: string, name: string, fileUrl: string }> };

export type CourseUserAgreementsFragment = { __typename?: 'CourseUserAgreement', id: number, gid: string, viewedAt?: Date | null, agreedAt?: Date | null, courseAgreement: { __typename?: 'CourseAgreement', id: number, gid: string, name: string, fileUrl: string } };

export type CreateCourseAgreementMutationVariables = Exact<{
  input: CreateCourseAgreementInput;
}>;


export type CreateCourseAgreementMutationResult = { __typename?: 'Mutation', createCourseAgreement?: { __typename?: 'CreateCourseAgreementPayload', courseAgreement?: { __typename?: 'CourseAgreement', id: number, gid: string, name: string, fileUrl: string } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreateCoursePromptMutationVariables = Exact<{
  input: CreateCoursePromptInput;
}>;


export type CreateCoursePromptMutationResult = { __typename?: 'Mutation', createCoursePrompt?: { __typename?: 'CreateCoursePromptPayload', coursePrompt?: { __typename?: 'CoursePrompt', id: number, gid: string, minimumTime: number, maximumTime: number, customFieldCourseRequirements?: Array<{ __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> }> | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreateCourseRequirementMutationVariables = Exact<{
  input: CreateCourseRequirementInput;
}>;


export type CreateCourseRequirementMutationResult = { __typename?: 'Mutation', createCourseRequirement?: { __typename?: 'CreateCourseRequirementPayload', courseRequirement?: { __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, course: { __typename?: 'Course', id: number, gid: string, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum }> } } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, course: { __typename?: 'Course', id: number, gid: string, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum }> } } | { __typename?: 'PrerequisiteCourseRequirement' } | null } | null };

export type CreateCourseResourceLinkMutationVariables = Exact<{
  input: CreateCourseResourceLinkInput;
}>;


export type CreateCourseResourceLinkMutationResult = { __typename?: 'Mutation', createCourseResourceLink?: { __typename?: 'CreateCourseResourceLinkPayload', errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }>, resourceLink?: { __typename?: 'ResourceLink', id: number, gid: string, name: string, url: string } | null } | null };

export type CreateCourseMutationVariables = Exact<{
  input: CreateCourseInput;
}>;


export type CreateCourseMutationResult = { __typename?: 'Mutation', createCourse?: { __typename?: 'CreateCoursePayload', course?: { __typename?: 'Course', id: number, gid: string, name: string, shortDescription?: string | null, locale: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> }> } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreateCustomFieldCourseRequirementMutationVariables = Exact<{
  input: CreateCustomFieldCourseRequirementInput;
}>;


export type CreateCustomFieldCourseRequirementMutationResult = { __typename?: 'Mutation', createCustomFieldCourseRequirement?: { __typename?: 'CreateCustomFieldCourseRequirementPayload', customFieldCourseRequirement?: { __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, course: { __typename?: 'Course', id: number, gid: string, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum }> }, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreatePrerequisiteCourseRequirementMutationVariables = Exact<{
  input: CreatePrerequisiteCourseRequirementInput;
}>;


export type CreatePrerequisiteCourseRequirementMutationResult = { __typename?: 'Mutation', createPrerequisiteCourseRequirement?: { __typename?: 'CreatePrerequisiteCourseRequirementPayload', prerequisiteCourseRequirement?: { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, requirementType: PrerequisiteCourseRequirementRequirementTypeEnum, requirementQuantity: number, course: { __typename?: 'Course', id: number, gid: string, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum }> }, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type DeprecateCourseMutationVariables = Exact<{
  input: DeprecateCourseInput;
}>;


export type DeprecateCourseMutationResult = { __typename?: 'Mutation', deprecateCourse?: { __typename?: 'DeprecateCoursePayload', course: { __typename?: 'Course', id: number, gid: string, name: string, deprecatedAt?: Date | null }, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type LoadCourseDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadCourseDetailsQueryResult = { __typename?: 'Query', courses?: { __typename?: 'CoursesNamespace', findById: { __typename?: 'Course', id: number, gid: string, categories: Array<string>, contents?: string | null, createdAt: Date, deprecatedAt?: Date | null, description?: string | null, discussionForums: boolean, estimatedCompletionTime?: number | null, expireLicensesAfterDays?: number | null, expireLicensesAt?: Date | null, expireGrantsAfterDays?: number | null, locale: string, mobile: boolean, name: string, ordered: boolean, ownerId: string, summary?: string | null, surveySchemaId?: number | null, sellCourse: boolean, shortDescription?: string | null, verificationServices: string, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, courseAgreements: Array<{ __typename?: 'CourseAgreement', id: number, gid: string, name: string, fileUrl: string }>, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> }>, coursePrompt?: { __typename?: 'CoursePrompt', id: number, gid: string, minimumTime: number, maximumTime: number, customFieldCourseRequirements?: Array<{ __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> }> | null } | null, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, surveySchema?: { __typename?: 'SurveySchema', id: number, gid: string, name: string } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, productDefault?: { __typename?: 'ProductDefault', id: number, gid: string, bookDuringPurchase: BookDuringPurchaseEnum, bulkDiscounts: boolean, sku?: string | null, taxesEnabled: boolean, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, prices: Array<{ __typename?: 'Price', id: number, gid: string, currency: string, value: number }> } | null, resources?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null, resourceLinks: Array<{ __typename?: 'ResourceLink', id: number, gid: string, name: string, url: string }>, verificationOptions?: { __typename?: 'CourseVerificationOptions', forceNewIdentification: boolean, holdCertIfUnderReview: boolean, reviewsPerformedByAuthor: boolean, optionalDuringCheckout: boolean, enableMinimumTime: boolean, minimumTime: number, enableMaximumAbsent: boolean, maximumAbsent: number, enableMaximumAssistance: boolean, maximumAssistance: number } | null, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, satisfied: boolean, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null }> } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, requirementType: PrerequisiteCourseRequirementRequirementTypeEnum, requirementQuantity: number, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }> }>, certificationTemplate?: { __typename?: 'CertificationTemplate', id: number, gid: string, name: string, description?: string | null, daysValid?: number | null, remindersDisabled: boolean, digitalBadgeImage: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, courseItem?: { __typename?: 'CourseItem', id: number, gid: string, name: string } | null, walletCardOptions?: { __typename?: 'WalletCardOptions', template: CertificationTemplateEditor, front?: string | null, back?: string | null } | null, wallCertificateOptions?: { __typename?: 'WallCertificateOptions', template: CertificationTemplateEditor, orientation: PageOrientation, front?: string | null } | null } | null } } | null };

export type LoadRegulatorSubmissionConfiguredCourseListQueryVariables = Exact<{
  organizationIds: Array<Scalars['ID']> | Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadRegulatorSubmissionConfiguredCourseListQueryResult = { __typename?: 'Query', courses?: { __typename?: 'CoursesNamespace', configuredForRegulatorSubmission: { __typename?: 'CourseConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Course', id: number, gid: string, name: string } | null> | null } } | null };

export type LoadRegulatorSubmissionCourseListQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadRegulatorSubmissionCourseListQueryResult = { __typename?: 'Query', courses?: { __typename?: 'CoursesNamespace', availableForRegulatorSubmission: { __typename?: 'CourseConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Course', id: number, gid: string, name: string } | null> | null } } | null };

export type LoadCourseListQueryVariables = Exact<{
  openlyLicensed?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadCourseListQueryResult = { __typename?: 'Query', courses?: { __typename?: 'CoursesNamespace', all: { __typename?: 'CourseConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Course', id: number, gid: string, name: string, deprecatedAt?: Date | null, verificationServices: string, photo?: { __typename?: 'AttacheFile', url: string } | null, can: { __typename?: 'CoursePermissions', id: number, gid: string, update: boolean, license: boolean, destroy: boolean, deprecate: boolean }, owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | null> | null } } | null };

export type LoadCoursePromptQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadCoursePromptQueryResult = { __typename?: 'Query', courses?: { __typename?: 'CoursesNamespace', findById: { __typename?: 'Course', coursePrompt?: { __typename?: 'CoursePrompt', id: number, gid: string, minimumTime: number, maximumTime: number, customFieldCourseRequirements?: Array<{ __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> }> | null } | null } } | null };

export type LoadCourseUsageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadCourseUsageQueryResult = { __typename?: 'Query', courses?: { __typename?: 'CoursesNamespace', findById: { __typename?: 'Course', id: number, gid: string, usageInformation: { __typename?: 'CourseUsage', grantCount: number, inviteCount: number, licenseCount: number, productCount: number } } } | null };

export type LoadCourseUserAgreementDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadCourseUserAgreementDetailsQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement', id: number, gid: string, viewedAt?: Date | null, agreedAt?: Date | null, courseAgreement: { __typename?: 'CourseAgreement', id: number, gid: string, name: string, fileUrl: string } } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type LoadCoursesBookableForIlClassQueryVariables = Exact<{
  ilClassId: Scalars['ID'];
}>;


export type LoadCoursesBookableForIlClassQueryResult = { __typename?: 'Query', courses?: { __typename?: 'CoursesNamespace', bookableForIlClass: { __typename?: 'CourseConnection', nodes?: Array<{ __typename?: 'Course', id: number, gid: string, name: string } | null> | null } } | null };

export type LoadLearnerCourseListQueryVariables = Exact<{
  includeArchived: Scalars['Boolean'];
}>;


export type LoadLearnerCourseListQueryResult = { __typename?: 'Query', viewer?: { __typename?: 'User', id: number, gid: string, grants?: Array<{ __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, createdAt?: Date | null, archived: boolean, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, percentComplete: number, completedAt?: Date | null } | null, can: { __typename?: 'GrantPermissions', id: number, gid: string, run: boolean, archive: boolean, unarchive: boolean }, certification?: { __typename?: 'Certification', id: number, gid: string, number: string, name: string, issuerName: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string } | null, course: { __typename?: 'Course', id: number, gid: string, name: string, verificationServices: string, deprecatedAt?: Date | null, createdAt: Date, photo?: { __typename?: 'AttacheFile', url: string } | null, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, can: { __typename?: 'CoursePermissions', id: number, gid: string, destroy: boolean }, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, satisfied: boolean } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, requirementType: PrerequisiteCourseRequirementRequirementTypeEnum, requirementQuantity: number, satisfied: boolean, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }> }> }, license?: { __typename?: 'License', id: number, gid: string, stripeSubscription?: { __typename?: 'StripeSubscription', id: number, gid: string, secondsRemainingInArrears?: number | null, status: StripeSubscriptionStatusEnum } | null } | null }> | null } | null };

export type LoadStorefrontsForCourseQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type LoadStorefrontsForCourseQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', all: Array<{ __typename?: 'Storefront', id: number, gid: string, name: string }> } | null };

export type ReloadCourseRequirementsPartFragment = { __typename?: 'Course', id: number, gid: string, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum }> };

export type RemoveCourseFromStorefrontMutationVariables = Exact<{
  input: RemoveCourseFromStorefrontInput;
}>;


export type RemoveCourseFromStorefrontMutationResult = { __typename?: 'Mutation', removeCourseFromStorefront?: { __typename?: 'RemoveCourseFromStorefrontPayload', course: { __typename?: 'Course', id: number, gid: string, name: string }, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type RemoveCustomFieldCourseRequirementMutationVariables = Exact<{
  input: RemoveCustomFieldCourseRequirementInput;
}>;


export type RemoveCustomFieldCourseRequirementMutationResult = { __typename?: 'Mutation', removeCustomFieldCourseRequirement?: { __typename?: 'RemoveCustomFieldCourseRequirementPayload', course: { __typename?: 'Course', id: number, gid: string, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement' } | { __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, satisfied: boolean, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null }> } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'PrerequisiteCourseRequirement' }> }, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CourseResourceLinksFragment = { __typename?: 'Course', id: number, resourceLinks: Array<{ __typename?: 'ResourceLink', id: number, gid: string, name: string, url: string }> };

export type StopSellingCourseMutationVariables = Exact<{
  input: StopSellingCourseInput;
}>;


export type StopSellingCourseMutationResult = { __typename?: 'Mutation', stopSellingCourse?: { __typename?: 'StopSellingCoursePayload', course: { __typename?: 'Course', id: number, gid: string, name: string }, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type SubmitGradedAssignmentMutationVariables = Exact<{
  input: SubmitGradedAssignmentInput;
}>;


export type SubmitGradedAssignmentMutationResult = { __typename?: 'Mutation', submitGradedAssignment?: { __typename?: 'SubmitGradedAssignmentPayload', gradedAssignmentSubmission?: { __typename?: 'GradedAssignmentSubmission', id: number, gid: string, createdAt: Date, passedAt?: Date | null, failedAt?: Date | null, points?: number | null, file: { __typename?: 'AttacheFile', url: string }, courseItemProgression: { __typename?: 'CourseItemProgression', id: number, gid: string, gradedAssignmentSubmissions: Array<{ __typename?: 'GradedAssignmentSubmission', id: number, gid: string, createdAt: Date, passedAt?: Date | null, failedAt?: Date | null, points?: number | null, file: { __typename?: 'AttacheFile', url: string } }> } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateCourseItemMutationVariables = Exact<{
  input: UpdateCourseItemInput;
}>;


export type UpdateCourseItemMutationResult = { __typename?: 'Mutation', updateCourseItem?: { __typename?: 'UpdateCourseItemPayload', courseItem?: { __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> } | null } | null };

export type UpdateCoursePromptMutationVariables = Exact<{
  input: UpdateCoursePromptInput;
}>;


export type UpdateCoursePromptMutationResult = { __typename?: 'Mutation', updateCoursePrompt?: { __typename?: 'UpdateCoursePromptPayload', coursePrompt?: { __typename?: 'CoursePrompt', id: number, gid: string, minimumTime: number, maximumTime: number, customFieldCourseRequirements?: Array<{ __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> }> | null } | null } | null };

export type UpdateCourseMutationVariables = Exact<{
  input: UpdateCourseInput;
}>;


export type UpdateCourseMutationResult = { __typename?: 'Mutation', updateCourse?: { __typename?: 'UpdateCoursePayload', course?: { __typename?: 'Course', id: number, gid: string, categories: Array<string>, contents?: string | null, createdAt: Date, deprecatedAt?: Date | null, description?: string | null, discussionForums: boolean, estimatedCompletionTime?: number | null, expireLicensesAfterDays?: number | null, expireLicensesAt?: Date | null, expireGrantsAfterDays?: number | null, locale: string, mobile: boolean, name: string, ordered: boolean, ownerId: string, summary?: string | null, surveySchemaId?: number | null, sellCourse: boolean, shortDescription?: string | null, verificationServices: string, courseAgreements: Array<{ __typename?: 'CourseAgreement', id: number, gid: string, name: string, fileUrl: string }>, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> }>, coursePrompt?: { __typename?: 'CoursePrompt', id: number, gid: string, minimumTime: number, maximumTime: number, customFieldCourseRequirements?: Array<{ __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> }> | null } | null, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, surveySchema?: { __typename?: 'SurveySchema', id: number, gid: string, name: string } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, productDefault?: { __typename?: 'ProductDefault', id: number, gid: string, bookDuringPurchase: BookDuringPurchaseEnum, bulkDiscounts: boolean, sku?: string | null, taxesEnabled: boolean, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, prices: Array<{ __typename?: 'Price', id: number, gid: string, currency: string, value: number }> } | null, resources?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null, resourceLinks: Array<{ __typename?: 'ResourceLink', id: number, gid: string, name: string, url: string }>, verificationOptions?: { __typename?: 'CourseVerificationOptions', forceNewIdentification: boolean, holdCertIfUnderReview: boolean, reviewsPerformedByAuthor: boolean, optionalDuringCheckout: boolean, enableMinimumTime: boolean, minimumTime: number, enableMaximumAbsent: boolean, maximumAbsent: number, enableMaximumAssistance: boolean, maximumAssistance: number } | null, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, satisfied: boolean, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null }> } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, requirementType: PrerequisiteCourseRequirementRequirementTypeEnum, requirementQuantity: number, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }> }>, certificationTemplate?: { __typename?: 'CertificationTemplate', id: number, gid: string, name: string, description?: string | null, daysValid?: number | null, remindersDisabled: boolean, digitalBadgeImage: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, courseItem?: { __typename?: 'CourseItem', id: number, gid: string, name: string } | null, walletCardOptions?: { __typename?: 'WalletCardOptions', template: CertificationTemplateEditor, front?: string | null, back?: string | null } | null, wallCertificateOptions?: { __typename?: 'WallCertificateOptions', template: CertificationTemplateEditor, orientation: PageOrientation, front?: string | null } | null } | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type UpdatePrerequisiteCourseRequirementMutationVariables = Exact<{
  input: UpdatePrerequisiteCourseRequirementInput;
}>;


export type UpdatePrerequisiteCourseRequirementMutationResult = { __typename?: 'Mutation', updatePrerequisiteCourseRequirement?: { __typename?: 'UpdatePrerequisiteCourseRequirementPayload', prerequisiteCourseRequirement?: { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, requirementType: PrerequisiteCourseRequirementRequirementTypeEnum, requirementQuantity: number, course: { __typename?: 'Course', id: number, gid: string, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum }> }, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type ViewCourseAgreementMutationVariables = Exact<{
  input: ViewCourseAgreementInput;
}>;


export type ViewCourseAgreementMutationResult = { __typename?: 'Mutation', viewCourseAgreement?: { __typename?: 'ViewCourseAgreementPayload', courseUserAgreement?: { __typename?: 'CourseUserAgreement', id: number, gid: string, viewedAt?: Date | null, agreedAt?: Date | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type LoadCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadCustomFieldsQueryResult = { __typename?: 'Query', customFields: { __typename?: 'CustomFieldsNamespace', all: { __typename?: 'CustomFieldConnection', nodes?: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null } | null> | null } } };

export type DestroyNodeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyNodeMutationResult = { __typename?: 'Mutation', destroyNode?: { __typename?: 'DestroyNodePayload', ok: boolean, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null };

export type CreateDiscussionReplyMutationVariables = Exact<{
  input: CreateDiscussionReplyInput;
}>;


export type CreateDiscussionReplyMutationResult = { __typename?: 'Mutation', createDiscussionReply?: { __typename?: 'CreateDiscussionReplyPayload', reply?: { __typename?: 'DiscussionMessage', id: number, gid: string, content: string, createdAt: Date, updatedAt: Date, topic?: { __typename?: 'DiscussionMessage', id: number, gid: string } | null, can: { __typename?: 'DiscussionMessagePermissions', id: number, gid: string, destroy: boolean }, discussable: { __typename?: 'Course', id: number, gid: string } | { __typename?: 'CourseItemProgression', id: number, gid: string } | { __typename?: 'ILClass', id: number, gid: string }, author: { __typename?: 'LightUser', id: number, gid: string, name: string, avatarUrl: string }, files: Array<{ __typename?: 'AttacheFile', url: string, path: string }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateDiscussionTopicMutationVariables = Exact<{
  input: CreateDiscussionTopicInput;
}>;


export type CreateDiscussionTopicMutationResult = { __typename?: 'Mutation', createDiscussionTopic?: { __typename?: 'CreateDiscussionTopicPayload', topic?: { __typename?: 'DiscussionMessage', title?: string | null, id: number, gid: string, content: string, createdAt: Date, updatedAt: Date, can: { __typename?: 'DiscussionMessagePermissions', id: number, gid: string, destroy: boolean }, discussable: { __typename?: 'Course', id: number, gid: string } | { __typename?: 'CourseItemProgression', id: number, gid: string } | { __typename?: 'ILClass', id: number, gid: string }, author: { __typename?: 'LightUser', id: number, gid: string, name: string, avatarUrl: string }, files: Array<{ __typename?: 'AttacheFile', url: string, path: string }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type DiscussionMessagePartsFragment = { __typename?: 'DiscussionMessage', id: number, gid: string, content: string, createdAt: Date, updatedAt: Date, can: { __typename?: 'DiscussionMessagePermissions', id: number, gid: string, destroy: boolean }, discussable: { __typename?: 'Course', id: number, gid: string } | { __typename?: 'CourseItemProgression', id: number, gid: string } | { __typename?: 'ILClass', id: number, gid: string }, author: { __typename?: 'LightUser', id: number, gid: string, name: string, avatarUrl: string }, files: Array<{ __typename?: 'AttacheFile', url: string, path: string }> };

export type LoadGraderInboxMessagesQueryVariables = Exact<{
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  previewLength?: InputMaybe<Scalars['Int']>;
}>;


export type LoadGraderInboxMessagesQueryResult = { __typename?: 'Query', discussionMessages?: { __typename?: 'DiscussionMessagesNamespace', graderInbox: { __typename?: 'DiscussionMessageConnection', nodes?: Array<{ __typename?: 'DiscussionMessage', id: number, gid: string, createdAt: Date, updatedAt: Date, preview: string, title?: string | null, topic?: { __typename?: 'DiscussionMessage', id: number, gid: string, title?: string | null } | null, discussable: { __typename?: 'Course', id: number, gid: string } | { __typename?: 'CourseItemProgression', id: number, gid: string, latestGradedAssignmentSubmission?: { __typename?: 'GradedAssignmentSubmission', id: number, gid: string } | null } | { __typename?: 'ILClass', id: number, gid: string }, author: { __typename?: 'LightUser', id: number, gid: string, name: string } } | null> | null } } | null };

export type LoadRepliesForTopicQueryVariables = Exact<{
  topicId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
}>;


export type LoadRepliesForTopicQueryResult = { __typename?: 'Query', discussionMessages?: { __typename?: 'DiscussionMessagesNamespace', replies: { __typename?: 'DiscussionMessageConnection', nodes?: Array<{ __typename?: 'DiscussionMessage', id: number, gid: string, content: string, createdAt: Date, updatedAt: Date, topic?: { __typename?: 'DiscussionMessage', id: number, gid: string } | null, can: { __typename?: 'DiscussionMessagePermissions', id: number, gid: string, destroy: boolean }, discussable: { __typename?: 'Course', id: number, gid: string } | { __typename?: 'CourseItemProgression', id: number, gid: string } | { __typename?: 'ILClass', id: number, gid: string }, author: { __typename?: 'LightUser', id: number, gid: string, name: string, avatarUrl: string }, files: Array<{ __typename?: 'AttacheFile', url: string, path: string }> } | null> | null } } | null };

export type LoadTopicsForDiscussableQueryVariables = Exact<{
  discussableId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
}>;


export type LoadTopicsForDiscussableQueryResult = { __typename?: 'Query', discussionMessages?: { __typename?: 'DiscussionMessagesNamespace', all: { __typename?: 'DiscussionMessageConnection', nodes?: Array<{ __typename?: 'DiscussionMessage', title?: string | null, id: number, gid: string, content: string, createdAt: Date, updatedAt: Date, can: { __typename?: 'DiscussionMessagePermissions', id: number, gid: string, destroy: boolean }, discussable: { __typename?: 'Course', id: number, gid: string } | { __typename?: 'CourseItemProgression', id: number, gid: string } | { __typename?: 'ILClass', id: number, gid: string }, author: { __typename?: 'LightUser', id: number, gid: string, name: string, avatarUrl: string }, files: Array<{ __typename?: 'AttacheFile', url: string, path: string }> } | null> | null } } | null };

export type CreateEnrolmentKeyMutationVariables = Exact<{
  input: CreateEnrolmentKeyInput;
}>;


export type CreateEnrolmentKeyMutationResult = { __typename?: 'Mutation', createEnrolmentKey?: { __typename?: 'CreateEnrolmentKeyPayload', errors: Array<{ __typename?: 'ValidationError', message: string }>, enrolmentKey?: { __typename?: 'EnrolmentKey', id: number, gid: string, token: string, uses: number, maxUses?: number | null, remainingUses?: number | null, universal: boolean, expiresAt?: Date | null, deletedAt?: Date | null, isDeleted: boolean, can: { __typename?: 'EnrolmentKeyPermissions', id: number, gid: string, update: boolean, destroy: boolean, restore: boolean } } | null, license: { __typename?: 'License', id: number, gid: string } | { __typename?: 'LicenseGroup', gid: string } } | null };

export type DeactivateEnrolmentKeyMutationVariables = Exact<{
  input: DestroyNodeInput;
}>;


export type DeactivateEnrolmentKeyMutationResult = { __typename?: 'Mutation', destroyNode?: { __typename?: 'DestroyNodePayload', ok: boolean, node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey', id: number, gid: string, token: string, uses: number, maxUses?: number | null, remainingUses?: number | null, universal: boolean, expiresAt?: Date | null, deletedAt?: Date | null, isDeleted: boolean, can: { __typename?: 'EnrolmentKeyPermissions', id: number, gid: string, update: boolean, destroy: boolean, restore: boolean } } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null } | null };

export type EnrolmentKeyPartsFragment = { __typename?: 'EnrolmentKey', id: number, gid: string, token: string, uses: number, maxUses?: number | null, remainingUses?: number | null, universal: boolean, expiresAt?: Date | null, deletedAt?: Date | null, isDeleted: boolean, can: { __typename?: 'EnrolmentKeyPermissions', id: number, gid: string, update: boolean, destroy: boolean, restore: boolean } };

export type ReactivateEnrolmentKeyMutationVariables = Exact<{
  input: RestoreNodeInput;
}>;


export type ReactivateEnrolmentKeyMutationResult = { __typename?: 'Mutation', restoreNode?: { __typename?: 'RestoreNodePayload', ok: boolean, node?: { __typename?: 'EnrolmentKey', id: number, gid: string, token: string, uses: number, maxUses?: number | null, remainingUses?: number | null, universal: boolean, expiresAt?: Date | null, deletedAt?: Date | null, isDeleted: boolean, can: { __typename?: 'EnrolmentKeyPermissions', id: number, gid: string, update: boolean, destroy: boolean, restore: boolean } } | { __typename?: 'Grant' } | null } | null };

export type UpdateEnrolmentKeyMutationVariables = Exact<{
  input: UpdateEnrolmentKeyInput;
}>;


export type UpdateEnrolmentKeyMutationResult = { __typename?: 'Mutation', updateEnrolmentKey?: { __typename?: 'UpdateEnrolmentKeyPayload', errors: Array<{ __typename?: 'ValidationError', message: string }>, enrolmentKey?: { __typename?: 'EnrolmentKey', id: number, gid: string, token: string, uses: number, maxUses?: number | null, remainingUses?: number | null, universal: boolean, expiresAt?: Date | null, deletedAt?: Date | null, isDeleted: boolean, can: { __typename?: 'EnrolmentKeyPermissions', id: number, gid: string, update: boolean, destroy: boolean, restore: boolean } } | null } | null };

export type CreateNitoBankMutationVariables = Exact<{
  input: CreateNitoBankInput;
}>;


export type CreateNitoBankMutationResult = { __typename?: 'Mutation', createNitoBank?: { __typename?: 'CreateNitoBankPayload', bank?: { __typename?: 'NitoBank', id: number, gid: string, name: string } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateNitoExamMutationVariables = Exact<{
  input: CreateNitoExamInput;
}>;


export type CreateNitoExamMutationResult = { __typename?: 'Mutation', createNitoExam?: { __typename?: 'CreateNitoExamPayload', exam?: { __typename?: 'NitoExam', id: number, gid: string, name: string } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type EditNitoBanksMutationVariables = Exact<{
  input: EditNitoBanksInput;
}>;


export type EditNitoBanksMutationResult = { __typename?: 'Mutation', editNitoBanks?: { __typename?: 'EditNitoBanksPayload', url: string } | null };

export type EditNitoExamsMutationVariables = Exact<{
  input: EditNitoExamsInput;
}>;


export type EditNitoExamsMutationResult = { __typename?: 'Mutation', editNitoExams?: { __typename?: 'EditNitoExamsPayload', url: string } | null };

export type LoadBanksListQueryVariables = Exact<{
  organizationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LoadBanksListQueryResult = { __typename?: 'Query', nitoBanks?: { __typename?: 'NitoBanksNamespace', all: { __typename?: 'NitoBankConnection', nodes?: Array<{ __typename?: 'NitoBank', id: number, gid: string, name: string, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, rules: Array<{ __typename?: 'Rule', numberOfItems: number, formName: string }> } | null> | null } } | null };

export type LoadExamsListQueryVariables = Exact<{
  organizationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LoadExamsListQueryResult = { __typename?: 'Query', nitoExams?: { __typename?: 'NitoExamsNamespace', all: { __typename?: 'NitoExamConnection', nodes?: Array<{ __typename?: 'NitoExam', id: number, gid: string, name: string, owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | null> | null } } | null };

export type RefreshNitoRecordsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RefreshNitoRecordsQueryResult = { __typename?: 'Query', nodes: Array<{ __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank', id: number, gid: string, name: string } | { __typename?: 'NitoExam', id: number, gid: string, name: string } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null> };

export type FeatureEnabledQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type FeatureEnabledQueryResult = { __typename?: 'Query', featureEnabled: boolean };

export type AddressPartsFragment = { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null };

export type CountryPartsFragment = { __typename?: 'Country', name: string, code: string };

export type LocationPartsFragment = { __typename?: 'Location', code: string, name: string };

export type CartItemPartsFragment = { __typename?: 'CartItem', id: number, gid: string, bulkDiscountApplied: boolean, quantity: number, total: number, fullPrice: number, splitPromo: boolean, price: number, totalTaxed: number, promoPriceQuantity?: number | null, quantityRemainder?: number | null, product: { __typename?: 'Product', isInstructorLed: boolean, id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }, promoCodeClaim?: { __typename?: 'PromoCodeClaim', id: number, gid: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, description: string, code: string } | null, pendingIlBookingReservations: Array<{ __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } }> };

export type CertificationDefaultPartsFragment = { __typename?: 'CertificationDefault', id: number, gid: string, name: string, customSignature?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, contentType: string, geometry?: string | null, signature: string } | null, customLogo?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, contentType: string, geometry?: string | null, signature: string } | null };

export type CertificationTemplatePartsFragment = { __typename?: 'CertificationTemplate', id: number, gid: string, name: string, description?: string | null, daysValid?: number | null, remindersDisabled: boolean, digitalBadgeImage: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, courseItem?: { __typename?: 'CourseItem', id: number, gid: string, name: string } | null, walletCardOptions?: { __typename?: 'WalletCardOptions', template: CertificationTemplateEditor, front?: string | null, back?: string | null } | null, wallCertificateOptions?: { __typename?: 'WallCertificateOptions', template: CertificationTemplateEditor, orientation: PageOrientation, front?: string | null } | null };

export type ContractRevenueRecordPartsFragment = { __typename?: 'ContractRevenue', id: number, gid: string, calculatedDay: any, reportedDay: any, quantity: number, revenue: number, contract: { __typename?: 'Contract', id: number, gid: string, name: string, notes?: string | null, startDate: any, endDate?: any | null, active: boolean, customerType: ContractCustomerTypeEnum, currency: string } };

export type CoursePartsFragment = { __typename?: 'Course', id: number, gid: string, categories: Array<string>, contents?: string | null, createdAt: Date, deprecatedAt?: Date | null, description?: string | null, discussionForums: boolean, estimatedCompletionTime?: number | null, expireLicensesAfterDays?: number | null, expireLicensesAt?: Date | null, expireGrantsAfterDays?: number | null, locale: string, mobile: boolean, name: string, ordered: boolean, ownerId: string, summary?: string | null, surveySchemaId?: number | null, sellCourse: boolean, shortDescription?: string | null, verificationServices: string, courseAgreements: Array<{ __typename?: 'CourseAgreement', id: number, gid: string, name: string, fileUrl: string }>, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> }>, coursePrompt?: { __typename?: 'CoursePrompt', id: number, gid: string, minimumTime: number, maximumTime: number, customFieldCourseRequirements?: Array<{ __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> }> | null } | null, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, surveySchema?: { __typename?: 'SurveySchema', id: number, gid: string, name: string } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, productDefault?: { __typename?: 'ProductDefault', id: number, gid: string, bookDuringPurchase: BookDuringPurchaseEnum, bulkDiscounts: boolean, sku?: string | null, taxesEnabled: boolean, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, prices: Array<{ __typename?: 'Price', id: number, gid: string, currency: string, value: number }> } | null, resources?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null, resourceLinks: Array<{ __typename?: 'ResourceLink', id: number, gid: string, name: string, url: string }>, verificationOptions?: { __typename?: 'CourseVerificationOptions', forceNewIdentification: boolean, holdCertIfUnderReview: boolean, reviewsPerformedByAuthor: boolean, optionalDuringCheckout: boolean, enableMinimumTime: boolean, minimumTime: number, enableMaximumAbsent: boolean, maximumAbsent: number, enableMaximumAssistance: boolean, maximumAssistance: number } | null, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, satisfied: boolean, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null }> } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, requirementType: PrerequisiteCourseRequirementRequirementTypeEnum, requirementQuantity: number, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }> }>, certificationTemplate?: { __typename?: 'CertificationTemplate', id: number, gid: string, name: string, description?: string | null, daysValid?: number | null, remindersDisabled: boolean, digitalBadgeImage: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, courseItem?: { __typename?: 'CourseItem', id: number, gid: string, name: string } | null, walletCardOptions?: { __typename?: 'WalletCardOptions', template: CertificationTemplateEditor, front?: string | null, back?: string | null } | null, wallCertificateOptions?: { __typename?: 'WallCertificateOptions', template: CertificationTemplateEditor, orientation: PageOrientation, front?: string | null } | null } | null };

export type CourseItemPartsFragment = { __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> };

export type CoursePromptPartsFragment = { __typename?: 'CoursePrompt', id: number, gid: string, minimumTime: number, maximumTime: number, customFieldCourseRequirements?: Array<{ __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> }> | null };

export type CurrencyPartsFragment = { __typename?: 'Currency', isoCode: string, name: string };

export type CustomFieldPartsFragment = { __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } };

export type FilePartsFragment = { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string };

type CommonLicenseParts_License_Fragment = { __typename?: 'License', id: number, gid: string, availableSeats?: number | null, seats?: number | null, usedSeats: number, can: { __typename?: 'LicensePermissions', id: string, gid: string, take: boolean, share: boolean, destroy: boolean, assignTraining: boolean, createEnrolmentKey: boolean } };

type CommonLicenseParts_LicenseGroup_Fragment = { __typename?: 'LicenseGroup', gid: string, availableSeats?: number | null, seats?: number | null, usedSeats: number, can: { __typename?: 'LicensePermissions', id: string, gid: string, take: boolean, share: boolean, destroy: boolean, assignTraining: boolean, createEnrolmentKey: boolean } };

export type CommonLicensePartsFragment = CommonLicenseParts_License_Fragment | CommonLicenseParts_LicenseGroup_Fragment;

export type OrderItemRecordPartsFragment = { __typename?: 'LedgerOrderItemRecord', id: string, gid: string, orderId: number, orderItemId?: number | null, refundId?: number | null, refundItemId?: number | null, itemId: number, itemType: string, createdAt: Date, requiresShipping: boolean, lvEnabled: boolean, currency: string, price: number, quantity: number, promoCodeId?: number | null, promoCodeCode?: string | null, promoCodeSavings: number, orderSubtotal: number, productId?: number | null, productSku?: string | null, productName: string, courseOwnerType?: string | null, courseOwnerName?: string | null, authorAmount?: number | null, sellerAmount?: number | null, platformAmount?: number | null };

export type PayoutRecordPartsFragment = { __typename?: 'Payout', id: number, gid: string, amount: number, revenuePart: PayoutRevenuePartEnum, createdAt: Date, organization?: { __typename?: 'Organization', id: number, gid: string, name: string } | null, refundable?: { __typename?: 'RefundItem', id: number, gid: string } | { __typename?: 'StripeRefund', id: number, gid: string, stripeChargeId: string, stripeRefundId: string, amount: number, refundable: { __typename?: 'Order', id: number, gid: string, createdAt: Date, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string } } | { __typename?: 'StripeSubscription', id: number, gid: string, stripeSubscriptionId: string, createdAt: Date } } | null, orderItem?: { __typename?: 'OrderItem', id: number, gid: string, total: number, order: { __typename?: 'Order', id: number, gid: string, createdAt: Date, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string } }, product: { __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null } } | null, contract: { __typename?: 'Contract', id: number, gid: string, name: string } };

export type PendingIlBookingReservationFragment = { __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } };

export type ProductPartsFragment = { __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } };

export type RefundRecordPartsFragment = { __typename?: 'LedgerRefundRecord', id: string, gid: string, itemId: number, itemType: string, createdAt: Date, amount: number, quantity: number, tax: number, totalRefundedAmount: number, reason: string, stripeRefundToken?: string | null, requiresShipping: boolean, lvEnabled: boolean, purchasedQuantity?: number | null, orderId: number, currency: string, stripeChargeId?: string | null, productId?: number | null, courseId?: number | null, productSku?: string | null, productName?: string | null, authorAmount: number, sellerAmount: number, platformAmount: number };

export type ShoppingCartPartsFragment = { __typename?: 'ShoppingCart', expectedTotal: number, expectedTotalCents: number, expectedShipping: number, expectedTax: number, expectedSubtotal: number, requiresShipping: boolean, userId: number, cartItems: Array<{ __typename?: 'CartItem', id: number, gid: string, bulkDiscountApplied: boolean, quantity: number, total: number, fullPrice: number, splitPromo: boolean, price: number, totalTaxed: number, promoPriceQuantity?: number | null, quantityRemainder?: number | null, product: { __typename?: 'Product', isInstructorLed: boolean, id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }, promoCodeClaim?: { __typename?: 'PromoCodeClaim', id: number, gid: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, description: string, code: string } | null, pendingIlBookingReservations: Array<{ __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } }> }>, taxes: Array<{ __typename?: 'TaxItemBase', amount: number, rate: number, description: string }>, billingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, shippingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string, stripePublishableKey: string, currency: { __typename?: 'Currency', isoCode: string, name: string } }, shippingInformation?: { __typename?: 'ShoppingCartShippingInformation', name: string, email: string, phoneNumber?: string | null, companyName?: string | null } | null };

export type StorefrontPartsFragment = { __typename?: 'Storefront', id: number, gid: string, name: string, sector: string, addressOnSignup: boolean, addressRequired: boolean, faviconPath?: string | null, logoUrl?: string | null, url: string, hasSubscriptions: boolean, analyticsOptIn: boolean, currency: { __typename?: 'Currency', isoCode: string, name: string }, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, value: string }> | null }>, can: { __typename?: 'StorefrontPermissions', id: number, gid: string, createOrder: boolean } };

export type StorefrontRevenueLineOfBusinessTotalAmountPartFragment = { __typename?: 'StorefrontRevenues', startPeriod: any, endPeriod: any, onlineTraining: { __typename?: 'StorefrontOnlineTrainingRevenue', amount: number }, ilTraining: { __typename?: 'StorefrontILTrainingRevenue', amount: number }, physicalProduct: { __typename?: 'StorefrontPhysicalProductRevenue', amount: number }, promoCodeSaving: { __typename?: 'StorefrontPromoCodeSavingRevenue', amount: number }, shipping: { __typename?: 'StorefrontShippingRevenue', amount: number }, platformSetup: { __typename?: 'StorefrontPlatformSetupRevenue', amount: number }, platformLicenses: { __typename?: 'StorefrontRecurringFlatFeeRevenue', amount: number }, transactionFees: { __typename?: 'StorefrontTransactionFeesRevenue', amount: number }, subscription: { __typename?: 'StorefrontSubscriptionRevenue', amount: number }, courseDistribution: { __typename?: 'StorefrontCourseDistributionRevenue', amount: number }, thirdPartyPayout: { __typename?: 'StorefrontThirdPartyPayoutRevenue', amount: number }, refunds: { __typename?: 'StorefrontRefundRevenue', amount: number }, federalTaxes: { __typename?: 'StorefrontFederalTaxRevenue', amount: number }, provincialTaxes: { __typename?: 'StorefrontProvincialTaxRevenue', amount: number } };

export type StripeInvoicePaymentRecordPartsFragment = { __typename?: 'StripeInvoicePayment', id: number, gid: string, amountPaid: number, stripeSubscription: { __typename?: 'StripeSubscription', id: number, gid: string, stripeCustomer: { __typename?: 'StripeCustomer', id: number, gid: string, owner: { __typename?: 'User', id: number, gid: string, firstName: string, lastName: string } }, stripePlan: { __typename?: 'StripePlan', id: number, gid: string, name: string, stripeProduct: { __typename?: 'StripeProduct', id: number, gid: string, name: string } } } };

export type SurveySchemaPartsFragment = { __typename?: 'SurveySchema', id: number, gid: string, name: string, description?: string | null, closeable: boolean, content: any, theme: any, can: { __typename?: 'SurveySchemaPermissions', update: boolean, destroy: boolean } };

export type SurveySchemaResultsPartsFragment = { __typename?: 'SurveySchema', id: number, gid: string, name: string, description?: string | null, content: any, surveyResults: Array<{ __typename?: 'SurveyResult', id: number, gid: string, content: any }> };

export type TaxItemPartsFragment = { __typename?: 'TaxItem', id: number, gid: string, description: string, rate: number, amount: number, amountFormatted: string };

export type TaxRecordPartsFragment = { __typename?: 'LedgerTaxRecord', id: string, gid: string, itemId: number, itemType: string, orderId: number, kind: string, rate: number, amount: number, taxableType: string, taxableId: number, description: string, createdAt: Date };

export type LoadGradedAssignmentSubmissionDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadGradedAssignmentSubmissionDetailsQueryResult = { __typename?: 'Query', gradedAssignmentSubmissions: { __typename?: 'GradedAssignmentSubmissionsNamespace', findById: { __typename?: 'GradedAssignmentSubmission', id: number, gid: string, passedAt?: Date | null, failedAt?: Date | null, updatedAt: Date, createdAt: Date, points?: number | null, file: { __typename?: 'AttacheFile', url: string, contentType: string, path: string }, courseItemProgression: { __typename?: 'CourseItemProgression', id: number, gid: string, name: string, gradedAssignmentSettings?: { __typename?: 'GradedAssignmentSettings', id: number, gid: string, maxPoints: number, passingGrade: number } | null, courseProgression: { __typename?: 'CourseProgression', id: number, gid: string, completedAt?: Date | null, course: { __typename?: 'Course', id: number, gid: string, name: string }, user: { __typename?: 'User', id: number, gid: string, fullName: string } } } } } };

export type LoadGradedAssignmentSubmissionsListQueryVariables = Exact<{
  ungraded?: InputMaybe<Scalars['Boolean']>;
}>;


export type LoadGradedAssignmentSubmissionsListQueryResult = { __typename?: 'Query', gradedAssignmentSubmissions: { __typename?: 'GradedAssignmentSubmissionsNamespace', all: { __typename?: 'GradedAssignmentSubmissionConnection', nodes?: Array<{ __typename?: 'GradedAssignmentSubmission', id: number, gid: string, createdAt: Date, updatedAt: Date, passedAt?: Date | null, failedAt?: Date | null, points?: number | null, file: { __typename?: 'AttacheFile', url: string, contentType: string }, courseItemProgression: { __typename?: 'CourseItemProgression', id: number, gid: string, name: string, gradedAssignmentSettings?: { __typename?: 'GradedAssignmentSettings', id: number, gid: string, maxPoints: number, passingGrade: number } | null, courseProgression: { __typename?: 'CourseProgression', id: number, gid: string, completedAt?: Date | null, course: { __typename?: 'Course', id: number, gid: string, name: string }, user: { __typename?: 'User', id: number, gid: string, fullName: string } } } } | null> | null } } };

export type UpdateGradedAssignmentSubmissionMutationVariables = Exact<{
  input: UpdateGradedAssignmentSubmissionInput;
}>;


export type UpdateGradedAssignmentSubmissionMutationResult = { __typename?: 'Mutation', updateGradedAssignmentSubmission?: { __typename?: 'UpdateGradedAssignmentSubmissionPayload', gradedAssignmentSubmission?: { __typename?: 'GradedAssignmentSubmission', id: number, gid: string, passedAt?: Date | null, failedAt?: Date | null, points?: number | null, updatedAt: Date, file: { __typename?: 'AttacheFile', url: string }, courseItemProgression: { __typename?: 'CourseItemProgression', id: number, gid: string, name: string, gradedAssignmentSettings?: { __typename?: 'GradedAssignmentSettings', id: number, gid: string, maxPoints: number, passingGrade: number } | null, courseProgression: { __typename?: 'CourseProgression', id: number, gid: string, completedAt?: Date | null, course: { __typename?: 'Course', id: number, gid: string, name: string }, user: { __typename?: 'User', id: number, gid: string, fullName: string } } } } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreateGraderMutationVariables = Exact<{
  input: CreateGraderInput;
}>;


export type CreateGraderMutationResult = { __typename?: 'Mutation', createGrader?: { __typename?: 'CreateGraderPayload', grader?: { __typename?: 'Grader', id: number, gid: string, firstName: string, lastName: string, email?: string | null, status: GraderStatusEnum, organization: { __typename?: 'Organization', id: number, gid: string } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LoadGradersQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadGradersQueryResult = { __typename?: 'Query', graders?: { __typename?: 'GradersNamespace', all: { __typename?: 'GraderConnection', nodes?: Array<{ __typename?: 'Grader', id: number, gid: string, firstName: string, lastName: string, email?: string | null, status: GraderStatusEnum, organization: { __typename?: 'Organization', id: number, gid: string } } | null> | null } } | null };

export type GrantCourseViaSubscriptionMutationVariables = Exact<{
  input: GrantCourseViaSubscriptionInput;
}>;


export type GrantCourseViaSubscriptionMutationResult = { __typename?: 'Mutation', grantCourseViaSubscription?: { __typename?: 'GrantCourseViaSubscriptionPayload', grant: { __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, createdAt?: Date | null, archived: boolean, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, percentComplete: number, completedAt?: Date | null } | null, can: { __typename?: 'GrantPermissions', id: number, gid: string, run: boolean, archive: boolean, unarchive: boolean }, certification?: { __typename?: 'Certification', id: number, gid: string, number: string, name: string, issuerName: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string } | null, course: { __typename?: 'Course', id: number, gid: string, name: string, verificationServices: string, deprecatedAt?: Date | null, createdAt: Date, photo?: { __typename?: 'AttacheFile', url: string } | null, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, can: { __typename?: 'CoursePermissions', id: number, gid: string, destroy: boolean }, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, satisfied: boolean } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, requirementType: PrerequisiteCourseRequirementRequirementTypeEnum, requirementQuantity: number, satisfied: boolean, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }> }> }, license?: { __typename?: 'License', id: number, gid: string, stripeSubscription?: { __typename?: 'StripeSubscription', id: number, gid: string, secondsRemainingInArrears?: number | null, status: StripeSubscriptionStatusEnum } | null } | null }, accessSubscription: { __typename?: 'AccessSubscription', id: number, gid: string, grants: { __typename?: 'GrantConnection', nodes?: Array<{ __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, archived: boolean, can: { __typename?: 'GrantPermissions', id: number, gid: string, archive: boolean, unarchive: boolean }, course: { __typename?: 'Course', id: number, gid: string } } | null> | null } } } | null };

export type GrantPartsFragment = { __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, createdAt?: Date | null, archived: boolean, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, percentComplete: number, completedAt?: Date | null } | null, can: { __typename?: 'GrantPermissions', id: number, gid: string, run: boolean, archive: boolean, unarchive: boolean }, certification?: { __typename?: 'Certification', id: number, gid: string, number: string, name: string, issuerName: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string } | null, course: { __typename?: 'Course', id: number, gid: string, name: string, verificationServices: string, deprecatedAt?: Date | null, createdAt: Date, photo?: { __typename?: 'AttacheFile', url: string } | null, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, can: { __typename?: 'CoursePermissions', id: number, gid: string, destroy: boolean }, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, satisfied: boolean } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, requirementType: PrerequisiteCourseRequirementRequirementTypeEnum, requirementQuantity: number, satisfied: boolean, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }> }> }, license?: { __typename?: 'License', id: number, gid: string, stripeSubscription?: { __typename?: 'StripeSubscription', id: number, gid: string, secondsRemainingInArrears?: number | null, status: StripeSubscriptionStatusEnum } | null } | null };

export type LoadCourseForGrantQueryVariables = Exact<{
  grantId: Scalars['Int'];
  includeDetails: Scalars['Boolean'];
}>;


export type LoadCourseForGrantQueryResult = { __typename?: 'Query', grants?: { __typename?: 'GrantsNamespace', findById: { __typename?: 'Grant', course: { __typename?: 'Course', id: number, gid: string, name: string, categories: Array<string>, contents?: string | null, createdAt: Date, deprecatedAt?: Date | null, description?: string | null, discussionForums: boolean, estimatedCompletionTime?: number | null, expireLicensesAfterDays?: number | null, expireLicensesAt?: Date | null, expireGrantsAfterDays?: number | null, locale: string, mobile: boolean, ordered: boolean, ownerId: string, summary?: string | null, surveySchemaId?: number | null, sellCourse: boolean, shortDescription?: string | null, verificationServices: string, courseAgreements: Array<{ __typename?: 'CourseAgreement', id: number, gid: string, name: string, fileUrl: string }>, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> }>, coursePrompt?: { __typename?: 'CoursePrompt', id: number, gid: string, minimumTime: number, maximumTime: number, customFieldCourseRequirements?: Array<{ __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> }> | null } | null, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, surveySchema?: { __typename?: 'SurveySchema', id: number, gid: string, name: string } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, productDefault?: { __typename?: 'ProductDefault', id: number, gid: string, bookDuringPurchase: BookDuringPurchaseEnum, bulkDiscounts: boolean, sku?: string | null, taxesEnabled: boolean, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, prices: Array<{ __typename?: 'Price', id: number, gid: string, currency: string, value: number }> } | null, resources?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null, resourceLinks: Array<{ __typename?: 'ResourceLink', id: number, gid: string, name: string, url: string }>, verificationOptions?: { __typename?: 'CourseVerificationOptions', forceNewIdentification: boolean, holdCertIfUnderReview: boolean, reviewsPerformedByAuthor: boolean, optionalDuringCheckout: boolean, enableMinimumTime: boolean, minimumTime: number, enableMaximumAbsent: boolean, maximumAbsent: number, enableMaximumAssistance: boolean, maximumAssistance: number } | null, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, satisfied: boolean, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null }> } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, requirementType: PrerequisiteCourseRequirementRequirementTypeEnum, requirementQuantity: number, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }> }>, certificationTemplate?: { __typename?: 'CertificationTemplate', id: number, gid: string, name: string, description?: string | null, daysValid?: number | null, remindersDisabled: boolean, digitalBadgeImage: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, courseItem?: { __typename?: 'CourseItem', id: number, gid: string, name: string } | null, walletCardOptions?: { __typename?: 'WalletCardOptions', template: CertificationTemplateEditor, front?: string | null, back?: string | null } | null, wallCertificateOptions?: { __typename?: 'WallCertificateOptions', template: CertificationTemplateEditor, orientation: PageOrientation, front?: string | null } | null } | null } } } | null };

export type StartCourseMutationVariables = Exact<{
  input: StartCourseInput;
  url: Scalars['String'];
}>;


export type StartCourseMutationResult = { __typename?: 'Mutation', startCourse?: { __typename?: 'StartCoursePayload', grant: { __typename?: 'Grant', id: number, gid: string, presence?: { __typename?: 'PresenceData', channel: string, token: string, clientId: string, uuid: string } | null, channelData?: { __typename?: 'ChannelData', channel: string, token: string, clientId: string } | null, learnerVerifiedSession?: { __typename?: 'LearnerVerifiedSession', id: number, gid: string, resume: boolean, token: string, client: string } | null } } | null };

export type AddIlCourseToCourseMutationVariables = Exact<{
  input: AddIlCourseToCourseInput;
}>;


export type AddIlCourseToCourseMutationResult = { __typename?: 'Mutation', addIlCourseToCourse?: { __typename?: 'AddILCourseToCoursePayload', course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CancelIlBookingMutationVariables = Exact<{
  input: CancelIlBookingInput;
}>;


export type CancelIlBookingMutationResult = { __typename?: 'Mutation', cancelIlBooking?: { __typename?: 'CancelILBookingPayload', ilBooking?: { __typename?: 'ILBooking', id: number, gid: string, courseItemProgression: { __typename?: 'CourseItemProgression', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateIlBookingForUserMutationVariables = Exact<{
  input: CreateIlBookingForUserInput;
}>;


export type CreateIlBookingForUserMutationResult = { __typename?: 'Mutation', createIlBookingForUser?: { __typename?: 'CreateILBookingForUserPayload', errors: Array<{ __typename?: 'ValidationError', message: string }>, ilBooking?: { __typename?: 'ILBooking', id: number, gid: string, createdAt: Date, status: IlBookingStatusEnum, waitlistPosition?: number | null, can: { __typename?: 'ILBookingPermissions', id: number, gid: string, cancel: boolean, promoteBooking: boolean }, user: { __typename?: 'LightUser', id: number, gid: string, sgid: string, fullName: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: string | null }, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, owner: { __typename?: 'Owner', id: number, gid: string } } }, ilClassResults: Array<{ __typename?: 'ILClassResult', id: number, gid: string, passed?: boolean | null, grade?: string | null, attendance?: boolean | null, ilCourseItem: { __typename?: 'ILCourseItem', id: number, gid: string, name: string, trackAttendance: boolean, trackGrade: boolean } }>, certification?: { __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } } | null, previousCourseItemProgressions: Array<{ __typename?: 'CourseItemProgression', id: number, gid: string, name: string, status: CourseItemProgressionStatusEnum, score?: number | null, failedAt?: Date | null }> } | null } | null };

export type CreateIlBookingMutationVariables = Exact<{
  input: CreateIlBookingInput;
}>;


export type CreateIlBookingMutationResult = { __typename?: 'Mutation', createIlBooking?: { __typename?: 'CreateILBookingPayload', ilBooking?: { __typename?: 'ILBooking', id: number, gid: string, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum }, courseItemProgression: { __typename?: 'CourseItemProgression', id: number, gid: string, ilBooking?: { __typename?: 'ILBooking', id: number, gid: string, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, ilSessions: Array<{ __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string }> } } | null } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateIlClassMutationVariables = Exact<{
  input: CreateIlClassInput;
}>;


export type CreateIlClassMutationResult = { __typename?: 'Mutation', createIlClass?: { __typename?: 'CreateILClassPayload', ilClass?: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, access: IlClassAccessEnum, availableSeats: number, rrule?: string | null, maxCapacity: number, numberOfBookings: number, numberOfWaitlist: number, isFirstRecurrence: boolean, bookingStartsAt?: Date | null, bookingEndsAt?: Date | null, waitlistSize: number, can: { __typename?: 'ILClassPermissions', id: number, gid: string, adjustMarks: boolean, overrideFailedMark: boolean, update: boolean, destroy: boolean }, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string }, ilSessions: Array<{ __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string, ilLocation: { __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILOnlineLocation', url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILPhysicalLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } } }>, instructors: Array<{ __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, email?: string | null }>, bookingWindow: { __typename?: 'BookingWindow', startsAt?: any | null, endsAt: any }, firstRecurrence?: { __typename?: 'ILClass', id: number, gid: string, rrule?: string | null, isFirstRecurrence: boolean } | null } | null, errors: Array<{ __typename?: 'ValidationError', message: string }>, recurrences?: Array<{ __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, access: IlClassAccessEnum, availableSeats: number, rrule?: string | null, maxCapacity: number, numberOfBookings: number, isFirstRecurrence: boolean, firstRecurrence?: { __typename?: 'ILClass', id: number, gid: string, rrule?: string | null, isFirstRecurrence: boolean } | null, can: { __typename?: 'ILClassPermissions', id: number, gid: string, adjustMarks: boolean, overrideFailedMark: boolean, update: boolean }, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string }, ilSessions: Array<{ __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string, ilLocation: { __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILOnlineLocation', createdAt: Date, url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILPhysicalLocation', createdAt: Date, id: number, gid: string, name: string, type: IlLocationTypeEnum, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } } }>, instructors: Array<{ __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, email?: string | null }> }> | null } | null };

export type CreateIlCourseItemMutationVariables = Exact<{
  input: CreateIlCourseItemInput;
}>;


export type CreateIlCourseItemMutationResult = { __typename?: 'Mutation', createIlCourseItem?: { __typename?: 'CreateILCourseItemPayload', errors: Array<{ __typename?: 'ValidationError', message: string }>, ilCourseItem?: { __typename?: 'ILCourseItem', id: number, gid: string, name: string, trackGrade: boolean, trackAttendance: boolean } | null } | null };

export type CreateIlCourseMutationVariables = Exact<{
  input: CreateIlCourseInput;
}>;


export type CreateIlCourseMutationResult = { __typename?: 'Mutation', createIlCourse?: { __typename?: 'CreateILCoursePayload', ilCourse?: { __typename?: 'ILCourse', id: number, gid: string, name: string, createdAt: Date, ilCourseItems: Array<{ __typename?: 'ILCourseItem', id: number, gid: string, name: string, position: number, trackGrade: boolean, trackAttendance: boolean }>, can: { __typename?: 'ILCoursePermissions', id: number, gid: string, destroy: boolean }, owner: { __typename?: 'Owner', id: number, gid: string } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateIlLocationMutationVariables = Exact<{
  input: CreateIlLocationInput;
}>;


export type CreateIlLocationMutationResult = { __typename?: 'Mutation', createIlLocation?: { __typename?: 'CreateILLocationPayload', ilLocation?: { __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | { __typename?: 'ILOnlineLocation', createdAt: Date, url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum, owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | { __typename?: 'ILPhysicalLocation', createdAt: Date, id: number, gid: string, name: string, type: IlLocationTypeEnum, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null }, owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateIlSessionMutationVariables = Exact<{
  input: CreateIlSessionInput;
}>;


export type CreateIlSessionMutationResult = { __typename?: 'Mutation', createIlSession?: { __typename?: 'CreateILSessionPayload', ilSession?: { __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string, ilLocation: { __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILOnlineLocation', url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILPhysicalLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateInstructorCredentialMutationVariables = Exact<{
  input: CreateInstructorCredentialInput;
}>;


export type CreateInstructorCredentialMutationResult = { __typename?: 'Mutation', createInstructorCredential?: { __typename?: 'CreateInstructorCredentialPayload', credential?: { __typename?: 'InstructorCredential', id: number, gid: string, name: string, comment?: string | null, expiresAt?: Date | null, issuedAt?: Date | null, can: { __typename?: 'InstructorCredentialPermissions', id: number, gid: string, destroy: boolean }, file: { __typename?: 'AttacheFile', contentType: string, path: string, url: string } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateInstructorIlCoursePermissionMutationVariables = Exact<{
  input: CreateInstructorIlCoursePermissionInput;
}>;


export type CreateInstructorIlCoursePermissionMutationResult = { __typename?: 'Mutation', createInstructorIlCoursePermission?: { __typename?: 'CreateInstructorILCoursePermissionPayload', instructorIlCoursePermission?: { __typename?: 'InstructorILCoursePermission', id: number, gid: string, can: { __typename?: 'InstructorILCoursePermissionPermissions', id: number, gid: string, destroy: boolean }, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateInstructorMutationVariables = Exact<{
  input: CreateInstructorInput;
}>;


export type CreateInstructorMutationResult = { __typename?: 'Mutation', createInstructor?: { __typename?: 'CreateInstructorPayload', instructor?: { __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null, status: InstructorStatusEnum, distributeWithoutPurchase: boolean, accessLearnerContactDetails: boolean, organization: { __typename?: 'Organization', id: number, gid: string }, can: { __typename?: 'InstructorPermissions', id: number, gid: string, destroy: boolean, resendInvitation: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreatePendingIlBookingReservationMutationVariables = Exact<{
  input: CreatePendingIlBookingReservationInput;
}>;


export type CreatePendingIlBookingReservationMutationResult = { __typename?: 'Mutation', createPendingIlBookingReservation?: { __typename?: 'CreatePendingILBookingReservationPayload', errors: Array<{ __typename?: 'ValidationError', message: string }>, pendingIlBookingReservation?: { __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } } | null } | null };

export type ForcePromoteIlBookingMutationVariables = Exact<{
  input: ForcePromoteIlBookingInput;
}>;


export type ForcePromoteIlBookingMutationResult = { __typename?: 'Mutation', forcePromoteIlBooking?: { __typename?: 'ForcePromoteILBookingPayload', ilBooking?: { __typename?: 'ILBooking', id: number, gid: string, status: IlBookingStatusEnum } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type ForcePassIlClassResultMutationVariables = Exact<{
  input: ForcePassIlClassResultInput;
}>;


export type ForcePassIlClassResultMutationResult = { __typename?: 'Mutation', forcePassIlClassResult?: { __typename?: 'ForcePassILClassResultPayload', ilClassResult?: { __typename?: 'ILClassResult', id: number, gid: string, passed?: boolean | null } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type IlBookingWithDetailsPartsFragment = { __typename?: 'ILBooking', id: number, gid: string, createdAt: Date, status: IlBookingStatusEnum, waitlistPosition?: number | null, can: { __typename?: 'ILBookingPermissions', id: number, gid: string, cancel: boolean, promoteBooking: boolean }, user: { __typename?: 'LightUser', id: number, gid: string, sgid: string, fullName: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: string | null }, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, owner: { __typename?: 'Owner', id: number, gid: string } } }, ilClassResults: Array<{ __typename?: 'ILClassResult', id: number, gid: string, passed?: boolean | null, grade?: string | null, attendance?: boolean | null, ilCourseItem: { __typename?: 'ILCourseItem', id: number, gid: string, name: string, trackAttendance: boolean, trackGrade: boolean } }>, certification?: { __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } } | null, previousCourseItemProgressions: Array<{ __typename?: 'CourseItemProgression', id: number, gid: string, name: string, status: CourseItemProgressionStatusEnum, score?: number | null, failedAt?: Date | null }> };

export type IlClassPartsFragment = { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, access: IlClassAccessEnum, availableSeats: number, rrule?: string | null, maxCapacity: number, numberOfBookings: number, numberOfWaitlist: number, isFirstRecurrence: boolean, bookingStartsAt?: Date | null, bookingEndsAt?: Date | null, waitlistSize: number, can: { __typename?: 'ILClassPermissions', id: number, gid: string, destroy: boolean }, bookingWindow: { __typename?: 'BookingWindow', startsAt?: any | null, endsAt: any }, firstRecurrence?: { __typename?: 'ILClass', id: number, gid: string, rrule?: string | null, isFirstRecurrence: boolean } | null };

export type IlCourseItemPartsFragment = { __typename?: 'ILCourseItem', id: number, gid: string, name: string, position: number, trackAttendance: boolean, trackGrade: boolean };

export type IlCoursePartsFragment = { __typename?: 'ILCourse', id: number, gid: string, name: string, createdAt: Date, can: { __typename?: 'ILCoursePermissions', id: number, gid: string, destroy: boolean }, owner: { __typename?: 'Owner', id: number, gid: string }, ilCourseItems: Array<{ __typename?: 'ILCourseItem', id: number, gid: string, name: string, position: number, trackGrade: boolean, trackAttendance: boolean }> };

export type IlSessionPartsFragment = { __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string, ilLocation: { __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILOnlineLocation', url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILPhysicalLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } } };

export type InstructorCredentialPartsFragment = { __typename?: 'InstructorCredential', id: number, gid: string, name: string, comment?: string | null, expiresAt?: Date | null, issuedAt?: Date | null, can: { __typename?: 'InstructorCredentialPermissions', id: number, gid: string, destroy: boolean }, file: { __typename?: 'AttacheFile', contentType: string, path: string, url: string } };

export type InstructorIlCoursePermissionPartsFragment = { __typename?: 'InstructorILCoursePermission', id: number, gid: string, can: { __typename?: 'InstructorILCoursePermissionPermissions', id: number, gid: string, destroy: boolean }, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string } };

export type InstructorPartsFragment = { __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null, status: InstructorStatusEnum, distributeWithoutPurchase: boolean, accessLearnerContactDetails: boolean, organization: { __typename?: 'Organization', id: number, gid: string }, can: { __typename?: 'InstructorPermissions', id: number, gid: string, destroy: boolean, resendInvitation: boolean } };

export type LoadBookableClassesForIlCourseQueryVariables = Exact<{
  ilCourseId: Scalars['Int'];
  reservable?: InputMaybe<Scalars['Boolean']>;
}>;


export type LoadBookableClassesForIlCourseQueryResult = { __typename?: 'Query', ilClasses?: { __typename?: 'ILClassesNamespace', bookable: { __typename?: 'ILClassConnection', nodes?: Array<{ __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, maxCapacity: number, availableSeats: number, ilBookings?: { __typename?: 'ILBookingConnection', nodes?: Array<{ __typename?: 'ILBooking', id: number, gid: string, user: { __typename?: 'LightUser', id: number, gid: string, fullName: string } } | null> | null } | null, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string }, ilSessions: Array<{ __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string, ilLocation: { __typename?: 'ILLocation', id: number, gid: string, type: IlLocationTypeEnum, name: string } | { __typename?: 'ILOnlineLocation', createdAt: Date, url?: string | null, id: number, gid: string, type: IlLocationTypeEnum, name: string } | { __typename?: 'ILPhysicalLocation', createdAt: Date, id: number, gid: string, type: IlLocationTypeEnum, name: string, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } } }>, instructors: Array<{ __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, email?: string | null, status: InstructorStatusEnum }> } | null> | null } } | null };

export type LoadIlClassBookingsQueryVariables = Exact<{
  id: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadIlClassBookingsQueryResult = { __typename?: 'Query', ilClasses?: { __typename?: 'ILClassesNamespace', findById: { __typename?: 'ILClass', id: number, gid: string, ilBookings?: { __typename?: 'ILBookingConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'ILBooking', id: number, gid: string, createdAt: Date, status: IlBookingStatusEnum, waitlistPosition?: number | null, can: { __typename?: 'ILBookingPermissions', id: number, gid: string, cancel: boolean, promoteBooking: boolean }, user: { __typename?: 'LightUser', id: number, gid: string, sgid: string, fullName: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: string | null }, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, owner: { __typename?: 'Owner', id: number, gid: string } } }, ilClassResults: Array<{ __typename?: 'ILClassResult', id: number, gid: string, passed?: boolean | null, grade?: string | null, attendance?: boolean | null, ilCourseItem: { __typename?: 'ILCourseItem', id: number, gid: string, name: string, trackAttendance: boolean, trackGrade: boolean } }>, certification?: { __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } } | null, previousCourseItemProgressions: Array<{ __typename?: 'CourseItemProgression', id: number, gid: string, name: string, status: CourseItemProgressionStatusEnum, score?: number | null, failedAt?: Date | null }> } | null> | null } | null } } | null };

export type LoadIlClassDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadIlClassDetailsQueryResult = { __typename?: 'Query', ilClasses?: { __typename?: 'ILClassesNamespace', findById: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, access: IlClassAccessEnum, availableSeats: number, rrule?: string | null, maxCapacity: number, numberOfBookings: number, numberOfWaitlist: number, isFirstRecurrence: boolean, bookingStartsAt?: Date | null, bookingEndsAt?: Date | null, waitlistSize: number, paths: { __typename?: 'ILClassPaths', id: number, gid: string, exportBookedStudents?: string | null, exportWaitlistedStudents?: string | null, bulkWalletCards?: string | null, bulkWallCertificates?: string | null }, can: { __typename?: 'ILClassPermissions', id: number, gid: string, adjustMarks: boolean, overrideFailedMark: boolean, update: boolean, updateStatus: boolean, distributeWithoutPurchase: boolean, bookInto: boolean, updateWithRestrictions: boolean, destroy: boolean }, ilCourseItems: Array<{ __typename?: 'ILCourseItem', id: number, gid: string, name: string, position: number, trackAttendance: boolean, trackGrade: boolean }>, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, ilCourseItems: Array<{ __typename?: 'ILCourseItem', id: number, gid: string, name: string, position: number, trackAttendance: boolean, trackGrade: boolean }>, instructorFiles?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null, learnerFiles?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null }, instructors: Array<{ __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, email?: string | null }>, ilSessions: Array<{ __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string, ilLocation: { __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILOnlineLocation', url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILPhysicalLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } } }>, bookingWindow: { __typename?: 'BookingWindow', startsAt?: any | null, endsAt: any }, firstRecurrence?: { __typename?: 'ILClass', id: number, gid: string, rrule?: string | null, isFirstRecurrence: boolean } | null } } | null };

export type LoadIlClassListQueryVariables = Exact<{
  forTrainingManager?: InputMaybe<Scalars['Boolean']>;
  status: Array<IlClassStatusEnum> | IlClassStatusEnum;
  access?: InputMaybe<Array<IlClassAccessEnum> | IlClassAccessEnum>;
  startsAfter?: InputMaybe<Scalars['Date']>;
  endsBefore?: InputMaybe<Scalars['Date']>;
  ilCourseIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  instructorIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LoadIlClassListQueryResult = { __typename?: 'Query', ilClasses?: { __typename?: 'ILClassesNamespace', all: { __typename?: 'ILClassConnection', nodes?: Array<{ __typename?: 'ILClass', startsAt: Date, id: number, gid: string, status: IlClassStatusEnum, access: IlClassAccessEnum, availableSeats: number, rrule?: string | null, maxCapacity: number, numberOfBookings: number, numberOfWaitlist: number, isFirstRecurrence: boolean, bookingStartsAt?: Date | null, bookingEndsAt?: Date | null, waitlistSize: number, can: { __typename?: 'ILClassPermissions', id: number, gid: string, update: boolean, destroy: boolean }, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string, owner: { __typename?: 'Owner', id: number, gid: string, name: string } }, ilSessions: Array<{ __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string, ilLocation: { __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILOnlineLocation', url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILPhysicalLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } } }>, instructors: Array<{ __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, email?: string | null }>, bookingWindow: { __typename?: 'BookingWindow', startsAt?: any | null, endsAt: any }, firstRecurrence?: { __typename?: 'ILClass', id: number, gid: string, rrule?: string | null, isFirstRecurrence: boolean } | null } | null> | null } } | null };

export type LoadIlClassWaitlistQueryVariables = Exact<{
  id: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadIlClassWaitlistQueryResult = { __typename?: 'Query', ilClasses?: { __typename?: 'ILClassesNamespace', findById: { __typename?: 'ILClass', id: number, gid: string, waitlist?: { __typename?: 'ILBookingConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'ILBooking', id: number, gid: string, createdAt: Date, status: IlBookingStatusEnum, waitlistPosition?: number | null, can: { __typename?: 'ILBookingPermissions', id: number, gid: string, cancel: boolean, promoteBooking: boolean }, user: { __typename?: 'LightUser', id: number, gid: string, sgid: string, fullName: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: string | null }, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, owner: { __typename?: 'Owner', id: number, gid: string } } }, ilClassResults: Array<{ __typename?: 'ILClassResult', id: number, gid: string, passed?: boolean | null, grade?: string | null, attendance?: boolean | null, ilCourseItem: { __typename?: 'ILCourseItem', id: number, gid: string, name: string, trackAttendance: boolean, trackGrade: boolean } }>, certification?: { __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } } | null, previousCourseItemProgressions: Array<{ __typename?: 'CourseItemProgression', id: number, gid: string, name: string, status: CourseItemProgressionStatusEnum, score?: number | null, failedAt?: Date | null }> } | null> | null } | null } } | null };

export type LoadIlCourseDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadIlCourseDetailsQueryResult = { __typename?: 'Query', ilCourses?: { __typename?: 'ILCoursesNamespace', findById: { __typename?: 'ILCourse', id: number, gid: string, name: string, instructorFiles?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null, learnerFiles?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null, owner: { __typename?: 'Owner', id: number, gid: string }, can: { __typename?: 'ILCoursePermissions', id: number, gid: string, destroy: boolean }, ilCourseItems: Array<{ __typename?: 'ILCourseItem', id: number, gid: string, name: string, trackGrade: boolean, trackAttendance: boolean, can: { __typename?: 'ILCourseItemPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> } } | null };

export type LoadIlCourseListQueryVariables = Exact<{
  organizationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LoadIlCourseListQueryResult = { __typename?: 'Query', ilCourses?: { __typename?: 'ILCoursesNamespace', all: { __typename?: 'ILCourseConnection', nodes?: Array<{ __typename?: 'ILCourse', id: number, gid: string, name: string, createdAt: Date, can: { __typename?: 'ILCoursePermissions', id: number, gid: string, destroy: boolean }, owner: { __typename?: 'Owner', id: number, gid: string }, ilCourseItems: Array<{ __typename?: 'ILCourseItem', id: number, gid: string, name: string, position: number, trackGrade: boolean, trackAttendance: boolean }> } | null> | null } } | null };

export type LoadIlInstructorClassesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadIlInstructorClassesQueryResult = { __typename?: 'Query', instructors?: { __typename?: 'InstructorsNamespace', findById: { __typename?: 'Instructor', id: number, gid: string, organization: { __typename?: 'Organization', id: number, gid: string, name: string }, ilClasses: { __typename?: 'ILClassConnection', nodes?: Array<{ __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, maxCapacity: number, numberOfBookings: number, access: IlClassAccessEnum, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string }, ilSessions: Array<{ __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string }> } | null> | null } } } | null };

export type LoadIlInstructorCredentialsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadIlInstructorCredentialsQueryResult = { __typename?: 'Query', instructors?: { __typename?: 'InstructorsNamespace', findById: { __typename?: 'Instructor', id: number, gid: string, credentials: { __typename?: 'InstructorCredentialConnection', nodes?: Array<{ __typename?: 'InstructorCredential', id: number, gid: string, name: string, comment?: string | null, expiresAt?: Date | null, issuedAt?: Date | null, can: { __typename?: 'InstructorCredentialPermissions', id: number, gid: string, destroy: boolean }, file: { __typename?: 'AttacheFile', contentType: string, path: string, url: string } } | null> | null } } } | null };

export type LoadIlInstructorDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadIlInstructorDetailsQueryResult = { __typename?: 'Query', instructors?: { __typename?: 'InstructorsNamespace', findById: { __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null, status: InstructorStatusEnum, distributeWithoutPurchase: boolean, accessLearnerContactDetails: boolean, organization: { __typename?: 'Organization', id: number, gid: string }, can: { __typename?: 'InstructorPermissions', id: number, gid: string, destroy: boolean, resendInvitation: boolean } } } | null };

export type LoadIlLocationDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadIlLocationDetailsQueryResult = { __typename?: 'Query', ilLocations?: { __typename?: 'ILLocationsNamespace', findById: { __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, createdAt: Date, owner: { __typename?: 'Owner', id: number, name: string, gid: string } } | { __typename?: 'ILOnlineLocation', url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum, createdAt: Date, owner: { __typename?: 'Owner', id: number, name: string, gid: string } } | { __typename?: 'ILPhysicalLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, createdAt: Date, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null }, owner: { __typename?: 'Owner', id: number, name: string, gid: string } } } | null };

export type LoadIlLocationsListQueryVariables = Exact<{
  organizationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadIlLocationsListQueryResult = { __typename?: 'Query', ilLocations?: { __typename?: 'ILLocationsNamespace', all: { __typename?: 'ILLocationInterfaceConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | { __typename?: 'ILOnlineLocation', createdAt: Date, url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum, owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | { __typename?: 'ILPhysicalLocation', createdAt: Date, id: number, gid: string, name: string, type: IlLocationTypeEnum, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null }, owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | null> | null } } | null };

export type LoadInstructorIlCoursePermissionsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadInstructorIlCoursePermissionsQueryResult = { __typename?: 'Query', instructors?: { __typename?: 'InstructorsNamespace', findById: { __typename?: 'Instructor', id: number, gid: string, organization: { __typename?: 'Organization', id: number, gid: string }, instructorIlCoursePermissions: Array<{ __typename?: 'InstructorILCoursePermission', id: number, gid: string, can: { __typename?: 'InstructorILCoursePermissionPermissions', id: number, gid: string, destroy: boolean }, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string } }> } } | null };

export type LoadInstructorsListQueryVariables = Exact<{
  organizationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LoadInstructorsListQueryResult = { __typename?: 'Query', instructors?: { __typename?: 'InstructorsNamespace', all: { __typename?: 'InstructorConnection', nodes?: Array<{ __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null, status: InstructorStatusEnum, distributeWithoutPurchase: boolean, accessLearnerContactDetails: boolean, organization: { __typename?: 'Organization', id: number, gid: string }, can: { __typename?: 'InstructorPermissions', id: number, gid: string, destroy: boolean, resendInvitation: boolean } } | null> | null } } | null };

export type ReorderIlCourseItemsMutationVariables = Exact<{
  input: ReorderIlCourseItemsInput;
}>;


export type ReorderIlCourseItemsMutationResult = { __typename?: 'Mutation', reorderIlCourseItems?: { __typename?: 'ReorderILCourseItemsPayload', errors: Array<{ __typename?: 'ValidationError', message: string }>, ilCourseItems: Array<{ __typename?: 'ILCourseItem', id: number, gid: string, name: string, trackGrade: boolean, trackAttendance: boolean, position: number }> } | null };

export type ResendInstructorInvitationMutationVariables = Exact<{
  input: ResendInstructorInvitationInput;
}>;


export type ResendInstructorInvitationMutationResult = { __typename?: 'Mutation', resendInstructorInvitation?: { __typename?: 'ResendInstructorInvitationPayload', instructor?: { __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null, status: InstructorStatusEnum, distributeWithoutPurchase: boolean, accessLearnerContactDetails: boolean, organization: { __typename?: 'Organization', id: number, gid: string }, can: { __typename?: 'InstructorPermissions', id: number, gid: string, destroy: boolean, resendInvitation: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateIlClassMutationVariables = Exact<{
  input: UpdateIlClassInput;
}>;


export type UpdateIlClassMutationResult = { __typename?: 'Mutation', updateIlClass?: { __typename?: 'UpdateILClassPayload', ilClass?: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, access: IlClassAccessEnum, availableSeats: number, rrule?: string | null, maxCapacity: number, numberOfBookings: number, numberOfWaitlist: number, isFirstRecurrence: boolean, bookingStartsAt?: Date | null, bookingEndsAt?: Date | null, waitlistSize: number, can: { __typename?: 'ILClassPermissions', id: number, gid: string, adjustMarks: boolean, overrideFailedMark: boolean, destroy: boolean }, ilBookings?: { __typename?: 'ILBookingConnection', nodes?: Array<{ __typename?: 'ILBooking', id: number, gid: string, createdAt: Date, status: IlBookingStatusEnum, waitlistPosition?: number | null, can: { __typename?: 'ILBookingPermissions', id: number, gid: string, cancel: boolean, promoteBooking: boolean }, user: { __typename?: 'LightUser', id: number, gid: string, sgid: string, fullName: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: string | null }, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, owner: { __typename?: 'Owner', id: number, gid: string } } }, ilClassResults: Array<{ __typename?: 'ILClassResult', id: number, gid: string, passed?: boolean | null, grade?: string | null, attendance?: boolean | null, ilCourseItem: { __typename?: 'ILCourseItem', id: number, gid: string, name: string, trackAttendance: boolean, trackGrade: boolean } }>, certification?: { __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } } | null, previousCourseItemProgressions: Array<{ __typename?: 'CourseItemProgression', id: number, gid: string, name: string, status: CourseItemProgressionStatusEnum, score?: number | null, failedAt?: Date | null }> } | null> | null } | null, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, ilCourseItems: Array<{ __typename?: 'ILCourseItem', id: number, gid: string, name: string, position: number, trackAttendance: boolean, trackGrade: boolean }>, instructorFiles?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null, learnerFiles?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null }, ilCourseItems: Array<{ __typename?: 'ILCourseItem', id: number, gid: string, name: string, position: number, trackAttendance: boolean, trackGrade: boolean }>, instructors: Array<{ __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, email?: string | null }>, ilSessions: Array<{ __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string, ilLocation: { __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILOnlineLocation', url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum } | { __typename?: 'ILPhysicalLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } } }>, bookingWindow: { __typename?: 'BookingWindow', startsAt?: any | null, endsAt: any }, firstRecurrence?: { __typename?: 'ILClass', id: number, gid: string, rrule?: string | null, isFirstRecurrence: boolean } | null } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateIlCourseItemMutationVariables = Exact<{
  input: UpdateIlCourseItemInput;
}>;


export type UpdateIlCourseItemMutationResult = { __typename?: 'Mutation', updateIlCourseItem?: { __typename?: 'UpdateILCourseItemPayload', errors: Array<{ __typename?: 'ValidationError', message: string }>, ilCourseItem?: { __typename?: 'ILCourseItem', id: number, gid: string, name: string, trackGrade: boolean, trackAttendance: boolean } | null } | null };

export type UpdateIlCourseMutationVariables = Exact<{
  input: UpdateIlCourseInput;
}>;


export type UpdateIlCourseMutationResult = { __typename?: 'Mutation', updateIlCourse?: { __typename?: 'UpdateILCoursePayload', errors: Array<{ __typename?: 'ValidationError', message: string }>, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string, name: string, owner: { __typename?: 'Owner', id: number, gid: string }, can: { __typename?: 'ILCoursePermissions', id: number, gid: string, destroy: boolean }, ilCourseItems: Array<{ __typename?: 'ILCourseItem', id: number, gid: string, name: string, trackGrade: boolean, trackAttendance: boolean, position: number }>, instructorFiles?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null, learnerFiles?: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }> | null } | null } | null };

export type UpdateIlLocationMutationVariables = Exact<{
  input: UpdateIlLocationInput;
}>;


export type UpdateIlLocationMutationResult = { __typename?: 'Mutation', updateIlLocation?: { __typename?: 'UpdateILLocationPayload', ilLocation?: { __typename?: 'ILLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, createdAt: Date } | { __typename?: 'ILOnlineLocation', url?: string | null, id: number, gid: string, name: string, type: IlLocationTypeEnum, createdAt: Date } | { __typename?: 'ILPhysicalLocation', id: number, gid: string, name: string, type: IlLocationTypeEnum, createdAt: Date, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateInstructorMutationVariables = Exact<{
  input: UpdateInstructorInput;
}>;


export type UpdateInstructorMutationResult = { __typename?: 'Mutation', updateInstructor?: { __typename?: 'UpdateInstructorPayload', instructor?: { __typename?: 'Instructor', id: number, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null, status: InstructorStatusEnum, distributeWithoutPurchase: boolean, accessLearnerContactDetails: boolean, organization: { __typename?: 'Organization', id: number, gid: string }, can: { __typename?: 'InstructorPermissions', id: number, gid: string, destroy: boolean, resendInvitation: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateMultipleIlClassResultsMutationVariables = Exact<{
  input: UpdateIlClassResultsInput;
}>;


export type UpdateMultipleIlClassResultsMutationResult = { __typename?: 'Mutation', updateIlClassResults?: { __typename?: 'UpdateILClassResultsPayload', ilClassResults?: Array<{ __typename?: 'ILClassResult', id: number, gid: string, attendance?: boolean | null, grade?: string | null, passed?: boolean | null, ilCourseItem: { __typename?: 'ILCourseItem', id: number, name: string, trackAttendance: boolean, trackGrade: boolean } }> | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UploadIlClassRosterLearnerMutationVariables = Exact<{
  input: UploadIlClassRosterLearnerInput;
}>;


export type UploadIlClassRosterLearnerMutationResult = { __typename?: 'Mutation', uploadIlClassRosterLearner?: { __typename?: 'UploadILClassRosterLearnerPayload', ilClass?: { __typename?: 'ILClass', id: number, gid: string, availableSeats: number } | null, ilBooking?: { __typename?: 'ILBooking', id: number, gid: string, createdAt: Date, status: IlBookingStatusEnum, waitlistPosition?: number | null, can: { __typename?: 'ILBookingPermissions', id: number, gid: string, cancel: boolean, promoteBooking: boolean }, user: { __typename?: 'LightUser', id: number, gid: string, sgid: string, fullName: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: string | null }, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, owner: { __typename?: 'Owner', id: number, gid: string } } }, ilClassResults: Array<{ __typename?: 'ILClassResult', id: number, gid: string, passed?: boolean | null, grade?: string | null, attendance?: boolean | null, ilCourseItem: { __typename?: 'ILCourseItem', id: number, gid: string, name: string, trackAttendance: boolean, trackGrade: boolean } }>, certification?: { __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } } | null, previousCourseItemProgressions: Array<{ __typename?: 'CourseItemProgression', id: number, gid: string, name: string, status: CourseItemProgressionStatusEnum, score?: number | null, failedAt?: Date | null }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type AvalaraSyncProductsMutationVariables = Exact<{
  input: AvalaraSyncProductsInput;
}>;


export type AvalaraSyncProductsMutationResult = { __typename?: 'Mutation', avalaraSyncProducts?: { __typename?: 'AvalaraSyncProductsPayload', ok: boolean } | null };

export type ConfigureIntegrationMutationVariables = Exact<{
  input: ConfigureIntegrationInput;
}>;


export type ConfigureIntegrationMutationResult = { __typename?: 'Mutation', configureIntegration?: { __typename?: 'ConfigureIntegrationPayload', integration?: { __typename?: 'Integration', id: number, gid: string, type: IntegrationTypeEnum, integratableGid: string, integrationOptions: any } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type LoadIntegrationsQueryVariables = Exact<{
  integratableGid: Scalars['ID'];
}>;


export type LoadIntegrationsQueryResult = { __typename?: 'Query', integrations?: { __typename?: 'IntegrationsNamespace', findByIntegratable?: Array<{ __typename?: 'Integration', id: number, gid: string, type: IntegrationTypeEnum, integratableGid: string, integrationOptions: any }> | null } | null };

export type InviteConnectionPartsFragment = { __typename?: 'InviteConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Invite', id: number, gid: string, name: string, status: string, updatedAt: Date, emailStatus: string, emailStatusMessage: string, emailShortStatusMessage: string, learner?: { __typename?: 'Learner', id: string, gid: string, firstName: string, lastName: string, fullName: string } | null, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean, resend: boolean } } | null> | null };

export type InvitePartsFragment = { __typename?: 'Invite', id: number, gid: string, name: string, status: string, updatedAt: Date, emailStatus: string, emailStatusMessage: string, emailShortStatusMessage: string, learner?: { __typename?: 'Learner', id: string, gid: string, firstName: string, lastName: string, fullName: string } | null, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean, resend: boolean } };

export type ResendInviteMutationVariables = Exact<{
  input: ResendInviteInput;
}>;


export type ResendInviteMutationResult = { __typename?: 'Mutation', resendInvite?: { __typename?: 'ResendInvitePayload', invite: { __typename?: 'Invite', id: number, gid: string } } | null };

export type LoadGrantsForReviewQueryVariables = Exact<{
  filter: ReviewableGrantsFilterEnum;
}>;


export type LoadGrantsForReviewQueryResult = { __typename?: 'Query', learnerVerified?: { __typename?: 'LearnerVerifiedNamespace', reviewableGrants: { __typename?: 'GrantConnection', nodes?: Array<{ __typename?: 'Grant', id: number, gid: string, learnerVerifiedStatus: string, course: { __typename?: 'Course', id: number, gid: string, name: string, photo?: { __typename?: 'AttacheFile', url: string } | null }, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, completedAt?: Date | null } | null, can: { __typename?: 'GrantPermissions', id: number, gid: string, overrideLearnerVerifiedStatus: boolean }, user?: { __typename?: 'User', id: number, gid: string, firstName: string, lastName: string, fullName: string } | null } | null> | null } } | null };

export type LoadReviewUrlForGrantMutationVariables = Exact<{
  input: ReviewLearnerVerifiedSessionsInput;
}>;


export type LoadReviewUrlForGrantMutationResult = { __typename?: 'Mutation', reviewLearnerVerifiedSessions?: { __typename?: 'ReviewLearnerVerifiedSessionsPayload', url?: string | null } | null };

export type OverrideLearnerVerifiedStatusMutationVariables = Exact<{
  input: OverrideLearnerVerifiedStatusInput;
}>;


export type OverrideLearnerVerifiedStatusMutationResult = { __typename?: 'Mutation', overrideLearnerVerifiedStatus?: { __typename?: 'OverrideLearnerVerifiedStatusPayload', grant: { __typename?: 'Grant', id: number, gid: string, learnerVerifiedStatus: string, can: { __typename?: 'GrantPermissions', id: number, gid: string, overrideLearnerVerifiedStatus: boolean } } } | null };

export type UpdateLearnerVerifiedSessionMutationVariables = Exact<{
  input: UpdateLearnerVerifiedSessionInput;
}>;


export type UpdateLearnerVerifiedSessionMutationResult = { __typename?: 'Mutation', updateLearnerVerifiedSession?: { __typename?: 'UpdateLearnerVerifiedSessionPayload', session?: { __typename?: 'LearnerVerifiedSession', id: number, startedAt?: Date | null } | null, errors: Array<{ __typename?: 'ValidationError', message: string, attribute?: string | null }> } | null };

export type AssignTrainingMutationVariables = Exact<{
  input: AssignTrainingInput;
}>;


export type AssignTrainingMutationResult = { __typename?: 'Mutation', assignTraining?: { __typename?: 'AssignTrainingPayload', invite?: { __typename?: 'Invite', id: number, gid: string, name: string, learner?: { __typename?: 'Learner', id: string, gid: string, active: boolean, createdAt: Date, email?: string | null, firstName: string, fullName: string, lastName: string, loginToken?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, invites: Array<{ __typename?: 'Invite', id: number, gid: string, name: string, status: string, updatedAt: Date, emailStatus: string, emailStatusMessage: string, emailShortStatusMessage: string, learner?: { __typename?: 'Learner', id: string, gid: string, firstName: string, lastName: string, fullName: string } | null, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean, resend: boolean } }>, can: { __typename?: 'LearnerPermissions', id: string, gid: string, update: boolean, updateContactMethods: boolean, sendResetPasswordInstructions: boolean, sendLearnerInviteNotification: boolean } } | null } | null, license: { __typename?: 'License', id: number, gid: string, availableSeats?: number | null, seats?: number | null, usedSeats: number, can: { __typename?: 'LicensePermissions', id: string, gid: string, take: boolean, share: boolean, destroy: boolean, assignTraining: boolean, createEnrolmentKey: boolean } } | { __typename?: 'LicenseGroup', gid: string, availableSeats?: number | null, seats?: number | null, usedSeats: number, can: { __typename?: 'LicensePermissions', id: string, gid: string, take: boolean, share: boolean, destroy: boolean, assignTraining: boolean, createEnrolmentKey: boolean } }, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateInviteeMutationVariables = Exact<{
  input: CreateInviteeInput;
}>;


export type CreateInviteeMutationResult = { __typename?: 'Mutation', createInvitee?: { __typename?: 'CreateInviteePayload', learner?: { __typename?: 'Learner', id: string, gid: string, active: boolean, createdAt: Date, email?: string | null, firstName: string, fullName: string, lastName: string, loginToken?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, can: { __typename?: 'LearnerPermissions', id: string, gid: string, update: boolean, updateContactMethods: boolean, sendResetPasswordInstructions: boolean, sendLearnerInviteNotification: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LearnerPartsFragment = { __typename?: 'Learner', id: string, gid: string, active: boolean, createdAt: Date, email?: string | null, firstName: string, fullName: string, lastName: string, loginToken?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, can: { __typename?: 'LearnerPermissions', id: string, gid: string, update: boolean, updateContactMethods: boolean, sendResetPasswordInstructions: boolean, sendLearnerInviteNotification: boolean } };

export type LoadCourseProgressionQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadCourseProgressionQueryResult = { __typename?: 'Query', grants?: { __typename?: 'GrantsNamespace', findById: { __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, certification?: { __typename?: 'Certification', id: number, gid: string, badgeUrl: string } | null, course: { __typename?: 'Course', id: number, gid: string, name: string, verificationServices: string, discussionForums: boolean, surveySchema?: { __typename?: 'SurveySchema', id: number, gid: string, closeable: boolean } | null, certificationTemplate?: { __typename?: 'CertificationTemplate', id: number, gid: string, digitalBadgeImage: { __typename?: 'AttacheFile', url: string, path: string, contentType: string, bytes: number, signature: string } } | null }, courseUserAgreements?: Array<{ __typename?: 'CourseUserAgreement', id: number, gid: string, viewedAt?: Date | null, agreedAt?: Date | null, courseAgreement: { __typename?: 'CourseAgreement', id: number, gid: string, name: string, fileUrl: string } }> | null, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, status: CourseProgressionStatusEnum, percentComplete: number, ordered: boolean, estimatedCompletionTime?: number | null, courseResources: Array<{ __typename?: 'CourseProgressionResource', name: string, url: string }>, courseItemProgressions: Array<{ __typename?: 'CourseItemProgression', id: number, gid: string, name: string, type: string, status: CourseItemProgressionStatusEnum, completed: boolean, gradedAssignmentSubmissionsClosedAt?: Date | null, runnable: boolean, openable: boolean, practiceable: boolean, attemptsRemaining?: number | null, progress: number, reviewable: boolean, courseItem: { __typename?: 'CourseItem', id: number, gid: string, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }, gradedAssignmentSettings?: { __typename?: 'GradedAssignmentSettings', id: number, gid: string, maxPoints: number, passingGrade: number } | null, gradedAssignmentSubmissions: Array<{ __typename?: 'GradedAssignmentSubmission', id: number, gid: string, createdAt: Date, passedAt?: Date | null, failedAt?: Date | null, points?: number | null, file: { __typename?: 'AttacheFile', url: string } }>, ilBooking?: { __typename?: 'ILBooking', id: number, gid: string, status: IlBookingStatusEnum, waitlistPosition?: number | null, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, ilSessions: Array<{ __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string }> }, ilClassResults: Array<{ __typename?: 'ILClassResult', id: number, gid: string, attendance?: boolean | null, passed?: boolean | null, grade?: string | null, ilCourseItem: { __typename?: 'ILCourseItem', id: number, gid: string, trackAttendance: boolean, trackGrade: boolean } }> } | null }> } | null } } | null };

export type LoadLearnerCertificationsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadLearnerCertificationsQueryResult = { __typename?: 'Query', learners?: { __typename?: 'LearnersNamespace', find: { __typename?: 'Learner', id: string, gid: string, certifications: Array<{ __typename?: 'Certification', id: number, gid: string, name: string, number: string, createdAt: Date, expiresAt?: Date | null, learnerVerifiedStatus: string, issuerName: string, badgeUrl: string, uploaded?: boolean | null, userFirstName: string, userLastName: string, description?: string | null, archived: boolean, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null, verifiedCredentialStatus: VerifiedCredentialStatusEnum, verifiedCredentialExported: boolean, can: { __typename?: 'CertificationPermissions', id: number, gid: string, show: boolean, archive: boolean, unarchive: boolean, destroy: boolean, requestChange: boolean, postToCredivera: boolean, exportVerifiedCredential: boolean, verifiedCredential: boolean, shareToSocial: boolean } }> } } | null };

export type LoadLearnerDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadLearnerDetailsQueryResult = { __typename?: 'Query', learners?: { __typename?: 'LearnersNamespace', find: { __typename?: 'Learner', id: string, gid: string, active: boolean, createdAt: Date, email?: string | null, firstName: string, fullName: string, lastName: string, loginToken?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, organizations: Array<{ __typename?: 'Organization', id: number, gid: string, name: string }>, can: { __typename?: 'LearnerPermissions', id: string, gid: string, update: boolean, updateContactMethods: boolean, sendResetPasswordInstructions: boolean, sendLearnerInviteNotification: boolean } } } | null };

export type LoadLearnerGrantDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadLearnerGrantDetailsQueryResult = { __typename?: 'Query', learners?: { __typename?: 'LearnersNamespace', find: { __typename?: 'Learner', id: string, gid: string, active: boolean, createdAt: Date, email?: string | null, firstName: string, fullName: string, lastName: string, loginToken?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, grants: Array<{ __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, createdAt?: Date | null, updatedAt: Date, can: { __typename?: 'GrantPermissions', id: number, gid: string, destroy: boolean }, course: { __typename?: 'Course', id: number, gid: string, name: string, photo?: { __typename?: 'AttacheFile', url: string } | null }, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, startedAt?: Date | null, completedAt?: Date | null, failedAt?: Date | null, courseItemProgressions: Array<{ __typename?: 'CourseItemProgression', id: number, gid: string, name: string, status: CourseItemProgressionStatusEnum, completed: boolean, progress: number, type: string, score?: number | null, failedAt?: Date | null, startedAt?: Date | null, completedAt?: Date | null, scorm?: { __typename?: 'Scorm', totalSeconds?: number | null, interactions: Array<{ __typename?: 'ScormInteraction', correctResponses: Array<string>, description?: string | null, latency?: string | null, learnerResponse?: string | null, result: string, timestamp: Date, type: string }> } | null, gradedAssignmentSettings?: { __typename?: 'GradedAssignmentSettings', id: number, gid: string, maxPoints: number, passingGrade: number } | null, can: { __typename?: 'CourseItemProgressionPermissions', id: number, gid: string, review: boolean }, ilBooking?: { __typename?: 'ILBooking', id: number, gid: string, status: IlBookingStatusEnum, waitlistPosition?: number | null, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, ilSessions: Array<{ __typename?: 'ILSession', id: number, gid: string, startsAt: Date, endsAt: Date, timeZone: string }> } } | null }> } | null }>, can: { __typename?: 'LearnerPermissions', id: string, gid: string, update: boolean, updateContactMethods: boolean, sendResetPasswordInstructions: boolean, sendLearnerInviteNotification: boolean } } } | null };

export type LoadLearnerInvitesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadLearnerInvitesQueryResult = { __typename?: 'Query', learners?: { __typename?: 'LearnersNamespace', find: { __typename?: 'Learner', id: string, gid: string, active: boolean, createdAt: Date, email?: string | null, firstName: string, fullName: string, lastName: string, loginToken?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, invites: Array<{ __typename?: 'Invite', id: number, gid: string, name: string, status: string, updatedAt: Date, emailStatus: string, emailStatusMessage: string, emailShortStatusMessage: string, learner?: { __typename?: 'Learner', id: string, gid: string, firstName: string, lastName: string, fullName: string } | null, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean, resend: boolean } }>, can: { __typename?: 'LearnerPermissions', id: string, gid: string, update: boolean, updateContactMethods: boolean, sendResetPasswordInstructions: boolean, sendLearnerInviteNotification: boolean } } } | null };

export type LoadLearnerListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type LoadLearnerListQueryResult = { __typename?: 'Query', learners?: { __typename?: 'LearnersNamespace', all: { __typename?: 'LearnerConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Learner', id: string, gid: string, active: boolean, createdAt: Date, email?: string | null, firstName: string, fullName: string, lastName: string, loginToken?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, can: { __typename?: 'LearnerPermissions', id: string, gid: string, update: boolean, updateContactMethods: boolean, sendResetPasswordInstructions: boolean, sendLearnerInviteNotification: boolean } } | null> | null } } | null };

export type LoginInviteMutationVariables = Exact<{
  input: LoginInviteInput;
}>;


export type LoginInviteMutationResult = { __typename?: 'Mutation', loginInvite?: { __typename?: 'LoginInvitePayload', ok: boolean } | null };

export type ShareLearnersMutationVariables = Exact<{
  input: ShareLearnersInput;
}>;


export type ShareLearnersMutationResult = { __typename?: 'Mutation', shareLearners?: { __typename?: 'ShareLearnersPayload', learners?: Array<{ __typename?: 'Learner', id: string, gid: string, active: boolean, createdAt: Date, email?: string | null, firstName: string, fullName: string, lastName: string, loginToken?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, organizations: Array<{ __typename?: 'Organization', id: number, gid: string, name: string }>, can: { __typename?: 'LearnerPermissions', id: string, gid: string, update: boolean, updateContactMethods: boolean, sendResetPasswordInstructions: boolean, sendLearnerInviteNotification: boolean } }> | null } | null };

export type UpdateLearnerMutationVariables = Exact<{
  input: UpdateLearnerInput;
}>;


export type UpdateLearnerMutationResult = { __typename?: 'Mutation', updateLearner?: { __typename?: 'UpdateLearnerPayload', learner?: { __typename?: 'Learner', id: string, gid: string, active: boolean, createdAt: Date, email?: string | null, firstName: string, fullName: string, lastName: string, loginToken?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, can: { __typename?: 'LearnerPermissions', id: string, gid: string, update: boolean, updateContactMethods: boolean, sendResetPasswordInstructions: boolean, sendLearnerInviteNotification: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateLearnersActiveMutationVariables = Exact<{
  input: UpdateLearnersActiveInput;
}>;


export type UpdateLearnersActiveMutationResult = { __typename?: 'Mutation', updateLearnersActive?: { __typename?: 'UpdateLearnersActivePayload', learners?: Array<{ __typename?: 'Learner', id: string, gid: string, active: boolean }> | null } | null };

export type UseActivationCodeMutationVariables = Exact<{
  input: UseActivationCodeInput;
}>;


export type UseActivationCodeMutationResult = { __typename?: 'Mutation', useActivationCode?: { __typename?: 'UseActivationCodePayload', user?: { __typename?: 'User', id: number } | null, errors?: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> | null } | null };

export type UseEnrolmentKeyMutationVariables = Exact<{
  input: UseEnrolmentKeyInput;
}>;


export type UseEnrolmentKeyMutationResult = { __typename?: 'Mutation', useEnrolmentKey?: { __typename?: 'UseEnrolmentKeyPayload', errors?: Array<string> | null, grant?: { __typename?: 'Grant', id: number, gid: string, course: { __typename?: 'Course', id: number, name: string } } | null } | null };

export type CreateLicenseMutationVariables = Exact<{
  input: CreateLicenseInput;
}>;


export type CreateLicenseMutationResult = { __typename?: 'Mutation', createLicense?: { __typename?: 'CreateLicensePayload', license?: { __typename?: 'License', id: number, gid: string, availableSeats?: number | null, grantedSeats: number, invitedSeats: number, seats?: number | null, usedSeats: number, createdAt: Date, stripeSubscription?: { __typename?: 'StripeSubscription', id: number, gid: string } | null, course: { __typename?: 'Course', id: number, gid: string, name: string, deprecatedAt?: Date | null, photo?: { __typename?: 'AttacheFile', url: string } | null, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string, name: string } | null }> }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, can: { __typename?: 'LicensePermissions', id: string, gid: string, destroy: boolean, share: boolean, take: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LicensePartsFragment = { __typename?: 'License', id: number, gid: string, availableSeats?: number | null, grantedSeats: number, invitedSeats: number, seats?: number | null, usedSeats: number, createdAt: Date, stripeSubscription?: { __typename?: 'StripeSubscription', id: number, gid: string } | null, course: { __typename?: 'Course', id: number, gid: string, name: string, deprecatedAt?: Date | null, photo?: { __typename?: 'AttacheFile', url: string } | null, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string, name: string } | null }> }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, can: { __typename?: 'LicensePermissions', id: string, gid: string, destroy: boolean, share: boolean, take: boolean } };

export type EnrolmentKeyConnectionPartsFragment = { __typename?: 'EnrolmentKeyConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'EnrolmentKey', id: number, gid: string, token: string, uses: number, maxUses?: number | null, remainingUses?: number | null, universal: boolean, expiresAt?: Date | null, deletedAt?: Date | null, isDeleted: boolean, can: { __typename?: 'EnrolmentKeyPermissions', id: number, gid: string, update: boolean, destroy: boolean, restore: boolean } } | null> | null };

export type LoadEnrolmentKeysQueryVariables = Exact<{
  gid: Scalars['ID'];
  withDeleted?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadEnrolmentKeysQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License', id: number, gid: string, enrolmentKeys: { __typename?: 'EnrolmentKeyConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'EnrolmentKey', id: number, gid: string, token: string, uses: number, maxUses?: number | null, remainingUses?: number | null, universal: boolean, expiresAt?: Date | null, deletedAt?: Date | null, isDeleted: boolean, can: { __typename?: 'EnrolmentKeyPermissions', id: number, gid: string, update: boolean, destroy: boolean, restore: boolean } } | null> | null } } | { __typename?: 'LicenseGroup', gid: string, enrolmentKeys: { __typename?: 'EnrolmentKeyConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'EnrolmentKey', id: number, gid: string, token: string, uses: number, maxUses?: number | null, remainingUses?: number | null, universal: boolean, expiresAt?: Date | null, deletedAt?: Date | null, isDeleted: boolean, can: { __typename?: 'EnrolmentKeyPermissions', id: number, gid: string, update: boolean, destroy: boolean, restore: boolean } } | null> | null } } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type LoadLicenseGroupDetailsQueryVariables = Exact<{
  gid: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadLicenseGroupDetailsQueryResult = { __typename?: 'Query', licenseGroups?: { __typename?: 'LicenseGroupsNamespace', findByGid?: { __typename?: 'LicenseGroup', id: string, gid: string, licenses: { __typename?: 'LicenseConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'License', id: number, gid: string, availableSeats?: number | null, grantedSeats: number, invitedSeats: number, seats?: number | null, usedSeats: number, createdAt: Date, stripeSubscription?: { __typename?: 'StripeSubscription', id: number, gid: string } | null, course: { __typename?: 'Course', id: number, gid: string, name: string, deprecatedAt?: Date | null, photo?: { __typename?: 'AttacheFile', url: string } | null, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string, name: string } | null }> }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, can: { __typename?: 'LicensePermissions', id: string, gid: string, destroy: boolean, share: boolean, take: boolean } } | null> | null } } | null } | null };

export type LoadLicenseGroupListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadLicenseGroupListQueryResult = { __typename?: 'Query', licenseGroups?: { __typename?: 'LicenseGroupsNamespace', all: { __typename?: 'LicenseGroupConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null }, nodes?: Array<{ __typename?: 'LicenseGroup', gid: string, availableSeats?: number | null, seats?: number | null, usedSeats: number, course: { __typename?: 'Course', id: number, gid: string, name: string, deprecatedAt?: Date | null, paths: { __typename?: 'CoursePaths', id: number, gid: string, productUrl?: string | null }, photo?: { __typename?: 'AttacheFile', url: string } | null, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, createdAt: Date, name: string, position: number, type: string, url?: string | null, scormPreviewLink?: string | null, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string, name: string } | null, file?: { __typename?: 'AttacheFile', url: string, contentType: string } | null, can: { __typename?: 'CourseItemPermissions', preview: boolean }, certificationTemplates: Array<{ __typename?: 'CertificationTemplate', id: number, gid: string, name: string }> }>, owner: { __typename?: 'Owner', id: number, gid: string, name: string } }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, can: { __typename?: 'LicensePermissions', id: string, gid: string, take: boolean, share: boolean, destroy: boolean, assignTraining: boolean, createEnrolmentKey: boolean } } | null> | null } } | null };

export type LoadLicenseInvitesQueryVariables = Exact<{
  gid: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadLicenseInvitesQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License', id: number, gid: string, invites: { __typename?: 'InviteConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Invite', id: number, gid: string, name: string, status: string, updatedAt: Date, emailStatus: string, emailStatusMessage: string, emailShortStatusMessage: string, learner?: { __typename?: 'Learner', id: string, gid: string, firstName: string, lastName: string, fullName: string } | null, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean, resend: boolean } } | null> | null } } | { __typename?: 'LicenseGroup', gid: string, invites: { __typename?: 'InviteConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Invite', id: number, gid: string, name: string, status: string, updatedAt: Date, emailStatus: string, emailStatusMessage: string, emailShortStatusMessage: string, learner?: { __typename?: 'Learner', id: string, gid: string, firstName: string, lastName: string, fullName: string } | null, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean, resend: boolean } } | null> | null } } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type LoadLicenseOrGroupForDistributionQueryVariables = Exact<{
  gid: Scalars['ID'];
}>;


export type LoadLicenseOrGroupForDistributionQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course', owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse', owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License', id: number, gid: string, availableSeats?: number | null, seats?: number | null, usedSeats: number, course: { __typename?: 'Course', id: number, gid: string, name: string, photo?: { __typename?: 'AttacheFile', url: string } | null, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string, name: string } | null }> }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, can: { __typename?: 'LicensePermissions', id: string, gid: string, take: boolean, share: boolean, destroy: boolean, assignTraining: boolean, createEnrolmentKey: boolean } } | { __typename?: 'LicenseGroup', gid: string, availableSeats?: number | null, seats?: number | null, usedSeats: number, course: { __typename?: 'Course', id: number, gid: string, name: string, photo?: { __typename?: 'AttacheFile', url: string } | null, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string, name: string } | null }> }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, can: { __typename?: 'LicensePermissions', id: string, gid: string, take: boolean, share: boolean, destroy: boolean, assignTraining: boolean, createEnrolmentKey: boolean } } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank', owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | { __typename?: 'NitoExam', owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem', owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront', owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type GrantUsageFragment = { __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, updatedAt: Date, firstName: string, lastName: string, email: string, mobileNumber: string, can: { __typename?: 'GrantPermissions', id: number, gid: string, destroy: boolean }, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, percentComplete: number } | null, user?: { __typename?: 'User', id: number, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null } | null };

export type InviteUsageFragment = { __typename?: 'Invite', id: number, gid: string, updatedAt: Date, firstName: string, lastName: string, email: string, mobileNumber: string, inviteStatus: string, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean }, learner?: { __typename?: 'Learner', id: string, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null } | null };

export type LoadLicenseUsageQueryVariables = Exact<{
  gid: Scalars['ID'];
}>;


export type LoadLicenseUsageQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License', id: number, gid: string, uses: Array<{ __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, updatedAt: Date, firstName: string, lastName: string, email: string, mobileNumber: string, can: { __typename?: 'GrantPermissions', id: number, gid: string, destroy: boolean }, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, percentComplete: number } | null, user?: { __typename?: 'User', id: number, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null } | null } | { __typename?: 'Invite', id: number, gid: string, updatedAt: Date, firstName: string, lastName: string, email: string, mobileNumber: string, inviteStatus: string, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean }, learner?: { __typename?: 'Learner', id: string, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null } | null }> } | { __typename?: 'LicenseGroup', gid: string, uses: Array<{ __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, updatedAt: Date, firstName: string, lastName: string, email: string, mobileNumber: string, can: { __typename?: 'GrantPermissions', id: number, gid: string, destroy: boolean }, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, percentComplete: number } | null, user?: { __typename?: 'User', id: number, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null } | null } | { __typename?: 'Invite', id: number, gid: string, updatedAt: Date, firstName: string, lastName: string, email: string, mobileNumber: string, inviteStatus: string, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean }, learner?: { __typename?: 'Learner', id: string, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null } | null }> } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type ShareLicenseMutationVariables = Exact<{
  input: ShareLicenseInput;
}>;


export type ShareLicenseMutationResult = { __typename?: 'Mutation', shareLicense?: { __typename?: 'ShareLicensePayload', sharedLicense?: { __typename?: 'License', id: number, gid: string, availableSeats?: number | null, grantedSeats: number, invitedSeats: number, seats?: number | null, usedSeats: number, createdAt: Date, stripeSubscription?: { __typename?: 'StripeSubscription', id: number, gid: string } | null, course: { __typename?: 'Course', id: number, gid: string, name: string, deprecatedAt?: Date | null, photo?: { __typename?: 'AttacheFile', url: string } | null, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string, name: string } | null }> }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, can: { __typename?: 'LicensePermissions', id: string, gid: string, destroy: boolean, share: boolean, take: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type SupportLicensePartsFragment = { __typename?: 'SupportLicense', id: number, gid: string, availableSeats?: number | null, grantedSeats: number, invitedSeats: number, seats?: number | null, usedSeats: number, course: { __typename?: 'SupportCourse', id: number, gid: string, name: string }, can: { __typename?: 'LicensePermissions', id: string, gid: string, destroy: boolean } };

export type TakeCourseMutationVariables = Exact<{
  input: TakeCourseInput;
}>;


export type TakeCourseMutationResult = { __typename?: 'Mutation', takeCourse?: { __typename?: 'TakeCoursePayload', grant?: { __typename?: 'Grant', id: number, gid: string } | null, license: { __typename?: 'License', id: number, gid: string, availableSeats?: number | null, seats?: number | null, usedSeats: number, can: { __typename?: 'LicensePermissions', id: string, gid: string, take: boolean, share: boolean, destroy: boolean, assignTraining: boolean, createEnrolmentKey: boolean } } | { __typename?: 'LicenseGroup', gid: string, availableSeats?: number | null, seats?: number | null, usedSeats: number, can: { __typename?: 'LicensePermissions', id: string, gid: string, take: boolean, share: boolean, destroy: boolean, assignTraining: boolean, createEnrolmentKey: boolean } }, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateLicenseMutationVariables = Exact<{
  input: UpdateLicenseInput;
}>;


export type UpdateLicenseMutationResult = { __typename?: 'Mutation', updateLicense?: { __typename?: 'UpdateLicensePayload', license?: { __typename?: 'License', id: number, gid: string, availableSeats?: number | null, grantedSeats: number, invitedSeats: number, seats?: number | null, usedSeats: number, createdAt: Date, stripeSubscription?: { __typename?: 'StripeSubscription', id: number, gid: string } | null, course: { __typename?: 'Course', id: number, gid: string, name: string, deprecatedAt?: Date | null, photo?: { __typename?: 'AttacheFile', url: string } | null, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string, name: string } | null }> }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, can: { __typename?: 'LicensePermissions', id: string, gid: string, destroy: boolean, share: boolean, take: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type LoadAttacheOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadAttacheOptionsQueryResult = { __typename?: 'Query', attacheOptions?: { __typename?: 'AttacheOptions', uuid: string, expiration: number, hmac: string, uploadUrl: string, downloadUrl: string } | null };

export type LoadCountryListQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadCountryListQueryResult = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', name: string, code: string, provinces?: Array<{ __typename?: 'Location', name: string, code: string }> | null }> | null };

export type LoadFontListQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadFontListQueryResult = { __typename?: 'Query', fonts?: Array<{ __typename?: 'Font', name: string, sizes: Array<number>, cssClass: string, url: string }> | null };

export type LoadStaticPathsListQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadStaticPathsListQueryResult = { __typename?: 'Query', staticPaths: Array<{ __typename?: 'StaticPath', id: number, gid: string, path: string, helper: string }> };

export type LoadUiQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadUiQueryResult = { __typename?: 'Query', automationScripts?: { __typename?: 'AutomationScriptsNamespace', eventTypes: Array<{ __typename?: 'DescribedAutomationEvent', event: AutomationEvent, description: string }> } | null };

export type LoadOfflineOrderDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadOfflineOrderDetailsQueryResult = { __typename?: 'Query', offlineOrders?: { __typename?: 'OfflineOrdersNamespace', findById: { __typename?: 'OfflineOrder', id: number, gid: string, customerNumber?: string | null, purchaseOrderNumber?: string | null, salesPersonName?: string | null, note?: string | null, withoutPayment: boolean, order: { __typename?: 'Order', id: number, gid: string, createdAt: Date, subtotalFormatted: string, shippingFormatted: string, taxFormatted: string, totalFormatted: string, promotionalSavingsFormatted: string, paymentMethod: string, user: { __typename?: 'User', id: number, gid: string, fullName: string }, billingAddress: { __typename?: 'BillingAddress', id?: number | null, address1?: string | null, address2?: string | null, city?: string | null, postalCode?: string | null, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null }, shippingAddress?: { __typename?: 'Address', id: number, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, shippingInformation?: { __typename?: 'ShippingInformation', id: number, name: string, companyName?: string | null, email: string, phoneNumber: string } | null, orderItems: Array<{ __typename?: 'OrderItem', id: number, gid: string, quantity: number, priceFormatted: string, totalFormatted: string, product: { __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null } }>, promoCodeUses: Array<{ __typename?: 'PromoCodeUse', id: number, gid: string, savingsFormatted: string, promoCode: { __typename?: 'PromoCode', id: number, gid: string, description: string }, orderItem?: { __typename?: 'OrderItem', id: number, gid: string, product: { __typename?: 'Product', id: number, gid: string, name: string }, originalProduct: { __typename?: 'OriginalProduct', priceFormatted: string } } | null }> }, orderPerson: { __typename?: 'User', id: number, gid: string, fullName: string } } } | null };

export type LoadOfflineOrderListQueryVariables = Exact<{
  storefrontId?: InputMaybe<Scalars['Int']>;
}>;


export type LoadOfflineOrderListQueryResult = { __typename?: 'Query', offlineOrders?: { __typename?: 'OfflineOrdersNamespace', all: { __typename?: 'OfflineOrderConnection', nodes?: Array<{ __typename?: 'OfflineOrder', id: number, gid: string, order: { __typename?: 'Order', id: number, gid: string } } | null> | null } } | null };

export type CreateRefundMutationVariables = Exact<{
  input: CreateRefundInput;
}>;


export type CreateRefundMutationResult = { __typename?: 'Mutation', createRefund?: { __typename?: 'CreateRefundPayload', refund?: { __typename?: 'Refund', id: number, gid: string, total: number, refundItems: Array<{ __typename?: 'RefundItem', id: number, gid: string, quantity: number, amount: number }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string, attribute?: string | null }> } | null };

export type EstimateRefundTaxesQueryVariables = Exact<{
  orderId: Scalars['Int'];
  orderItems: Array<OrderItemPairAttributes> | OrderItemPairAttributes;
  refundShipping: Scalars['Boolean'];
}>;


export type EstimateRefundTaxesQueryResult = { __typename?: 'Query', taxes?: { __typename?: 'TaxesNamespace', estimateForRefund: Array<{ __typename?: 'TaxItem', rate: number, description: string, amount: number }> } | null };

export type InitiateOfflineOrderMutationVariables = Exact<{
  input: InitiateOfflineOrderInput;
}>;


export type InitiateOfflineOrderMutationResult = { __typename?: 'Mutation', initiateOfflineOrder?: { __typename?: 'InitiateOfflineOrderPayload', success: boolean } | null };

export type LoadOrderDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadOrderDetailsQueryResult = { __typename?: 'Query', orders?: { __typename?: 'OrdersNamespace', findById: { __typename?: 'Order', id: number, gid: string, createdAt: Date, paymentMethod: string, refundedAmount: number, refundedAmountFormatted: string, refundableAmount: number, refundableAmountFormatted: string, subtotalFormatted: string, shippingFormatted: string, tax: number, taxFormatted: string, total: number, totalFormatted: string, promotionalSavingsFormatted: string, shipping: number, can: { __typename?: 'OrderPermissions', id: number, gid: string, refund: boolean }, user: { __typename?: 'User', id: number, gid: string, fullName: string, certificationDefault?: { __typename?: 'CertificationDefault', id: number, gid: string, name: string } | null }, currency: { __typename?: 'Currency', isoCode: string, name: string }, taxItems: Array<{ __typename?: 'TaxItem', id: number, gid: string, description: string, rate: number, amount: number, amountFormatted: string }>, billingAddress: { __typename?: 'BillingAddress', id?: number | null, address1?: string | null, address2?: string | null, city?: string | null, postalCode?: string | null, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null }, shippingAddress?: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } | null, shippingInformation?: { __typename?: 'ShippingInformation', id: number, name: string, companyName?: string | null, email: string, phoneNumber: string } | null, shippingItems: Array<{ __typename?: 'ShippingItem', id: number, gid: string, kind: string, amount: number, taxItems: Array<{ __typename?: 'TaxItem', id: number, gid: string, description: string, rate: number, amount: number, amountFormatted: string }> }>, orderItems: Array<{ __typename?: 'OrderItem', id: number, gid: string, quantity: number, price: number, total: number, priceFormatted: string, totalFormatted: string, promotionalSavings: number, promotionalSavingsFormatted: string, refundableAmount: number, refundableQuantity: number, requiresShipping: boolean, product: { __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null, price: number, brand?: string | null }, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, code: string, value: number, type: PromoCodeTypeEnum } | null, can: { __typename?: 'OrderItemPermissions', id: number, gid: string, refund: boolean } }>, promoCodeUses: Array<{ __typename?: 'PromoCodeUse', id: number, gid: string, savingsFormatted: string, promoCode: { __typename?: 'PromoCode', id: number, gid: string, description: string, code: string }, orderItem?: { __typename?: 'OrderItem', id: number, gid: string, product: { __typename?: 'Product', id: number, gid: string, name: string, brand?: string | null, sku?: string | null, price: number }, originalProduct: { __typename?: 'OriginalProduct', priceFormatted: string } } | null }>, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string, email?: string | null, phoneNumber?: string | null, businessNumber?: string | null, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } }, usedLicenses: Array<{ __typename?: 'License', id: number, gid: string, course: { __typename?: 'Course', id: number, gid: string, name: string }, uses: Array<{ __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, consumersLastActivity?: Date | null, grantableType: string, can: { __typename?: 'GrantPermissions', id: number, gid: string, destroy: boolean }, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, percentComplete: number } | null, user?: { __typename?: 'User', id: number, gid: string, fullName: string } | null } | { __typename?: 'Invite', id: number, gid: string, consumersLastActivity?: Date | null, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean }, learner?: { __typename?: 'Learner', id: string, gid: string, fullName: string } | null }> }>, refunds: Array<{ __typename?: 'Refund', id: number, gid: string, createdAt: Date, reason: string, total: number, totalFormatted: string, refundItems: Array<{ __typename?: 'RefundItem', id: number, gid: string, quantity: number, amount: number, amountFormatted: string, orderItem: { __typename?: 'OrderItem', id: number, gid: string, product: { __typename?: 'Product', id: number, gid: string, name: string } } }> }>, stripeRefunds: Array<{ __typename?: 'StripeRefund', id: number, gid: string, amount: number, amountFormatted: string, stripeChargeId: string, stripeRefundId: string, createdAt: Date }> } } | null };

export type LoadStorefrontOrdersQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadStorefrontOrdersQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findById: { __typename?: 'Storefront', id: number, gid: string, name: string, orders: { __typename?: 'OrderConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Order', id: number, gid: string, createdAt: Date, shipping: number, subtotal: number, tax: number, total: number, totalFormatted: string, refundedAmount: number, refundedAmountFormatted: string, currency: { __typename?: 'Currency', isoCode: string, name: string }, user: { __typename?: 'User', id: number, gid: string, email?: string | null, name: string }, can: { __typename?: 'OrderPermissions', id: number, gid: string, refund: boolean }, orderItems: Array<{ __typename?: 'OrderItem', id: number, gid: string, quantity: number, price: number, total: number, refundableQuantity: number, refundableAmount: number, can: { __typename?: 'OrderItemPermissions', id: number, gid: string, refund: boolean }, product: { __typename?: 'Product', id: number, gid: string, name: string, price: number }, refundItems?: Array<{ __typename?: 'RefundItem', id: number, gid: string, quantity: number, amount: number }> | null }>, refunds: Array<{ __typename?: 'Refund', id: number, gid: string, total: number, refundItems: Array<{ __typename?: 'RefundItem', id: number, gid: string, quantity: number, amount: number }> }>, stripeRefunds: Array<{ __typename?: 'StripeRefund', id: number, gid: string, amount: number, stripeChargeId: string, stripeRefundId: string, createdAt: Date }>, taxItems: Array<{ __typename?: 'TaxItem', id: number, gid: string, amount: number, description: string }>, promoCodeUses: Array<{ __typename?: 'PromoCodeUse', id: number, gid: string, savings: number, promoCode: { __typename?: 'PromoCode', id: number, gid: string, type: PromoCodeTypeEnum, code: string } }> } | null> | null } } } | null };

export type LoadUserOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadUserOrdersQueryResult = { __typename?: 'Query', orders?: { __typename?: 'OrdersNamespace', mine: { __typename?: 'OrderConnection', nodes?: Array<{ __typename?: 'Order', id: number, gid: string, total: number, totalFormatted: string, tax: number, taxFormatted: string, shipping: number, shippingFormatted: string, refundedAmount: number, refundedAmountFormatted: string, refundableAmount: number, refundableAmountFormatted: string, createdAt: Date, orderItems: Array<{ __typename?: 'OrderItem', id: number, gid: string, price: number, priceFormatted: string, quantity: number, totalFormatted: string, product: { __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null, photo?: { __typename?: 'AttacheFile', url: string } | null }, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, code: string, value: number, type: PromoCodeTypeEnum } | null }>, user: { __typename?: 'User', id: number, gid: string, fullName: string }, refunds: Array<{ __typename?: 'Refund', id: number, gid: string, createdAt: Date, reason: string, total: number, totalFormatted: string, refundItems: Array<{ __typename?: 'RefundItem', id: number, gid: string, quantity: number, amount: number, amountFormatted: string, orderItem: { __typename?: 'OrderItem', id: number, gid: string, product: { __typename?: 'Product', id: number, gid: string, name: string } } }> }>, stripeRefunds: Array<{ __typename?: 'StripeRefund', id: number, gid: string, amount: number, amountFormatted: string, stripeChargeId: string, stripeRefundId: string, createdAt: Date }> } | null> | null } } | null };

export type RefundsPartsFragment = { __typename?: 'Order', refunds: Array<{ __typename?: 'Refund', id: number, gid: string, createdAt: Date, reason: string, total: number, totalFormatted: string, refundItems: Array<{ __typename?: 'RefundItem', id: number, gid: string, quantity: number, amount: number, amountFormatted: string, orderItem: { __typename?: 'OrderItem', id: number, gid: string, product: { __typename?: 'Product', id: number, gid: string, name: string } } }> }>, stripeRefunds: Array<{ __typename?: 'StripeRefund', id: number, gid: string, amount: number, amountFormatted: string, stripeChargeId: string, stripeRefundId: string, createdAt: Date }> };

export type AutomationLogPartsFragment = { __typename?: 'AutomationLog', id: number, gid: string, severity: string, message: string, sidekiqJobId?: string | null, createdAt: Date };

export type AutomationScriptPartsFragment = { __typename?: 'AutomationScript', id: number, gid: string, title: string, translatedEvent: string, event: AutomationEvent, enabled: boolean, lua: string };

export type CreateAutomationConstantMutationVariables = Exact<{
  input: CreateAutomationConstantInput;
}>;


export type CreateAutomationConstantMutationResult = { __typename?: 'Mutation', createAutomationConstant?: { __typename?: 'CreateAutomationConstantPayload', constant?: { __typename?: 'AutomationConstant', id: number, gid: string, name: string, value: string } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreateAutomationScriptMutationVariables = Exact<{
  input: CreateAutomationScriptInput;
}>;


export type CreateAutomationScriptMutationResult = { __typename?: 'Mutation', createAutomationScript?: { __typename?: 'CreateAutomationScriptPayload', script?: { __typename?: 'AutomationScript', id: number, gid: string, title: string, translatedEvent: string, event: AutomationEvent, enabled: boolean, lua: string } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type LoadAutomationScriptDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadAutomationScriptDetailsQueryResult = { __typename?: 'Query', automationScripts?: { __typename?: 'AutomationScriptsNamespace', findById: { __typename?: 'AutomationScript', id: number, gid: string, title: string, translatedEvent: string, event: AutomationEvent, enabled: boolean, lua: string } } | null };

export type LoadAutomationScriptLogsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadAutomationScriptLogsQueryResult = { __typename?: 'Query', automationScripts?: { __typename?: 'AutomationScriptsNamespace', findById: { __typename?: 'AutomationScript', id: number, gid: string, title: string, automationLogs: Array<{ __typename?: 'AutomationLog', id: number, gid: string, severity: string, message: string, sidekiqJobId?: string | null, createdAt: Date, childLogs: Array<{ __typename?: 'AutomationLog', id: number, gid: string, severity: string, message: string, sidekiqJobId?: string | null, createdAt: Date }> }> } } | null };

export type LoadOrganizationAutomationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadOrganizationAutomationQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', findById: { __typename?: 'Organization', id: number, gid: string, name: string, automationScripts?: Array<{ __typename?: 'AutomationScript', id: number, gid: string, title: string, translatedEvent: string, event: AutomationEvent, enabled: boolean, lua: string }> | null, automationConstants?: Array<{ __typename?: 'AutomationConstant', id: number, gid: string, name: string, secret: boolean, value: string }> | null } } | null };

export type UpdateAutomationConstantMutationVariables = Exact<{
  input: UpdateAutomationConstantInput;
}>;


export type UpdateAutomationConstantMutationResult = { __typename?: 'Mutation', updateAutomationConstant?: { __typename?: 'UpdateAutomationConstantPayload', constant?: { __typename?: 'AutomationConstant', id: number, gid: string, name: string, value: string } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type UpdateAutomationScriptMutationVariables = Exact<{
  input: UpdateAutomationScriptInput;
}>;


export type UpdateAutomationScriptMutationResult = { __typename?: 'Mutation', updateAutomationScript?: { __typename?: 'UpdateAutomationScriptPayload', script?: { __typename?: 'AutomationScript', id: number, gid: string, title: string, translatedEvent: string, event: AutomationEvent, enabled: boolean, lua: string } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreateOidcProviderMutationVariables = Exact<{
  input: CreateOidcProviderInput;
}>;


export type CreateOidcProviderMutationResult = { __typename?: 'Mutation', createOidcProvider?: { __typename?: 'CreateOIDCProviderPayload', oidcProvider?: { __typename?: 'OIDCProvider', id: number, gid: string, name: string, clientId: string, clientSecret: string, configurationUrl: string, scope: string, confirmEmailDuringSignup: boolean, promoCodeClaimPath?: string | null, automationClaimPath?: string | null, can: { __typename?: 'OIDCProviderPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutationResult = { __typename?: 'Mutation', createOrganization?: { __typename?: 'CreateOrganizationPayload', organization?: { __typename?: 'Organization', id: number, gid: string, name: string } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateSamlProviderMutationVariables = Exact<{
  input: CreateSamlProviderInput;
}>;


export type CreateSamlProviderMutationResult = { __typename?: 'Mutation', createSamlProvider?: { __typename?: 'CreateSAMLProviderPayload', samlProvider?: { __typename?: 'SAMLProvider', id: number, gid: string, name: string, issuerUrl?: string | null, certFingerprint: string, certFingerprintAlgorithm: SamlProviderEncryptionAlgorithmsTypeEnum, targetUrl: string, sloTargetUrl?: string | null, confirmEmailDuringSignup: boolean, triggerIdpLogout: boolean, uidMapping?: string | null, firstNameMapping: string, lastNameMapping: string, emailMapping?: string | null, automationMapping?: string | null, promoCodesMapping?: string | null, acsUrl: string, sloUrl: string, can: { __typename?: 'SAMLProviderPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type InviteOrganizationMemberMutationVariables = Exact<{
  input: InviteOrganizationMemberInput;
}>;


export type InviteOrganizationMemberMutationResult = { __typename?: 'Mutation', inviteOrganizationMember?: { __typename?: 'InviteOrganizationMemberPayload', ok: boolean } | null };

export type LoadInstructorOrganizationListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadInstructorOrganizationListQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', allForInstructor: { __typename?: 'OrganizationConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'Organization', id: number, gid: string, name: string } | null> | null } } | null };

export type LoadOrganizationDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadOrganizationDetailsQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', findById: { __typename?: 'Organization', id: number, gid: string, name: string, billingEmail?: string | null, shippingNotificationEmail?: string | null, url?: string | null, analyticsOptIn: boolean, taxCodes: Array<TaxCodeEnum>, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null }, certificationDefault?: { __typename?: 'CertificationDefault', id: number, gid: string, name: string, customSignature?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, geometry?: string | null, contentType: string, signature: string } | null, customLogo?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, geometry?: string | null, contentType: string, signature: string } | null, address?: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } | null } | null, can: { __typename?: 'OrganizationPermissions', id: number, gid: string, update: boolean, integrate: boolean, automation: boolean, manageVerifiedCredentials: boolean, manageTrainingMatrix: boolean, stripeConnect: boolean, manageSurveys: boolean, manageSso: boolean } } } | null };

export type LoadOrganizationListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadOrganizationListQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', all: { __typename?: 'OrganizationConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'Organization', id: number, gid: string, name: string } | null> | null } } | null };

export type LoadOrganizationMembershipsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadOrganizationMembershipsQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', findById: { __typename?: 'Organization', id: number, gid: string, memberships?: Array<{ __typename?: 'OrganizationMembership', id: number, gid: string, user: { __typename?: 'User', id: number, gid: string, fullName: string, email?: string | null, mobileNumber?: string | null }, can: { __typename?: 'OrganizationMembershipPermissions', id: number, gid: string, destroy: boolean } }> | null } } | null };

export type LoadOrganizationPermissionsQueryVariables = Exact<{
  gid: Scalars['ID'];
}>;


export type LoadOrganizationPermissionsQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', findByGid?: { __typename?: 'Organization', id: number, gid: string, can: { __typename?: 'OrganizationPermissions', id: number, gid: string, update: boolean, integrate: boolean, automation: boolean, manageVerifiedCredentials: boolean, manageTrainingMatrix: boolean, stripeConnect: boolean, manageSurveys: boolean, manageSso: boolean } } | null } | null };

export type LoadOrganizationSsoProvidersQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadOrganizationSsoProvidersQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', findById: { __typename?: 'Organization', id: number, gid: string, can: { __typename?: 'OrganizationPermissions', id: number, gid: string, manageSso: boolean }, samlProviders?: Array<{ __typename?: 'SAMLProvider', id: number, gid: string, name: string, issuerUrl?: string | null, certFingerprint: string, certFingerprintAlgorithm: SamlProviderEncryptionAlgorithmsTypeEnum, targetUrl: string, sloTargetUrl?: string | null, confirmEmailDuringSignup: boolean, triggerIdpLogout: boolean, uidMapping?: string | null, firstNameMapping: string, lastNameMapping: string, emailMapping?: string | null, automationMapping?: string | null, promoCodesMapping?: string | null, acsUrl: string, sloUrl: string, can: { __typename?: 'SAMLProviderPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> | null, oidcProviders?: Array<{ __typename?: 'OIDCProvider', id: number, gid: string, name: string, clientId: string, clientSecret: string, configurationUrl: string, scope: string, confirmEmailDuringSignup: boolean, promoCodeClaimPath?: string | null, automationClaimPath?: string | null, can: { __typename?: 'OIDCProviderPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> | null } } | null };

export type LoadOrganizationStripeQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadOrganizationStripeQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', findById: { __typename?: 'Organization', id: number, gid: string, stripeConnectPaths?: Array<{ __typename?: 'OrganizationStripePath', name: string, path: string, isoCode: string }> | null, connectedStripeAccounts?: Array<{ __typename?: 'ConnectedStripeAccount', id: number, gid: string, stripeUserId: string, currency: { __typename?: 'Currency', isoCode: string, name: string } }> | null } } | null };

export type LoadOrganizationWithRevenueQueryVariables = Exact<{
  gid: Scalars['ID'];
  currency: Scalars['String'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
}>;


export type LoadOrganizationWithRevenueQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', findByGid?: { __typename?: 'Organization', id: number, gid: string, name: string, revenues?: { __typename?: 'OrganizationRevenues', royalties: { __typename?: 'OrganizationRoyaltiesRevenue', amount: number, records: { __typename?: 'PayoutConnection', nodes?: Array<{ __typename?: 'Payout', id: number, gid: string, amount: number, revenuePart: PayoutRevenuePartEnum, createdAt: Date, organization?: { __typename?: 'Organization', id: number, gid: string, name: string } | null, refundable?: { __typename?: 'RefundItem', id: number, gid: string } | { __typename?: 'StripeRefund', id: number, gid: string, stripeChargeId: string, stripeRefundId: string, amount: number, refundable: { __typename?: 'Order', id: number, gid: string, createdAt: Date, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string } } | { __typename?: 'StripeSubscription', id: number, gid: string, stripeSubscriptionId: string, createdAt: Date } } | null, orderItem?: { __typename?: 'OrderItem', id: number, gid: string, total: number, order: { __typename?: 'Order', id: number, gid: string, createdAt: Date, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string } }, product: { __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null } } | null, contract: { __typename?: 'Contract', id: number, gid: string, name: string } } | null> | null } }, royaltiesTaxes: { __typename?: 'OrganizationRoyaltiesTaxesRevenue', amount: number }, commissions: { __typename?: 'OrganizationCommissionsRevenue', amount: number, records: { __typename?: 'PayoutConnection', nodes?: Array<{ __typename?: 'Payout', id: number, gid: string, amount: number, revenuePart: PayoutRevenuePartEnum, createdAt: Date, organization?: { __typename?: 'Organization', id: number, gid: string, name: string } | null, refundable?: { __typename?: 'RefundItem', id: number, gid: string } | { __typename?: 'StripeRefund', id: number, gid: string, stripeChargeId: string, stripeRefundId: string, amount: number, refundable: { __typename?: 'Order', id: number, gid: string, createdAt: Date, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string } } | { __typename?: 'StripeSubscription', id: number, gid: string, stripeSubscriptionId: string, createdAt: Date } } | null, orderItem?: { __typename?: 'OrderItem', id: number, gid: string, total: number, order: { __typename?: 'Order', id: number, gid: string, createdAt: Date, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string } }, product: { __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null } } | null, contract: { __typename?: 'Contract', id: number, gid: string, name: string } } | null> | null } }, courseDistribution: { __typename?: 'OrganizationCourseDistributionRevenue', amount: number }, platformLicenses: { __typename?: 'OrganizationPlatformLicensesRevenue', amount: number }, transactionFees: { __typename?: 'OrganizationTransactionFeesRevenue', amount: number }, federalTaxes: { __typename?: 'OrganizationFederalTaxesRevenue', amount: number } } | null, storefronts?: Array<{ __typename?: 'Storefront', id: number, gid: string, name: string, currency: { __typename?: 'Currency', isoCode: string, name: string }, revenues?: { __typename?: 'StorefrontRevenues', startPeriod: any, endPeriod: any, onlineTraining: { __typename?: 'StorefrontOnlineTrainingRevenue', amount: number }, ilTraining: { __typename?: 'StorefrontILTrainingRevenue', amount: number }, physicalProduct: { __typename?: 'StorefrontPhysicalProductRevenue', amount: number }, promoCodeSaving: { __typename?: 'StorefrontPromoCodeSavingRevenue', amount: number }, shipping: { __typename?: 'StorefrontShippingRevenue', amount: number }, platformSetup: { __typename?: 'StorefrontPlatformSetupRevenue', amount: number }, platformLicenses: { __typename?: 'StorefrontRecurringFlatFeeRevenue', amount: number }, transactionFees: { __typename?: 'StorefrontTransactionFeesRevenue', amount: number }, subscription: { __typename?: 'StorefrontSubscriptionRevenue', amount: number }, courseDistribution: { __typename?: 'StorefrontCourseDistributionRevenue', amount: number }, thirdPartyPayout: { __typename?: 'StorefrontThirdPartyPayoutRevenue', amount: number }, refunds: { __typename?: 'StorefrontRefundRevenue', amount: number }, federalTaxes: { __typename?: 'StorefrontFederalTaxRevenue', amount: number }, provincialTaxes: { __typename?: 'StorefrontProvincialTaxRevenue', amount: number } } | null }> | null } | null } | null };

export type LoadOrganizationListWithRevenueQueryVariables = Exact<{
  currency: Scalars['String'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
}>;


export type LoadOrganizationListWithRevenueQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', allForTheLedger: { __typename?: 'OrganizationConnection', nodes?: Array<{ __typename?: 'Organization', id: number, gid: string, name: string, wktOwned: boolean, stripeSelfManaged: boolean, revenues?: { __typename?: 'OrganizationRevenues', royalties: { __typename?: 'OrganizationRoyaltiesRevenue', amount: number }, royaltiesTaxes: { __typename?: 'OrganizationRoyaltiesTaxesRevenue', amount: number }, commissions: { __typename?: 'OrganizationCommissionsRevenue', amount: number }, courseDistribution: { __typename?: 'OrganizationCourseDistributionRevenue', amount: number }, platformLicenses: { __typename?: 'OrganizationPlatformLicensesRevenue', amount: number }, transactionFees: { __typename?: 'OrganizationTransactionFeesRevenue', amount: number }, federalTaxes: { __typename?: 'OrganizationFederalTaxesRevenue', amount: number } } | null, storefronts?: Array<{ __typename?: 'Storefront', id: number, gid: string, name: string, revenues?: { __typename?: 'StorefrontRevenues', startPeriod: any, endPeriod: any, onlineTraining: { __typename?: 'StorefrontOnlineTrainingRevenue', amount: number }, ilTraining: { __typename?: 'StorefrontILTrainingRevenue', amount: number }, physicalProduct: { __typename?: 'StorefrontPhysicalProductRevenue', amount: number }, promoCodeSaving: { __typename?: 'StorefrontPromoCodeSavingRevenue', amount: number }, shipping: { __typename?: 'StorefrontShippingRevenue', amount: number }, platformSetup: { __typename?: 'StorefrontPlatformSetupRevenue', amount: number }, platformLicenses: { __typename?: 'StorefrontRecurringFlatFeeRevenue', amount: number }, transactionFees: { __typename?: 'StorefrontTransactionFeesRevenue', amount: number }, subscription: { __typename?: 'StorefrontSubscriptionRevenue', amount: number }, courseDistribution: { __typename?: 'StorefrontCourseDistributionRevenue', amount: number }, thirdPartyPayout: { __typename?: 'StorefrontThirdPartyPayoutRevenue', amount: number }, refunds: { __typename?: 'StorefrontRefundRevenue', amount: number }, federalTaxes: { __typename?: 'StorefrontFederalTaxRevenue', amount: number }, provincialTaxes: { __typename?: 'StorefrontProvincialTaxRevenue', amount: number } } | null }> | null } | null> | null } } | null };

export type OidcProviderPartsFragment = { __typename?: 'OIDCProvider', id: number, gid: string, name: string, clientId: string, clientSecret: string, configurationUrl: string, scope: string, confirmEmailDuringSignup: boolean, promoCodeClaimPath?: string | null, automationClaimPath?: string | null, can: { __typename?: 'OIDCProviderPermissions', id: number, gid: string, update: boolean, destroy: boolean } };

export type AttacheFilePartsFragment = { __typename?: 'AttacheFile', url: string, path: string, bytes: number, geometry?: string | null, contentType: string, signature: string };

export type OrganizationDetailPartsFragment = { __typename?: 'Organization', id: number, gid: string, name: string, billingEmail?: string | null, shippingNotificationEmail?: string | null, url?: string | null, analyticsOptIn: boolean, taxCodes: Array<TaxCodeEnum>, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null }, certificationDefault?: { __typename?: 'CertificationDefault', id: number, gid: string, name: string, customSignature?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, geometry?: string | null, contentType: string, signature: string } | null, customLogo?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, geometry?: string | null, contentType: string, signature: string } | null, address?: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } | null } | null, can: { __typename?: 'OrganizationPermissions', id: number, gid: string, update: boolean, integrate: boolean, automation: boolean, manageVerifiedCredentials: boolean, manageTrainingMatrix: boolean, stripeConnect: boolean, manageSurveys: boolean, manageSso: boolean } };

export type OrganizationPartsFragment = { __typename?: 'Organization', id: number, gid: string, name: string };

export type OrganizationPermissionsPartsFragment = { __typename?: 'Organization', can: { __typename?: 'OrganizationPermissions', id: number, gid: string, update: boolean, integrate: boolean, automation: boolean, manageVerifiedCredentials: boolean, manageTrainingMatrix: boolean, stripeConnect: boolean, manageSurveys: boolean, manageSso: boolean } };

export type SamlProviderPartsFragment = { __typename?: 'SAMLProvider', id: number, gid: string, name: string, issuerUrl?: string | null, certFingerprint: string, certFingerprintAlgorithm: SamlProviderEncryptionAlgorithmsTypeEnum, targetUrl: string, sloTargetUrl?: string | null, confirmEmailDuringSignup: boolean, triggerIdpLogout: boolean, uidMapping?: string | null, firstNameMapping: string, lastNameMapping: string, emailMapping?: string | null, automationMapping?: string | null, promoCodesMapping?: string | null, acsUrl: string, sloUrl: string, can: { __typename?: 'SAMLProviderPermissions', id: number, gid: string, update: boolean, destroy: boolean } };

export type UpdateOidcProviderMutationVariables = Exact<{
  input: UpdateOidcProviderInput;
}>;


export type UpdateOidcProviderMutationResult = { __typename?: 'Mutation', updateOidcProvider?: { __typename?: 'UpdateOIDCProviderPayload', oidcProvider?: { __typename?: 'OIDCProvider', id: number, gid: string, name: string, clientId: string, clientSecret: string, configurationUrl: string, scope: string, confirmEmailDuringSignup: boolean, promoCodeClaimPath?: string | null, automationClaimPath?: string | null, can: { __typename?: 'OIDCProviderPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutationResult = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'UpdateOrganizationPayload', organization?: { __typename?: 'Organization', id: number, gid: string, name: string, billingEmail?: string | null, shippingNotificationEmail?: string | null, url?: string | null, analyticsOptIn: boolean, taxCodes: Array<TaxCodeEnum>, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null }, certificationDefault?: { __typename?: 'CertificationDefault', id: number, gid: string, name: string, customSignature?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, geometry?: string | null, contentType: string, signature: string } | null, customLogo?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, geometry?: string | null, contentType: string, signature: string } | null, address?: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } | null } | null, can: { __typename?: 'OrganizationPermissions', id: number, gid: string, update: boolean, integrate: boolean, automation: boolean, manageVerifiedCredentials: boolean, manageTrainingMatrix: boolean, stripeConnect: boolean, manageSurveys: boolean, manageSso: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateSamlProviderMutationVariables = Exact<{
  input: UpdateSamlProviderInput;
}>;


export type UpdateSamlProviderMutationResult = { __typename?: 'Mutation', updateSamlProvider?: { __typename?: 'UpdateSAMLProviderPayload', samlProvider?: { __typename?: 'SAMLProvider', id: number, gid: string, name: string, issuerUrl?: string | null, certFingerprint: string, certFingerprintAlgorithm: SamlProviderEncryptionAlgorithmsTypeEnum, targetUrl: string, sloTargetUrl?: string | null, confirmEmailDuringSignup: boolean, triggerIdpLogout: boolean, uidMapping?: string | null, firstNameMapping: string, lastNameMapping: string, emailMapping?: string | null, automationMapping?: string | null, promoCodesMapping?: string | null, acsUrl: string, sloUrl: string, can: { __typename?: 'SAMLProviderPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LoadProductCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadProductCatalogQueryResult = { __typename?: 'Query', products?: { __typename?: 'ProductsNamespace', catalog: { __typename?: 'ProductCatalog', categories: Array<string>, products: Array<{ __typename?: 'Product', priceWithDiscount: number, discount: number, id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> } } | null };

export type LoadProductDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadProductDetailsQueryResult = { __typename?: 'Query', products?: { __typename?: 'ProductsNamespace', findById: { __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } } } | null };

export type LoadProductListQueryVariables = Exact<{
  storefrontId?: InputMaybe<Scalars['Int']>;
}>;


export type LoadProductListQueryResult = { __typename?: 'Query', products?: { __typename?: 'ProductsNamespace', all: Array<{ __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> } | null };

export type CreateRapidqlScheduleMutationVariables = Exact<{
  input: CreateRapidqlScheduleInput;
}>;


export type CreateRapidqlScheduleMutationResult = { __typename?: 'Mutation', createRapidqlSchedule?: { __typename?: 'CreateRapidqlSchedulePayload', rapidqlSchedule?: { __typename?: 'RapidqlSchedule', id: number, gid: string, emailTo: Array<string>, emailCc: Array<string>, emailBcc: Array<string>, filters: any, interval: RapidqlScheduleIntervalEnum, enabled: boolean, day: RapidqlScheduleDayEnum, dayModifier: RapidqlScheduleDayModifierEnum, dontSendIfNoResults: boolean, hourOfDay: number, timeZone: string, can: { __typename?: 'RapidqlSchedulePermission', update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreateSavedQueryMutationVariables = Exact<{
  input: CreateSavedQueryInput;
}>;


export type CreateSavedQueryMutationResult = { __typename?: 'Mutation', createSavedQuery?: { __typename?: 'CreateSavedQueryPayload', savedQuery?: { __typename?: 'SavedQuery', id: number, gid: string, name: string, description?: string | null, audience: AudienceEnum, query: string, system: boolean, pagination?: boolean | null, updatedAt: Date, rapidqlSchedules: Array<{ __typename?: 'RapidqlSchedule', id: number, gid: string, emailTo: Array<string>, emailCc: Array<string>, emailBcc: Array<string>, filters: any, interval: RapidqlScheduleIntervalEnum, enabled: boolean, day: RapidqlScheduleDayEnum, dayModifier: RapidqlScheduleDayModifierEnum, dontSendIfNoResults: boolean, hourOfDay: number, timeZone: string, can: { __typename?: 'RapidqlSchedulePermission', update: boolean, destroy: boolean } }>, can: { __typename?: 'SavedQueryPermissions', id: number, gid: string, update: boolean, destroy: boolean }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, filters: Array<{ __typename?: 'SavedQueryFilter', label: string, key: string, type: SavedQueryFilterTypeEnum, required: boolean, multiple: boolean, local: boolean, query?: string | null, savedQueryId?: string | null }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type FindSavedQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindSavedQueryQueryResult = { __typename?: 'Query', savedQueries?: { __typename?: 'SavedQueriesNamespace', findById: { __typename?: 'SavedQuery', id: number, gid: string, name: string, description?: string | null, audience: AudienceEnum, query: string, system: boolean, pagination?: boolean | null, updatedAt: Date, rapidqlSchedules: Array<{ __typename?: 'RapidqlSchedule', id: number, gid: string, emailTo: Array<string>, emailCc: Array<string>, emailBcc: Array<string>, filters: any, interval: RapidqlScheduleIntervalEnum, enabled: boolean, day: RapidqlScheduleDayEnum, dayModifier: RapidqlScheduleDayModifierEnum, dontSendIfNoResults: boolean, hourOfDay: number, timeZone: string, can: { __typename?: 'RapidqlSchedulePermission', update: boolean, destroy: boolean } }>, can: { __typename?: 'SavedQueryPermissions', id: number, gid: string, update: boolean, destroy: boolean }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, filters: Array<{ __typename?: 'SavedQueryFilter', label: string, key: string, type: SavedQueryFilterTypeEnum, required: boolean, multiple: boolean, local: boolean, query?: string | null, savedQueryId?: string | null }> } } | null };

export type InitializeOrRefreshRapidQlMutationVariables = Exact<{ [key: string]: never; }>;


export type InitializeOrRefreshRapidQlMutationResult = { __typename?: 'Mutation', refreshRapidql?: { __typename?: 'RefreshRapidqlPayload', ok: boolean } | null, initializeRapidql?: { __typename?: 'InitializeRapidqlPayload', ok: boolean } | null };

export type LoadRapidQlViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadRapidQlViewsQueryResult = { __typename?: 'Query', rapidql?: { __typename?: 'RapidqlNamespace', views: Array<{ __typename?: 'View', id: number, gid: string, name: string, createdAt: Date, updatedAt: Date, timeToBuild?: number | null, timeToIndex?: number | null, timeToRefresh?: number | null }> } | null };

export type LoadSavedQueriesQueryVariables = Exact<{
  audience: AudienceEnum;
}>;


export type LoadSavedQueriesQueryResult = { __typename?: 'Query', savedQueries?: { __typename?: 'SavedQueriesNamespace', all: { __typename?: 'SavedQueryConnection', nodes?: Array<{ __typename?: 'SavedQuery', id: number, gid: string, name: string, description?: string | null, audience: AudienceEnum, query: string, system: boolean, pagination?: boolean | null, updatedAt: Date, rapidqlSchedules: Array<{ __typename?: 'RapidqlSchedule', id: number, gid: string, emailTo: Array<string>, emailCc: Array<string>, emailBcc: Array<string>, filters: any, interval: RapidqlScheduleIntervalEnum, enabled: boolean, day: RapidqlScheduleDayEnum, dayModifier: RapidqlScheduleDayModifierEnum, dontSendIfNoResults: boolean, hourOfDay: number, timeZone: string, can: { __typename?: 'RapidqlSchedulePermission', update: boolean, destroy: boolean } }>, can: { __typename?: 'SavedQueryPermissions', id: number, gid: string, update: boolean, destroy: boolean }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, filters: Array<{ __typename?: 'SavedQueryFilter', label: string, key: string, type: SavedQueryFilterTypeEnum, required: boolean, multiple: boolean, local: boolean, query?: string | null, savedQueryId?: string | null }> } | null> | null } } | null };

export type RapidqlSchedulePartsFragment = { __typename?: 'RapidqlSchedule', id: number, gid: string, emailTo: Array<string>, emailCc: Array<string>, emailBcc: Array<string>, filters: any, interval: RapidqlScheduleIntervalEnum, enabled: boolean, day: RapidqlScheduleDayEnum, dayModifier: RapidqlScheduleDayModifierEnum, dontSendIfNoResults: boolean, hourOfDay: number, timeZone: string, can: { __typename?: 'RapidqlSchedulePermission', update: boolean, destroy: boolean } };

export type GetRapidqlDocumentationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRapidqlDocumentationQueryResult = { __typename?: 'Query', rapidql?: { __typename?: 'RapidqlNamespace', documentation: Array<{ __typename?: 'TableDocumentation', name: string, comment: string, updatedAt?: Date | null, columns: Array<{ __typename?: 'ColumnDocumentation', name: string, comment: string }> }> } | null };

export type SavedQueryFilterPartsFragment = { __typename?: 'SavedQueryFilter', label: string, key: string, type: SavedQueryFilterTypeEnum, required: boolean, multiple: boolean, local: boolean, query?: string | null, savedQueryId?: string | null };

export type SavedQueryPartsFragment = { __typename?: 'SavedQuery', id: number, gid: string, name: string, description?: string | null, audience: AudienceEnum, query: string, system: boolean, pagination?: boolean | null, updatedAt: Date, rapidqlSchedules: Array<{ __typename?: 'RapidqlSchedule', id: number, gid: string, emailTo: Array<string>, emailCc: Array<string>, emailBcc: Array<string>, filters: any, interval: RapidqlScheduleIntervalEnum, enabled: boolean, day: RapidqlScheduleDayEnum, dayModifier: RapidqlScheduleDayModifierEnum, dontSendIfNoResults: boolean, hourOfDay: number, timeZone: string, can: { __typename?: 'RapidqlSchedulePermission', update: boolean, destroy: boolean } }>, can: { __typename?: 'SavedQueryPermissions', id: number, gid: string, update: boolean, destroy: boolean }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, filters: Array<{ __typename?: 'SavedQueryFilter', label: string, key: string, type: SavedQueryFilterTypeEnum, required: boolean, multiple: boolean, local: boolean, query?: string | null, savedQueryId?: string | null }> };

export type SendReportNowMutationVariables = Exact<{
  input: SendReportNowInput;
}>;


export type SendReportNowMutationResult = { __typename?: 'Mutation', sendReportNow?: { __typename?: 'SendReportNowPayload', ok: boolean } | null };

export type UpdateRapidqlScheduleMutationVariables = Exact<{
  input: UpdateRapidqlScheduleInput;
}>;


export type UpdateRapidqlScheduleMutationResult = { __typename?: 'Mutation', updateRapidqlSchedule?: { __typename?: 'UpdateRapidqlSchedulePayload', rapidqlSchedule?: { __typename?: 'RapidqlSchedule', id: number, gid: string, emailTo: Array<string>, emailCc: Array<string>, emailBcc: Array<string>, filters: any, interval: RapidqlScheduleIntervalEnum, enabled: boolean, day: RapidqlScheduleDayEnum, dayModifier: RapidqlScheduleDayModifierEnum, dontSendIfNoResults: boolean, hourOfDay: number, timeZone: string, can: { __typename?: 'RapidqlSchedulePermission', update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type UpdateSavedQueryMutationVariables = Exact<{
  input: UpdateSavedQueryInput;
}>;


export type UpdateSavedQueryMutationResult = { __typename?: 'Mutation', updateSavedQuery?: { __typename?: 'UpdateSavedQueryPayload', savedQuery?: { __typename?: 'SavedQuery', id: number, gid: string, name: string, description?: string | null, audience: AudienceEnum, query: string, system: boolean, pagination?: boolean | null, updatedAt: Date, rapidqlSchedules: Array<{ __typename?: 'RapidqlSchedule', id: number, gid: string, emailTo: Array<string>, emailCc: Array<string>, emailBcc: Array<string>, filters: any, interval: RapidqlScheduleIntervalEnum, enabled: boolean, day: RapidqlScheduleDayEnum, dayModifier: RapidqlScheduleDayModifierEnum, dontSendIfNoResults: boolean, hourOfDay: number, timeZone: string, can: { __typename?: 'RapidqlSchedulePermission', update: boolean, destroy: boolean } }>, can: { __typename?: 'SavedQueryPermissions', id: number, gid: string, update: boolean, destroy: boolean }, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, filters: Array<{ __typename?: 'SavedQueryFilter', label: string, key: string, type: SavedQueryFilterTypeEnum, required: boolean, multiple: boolean, local: boolean, query?: string | null, savedQueryId?: string | null }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateRegulatorSubmissionMutationVariables = Exact<{
  input: CreateRegulatorSubmissionInput;
}>;


export type CreateRegulatorSubmissionMutationResult = { __typename?: 'Mutation', createRegulatorSubmission?: { __typename?: 'CreateRegulatorSubmissionPayload', submission: { __typename?: 'RegulatorSubmission', id: number, gid: string, regulatorReferenceId: string, submittedAt: Date, notes?: string | null }, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateRegulatorSubmissionMutationVariables = Exact<{
  input: UpdateRegulatorSubmissionInput;
}>;


export type UpdateRegulatorSubmissionMutationResult = { __typename?: 'Mutation', updateRegulatorSubmission?: { __typename?: 'UpdateRegulatorSubmissionPayload', submission: { __typename?: 'RegulatorSubmission', id: number, gid: string, regulatorReferenceId: string, submittedAt: Date, notes?: string | null }, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type RegulatorSubmissionReportQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  completedAfter?: InputMaybe<Scalars['Date']>;
  completedBefore?: InputMaybe<Scalars['Date']>;
  submittedAfter?: InputMaybe<Scalars['Date']>;
  submittedBefore?: InputMaybe<Scalars['Date']>;
  includeSubmitted?: InputMaybe<Scalars['Boolean']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  regulatorReferenceId?: InputMaybe<Scalars['String']>;
  courses?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  learnerQuery?: InputMaybe<Scalars['String']>;
}>;


export type RegulatorSubmissionReportQueryResult = { __typename?: 'Query', reports?: { __typename?: 'ReportsNamespace', regulatorSubmissionReport?: { __typename?: 'RegulatorSubmissionCompletionConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes?: Array<{ __typename?: 'RegulatorSubmissionCompletion', id: number, gid: string, completedAt: Date, licenseNumber?: string | null, course: { __typename?: 'Course', id: number, name: string }, user: { __typename?: 'User', id: number, fullName: string }, regulatorSubmission?: { __typename?: 'RegulatorSubmission', id: number, gid: string, regulatorReferenceId: string, submittedAt: Date, notes?: string | null } | null } | null> | null } | null } | null };

export type SalesReportQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  courses?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  storefronts?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  organizations?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SalesReportQueryResult = { __typename?: 'Query', reports?: { __typename?: 'ReportsNamespace', salesReport?: { __typename?: 'LITSalesReportOrderItemConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes?: Array<{ __typename?: 'LITSalesReportOrderItem', orderId: number, refundId?: number | null, orderItemId?: number | null, orderStripeChargeId?: string | null, createdAt: Date, storefrontName: string, lineItem: string, sku: string, unitPrice: number, prePromoUnitPrice?: number | null, quantity: number, subtotal: number, total: number, gst: number, pst: number, otherTax: number, promoCodeSavings?: number | null, consumerFullName: string, consumerEmail?: string | null, consumerPhoneNumber?: string | null, currency: { __typename?: 'Currency', isoCode: string, name: string }, organization: { __typename?: 'Owner', id: number, gid: string, name: string }, course?: { __typename?: 'Course', owner: { __typename?: 'Owner', id: number, gid: string, name: string } } | null, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, code: string } | null, billingAddress: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, province?: { __typename?: 'Location', name: string, code: string } | null, country: { __typename?: 'Country', name: string, code: string } }, shippingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, province?: { __typename?: 'Location', name: string } | null, country: { __typename?: 'Country', name: string } } | null, consumerCustomValues: Array<{ __typename?: 'CustomValue', id: number, gid: string, value?: string | null, customFieldId: number }> } | null> | null } | null } | null };

export type LoadSellingDashboardQueryVariables = Exact<{
  storefrontId: Scalars['ID'];
}>;


export type LoadSellingDashboardQueryResult = { __typename?: 'Query', dashboard?: { __typename?: 'DashboardNamespace', selling: { __typename?: 'SellingDashboard', todayAmount: number, yesterdayAmount: number, thisWeekAmount: number, newLearners: number, newTrainingManagers: number, totalTrainingManagers: number, knowledgeBaseUrl?: string | null, submitBugUrl?: string | null, faqs?: Array<{ __typename?: 'DashboardFaq', title: string, url: string }> | null }, reports: { __typename?: 'ReportDashboard', todayRevenueReportId?: number | null, yesterdayRevenueReportId?: number | null, thisWeekRevenueReportId?: number | null, newLearnersReportId?: number | null, newTrainingManagersReportId?: number | null, totalTrainingManagersReportId?: number | null, activeLearnersReportId?: number | null, learnerTrainingReportId?: number | null } } | null };

export type CreateSharedProductMutationVariables = Exact<{
  input: CreateSharedProductInput;
}>;


export type CreateSharedProductMutationResult = { __typename?: 'Mutation', createSharedProduct?: { __typename?: 'CreateSharedProductPayload', sharedProduct?: { __typename?: 'SharedProduct', id: number, gid: string, name: string, shortDescription?: string | null, summary?: string | null, description?: string | null, categories: Array<string>, sku?: string | null, bulkDiscounts: boolean, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, can: { __typename?: 'SharedProductPermissions', id: number, gid: string, update: boolean, destroy: boolean }, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, owner?: { __typename?: 'Owner', id: number, gid: string, kind: string, name: string } | null, prices: Array<{ __typename?: 'Price', id: number, gid: string, currency: string, value: number }>, storefronts: Array<{ __typename?: 'Storefront', id: number, gid: string, name: string }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LoadSharedProductsListQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadSharedProductsListQueryResult = { __typename?: 'Query', sharedProducts?: { __typename?: 'SharedProductsNamespace', all: { __typename?: 'SharedProductConnection', nodes?: Array<{ __typename?: 'SharedProduct', id: number, gid: string, name: string, shortDescription?: string | null, summary?: string | null, description?: string | null, categories: Array<string>, sku?: string | null, bulkDiscounts: boolean, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, can: { __typename?: 'SharedProductPermissions', id: number, gid: string, update: boolean, destroy: boolean }, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, owner?: { __typename?: 'Owner', id: number, gid: string, kind: string, name: string } | null, prices: Array<{ __typename?: 'Price', id: number, gid: string, currency: string, value: number }>, storefronts: Array<{ __typename?: 'Storefront', id: number, gid: string, name: string }> } | null> | null } } | null };

export type SharedProductPartsFragment = { __typename?: 'SharedProduct', id: number, gid: string, name: string, shortDescription?: string | null, summary?: string | null, description?: string | null, categories: Array<string>, sku?: string | null, bulkDiscounts: boolean, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, can: { __typename?: 'SharedProductPermissions', id: number, gid: string, update: boolean, destroy: boolean }, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, owner?: { __typename?: 'Owner', id: number, gid: string, kind: string, name: string } | null, prices: Array<{ __typename?: 'Price', id: number, gid: string, currency: string, value: number }>, storefronts: Array<{ __typename?: 'Storefront', id: number, gid: string, name: string }> };

export type UpdateSharedProductMutationVariables = Exact<{
  input: UpdateSharedProductInput;
}>;


export type UpdateSharedProductMutationResult = { __typename?: 'Mutation', updateSharedProduct?: { __typename?: 'UpdateSharedProductPayload', sharedProduct?: { __typename?: 'SharedProduct', id: number, gid: string, name: string, shortDescription?: string | null, summary?: string | null, description?: string | null, categories: Array<string>, sku?: string | null, bulkDiscounts: boolean, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, can: { __typename?: 'SharedProductPermissions', id: number, gid: string, update: boolean, destroy: boolean }, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, owner?: { __typename?: 'Owner', id: number, gid: string, kind: string, name: string } | null, prices: Array<{ __typename?: 'Price', id: number, gid: string, currency: string, value: number }>, storefronts: Array<{ __typename?: 'Storefront', id: number, gid: string, name: string }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type ClaimPromoCodeMutationVariables = Exact<{
  input: ClaimPromoCodeInput;
}>;


export type ClaimPromoCodeMutationResult = { __typename?: 'Mutation', claimPromoCode?: { __typename?: 'ClaimPromoCodePayload', shoppingCart?: { __typename?: 'ShoppingCart', expectedTotal: number, expectedTotalCents: number, expectedShipping: number, expectedTax: number, expectedSubtotal: number, requiresShipping: boolean, userId: number, cartItems: Array<{ __typename?: 'CartItem', id: number, gid: string, bulkDiscountApplied: boolean, quantity: number, total: number, fullPrice: number, splitPromo: boolean, price: number, totalTaxed: number, promoPriceQuantity?: number | null, quantityRemainder?: number | null, product: { __typename?: 'Product', isInstructorLed: boolean, id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }, promoCodeClaim?: { __typename?: 'PromoCodeClaim', id: number, gid: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, description: string, code: string } | null, pendingIlBookingReservations: Array<{ __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } }> }>, taxes: Array<{ __typename?: 'TaxItemBase', amount: number, rate: number, description: string }>, billingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, shippingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string, stripePublishableKey: string, currency: { __typename?: 'Currency', isoCode: string, name: string } }, shippingInformation?: { __typename?: 'ShoppingCartShippingInformation', name: string, email: string, phoneNumber?: string | null, companyName?: string | null } | null } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutationResult = { __typename?: 'Mutation', createOrder?: { __typename?: 'CreateOrderPayload', shoppingCart: { __typename?: 'ShoppingCart', expectedTotal: number, expectedTotalCents: number, expectedShipping: number, expectedTax: number, expectedSubtotal: number, requiresShipping: boolean, userId: number, cartItems: Array<{ __typename?: 'CartItem', id: number, gid: string, bulkDiscountApplied: boolean, quantity: number, total: number, fullPrice: number, splitPromo: boolean, price: number, totalTaxed: number, promoPriceQuantity?: number | null, quantityRemainder?: number | null, product: { __typename?: 'Product', isInstructorLed: boolean, id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }, promoCodeClaim?: { __typename?: 'PromoCodeClaim', id: number, gid: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, description: string, code: string } | null, pendingIlBookingReservations: Array<{ __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } }> }>, taxes: Array<{ __typename?: 'TaxItemBase', amount: number, rate: number, description: string }>, billingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, shippingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string, stripePublishableKey: string, currency: { __typename?: 'Currency', isoCode: string, name: string } }, shippingInformation?: { __typename?: 'ShoppingCartShippingInformation', name: string, email: string, phoneNumber?: string | null, companyName?: string | null } | null }, gatewayInfo?: { __typename?: 'GatewayInfo', clientSecret?: string | null, status?: string | null } | null, order?: { __typename?: 'Order', id: number, gid: string, channelData?: { __typename?: 'ChannelData', channel: string, token: string, clientId: string } | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type LoadShoppingCartQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadShoppingCartQueryResult = { __typename?: 'Query', shoppingCart?: { __typename?: 'ShoppingCart', expectedTotal: number, expectedTotalCents: number, expectedShipping: number, expectedTax: number, expectedSubtotal: number, requiresShipping: boolean, userId: number, cartItems: Array<{ __typename?: 'CartItem', id: number, gid: string, bulkDiscountApplied: boolean, quantity: number, total: number, fullPrice: number, splitPromo: boolean, price: number, totalTaxed: number, promoPriceQuantity?: number | null, quantityRemainder?: number | null, product: { __typename?: 'Product', isInstructorLed: boolean, id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }, promoCodeClaim?: { __typename?: 'PromoCodeClaim', id: number, gid: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, description: string, code: string } | null, pendingIlBookingReservations: Array<{ __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } }> }>, taxes: Array<{ __typename?: 'TaxItemBase', amount: number, rate: number, description: string }>, billingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, shippingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string, stripePublishableKey: string, currency: { __typename?: 'Currency', isoCode: string, name: string } }, shippingInformation?: { __typename?: 'ShoppingCartShippingInformation', name: string, email: string, phoneNumber?: string | null, companyName?: string | null } | null } | null };

export type UpdateAddressMutationVariables = Exact<{
  input: UpdateShoppingCartAddressInput;
}>;


export type UpdateAddressMutationResult = { __typename?: 'Mutation', updateShoppingCartAddress?: { __typename?: 'UpdateShoppingCartAddressPayload', shoppingCart?: { __typename?: 'ShoppingCart', expectedTotal: number, expectedTotalCents: number, expectedShipping: number, expectedTax: number, expectedSubtotal: number, requiresShipping: boolean, userId: number, cartItems: Array<{ __typename?: 'CartItem', id: number, gid: string, bulkDiscountApplied: boolean, quantity: number, total: number, fullPrice: number, splitPromo: boolean, price: number, totalTaxed: number, promoPriceQuantity?: number | null, quantityRemainder?: number | null, product: { __typename?: 'Product', isInstructorLed: boolean, id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }, promoCodeClaim?: { __typename?: 'PromoCodeClaim', id: number, gid: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, description: string, code: string } | null, pendingIlBookingReservations: Array<{ __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } }> }>, taxes: Array<{ __typename?: 'TaxItemBase', amount: number, rate: number, description: string }>, billingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, shippingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string, stripePublishableKey: string, currency: { __typename?: 'Currency', isoCode: string, name: string } }, shippingInformation?: { __typename?: 'ShoppingCartShippingInformation', name: string, email: string, phoneNumber?: string | null, companyName?: string | null } | null } | null, errors: Array<{ __typename?: 'ValidationError', message: string, attribute?: string | null }> } | null };

export type UpdateShippingInformationMutationVariables = Exact<{
  input: UpdateShoppingCartShippingInformationInput;
}>;


export type UpdateShippingInformationMutationResult = { __typename?: 'Mutation', updateShoppingCartShippingInformation?: { __typename?: 'UpdateShoppingCartShippingInformationPayload', shoppingCart?: { __typename?: 'ShoppingCart', expectedTotal: number, expectedTotalCents: number, expectedShipping: number, expectedTax: number, expectedSubtotal: number, requiresShipping: boolean, userId: number, cartItems: Array<{ __typename?: 'CartItem', id: number, gid: string, bulkDiscountApplied: boolean, quantity: number, total: number, fullPrice: number, splitPromo: boolean, price: number, totalTaxed: number, promoPriceQuantity?: number | null, quantityRemainder?: number | null, product: { __typename?: 'Product', isInstructorLed: boolean, id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } }, promoCodeClaim?: { __typename?: 'PromoCodeClaim', id: number, gid: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, gid: string, description: string, code: string } | null, pendingIlBookingReservations: Array<{ __typename?: 'PendingILBookingReservation', id: number, gid: string, startsAt: Date, timeZone: string, courseItem: { __typename?: 'CourseItem', id: number, gid: string }, ilClass: { __typename?: 'ILClass', id: number, gid: string } }> }>, taxes: Array<{ __typename?: 'TaxItemBase', amount: number, rate: number, description: string }>, billingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, shippingAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string, stripePublishableKey: string, currency: { __typename?: 'Currency', isoCode: string, name: string } }, shippingInformation?: { __typename?: 'ShoppingCartShippingInformation', name: string, email: string, phoneNumber?: string | null, companyName?: string | null } | null } | null, errors: Array<{ __typename?: 'ValidationError', message: string, attribute?: string | null }> } | null };

export type CreateCustomDomainMutationVariables = Exact<{
  input: CreateCustomDomainInput;
}>;


export type CreateCustomDomainMutationResult = { __typename?: 'Mutation', createCustomDomain?: { __typename?: 'CreateCustomDomainPayload', customDomain?: { __typename?: 'CustomDomain', id: number, gid: string, name: string, primaryAt?: string | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type UpdateCustomDomainMutationVariables = Exact<{
  input: UpdateCustomDomainInput;
}>;


export type UpdateCustomDomainMutationResult = { __typename?: 'Mutation', updateCustomDomain?: { __typename?: 'UpdateCustomDomainPayload', customDomain?: { __typename?: 'CustomDomain', id: number, gid: string, name: string, primaryAt?: string | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreateCustomFieldMutationVariables = Exact<{
  input: CreateCustomFieldInput;
}>;


export type CreateCustomFieldMutationResult = { __typename?: 'Mutation', createCustomField?: { __typename?: 'CreateCustomFieldPayload', customField?: { __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LoadStorefrontCustomFieldsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadStorefrontCustomFieldsQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findById: { __typename?: 'Storefront', id: number, gid: string, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> } } | null };

export type UpdateCustomFieldMutationVariables = Exact<{
  input: UpdateCustomFieldInput;
}>;


export type UpdateCustomFieldMutationResult = { __typename?: 'Mutation', updateCustomField?: { __typename?: 'UpdateCustomFieldPayload', customField?: { __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, showOnSignup: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, gid: string, value: string }> | null, can: { __typename?: 'CustomFieldPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateDownloadableFileMutationVariables = Exact<{
  input: CreateDownloadableFileInput;
}>;


export type CreateDownloadableFileMutationResult = { __typename?: 'Mutation', createDownloadableFile?: { __typename?: 'CreateDownloadableFilePayload', downloadableFile?: { __typename?: 'DownloadableFile', id: number, gid: string, name: string, staticUrl: string, url: string, downloads: number, staticId: string, file: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, can: { __typename?: 'DownloadableFilePermissions', id: number, gid: string, preview: boolean, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type DownloadableFilePartsFragment = { __typename?: 'DownloadableFile', id: number, gid: string, name: string, staticUrl: string, url: string, downloads: number, staticId: string, file: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, can: { __typename?: 'DownloadableFilePermissions', id: number, gid: string, preview: boolean, update: boolean, destroy: boolean } };

export type LoadStorefrontDownloadableFilesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadStorefrontDownloadableFilesQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findById: { __typename?: 'Storefront', id: number, gid: string, downloadableFiles: Array<{ __typename?: 'DownloadableFile', id: number, gid: string, name: string, staticUrl: string, url: string, downloads: number, staticId: string, file: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, can: { __typename?: 'DownloadableFilePermissions', id: number, gid: string, preview: boolean, update: boolean, destroy: boolean } }> } } | null };

export type UpdateDownloadableFileMutationVariables = Exact<{
  input: UpdateDownloadableFileInput;
}>;


export type UpdateDownloadableFileMutationResult = { __typename?: 'Mutation', updateDownloadableFile?: { __typename?: 'UpdateDownloadableFilePayload', downloadableFile?: { __typename?: 'DownloadableFile', id: number, gid: string, name: string, staticUrl: string, url: string, downloads: number, staticId: string, file: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, can: { __typename?: 'DownloadableFilePermissions', id: number, gid: string, preview: boolean, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LoadCurrentStorefrontQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadCurrentStorefrontQueryResult = { __typename?: 'Query', currentStorefront?: { __typename?: 'Storefront', id: number, gid: string, name: string, sector: string, addressOnSignup: boolean, addressRequired: boolean, faviconPath?: string | null, logoUrl?: string | null, url: string, hasSubscriptions: boolean, analyticsOptIn: boolean, currency: { __typename?: 'Currency', isoCode: string, name: string }, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, value: string }> | null }>, can: { __typename?: 'StorefrontPermissions', id: number, gid: string, createOrder: boolean } } | null };

export type LoadStorefrontActiveContractsQueryVariables = Exact<{
  id: Scalars['ID'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
}>;


export type LoadStorefrontActiveContractsQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findByGid?: { __typename?: 'Storefront', id: number, gid: string, name: string, activeContracts: Array<{ __typename?: 'Contract', id: number, gid: string, name: string, startDate: any, endDate?: any | null, calculable: { __typename?: 'DynamicContract', id: number, gid: string, type: string, logic: string } | { __typename?: 'MonthlyActiveUsersRateContract', id: number, gid: string, type: string, tierMin?: number | null, tierMax?: number | null, rate: number, flatRate: number } | { __typename?: 'MonthlyCourseDistributionRateContract', id: number, gid: string, type: string, tierMin?: number | null, tierMax?: number | null, rate: number, flatRate: number } | { __typename?: 'OneTimeFeeContract', id: number, gid: string, type: string, price: number, feeType: OneTimeFeeFeeTypeEnum } | { __typename?: 'RecurringFlatFeeContract', id: number, gid: string, type: string, price: number, period: RecurringFlatFeePeriodEnum } | { __typename?: 'ScormCourseRateContract', id: number, gid: string, type: string, courseTitle: string, destinationName: string, rate: number } | { __typename?: 'StripeTransactionFeeContract', id: number, gid: string, type: string, transactionFee: number } }> } | null } | null };

export type LoadStorefrontDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadStorefrontDetailsQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findById: { __typename?: 'Storefront', id: number, gid: string, name: string, url: string, allowMfaTrustedDevices: boolean, currency: { __typename?: 'Currency', isoCode: string, name: string }, can: { __typename?: 'StorefrontPermissions', createThemes: boolean, createPages: boolean, createRedirects: boolean, createProducts: boolean, createCustomFields: boolean, uploadFiles: boolean, update: boolean }, customDomains: Array<{ __typename?: 'CustomDomain', id: number, gid: string, name: string, primaryAt?: string | null, primary: boolean }> } } | null };

export type LoadStorefrontListQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadStorefrontListQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', all: Array<{ __typename?: 'Storefront', id: number, gid: string, name: string, url: string, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string }>, owner: { __typename?: 'Owner', id: number, gid: string, name: string } }> } | null };

export type LoadStorefrontRedirectablesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadStorefrontRedirectablesQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findById: { __typename?: 'Storefront', id: number, gid: string, pages: Array<{ __typename?: 'Page', id: number, gid: string, name: string, url: string }>, downloadableFiles: Array<{ __typename?: 'DownloadableFile', id: number, gid: string, name: string, url: string }> } } | null };

export type LoadStorefrontRevenueListQueryVariables = Exact<{
  sector: StorefrontSectorsEnum;
  currency: Scalars['String'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  showAll?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type LoadStorefrontRevenueListQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', all: Array<{ __typename?: 'Storefront', id: number, gid: string, name: string, sector: string, ledgerReviewed?: boolean | null, ledgerNotes?: string | null, currency: { __typename?: 'Currency', isoCode: string, name: string }, revenues?: { __typename?: 'StorefrontRevenues', startPeriod: any, endPeriod: any, onlineTraining: { __typename?: 'StorefrontOnlineTrainingRevenue', amount: number }, ilTraining: { __typename?: 'StorefrontILTrainingRevenue', amount: number }, physicalProduct: { __typename?: 'StorefrontPhysicalProductRevenue', amount: number }, promoCodeSaving: { __typename?: 'StorefrontPromoCodeSavingRevenue', amount: number }, shipping: { __typename?: 'StorefrontShippingRevenue', amount: number }, platformSetup: { __typename?: 'StorefrontPlatformSetupRevenue', amount: number }, platformLicenses: { __typename?: 'StorefrontRecurringFlatFeeRevenue', amount: number }, subscription: { __typename?: 'StorefrontSubscriptionRevenue', amount: number }, courseDistribution: { __typename?: 'StorefrontCourseDistributionRevenue', amount: number }, thirdPartyPayout: { __typename?: 'StorefrontThirdPartyPayoutRevenue', amount: number }, refunds: { __typename?: 'StorefrontRefundRevenue', amount: number }, federalTaxes: { __typename?: 'StorefrontFederalTaxRevenue', amount: number }, provincialTaxes: { __typename?: 'StorefrontProvincialTaxRevenue', amount: number } } | null }> } | null };

export type LoadStorefrontRevenueRecordsQueryVariables = Exact<{
  id: Scalars['ID'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  onlineTraining?: InputMaybe<Scalars['Boolean']>;
  ilTraining?: InputMaybe<Scalars['Boolean']>;
  physicalProduct?: InputMaybe<Scalars['Boolean']>;
  promoCodeSaving?: InputMaybe<Scalars['Boolean']>;
  shipping?: InputMaybe<Scalars['Boolean']>;
  platformSetup?: InputMaybe<Scalars['Boolean']>;
  platformLicenses?: InputMaybe<Scalars['Boolean']>;
  transactionFees?: InputMaybe<Scalars['Boolean']>;
  subscription?: InputMaybe<Scalars['Boolean']>;
  thirdPartyPayout?: InputMaybe<Scalars['Boolean']>;
  refunds?: InputMaybe<Scalars['Boolean']>;
  courseDistribution?: InputMaybe<Scalars['Boolean']>;
  federalTaxes?: InputMaybe<Scalars['Boolean']>;
  provincialTaxes?: InputMaybe<Scalars['Boolean']>;
}>;


export type LoadStorefrontRevenueRecordsQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findByGid?: { __typename?: 'Storefront', id: number, gid: string, name: string, revenues?: { __typename?: 'StorefrontRevenues', startPeriod: any, endPeriod: any, onlineTraining?: { __typename?: 'StorefrontOnlineTrainingRevenue', records: { __typename?: 'LedgerOrderItemRecordConnection', nodes?: Array<{ __typename?: 'LedgerOrderItemRecord', id: string, gid: string, orderId: number, orderItemId?: number | null, refundId?: number | null, refundItemId?: number | null, itemId: number, itemType: string, createdAt: Date, requiresShipping: boolean, lvEnabled: boolean, currency: string, price: number, quantity: number, promoCodeId?: number | null, promoCodeCode?: string | null, promoCodeSavings: number, orderSubtotal: number, productId?: number | null, productSku?: string | null, productName: string, courseOwnerType?: string | null, courseOwnerName?: string | null, authorAmount?: number | null, sellerAmount?: number | null, platformAmount?: number | null } | null> | null } }, ilTraining?: { __typename?: 'StorefrontILTrainingRevenue', records: { __typename?: 'LedgerOrderItemRecordConnection', nodes?: Array<{ __typename?: 'LedgerOrderItemRecord', id: string, gid: string, orderId: number, orderItemId?: number | null, refundId?: number | null, refundItemId?: number | null, itemId: number, itemType: string, createdAt: Date, requiresShipping: boolean, lvEnabled: boolean, currency: string, price: number, quantity: number, promoCodeId?: number | null, promoCodeCode?: string | null, promoCodeSavings: number, orderSubtotal: number, productId?: number | null, productSku?: string | null, productName: string, courseOwnerType?: string | null, courseOwnerName?: string | null, authorAmount?: number | null, sellerAmount?: number | null, platformAmount?: number | null } | null> | null } }, physicalProduct?: { __typename?: 'StorefrontPhysicalProductRevenue', records: { __typename?: 'LedgerOrderItemRecordConnection', nodes?: Array<{ __typename?: 'LedgerOrderItemRecord', id: string, gid: string, orderId: number, orderItemId?: number | null, refundId?: number | null, refundItemId?: number | null, itemId: number, itemType: string, createdAt: Date, requiresShipping: boolean, lvEnabled: boolean, currency: string, price: number, quantity: number, promoCodeId?: number | null, promoCodeCode?: string | null, promoCodeSavings: number, orderSubtotal: number, productId?: number | null, productSku?: string | null, productName: string, courseOwnerType?: string | null, courseOwnerName?: string | null, authorAmount?: number | null, sellerAmount?: number | null, platformAmount?: number | null } | null> | null } }, promoCodeSaving?: { __typename?: 'StorefrontPromoCodeSavingRevenue', amount: number, records: { __typename?: 'LedgerOrderItemRecordConnection', nodes?: Array<{ __typename?: 'LedgerOrderItemRecord', id: string, gid: string, orderId: number, orderItemId?: number | null, refundId?: number | null, refundItemId?: number | null, itemId: number, itemType: string, createdAt: Date, requiresShipping: boolean, lvEnabled: boolean, currency: string, price: number, quantity: number, promoCodeId?: number | null, promoCodeCode?: string | null, promoCodeSavings: number, orderSubtotal: number, productId?: number | null, productSku?: string | null, productName: string, courseOwnerType?: string | null, courseOwnerName?: string | null, authorAmount?: number | null, sellerAmount?: number | null, platformAmount?: number | null } | null> | null } }, shipping?: { __typename?: 'StorefrontShippingRevenue', amount: number, records: { __typename?: 'LedgerOrderItemRecordConnection', nodes?: Array<{ __typename?: 'LedgerOrderItemRecord', id: string, gid: string, orderId: number, orderItemId?: number | null, refundId?: number | null, refundItemId?: number | null, itemId: number, itemType: string, createdAt: Date, requiresShipping: boolean, lvEnabled: boolean, currency: string, price: number, quantity: number, promoCodeId?: number | null, promoCodeCode?: string | null, promoCodeSavings: number, orderSubtotal: number, productId?: number | null, productSku?: string | null, productName: string, courseOwnerType?: string | null, courseOwnerName?: string | null, authorAmount?: number | null, sellerAmount?: number | null, platformAmount?: number | null } | null> | null } }, platformSetup?: { __typename?: 'StorefrontPlatformSetupRevenue', records: { __typename?: 'ContractRevenueConnection', nodes?: Array<{ __typename?: 'ContractRevenue', id: number, gid: string, calculatedDay: any, reportedDay: any, quantity: number, revenue: number, contract: { __typename?: 'Contract', id: number, gid: string, name: string, notes?: string | null, startDate: any, endDate?: any | null, active: boolean, customerType: ContractCustomerTypeEnum, currency: string } } | null> | null } }, platformLicenses?: { __typename?: 'StorefrontRecurringFlatFeeRevenue', records: { __typename?: 'ContractRevenueConnection', nodes?: Array<{ __typename?: 'ContractRevenue', id: number, gid: string, calculatedDay: any, reportedDay: any, quantity: number, revenue: number, contract: { __typename?: 'Contract', id: number, gid: string, name: string, notes?: string | null, startDate: any, endDate?: any | null, active: boolean, customerType: ContractCustomerTypeEnum, currency: string } } | null> | null } }, transactionFees?: { __typename?: 'StorefrontTransactionFeesRevenue', records: { __typename?: 'ContractRevenueConnection', nodes?: Array<{ __typename?: 'ContractRevenue', id: number, gid: string, calculatedDay: any, reportedDay: any, quantity: number, revenue: number, contract: { __typename?: 'Contract', id: number, gid: string, name: string, notes?: string | null, startDate: any, endDate?: any | null, active: boolean, customerType: ContractCustomerTypeEnum, currency: string } } | null> | null } }, subscription?: { __typename?: 'StorefrontSubscriptionRevenue', records: { __typename?: 'StripeInvoicePaymentConnection', nodes?: Array<{ __typename?: 'StripeInvoicePayment', id: number, gid: string, amountPaid: number, stripeSubscription: { __typename?: 'StripeSubscription', id: number, gid: string, stripeCustomer: { __typename?: 'StripeCustomer', id: number, gid: string, owner: { __typename?: 'User', id: number, gid: string, firstName: string, lastName: string } }, stripePlan: { __typename?: 'StripePlan', id: number, gid: string, name: string, stripeProduct: { __typename?: 'StripeProduct', id: number, gid: string, name: string } } } } | null> | null } }, courseDistribution?: { __typename?: 'StorefrontCourseDistributionRevenue', records: { __typename?: 'ContractRevenueConnection', nodes?: Array<{ __typename?: 'ContractRevenue', id: number, gid: string, calculatedDay: any, reportedDay: any, quantity: number, revenue: number, contract: { __typename?: 'Contract', id: number, gid: string, name: string, notes?: string | null, startDate: any, endDate?: any | null, active: boolean, customerType: ContractCustomerTypeEnum, currency: string } } | null> | null } }, thirdPartyPayout?: { __typename?: 'StorefrontThirdPartyPayoutRevenue', records: { __typename?: 'PayoutConnection', nodes?: Array<{ __typename?: 'Payout', id: number, gid: string, amount: number, revenuePart: PayoutRevenuePartEnum, createdAt: Date, organization?: { __typename?: 'Organization', id: number, gid: string, name: string } | null, refundable?: { __typename?: 'RefundItem', id: number, gid: string } | { __typename?: 'StripeRefund', id: number, gid: string, stripeChargeId: string, stripeRefundId: string, amount: number, refundable: { __typename?: 'Order', id: number, gid: string, createdAt: Date, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string } } | { __typename?: 'StripeSubscription', id: number, gid: string, stripeSubscriptionId: string, createdAt: Date } } | null, orderItem?: { __typename?: 'OrderItem', id: number, gid: string, total: number, order: { __typename?: 'Order', id: number, gid: string, createdAt: Date, storefront: { __typename?: 'Storefront', id: number, gid: string, name: string } }, product: { __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null } } | null, contract: { __typename?: 'Contract', id: number, gid: string, name: string } } | null> | null } }, refunds?: { __typename?: 'StorefrontRefundRevenue', records: { __typename?: 'LedgerRefundRecordConnection', nodes?: Array<{ __typename?: 'LedgerRefundRecord', id: string, gid: string, itemId: number, itemType: string, createdAt: Date, amount: number, quantity: number, tax: number, totalRefundedAmount: number, reason: string, stripeRefundToken?: string | null, requiresShipping: boolean, lvEnabled: boolean, purchasedQuantity?: number | null, orderId: number, currency: string, stripeChargeId?: string | null, productId?: number | null, courseId?: number | null, productSku?: string | null, productName?: string | null, authorAmount: number, sellerAmount: number, platformAmount: number } | null> | null } }, federalTaxes?: { __typename?: 'StorefrontFederalTaxRevenue', records: { __typename?: 'LedgerTaxRecordConnection', nodes?: Array<{ __typename?: 'LedgerTaxRecord', id: string, gid: string, itemId: number, itemType: string, orderId: number, kind: string, rate: number, amount: number, taxableType: string, taxableId: number, description: string, createdAt: Date } | null> | null } }, provincialTaxes?: { __typename?: 'StorefrontProvincialTaxRevenue', records: { __typename?: 'LedgerTaxRecordConnection', nodes?: Array<{ __typename?: 'LedgerTaxRecord', id: string, gid: string, itemId: number, itemType: string, orderId: number, kind: string, rate: number, amount: number, taxableType: string, taxableId: number, description: string, createdAt: Date } | null> | null } } } | null } | null } | null };

export type LoadStorefrontRevenueTotalsQueryVariables = Exact<{
  id: Scalars['ID'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
}>;


export type LoadStorefrontRevenueTotalsQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findByGid?: { __typename?: 'Storefront', id: number, gid: string, name: string, sector: string, logoUrl?: string | null, url: string, ledgerReviewed?: boolean | null, ledgerNotes?: string | null, currency: { __typename?: 'Currency', isoCode: string, name: string }, revenues?: { __typename?: 'StorefrontRevenues', startPeriod: any, endPeriod: any, onlineTraining: { __typename?: 'StorefrontOnlineTrainingRevenue', amount: number }, ilTraining: { __typename?: 'StorefrontILTrainingRevenue', amount: number }, physicalProduct: { __typename?: 'StorefrontPhysicalProductRevenue', amount: number }, promoCodeSaving: { __typename?: 'StorefrontPromoCodeSavingRevenue', amount: number }, shipping: { __typename?: 'StorefrontShippingRevenue', amount: number }, platformSetup: { __typename?: 'StorefrontPlatformSetupRevenue', amount: number }, platformLicenses: { __typename?: 'StorefrontRecurringFlatFeeRevenue', amount: number }, transactionFees: { __typename?: 'StorefrontTransactionFeesRevenue', amount: number }, subscription: { __typename?: 'StorefrontSubscriptionRevenue', amount: number }, courseDistribution: { __typename?: 'StorefrontCourseDistributionRevenue', amount: number }, thirdPartyPayout: { __typename?: 'StorefrontThirdPartyPayoutRevenue', amount: number }, refunds: { __typename?: 'StorefrontRefundRevenue', amount: number }, federalTaxes: { __typename?: 'StorefrontFederalTaxRevenue', amount: number }, provincialTaxes: { __typename?: 'StorefrontProvincialTaxRevenue', amount: number } } | null } | null } | null };

export type LoadStorefrontSettingsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadStorefrontSettingsQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findById: { __typename?: 'Storefront', id: number, gid: string, name: string, domain: string, subdomain: string, locale: string, productPageVersion: ProductPageVersionTypeEnum, pageHeaderVersion: PageHeaderVersionTypeEnum, description?: string | null, contactMethodOnSignup?: ContactMethodOnSignUpTypeEnum | null, addressOnSignup: boolean, addressRequired: boolean, businessNumber?: string | null, googleAnalyticsTrackingId?: string | null, googleSiteVerificationId?: string | null, googleTagManagerId?: string | null, googleAdsenseId?: string | null, email?: string | null, phoneNumber?: string | null, facebook?: string | null, twitter?: string | null, youtube?: string | null, allowMfaTrustedDevices: boolean, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, orderNotificationSubscribers: Array<{ __typename?: 'User', id: number, gid: string, name: string, email?: string | null }>, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null }, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, favicon?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, emailLogo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null } } | null };

export type LoadStorefrontTagFieldsQueryVariables = Exact<{
  scope?: InputMaybe<TagFieldScopeEnum>;
}>;


export type LoadStorefrontTagFieldsQueryResult = { __typename?: 'Query', currentStorefront?: { __typename?: 'Storefront', id: number, gid: string, name: string, tagFields: Array<{ __typename?: 'TagField', id: number, gid: string, name: string, required: boolean, scope: TagFieldScopeEnum }> } | null };

export type CreateMenuItemMutationVariables = Exact<{
  input: CreateMenuItemInput;
}>;


export type CreateMenuItemMutationResult = { __typename?: 'Mutation', createMenuItem?: { __typename?: 'CreateMenuItemPayload', menuItem?: { __typename?: 'MenuItem', id: number, gid: string, position: number, title?: string | null, url?: string | null, page?: { __typename?: 'Page', id: number, gid: string, name: string, url: string } | null, parent?: { __typename?: 'MenuItem', id: number, gid: string } | null, featureImageRight?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, featureImageLeft?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, can: { __typename?: 'MenuItemPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LoadStorefrontMenuItemsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadStorefrontMenuItemsQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findById: { __typename?: 'Storefront', id: number, gid: string, menuItems: Array<{ __typename?: 'MenuItem', id: number, gid: string, position: number, title?: string | null, url?: string | null, page?: { __typename?: 'Page', id: number, gid: string, name: string, url: string } | null, parent?: { __typename?: 'MenuItem', id: number, gid: string } | null, featureImageRight?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, featureImageLeft?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, can: { __typename?: 'MenuItemPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> } } | null };

export type ShortPagePartsFragment = { __typename?: 'Page', id: number, gid: string, name: string, url: string };

export type MenuItemPartsFragment = { __typename?: 'MenuItem', id: number, gid: string, position: number, title?: string | null, url?: string | null, page?: { __typename?: 'Page', id: number, gid: string, name: string, url: string } | null, parent?: { __typename?: 'MenuItem', id: number, gid: string } | null, featureImageRight?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, featureImageLeft?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, can: { __typename?: 'MenuItemPermissions', id: number, gid: string, update: boolean, destroy: boolean } };

export type UpdateMenuItemMutationVariables = Exact<{
  input: UpdateMenuItemInput;
}>;


export type UpdateMenuItemMutationResult = { __typename?: 'Mutation', updateMenuItem?: { __typename?: 'UpdateMenuItemPayload', menuItem?: { __typename?: 'MenuItem', id: number, gid: string, position: number, title?: string | null, url?: string | null, page?: { __typename?: 'Page', id: number, gid: string, name: string, url: string } | null, parent?: { __typename?: 'MenuItem', id: number, gid: string } | null, featureImageRight?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, featureImageLeft?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, can: { __typename?: 'MenuItemPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreatePageMutationVariables = Exact<{
  input: CreatePageInput;
}>;


export type CreatePageMutationResult = { __typename?: 'Mutation', createPage?: { __typename?: 'CreatePagePayload', page?: { __typename?: 'Page', id: number, gid: string, name: string, slug: string, published: boolean, root: boolean, description?: string | null, password?: string | null, requireLoggedInUser: boolean, cssClass?: string | null, url: string, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, featureImage?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, can: { __typename?: 'PagePermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LoadStorefrontPagesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadStorefrontPagesQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findById: { __typename?: 'Storefront', id: number, gid: string, pages: Array<{ __typename?: 'Page', id: number, gid: string, name: string, slug: string, published: boolean, root: boolean, description?: string | null, password?: string | null, requireLoggedInUser: boolean, cssClass?: string | null, url: string, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, featureImage?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, can: { __typename?: 'PagePermissions', id: number, gid: string, update: boolean, destroy: boolean } }> } } | null };

export type PagePartsFragment = { __typename?: 'Page', id: number, gid: string, name: string, slug: string, published: boolean, root: boolean, description?: string | null, password?: string | null, requireLoggedInUser: boolean, cssClass?: string | null, url: string, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, featureImage?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, can: { __typename?: 'PagePermissions', id: number, gid: string, update: boolean, destroy: boolean } };

export type UpdatePageMutationVariables = Exact<{
  input: UpdatePageInput;
}>;


export type UpdatePageMutationResult = { __typename?: 'Mutation', updatePage?: { __typename?: 'UpdatePagePayload', page?: { __typename?: 'Page', id: number, gid: string, name: string, slug: string, published: boolean, root: boolean, description?: string | null, password?: string | null, requireLoggedInUser: boolean, cssClass?: string | null, url: string, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, featureImage?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, can: { __typename?: 'PagePermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutationResult = { __typename?: 'Mutation', createProduct?: { __typename?: 'CreateProductPayload', product?: { __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateProductMutationResult = { __typename?: 'Mutation', updateProduct?: { __typename?: 'UpdateProductPayload', product?: { __typename?: 'Product', id: number, gid: string, name: string, sku?: string | null, brand?: string | null, type?: string | null, description?: string | null, shortDescription?: string | null, summary?: string | null, price: number, categories: Array<string>, ordersCount: number, hidden: boolean, requiresShipping: boolean, taxesEnabled: boolean, availableForIndividualPurchase: boolean, bulkDiscounts: boolean, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, tags: Array<{ __typename?: 'Tag', key: string, value: string }>, bundledProducts: Array<{ __typename?: 'Product', id: number, gid: string, name: string, bookDuringPurchase: BookDuringPurchaseEnum, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, course?: { __typename?: 'Course', id: number, gid: string, courseItems: Array<{ __typename?: 'CourseItem', id: number, gid: string, name: string, ilCourse?: { __typename?: 'ILCourse', id: number, gid: string } | null }> } | null }>, currency: { __typename?: 'Currency', isoCode: string, name: string }, bulkDiscountOptions?: { __typename?: 'BulkDiscountOptions', hasCustomPricing: boolean, levels: Array<{ __typename?: 'DiscountLevel', percent: number, dollar: number, useDollarDiscount: boolean, min?: number | null, max?: number | null }> } | null, metaTags: Array<{ __typename?: 'MetaTags', name: string, content: string }>, carouselMedia: Array<{ __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }>, can: { __typename?: 'ProductPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreatePromoCodeMutationVariables = Exact<{
  input: CreatePromoCodeInput;
}>;


export type CreatePromoCodeMutationResult = { __typename?: 'Mutation', createPromoCode?: { __typename?: 'CreatePromoCodePayload', promoCode?: { __typename?: 'PromoCode', id: number, gid: string, code: string, startsAt?: Date | null, endsAt?: Date | null, type: PromoCodeTypeEnum, persistent: boolean, quantityLimit?: number | null, maxUses?: number | null, notes?: string | null, discounts: Array<{ __typename?: 'PromoCodeDiscount', id: number, gid: string, type: PromoCodeTypeEnum, value: number, products: Array<{ __typename?: 'Product', id: number, gid: string }> }> } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type LoadPromoCodesListQueryVariables = Exact<{
  storefrontId: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadPromoCodesListQueryResult = { __typename?: 'Query', promoCodes?: { __typename?: 'PromoCodesNamespace', all: { __typename?: 'PromoCodeConnection', nodes?: Array<{ __typename?: 'PromoCode', id: number, gid: string, code: string, startsAt?: Date | null, endsAt?: Date | null, type: PromoCodeTypeEnum, persistent: boolean, quantityLimit?: number | null, maxUses?: number | null, notes?: string | null, discounts: Array<{ __typename?: 'PromoCodeDiscount', id: number, gid: string, type: PromoCodeTypeEnum, value: number, products: Array<{ __typename?: 'Product', id: number, gid: string }> }> } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type PromoCodePartsFragment = { __typename?: 'PromoCode', id: number, gid: string, code: string, startsAt?: Date | null, endsAt?: Date | null, type: PromoCodeTypeEnum, persistent: boolean, quantityLimit?: number | null, maxUses?: number | null, notes?: string | null, discounts: Array<{ __typename?: 'PromoCodeDiscount', id: number, gid: string, type: PromoCodeTypeEnum, value: number, products: Array<{ __typename?: 'Product', id: number, gid: string }> }> };

export type UpdatePromoCodeMutationVariables = Exact<{
  input: UpdatePromoCodeInput;
}>;


export type UpdatePromoCodeMutationResult = { __typename?: 'Mutation', updatePromoCode?: { __typename?: 'UpdatePromoCodePayload', promoCode?: { __typename?: 'PromoCode', id: number, gid: string, code: string, startsAt?: Date | null, endsAt?: Date | null, type: PromoCodeTypeEnum, persistent: boolean, quantityLimit?: number | null, maxUses?: number | null, notes?: string | null, discounts: Array<{ __typename?: 'PromoCodeDiscount', id: number, gid: string, type: PromoCodeTypeEnum, value: number, products: Array<{ __typename?: 'Product', id: number, gid: string }> }> } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreateRedirectMutationVariables = Exact<{
  input: CreateRedirectInput;
}>;


export type CreateRedirectMutationResult = { __typename?: 'Mutation', createRedirect?: { __typename?: 'CreateRedirectPayload', redirect?: { __typename?: 'Redirect', id: number, gid: string, redirectionType: string, redirectionUrl: string, redirectFrom: string, redirectTo: { __typename?: 'DownloadableFile', id: number, gid: string, name: string, staticUrl: string, url: string, downloads: number, staticId: string, file: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, can: { __typename?: 'DownloadableFilePermissions', id: number, gid: string, preview: boolean, update: boolean, destroy: boolean } } | { __typename?: 'Page', id: number, gid: string, name: string, url: string } | { __typename?: 'Product', id: number, gid: string, name: string, url: string } | { __typename?: 'ProductBundle', id: number, gid: string, name: string, url: string } | { __typename?: 'StaticPath', id: number, gid: string, path: string }, can: { __typename?: 'RedirectPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LoadStorefrontRedirectsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadStorefrontRedirectsQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findById: { __typename?: 'Storefront', id: number, gid: string, redirects: Array<{ __typename?: 'Redirect', id: number, gid: string, redirectionType: string, redirectionUrl: string, redirectFrom: string, redirectTo: { __typename?: 'DownloadableFile', id: number, gid: string, name: string, staticUrl: string, url: string, downloads: number, staticId: string, file: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, can: { __typename?: 'DownloadableFilePermissions', id: number, gid: string, preview: boolean, update: boolean, destroy: boolean } } | { __typename?: 'Page', id: number, gid: string, name: string, url: string } | { __typename?: 'Product', id: number, gid: string, name: string, url: string } | { __typename?: 'ProductBundle', id: number, gid: string, name: string, url: string } | { __typename?: 'StaticPath', id: number, gid: string, path: string }, can: { __typename?: 'RedirectPermissions', id: number, gid: string, update: boolean, destroy: boolean } }> } } | null };

export type RedirectPartsFragment = { __typename?: 'Redirect', id: number, gid: string, redirectionType: string, redirectionUrl: string, redirectFrom: string, redirectTo: { __typename?: 'DownloadableFile', id: number, gid: string, name: string, staticUrl: string, url: string, downloads: number, staticId: string, file: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, can: { __typename?: 'DownloadableFilePermissions', id: number, gid: string, preview: boolean, update: boolean, destroy: boolean } } | { __typename?: 'Page', id: number, gid: string, name: string, url: string } | { __typename?: 'Product', id: number, gid: string, name: string, url: string } | { __typename?: 'ProductBundle', id: number, gid: string, name: string, url: string } | { __typename?: 'StaticPath', id: number, gid: string, path: string }, can: { __typename?: 'RedirectPermissions', id: number, gid: string, update: boolean, destroy: boolean } };

export type UpdateRedirectMutationVariables = Exact<{
  input: UpdateRedirectInput;
}>;


export type UpdateRedirectMutationResult = { __typename?: 'Mutation', updateRedirect?: { __typename?: 'UpdateRedirectPayload', redirect?: { __typename?: 'Redirect', id: number, gid: string, redirectionType: string, redirectionUrl: string, redirectFrom: string, redirectTo: { __typename?: 'DownloadableFile', id: number, gid: string, name: string, staticUrl: string, url: string, downloads: number, staticId: string, file: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string }, can: { __typename?: 'DownloadableFilePermissions', id: number, gid: string, preview: boolean, update: boolean, destroy: boolean } } | { __typename?: 'Page', id: number, gid: string, name: string, url: string } | { __typename?: 'Product', id: number, gid: string, name: string, url: string } | { __typename?: 'ProductBundle', id: number, gid: string, name: string, url: string } | { __typename?: 'StaticPath', id: number, gid: string, path: string }, can: { __typename?: 'RedirectPermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type SettingsPartsFragment = { __typename?: 'Storefront', id: number, gid: string, name: string, domain: string, subdomain: string, locale: string, productPageVersion: ProductPageVersionTypeEnum, pageHeaderVersion: PageHeaderVersionTypeEnum, description?: string | null, contactMethodOnSignup?: ContactMethodOnSignUpTypeEnum | null, addressOnSignup: boolean, addressRequired: boolean, businessNumber?: string | null, googleAnalyticsTrackingId?: string | null, googleSiteVerificationId?: string | null, googleTagManagerId?: string | null, googleAdsenseId?: string | null, email?: string | null, phoneNumber?: string | null, facebook?: string | null, twitter?: string | null, youtube?: string | null, allowMfaTrustedDevices: boolean, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, orderNotificationSubscribers: Array<{ __typename?: 'User', id: number, gid: string, name: string, email?: string | null }>, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null }, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, favicon?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, emailLogo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null };

export type CreateThemeMutationVariables = Exact<{
  input: CreateThemeInput;
}>;


export type CreateThemeMutationResult = { __typename?: 'Mutation', createTheme?: { __typename?: 'CreateThemePayload', theme?: { __typename?: 'Theme', id: number, gid: string, name: string, backgroundColor: string, textColor: string, fontName: string, customLess?: string | null, headerLiquid?: string | null, can: { __typename?: 'ThemePermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LoadStorefrontThemesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadStorefrontThemesQueryResult = { __typename?: 'Query', storefronts?: { __typename?: 'StorefrontsNamespace', findById: { __typename?: 'Storefront', id: number, gid: string, themes: Array<{ __typename?: 'Theme', id: number, gid: string, name: string, backgroundColor: string, textColor: string, fontName: string, customLess?: string | null, headerLiquid?: string | null, can: { __typename?: 'ThemePermissions', id: number, gid: string, update: boolean, destroy: boolean } }> } } | null };

export type ThemePartsFragment = { __typename?: 'Theme', id: number, gid: string, name: string, backgroundColor: string, textColor: string, fontName: string, customLess?: string | null, headerLiquid?: string | null, can: { __typename?: 'ThemePermissions', id: number, gid: string, update: boolean, destroy: boolean } };

export type UpdateThemeMutationVariables = Exact<{
  input: UpdateThemeInput;
}>;


export type UpdateThemeMutationResult = { __typename?: 'Mutation', updateTheme?: { __typename?: 'UpdateThemePayload', theme?: { __typename?: 'Theme', id: number, gid: string, name: string, backgroundColor: string, textColor: string, fontName: string, customLess?: string | null, headerLiquid?: string | null, can: { __typename?: 'ThemePermissions', id: number, gid: string, update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type UpdateStorefrontMutationVariables = Exact<{
  input: UpdateStorefrontInput;
}>;


export type UpdateStorefrontMutationResult = { __typename?: 'Mutation', updateStorefront?: { __typename?: 'UpdateStorefrontPayload', storefront?: { __typename?: 'Storefront', id: number, gid: string, name: string, domain: string, subdomain: string, locale: string, productPageVersion: ProductPageVersionTypeEnum, pageHeaderVersion: PageHeaderVersionTypeEnum, description?: string | null, contactMethodOnSignup?: ContactMethodOnSignUpTypeEnum | null, addressOnSignup: boolean, addressRequired: boolean, businessNumber?: string | null, googleAnalyticsTrackingId?: string | null, googleSiteVerificationId?: string | null, googleTagManagerId?: string | null, googleAdsenseId?: string | null, email?: string | null, phoneNumber?: string | null, facebook?: string | null, twitter?: string | null, youtube?: string | null, allowMfaTrustedDevices: boolean, owner: { __typename?: 'Owner', id: number, gid: string, name: string }, orderNotificationSubscribers: Array<{ __typename?: 'User', id: number, gid: string, name: string, email?: string | null }>, address: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null }, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, favicon?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, emailLogo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type LoadStripePlansQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadStripePlansQueryResult = { __typename?: 'Query', stripePlans?: { __typename?: 'StripePlansNamespace', all: { __typename?: 'StripePlanConnection', nodes?: Array<{ __typename?: 'StripePlan', id: number, gid: string, active: boolean, aggregateUsage?: StripePlanAggregateUsageEnum | null, amount?: number | null, amountFormatted?: string | null, confirmation: string, createdAt: Date, interval: StripePlanIntervalEnum, intervalCount: number, name: string, sku: string, stripePlanId: string, tiersMode?: StripePlanTiersModeEnum | null, updatedAt: Date, usageType: StripePlanUsageTypeEnum, createdBy?: { __typename?: 'LightUser', id: number, gid: string, fullName: string } | null, currency: { __typename?: 'Currency', isoCode: string, name: string }, organization: { __typename?: 'Owner', id: number, gid: string, name: string }, stripeProduct: { __typename?: 'StripeProduct', id: number, gid: string, stripeProductId?: string | null }, tiers: Array<{ __typename?: 'StripePlanTier', flatAmount?: number | null, flatAmountFormatted?: string | null, unitAmount?: number | null, unitAmountFormatted?: string | null, upTo?: number | null }> } | null> | null } } | null };

export type LoadStripeProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadStripeProductsQueryResult = { __typename?: 'Query', stripeProducts?: { __typename?: 'StripeProductsNamespace', all: { __typename?: 'StripeProductConnection', nodes?: Array<{ __typename?: 'StripeProduct', id: number, gid: string, active: boolean, createdAt: Date, description: string, name: string, stripeProductId?: string | null, updatedAt: Date, createdBy?: { __typename?: 'LightUser', id: number, gid: string, fullName: string } | null, currency: { __typename?: 'Currency', isoCode: string, name: string }, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string, photo?: { __typename?: 'AttacheFile', url: string } | null }>, stripePlans?: Array<{ __typename?: 'StripePlan', id: number, gid: string, active: boolean, aggregateUsage?: StripePlanAggregateUsageEnum | null, amount?: number | null, amountFormatted?: string | null, confirmation: string, createdAt: Date, interval: StripePlanIntervalEnum, intervalCount: number, name: string, sku: string, stripePlanId: string, tiersMode?: StripePlanTiersModeEnum | null, updatedAt: Date, usageType: StripePlanUsageTypeEnum, createdBy?: { __typename?: 'LightUser', id: number, gid: string, fullName: string } | null, currency: { __typename?: 'Currency', isoCode: string, name: string }, organization: { __typename?: 'Owner', id: number, gid: string, name: string }, stripeProduct: { __typename?: 'StripeProduct', id: number, gid: string, stripeProductId?: string | null }, tiers: Array<{ __typename?: 'StripePlanTier', flatAmount?: number | null, flatAmountFormatted?: string | null, unitAmount?: number | null, unitAmountFormatted?: string | null, upTo?: number | null }> }> | null } | null> | null } } | null };

export type LoadStripeSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadStripeSubscriptionsQueryResult = { __typename?: 'Query', stripeSubscriptions?: { __typename?: 'StripeSubscriptionsNamespace', mine: Array<{ __typename?: 'AccessSubscription', id: number, gid: string, stripeSubscriptionId: string, accessControlled: boolean, usageControlled: boolean, secondsRemainingInArrears?: number | null, status: StripeSubscriptionStatusEnum, courses: { __typename?: 'CourseConnection', nodes?: Array<{ __typename?: 'Course', id: number, gid: string, name: string, verificationServices: string, photo?: { __typename?: 'AttacheFile', url: string } | null } | null> | null }, grants: { __typename?: 'GrantConnection', nodes?: Array<{ __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, archived: boolean, can: { __typename?: 'GrantPermissions', id: number, gid: string, archive: boolean, unarchive: boolean }, course: { __typename?: 'Course', id: number, gid: string } } | null> | null }, stripePlan: { __typename?: 'StripePlan', id: number, gid: string, name: string }, stripePaymentMethod?: { __typename?: 'StripePaymentMethod', card?: { __typename?: 'StripeCreditCard', brand: StripeCreditCardBrandEnum, last4: number, expMonth: number, expYear: number } | null, billingDetails?: { __typename?: 'StripeBillingDetails', name?: string | null, address?: { __typename?: 'SimpleAddress', address1?: string | null, address2?: string | null, city?: string | null, province?: string | null, country?: string | null, postalCode?: string | null } | null } | null } | null, paths: { __typename?: 'StripeSubscriptionPaths', id: number, gid: string, editPaymentMethod: string } } | { __typename?: 'StripeSubscription', id: number, gid: string, stripeSubscriptionId: string, accessControlled: boolean, usageControlled: boolean, secondsRemainingInArrears?: number | null, status: StripeSubscriptionStatusEnum, stripePlan: { __typename?: 'StripePlan', id: number, gid: string, name: string }, stripePaymentMethod?: { __typename?: 'StripePaymentMethod', card?: { __typename?: 'StripeCreditCard', brand: StripeCreditCardBrandEnum, last4: number, expMonth: number, expYear: number } | null, billingDetails?: { __typename?: 'StripeBillingDetails', name?: string | null, address?: { __typename?: 'SimpleAddress', address1?: string | null, address2?: string | null, city?: string | null, province?: string | null, country?: string | null, postalCode?: string | null } | null } | null } | null, paths: { __typename?: 'StripeSubscriptionPaths', id: number, gid: string, editPaymentMethod: string } } | { __typename?: 'UsageSubscription', currentPeriodStart: Date, currentPeriodEnd: Date, id: number, gid: string, stripeSubscriptionId: string, accessControlled: boolean, usageControlled: boolean, secondsRemainingInArrears?: number | null, status: StripeSubscriptionStatusEnum, licenses: Array<{ __typename?: 'License', id: number, gid: string, isOpen: boolean, seats?: number | null, availableSeats?: number | null, grantedSeats: number, invitedSeats: number, usedSeats: number, expiresAt?: Date | null, verificationServices: string, course: { __typename?: 'Course', id: number, gid: string, name: string, photo?: { __typename?: 'AttacheFile', url: string } | null }, createdBy?: { __typename?: 'LightUser', id: number, gid: string, fullName: string } | null }>, createdBy?: { __typename?: 'LightUser', id: number, gid: string, fullName: string } | null, stripeCustomer: { __typename?: 'StripeCustomer', id: number, gid: string, owner: { __typename?: 'User', id: number, gid: string, fullName: string } }, currentPeriodUsage: Array<{ __typename?: 'Grant', id: number, gid: string, badgePreviewUrl?: string | null, status: GrantStatusEnum, certification?: { __typename?: 'Certification', id: number, gid: string, name: string } | null, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, completedAt?: Date | null, percentComplete: number } | null, course: { __typename?: 'Course', id: number, gid: string, name: string, photo?: { __typename?: 'AttacheFile', url: string } | null }, user?: { __typename?: 'User', id: number, gid: string, sgid: string, name: string, email?: string | null, mobileNumber?: string | null } | null }>, stripePlan: { __typename?: 'StripePlan', id: number, gid: string, name: string }, stripePaymentMethod?: { __typename?: 'StripePaymentMethod', card?: { __typename?: 'StripeCreditCard', brand: StripeCreditCardBrandEnum, last4: number, expMonth: number, expYear: number } | null, billingDetails?: { __typename?: 'StripeBillingDetails', name?: string | null, address?: { __typename?: 'SimpleAddress', address1?: string | null, address2?: string | null, city?: string | null, province?: string | null, country?: string | null, postalCode?: string | null } | null } | null } | null, paths: { __typename?: 'StripeSubscriptionPaths', id: number, gid: string, editPaymentMethod: string } }> } | null };

export type UpdateStripeSubscriptionMutationVariables = Exact<{
  input: UpdateStripeSubscriptionInput;
}>;


export type UpdateStripeSubscriptionMutationResult = { __typename?: 'Mutation', updateStripeSubscription?: { __typename?: 'UpdateStripeSubscriptionPayload', success: boolean, stripeSubscription: { __typename?: 'AccessSubscription', id: number, gid: string, status: StripeSubscriptionStatusEnum } | { __typename?: 'StripeSubscription', id: number, gid: string, status: StripeSubscriptionStatusEnum } | { __typename?: 'UsageSubscription', id: number, gid: string, status: StripeSubscriptionStatusEnum } } | null };

export type ProvideSupportCertificationsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProvideSupportCertificationsQueryResult = { __typename?: 'Query', provideSupport?: { __typename?: 'SupportedUser', id: number, certifications: { __typename?: 'CertificationConnection', nodes?: Array<{ __typename?: 'Certification', id: number, gid: string, number: string, name: string, createdAt: Date, expiresAt?: Date | null, publicUrl: string, walletCardUrl?: string | null, wallCertificateUrl?: string | null } | null> | null } } | null };

export type ProvideSupportEmailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProvideSupportEmailsQueryResult = { __typename?: 'Query', provideSupport?: { __typename?: 'SupportedUser', id: number, sentEmails: { __typename?: 'SentEmailConnection', nodes?: Array<{ __typename?: 'SentEmail', id: number, status: string, emailStatusAt?: Date | null, subject: string, to: Array<string>, from: string, body?: string | null, createdAt: Date, can: { __typename?: 'SentEmailPermissions', id: number, gid: string, show: boolean } } | null> | null } } | null };

export type ProvideSupportGrantDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProvideSupportGrantDetailsQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant', id: number, gid: string, courseProgression?: { __typename?: 'CourseProgression', id: number, gid: string, status: CourseProgressionStatusEnum, percentComplete: number, createdAt: Date, completedAt?: Date | null, courseItemProgressions: Array<{ __typename?: 'CourseItemProgression', id: number, gid: string, name: string, createdAt: Date, completedAt?: Date | null, status: CourseItemProgressionStatusEnum, progress: number, score?: number | null, type: string, ilBooking?: { __typename?: 'ILBooking', id: number, gid: string, createdAt: Date, ilClass: { __typename?: 'ILClass', id: number, gid: string, status: IlClassStatusEnum, can: { __typename?: 'ILClassPermissions', id: number, gid: string, show: boolean }, ilCourse: { __typename?: 'ILCourse', id: number, gid: string, name: string } }, ilClassResults: Array<{ __typename?: 'ILClassResult', id: number, gid: string, attendance?: boolean | null, passed?: boolean | null, grade?: string | null }> } | null, latestGradedAssignmentSubmission?: { __typename?: 'GradedAssignmentSubmission', id: number, gid: string, points?: number | null, updatedAt: Date, failedAt?: Date | null, passedAt?: Date | null, file: { __typename?: 'AttacheFile', url: string, contentType: string } } | null, gradedAssignmentSettings?: { __typename?: 'GradedAssignmentSettings', id: number, gid: string, maxPoints: number } | null, scorm?: { __typename?: 'Scorm', totalSeconds?: number | null, passed?: boolean | null, interactions: Array<{ __typename?: 'ScormInteraction', correctResponses: Array<string>, description?: string | null, latency?: string | null, learnerResponse?: string | null, result: string, timestamp: Date, type: string }> } | null }> } | null } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type ProvideSupportGrantsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProvideSupportGrantsQueryResult = { __typename?: 'Query', provideSupport?: { __typename?: 'SupportedUser', id: number, grants: { __typename?: 'SupportGrantConnection', nodes?: Array<{ __typename?: 'SupportGrant', id: number, gid: string, status: string, license: { __typename?: 'SupportLicense', id: number, gid: string, course: { __typename?: 'SupportCourse', id: number, gid: string, name: string } }, can: { __typename?: 'GrantPermissions', id: number, gid: string, destroy: boolean }, courseProgression?: { __typename?: 'SupportCourseProgression', id: number, gid: string, startedAt?: Date | null, completedAt?: Date | null, failedAt?: Date | null } | null } | null> | null } } | null };

export type ProvideSupportInvitesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProvideSupportInvitesQueryResult = { __typename?: 'Query', provideSupport?: { __typename?: 'SupportedUser', id: number, invites: { __typename?: 'InviteConnection', nodes?: Array<{ __typename?: 'Invite', id: number, gid: string, name: string, updatedAt: Date, status: string, inviter: { __typename?: 'LightUser', id: number, fullName: string }, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean } } | null> | null } } | null };

export type ProvideSupportLearnersQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProvideSupportLearnersQueryResult = { __typename?: 'Query', provideSupport?: { __typename?: 'SupportedUser', id: number, learners: Array<{ __typename?: 'Learner', id: string, active: boolean, fullName: string, email?: string | null, mobileNumber?: string | null, loginToken?: string | null }> } | null };

export type ProvideSupportLicenseDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProvideSupportLicenseDetailsQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License', grantedSeats: number, invitedSeats: number, id: number, gid: string, availableSeats?: number | null, seats?: number | null, usedSeats: number, course: { __typename?: 'Course', id: number, gid: string, name: string }, uses: Array<{ __typename?: 'Grant', gid: string, status: GrantStatusEnum, updatedAt: Date, learner?: { __typename?: 'User', fullName: string, email?: string | null, mobileNumber?: string | null } | null, can: { __typename?: 'GrantPermissions', id: number, gid: string, destroy: boolean } } | { __typename?: 'Invite', gid: string, updatedAt: Date, inviteStatus: string, learner?: { __typename?: 'Learner', fullName: string, email?: string | null, mobileNumber?: string | null } | null, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean } }>, enrolmentKeys: { __typename?: 'EnrolmentKeyConnection', nodes?: Array<{ __typename?: 'EnrolmentKey', id: number, gid: string, token: string, uses: number, maxUses?: number | null, expiresAt?: Date | null } | null> | null }, can: { __typename?: 'LicensePermissions', id: string, gid: string, take: boolean, share: boolean, destroy: boolean, assignTraining: boolean, createEnrolmentKey: boolean } } | { __typename?: 'LicenseGroup', grantedSeats: number, invitedSeats: number, gid: string, availableSeats?: number | null, seats?: number | null, usedSeats: number, course: { __typename?: 'Course', id: number, gid: string, name: string }, uses: Array<{ __typename?: 'Grant', gid: string, status: GrantStatusEnum, updatedAt: Date, learner?: { __typename?: 'User', fullName: string, email?: string | null, mobileNumber?: string | null } | null, can: { __typename?: 'GrantPermissions', id: number, gid: string, destroy: boolean } } | { __typename?: 'Invite', gid: string, updatedAt: Date, inviteStatus: string, learner?: { __typename?: 'Learner', fullName: string, email?: string | null, mobileNumber?: string | null } | null, can: { __typename?: 'InvitePermissions', id: number, gid: string, destroy: boolean } }>, enrolmentKeys: { __typename?: 'EnrolmentKeyConnection', nodes?: Array<{ __typename?: 'EnrolmentKey', id: number, gid: string, token: string, uses: number, maxUses?: number | null, expiresAt?: Date | null } | null> | null }, can: { __typename?: 'LicensePermissions', id: string, gid: string, take: boolean, share: boolean, destroy: boolean, assignTraining: boolean, createEnrolmentKey: boolean } } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type ProvideSupportLicensesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
}>;


export type ProvideSupportLicensesQueryResult = { __typename?: 'Query', provideSupport?: { __typename?: 'SupportedUser', id: number, licenses: { __typename?: 'SupportLicenseConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'SupportLicense', id: number, gid: string, availableSeats?: number | null, grantedSeats: number, invitedSeats: number, seats?: number | null, usedSeats: number, course: { __typename?: 'SupportCourse', id: number, gid: string, name: string }, can: { __typename?: 'LicensePermissions', id: string, gid: string, destroy: boolean } } | null> | null } } | null };

export type ProvideSupportOrdersQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProvideSupportOrdersQueryResult = { __typename?: 'Query', provideSupport?: { __typename?: 'SupportedUser', id: number, orders: { __typename?: 'OrderConnection', nodes?: Array<{ __typename?: 'Order', id: number, gid: string, total: number, tax: number, shipping: number, totalFormatted: string, createdAt: Date, refundedAmount: number, taxFormatted: string, refundedAmountFormatted: string, can: { __typename?: 'OrderPermissions', id: number, gid: string, refund: boolean }, promoCodeUses: Array<{ __typename?: 'PromoCodeUse', id: number, promoCode: { __typename?: 'PromoCode', id: number, code: string } }>, currency: { __typename?: 'Currency', isoCode: string, name: string } } | null> | null } } | null };

export type ProvideSupportQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProvideSupportQueryResult = { __typename?: 'Query', provideSupport?: { __typename?: 'SupportedUser', id: number, gid: string, avatarUrl: string, currentSignInAt?: Date | null, notificationType: NotificationTypeEnum, email?: string | null, mobileNumber?: string | null, firstName: string, fullName: string, timeZone: string, locale: string, userAgent?: { __typename?: 'UserAgent', browser: { __typename?: 'VersionedObject', name: string, version: string }, os: { __typename?: 'VersionedObject', name: string, version: string } } | null, can: { __typename?: 'SupportedUserPermissions', id: number, gid: string, impersonate: boolean, merge: boolean, update: boolean, sendResetPasswordInstructions: boolean, createOfflineOrder: boolean }, address?: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } | null, customValues: Array<{ __typename?: 'CustomValue', id: number, gid: string, value?: string | null, customField: { __typename?: 'CustomField', id: number, gid: string, name: string } }>, storefrontRegisteredAt?: { __typename?: 'Storefront', id: number, gid: string, name: string, url: string, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, required: boolean }> } | null } | null };

export type CreateSurveyResultMutationVariables = Exact<{
  input: CreateSurveyResultInput;
}>;


export type CreateSurveyResultMutationResult = { __typename?: 'Mutation', createSurveyResult?: { __typename?: 'CreateSurveyResultPayload', ok: boolean } | null };

export type CreateSurveySchemaMutationVariables = Exact<{
  input: CreateSurveySchemaInput;
}>;


export type CreateSurveySchemaMutationResult = { __typename?: 'Mutation', createSurveySchema?: { __typename?: 'CreateSurveySchemaPayload', surveySchema?: { __typename?: 'SurveySchema', id: number, gid: string, name: string, description?: string | null, closeable: boolean, content: any, theme: any, can: { __typename?: 'SurveySchemaPermissions', update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string, attribute?: string | null }> } | null };

export type LoadSurveySchemaResultsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadSurveySchemaResultsQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema', id: number, gid: string, name: string, description?: string | null, content: any, surveyResults: Array<{ __typename?: 'SurveyResult', id: number, gid: string, content: any }> } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type LoadSurveySchemaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadSurveySchemaQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema', id: number, gid: string, name: string, description?: string | null, closeable: boolean, content: any, theme: any, can: { __typename?: 'SurveySchemaPermissions', update: boolean, destroy: boolean } } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type LoadSurveySchemasQueryVariables = Exact<{
  organizationIds: Array<Scalars['ID']> | Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadSurveySchemasQueryResult = { __typename?: 'Query', surveySchemas?: { __typename?: 'SurveySchemasNamespace', all: { __typename?: 'SurveySchemaConnection', nodes?: Array<{ __typename?: 'SurveySchema', id: number, gid: string, name: string, description?: string | null, closeable: boolean, content: any, theme: any, can: { __typename?: 'SurveySchemaPermissions', update: boolean, destroy: boolean } } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type UpdateSurveySchemaMutationVariables = Exact<{
  input: UpdateSurveySchemaInput;
}>;


export type UpdateSurveySchemaMutationResult = { __typename?: 'Mutation', updateSurveySchema?: { __typename?: 'UpdateSurveySchemaPayload', surveySchema?: { __typename?: 'SurveySchema', id: number, gid: string, name: string, description?: string | null, closeable: boolean, content: any, theme: any, can: { __typename?: 'SurveySchemaPermissions', update: boolean, destroy: boolean } } | null, errors: Array<{ __typename?: 'ValidationError', message: string, attribute?: string | null }> } | null };

export type LoadManageLearnersStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadManageLearnersStatsQueryResult = { __typename?: 'Query', invites?: { __typename?: 'InvitesNamespace', pendingCount: number } | null, learners?: { __typename?: 'LearnersNamespace', unregisteredCount: number, activeCount: number, withOutstandingTrainingCount: number } | null, grants?: { __typename?: 'GrantsNamespace', completedCount: number, incompleteCount: number } | null, certifications: { __typename?: 'CertificationsNamespace', expiresSoonCount: number } };

export type LoadQuickBuyLicensesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type LoadQuickBuyLicensesQueryResult = { __typename?: 'Query', licenseGroups?: { __typename?: 'LicenseGroupsNamespace', lowSeats?: Array<{ __typename?: 'LicenseGroup', gid: string, availableSeats?: number | null, course: { __typename?: 'Course', id: number, gid: string, name: string, paths: { __typename?: 'CoursePaths', id: number, gid: string, productUrl?: string | null } } }> | null } | null };

export type LoadTrainingDashboardReportIDsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadTrainingDashboardReportIDsQueryResult = { __typename?: 'Query', dashboard?: { __typename?: 'DashboardNamespace', reports: { __typename?: 'ReportDashboard', activeLearnersReportId?: number | null, certificationsReportId?: number | null, learnersPendingSignupReportId?: number | null, learnerTrainingReportId?: number | null, learnersWithOutstandingTrainingReportId?: number | null, completedCoursesReportId?: number | null, incompleteCoursesReportId?: number | null, pendingInvitesReportId?: number | null, expiringCertificationsReportId?: number | null } } | null };

export type ApplyTrainingRoleMutationVariables = Exact<{
  input: ApplyTrainingRoleInput;
}>;


export type ApplyTrainingRoleMutationResult = { __typename?: 'Mutation', applyTrainingRole?: { __typename?: 'ApplyTrainingRolePayload', trainingRoleApplication?: { __typename?: 'TrainingRoleApplication', id: number, gid: string, status: TrainingRoleApplicationStatusEnum, trainingRole: { __typename?: 'TrainingRole', id: number, gid: string, name: string } } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type AssignMatrixTrainingMutationVariables = Exact<{
  input: AssignMatrixTrainingInput;
}>;


export type AssignMatrixTrainingMutationResult = { __typename?: 'Mutation', assignMatrixTraining?: { __typename?: 'AssignMatrixTrainingPayload', ok: boolean } | null };

export type CreateTrainingCompetencyMutationVariables = Exact<{
  input: CreateTrainingCompetencyInput;
}>;


export type CreateTrainingCompetencyMutationResult = { __typename?: 'Mutation', createTrainingCompetency?: { __typename?: 'CreateTrainingCompetencyPayload', trainingCompetency?: { __typename?: 'TrainingCompetency', id: number, gid: string, name: string, description?: string | null, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }>, can?: { __typename?: 'TrainingCompetencyPermissions', id: number, gid: string, destroy: boolean } | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type CreateTrainingRoleMutationVariables = Exact<{
  input: CreateTrainingRoleInput;
}>;


export type CreateTrainingRoleMutationResult = { __typename?: 'Mutation', createTrainingRole?: { __typename?: 'CreateTrainingRolePayload', trainingRole?: { __typename?: 'TrainingRole', id: number, gid: string, name: string, description?: string | null, trainingCompetencies: Array<{ __typename?: 'TrainingCompetency', id: number, gid: string, name: string }>, can?: { __typename?: 'TrainingRolePermissions', id: number, gid: string, destroy: boolean } | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type LoadCoursesAvailableForTrainingMatricesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LoadCoursesAvailableForTrainingMatricesQueryResult = { __typename?: 'Query', courses?: { __typename?: 'CoursesNamespace', availableForTrainingMatrices: { __typename?: 'CourseConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Course', id: number, gid: string, name: string, authorName: string } | null> | null } } | null };

export type LoadLearnersForTrainingMatricesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type LoadLearnersForTrainingMatricesQueryResult = { __typename?: 'Query', learners?: { __typename?: 'LearnersNamespace', all: { __typename?: 'LearnerConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Learner', id: string, gid: string, active: boolean, createdAt: Date, email?: string | null, firstName: string, fullName: string, lastName: string, loginToken?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, trainingRoleApplications: Array<{ __typename?: 'TrainingRoleApplication', id: number, gid: string, status: TrainingRoleApplicationStatusEnum, trainingRole: { __typename?: 'TrainingRole', id: number, gid: string, name: string } }>, can: { __typename?: 'LearnerPermissions', id: string, gid: string, update: boolean, updateContactMethods: boolean, sendResetPasswordInstructions: boolean, sendLearnerInviteNotification: boolean } } | null> | null } } | null };

export type LoadTrainingCompetenciesQueryVariables = Exact<{
  organizationGID: Scalars['ID'];
}>;


export type LoadTrainingCompetenciesQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization', id: number, gid: string, trainingCompetencies?: Array<{ __typename?: 'TrainingCompetency', id: number, gid: string, name: string, description?: string | null, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }>, can?: { __typename?: 'TrainingCompetencyPermissions', id: number, gid: string, destroy: boolean } | null }> | null } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type LoadTrainingCompetencyApplicationsQueryVariables = Exact<{
  gid: Scalars['ID'];
}>;


export type LoadTrainingCompetencyApplicationsQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication', id: number, gid: string, status: TrainingRoleApplicationStatusEnum, learner?: { __typename?: 'Learner', id: string, gid: string, fullName: string } | null, trainingRole: { __typename?: 'TrainingRole', id: number, gid: string, name: string }, trainingCompetencyApplications?: Array<{ __typename?: 'TrainingCompetencyApplication', id: number, gid: string, status: TrainingCompetencyApplicationStatusEnum, trainingCompetencyCompliances: Array<{ __typename?: 'TrainingCompetencyCompliance', id: number, gid: string, status: TrainingCompetencyComplianceStatusEnum, startedAt?: Date | null, completedAt?: Date | null, expiresAt?: Date | null, course: { __typename?: 'Course', id: number, gid: string, name: string } }>, trainingCompetency: { __typename?: 'TrainingCompetency', id: number, gid: string, name: string, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }> } }> | null } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type LoadTrainingCompetencyDetailsQueryVariables = Exact<{
  gid: Scalars['ID'];
}>;


export type LoadTrainingCompetencyDetailsQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency', id: number, gid: string, name: string, description?: string | null, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }>, can?: { __typename?: 'TrainingCompetencyPermissions', id: number, gid: string, destroy: boolean } | null } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type LoadTrainingMatrixChannelQueryVariables = Exact<{
  organizationGID: Scalars['ID'];
}>;


export type LoadTrainingMatrixChannelQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', findByGid?: { __typename?: 'Organization', id: number, gid: string, trainingMatrixChannelData: { __typename?: 'ChannelData', clientId: string, channel: string, token: string } } | null } | null };

export type LoadTrainingRoleDetailsQueryVariables = Exact<{
  gid: Scalars['ID'];
}>;


export type LoadTrainingRoleDetailsQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole', id: number, gid: string, name: string, description?: string | null, trainingCompetencies: Array<{ __typename?: 'TrainingCompetency', id: number, gid: string, name: string }>, can?: { __typename?: 'TrainingRolePermissions', id: number, gid: string, destroy: boolean } | null } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type LoadTrainingRolesQueryVariables = Exact<{
  organizationGID: Scalars['ID'];
}>;


export type LoadTrainingRolesQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey' } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization', id: number, gid: string, trainingRoles?: Array<{ __typename?: 'TrainingRole', id: number, gid: string, name: string, description?: string | null, trainingCompetencies: Array<{ __typename?: 'TrainingCompetency', id: number, gid: string, name: string }>, can?: { __typename?: 'TrainingRolePermissions', id: number, gid: string, destroy: boolean } | null }> | null } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type RefreshMatrixLearnerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefreshMatrixLearnerQueryResult = { __typename?: 'Query', learners?: { __typename?: 'LearnersNamespace', find: { __typename?: 'Learner', id: string, gid: string, active: boolean, createdAt: Date, email?: string | null, firstName: string, fullName: string, lastName: string, loginToken?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, trainingRoleApplications: Array<{ __typename?: 'TrainingRoleApplication', id: number, gid: string, status: TrainingRoleApplicationStatusEnum, trainingCompetencyApplications?: Array<{ __typename?: 'TrainingCompetencyApplication', id: number, gid: string, status: TrainingCompetencyApplicationStatusEnum, trainingCompetencyCompliances: Array<{ __typename?: 'TrainingCompetencyCompliance', id: number, gid: string, status: TrainingCompetencyComplianceStatusEnum, course: { __typename?: 'Course', id: number, gid: string, name: string } }> }> | null, trainingRole: { __typename?: 'TrainingRole', id: number, gid: string, name: string, description?: string | null, trainingCompetencies: Array<{ __typename?: 'TrainingCompetency', id: number, gid: string, name: string }>, can?: { __typename?: 'TrainingRolePermissions', id: number, gid: string, destroy: boolean } | null } }>, can: { __typename?: 'LearnerPermissions', id: string, gid: string, update: boolean, updateContactMethods: boolean, sendResetPasswordInstructions: boolean, sendLearnerInviteNotification: boolean } } } | null };

export type TrainingCompetencyApplicationPartsFragment = { __typename?: 'TrainingCompetencyApplication', id: number, gid: string, status: TrainingCompetencyApplicationStatusEnum };

export type TrainingCompetencyCompliancePartsFragment = { __typename?: 'TrainingCompetencyCompliance', id: number, gid: string, status: TrainingCompetencyComplianceStatusEnum };

export type TrainingCompetencyPartsFragment = { __typename?: 'TrainingCompetency', id: number, gid: string, name: string, description?: string | null, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }>, can?: { __typename?: 'TrainingCompetencyPermissions', id: number, gid: string, destroy: boolean } | null };

export type TrainingRoleApplicationPartsFragment = { __typename?: 'TrainingRoleApplication', id: number, gid: string, status: TrainingRoleApplicationStatusEnum };

export type TrainingRolePartsFragment = { __typename?: 'TrainingRole', id: number, gid: string, name: string, description?: string | null, trainingCompetencies: Array<{ __typename?: 'TrainingCompetency', id: number, gid: string, name: string }>, can?: { __typename?: 'TrainingRolePermissions', id: number, gid: string, destroy: boolean } | null };

export type UpdateTrainingCompetencyMutationVariables = Exact<{
  input: UpdateTrainingCompetencyInput;
}>;


export type UpdateTrainingCompetencyMutationResult = { __typename?: 'Mutation', updateTrainingCompetency?: { __typename?: 'UpdateTrainingCompetencyPayload', trainingCompetency?: { __typename?: 'TrainingCompetency', id: number, gid: string, name: string, description?: string | null, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }>, can?: { __typename?: 'TrainingCompetencyPermissions', id: number, gid: string, destroy: boolean } | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type UpdateTrainingRoleMutationVariables = Exact<{
  input: UpdateTrainingRoleInput;
}>;


export type UpdateTrainingRoleMutationResult = { __typename?: 'Mutation', updateTrainingRole?: { __typename?: 'UpdateTrainingRolePayload', trainingRole?: { __typename?: 'TrainingRole', id: number, gid: string, name: string, description?: string | null, trainingCompetencies: Array<{ __typename?: 'TrainingCompetency', id: number, gid: string, name: string }>, can?: { __typename?: 'TrainingRolePermissions', id: number, gid: string, destroy: boolean } | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type EnrolmentKeyUsageDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EnrolmentKeyUsageDetailsQueryResult = { __typename?: 'Query', node?: { __typename?: 'AccessSubscription' } | { __typename?: 'Address' } | { __typename?: 'AddressCourseRequirement' } | { __typename?: 'AutomationConstant' } | { __typename?: 'AutomationLog' } | { __typename?: 'AutomationScript' } | { __typename?: 'CartItem' } | { __typename?: 'Certification' } | { __typename?: 'CertificationChangeRequest' } | { __typename?: 'CertificationDefault' } | { __typename?: 'CertificationTemplate' } | { __typename?: 'Comment' } | { __typename?: 'ConnectedStripeAccount' } | { __typename?: 'ContactMethod' } | { __typename?: 'Contract' } | { __typename?: 'ContractRevenue' } | { __typename?: 'Course' } | { __typename?: 'CourseAgreement' } | { __typename?: 'CourseDeprecation' } | { __typename?: 'CourseItem' } | { __typename?: 'CourseItemProgression' } | { __typename?: 'CourseProgression' } | { __typename?: 'CourseProgressionResource' } | { __typename?: 'CoursePrompt' } | { __typename?: 'CourseUserAgreement' } | { __typename?: 'CustomAttribute' } | { __typename?: 'CustomDomain' } | { __typename?: 'CustomField' } | { __typename?: 'CustomFieldCourseRequirement' } | { __typename?: 'CustomFieldOption' } | { __typename?: 'CustomValue' } | { __typename?: 'DiscussionMessage' } | { __typename?: 'DownloadableFile' } | { __typename?: 'DynamicContract' } | { __typename?: 'EmailCourseRequirement' } | { __typename?: 'EnrolmentKey', id: number, gid: string, grants: { __typename?: 'GrantConnection', nodes?: Array<{ __typename?: 'Grant', id: number, gid: string, status: GrantStatusEnum, createdAt?: Date | null, user?: { __typename?: 'User', id: number, gid: string, fullName: string } | null } | null> | null } } | { __typename?: 'GradedAssignmentSettings' } | { __typename?: 'GradedAssignmentSubmission' } | { __typename?: 'Grader' } | { __typename?: 'Grant' } | { __typename?: 'ILBooking' } | { __typename?: 'ILClass' } | { __typename?: 'ILClassResult' } | { __typename?: 'ILCourse' } | { __typename?: 'ILCourseItem' } | { __typename?: 'ILLocation' } | { __typename?: 'ILOnlineLocation' } | { __typename?: 'ILPhysicalLocation' } | { __typename?: 'ILSession' } | { __typename?: 'Instructor' } | { __typename?: 'InstructorCredential' } | { __typename?: 'InstructorILCoursePermission' } | { __typename?: 'Integration' } | { __typename?: 'Invite' } | { __typename?: 'LITSalesReportOrderItem' } | { __typename?: 'LearnerVerifiedSession' } | { __typename?: 'License' } | { __typename?: 'LicenseGroup' } | { __typename?: 'LicensePack' } | { __typename?: 'LicensePackUse' } | { __typename?: 'LightUser' } | { __typename?: 'MFAMethod' } | { __typename?: 'MFATrustedDevice' } | { __typename?: 'MenuItem' } | { __typename?: 'MicrosoftEntraCredentialConfiguration' } | { __typename?: 'MonthlyActiveUsersRateContract' } | { __typename?: 'MonthlyCourseDistributionRateContract' } | { __typename?: 'NitoBank' } | { __typename?: 'NitoExam' } | { __typename?: 'OIDCProvider' } | { __typename?: 'OfflineOrder' } | { __typename?: 'OneTimeFeeContract' } | { __typename?: 'Order' } | { __typename?: 'OrderItem' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Owner' } | { __typename?: 'Page' } | { __typename?: 'Payout' } | { __typename?: 'PendingILBookingReservation' } | { __typename?: 'PlatformUsageItem' } | { __typename?: 'PrerequisiteCourseRequirement' } | { __typename?: 'Price' } | { __typename?: 'Product' } | { __typename?: 'ProductBundle' } | { __typename?: 'ProductDefault' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeClaim' } | { __typename?: 'PromoCodeDiscount' } | { __typename?: 'PromoCodeUse' } | { __typename?: 'RapidqlSchedule' } | { __typename?: 'RecurringFlatFeeContract' } | { __typename?: 'Redirect' } | { __typename?: 'Refund' } | { __typename?: 'RefundItem' } | { __typename?: 'RegulatorSubmission' } | { __typename?: 'RegulatorSubmissionCompletion' } | { __typename?: 'ResellerAgreement' } | { __typename?: 'ResourceLink' } | { __typename?: 'Rule' } | { __typename?: 'SAMLProvider' } | { __typename?: 'SalesReportOrderItem' } | { __typename?: 'SavedQuery' } | { __typename?: 'ScormCourseRateContract' } | { __typename?: 'SentEmail' } | { __typename?: 'SharedProduct' } | { __typename?: 'ShippingInformation' } | { __typename?: 'ShippingItem' } | { __typename?: 'ShoppingCartShippingInformation' } | { __typename?: 'StaticPath' } | { __typename?: 'Storefront' } | { __typename?: 'StorefrontTemplate' } | { __typename?: 'StripeCustomer' } | { __typename?: 'StripeInvoicePayment' } | { __typename?: 'StripePlan' } | { __typename?: 'StripeProduct' } | { __typename?: 'StripeRefund' } | { __typename?: 'StripeSubscription' } | { __typename?: 'StripeTransactionFeeContract' } | { __typename?: 'SupportCourse' } | { __typename?: 'SupportCourseItemProgression' } | { __typename?: 'SupportCourseProgression' } | { __typename?: 'SupportGrant' } | { __typename?: 'SupportLicense' } | { __typename?: 'SupportedUser' } | { __typename?: 'SurveyResult' } | { __typename?: 'SurveySchema' } | { __typename?: 'TagField' } | { __typename?: 'TaxItem' } | { __typename?: 'TermsOfService' } | { __typename?: 'TermsOfServiceUserAgreement' } | { __typename?: 'Theme' } | { __typename?: 'TractionCredentialConfiguration' } | { __typename?: 'TrainingCompetency' } | { __typename?: 'TrainingCompetencyApplication' } | { __typename?: 'TrainingCompetencyCompliance' } | { __typename?: 'TrainingRole' } | { __typename?: 'TrainingRoleApplication' } | { __typename?: 'UsageSubscription' } | { __typename?: 'User' } | { __typename?: 'UserMemory' } | { __typename?: 'VerifiedCredential' } | { __typename?: 'VerifiedCredentialIssuer' } | { __typename?: 'View' } | null };

export type LoadCertificationDefaultQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadCertificationDefaultQueryResult = { __typename?: 'Query', viewer?: { __typename?: 'User', id: number, certificationDefault?: { __typename?: 'CertificationDefault', id: number, gid: string, name: string, customSignature?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, contentType: string, geometry?: string | null, signature: string } | null, customLogo?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, contentType: string, geometry?: string | null, signature: string } | null, address?: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } | null } | null } | null };

export type UpdateCertificationDefaultMutationVariables = Exact<{
  input: UpdateCertificationDefaultInput;
}>;


export type UpdateCertificationDefaultMutationResult = { __typename?: 'Mutation', updateCertificationDefault?: { __typename?: 'UpdateCertificationDefaultPayload', certificationDefault?: { __typename?: 'CertificationDefault', id: number, gid: string, name: string, customSignature?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, contentType: string, geometry?: string | null, signature: string } | null, customLogo?: { __typename?: 'AttacheFile', url: string, path: string, bytes: number, contentType: string, geometry?: string | null, signature: string } | null, address?: { __typename?: 'Address', id: number, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', code: string }, province?: { __typename?: 'Location', code: string } | null } | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type UpdateArchivedNodesMutationVariables = Exact<{
  input: UpdateArchivedNodesInput;
}>;


export type UpdateArchivedNodesMutationResult = { __typename?: 'Mutation', updateArchivedNodes?: { __typename?: 'UpdateArchivedNodesPayload', nodes: Array<{ __typename?: 'Certification', id: number, gid: string, archived: boolean } | { __typename?: 'Grant', id: number, gid: string, archived: boolean }> } | null };

export type AcceptTermsOfServiceMutationVariables = Exact<{
  input: AcceptTermsOfServiceInput;
}>;


export type AcceptTermsOfServiceMutationResult = { __typename?: 'Mutation', acceptTermsOfService?: { __typename?: 'AcceptTermsOfServicePayload', termsOfServiceUserAgreement?: { __typename?: 'TermsOfServiceUserAgreement', id: number, gid: string, termsOfService: { __typename?: 'TermsOfService', id: number, gid: string, agreed: boolean, userAgreements: Array<{ __typename?: 'TermsOfServiceUserAgreement', id: number, gid: string, createdAt: Date }> } } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutationResult = { __typename?: 'Mutation', changePassword?: { __typename?: 'ChangePasswordPayload', user?: { __typename?: 'User', id: number } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type ClearImpersonationMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearImpersonationMutationResult = { __typename?: 'Mutation', clearImpersonation?: { __typename?: 'ClearImpersonationPayload', success: boolean, url: string } | null };

export type ConfirmContactMethodMutationVariables = Exact<{
  input: ConfirmContactMethodInput;
}>;


export type ConfirmContactMethodMutationResult = { __typename?: 'Mutation', confirmContactMethod?: { __typename?: 'ConfirmContactMethodPayload', contactMethod?: { __typename?: 'ContactMethod', id: number, gid: string, value: string, confirmed: boolean, confirmedAt?: Date | null } | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null };

export type CreateMfaMethodMutationVariables = Exact<{
  input: CreateMfaMethodInput;
}>;


export type CreateMfaMethodMutationResult = { __typename?: 'Mutation', createMfaMethod?: { __typename?: 'CreateMFAMethodPayload', mfaMethod?: { __typename?: 'MFAMethod', id: number, gid: string } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type CreateUserMemoryMutationVariables = Exact<{
  input: CreateUserMemoryInput;
}>;


export type CreateUserMemoryMutationResult = { __typename?: 'Mutation', createUserMemory?: { __typename?: 'CreateUserMemoryPayload', userMemory?: { __typename?: 'UserMemory', id: number, gid: string, name: string, value: string } | null } | null };

export type HandleInviteMutationVariables = Exact<{
  input: HandleInviteInput;
}>;


export type HandleInviteMutationResult = { __typename?: 'Mutation', handleInvite?: { __typename?: 'HandleInvitePayload', invite?: { __typename?: 'Invite', id: number, name: string, status: string, handled: boolean, inviter: { __typename?: 'LightUser', id: number, fullName: string } } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type ImpersonateUserMutationVariables = Exact<{
  input: ImpersonateUserInput;
}>;


export type ImpersonateUserMutationResult = { __typename?: 'Mutation', impersonateUser?: { __typename?: 'ImpersonateUserPayload', success: boolean } | null };

export type LoadCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadCurrentUserQueryResult = { __typename?: 'Query', timeZones?: Array<string> | null, locales?: Array<string> | null, minimumPasswordComplexity?: number | null, viewer?: { __typename?: 'User', id: number, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, timeZone: string, locale: string, lastSignInAt?: Date | null, name: string, roles: Array<string>, persona: string, allowVenomOptOut: boolean, hasStripeSubscriptions: boolean, mightBeTrainingManager: boolean, currencies: Array<string>, memories?: Array<{ __typename?: 'UserMemory', id: number, gid: string, name: string, value: string }> | null, address?: { __typename?: 'Address', id: number, gid: string, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', code: string, name: string } | null } | null, can: { __typename?: 'UserPermissions', id: number, gid: string, sidekiq: boolean, admin: boolean, trainingManager: boolean, ilManager: boolean, instructor: boolean, createIlCourse: boolean, createIlClass: boolean, createIlLocation: boolean, createInstructor: boolean, provideSupport: boolean, vend: boolean, resell: boolean, author: boolean, survey: boolean, grade: boolean, ecommerceUpgrade: boolean, managePaymentInformation: boolean, reportOnRegulatorSubmissions: boolean, reportOnPlatformUsage: boolean, reportOnCourseCompletions: boolean, changePassword: boolean, createOrganization: boolean, visitClassic: boolean, manageTrainingMatrices: boolean, showLedger: boolean, exportLedger: boolean }, certificationDefault?: { __typename?: 'CertificationDefault', id: number, gid: string, name: string } | null, contactMethods?: Array<{ __typename?: 'ContactMethod', id: number, gid: string, value: string, notificationType: NotificationTypeEnum, confirmedAt?: Date | null, confirmed: boolean }> | null, receivedInvites?: Array<{ __typename?: 'Invite', id: number, gid: string, name: string, status: string, handled: boolean, inviter: { __typename?: 'LightUser', id: number, gid: string, fullName: string } }> | null, customValues?: Array<{ __typename?: 'CustomValue', id: number, gid: string, customFieldId: number, value?: string | null, required: boolean }> | null, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, satisfied: boolean, course: { __typename?: 'Course', id: number, gid: string, name: string } } | { __typename?: 'CustomFieldCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, satisfied: boolean, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string }>, course: { __typename?: 'Course', id: number, gid: string, name: string } } | { __typename?: 'EmailCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, satisfied: boolean, course: { __typename?: 'Course', id: number, gid: string, name: string } } | { __typename?: 'PrerequisiteCourseRequirement', id: number, gid: string, type: CourseRequirementsTypeEnum, requirementType: PrerequisiteCourseRequirementRequirementTypeEnum, requirementQuantity: number, courses: Array<{ __typename?: 'Course', id: number, gid: string, name: string }> }>, pendingTermsOfServices: Array<{ __typename?: 'TermsOfService', id: number, gid: string, name: string, fileUrl: string }>, impersonatedBy?: { __typename?: 'User', id: number, gid: string, fullName: string } | null } | null, currentStorefront?: { __typename?: 'Storefront', id: number, gid: string, name: string, sector: string, addressOnSignup: boolean, addressRequired: boolean, faviconPath?: string | null, logoUrl?: string | null, url: string, hasSubscriptions: boolean, analyticsOptIn: boolean, currency: { __typename?: 'Currency', isoCode: string, name: string }, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string, fieldType?: CustomFieldFieldTypeTypeEnum | null, required: boolean, customFieldOptions?: Array<{ __typename?: 'CustomFieldOption', id: number, value: string }> | null }>, can: { __typename?: 'StorefrontPermissions', id: number, gid: string, createOrder: boolean } } | null };

export type LoadMfaMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadMfaMethodsQueryResult = { __typename?: 'Query', mfaMethods: Array<{ __typename?: 'MFAMethod', id: number, gid: string, lastUsedAt?: Date | null, verifiedAt?: Date | null, contactMethod: { __typename?: 'ContactMethod', id: number, gid: string, notificationType: NotificationTypeEnum, value: string }, can: { __typename?: 'MFAMethodPermissions', verify: boolean, destroy: boolean } }> };

export type LoadMfaTrustedDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadMfaTrustedDevicesQueryResult = { __typename?: 'Query', mfaTrustedDevices: Array<{ __typename?: 'MFATrustedDevice', id: number, gid: string, description: string, createdAt: Date, lastUsedAt?: Date | null, expiresAt: Date, can: { __typename?: 'MFATrustedDevicePermissions', id: number, gid: string, destroy: boolean } }> };

export type MakeTrainingManagerMutationVariables = Exact<{
  input: MakeTrainingManagerInput;
}>;


export type MakeTrainingManagerMutationResult = { __typename?: 'Mutation', makeTrainingManager?: { __typename?: 'MakeTrainingManagerPayload', user?: { __typename?: 'User', id: number, gid: string, name: string, roles: Array<string>, certificationDefault?: { __typename?: 'CertificationDefault', id: number, gid: string, name: string } | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type ResendConfirmationCodeMutationVariables = Exact<{
  input: ResendConfirmationCodeInput;
}>;


export type ResendConfirmationCodeMutationResult = { __typename?: 'Mutation', resendConfirmationCode?: { __typename?: 'ResendConfirmationCodePayload', ok: boolean } | null };

export type SignOutMutationVariables = Exact<{
  input: SignOutInput;
}>;


export type SignOutMutationResult = { __typename?: 'Mutation', signOut?: { __typename?: 'SignOutPayload', success: boolean, redirectTo: string } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutationResult = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id: number, gid: string, firstName: string, lastName: string, fullName: string, email?: string | null, mobileNumber?: string | null, notificationType: NotificationTypeEnum, timeZone: string, locale: string, allowVenomOptOut: boolean, address?: { __typename?: 'Address', id: number, address1: string, address2?: string | null, city: string, postalCode: string, country: { __typename?: 'Country', name: string, code: string }, province?: { __typename?: 'Location', name: string, code: string } | null } | null, contactMethods?: Array<{ __typename?: 'ContactMethod', id: number, gid: string, value: string, notificationType: NotificationTypeEnum, confirmedAt?: Date | null, confirmed: boolean }> | null, customValues?: Array<{ __typename?: 'CustomValue', id: number, gid: string, customFieldId: number, value?: string | null, required: boolean }> | null, courseRequirements: Array<{ __typename?: 'AddressCourseRequirement', type: CourseRequirementsTypeEnum, satisfied: boolean, course: { __typename?: 'Course', id: number, gid: string, name: string } } | { __typename?: 'CustomFieldCourseRequirement', type: CourseRequirementsTypeEnum, satisfied: boolean, customFields: Array<{ __typename?: 'CustomField', id: number, gid: string, name: string }>, course: { __typename?: 'Course', id: number, gid: string, name: string } } | { __typename?: 'EmailCourseRequirement', type: CourseRequirementsTypeEnum, satisfied: boolean, course: { __typename?: 'Course', id: number, gid: string, name: string } } | { __typename?: 'PrerequisiteCourseRequirement' }> } | null, errors?: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> | null } | null };

export type MergeUsersMutationVariables = Exact<{
  input: MergeUsersInput;
}>;


export type MergeUsersMutationResult = { __typename?: 'Mutation', mergeUsers?: { __typename?: 'MergeUsersPayload', success: boolean } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutationResult = { __typename?: 'Mutation', requestPasswordReset?: { __typename?: 'RequestPasswordResetPayload', ok: boolean } | null };

export type SearchUsersWithIlClassAccessQueryVariables = Exact<{
  ilClassId: Scalars['ID'];
  query: Scalars['String'];
}>;


export type SearchUsersWithIlClassAccessQueryResult = { __typename?: 'Query', users?: { __typename?: 'UsersNamespace', searchByIlClassAccess: { __typename?: 'UserConnection', nodes?: Array<{ __typename?: 'User', gid: string, id: number, firstName: string, lastName: string, email?: string | null, mobileNumber?: string | null, ilBookings?: Array<{ __typename?: 'ILBooking', id: number, gid: string }> | null, grantsAvailableForClass: Array<{ __typename?: 'Grant', id: number, gid: string }> } | null> | null } } | null };

export type SearchUsersQueryVariables = Exact<{
  query: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchUsersQueryResult = { __typename?: 'Query', searchUsers?: Array<{ __typename?: 'User', id: number, gid: string, avatarUrl: string, firstName: string, fullName: string, email?: string | null, mobileNumber?: string | null, currentSignInAt?: Date | null, roles: Array<string> }> | null };

export type IssueVerifiedCredentialMutationVariables = Exact<{
  input: IssueVerifiedCredentialInput;
}>;


export type IssueVerifiedCredentialMutationResult = { __typename?: 'Mutation', issueVerifiedCredential?: { __typename?: 'IssueVerifiedCredentialPayload', url?: string | null, appUrl?: string | null, channelData: { __typename?: 'ChannelData', channel: string, token: string, clientId: string } } | null };

export type LoadVerifiedCredentialIssuersQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadVerifiedCredentialIssuersQueryResult = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsNamespace', findById: { __typename?: 'Organization', id: number, gid: string, verifiedCredentialIssuers?: Array<{ __typename?: 'VerifiedCredentialIssuer', id: number, gid: string, name: string, analyticsId?: string | null, valuePropositionHtml?: string | null, requiredPresentationHelpHtml?: string | null, helpHtml?: string | null, iosAppUrl?: string | null, androidAppUrl?: string | null, preambleButtonLabel: string, preambleHtml: string, personHtml?: string | null, courseHtml?: string | null, appLinkPattern?: string | null, currentUserVerification: { __typename?: 'VerifiedCredentialVerification', verificationRequired: boolean, verified: boolean, error?: string | null, verifiedCredential?: { __typename?: 'VerifiedCredential', id: number, gid: string, firstName?: string | null, lastName?: string | null } | null }, termsOfService: Array<{ __typename?: 'TermsOfService', id: number, gid: string, name: string, agreed: boolean, fileUrl: string, userAgreements: Array<{ __typename?: 'TermsOfServiceUserAgreement', id: number, gid: string, createdAt: Date }> }> }> | null } } | null };

export type RequestVerifiedCredentialPresentationMutationVariables = Exact<{
  input: RequestVerifiedCredentialPresentationInput;
}>;


export type RequestVerifiedCredentialPresentationMutationResult = { __typename?: 'Mutation', requestVerifiedCredentialPresentation?: { __typename?: 'RequestVerifiedCredentialPresentationPayload', url?: string | null, appUrl?: string | null, channelData: { __typename?: 'ChannelData', channel: string, token: string, clientId: string } } | null };

export type UpdateVerifiedCredentialIssuerMutationVariables = Exact<{
  input: UpdateVerifiedCredentialIssuerInput;
}>;


export type UpdateVerifiedCredentialIssuerMutationResult = { __typename?: 'Mutation', updateVerifiedCredentialIssuer?: { __typename?: 'UpdateVerifiedCredentialIssuerPayload', verifiedCredentialIssuer?: { __typename?: 'VerifiedCredentialIssuer', id: number, gid: string, name: string, analyticsId?: string | null, valuePropositionHtml?: string | null, requiredPresentationHelpHtml?: string | null, helpHtml?: string | null, iosAppUrl?: string | null, androidAppUrl?: string | null, preambleButtonLabel: string, preambleHtml: string, personHtml?: string | null, courseHtml?: string | null, appLinkPattern?: string | null, currentUserVerification: { __typename?: 'VerifiedCredentialVerification', verificationRequired: boolean, verified: boolean, error?: string | null, verifiedCredential?: { __typename?: 'VerifiedCredential', id: number, gid: string, firstName?: string | null, lastName?: string | null } | null }, termsOfService: Array<{ __typename?: 'TermsOfService', id: number, gid: string, name: string, agreed: boolean, fileUrl: string, userAgreements: Array<{ __typename?: 'TermsOfServiceUserAgreement', id: number, gid: string, createdAt: Date }> }> } | null, errors: Array<{ __typename?: 'ValidationError', message: string }> } | null };

export type VerifiedCredentialIssuerPartsFragment = { __typename?: 'VerifiedCredentialIssuer', id: number, gid: string, name: string, analyticsId?: string | null, valuePropositionHtml?: string | null, requiredPresentationHelpHtml?: string | null, helpHtml?: string | null, iosAppUrl?: string | null, androidAppUrl?: string | null, preambleButtonLabel: string, preambleHtml: string, personHtml?: string | null, courseHtml?: string | null, appLinkPattern?: string | null, currentUserVerification: { __typename?: 'VerifiedCredentialVerification', verificationRequired: boolean, verified: boolean, error?: string | null, verifiedCredential?: { __typename?: 'VerifiedCredential', id: number, gid: string, firstName?: string | null, lastName?: string | null } | null }, termsOfService: Array<{ __typename?: 'TermsOfService', id: number, gid: string, name: string, agreed: boolean, fileUrl: string, userAgreements: Array<{ __typename?: 'TermsOfServiceUserAgreement', id: number, gid: string, createdAt: Date }> }> };

export const CommentsFragmentDoc = gql`
    fragment Comments on Commentable {
  id
  gid
  comments {
    nodes {
      id
      gid
    }
  }
}
    `;
export const CourseAgreementsFragmentDoc = gql`
    fragment CourseAgreements on Course {
  id
  courseAgreements {
    id
    gid
    name
    fileUrl
  }
}
    `;
export const CourseUserAgreementsFragmentDoc = gql`
    fragment courseUserAgreements on CourseUserAgreement {
  id
  gid
  viewedAt
  agreedAt
  courseAgreement {
    id
    gid
    name
    fileUrl
  }
}
    `;
export const ReloadCourseRequirementsPartFragmentDoc = gql`
    fragment ReloadCourseRequirementsPart on Course {
  id
  gid
  courseRequirements {
    ... on EmailCourseRequirement {
      id
      gid
      type
    }
    ... on AddressCourseRequirement {
      id
      gid
      type
    }
    ... on PrerequisiteCourseRequirement {
      id
      gid
      type
    }
  }
}
    `;
export const CourseResourceLinksFragmentDoc = gql`
    fragment CourseResourceLinks on Course {
  id
  resourceLinks {
    id
    gid
    name
    url
  }
}
    `;
export const DiscussionMessagePartsFragmentDoc = gql`
    fragment DiscussionMessageParts on DiscussionMessage {
  id
  gid
  content
  createdAt
  updatedAt
  can {
    id
    gid
    destroy
  }
  discussable {
    id
    gid
  }
  author {
    id
    gid
    name
    avatarUrl
  }
  files {
    url
    path
  }
}
    `;
export const CertificationDefaultPartsFragmentDoc = gql`
    fragment CertificationDefaultParts on CertificationDefault {
  id
  gid
  name
  customSignature {
    url
    path
    bytes
    contentType
    geometry
    signature
  }
  customLogo {
    url
    path
    bytes
    contentType
    geometry
    signature
  }
}
    `;
export const ContractRevenueRecordPartsFragmentDoc = gql`
    fragment ContractRevenueRecordParts on ContractRevenue {
  id
  gid
  calculatedDay
  reportedDay
  quantity
  revenue
  contract {
    id
    gid
    name
    notes
    startDate
    endDate
    active
    customerType
    currency
  }
}
    `;
export const CourseItemPartsFragmentDoc = gql`
    fragment CourseItemParts on CourseItem {
  id
  gid
  createdAt
  file {
    url
    contentType
  }
  name
  position
  type
  url
  scormPreviewLink
  can {
    preview
  }
  certificationTemplates {
    id
    gid
    name
  }
}
    `;
export const CustomFieldPartsFragmentDoc = gql`
    fragment CustomFieldParts on CustomField {
  id
  gid
  name
  fieldType
  required
  showOnSignup
  customFieldOptions {
    id
    gid
    value
  }
  can {
    id
    gid
    update
    destroy
  }
}
    `;
export const CoursePromptPartsFragmentDoc = gql`
    fragment CoursePromptParts on CoursePrompt {
  id
  gid
  minimumTime
  maximumTime
  customFieldCourseRequirements {
    id
    gid
    type
    customFields {
      id
      gid
      ...CustomFieldParts
    }
  }
}
    ${CustomFieldPartsFragmentDoc}`;
export const FilePartsFragmentDoc = gql`
    fragment FileParts on AttacheFile {
  bytes
  contentType
  geometry
  path
  signature
  url
}
    `;
export const CertificationTemplatePartsFragmentDoc = gql`
    fragment CertificationTemplateParts on CertificationTemplate {
  id
  gid
  name
  description
  daysValid
  remindersDisabled
  digitalBadgeImage {
    ...FileParts
  }
  courseItem {
    id
    gid
    name
  }
  walletCardOptions {
    template
    front
    back
  }
  wallCertificateOptions {
    template
    orientation
    front
  }
}
    ${FilePartsFragmentDoc}`;
export const CoursePartsFragmentDoc = gql`
    fragment CourseParts on Course {
  id
  gid
  categories
  contents
  createdAt
  courseAgreements {
    id
    gid
    name
    fileUrl
  }
  courseItems {
    ...CourseItemParts
  }
  coursePrompt {
    ...CoursePromptParts
  }
  deprecatedAt
  description
  discussionForums
  estimatedCompletionTime
  expireLicensesAfterDays
  expireLicensesAt
  expireGrantsAfterDays
  locale
  mobile
  name
  ordered
  owner {
    id
    gid
    name
  }
  ownerId @client
  summary
  surveySchema {
    id
    gid
    name
  }
  surveySchemaId
  photo {
    ...FileParts
  }
  productDefault {
    id
    gid
    bookDuringPurchase
    bulkDiscounts
    bulkDiscountOptions {
      hasCustomPricing
      levels {
        percent
        dollar
        useDollarDiscount
        min
        max
      }
    }
    carouselMedia {
      ...FileParts
    }
    metaTags {
      name
      content
    }
    sku
    taxesEnabled
    prices {
      id
      gid
      currency
      value
    }
  }
  resources {
    ...FileParts
  }
  resourceLinks {
    id
    gid
    name
    url
  }
  sellCourse @client
  shortDescription
  verificationServices
  verificationOptions {
    forceNewIdentification
    holdCertIfUnderReview
    reviewsPerformedByAuthor
    optionalDuringCheckout
    enableMinimumTime
    minimumTime
    enableMaximumAbsent
    maximumAbsent
    enableMaximumAssistance
    maximumAssistance
  }
  courseRequirements {
    ... on CustomFieldCourseRequirement {
      id
      gid
      type
      satisfied
      customFields {
        id
        gid
        name
        fieldType
        required
        customFieldOptions {
          id
          gid
          value
        }
      }
    }
    ... on EmailCourseRequirement {
      id
      gid
      type
    }
    ... on AddressCourseRequirement {
      id
      gid
      type
    }
    ... on PrerequisiteCourseRequirement {
      id
      gid
      type
      requirementType
      requirementQuantity
      courses {
        id
        gid
        name
      }
    }
  }
  certificationTemplate {
    ...CertificationTemplateParts
  }
}
    ${CourseItemPartsFragmentDoc}
${CoursePromptPartsFragmentDoc}
${FilePartsFragmentDoc}
${CertificationTemplatePartsFragmentDoc}`;
export const CommonLicensePartsFragmentDoc = gql`
    fragment CommonLicenseParts on CommonLicense {
  ... on License {
    id
    gid
  }
  ... on LicenseGroup {
    gid
  }
  availableSeats
  seats
  usedSeats
  can {
    id
    gid
    take
    share
    destroy
    assignTraining
    createEnrolmentKey
  }
}
    `;
export const OrderItemRecordPartsFragmentDoc = gql`
    fragment OrderItemRecordParts on LedgerOrderItemRecord {
  id
  gid
  orderId
  orderItemId
  refundId
  refundItemId
  itemId
  itemType
  createdAt
  requiresShipping
  lvEnabled
  currency
  price
  quantity
  promoCodeId
  promoCodeCode
  promoCodeSavings
  orderSubtotal
  productId
  productSku
  productName
  courseOwnerType
  courseOwnerName
  authorAmount
  sellerAmount
  platformAmount
}
    `;
export const PayoutRecordPartsFragmentDoc = gql`
    fragment PayoutRecordParts on Payout {
  id
  gid
  amount
  revenuePart
  createdAt
  organization {
    id
    gid
    name
  }
  refundable {
    ... on RefundItem {
      id
      gid
    }
    ... on StripeRefund {
      id
      gid
      stripeChargeId
      stripeRefundId
      amount
      refundable {
        ... on StripeSubscription {
          id
          gid
          stripeSubscriptionId
          createdAt
        }
        ... on Order {
          id
          gid
          createdAt
          storefront {
            id
            gid
            name
          }
        }
      }
    }
  }
  orderItem {
    id
    gid
    order {
      id
      gid
      createdAt
      storefront {
        id
        gid
        name
      }
    }
    product {
      id
      gid
      name
      sku
    }
    total
  }
  contract {
    id
    gid
    name
  }
}
    `;
export const RefundRecordPartsFragmentDoc = gql`
    fragment RefundRecordParts on LedgerRefundRecord {
  id
  gid
  itemId
  itemType
  createdAt
  amount
  quantity
  tax
  totalRefundedAmount
  reason
  stripeRefundToken
  requiresShipping
  lvEnabled
  purchasedQuantity
  orderId
  currency
  stripeChargeId
  productId
  courseId
  productSku
  productName
  authorAmount
  sellerAmount
  platformAmount
}
    `;
export const CurrencyPartsFragmentDoc = gql`
    fragment CurrencyParts on Currency {
  isoCode
  name
}
    `;
export const ProductPartsFragmentDoc = gql`
    fragment ProductParts on Product {
  id
  gid
  name
  sku
  brand
  type
  description
  shortDescription
  summary
  photo {
    ...FileParts
  }
  price
  categories
  tags {
    key
    value
  }
  ordersCount
  bundledProducts {
    id
    gid
    name
    bookDuringPurchase
    photo {
      ...FileParts
    }
    course {
      id
      gid
      courseItems {
        id
        gid
        name
        ilCourse {
          id
          gid
        }
      }
    }
  }
  currency {
    ...CurrencyParts
  }
  hidden
  requiresShipping
  taxesEnabled
  availableForIndividualPurchase
  bulkDiscounts
  bookDuringPurchase
  bulkDiscountOptions {
    hasCustomPricing
    levels {
      percent
      dollar
      useDollarDiscount
      min
      max
    }
  }
  metaTags {
    name
    content
  }
  carouselMedia {
    ...FileParts
  }
  can {
    id
    gid
    update
    destroy
  }
}
    ${FilePartsFragmentDoc}
${CurrencyPartsFragmentDoc}`;
export const PendingIlBookingReservationFragmentDoc = gql`
    fragment PendingILBookingReservation on PendingILBookingReservation {
  id
  gid
  startsAt
  timeZone
  courseItem {
    id
    gid
  }
  ilClass {
    id
    gid
  }
}
    `;
export const CartItemPartsFragmentDoc = gql`
    fragment CartItemParts on CartItem {
  id
  gid
  bulkDiscountApplied
  quantity
  total
  fullPrice
  splitPromo
  price
  totalTaxed
  promoPriceQuantity
  quantityRemainder
  product {
    ...ProductParts
    isInstructorLed
    course {
      id
      gid
      courseItems {
        id
        gid
        name
        ilCourse {
          id
          gid
        }
      }
    }
  }
  promoCodeClaim {
    id
    gid
  }
  promoCode {
    id
    gid
    description
    code
  }
  pendingIlBookingReservations {
    ...PendingILBookingReservation
  }
}
    ${ProductPartsFragmentDoc}
${PendingIlBookingReservationFragmentDoc}`;
export const ShoppingCartPartsFragmentDoc = gql`
    fragment ShoppingCartParts on ShoppingCart {
  expectedTotal
  expectedTotalCents
  expectedShipping
  expectedTax
  expectedSubtotal
  requiresShipping
  userId
  cartItems {
    ...CartItemParts
  }
  taxes {
    amount
    rate
    description
  }
  billingAddress {
    address1
    address2
    city
    postalCode
    country {
      name
      code
    }
    province {
      name
      code
    }
  }
  shippingAddress {
    address1
    address2
    city
    postalCode
    country {
      name
      code
    }
    province {
      name
      code
    }
  }
  storefront {
    id
    gid
    currency {
      ...CurrencyParts
    }
    name
    stripePublishableKey
  }
  shippingInformation {
    name
    email
    phoneNumber
    companyName
  }
}
    ${CartItemPartsFragmentDoc}
${CurrencyPartsFragmentDoc}`;
export const StorefrontPartsFragmentDoc = gql`
    fragment StorefrontParts on Storefront {
  id
  gid
  name
  sector
  addressOnSignup
  addressRequired
  currency {
    ...CurrencyParts
  }
  customFields {
    id
    gid
    name
    fieldType
    required(applyCourseRequirements: true)
    customFieldOptions {
      id
      value
    }
  }
  can {
    id
    gid
    createOrder
  }
  faviconPath
  logoUrl
  url
  hasSubscriptions
  analyticsOptIn
}
    ${CurrencyPartsFragmentDoc}`;
export const StorefrontRevenueLineOfBusinessTotalAmountPartFragmentDoc = gql`
    fragment StorefrontRevenueLineOfBusinessTotalAmountPart on StorefrontRevenues {
  startPeriod
  endPeriod
  onlineTraining {
    amount
  }
  ilTraining {
    amount
  }
  physicalProduct {
    amount
  }
  promoCodeSaving {
    amount
  }
  shipping {
    amount
  }
  platformSetup {
    amount
  }
  platformLicenses {
    amount
  }
  transactionFees {
    amount
  }
  subscription {
    amount
  }
  courseDistribution {
    amount
  }
  thirdPartyPayout {
    amount
  }
  refunds {
    amount
  }
  federalTaxes {
    amount
  }
  provincialTaxes {
    amount
  }
}
    `;
export const StripeInvoicePaymentRecordPartsFragmentDoc = gql`
    fragment StripeInvoicePaymentRecordParts on StripeInvoicePayment {
  id
  gid
  amountPaid
  stripeSubscription {
    id
    gid
    stripeCustomer {
      id
      gid
      owner {
        id
        gid
        firstName
        lastName
      }
    }
    stripePlan {
      id
      gid
      name
      stripeProduct {
        id
        gid
        name
      }
    }
  }
}
    `;
export const SurveySchemaPartsFragmentDoc = gql`
    fragment SurveySchemaParts on SurveySchema {
  id
  gid
  name
  description
  closeable
  content
  theme
  can {
    update
    destroy
  }
}
    `;
export const SurveySchemaResultsPartsFragmentDoc = gql`
    fragment SurveySchemaResultsParts on SurveySchema {
  id
  gid
  name
  description
  content
  surveyResults {
    id
    gid
    content
  }
}
    `;
export const TaxItemPartsFragmentDoc = gql`
    fragment TaxItemParts on TaxItem {
  id
  gid
  description
  rate
  amount
  amountFormatted
}
    `;
export const TaxRecordPartsFragmentDoc = gql`
    fragment TaxRecordParts on LedgerTaxRecord {
  id
  gid
  itemId
  itemType
  orderId
  kind
  rate
  amount
  taxableType
  taxableId
  description
  createdAt
}
    `;
export const GrantPartsFragmentDoc = gql`
    fragment GrantParts on Grant {
  id
  gid
  status
  createdAt
  archived
  courseProgression {
    id
    gid
    percentComplete
    completedAt
  }
  can {
    id
    gid
    run
    archive
    unarchive
  }
  certification {
    id
    gid
    number
    name
    issuerName
    createdAt
    expiresAt
    learnerVerifiedStatus
  }
  course {
    id
    gid
    name
    verificationServices
    deprecatedAt
    photo {
      url
    }
    createdAt
    owner {
      id
      gid
      name
    }
    can {
      id
      gid
      destroy
    }
    courseRequirements {
      ... on EmailCourseRequirement {
        id
        gid
        type
      }
      ... on AddressCourseRequirement {
        id
        gid
        type
      }
      ... on PrerequisiteCourseRequirement {
        id
        gid
        type
        requirementType
        requirementQuantity
        satisfied
        courses {
          id
          gid
          name
        }
      }
      ... on CustomFieldCourseRequirement {
        id
        gid
        type
        satisfied
      }
    }
  }
  license {
    id
    gid
    stripeSubscription {
      id
      gid
      secondsRemainingInArrears
      status
    }
  }
}
    `;
export const CertificationPartsFragmentDoc = gql`
    fragment CertificationParts on Certification {
  id
  gid
  name
  number
  createdAt
  expiresAt
  learnerVerifiedStatus
  issuerName
  badgeUrl
  uploaded
  userFirstName
  userLastName
  description
  archived
  publicUrl
  walletCardUrl
  wallCertificateUrl
  verifiedCredentialStatus
  verifiedCredentialExported
  can {
    id
    gid
    show
    archive
    unarchive
    destroy
    requestChange
    postToCredivera
    exportVerifiedCredential
    verifiedCredential
    shareToSocial
  }
}
    `;
export const IlBookingWithDetailsPartsFragmentDoc = gql`
    fragment ILBookingWithDetailsParts on ILBooking {
  id
  gid
  createdAt
  status
  waitlistPosition
  can {
    id
    gid
    cancel
    promoteBooking
  }
  user {
    id
    gid
    sgid
    fullName
    firstName
    lastName
    email
    mobileNumber
  }
  ilClass {
    id
    gid
    status
    ilCourse {
      id
      gid
      owner {
        id
        gid
      }
    }
  }
  ilClassResults {
    id
    gid
    passed
    grade
    attendance
    ilCourseItem {
      id
      gid
      name
      trackAttendance
      trackGrade
    }
  }
  certification {
    ...CertificationParts
  }
  previousCourseItemProgressions {
    id
    gid
    name
    status
    score
    failedAt
  }
}
    ${CertificationPartsFragmentDoc}`;
export const IlClassPartsFragmentDoc = gql`
    fragment ILClassParts on ILClass {
  id
  gid
  can {
    id
    gid
    destroy
  }
  status
  access
  availableSeats
  rrule
  maxCapacity
  numberOfBookings
  numberOfWaitlist
  isFirstRecurrence
  bookingStartsAt
  bookingEndsAt
  waitlistSize
  bookingWindow @client {
    startsAt
    endsAt
  }
  firstRecurrence {
    id
    gid
    rrule
    isFirstRecurrence
  }
}
    `;
export const IlCourseItemPartsFragmentDoc = gql`
    fragment ILCourseItemParts on ILCourseItem {
  id
  gid
  name
  position
  trackAttendance
  trackGrade
}
    `;
export const IlCoursePartsFragmentDoc = gql`
    fragment ILCourseParts on ILCourse {
  id
  gid
  name
  createdAt
  can {
    id
    gid
    destroy
  }
  owner {
    id
    gid
  }
  ilCourseItems {
    id
    gid
    name
    position
    trackGrade
    trackAttendance
  }
}
    `;
export const CountryPartsFragmentDoc = gql`
    fragment CountryParts on Country {
  name
  code
}
    `;
export const LocationPartsFragmentDoc = gql`
    fragment LocationParts on Location {
  code
  name
}
    `;
export const AddressPartsFragmentDoc = gql`
    fragment AddressParts on Address {
  id
  gid
  address1
  address2
  city
  country {
    ...CountryParts
  }
  postalCode
  province {
    ...LocationParts
  }
}
    ${CountryPartsFragmentDoc}
${LocationPartsFragmentDoc}`;
export const IlSessionPartsFragmentDoc = gql`
    fragment ILSessionParts on ILSession {
  id
  gid
  startsAt
  endsAt
  timeZone
  ilLocation {
    id
    gid
    name
    type
    ... on ILOnlineLocation {
      url
    }
    ... on ILPhysicalLocation {
      address {
        ...AddressParts
      }
    }
  }
}
    ${AddressPartsFragmentDoc}`;
export const InstructorCredentialPartsFragmentDoc = gql`
    fragment InstructorCredentialParts on InstructorCredential {
  id
  gid
  name
  comment
  expiresAt
  issuedAt
  can {
    id
    gid
    destroy
  }
  file {
    contentType
    path
    url
  }
}
    `;
export const InstructorIlCoursePermissionPartsFragmentDoc = gql`
    fragment InstructorILCoursePermissionParts on InstructorILCoursePermission {
  id
  gid
  can {
    id
    gid
    destroy
  }
  ilCourse {
    id
    gid
    name
  }
}
    `;
export const InstructorPartsFragmentDoc = gql`
    fragment InstructorParts on Instructor {
  id
  gid
  firstName
  lastName
  fullName
  email
  mobileNumber
  status
  distributeWithoutPurchase
  accessLearnerContactDetails
  organization {
    id
    gid
  }
  can {
    id
    gid
    destroy
    resendInvitation
  }
}
    `;
export const InvitePartsFragmentDoc = gql`
    fragment InviteParts on Invite {
  id
  gid
  name
  status
  updatedAt
  emailStatus
  emailStatusMessage
  emailShortStatusMessage
  learner {
    id
    gid
    firstName
    lastName
    fullName @client
  }
  can {
    id
    gid
    destroy
    resend
  }
}
    `;
export const InviteConnectionPartsFragmentDoc = gql`
    fragment InviteConnectionParts on InviteConnection {
  pageInfo {
    hasNextPage
    endCursor
  }
  nodes {
    ...InviteParts
  }
}
    ${InvitePartsFragmentDoc}`;
export const LearnerPartsFragmentDoc = gql`
    fragment LearnerParts on Learner {
  id
  gid
  active
  createdAt
  email
  firstName
  fullName
  lastName
  loginToken
  mobileNumber
  notificationType
  can {
    id
    gid
    update
    updateContactMethods
    sendResetPasswordInstructions
    sendLearnerInviteNotification
  }
}
    `;
export const LicensePartsFragmentDoc = gql`
    fragment LicenseParts on License {
  id
  gid
  availableSeats
  grantedSeats
  invitedSeats
  seats
  usedSeats
  createdAt
  stripeSubscription {
    id
    gid
  }
  course {
    id
    gid
    name
    deprecatedAt
    photo(geometry: "120x120>") {
      url
    }
    courseItems {
      id
      gid
      ilCourse {
        id
        gid
        name
      }
    }
  }
  owner {
    id
    gid
    name
  }
  can {
    id
    gid
    destroy
    share
    take
  }
}
    `;
export const EnrolmentKeyPartsFragmentDoc = gql`
    fragment EnrolmentKeyParts on EnrolmentKey {
  id
  gid
  token
  uses
  maxUses
  remainingUses
  universal
  expiresAt
  deletedAt
  isDeleted @client
  can {
    id
    gid
    update
    destroy
    restore
  }
}
    `;
export const EnrolmentKeyConnectionPartsFragmentDoc = gql`
    fragment EnrolmentKeyConnectionParts on EnrolmentKeyConnection {
  pageInfo {
    hasNextPage
    endCursor
  }
  nodes {
    ...EnrolmentKeyParts
  }
}
    ${EnrolmentKeyPartsFragmentDoc}`;
export const GrantUsageFragmentDoc = gql`
    fragment GrantUsage on Grant {
  id
  gid
  status
  updatedAt
  firstName @client
  lastName @client
  email @client
  mobileNumber @client
  can {
    id
    gid
    destroy
  }
  courseProgression {
    id
    gid
    percentComplete
  }
  user {
    id
    gid
    firstName
    lastName
    fullName @client
    email
    mobileNumber
  }
}
    `;
export const InviteUsageFragmentDoc = gql`
    fragment InviteUsage on Invite {
  id
  gid
  inviteStatus: status
  updatedAt
  firstName @client
  lastName @client
  email @client
  mobileNumber @client
  can {
    id
    gid
    destroy
  }
  learner {
    id
    gid
    firstName
    lastName
    fullName @client
    email
    mobileNumber
  }
}
    `;
export const SupportLicensePartsFragmentDoc = gql`
    fragment SupportLicenseParts on SupportLicense {
  id
  gid
  course {
    id
    gid
    name
  }
  availableSeats
  grantedSeats
  invitedSeats
  seats
  usedSeats
  can {
    id
    gid
    destroy
  }
}
    `;
export const RefundsPartsFragmentDoc = gql`
    fragment RefundsParts on Order {
  refunds {
    id
    gid
    createdAt
    reason
    total
    totalFormatted
    refundItems {
      id
      gid
      quantity
      amount
      amountFormatted
      orderItem {
        id
        gid
        product {
          id
          gid
          name
        }
      }
    }
  }
  stripeRefunds {
    id
    gid
    amount
    amountFormatted
    stripeChargeId
    stripeRefundId
    createdAt
  }
}
    `;
export const AutomationLogPartsFragmentDoc = gql`
    fragment AutomationLogParts on AutomationLog {
  id
  gid
  severity
  message
  sidekiqJobId
  createdAt
}
    `;
export const AutomationScriptPartsFragmentDoc = gql`
    fragment AutomationScriptParts on AutomationScript {
  id
  gid
  title
  translatedEvent
  event
  enabled
  lua
}
    `;
export const OidcProviderPartsFragmentDoc = gql`
    fragment OIDCProviderParts on OIDCProvider {
  id
  gid
  name
  clientId
  clientSecret
  configurationUrl
  scope
  confirmEmailDuringSignup
  promoCodeClaimPath
  automationClaimPath
  can {
    id
    gid
    update
    destroy
  }
}
    `;
export const OrganizationPermissionsPartsFragmentDoc = gql`
    fragment OrganizationPermissionsParts on Organization {
  can {
    id
    gid
    update
    integrate
    automation
    manageVerifiedCredentials
    manageTrainingMatrix
    stripeConnect
    manageSurveys
    manageSso
  }
}
    `;
export const AttacheFilePartsFragmentDoc = gql`
    fragment AttacheFileParts on AttacheFile {
  url
  path
  bytes
  geometry
  contentType
  signature
}
    `;
export const OrganizationDetailPartsFragmentDoc = gql`
    fragment OrganizationDetailParts on Organization {
  id
  gid
  name
  billingEmail
  shippingNotificationEmail
  url
  analyticsOptIn
  taxCodes
  ...OrganizationPermissionsParts
  address {
    ...AddressParts
  }
  certificationDefault {
    id
    gid
    name
    customSignature(geometry: "original") {
      ...AttacheFileParts
    }
    customLogo(geometry: "original") {
      ...AttacheFileParts
    }
    address {
      ...AddressParts
    }
  }
}
    ${OrganizationPermissionsPartsFragmentDoc}
${AddressPartsFragmentDoc}
${AttacheFilePartsFragmentDoc}`;
export const OrganizationPartsFragmentDoc = gql`
    fragment OrganizationParts on Organization {
  id
  gid
  name
}
    `;
export const SamlProviderPartsFragmentDoc = gql`
    fragment SAMLProviderParts on SAMLProvider {
  id
  gid
  name
  issuerUrl
  certFingerprint
  certFingerprintAlgorithm
  targetUrl
  sloTargetUrl
  confirmEmailDuringSignup
  triggerIdpLogout
  uidMapping
  firstNameMapping
  lastNameMapping
  emailMapping
  automationMapping
  promoCodesMapping
  acsUrl
  sloUrl
  can {
    id
    gid
    update
    destroy
  }
}
    `;
export const RapidqlSchedulePartsFragmentDoc = gql`
    fragment RapidqlScheduleParts on RapidqlSchedule {
  id
  gid
  emailTo
  emailCc
  emailBcc
  filters
  interval
  enabled
  day
  dayModifier
  dontSendIfNoResults
  hourOfDay
  timeZone
  can {
    update
    destroy
  }
}
    `;
export const SavedQueryFilterPartsFragmentDoc = gql`
    fragment SavedQueryFilterParts on SavedQueryFilter {
  label
  key
  type
  required
  multiple
  local
  query
  savedQueryId
}
    `;
export const SavedQueryPartsFragmentDoc = gql`
    fragment SavedQueryParts on SavedQuery {
  id
  gid
  name
  description
  audience
  query
  system
  pagination
  updatedAt
  rapidqlSchedules {
    ...RapidqlScheduleParts
  }
  can {
    id
    gid
    update
    destroy
  }
  owner {
    id
    gid
    name
  }
  filters {
    ...SavedQueryFilterParts
  }
}
    ${RapidqlSchedulePartsFragmentDoc}
${SavedQueryFilterPartsFragmentDoc}`;
export const SharedProductPartsFragmentDoc = gql`
    fragment SharedProductParts on SharedProduct {
  id
  gid
  name
  shortDescription
  summary
  description
  categories
  sku
  bulkDiscounts
  bulkDiscountOptions {
    hasCustomPricing
    levels {
      percent
      dollar
      useDollarDiscount
      min
      max
    }
  }
  can {
    id
    gid
    update
    destroy
  }
  photo {
    ...FileParts
  }
  carouselMedia {
    ...FileParts
  }
  owner {
    id
    gid
    kind
    name
  }
  prices {
    id
    gid
    currency
    value
  }
  storefronts {
    id
    gid
    name
  }
}
    ${FilePartsFragmentDoc}`;
export const ShortPagePartsFragmentDoc = gql`
    fragment ShortPageParts on Page {
  id
  gid
  name
  url
}
    `;
export const MenuItemPartsFragmentDoc = gql`
    fragment MenuItemParts on MenuItem {
  id
  gid
  page {
    ...ShortPageParts
  }
  parent {
    id
    gid
  }
  position
  title
  url
  featureImageRight {
    ...FileParts
  }
  featureImageLeft {
    ...FileParts
  }
  can {
    id
    gid
    update
    destroy
  }
}
    ${ShortPagePartsFragmentDoc}
${FilePartsFragmentDoc}`;
export const PagePartsFragmentDoc = gql`
    fragment PageParts on Page {
  id
  gid
  name
  slug
  published
  root
  description
  password
  requireLoggedInUser
  cssClass
  url
  metaTags {
    name
    content
  }
  featureImage {
    ...FileParts
  }
  can {
    id
    gid
    update
    destroy
  }
}
    ${FilePartsFragmentDoc}`;
export const PromoCodePartsFragmentDoc = gql`
    fragment PromoCodeParts on PromoCode {
  id
  gid
  code
  startsAt
  endsAt
  type
  persistent
  quantityLimit
  maxUses
  notes
  discounts {
    id
    gid
    type
    value
    products {
      id
      gid
    }
  }
}
    `;
export const DownloadableFilePartsFragmentDoc = gql`
    fragment DownloadableFileParts on DownloadableFile {
  id
  gid
  name
  staticUrl
  url
  downloads
  staticId
  file {
    ...FileParts
  }
  can {
    id
    gid
    preview
    update
    destroy
  }
}
    ${FilePartsFragmentDoc}`;
export const RedirectPartsFragmentDoc = gql`
    fragment RedirectParts on Redirect {
  id
  gid
  redirectionType
  redirectionUrl
  redirectFrom
  redirectTo {
    ... on Page {
      id
      gid
      name
      url
    }
    ... on Product {
      id
      gid
      name
      url
    }
    ... on ProductBundle {
      id
      gid
      name
      url
    }
    ... on DownloadableFile {
      ...DownloadableFileParts
    }
    ... on StaticPath {
      id
      gid
      path
    }
  }
  can {
    id
    gid
    update
    destroy
  }
}
    ${DownloadableFilePartsFragmentDoc}`;
export const SettingsPartsFragmentDoc = gql`
    fragment SettingsParts on Storefront {
  id
  gid
  name
  domain
  subdomain
  locale
  productPageVersion
  pageHeaderVersion
  description
  contactMethodOnSignup
  addressOnSignup
  addressRequired
  businessNumber
  googleAnalyticsTrackingId
  googleSiteVerificationId
  googleTagManagerId
  googleAdsenseId
  email
  phoneNumber
  facebook
  twitter
  youtube
  allowMfaTrustedDevices
  owner {
    id
    gid
    name
  }
  orderNotificationSubscribers {
    id
    gid
    name
    email
  }
  address {
    ...AddressParts
  }
  photo {
    ...FileParts
  }
  favicon {
    ...FileParts
  }
  emailLogo {
    ...FileParts
  }
}
    ${AddressPartsFragmentDoc}
${FilePartsFragmentDoc}`;
export const ThemePartsFragmentDoc = gql`
    fragment ThemeParts on Theme {
  id
  gid
  name
  backgroundColor
  textColor
  fontName
  customLess
  headerLiquid
  can {
    id
    gid
    update
    destroy
  }
}
    `;
export const TrainingCompetencyApplicationPartsFragmentDoc = gql`
    fragment TrainingCompetencyApplicationParts on TrainingCompetencyApplication {
  id
  gid
  status
}
    `;
export const TrainingCompetencyCompliancePartsFragmentDoc = gql`
    fragment TrainingCompetencyComplianceParts on TrainingCompetencyCompliance {
  id
  gid
  status
}
    `;
export const TrainingCompetencyPartsFragmentDoc = gql`
    fragment TrainingCompetencyParts on TrainingCompetency {
  id
  gid
  name
  description
  courses {
    id
    gid
    name
  }
  can {
    id
    gid
    destroy
  }
}
    `;
export const TrainingRoleApplicationPartsFragmentDoc = gql`
    fragment TrainingRoleApplicationParts on TrainingRoleApplication {
  id
  gid
  status
}
    `;
export const TrainingRolePartsFragmentDoc = gql`
    fragment TrainingRoleParts on TrainingRole {
  id
  gid
  name
  description
  trainingCompetencies {
    id
    gid
    name
  }
  can {
    id
    gid
    destroy
  }
}
    `;
export const VerifiedCredentialIssuerPartsFragmentDoc = gql`
    fragment VerifiedCredentialIssuerParts on VerifiedCredentialIssuer {
  id
  gid
  name
  analyticsId
  valuePropositionHtml
  requiredPresentationHelpHtml
  helpHtml
  iosAppUrl
  androidAppUrl
  preambleButtonLabel
  preambleHtml
  personHtml
  courseHtml
  appLinkPattern
  currentUserVerification {
    verifiedCredential {
      id
      gid
      firstName
      lastName
    }
    verificationRequired
    verified
    error
  }
  termsOfService {
    id
    gid
    name
    agreed @client
    fileUrl
    userAgreements {
      id
      gid
      createdAt
    }
  }
}
    `;
export const AddProductToCartDocument = gql`
    mutation AddProductToCart($input: AddProductToCartInput!) {
  addProductToCart(input: $input) {
    shoppingCart {
      ...ShoppingCartParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${ShoppingCartPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddProductToCartMutation extends Apollo.Mutation<AddProductToCartMutationResult, AddProductToCartMutationVariables> {
    document = AddProductToCartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCartItemsDocument = gql`
    query LoadCartItems {
  cartItems {
    all {
      nodes {
        ...CartItemParts
      }
    }
  }
}
    ${CartItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCartItemsQuery extends Apollo.Query<LoadCartItemsQueryResult, LoadCartItemsQueryVariables> {
    document = LoadCartItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCartItemDocument = gql`
    mutation UpdateCartItem($input: UpdateCartItemInput!) {
  updateCartItem(input: $input) {
    shoppingCart {
      ...ShoppingCartParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${ShoppingCartPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCartItemMutation extends Apollo.Mutation<UpdateCartItemMutationResult, UpdateCartItemMutationVariables> {
    document = UpdateCartItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadChangeRequestsDocument = gql`
    query LoadChangeRequests {
  certificationChangeRequests {
    all {
      count
      nodes {
        id
        gid
        userFirstName
        userLastName
        issuerName
        issuerAddress {
          ...AddressParts
        }
        reason
        can {
          id
          gid
          approve
          decline
        }
        certification {
          id
          gid
          name
          userFirstName
          userLastName
          issuerName
          issuerAddress {
            ...AddressParts
          }
          badgeUrl(geometry: "100x100")
        }
        createdBy {
          id
          gid
          fullName
        }
        verifiedCredential {
          id
          gid
          firstName
          lastName
        }
      }
    }
  }
}
    ${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadChangeRequestsQuery extends Apollo.Query<LoadChangeRequestsQueryResult, LoadChangeRequestsQueryVariables> {
    document = LoadChangeRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadPendingChangeRequestsCountDocument = gql`
    query LoadPendingChangeRequestsCount {
  certificationChangeRequests {
    all {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadPendingChangeRequestsCountQuery extends Apollo.Query<LoadPendingChangeRequestsCountQueryResult, LoadPendingChangeRequestsCountQueryVariables> {
    document = LoadPendingChangeRequestsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCertificationChangeRequestDocument = gql`
    mutation UpdateCertificationChangeRequest($input: UpdateCertificationChangeRequestInput!) {
  updateCertificationChangeRequest(input: $input) {
    certificationChangeRequest {
      id
      gid
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCertificationChangeRequestMutation extends Apollo.Mutation<UpdateCertificationChangeRequestMutationResult, UpdateCertificationChangeRequestMutationVariables> {
    document = UpdateCertificationChangeRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCertificationTemplateDocument = gql`
    mutation CreateCertificationTemplate($input: CreateCertificationTemplateInput!) {
  createCertificationTemplate(input: $input) {
    certificationTemplate {
      id
      gid
      name
      description
      daysValid
      remindersDisabled
      digitalBadgeImage {
        url
        path
        bytes
        contentType
        geometry
        signature
      }
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCertificationTemplateMutation extends Apollo.Mutation<CreateCertificationTemplateMutationResult, CreateCertificationTemplateMutationVariables> {
    document = CreateCertificationTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEntraManifestDocument = gql`
    mutation CreateEntraManifest($input: CreateEntraManifestInput!) {
  createEntraManifest(input: $input) {
    certificationTemplate {
      id
      gid
      name
      description
      credentialConfiguration {
        ... on MicrosoftEntraCredentialConfiguration {
          id
          gid
          manifestUrl
          textColor
          backgroundColor
        }
      }
      verifiedCredentialIssuer {
        id
        gid
        name
        implementationType
      }
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEntraManifestMutation extends Apollo.Mutation<CreateEntraManifestMutationResult, CreateEntraManifestMutationVariables> {
    document = CreateEntraManifestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCertificationTemplateDetailsDocument = gql`
    query LoadCertificationTemplateDetails($id: Int!) {
  certificationTemplates {
    findById(id: $id) {
      id
      gid
      name
      description
      daysValid
      remindersDisabled
      digitalBadgeImage {
        url
        path
        bytes
        contentType
        geometry
        signature
      }
      walletCardOptions {
        template
        front
        back
      }
      wallCertificateOptions {
        template
        orientation
        front
      }
      credentialConfiguration {
        ... on MicrosoftEntraCredentialConfiguration {
          id
          gid
          manifestUrl
          textColor
          backgroundColor
        }
      }
      verifiedCredentialIssuer {
        id
        gid
        name
        implementationType
      }
      can {
        id
        gid
        createEntraManifest
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCertificationTemplateDetailsQuery extends Apollo.Query<LoadCertificationTemplateDetailsQueryResult, LoadCertificationTemplateDetailsQueryVariables> {
    document = LoadCertificationTemplateDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCertificationTemplateListDocument = gql`
    query LoadCertificationTemplateList($organizationIds: [ID!]) {
  certificationTemplates {
    all(organizationIds: $organizationIds) {
      nodes {
        id
        gid
        name
        description
        daysValid
        remindersDisabled
        digitalBadgeImage {
          url
          path
          bytes
          contentType
          geometry
          signature
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCertificationTemplateListQuery extends Apollo.Query<LoadCertificationTemplateListQueryResult, LoadCertificationTemplateListQueryVariables> {
    document = LoadCertificationTemplateListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCertificationTemplateDocument = gql`
    mutation UpdateCertificationTemplate($input: UpdateCertificationTemplateInput!) {
  updateCertificationTemplate(input: $input) {
    certificationTemplate {
      id
      gid
      name
      description
      daysValid
      remindersDisabled
      digitalBadgeImage {
        url
        path
        bytes
        contentType
        geometry
        signature
      }
      walletCardOptions {
        template
        front
        back
      }
      wallCertificateOptions {
        template
        orientation
        front
      }
      courseItem {
        id
        gid
      }
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCertificationTemplateMutation extends Apollo.Mutation<UpdateCertificationTemplateMutationResult, UpdateCertificationTemplateMutationVariables> {
    document = UpdateCertificationTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCertificationChangeRequestDocument = gql`
    mutation CreateCertificationChangeRequest($input: CreateCertificationChangeRequestInput!) {
  createCertificationChangeRequest(input: $input) {
    changeRequest {
      id
      gid
      certificationId
      userFirstName
      userLastName
      issuerName
      issuerAddress {
        ...AddressParts
      }
      reason
    }
    errors {
      attribute
      message
    }
  }
}
    ${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCertificationChangeRequestMutation extends Apollo.Mutation<CreateCertificationChangeRequestMutationResult, CreateCertificationChangeRequestMutationVariables> {
    document = CreateCertificationChangeRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCertificationDetailsDocument = gql`
    query LoadCertificationDetails($id: Int!) {
  certifications {
    findById(id: $id) {
      ...CertificationParts
      verifiedCredentialIssuer {
        ...VerifiedCredentialIssuerParts
      }
      issuerAddress {
        ...AddressParts
      }
    }
  }
}
    ${CertificationPartsFragmentDoc}
${VerifiedCredentialIssuerPartsFragmentDoc}
${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCertificationDetailsQuery extends Apollo.Query<LoadCertificationDetailsQueryResult, LoadCertificationDetailsQueryVariables> {
    document = LoadCertificationDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLearnerCertificationListDocument = gql`
    query LoadLearnerCertificationList($includeArchived: Boolean!) {
  viewer {
    id
    certifications(includeArchived: $includeArchived) {
      ...CertificationParts
    }
  }
}
    ${CertificationPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLearnerCertificationListQuery extends Apollo.Query<LoadLearnerCertificationListQueryResult, LoadLearnerCertificationListQueryVariables> {
    document = LoadLearnerCertificationListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadTrainingManagerCertificationListDocument = gql`
    query LoadTrainingManagerCertificationList($search: String, $after: String, $first: Int) {
  certifications {
    all(onlyMine: false, search: $search, after: $after, first: $first) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...CertificationParts
        user {
          id
          sgid
          fullName
          email
          mobileNumber
        }
      }
    }
  }
}
    ${CertificationPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadTrainingManagerCertificationListQuery extends Apollo.Query<LoadTrainingManagerCertificationListQueryResult, LoadTrainingManagerCertificationListQueryVariables> {
    document = LoadTrainingManagerCertificationListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PostCertificationToCrediveraDocument = gql`
    mutation PostCertificationToCredivera($input: PostCertificationToCrediveraInput!) {
  postCertificationToCredivera(input: $input) {
    ok
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PostCertificationToCrediveraMutation extends Apollo.Mutation<PostCertificationToCrediveraMutationResult, PostCertificationToCrediveraMutationVariables> {
    document = PostCertificationToCrediveraDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadCertificationDocument = gql`
    mutation UploadCertification($input: UploadCertificationInput!) {
  uploadCertification(input: $input) {
    certification {
      ...CertificationParts
    }
    errors {
      message
    }
  }
}
    ${CertificationPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadCertificationMutation extends Apollo.Mutation<UploadCertificationMutationResult, UploadCertificationMutationVariables> {
    document = UploadCertificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommentDocument = gql`
    mutation CreateComment($input: CreateCommentInput!) {
  createComment(input: $input) {
    errors {
      message
    }
    comment {
      can {
        id
        gid
        destroy
      }
      id
      gid
      content
      createdAt
      author {
        id
        gid
        fullName
        avatarUrl
      }
      organization {
        id
        gid
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommentMutation extends Apollo.Mutation<CreateCommentMutationResult, CreateCommentMutationVariables> {
    document = CreateCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCommentsForCommentableDocument = gql`
    query LoadCommentsForCommentable($id: ID!) {
  comments {
    all(commentableId: $id) {
      nodes {
        id
        gid
        content
        createdAt
        author {
          id
          gid
          fullName
          avatarUrl
        }
        organization {
          id
          gid
          name
        }
        can {
          id
          gid
          destroy
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCommentsForCommentableQuery extends Apollo.Query<LoadCommentsForCommentableQueryResult, LoadCommentsForCommentableQueryVariables> {
    document = LoadCommentsForCommentableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCourseItemProgressionDocument = gql`
    query LoadCourseItemProgression($itemId: ID!) {
  courseItemProgressions {
    findById(id: $itemId) {
      id
      gid
      name
      status
      type
      ready
      runnable
      openable
      practiceable
      reviewable
      attemptsRemaining
      progress
      completed
      score
      url
      gradedAssignmentSubmissionsClosedAt
      can {
        submitGradedAssignment
      }
      ilBooking {
        id
        gid
        can {
          id
          gid
          cancel
        }
        ilClassResults {
          id
          gid
          attendance
          passed
          grade
          ilCourseItem {
            id
            gid
            name
            position
            trackAttendance
            trackGrade
          }
        }
        ilClass {
          id
          gid
          status
          bookingStartsAt
          bookingEndsAt
          bookingWindow @client {
            startsAt
            endsAt
          }
          ilCourse {
            id
            gid
            name
            learnerFiles {
              bytes
              contentType
              geometry
              path
              signature
              url
            }
          }
          instructors {
            id
            gid
            firstName
            lastName
            email
          }
          ilSessions {
            id
            gid
            startsAt
            endsAt
            timeZone
            ilLocation {
              id
              gid
              name
              type
              ... on ILOnlineLocation {
                url
              }
              ... on ILPhysicalLocation {
                address {
                  ...AddressParts
                }
              }
            }
          }
        }
      }
      courseItem {
        id
        gid
        contentType
        file {
          url
          contentType
        }
      }
      gradedAssignmentSettings {
        id
        gid
        maxPoints
        passingGrade
      }
      gradedAssignmentSubmissions {
        id
        gid
        createdAt
        passedAt
        failedAt
        points
        file {
          url
          contentType
        }
      }
      latestGradedAssignmentSubmission {
        id
        gid
        points
        file {
          url
          contentType
        }
      }
      courseProgression {
        id
        gid
        status
        percentComplete
        grant {
          id
          gid
          status
          certification {
            id
            gid
            badgeUrl
          }
        }
      }
    }
  }
}
    ${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCourseItemProgressionQuery extends Apollo.Query<LoadCourseItemProgressionQueryResult, LoadCourseItemProgressionQueryVariables> {
    document = LoadCourseItemProgressionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkCourseItemProgressionCompleteDocument = gql`
    mutation MarkCourseItemProgressionComplete($input: MarkCourseItemProgressionCompleteInput!) {
  markCourseItemProgressionComplete(input: $input) {
    item {
      id
      gid
      runnable
      progress
      status
      completed
      courseProgression {
        id
        percentComplete
        grant {
          id
          certification {
            id
            gid
            badgeUrl
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkCourseItemProgressionCompleteMutation extends Apollo.Mutation<MarkCourseItemProgressionCompleteMutationResult, MarkCourseItemProgressionCompleteMutationVariables> {
    document = MarkCourseItemProgressionCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReviewCourseItemProgressionDocument = gql`
    mutation ReviewCourseItemProgression($input: ReviewCourseItemProgressionInput!) {
  reviewCourseItemProgression(input: $input) {
    review {
      url
      error
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReviewCourseItemProgressionMutation extends Apollo.Mutation<ReviewCourseItemProgressionMutationResult, ReviewCourseItemProgressionMutationVariables> {
    document = ReviewCourseItemProgressionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RunCourseItemProgressionDocument = gql`
    mutation RunCourseItemProgression($input: RunCourseItemProgressionInput!) {
  runCourseItemProgression(input: $input) {
    launch {
      url
      error
    }
    item {
      id
      gid
      runnable
      openable
      attemptsRemaining
      practiceable
      reviewable
      progress
      status
      completed
      courseProgression {
        id
        percentComplete
        grant {
          id
          status
          certification {
            id
            gid
            badgeUrl
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RunCourseItemProgressionMutation extends Apollo.Mutation<RunCourseItemProgressionMutationResult, RunCourseItemProgressionMutationVariables> {
    document = RunCourseItemProgressionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseItemProgressionProgressDocument = gql`
    mutation UpdateCourseItemProgressionProgress($input: UpdateCourseItemProgressionProgressInput!) {
  updateCourseItemProgressionProgress(input: $input) {
    item {
      id
      gid
      runnable
      progress
      status
      completed
      courseProgression {
        id
        percentComplete
        grant {
          id
          certification {
            id
            gid
            badgeUrl
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseItemProgressionProgressMutation extends Apollo.Mutation<UpdateCourseItemProgressionProgressMutationResult, UpdateCourseItemProgressionProgressMutationVariables> {
    document = UpdateCourseItemProgressionProgressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCourseToStorefrontDocument = gql`
    mutation AddCourseToStorefront($input: AddCourseToStorefrontInput!) {
  addCourseToStorefront(input: $input) {
    course {
      id
      gid
      name
    }
    product {
      id
      gid
      name
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCourseToStorefrontMutation extends Apollo.Mutation<AddCourseToStorefrontMutationResult, AddCourseToStorefrontMutationVariables> {
    document = AddCourseToStorefrontDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddExamToCourseDocument = gql`
    mutation AddExamToCourse($input: AddExamToCourseInput!) {
  addExamToCourse(input: $input) {
    course {
      id
      gid
      courseItems {
        ...CourseItemParts
      }
    }
  }
}
    ${CourseItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddExamToCourseMutation extends Apollo.Mutation<AddExamToCourseMutationResult, AddExamToCourseMutationVariables> {
    document = AddExamToCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddGradedAssignmentToCourseDocument = gql`
    mutation AddGradedAssignmentToCourse($input: AddGradedAssignmentToCourseInput!) {
  addGradedAssignmentToCourse(input: $input) {
    course {
      id
      gid
      courseItems {
        ...CourseItemParts
      }
    }
    errors {
      message
    }
  }
}
    ${CourseItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddGradedAssignmentToCourseMutation extends Apollo.Mutation<AddGradedAssignmentToCourseMutationResult, AddGradedAssignmentToCourseMutationVariables> {
    document = AddGradedAssignmentToCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddItemToCourseDocument = gql`
    mutation AddItemToCourse($input: AddItemToCourseInput!) {
  addItemToCourse(input: $input) {
    course {
      id
      gid
      courseItems {
        ...CourseItemParts
      }
    }
    errors {
      message
    }
  }
}
    ${CourseItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddItemToCourseMutation extends Apollo.Mutation<AddItemToCourseMutationResult, AddItemToCourseMutationVariables> {
    document = AddItemToCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddLinkToCourseDocument = gql`
    mutation AddLinkToCourse($input: AddLinkToCourseInput!) {
  addLinkToCourse(input: $input) {
    course {
      id
      gid
      courseItems {
        ...CourseItemParts
      }
    }
    errors {
      message
    }
  }
}
    ${CourseItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddLinkToCourseMutation extends Apollo.Mutation<AddLinkToCourseMutationResult, AddLinkToCourseMutationVariables> {
    document = AddLinkToCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AgreeToCourseAgreementDocument = gql`
    mutation AgreeToCourseAgreement($input: AgreeToCourseAgreementInput!) {
  agreeToCourseAgreement(input: $input) {
    courseUserAgreement {
      id
      gid
      viewedAt
      agreedAt
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AgreeToCourseAgreementMutation extends Apollo.Mutation<AgreeToCourseAgreementMutationResult, AgreeToCourseAgreementMutationVariables> {
    document = AgreeToCourseAgreementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseAgreementDocument = gql`
    mutation CreateCourseAgreement($input: CreateCourseAgreementInput!) {
  createCourseAgreement(input: $input) {
    courseAgreement {
      id
      gid
      name
      fileUrl
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseAgreementMutation extends Apollo.Mutation<CreateCourseAgreementMutationResult, CreateCourseAgreementMutationVariables> {
    document = CreateCourseAgreementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCoursePromptDocument = gql`
    mutation CreateCoursePrompt($input: CreateCoursePromptInput!) {
  createCoursePrompt(input: $input) {
    coursePrompt {
      id
      gid
      minimumTime
      maximumTime
      customFieldCourseRequirements {
        id
        gid
        type
        customFields {
          id
          gid
          ...CustomFieldParts
        }
      }
    }
    errors {
      attribute
      message
    }
  }
}
    ${CustomFieldPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCoursePromptMutation extends Apollo.Mutation<CreateCoursePromptMutationResult, CreateCoursePromptMutationVariables> {
    document = CreateCoursePromptDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseRequirementDocument = gql`
    mutation CreateCourseRequirement($input: CreateCourseRequirementInput!) {
  createCourseRequirement(input: $input) {
    courseRequirement {
      ... on EmailCourseRequirement {
        id
        gid
        type
        course {
          ...ReloadCourseRequirementsPart
        }
      }
      ... on AddressCourseRequirement {
        id
        gid
        type
        course {
          ...ReloadCourseRequirementsPart
        }
      }
    }
  }
}
    ${ReloadCourseRequirementsPartFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseRequirementMutation extends Apollo.Mutation<CreateCourseRequirementMutationResult, CreateCourseRequirementMutationVariables> {
    document = CreateCourseRequirementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseResourceLinkDocument = gql`
    mutation CreateCourseResourceLink($input: CreateCourseResourceLinkInput!) {
  createCourseResourceLink(input: $input) {
    errors {
      attribute
      message
    }
    resourceLink {
      id
      gid
      name
      url
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseResourceLinkMutation extends Apollo.Mutation<CreateCourseResourceLinkMutationResult, CreateCourseResourceLinkMutationVariables> {
    document = CreateCourseResourceLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseDocument = gql`
    mutation CreateCourse($input: CreateCourseInput!) {
  createCourse(input: $input) {
    course {
      id
      gid
      name
      shortDescription
      locale
      courseItems {
        ...CourseItemParts
      }
    }
    errors {
      attribute
      message
    }
  }
}
    ${CourseItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseMutation extends Apollo.Mutation<CreateCourseMutationResult, CreateCourseMutationVariables> {
    document = CreateCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomFieldCourseRequirementDocument = gql`
    mutation CreateCustomFieldCourseRequirement($input: CreateCustomFieldCourseRequirementInput!) {
  createCustomFieldCourseRequirement(input: $input) {
    customFieldCourseRequirement {
      id
      gid
      course {
        ...ReloadCourseRequirementsPart
      }
      customFields {
        id
        gid
        name
        fieldType
      }
    }
    errors {
      message
    }
  }
}
    ${ReloadCourseRequirementsPartFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomFieldCourseRequirementMutation extends Apollo.Mutation<CreateCustomFieldCourseRequirementMutationResult, CreateCustomFieldCourseRequirementMutationVariables> {
    document = CreateCustomFieldCourseRequirementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePrerequisiteCourseRequirementDocument = gql`
    mutation CreatePrerequisiteCourseRequirement($input: CreatePrerequisiteCourseRequirementInput!) {
  createPrerequisiteCourseRequirement(input: $input) {
    prerequisiteCourseRequirement {
      id
      gid
      requirementType
      requirementQuantity
      course {
        ...ReloadCourseRequirementsPart
      }
      courses {
        id
        gid
        name
      }
    }
    errors {
      message
    }
  }
}
    ${ReloadCourseRequirementsPartFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePrerequisiteCourseRequirementMutation extends Apollo.Mutation<CreatePrerequisiteCourseRequirementMutationResult, CreatePrerequisiteCourseRequirementMutationVariables> {
    document = CreatePrerequisiteCourseRequirementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeprecateCourseDocument = gql`
    mutation DeprecateCourse($input: DeprecateCourseInput!) {
  deprecateCourse(input: $input) {
    course {
      id
      gid
      name
      deprecatedAt
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeprecateCourseMutation extends Apollo.Mutation<DeprecateCourseMutationResult, DeprecateCourseMutationVariables> {
    document = DeprecateCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCourseDetailsDocument = gql`
    query LoadCourseDetails($id: Int!) {
  courses {
    findById(id: $id) {
      ...CourseParts
      tags {
        key
        value
      }
    }
  }
}
    ${CoursePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCourseDetailsQuery extends Apollo.Query<LoadCourseDetailsQueryResult, LoadCourseDetailsQueryVariables> {
    document = LoadCourseDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadRegulatorSubmissionConfiguredCourseListDocument = gql`
    query LoadRegulatorSubmissionConfiguredCourseList($organizationIds: [ID!]!, $after: String, $first: Int) {
  courses {
    configuredForRegulatorSubmission(
      organizationIds: $organizationIds
      after: $after
      first: $first
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        gid
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadRegulatorSubmissionConfiguredCourseListQuery extends Apollo.Query<LoadRegulatorSubmissionConfiguredCourseListQueryResult, LoadRegulatorSubmissionConfiguredCourseListQueryVariables> {
    document = LoadRegulatorSubmissionConfiguredCourseListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadRegulatorSubmissionCourseListDocument = gql`
    query LoadRegulatorSubmissionCourseList($organizationId: ID!, $after: String, $first: Int) {
  courses {
    availableForRegulatorSubmission(
      organizationId: $organizationId
      after: $after
      first: $first
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        gid
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadRegulatorSubmissionCourseListQuery extends Apollo.Query<LoadRegulatorSubmissionCourseListQueryResult, LoadRegulatorSubmissionCourseListQueryVariables> {
    document = LoadRegulatorSubmissionCourseListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCourseListDocument = gql`
    query LoadCourseList($openlyLicensed: Boolean, $after: String, $first: Int) {
  courses {
    all(openlyLicensed: $openlyLicensed, after: $after, first: $first) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        gid
        name
        deprecatedAt
        photo {
          url
        }
        verificationServices
        can {
          id
          gid
          update
          license
          destroy
          deprecate
        }
        owner {
          id
          gid
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCourseListQuery extends Apollo.Query<LoadCourseListQueryResult, LoadCourseListQueryVariables> {
    document = LoadCourseListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCoursePromptDocument = gql`
    query LoadCoursePrompt($id: Int!) {
  courses {
    findById(id: $id) {
      coursePrompt {
        ...CoursePromptParts
      }
    }
  }
}
    ${CoursePromptPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCoursePromptQuery extends Apollo.Query<LoadCoursePromptQueryResult, LoadCoursePromptQueryVariables> {
    document = LoadCoursePromptDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCourseUsageDocument = gql`
    query LoadCourseUsage($id: Int!) {
  courses {
    findById(id: $id) {
      id
      gid
      usageInformation {
        grantCount
        inviteCount
        licenseCount
        productCount
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCourseUsageQuery extends Apollo.Query<LoadCourseUsageQueryResult, LoadCourseUsageQueryVariables> {
    document = LoadCourseUsageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCourseUserAgreementDetailsDocument = gql`
    query LoadCourseUserAgreementDetails($id: ID!) {
  node(id: $id) {
    ... on CourseUserAgreement {
      id
      gid
      viewedAt
      agreedAt
      courseAgreement {
        id
        gid
        name
        fileUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCourseUserAgreementDetailsQuery extends Apollo.Query<LoadCourseUserAgreementDetailsQueryResult, LoadCourseUserAgreementDetailsQueryVariables> {
    document = LoadCourseUserAgreementDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCoursesBookableForIlClassDocument = gql`
    query LoadCoursesBookableForILClass($ilClassId: ID!) {
  courses {
    bookableForIlClass(ilClassId: $ilClassId) {
      nodes {
        id
        gid
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCoursesBookableForIlClassQuery extends Apollo.Query<LoadCoursesBookableForIlClassQueryResult, LoadCoursesBookableForIlClassQueryVariables> {
    document = LoadCoursesBookableForIlClassDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLearnerCourseListDocument = gql`
    query LoadLearnerCourseList($includeArchived: Boolean!) {
  viewer {
    id
    gid
    grants(includeArchived: $includeArchived) {
      ...GrantParts
    }
  }
}
    ${GrantPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLearnerCourseListQuery extends Apollo.Query<LoadLearnerCourseListQueryResult, LoadLearnerCourseListQueryVariables> {
    document = LoadLearnerCourseListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontsForCourseDocument = gql`
    query LoadStorefrontsForCourse($courseId: ID!) {
  storefronts {
    all(courseId: $courseId) {
      id
      gid
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontsForCourseQuery extends Apollo.Query<LoadStorefrontsForCourseQueryResult, LoadStorefrontsForCourseQueryVariables> {
    document = LoadStorefrontsForCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCourseFromStorefrontDocument = gql`
    mutation RemoveCourseFromStorefront($input: RemoveCourseFromStorefrontInput!) {
  removeCourseFromStorefront(input: $input) {
    course {
      id
      gid
      name
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCourseFromStorefrontMutation extends Apollo.Mutation<RemoveCourseFromStorefrontMutationResult, RemoveCourseFromStorefrontMutationVariables> {
    document = RemoveCourseFromStorefrontDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCustomFieldCourseRequirementDocument = gql`
    mutation removeCustomFieldCourseRequirement($input: RemoveCustomFieldCourseRequirementInput!) {
  removeCustomFieldCourseRequirement(input: $input) {
    course {
      id
      gid
      courseRequirements {
        ... on CustomFieldCourseRequirement {
          id
          gid
          type
          satisfied
          customFields {
            id
            gid
            name
            fieldType
            required
            customFieldOptions {
              id
              gid
              value
            }
          }
        }
      }
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCustomFieldCourseRequirementMutation extends Apollo.Mutation<RemoveCustomFieldCourseRequirementMutationResult, RemoveCustomFieldCourseRequirementMutationVariables> {
    document = RemoveCustomFieldCourseRequirementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StopSellingCourseDocument = gql`
    mutation StopSellingCourse($input: StopSellingCourseInput!) {
  stopSellingCourse(input: $input) {
    course {
      id
      gid
      name
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StopSellingCourseMutation extends Apollo.Mutation<StopSellingCourseMutationResult, StopSellingCourseMutationVariables> {
    document = StopSellingCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitGradedAssignmentDocument = gql`
    mutation SubmitGradedAssignment($input: SubmitGradedAssignmentInput!) {
  submitGradedAssignment(input: $input) {
    gradedAssignmentSubmission {
      id
      gid
      createdAt
      passedAt
      failedAt
      points
      file {
        url
      }
      courseItemProgression {
        id
        gid
        gradedAssignmentSubmissions {
          id
          gid
          createdAt
          passedAt
          failedAt
          points
          file {
            url
          }
        }
      }
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitGradedAssignmentMutation extends Apollo.Mutation<SubmitGradedAssignmentMutationResult, SubmitGradedAssignmentMutationVariables> {
    document = SubmitGradedAssignmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseItemDocument = gql`
    mutation UpdateCourseItem($input: UpdateCourseItemInput!) {
  updateCourseItem(input: $input) {
    courseItem {
      ...CourseItemParts
    }
  }
}
    ${CourseItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseItemMutation extends Apollo.Mutation<UpdateCourseItemMutationResult, UpdateCourseItemMutationVariables> {
    document = UpdateCourseItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCoursePromptDocument = gql`
    mutation UpdateCoursePrompt($input: UpdateCoursePromptInput!) {
  updateCoursePrompt(input: $input) {
    coursePrompt {
      id
      gid
      minimumTime
      maximumTime
      customFieldCourseRequirements {
        id
        gid
        type
        customFields {
          id
          gid
          ...CustomFieldParts
        }
      }
    }
  }
}
    ${CustomFieldPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCoursePromptMutation extends Apollo.Mutation<UpdateCoursePromptMutationResult, UpdateCoursePromptMutationVariables> {
    document = UpdateCoursePromptDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseDocument = gql`
    mutation UpdateCourse($input: UpdateCourseInput!) {
  updateCourse(input: $input) {
    course {
      ...CourseParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${CoursePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseMutation extends Apollo.Mutation<UpdateCourseMutationResult, UpdateCourseMutationVariables> {
    document = UpdateCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePrerequisiteCourseRequirementDocument = gql`
    mutation UpdatePrerequisiteCourseRequirement($input: UpdatePrerequisiteCourseRequirementInput!) {
  updatePrerequisiteCourseRequirement(input: $input) {
    prerequisiteCourseRequirement {
      id
      gid
      requirementType
      requirementQuantity
      course {
        ...ReloadCourseRequirementsPart
      }
      courses {
        id
        gid
        name
      }
    }
    errors {
      message
    }
  }
}
    ${ReloadCourseRequirementsPartFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePrerequisiteCourseRequirementMutation extends Apollo.Mutation<UpdatePrerequisiteCourseRequirementMutationResult, UpdatePrerequisiteCourseRequirementMutationVariables> {
    document = UpdatePrerequisiteCourseRequirementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ViewCourseAgreementDocument = gql`
    mutation ViewCourseAgreement($input: ViewCourseAgreementInput!) {
  viewCourseAgreement(input: $input) {
    courseUserAgreement {
      id
      gid
      viewedAt
      agreedAt
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ViewCourseAgreementMutation extends Apollo.Mutation<ViewCourseAgreementMutationResult, ViewCourseAgreementMutationVariables> {
    document = ViewCourseAgreementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCustomFieldsDocument = gql`
    query LoadCustomFields {
  customFields {
    all {
      nodes {
        id
        gid
        name
        fieldType
        required
        customFieldOptions {
          id
          gid
          value
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCustomFieldsQuery extends Apollo.Query<LoadCustomFieldsQueryResult, LoadCustomFieldsQueryVariables> {
    document = LoadCustomFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DestroyNodeDocument = gql`
    mutation DestroyNode($id: ID!) {
  destroyNode(input: {id: $id}) {
    ok
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DestroyNodeMutation extends Apollo.Mutation<DestroyNodeMutationResult, DestroyNodeMutationVariables> {
    document = DestroyNodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDiscussionReplyDocument = gql`
    mutation CreateDiscussionReply($input: CreateDiscussionReplyInput!) {
  createDiscussionReply(input: $input) {
    reply {
      ...DiscussionMessageParts
      topic {
        id
        gid
      }
    }
    errors {
      message
    }
  }
}
    ${DiscussionMessagePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDiscussionReplyMutation extends Apollo.Mutation<CreateDiscussionReplyMutationResult, CreateDiscussionReplyMutationVariables> {
    document = CreateDiscussionReplyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDiscussionTopicDocument = gql`
    mutation CreateDiscussionTopic($input: CreateDiscussionTopicInput!) {
  createDiscussionTopic(input: $input) {
    topic {
      ...DiscussionMessageParts
      title
    }
    errors {
      message
    }
  }
}
    ${DiscussionMessagePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDiscussionTopicMutation extends Apollo.Mutation<CreateDiscussionTopicMutationResult, CreateDiscussionTopicMutationVariables> {
    document = CreateDiscussionTopicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadGraderInboxMessagesDocument = gql`
    query LoadGraderInboxMessages($createdAfter: ISO8601DateTime, $previewLength: Int) {
  discussionMessages {
    graderInbox(createdAfter: $createdAfter) {
      nodes {
        id
        gid
        createdAt
        updatedAt
        preview(length: $previewLength)
        title
        topic {
          id
          gid
          title
        }
        discussable {
          id
          gid
          ... on CourseItemProgression {
            latestGradedAssignmentSubmission {
              id
              gid
            }
          }
        }
        author {
          id
          gid
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadGraderInboxMessagesQuery extends Apollo.Query<LoadGraderInboxMessagesQueryResult, LoadGraderInboxMessagesQueryVariables> {
    document = LoadGraderInboxMessagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadRepliesForTopicDocument = gql`
    query LoadRepliesForTopic($topicId: ID!, $query: String) {
  discussionMessages {
    replies(topicId: $topicId, query: $query) {
      nodes {
        ...DiscussionMessageParts
        topic {
          id
          gid
        }
      }
    }
  }
}
    ${DiscussionMessagePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadRepliesForTopicQuery extends Apollo.Query<LoadRepliesForTopicQueryResult, LoadRepliesForTopicQueryVariables> {
    document = LoadRepliesForTopicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadTopicsForDiscussableDocument = gql`
    query LoadTopicsForDiscussable($discussableId: ID!, $query: String) {
  discussionMessages {
    all(discussableId: $discussableId, query: $query) {
      nodes {
        ...DiscussionMessageParts
        title
      }
    }
  }
}
    ${DiscussionMessagePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadTopicsForDiscussableQuery extends Apollo.Query<LoadTopicsForDiscussableQueryResult, LoadTopicsForDiscussableQueryVariables> {
    document = LoadTopicsForDiscussableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEnrolmentKeyDocument = gql`
    mutation CreateEnrolmentKey($input: CreateEnrolmentKeyInput!) {
  createEnrolmentKey(input: $input) {
    errors {
      message
    }
    enrolmentKey {
      ...EnrolmentKeyParts
    }
    license {
      ... on License {
        id
        gid
      }
      ... on LicenseGroup {
        gid
      }
    }
  }
}
    ${EnrolmentKeyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEnrolmentKeyMutation extends Apollo.Mutation<CreateEnrolmentKeyMutationResult, CreateEnrolmentKeyMutationVariables> {
    document = CreateEnrolmentKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeactivateEnrolmentKeyDocument = gql`
    mutation DeactivateEnrolmentKey($input: DestroyNodeInput!) {
  destroyNode(input: $input) {
    ok
    node {
      ... on EnrolmentKey {
        ...EnrolmentKeyParts
      }
    }
  }
}
    ${EnrolmentKeyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeactivateEnrolmentKeyMutation extends Apollo.Mutation<DeactivateEnrolmentKeyMutationResult, DeactivateEnrolmentKeyMutationVariables> {
    document = DeactivateEnrolmentKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReactivateEnrolmentKeyDocument = gql`
    mutation ReactivateEnrolmentKey($input: RestoreNodeInput!) {
  restoreNode(input: $input) {
    ok
    node {
      ... on EnrolmentKey {
        ...EnrolmentKeyParts
      }
    }
  }
}
    ${EnrolmentKeyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReactivateEnrolmentKeyMutation extends Apollo.Mutation<ReactivateEnrolmentKeyMutationResult, ReactivateEnrolmentKeyMutationVariables> {
    document = ReactivateEnrolmentKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEnrolmentKeyDocument = gql`
    mutation UpdateEnrolmentKey($input: UpdateEnrolmentKeyInput!) {
  updateEnrolmentKey(input: $input) {
    errors {
      message
    }
    enrolmentKey {
      ...EnrolmentKeyParts
    }
  }
}
    ${EnrolmentKeyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEnrolmentKeyMutation extends Apollo.Mutation<UpdateEnrolmentKeyMutationResult, UpdateEnrolmentKeyMutationVariables> {
    document = UpdateEnrolmentKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNitoBankDocument = gql`
    mutation CreateNitoBank($input: CreateNitoBankInput!) {
  createNitoBank(input: $input) {
    bank {
      id
      gid
      name
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNitoBankMutation extends Apollo.Mutation<CreateNitoBankMutationResult, CreateNitoBankMutationVariables> {
    document = CreateNitoBankDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNitoExamDocument = gql`
    mutation CreateNitoExam($input: CreateNitoExamInput!) {
  createNitoExam(input: $input) {
    exam {
      id
      gid
      name
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNitoExamMutation extends Apollo.Mutation<CreateNitoExamMutationResult, CreateNitoExamMutationVariables> {
    document = CreateNitoExamDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditNitoBanksDocument = gql`
    mutation EditNitoBanks($input: EditNitoBanksInput!) {
  editNitoBanks(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditNitoBanksMutation extends Apollo.Mutation<EditNitoBanksMutationResult, EditNitoBanksMutationVariables> {
    document = EditNitoBanksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditNitoExamsDocument = gql`
    mutation EditNitoExams($input: EditNitoExamsInput!) {
  editNitoExams(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditNitoExamsMutation extends Apollo.Mutation<EditNitoExamsMutationResult, EditNitoExamsMutationVariables> {
    document = EditNitoExamsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadBanksListDocument = gql`
    query LoadBanksList($organizationIds: [ID!]) {
  nitoBanks {
    all(organizationIds: $organizationIds) {
      nodes {
        id
        gid
        name
        owner {
          id
          gid
          name
        }
        rules {
          numberOfItems
          formName
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadBanksListQuery extends Apollo.Query<LoadBanksListQueryResult, LoadBanksListQueryVariables> {
    document = LoadBanksListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadExamsListDocument = gql`
    query LoadExamsList($organizationIds: [ID!]) {
  nitoExams {
    all(organizationIds: $organizationIds) {
      nodes {
        id
        gid
        name
        owner {
          id
          gid
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadExamsListQuery extends Apollo.Query<LoadExamsListQueryResult, LoadExamsListQueryVariables> {
    document = LoadExamsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshNitoRecordsDocument = gql`
    query RefreshNitoRecords($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on NitoExam {
      id
      gid
      name
    }
    ... on NitoBank {
      id
      gid
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshNitoRecordsQuery extends Apollo.Query<RefreshNitoRecordsQueryResult, RefreshNitoRecordsQueryVariables> {
    document = RefreshNitoRecordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FeatureEnabledDocument = gql`
    query FeatureEnabled($name: String!) {
  featureEnabled(name: $name)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FeatureEnabledQuery extends Apollo.Query<FeatureEnabledQueryResult, FeatureEnabledQueryVariables> {
    document = FeatureEnabledDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadGradedAssignmentSubmissionDetailsDocument = gql`
    query LoadGradedAssignmentSubmissionDetails($id: Int!) {
  gradedAssignmentSubmissions {
    findById(id: $id) {
      id
      gid
      passedAt
      failedAt
      updatedAt
      createdAt
      points
      file {
        url
        contentType
        path
      }
      courseItemProgression {
        id
        gid
        name
        gradedAssignmentSettings {
          id
          gid
          maxPoints
          passingGrade
        }
        courseProgression {
          id
          gid
          course {
            id
            gid
            name
          }
          completedAt
          user {
            id
            gid
            fullName
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadGradedAssignmentSubmissionDetailsQuery extends Apollo.Query<LoadGradedAssignmentSubmissionDetailsQueryResult, LoadGradedAssignmentSubmissionDetailsQueryVariables> {
    document = LoadGradedAssignmentSubmissionDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadGradedAssignmentSubmissionsListDocument = gql`
    query LoadGradedAssignmentSubmissionsList($ungraded: Boolean) {
  gradedAssignmentSubmissions {
    all(ungraded: $ungraded) {
      nodes {
        id
        gid
        createdAt
        updatedAt
        passedAt
        failedAt
        points
        file {
          url
          contentType
        }
        courseItemProgression {
          id
          gid
          name
          gradedAssignmentSettings {
            id
            gid
            maxPoints
            passingGrade
          }
          courseProgression {
            id
            gid
            course {
              id
              gid
              name
            }
            completedAt
            user {
              id
              gid
              fullName
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadGradedAssignmentSubmissionsListQuery extends Apollo.Query<LoadGradedAssignmentSubmissionsListQueryResult, LoadGradedAssignmentSubmissionsListQueryVariables> {
    document = LoadGradedAssignmentSubmissionsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateGradedAssignmentSubmissionDocument = gql`
    mutation UpdateGradedAssignmentSubmission($input: UpdateGradedAssignmentSubmissionInput!) {
  updateGradedAssignmentSubmission(input: $input) {
    gradedAssignmentSubmission {
      id
      gid
      passedAt
      failedAt
      points
      updatedAt
      file {
        url
      }
      courseItemProgression {
        id
        gid
        name
        gradedAssignmentSettings {
          id
          gid
          maxPoints
          passingGrade
        }
        courseProgression {
          id
          gid
          course {
            id
            gid
            name
          }
          completedAt
          user {
            id
            gid
            fullName
          }
        }
      }
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateGradedAssignmentSubmissionMutation extends Apollo.Mutation<UpdateGradedAssignmentSubmissionMutationResult, UpdateGradedAssignmentSubmissionMutationVariables> {
    document = UpdateGradedAssignmentSubmissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateGraderDocument = gql`
    mutation CreateGrader($input: CreateGraderInput!) {
  createGrader(input: $input) {
    grader {
      id
      gid
      firstName
      lastName
      email
      status
      organization {
        id
        gid
      }
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateGraderMutation extends Apollo.Mutation<CreateGraderMutationResult, CreateGraderMutationVariables> {
    document = CreateGraderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadGradersDocument = gql`
    query LoadGraders {
  graders {
    all {
      nodes {
        id
        gid
        firstName
        lastName
        email
        status
        organization {
          id
          gid
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadGradersQuery extends Apollo.Query<LoadGradersQueryResult, LoadGradersQueryVariables> {
    document = LoadGradersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GrantCourseViaSubscriptionDocument = gql`
    mutation GrantCourseViaSubscription($input: GrantCourseViaSubscriptionInput!) {
  grantCourseViaSubscription(input: $input) {
    grant {
      ...GrantParts
    }
    accessSubscription {
      id
      gid
      grants {
        nodes {
          id
          gid
          status
          archived
          can {
            id
            gid
            archive
            unarchive
          }
          course {
            id
            gid
          }
        }
      }
    }
  }
}
    ${GrantPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GrantCourseViaSubscriptionMutation extends Apollo.Mutation<GrantCourseViaSubscriptionMutationResult, GrantCourseViaSubscriptionMutationVariables> {
    document = GrantCourseViaSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCourseForGrantDocument = gql`
    query LoadCourseForGrant($grantId: Int!, $includeDetails: Boolean!) {
  grants {
    findById(id: $grantId) {
      course {
        id
        gid
        name
        ...CourseParts @include(if: $includeDetails)
      }
    }
  }
}
    ${CoursePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCourseForGrantQuery extends Apollo.Query<LoadCourseForGrantQueryResult, LoadCourseForGrantQueryVariables> {
    document = LoadCourseForGrantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StartCourseDocument = gql`
    mutation StartCourse($input: StartCourseInput!, $url: String!) {
  startCourse(input: $input) {
    grant {
      id
      gid
      presence {
        channel
        token
        clientId
        uuid
      }
      channelData {
        channel
        token
        clientId
      }
      learnerVerifiedSession(url: $url) {
        id
        gid
        resume
        token
        client
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StartCourseMutation extends Apollo.Mutation<StartCourseMutationResult, StartCourseMutationVariables> {
    document = StartCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddIlCourseToCourseDocument = gql`
    mutation AddILCourseToCourse($input: AddILCourseToCourseInput!) {
  addIlCourseToCourse(input: $input) {
    course {
      id
      gid
      courseItems {
        ...CourseItemParts
      }
    }
    errors {
      message
    }
  }
}
    ${CourseItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddIlCourseToCourseMutation extends Apollo.Mutation<AddIlCourseToCourseMutationResult, AddIlCourseToCourseMutationVariables> {
    document = AddIlCourseToCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelIlBookingDocument = gql`
    mutation CancelILBooking($input: CancelILBookingInput!) {
  cancelIlBooking(input: $input) {
    ilBooking {
      id
      gid
      courseItemProgression {
        id
        gid
      }
      ilClass {
        id
        gid
      }
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelIlBookingMutation extends Apollo.Mutation<CancelIlBookingMutationResult, CancelIlBookingMutationVariables> {
    document = CancelIlBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIlBookingForUserDocument = gql`
    mutation CreateILBookingForUser($input: CreateILBookingForUserInput!) {
  createIlBookingForUser(input: $input) {
    errors {
      message
    }
    ilBooking {
      ...ILBookingWithDetailsParts
    }
  }
}
    ${IlBookingWithDetailsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIlBookingForUserMutation extends Apollo.Mutation<CreateIlBookingForUserMutationResult, CreateIlBookingForUserMutationVariables> {
    document = CreateIlBookingForUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIlBookingDocument = gql`
    mutation CreateILBooking($input: CreateILBookingInput!) {
  createIlBooking(input: $input) {
    ilBooking {
      id
      gid
      ilClass {
        id
        gid
        status
      }
      courseItemProgression {
        id
        gid
        ilBooking {
          id
          gid
          ilClass {
            id
            gid
            status
            ilSessions {
              id
              gid
              startsAt
              endsAt
              timeZone
            }
          }
        }
      }
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIlBookingMutation extends Apollo.Mutation<CreateIlBookingMutationResult, CreateIlBookingMutationVariables> {
    document = CreateIlBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIlClassDocument = gql`
    mutation CreateIlClass($input: CreateILClassInput!) {
  createIlClass(input: $input) {
    ilClass {
      ...ILClassParts
      can {
        id
        gid
        adjustMarks
        overrideFailedMark
        update
      }
      ilCourse {
        id
        gid
        name
      }
      ilSessions {
        ...ILSessionParts
      }
      instructors {
        id
        gid
        firstName
        lastName
        email
      }
    }
    errors {
      message
    }
    recurrences {
      id
      gid
      status
      access
      availableSeats
      rrule
      maxCapacity
      numberOfBookings
      isFirstRecurrence
      firstRecurrence {
        id
        gid
        rrule
        isFirstRecurrence
      }
      can {
        id
        gid
        adjustMarks
        overrideFailedMark
        update
      }
      ilCourse {
        id
        gid
        name
      }
      ilSessions {
        id
        gid
        startsAt
        endsAt
        timeZone
        ilLocation {
          id
          gid
          name
          type
          ... on ILOnlineLocation {
            createdAt
            url
          }
          ... on ILPhysicalLocation {
            createdAt
            address {
              ...AddressParts
            }
          }
        }
      }
      instructors {
        id
        gid
        firstName
        lastName
        email
      }
    }
  }
}
    ${IlClassPartsFragmentDoc}
${IlSessionPartsFragmentDoc}
${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIlClassMutation extends Apollo.Mutation<CreateIlClassMutationResult, CreateIlClassMutationVariables> {
    document = CreateIlClassDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIlCourseItemDocument = gql`
    mutation CreateILCourseItem($input: CreateILCourseItemInput!) {
  createIlCourseItem(input: $input) {
    errors {
      message
    }
    ilCourseItem {
      id
      gid
      name
      trackGrade
      trackAttendance
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIlCourseItemMutation extends Apollo.Mutation<CreateIlCourseItemMutationResult, CreateIlCourseItemMutationVariables> {
    document = CreateIlCourseItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIlCourseDocument = gql`
    mutation CreateILCourse($input: CreateILCourseInput!) {
  createIlCourse(input: $input) {
    ilCourse {
      id
      gid
      name
      ilCourseItems {
        ...ILCourseItemParts
      }
      can {
        id
        gid
        destroy
      }
      owner {
        id
        gid
      }
      ...ILCourseParts
    }
    errors {
      message
    }
  }
}
    ${IlCourseItemPartsFragmentDoc}
${IlCoursePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIlCourseMutation extends Apollo.Mutation<CreateIlCourseMutationResult, CreateIlCourseMutationVariables> {
    document = CreateIlCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIlLocationDocument = gql`
    mutation CreateILLocation($input: CreateILLocationInput!) {
  createIlLocation(input: $input) {
    ilLocation {
      id
      gid
      name
      type
      owner {
        id
        gid
        name
      }
      ... on ILOnlineLocation {
        createdAt
        url
      }
      ... on ILPhysicalLocation {
        createdAt
        address {
          ...AddressParts
        }
      }
    }
    errors {
      message
    }
  }
}
    ${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIlLocationMutation extends Apollo.Mutation<CreateIlLocationMutationResult, CreateIlLocationMutationVariables> {
    document = CreateIlLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIlSessionDocument = gql`
    mutation CreateILSession($input: CreateILSessionInput!) {
  createIlSession(input: $input) {
    ilSession {
      id
      gid
      startsAt
      endsAt
      timeZone
      ilLocation {
        id
        gid
        name
        type
        ... on ILOnlineLocation {
          url
        }
        ... on ILPhysicalLocation {
          address {
            ...AddressParts
          }
        }
      }
    }
    errors {
      message
    }
  }
}
    ${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIlSessionMutation extends Apollo.Mutation<CreateIlSessionMutationResult, CreateIlSessionMutationVariables> {
    document = CreateIlSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInstructorCredentialDocument = gql`
    mutation CreateInstructorCredential($input: CreateInstructorCredentialInput!) {
  createInstructorCredential(input: $input) {
    credential {
      ...InstructorCredentialParts
    }
    errors {
      message
    }
  }
}
    ${InstructorCredentialPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInstructorCredentialMutation extends Apollo.Mutation<CreateInstructorCredentialMutationResult, CreateInstructorCredentialMutationVariables> {
    document = CreateInstructorCredentialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInstructorIlCoursePermissionDocument = gql`
    mutation CreateInstructorILCoursePermission($input: CreateInstructorILCoursePermissionInput!) {
  createInstructorIlCoursePermission(input: $input) {
    instructorIlCoursePermission {
      ...InstructorILCoursePermissionParts
    }
    errors {
      message
    }
  }
}
    ${InstructorIlCoursePermissionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInstructorIlCoursePermissionMutation extends Apollo.Mutation<CreateInstructorIlCoursePermissionMutationResult, CreateInstructorIlCoursePermissionMutationVariables> {
    document = CreateInstructorIlCoursePermissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInstructorDocument = gql`
    mutation CreateInstructor($input: CreateInstructorInput!) {
  createInstructor(input: $input) {
    instructor {
      ...InstructorParts
    }
    errors {
      message
    }
  }
}
    ${InstructorPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInstructorMutation extends Apollo.Mutation<CreateInstructorMutationResult, CreateInstructorMutationVariables> {
    document = CreateInstructorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePendingIlBookingReservationDocument = gql`
    mutation CreatePendingIlBookingReservation($input: CreatePendingILBookingReservationInput!) {
  createPendingIlBookingReservation(input: $input) {
    errors {
      message
    }
    pendingIlBookingReservation {
      ...PendingILBookingReservation
    }
  }
}
    ${PendingIlBookingReservationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePendingIlBookingReservationMutation extends Apollo.Mutation<CreatePendingIlBookingReservationMutationResult, CreatePendingIlBookingReservationMutationVariables> {
    document = CreatePendingIlBookingReservationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForcePromoteIlBookingDocument = gql`
    mutation ForcePromoteILBooking($input: ForcePromoteILBookingInput!) {
  forcePromoteIlBooking(input: $input) {
    ilBooking {
      id
      gid
      status
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForcePromoteIlBookingMutation extends Apollo.Mutation<ForcePromoteIlBookingMutationResult, ForcePromoteIlBookingMutationVariables> {
    document = ForcePromoteIlBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForcePassIlClassResultDocument = gql`
    mutation ForcePassILClassResult($input: ForcePassILClassResultInput!) {
  forcePassIlClassResult(input: $input) {
    ilClassResult {
      id
      gid
      passed
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForcePassIlClassResultMutation extends Apollo.Mutation<ForcePassIlClassResultMutationResult, ForcePassIlClassResultMutationVariables> {
    document = ForcePassIlClassResultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadBookableClassesForIlCourseDocument = gql`
    query LoadBookableClassesForILCourse($ilCourseId: Int!, $reservable: Boolean) {
  ilClasses {
    bookable(ilCourseId: $ilCourseId, reservable: $reservable) {
      nodes {
        id
        gid
        status
        maxCapacity
        availableSeats
        ilBookings {
          nodes {
            id
            gid
            user {
              id
              gid
              fullName
            }
          }
        }
        ilCourse {
          id
          gid
          name
        }
        ilSessions {
          id
          gid
          startsAt
          endsAt
          timeZone
          ilLocation {
            id
            gid
            type
            name
            ... on ILOnlineLocation {
              createdAt
              url
            }
            ... on ILPhysicalLocation {
              createdAt
              address {
                ...AddressParts
              }
            }
          }
        }
        instructors {
          id
          gid
          firstName
          lastName
          email
          status
        }
      }
    }
  }
}
    ${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadBookableClassesForIlCourseQuery extends Apollo.Query<LoadBookableClassesForIlCourseQueryResult, LoadBookableClassesForIlCourseQueryVariables> {
    document = LoadBookableClassesForIlCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIlClassBookingsDocument = gql`
    query LoadILClassBookings($id: Int!, $after: String, $first: Int) {
  ilClasses {
    findById(id: $id) {
      id
      gid
      ilBookings(after: $after, first: $first) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          ...ILBookingWithDetailsParts
        }
      }
    }
  }
}
    ${IlBookingWithDetailsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIlClassBookingsQuery extends Apollo.Query<LoadIlClassBookingsQueryResult, LoadIlClassBookingsQueryVariables> {
    document = LoadIlClassBookingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIlClassDetailsDocument = gql`
    query LoadILClassDetails($id: Int!) {
  ilClasses {
    findById(id: $id) {
      ...ILClassParts
      paths {
        id
        gid
        exportBookedStudents
        exportWaitlistedStudents
        bulkWalletCards
        bulkWallCertificates
      }
      can {
        id
        gid
        adjustMarks
        overrideFailedMark
        update
        updateStatus
        distributeWithoutPurchase
        bookInto
        updateWithRestrictions
      }
      ilCourseItems {
        ...ILCourseItemParts
      }
      ilCourse {
        id
        gid
        name
        owner {
          id
          gid
          name
        }
        ilCourseItems {
          ...ILCourseItemParts
        }
        instructorFiles {
          ...FileParts
        }
        learnerFiles {
          ...FileParts
        }
      }
      instructors {
        id
        gid
        firstName
        lastName
        email
      }
      ilSessions {
        ...ILSessionParts
      }
    }
  }
}
    ${IlClassPartsFragmentDoc}
${IlCourseItemPartsFragmentDoc}
${FilePartsFragmentDoc}
${IlSessionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIlClassDetailsQuery extends Apollo.Query<LoadIlClassDetailsQueryResult, LoadIlClassDetailsQueryVariables> {
    document = LoadIlClassDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIlClassListDocument = gql`
    query LoadILClassList($forTrainingManager: Boolean, $status: [ILClassStatusEnum!]!, $access: [ILClassAccessEnum!], $startsAfter: Date, $endsBefore: Date, $ilCourseIds: [ID!], $instructorIds: [ID!], $organizationIds: [ID!]) {
  ilClasses {
    all(
      forTrainingManager: $forTrainingManager
      status: $status
      access: $access
      startsAfter: $startsAfter
      endsBefore: $endsBefore
      ilCourseIds: $ilCourseIds
      instructorIds: $instructorIds
      organizationIds: $organizationIds
    ) {
      nodes {
        ...ILClassParts
        can {
          id
          gid
          update
        }
        ilCourse {
          id
          gid
          name
          owner {
            id
            gid
            name
          }
        }
        startsAt @client
        ilSessions {
          ...ILSessionParts
        }
        instructors {
          id
          gid
          firstName
          lastName
          email
        }
      }
    }
  }
}
    ${IlClassPartsFragmentDoc}
${IlSessionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIlClassListQuery extends Apollo.Query<LoadIlClassListQueryResult, LoadIlClassListQueryVariables> {
    document = LoadIlClassListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIlClassWaitlistDocument = gql`
    query LoadILClassWaitlist($id: Int!, $after: String, $first: Int) {
  ilClasses {
    findById(id: $id) {
      id
      gid
      waitlist(after: $after, first: $first) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          ...ILBookingWithDetailsParts
        }
      }
    }
  }
}
    ${IlBookingWithDetailsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIlClassWaitlistQuery extends Apollo.Query<LoadIlClassWaitlistQueryResult, LoadIlClassWaitlistQueryVariables> {
    document = LoadIlClassWaitlistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIlCourseDetailsDocument = gql`
    query LoadILCourseDetails($id: Int!) {
  ilCourses {
    findById(id: $id) {
      id
      gid
      name
      instructorFiles {
        bytes
        contentType
        geometry
        path
        signature
        url
      }
      learnerFiles {
        bytes
        contentType
        geometry
        path
        signature
        url
      }
      owner {
        id
        gid
      }
      can {
        id
        gid
        destroy
      }
      ilCourseItems {
        id
        gid
        name
        trackGrade
        trackAttendance
        can {
          id
          gid
          update
          destroy
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIlCourseDetailsQuery extends Apollo.Query<LoadIlCourseDetailsQueryResult, LoadIlCourseDetailsQueryVariables> {
    document = LoadIlCourseDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIlCourseListDocument = gql`
    query LoadIlCourseList($organizationIds: [ID!]) {
  ilCourses {
    all(organizationIds: $organizationIds) {
      nodes {
        ...ILCourseParts
      }
    }
  }
}
    ${IlCoursePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIlCourseListQuery extends Apollo.Query<LoadIlCourseListQueryResult, LoadIlCourseListQueryVariables> {
    document = LoadIlCourseListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIlInstructorClassesDocument = gql`
    query LoadILInstructorClasses($id: Int!) {
  instructors {
    findById(id: $id) {
      id
      gid
      organization {
        id
        gid
        name
      }
      ilClasses {
        nodes {
          id
          gid
          status
          maxCapacity
          numberOfBookings
          access
          ilCourse {
            id
            gid
            name
          }
          ilSessions {
            id
            gid
            startsAt
            endsAt
            timeZone
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIlInstructorClassesQuery extends Apollo.Query<LoadIlInstructorClassesQueryResult, LoadIlInstructorClassesQueryVariables> {
    document = LoadIlInstructorClassesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIlInstructorCredentialsDocument = gql`
    query LoadILInstructorCredentials($id: Int!) {
  instructors {
    findById(id: $id) {
      id
      gid
      credentials {
        nodes {
          ...InstructorCredentialParts
        }
      }
    }
  }
}
    ${InstructorCredentialPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIlInstructorCredentialsQuery extends Apollo.Query<LoadIlInstructorCredentialsQueryResult, LoadIlInstructorCredentialsQueryVariables> {
    document = LoadIlInstructorCredentialsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIlInstructorDetailsDocument = gql`
    query LoadILInstructorDetails($id: Int!) {
  instructors {
    findById(id: $id) {
      ...InstructorParts
    }
  }
}
    ${InstructorPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIlInstructorDetailsQuery extends Apollo.Query<LoadIlInstructorDetailsQueryResult, LoadIlInstructorDetailsQueryVariables> {
    document = LoadIlInstructorDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIlLocationDetailsDocument = gql`
    query LoadILLocationDetails($id: Int!) {
  ilLocations {
    findById(id: $id) {
      id
      gid
      name
      type
      createdAt
      owner {
        id
        name
        gid
      }
      ... on ILOnlineLocation {
        url
      }
      ... on ILPhysicalLocation {
        address {
          ...AddressParts
        }
      }
    }
  }
}
    ${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIlLocationDetailsQuery extends Apollo.Query<LoadIlLocationDetailsQueryResult, LoadIlLocationDetailsQueryVariables> {
    document = LoadIlLocationDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIlLocationsListDocument = gql`
    query LoadIlLocationsList($organizationIds: [ID!], $after: String, $first: Int) {
  ilLocations {
    all(organizationIds: $organizationIds, after: $after, first: $first) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        gid
        name
        type
        owner {
          id
          gid
          name
        }
        ... on ILOnlineLocation {
          createdAt
          url
        }
        ... on ILPhysicalLocation {
          createdAt
          address {
            ...AddressParts
          }
        }
      }
    }
  }
}
    ${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIlLocationsListQuery extends Apollo.Query<LoadIlLocationsListQueryResult, LoadIlLocationsListQueryVariables> {
    document = LoadIlLocationsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadInstructorIlCoursePermissionsDocument = gql`
    query LoadInstructorILCoursePermissions($id: Int!) {
  instructors {
    findById(id: $id) {
      id
      gid
      organization {
        id
        gid
      }
      instructorIlCoursePermissions {
        ...InstructorILCoursePermissionParts
      }
    }
  }
}
    ${InstructorIlCoursePermissionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadInstructorIlCoursePermissionsQuery extends Apollo.Query<LoadInstructorIlCoursePermissionsQueryResult, LoadInstructorIlCoursePermissionsQueryVariables> {
    document = LoadInstructorIlCoursePermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadInstructorsListDocument = gql`
    query LoadInstructorsList($organizationIds: [ID!]) {
  instructors {
    all(organizationIds: $organizationIds) {
      nodes {
        ...InstructorParts
      }
    }
  }
}
    ${InstructorPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadInstructorsListQuery extends Apollo.Query<LoadInstructorsListQueryResult, LoadInstructorsListQueryVariables> {
    document = LoadInstructorsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReorderIlCourseItemsDocument = gql`
    mutation ReorderILCourseItems($input: ReorderILCourseItemsInput!) {
  reorderIlCourseItems(input: $input) {
    errors {
      message
    }
    ilCourseItems {
      id
      gid
      name
      trackGrade
      trackAttendance
      position
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReorderIlCourseItemsMutation extends Apollo.Mutation<ReorderIlCourseItemsMutationResult, ReorderIlCourseItemsMutationVariables> {
    document = ReorderIlCourseItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendInstructorInvitationDocument = gql`
    mutation ResendInstructorInvitation($input: ResendInstructorInvitationInput!) {
  resendInstructorInvitation(input: $input) {
    instructor {
      ...InstructorParts
    }
    errors {
      message
    }
  }
}
    ${InstructorPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendInstructorInvitationMutation extends Apollo.Mutation<ResendInstructorInvitationMutationResult, ResendInstructorInvitationMutationVariables> {
    document = ResendInstructorInvitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateIlClassDocument = gql`
    mutation UpdateILClass($input: UpdateILClassInput!) {
  updateIlClass(input: $input) {
    ilClass {
      ...ILClassParts
      can {
        id
        gid
        adjustMarks
        overrideFailedMark
      }
      ilBookings {
        nodes {
          ...ILBookingWithDetailsParts
        }
      }
      ilCourse {
        id
        gid
        name
        owner {
          id
          gid
          name
        }
        ilCourseItems {
          ...ILCourseItemParts
        }
        instructorFiles {
          ...FileParts
        }
        learnerFiles {
          ...FileParts
        }
      }
      ilCourseItems {
        ...ILCourseItemParts
      }
      instructors {
        id
        gid
        firstName
        lastName
        email
      }
      ilSessions {
        ...ILSessionParts
      }
    }
    errors {
      message
    }
  }
}
    ${IlClassPartsFragmentDoc}
${IlBookingWithDetailsPartsFragmentDoc}
${IlCourseItemPartsFragmentDoc}
${FilePartsFragmentDoc}
${IlSessionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateIlClassMutation extends Apollo.Mutation<UpdateIlClassMutationResult, UpdateIlClassMutationVariables> {
    document = UpdateIlClassDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateIlCourseItemDocument = gql`
    mutation UpdateILCourseItem($input: UpdateILCourseItemInput!) {
  updateIlCourseItem(input: $input) {
    errors {
      message
    }
    ilCourseItem {
      id
      gid
      name
      trackGrade
      trackAttendance
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateIlCourseItemMutation extends Apollo.Mutation<UpdateIlCourseItemMutationResult, UpdateIlCourseItemMutationVariables> {
    document = UpdateIlCourseItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateIlCourseDocument = gql`
    mutation UpdateILCourse($input: UpdateILCourseInput!) {
  updateIlCourse(input: $input) {
    errors {
      message
    }
    ilCourse {
      id
      gid
      name
      owner {
        id
        gid
      }
      can {
        id
        gid
        destroy
      }
      ilCourseItems {
        id
        gid
        name
        trackGrade
        trackAttendance
        position
      }
      instructorFiles {
        bytes
        contentType
        geometry
        path
        signature
        url
      }
      learnerFiles {
        bytes
        contentType
        geometry
        path
        signature
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateIlCourseMutation extends Apollo.Mutation<UpdateIlCourseMutationResult, UpdateIlCourseMutationVariables> {
    document = UpdateIlCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateIlLocationDocument = gql`
    mutation UpdateILLocation($input: UpdateILLocationInput!) {
  updateIlLocation(input: $input) {
    ilLocation {
      id
      gid
      name
      type
      createdAt
      ... on ILOnlineLocation {
        url
      }
      ... on ILPhysicalLocation {
        address {
          ...AddressParts
        }
      }
    }
    errors {
      message
    }
  }
}
    ${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateIlLocationMutation extends Apollo.Mutation<UpdateIlLocationMutationResult, UpdateIlLocationMutationVariables> {
    document = UpdateIlLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInstructorDocument = gql`
    mutation UpdateInstructor($input: UpdateInstructorInput!) {
  updateInstructor(input: $input) {
    instructor {
      ...InstructorParts
    }
    errors {
      message
    }
  }
}
    ${InstructorPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInstructorMutation extends Apollo.Mutation<UpdateInstructorMutationResult, UpdateInstructorMutationVariables> {
    document = UpdateInstructorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMultipleIlClassResultsDocument = gql`
    mutation UpdateMultipleILClassResults($input: UpdateILClassResultsInput!) {
  updateIlClassResults(input: $input) {
    ilClassResults {
      id
      gid
      attendance
      grade
      passed
      ilCourseItem {
        id
        name
        trackAttendance
        trackGrade
      }
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMultipleIlClassResultsMutation extends Apollo.Mutation<UpdateMultipleIlClassResultsMutationResult, UpdateMultipleIlClassResultsMutationVariables> {
    document = UpdateMultipleIlClassResultsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadIlClassRosterLearnerDocument = gql`
    mutation UploadILClassRosterLearner($input: UploadILClassRosterLearnerInput!) {
  uploadIlClassRosterLearner(input: $input) {
    ilClass {
      id
      gid
      availableSeats
    }
    ilBooking {
      ...ILBookingWithDetailsParts
    }
    errors {
      message
    }
  }
}
    ${IlBookingWithDetailsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadIlClassRosterLearnerMutation extends Apollo.Mutation<UploadIlClassRosterLearnerMutationResult, UploadIlClassRosterLearnerMutationVariables> {
    document = UploadIlClassRosterLearnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvalaraSyncProductsDocument = gql`
    mutation AvalaraSyncProducts($input: AvalaraSyncProductsInput!) {
  avalaraSyncProducts(input: $input) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AvalaraSyncProductsMutation extends Apollo.Mutation<AvalaraSyncProductsMutationResult, AvalaraSyncProductsMutationVariables> {
    document = AvalaraSyncProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfigureIntegrationDocument = gql`
    mutation ConfigureIntegration($input: ConfigureIntegrationInput!) {
  configureIntegration(input: $input) {
    integration {
      id
      gid
      type
      integratableGid
      integrationOptions
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfigureIntegrationMutation extends Apollo.Mutation<ConfigureIntegrationMutationResult, ConfigureIntegrationMutationVariables> {
    document = ConfigureIntegrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadIntegrationsDocument = gql`
    query LoadIntegrations($integratableGid: ID!) {
  integrations {
    findByIntegratable(integratableGid: $integratableGid) {
      id
      gid
      type
      integratableGid
      integrationOptions
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadIntegrationsQuery extends Apollo.Query<LoadIntegrationsQueryResult, LoadIntegrationsQueryVariables> {
    document = LoadIntegrationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendInviteDocument = gql`
    mutation ResendInvite($input: ResendInviteInput!) {
  resendInvite(input: $input) {
    invite {
      id
      gid
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendInviteMutation extends Apollo.Mutation<ResendInviteMutationResult, ResendInviteMutationVariables> {
    document = ResendInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadGrantsForReviewDocument = gql`
    query LoadGrantsForReview($filter: ReviewableGrantsFilterEnum!) {
  learnerVerified {
    reviewableGrants(filter: $filter) {
      nodes {
        id
        gid
        learnerVerifiedStatus
        course {
          id
          gid
          name
          photo(geometry: "120x120>") {
            url
          }
        }
        courseProgression {
          id
          gid
          completedAt
        }
        can {
          id
          gid
          overrideLearnerVerifiedStatus
        }
        user {
          id
          gid
          firstName
          lastName
          fullName
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadGrantsForReviewQuery extends Apollo.Query<LoadGrantsForReviewQueryResult, LoadGrantsForReviewQueryVariables> {
    document = LoadGrantsForReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadReviewUrlForGrantDocument = gql`
    mutation LoadReviewUrlForGrant($input: ReviewLearnerVerifiedSessionsInput!) {
  reviewLearnerVerifiedSessions(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadReviewUrlForGrantMutation extends Apollo.Mutation<LoadReviewUrlForGrantMutationResult, LoadReviewUrlForGrantMutationVariables> {
    document = LoadReviewUrlForGrantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverrideLearnerVerifiedStatusDocument = gql`
    mutation OverrideLearnerVerifiedStatus($input: OverrideLearnerVerifiedStatusInput!) {
  overrideLearnerVerifiedStatus(input: $input) {
    grant {
      id
      gid
      learnerVerifiedStatus
      can {
        id
        gid
        overrideLearnerVerifiedStatus
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverrideLearnerVerifiedStatusMutation extends Apollo.Mutation<OverrideLearnerVerifiedStatusMutationResult, OverrideLearnerVerifiedStatusMutationVariables> {
    document = OverrideLearnerVerifiedStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLearnerVerifiedSessionDocument = gql`
    mutation UpdateLearnerVerifiedSession($input: UpdateLearnerVerifiedSessionInput!) {
  updateLearnerVerifiedSession(input: $input) {
    session {
      id
      startedAt
    }
    errors {
      message
      attribute
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLearnerVerifiedSessionMutation extends Apollo.Mutation<UpdateLearnerVerifiedSessionMutationResult, UpdateLearnerVerifiedSessionMutationVariables> {
    document = UpdateLearnerVerifiedSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignTrainingDocument = gql`
    mutation AssignTraining($input: AssignTrainingInput!) {
  assignTraining(input: $input) {
    invite {
      id
      gid
      name
      learner {
        ...LearnerParts
        invites {
          ...InviteParts
        }
      }
    }
    license {
      ...CommonLicenseParts
    }
    errors {
      message
    }
  }
}
    ${LearnerPartsFragmentDoc}
${InvitePartsFragmentDoc}
${CommonLicensePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignTrainingMutation extends Apollo.Mutation<AssignTrainingMutationResult, AssignTrainingMutationVariables> {
    document = AssignTrainingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInviteeDocument = gql`
    mutation CreateInvitee($input: CreateInviteeInput!) {
  createInvitee(input: $input) {
    learner {
      ...LearnerParts
    }
    errors {
      message
    }
  }
}
    ${LearnerPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInviteeMutation extends Apollo.Mutation<CreateInviteeMutationResult, CreateInviteeMutationVariables> {
    document = CreateInviteeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCourseProgressionDocument = gql`
    query LoadCourseProgression($id: Int!) {
  grants {
    findById(id: $id) {
      id
      gid
      status
      certification {
        id
        gid
        badgeUrl
      }
      course {
        id
        gid
        name
        verificationServices
        surveySchema {
          id
          gid
          closeable
        }
        discussionForums
        certificationTemplate {
          id
          gid
          digitalBadgeImage(geometry: "250x250") {
            url
            path
            contentType
            bytes
            signature
          }
        }
      }
      courseUserAgreements {
        id
        gid
        viewedAt
        agreedAt
        courseAgreement {
          id
          gid
          name
          fileUrl
        }
      }
      courseProgression {
        id
        gid
        status
        percentComplete
        ordered
        estimatedCompletionTime
        courseResources {
          name
          url
        }
        courseItemProgressions {
          id
          gid
          name
          type
          status
          completed
          gradedAssignmentSubmissionsClosedAt
          runnable
          openable
          practiceable
          attemptsRemaining
          progress
          reviewable
          courseItem {
            id
            gid
            file {
              url
              contentType
            }
            ilCourse {
              id
              gid
            }
          }
          gradedAssignmentSettings {
            id
            gid
            maxPoints
            passingGrade
          }
          gradedAssignmentSubmissions {
            id
            gid
            createdAt
            passedAt
            failedAt
            points
            file {
              url
            }
          }
          ilBooking {
            id
            gid
            status
            waitlistPosition
            ilClass {
              id
              gid
              status
              ilSessions {
                id
                gid
                startsAt
                endsAt
                timeZone
              }
            }
            ilClassResults {
              id
              gid
              attendance
              passed
              grade
              ilCourseItem {
                id
                gid
                trackAttendance
                trackGrade
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCourseProgressionQuery extends Apollo.Query<LoadCourseProgressionQueryResult, LoadCourseProgressionQueryVariables> {
    document = LoadCourseProgressionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLearnerCertificationsDocument = gql`
    query LoadLearnerCertifications($id: ID!) {
  learners {
    find(id: $id) {
      id
      gid
      certifications {
        ...CertificationParts
      }
    }
  }
}
    ${CertificationPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLearnerCertificationsQuery extends Apollo.Query<LoadLearnerCertificationsQueryResult, LoadLearnerCertificationsQueryVariables> {
    document = LoadLearnerCertificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLearnerDetailsDocument = gql`
    query LoadLearnerDetails($id: ID!) {
  learners {
    find(id: $id) {
      ...LearnerParts
      organizations {
        id
        gid
        name
      }
    }
  }
}
    ${LearnerPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLearnerDetailsQuery extends Apollo.Query<LoadLearnerDetailsQueryResult, LoadLearnerDetailsQueryVariables> {
    document = LoadLearnerDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLearnerGrantDetailsDocument = gql`
    query LoadLearnerGrantDetails($id: ID!) {
  learners {
    find(id: $id) {
      ...LearnerParts
      grants {
        id
        gid
        status
        createdAt
        updatedAt
        can {
          id
          gid
          destroy
        }
        course {
          id
          gid
          name
          photo {
            url
          }
        }
        courseProgression {
          id
          gid
          startedAt
          completedAt
          failedAt
          courseItemProgressions {
            id
            gid
            name
            status
            completed
            progress
            type
            score
            failedAt
            startedAt
            completedAt
            scorm {
              totalSeconds
              interactions {
                correctResponses
                description
                latency
                learnerResponse
                result
                timestamp
                type
              }
            }
            gradedAssignmentSettings {
              id
              gid
              maxPoints
              passingGrade
            }
            can {
              id
              gid
              review
            }
            ilBooking {
              id
              gid
              status
              waitlistPosition
              ilClass {
                id
                gid
                status
                ilSessions {
                  id
                  gid
                  startsAt
                  endsAt
                  timeZone
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${LearnerPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLearnerGrantDetailsQuery extends Apollo.Query<LoadLearnerGrantDetailsQueryResult, LoadLearnerGrantDetailsQueryVariables> {
    document = LoadLearnerGrantDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLearnerInvitesDocument = gql`
    query LoadLearnerInvites($id: ID!) {
  learners {
    find(id: $id) {
      ...LearnerParts
      invites {
        ...InviteParts
      }
    }
  }
}
    ${LearnerPartsFragmentDoc}
${InvitePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLearnerInvitesQuery extends Apollo.Query<LoadLearnerInvitesQueryResult, LoadLearnerInvitesQueryVariables> {
    document = LoadLearnerInvitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLearnerListDocument = gql`
    query LoadLearnerList($after: String, $first: Int, $organizationIds: [ID!], $active: Boolean) {
  learners {
    all(
      after: $after
      first: $first
      organizationIds: $organizationIds
      active: $active
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...LearnerParts
      }
    }
  }
}
    ${LearnerPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLearnerListQuery extends Apollo.Query<LoadLearnerListQueryResult, LoadLearnerListQueryVariables> {
    document = LoadLearnerListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginInviteDocument = gql`
    mutation LoginInvite($input: LoginInviteInput!) {
  loginInvite(input: $input) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginInviteMutation extends Apollo.Mutation<LoginInviteMutationResult, LoginInviteMutationVariables> {
    document = LoginInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShareLearnersDocument = gql`
    mutation ShareLearners($input: ShareLearnersInput!) {
  shareLearners(input: $input) {
    learners {
      ...LearnerParts
      organizations {
        id
        gid
        name
      }
    }
  }
}
    ${LearnerPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShareLearnersMutation extends Apollo.Mutation<ShareLearnersMutationResult, ShareLearnersMutationVariables> {
    document = ShareLearnersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLearnerDocument = gql`
    mutation UpdateLearner($input: UpdateLearnerInput!) {
  updateLearner(input: $input) {
    learner {
      ...LearnerParts
    }
    errors {
      message
    }
  }
}
    ${LearnerPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLearnerMutation extends Apollo.Mutation<UpdateLearnerMutationResult, UpdateLearnerMutationVariables> {
    document = UpdateLearnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLearnersActiveDocument = gql`
    mutation UpdateLearnersActive($input: UpdateLearnersActiveInput!) {
  updateLearnersActive(input: $input) {
    learners {
      id
      gid
      active
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLearnersActiveMutation extends Apollo.Mutation<UpdateLearnersActiveMutationResult, UpdateLearnersActiveMutationVariables> {
    document = UpdateLearnersActiveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UseActivationCodeDocument = gql`
    mutation UseActivationCode($input: UseActivationCodeInput!) {
  useActivationCode(input: $input) {
    user {
      id
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UseActivationCodeMutation extends Apollo.Mutation<UseActivationCodeMutationResult, UseActivationCodeMutationVariables> {
    document = UseActivationCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UseEnrolmentKeyDocument = gql`
    mutation UseEnrolmentKey($input: UseEnrolmentKeyInput!) {
  useEnrolmentKey(input: $input) {
    grant {
      id
      gid
      course {
        id
        name
      }
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UseEnrolmentKeyMutation extends Apollo.Mutation<UseEnrolmentKeyMutationResult, UseEnrolmentKeyMutationVariables> {
    document = UseEnrolmentKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLicenseDocument = gql`
    mutation CreateLicense($input: CreateLicenseInput!) {
  createLicense(input: $input) {
    license {
      ...LicenseParts
    }
    errors {
      message
    }
  }
}
    ${LicensePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLicenseMutation extends Apollo.Mutation<CreateLicenseMutationResult, CreateLicenseMutationVariables> {
    document = CreateLicenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadEnrolmentKeysDocument = gql`
    query LoadEnrolmentKeys($gid: ID!, $withDeleted: Boolean = true, $after: String, $first: Int) {
  node(id: $gid) {
    ... on License {
      id
      gid
      enrolmentKeys(after: $after, first: $first, withDeleted: $withDeleted) {
        ...EnrolmentKeyConnectionParts
      }
    }
    ... on LicenseGroup {
      gid
      enrolmentKeys(after: $after, first: $first, withDeleted: $withDeleted) {
        ...EnrolmentKeyConnectionParts
      }
    }
  }
}
    ${EnrolmentKeyConnectionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadEnrolmentKeysQuery extends Apollo.Query<LoadEnrolmentKeysQueryResult, LoadEnrolmentKeysQueryVariables> {
    document = LoadEnrolmentKeysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLicenseGroupDetailsDocument = gql`
    query LoadLicenseGroupDetails($gid: ID!, $after: String, $first: Int = 100) {
  licenseGroups {
    findByGid(id: $gid) {
      id
      gid
      licenses(after: $after, first: $first) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          ...LicenseParts
        }
      }
    }
  }
}
    ${LicensePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLicenseGroupDetailsQuery extends Apollo.Query<LoadLicenseGroupDetailsQueryResult, LoadLicenseGroupDetailsQueryVariables> {
    document = LoadLicenseGroupDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLicenseGroupListDocument = gql`
    query LoadLicenseGroupList($after: String, $first: Int) {
  licenseGroups {
    all(after: $after, first: $first) {
      pageInfo {
        endCursor
      }
      nodes {
        ...CommonLicenseParts
        course {
          id
          gid
          name
          deprecatedAt
          paths {
            id
            gid
            productUrl
          }
          photo(geometry: "120x120>") {
            url
          }
          courseItems {
            ...CourseItemParts
            ilCourse {
              id
              gid
              name
            }
          }
          owner {
            id
            gid
            name
          }
        }
        owner {
          id
          gid
          name
        }
      }
    }
  }
}
    ${CommonLicensePartsFragmentDoc}
${CourseItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLicenseGroupListQuery extends Apollo.Query<LoadLicenseGroupListQueryResult, LoadLicenseGroupListQueryVariables> {
    document = LoadLicenseGroupListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLicenseInvitesDocument = gql`
    query LoadLicenseInvites($gid: ID!, $after: String, $first: Int) {
  node(id: $gid) {
    ... on License {
      id
      gid
      invites(after: $after, first: $first) {
        ...InviteConnectionParts
      }
    }
    ... on LicenseGroup {
      gid
      invites(after: $after, first: $first) {
        ...InviteConnectionParts
      }
    }
  }
}
    ${InviteConnectionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLicenseInvitesQuery extends Apollo.Query<LoadLicenseInvitesQueryResult, LoadLicenseInvitesQueryVariables> {
    document = LoadLicenseInvitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLicenseOrGroupForDistributionDocument = gql`
    query LoadLicenseOrGroupForDistribution($gid: ID!) {
  node(id: $gid) {
    ... on CommonLicense {
      ...CommonLicenseParts
      course {
        id
        gid
        name
        photo(geometry: "120x120>") {
          url
        }
        courseItems {
          id
          gid
          ilCourse {
            id
            gid
            name
          }
        }
      }
    }
    ... on Ownable {
      owner {
        id
        gid
        name
      }
    }
  }
}
    ${CommonLicensePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLicenseOrGroupForDistributionQuery extends Apollo.Query<LoadLicenseOrGroupForDistributionQueryResult, LoadLicenseOrGroupForDistributionQueryVariables> {
    document = LoadLicenseOrGroupForDistributionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLicenseUsageDocument = gql`
    query LoadLicenseUsage($gid: ID!) {
  node(id: $gid) {
    ... on License {
      id
      gid
      uses {
        ... on Grant {
          ...GrantUsage
        }
        ... on Invite {
          ...InviteUsage
        }
      }
    }
    ... on LicenseGroup {
      gid
      uses {
        ... on Grant {
          ...GrantUsage
        }
        ... on Invite {
          ...InviteUsage
        }
      }
    }
  }
}
    ${GrantUsageFragmentDoc}
${InviteUsageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLicenseUsageQuery extends Apollo.Query<LoadLicenseUsageQueryResult, LoadLicenseUsageQueryVariables> {
    document = LoadLicenseUsageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShareLicenseDocument = gql`
    mutation ShareLicense($input: ShareLicenseInput!) {
  shareLicense(input: $input) {
    sharedLicense {
      ...LicenseParts
    }
    errors {
      message
    }
  }
}
    ${LicensePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShareLicenseMutation extends Apollo.Mutation<ShareLicenseMutationResult, ShareLicenseMutationVariables> {
    document = ShareLicenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TakeCourseDocument = gql`
    mutation TakeCourse($input: TakeCourseInput!) {
  takeCourse(input: $input) {
    grant {
      id
      gid
    }
    license {
      ...CommonLicenseParts
    }
    errors {
      message
    }
  }
}
    ${CommonLicensePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TakeCourseMutation extends Apollo.Mutation<TakeCourseMutationResult, TakeCourseMutationVariables> {
    document = TakeCourseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLicenseDocument = gql`
    mutation UpdateLicense($input: UpdateLicenseInput!) {
  updateLicense(input: $input) {
    license {
      ...LicenseParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${LicensePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLicenseMutation extends Apollo.Mutation<UpdateLicenseMutationResult, UpdateLicenseMutationVariables> {
    document = UpdateLicenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadAttacheOptionsDocument = gql`
    query LoadAttacheOptions {
  attacheOptions {
    uuid
    expiration
    hmac
    uploadUrl
    downloadUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadAttacheOptionsQuery extends Apollo.Query<LoadAttacheOptionsQueryResult, LoadAttacheOptionsQueryVariables> {
    document = LoadAttacheOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCountryListDocument = gql`
    query LoadCountryList {
  countries {
    name
    code
    provinces {
      name
      code
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCountryListQuery extends Apollo.Query<LoadCountryListQueryResult, LoadCountryListQueryVariables> {
    document = LoadCountryListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadFontListDocument = gql`
    query LoadFontList {
  fonts {
    name
    sizes
    cssClass
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadFontListQuery extends Apollo.Query<LoadFontListQueryResult, LoadFontListQueryVariables> {
    document = LoadFontListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStaticPathsListDocument = gql`
    query LoadStaticPathsList {
  staticPaths {
    id
    gid
    path
    helper
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStaticPathsListQuery extends Apollo.Query<LoadStaticPathsListQueryResult, LoadStaticPathsListQueryVariables> {
    document = LoadStaticPathsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadUiDocument = gql`
    query LoadUI {
  automationScripts {
    eventTypes {
      event
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadUiQuery extends Apollo.Query<LoadUiQueryResult, LoadUiQueryVariables> {
    document = LoadUiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOfflineOrderDetailsDocument = gql`
    query LoadOfflineOrderDetails($id: Int!) {
  offlineOrders {
    findById(id: $id) {
      id
      gid
      customerNumber
      purchaseOrderNumber
      salesPersonName
      note
      withoutPayment
      order {
        id
        gid
        createdAt
        subtotalFormatted
        shippingFormatted
        taxFormatted
        totalFormatted
        promotionalSavingsFormatted
        paymentMethod
        user {
          id
          gid
          fullName
        }
        billingAddress {
          id
          address1
          address2
          city
          postalCode
          country {
            name
            code
          }
          province {
            name
            code
          }
        }
        shippingAddress {
          id
          address1
          address2
          city
          postalCode
          country {
            name
            code
          }
          province {
            name
            code
          }
        }
        shippingInformation {
          id
          name
          companyName
          email
          phoneNumber
        }
        orderItems {
          id
          gid
          quantity
          priceFormatted
          totalFormatted
          product {
            id
            gid
            name
            sku
          }
        }
        promoCodeUses {
          id
          gid
          savingsFormatted
          promoCode {
            id
            gid
            description
          }
          orderItem {
            id
            gid
            product {
              id
              gid
              name
            }
            originalProduct {
              priceFormatted
            }
          }
        }
      }
      orderPerson {
        id
        gid
        fullName
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOfflineOrderDetailsQuery extends Apollo.Query<LoadOfflineOrderDetailsQueryResult, LoadOfflineOrderDetailsQueryVariables> {
    document = LoadOfflineOrderDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOfflineOrderListDocument = gql`
    query LoadOfflineOrderList($storefrontId: Int) {
  offlineOrders {
    all(storefrontId: $storefrontId) {
      nodes {
        id
        gid
        order {
          id
          gid
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOfflineOrderListQuery extends Apollo.Query<LoadOfflineOrderListQueryResult, LoadOfflineOrderListQueryVariables> {
    document = LoadOfflineOrderListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRefundDocument = gql`
    mutation CreateRefund($input: CreateRefundInput!) {
  createRefund(input: $input) {
    refund {
      id
      gid
      total
      refundItems {
        id
        gid
        quantity
        amount
      }
    }
    errors {
      message
      attribute
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRefundMutation extends Apollo.Mutation<CreateRefundMutationResult, CreateRefundMutationVariables> {
    document = CreateRefundDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EstimateRefundTaxesDocument = gql`
    query EstimateRefundTaxes($orderId: Int!, $orderItems: [OrderItemPairAttributes!]!, $refundShipping: Boolean!) {
  taxes {
    estimateForRefund(
      orderId: $orderId
      orderItems: $orderItems
      refundShipping: $refundShipping
    ) {
      rate
      description
      amount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EstimateRefundTaxesQuery extends Apollo.Query<EstimateRefundTaxesQueryResult, EstimateRefundTaxesQueryVariables> {
    document = EstimateRefundTaxesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InitiateOfflineOrderDocument = gql`
    mutation InitiateOfflineOrder($input: InitiateOfflineOrderInput!) {
  initiateOfflineOrder(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InitiateOfflineOrderMutation extends Apollo.Mutation<InitiateOfflineOrderMutationResult, InitiateOfflineOrderMutationVariables> {
    document = InitiateOfflineOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOrderDetailsDocument = gql`
    query LoadOrderDetails($id: Int!) {
  orders {
    findById(id: $id) {
      id
      gid
      createdAt
      paymentMethod
      can {
        id
        gid
        refund
      }
      user {
        id
        gid
        fullName
        certificationDefault {
          id
          gid
          name
        }
      }
      refundedAmount
      refundedAmountFormatted
      refundableAmount
      refundableAmountFormatted
      subtotalFormatted
      shippingFormatted
      tax
      taxFormatted
      currency {
        ...CurrencyParts
      }
      taxItems {
        ...TaxItemParts
      }
      total
      totalFormatted
      promotionalSavingsFormatted
      billingAddress {
        id
        address1
        address2
        city
        postalCode
        country {
          name
          code
        }
        province {
          name
          code
        }
      }
      shipping
      shippingAddress {
        ...AddressParts
      }
      shippingInformation {
        id
        name
        companyName
        email
        phoneNumber
      }
      shippingItems {
        id
        gid
        kind
        amount
        taxItems {
          ...TaxItemParts
        }
      }
      orderItems {
        id
        gid
        product {
          id
          gid
          name
          sku
          price
          brand
        }
        quantity
        price
        total
        priceFormatted
        totalFormatted
        promotionalSavings
        promotionalSavingsFormatted
        refundableAmount
        refundableQuantity
        requiresShipping
        promoCode {
          id
          gid
          code
          value
          type
        }
        can {
          id
          gid
          refund
        }
      }
      promoCodeUses {
        id
        gid
        promoCode {
          id
          gid
          description
          code
        }
        orderItem {
          id
          gid
          product {
            id
            gid
            name
            brand
            sku
            price
          }
          originalProduct {
            priceFormatted
          }
        }
        savingsFormatted
      }
      storefront {
        id
        gid
        name
        email
        phoneNumber
        businessNumber
        address {
          ...AddressParts
        }
      }
      ...RefundsParts
      usedLicenses {
        id
        gid
        course {
          id
          gid
          name
        }
        uses {
          ... on Grant {
            id
            gid
            status
            consumersLastActivity
            grantableType
            can {
              id
              gid
              destroy
            }
            courseProgression {
              id
              gid
              percentComplete
            }
            user {
              id
              gid
              fullName
            }
          }
          ... on Invite {
            id
            gid
            consumersLastActivity
            can {
              id
              gid
              destroy
            }
            learner {
              id
              gid
              fullName
            }
          }
        }
      }
    }
  }
}
    ${CurrencyPartsFragmentDoc}
${TaxItemPartsFragmentDoc}
${AddressPartsFragmentDoc}
${RefundsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOrderDetailsQuery extends Apollo.Query<LoadOrderDetailsQueryResult, LoadOrderDetailsQueryVariables> {
    document = LoadOrderDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontOrdersDocument = gql`
    query LoadStorefrontOrders($id: Int!) {
  storefronts {
    findById(id: $id) {
      id
      gid
      name
      orders {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          gid
          createdAt
          shipping
          subtotal
          tax
          total
          totalFormatted
          refundedAmount
          refundedAmountFormatted
          currency {
            ...CurrencyParts
          }
          user {
            id
            gid
            email
            name
          }
          can {
            id
            gid
            refund
          }
          orderItems {
            id
            gid
            quantity
            price
            total
            refundableQuantity
            refundableAmount
            can {
              id
              gid
              refund
            }
            product {
              id
              gid
              name
              price
            }
            refundItems {
              id
              gid
              quantity
              amount
            }
          }
          refunds {
            id
            gid
            total
            refundItems {
              id
              gid
              quantity
              amount
            }
          }
          stripeRefunds {
            id
            gid
            amount
            stripeChargeId
            stripeRefundId
            createdAt
          }
          taxItems {
            id
            gid
            amount
            description
          }
          promoCodeUses {
            id
            gid
            savings
            promoCode {
              id
              gid
              type
              code
            }
          }
        }
      }
    }
  }
}
    ${CurrencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontOrdersQuery extends Apollo.Query<LoadStorefrontOrdersQueryResult, LoadStorefrontOrdersQueryVariables> {
    document = LoadStorefrontOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadUserOrdersDocument = gql`
    query LoadUserOrders {
  orders {
    mine {
      nodes {
        id
        gid
        total
        totalFormatted
        tax
        taxFormatted
        shipping
        shippingFormatted
        refundedAmount
        refundedAmountFormatted
        refundableAmount
        refundableAmountFormatted
        createdAt
        orderItems {
          id
          gid
          product {
            id
            gid
            name
            sku
            photo(geometry: "150x150") {
              url
            }
          }
          promoCode {
            id
            gid
            code
            value
            type
          }
          price
          priceFormatted
          quantity
          totalFormatted
        }
        ...RefundsParts
        user {
          id
          gid
          fullName
        }
      }
    }
  }
}
    ${RefundsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadUserOrdersQuery extends Apollo.Query<LoadUserOrdersQueryResult, LoadUserOrdersQueryVariables> {
    document = LoadUserOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAutomationConstantDocument = gql`
    mutation CreateAutomationConstant($input: CreateAutomationConstantInput!) {
  createAutomationConstant(input: $input) {
    constant {
      id
      gid
      name
      value
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAutomationConstantMutation extends Apollo.Mutation<CreateAutomationConstantMutationResult, CreateAutomationConstantMutationVariables> {
    document = CreateAutomationConstantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAutomationScriptDocument = gql`
    mutation CreateAutomationScript($input: CreateAutomationScriptInput!) {
  createAutomationScript(input: $input) {
    script {
      ...AutomationScriptParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${AutomationScriptPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAutomationScriptMutation extends Apollo.Mutation<CreateAutomationScriptMutationResult, CreateAutomationScriptMutationVariables> {
    document = CreateAutomationScriptDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadAutomationScriptDetailsDocument = gql`
    query LoadAutomationScriptDetails($id: Int!) {
  automationScripts {
    findById(id: $id) {
      ...AutomationScriptParts
    }
  }
}
    ${AutomationScriptPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadAutomationScriptDetailsQuery extends Apollo.Query<LoadAutomationScriptDetailsQueryResult, LoadAutomationScriptDetailsQueryVariables> {
    document = LoadAutomationScriptDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadAutomationScriptLogsDocument = gql`
    query LoadAutomationScriptLogs($id: Int!) {
  automationScripts {
    findById(id: $id) {
      id
      gid
      title
      automationLogs {
        ...AutomationLogParts
        childLogs {
          ...AutomationLogParts
        }
      }
    }
  }
}
    ${AutomationLogPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadAutomationScriptLogsQuery extends Apollo.Query<LoadAutomationScriptLogsQueryResult, LoadAutomationScriptLogsQueryVariables> {
    document = LoadAutomationScriptLogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOrganizationAutomationDocument = gql`
    query LoadOrganizationAutomation($id: Int!) {
  organizations {
    findById(id: $id) {
      id
      gid
      name
      automationScripts {
        ...AutomationScriptParts
      }
      automationConstants {
        id
        gid
        name
        secret
        value
      }
    }
  }
}
    ${AutomationScriptPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOrganizationAutomationQuery extends Apollo.Query<LoadOrganizationAutomationQueryResult, LoadOrganizationAutomationQueryVariables> {
    document = LoadOrganizationAutomationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAutomationConstantDocument = gql`
    mutation UpdateAutomationConstant($input: UpdateAutomationConstantInput!) {
  updateAutomationConstant(input: $input) {
    constant {
      id
      gid
      name
      value
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAutomationConstantMutation extends Apollo.Mutation<UpdateAutomationConstantMutationResult, UpdateAutomationConstantMutationVariables> {
    document = UpdateAutomationConstantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAutomationScriptDocument = gql`
    mutation UpdateAutomationScript($input: UpdateAutomationScriptInput!) {
  updateAutomationScript(input: $input) {
    script {
      ...AutomationScriptParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${AutomationScriptPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAutomationScriptMutation extends Apollo.Mutation<UpdateAutomationScriptMutationResult, UpdateAutomationScriptMutationVariables> {
    document = UpdateAutomationScriptDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOidcProviderDocument = gql`
    mutation createOidcProvider($input: CreateOIDCProviderInput!) {
  createOidcProvider(input: $input) {
    oidcProvider {
      ...OIDCProviderParts
    }
    errors {
      message
    }
  }
}
    ${OidcProviderPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOidcProviderMutation extends Apollo.Mutation<CreateOidcProviderMutationResult, CreateOidcProviderMutationVariables> {
    document = CreateOidcProviderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    organization {
      ...OrganizationParts
    }
    errors {
      message
    }
  }
}
    ${OrganizationPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrganizationMutation extends Apollo.Mutation<CreateOrganizationMutationResult, CreateOrganizationMutationVariables> {
    document = CreateOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSamlProviderDocument = gql`
    mutation createSamlProvider($input: CreateSAMLProviderInput!) {
  createSamlProvider(input: $input) {
    samlProvider {
      ...SAMLProviderParts
    }
    errors {
      message
    }
  }
}
    ${SamlProviderPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSamlProviderMutation extends Apollo.Mutation<CreateSamlProviderMutationResult, CreateSamlProviderMutationVariables> {
    document = CreateSamlProviderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteOrganizationMemberDocument = gql`
    mutation InviteOrganizationMember($input: InviteOrganizationMemberInput!) {
  inviteOrganizationMember(input: $input) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteOrganizationMemberMutation extends Apollo.Mutation<InviteOrganizationMemberMutationResult, InviteOrganizationMemberMutationVariables> {
    document = InviteOrganizationMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadInstructorOrganizationListDocument = gql`
    query LoadInstructorOrganizationList($after: String, $first: Int) {
  organizations {
    allForInstructor(after: $after, first: $first) {
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        ...OrganizationParts
      }
    }
  }
}
    ${OrganizationPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadInstructorOrganizationListQuery extends Apollo.Query<LoadInstructorOrganizationListQueryResult, LoadInstructorOrganizationListQueryVariables> {
    document = LoadInstructorOrganizationListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOrganizationDetailsDocument = gql`
    query LoadOrganizationDetails($id: Int!) {
  organizations {
    findById(id: $id) {
      ...OrganizationDetailParts
    }
  }
}
    ${OrganizationDetailPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOrganizationDetailsQuery extends Apollo.Query<LoadOrganizationDetailsQueryResult, LoadOrganizationDetailsQueryVariables> {
    document = LoadOrganizationDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOrganizationListDocument = gql`
    query LoadOrganizationList($after: String, $first: Int) {
  organizations {
    all(after: $after, first: $first) {
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        ...OrganizationParts
      }
    }
  }
}
    ${OrganizationPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOrganizationListQuery extends Apollo.Query<LoadOrganizationListQueryResult, LoadOrganizationListQueryVariables> {
    document = LoadOrganizationListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOrganizationMembershipsDocument = gql`
    query LoadOrganizationMemberships($id: Int!) {
  organizations {
    findById(id: $id) {
      id
      gid
      memberships {
        id
        gid
        user {
          id
          gid
          fullName
          email
          mobileNumber
        }
        can {
          id
          gid
          destroy
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOrganizationMembershipsQuery extends Apollo.Query<LoadOrganizationMembershipsQueryResult, LoadOrganizationMembershipsQueryVariables> {
    document = LoadOrganizationMembershipsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOrganizationPermissionsDocument = gql`
    query LoadOrganizationPermissions($gid: ID!) {
  organizations {
    findByGid(id: $gid) {
      id
      gid
      ...OrganizationPermissionsParts
    }
  }
}
    ${OrganizationPermissionsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOrganizationPermissionsQuery extends Apollo.Query<LoadOrganizationPermissionsQueryResult, LoadOrganizationPermissionsQueryVariables> {
    document = LoadOrganizationPermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOrganizationSsoProvidersDocument = gql`
    query LoadOrganizationSSOProviders($id: Int!) {
  organizations {
    findById(id: $id) {
      id
      gid
      can {
        id
        gid
        manageSso
      }
      samlProviders {
        ...SAMLProviderParts
      }
      oidcProviders {
        ...OIDCProviderParts
      }
    }
  }
}
    ${SamlProviderPartsFragmentDoc}
${OidcProviderPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOrganizationSsoProvidersQuery extends Apollo.Query<LoadOrganizationSsoProvidersQueryResult, LoadOrganizationSsoProvidersQueryVariables> {
    document = LoadOrganizationSsoProvidersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOrganizationStripeDocument = gql`
    query LoadOrganizationStripe($id: Int!) {
  organizations {
    findById(id: $id) {
      id
      gid
      stripeConnectPaths {
        name
        path
        isoCode
      }
      connectedStripeAccounts {
        id
        gid
        stripeUserId
        currency {
          ...CurrencyParts
        }
      }
    }
  }
}
    ${CurrencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOrganizationStripeQuery extends Apollo.Query<LoadOrganizationStripeQueryResult, LoadOrganizationStripeQueryVariables> {
    document = LoadOrganizationStripeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOrganizationWithRevenueDocument = gql`
    query LoadOrganizationWithRevenue($gid: ID!, $currency: String!, $startDate: ISO8601Date, $endDate: ISO8601Date) {
  organizations {
    findByGid(id: $gid) {
      id
      gid
      name
      revenues(currency: $currency, startDate: $startDate, endDate: $endDate) {
        royalties {
          amount
          records {
            nodes {
              ...PayoutRecordParts
            }
          }
        }
        royaltiesTaxes {
          amount
        }
        commissions {
          amount
          records {
            nodes {
              ...PayoutRecordParts
            }
          }
        }
        courseDistribution {
          amount
        }
        platformLicenses {
          amount
        }
        transactionFees {
          amount
        }
        federalTaxes {
          amount
        }
      }
      storefronts(currency: $currency) {
        id
        gid
        name
        currency {
          ...CurrencyParts
        }
        revenues(startDate: $startDate, endDate: $endDate) {
          ...StorefrontRevenueLineOfBusinessTotalAmountPart
        }
      }
    }
  }
}
    ${PayoutRecordPartsFragmentDoc}
${CurrencyPartsFragmentDoc}
${StorefrontRevenueLineOfBusinessTotalAmountPartFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOrganizationWithRevenueQuery extends Apollo.Query<LoadOrganizationWithRevenueQueryResult, LoadOrganizationWithRevenueQueryVariables> {
    document = LoadOrganizationWithRevenueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadOrganizationListWithRevenueDocument = gql`
    query LoadOrganizationListWithRevenue($currency: String!, $startDate: ISO8601Date, $endDate: ISO8601Date) {
  organizations {
    allForTheLedger {
      nodes {
        id
        gid
        name
        wktOwned
        stripeSelfManaged
        revenues(currency: $currency, startDate: $startDate, endDate: $endDate) {
          royalties {
            amount
          }
          royaltiesTaxes {
            amount
          }
          commissions {
            amount
          }
          courseDistribution {
            amount
          }
          platformLicenses {
            amount
          }
          transactionFees {
            amount
          }
          federalTaxes {
            amount
          }
        }
        storefronts(currency: $currency) {
          id
          gid
          name
          revenues(startDate: $startDate, endDate: $endDate) {
            ...StorefrontRevenueLineOfBusinessTotalAmountPart
          }
        }
      }
    }
  }
}
    ${StorefrontRevenueLineOfBusinessTotalAmountPartFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadOrganizationListWithRevenueQuery extends Apollo.Query<LoadOrganizationListWithRevenueQueryResult, LoadOrganizationListWithRevenueQueryVariables> {
    document = LoadOrganizationListWithRevenueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOidcProviderDocument = gql`
    mutation updateOidcProvider($input: UpdateOIDCProviderInput!) {
  updateOidcProvider(input: $input) {
    oidcProvider {
      ...OIDCProviderParts
    }
    errors {
      message
    }
  }
}
    ${OidcProviderPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOidcProviderMutation extends Apollo.Mutation<UpdateOidcProviderMutationResult, UpdateOidcProviderMutationVariables> {
    document = UpdateOidcProviderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    organization {
      ...OrganizationDetailParts
    }
    errors {
      message
    }
  }
}
    ${OrganizationDetailPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrganizationMutation extends Apollo.Mutation<UpdateOrganizationMutationResult, UpdateOrganizationMutationVariables> {
    document = UpdateOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSamlProviderDocument = gql`
    mutation updateSamlProvider($input: UpdateSAMLProviderInput!) {
  updateSamlProvider(input: $input) {
    samlProvider {
      ...SAMLProviderParts
    }
    errors {
      message
    }
  }
}
    ${SamlProviderPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSamlProviderMutation extends Apollo.Mutation<UpdateSamlProviderMutationResult, UpdateSamlProviderMutationVariables> {
    document = UpdateSamlProviderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadProductCatalogDocument = gql`
    query LoadProductCatalog {
  products {
    catalog {
      categories
      products {
        ...ProductParts
        priceWithDiscount
        discount
      }
    }
  }
}
    ${ProductPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadProductCatalogQuery extends Apollo.Query<LoadProductCatalogQueryResult, LoadProductCatalogQueryVariables> {
    document = LoadProductCatalogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadProductDetailsDocument = gql`
    query LoadProductDetails($id: Int!) {
  products {
    findById(id: $id) {
      ...ProductParts
    }
  }
}
    ${ProductPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadProductDetailsQuery extends Apollo.Query<LoadProductDetailsQueryResult, LoadProductDetailsQueryVariables> {
    document = LoadProductDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadProductListDocument = gql`
    query LoadProductList($storefrontId: Int) {
  products {
    all(storefrontId: $storefrontId) {
      ...ProductParts
    }
  }
}
    ${ProductPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadProductListQuery extends Apollo.Query<LoadProductListQueryResult, LoadProductListQueryVariables> {
    document = LoadProductListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRapidqlScheduleDocument = gql`
    mutation CreateRapidqlSchedule($input: CreateRapidqlScheduleInput!) {
  createRapidqlSchedule(input: $input) {
    rapidqlSchedule {
      ...RapidqlScheduleParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${RapidqlSchedulePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRapidqlScheduleMutation extends Apollo.Mutation<CreateRapidqlScheduleMutationResult, CreateRapidqlScheduleMutationVariables> {
    document = CreateRapidqlScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSavedQueryDocument = gql`
    mutation CreateSavedQuery($input: CreateSavedQueryInput!) {
  createSavedQuery(input: $input) {
    savedQuery {
      ...SavedQueryParts
    }
    errors {
      message
    }
  }
}
    ${SavedQueryPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSavedQueryMutation extends Apollo.Mutation<CreateSavedQueryMutationResult, CreateSavedQueryMutationVariables> {
    document = CreateSavedQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindSavedQueryDocument = gql`
    query FindSavedQuery($id: Int!) {
  savedQueries {
    findById(id: $id) {
      ...SavedQueryParts
    }
  }
}
    ${SavedQueryPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FindSavedQueryQuery extends Apollo.Query<FindSavedQueryQueryResult, FindSavedQueryQueryVariables> {
    document = FindSavedQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InitializeOrRefreshRapidQlDocument = gql`
    mutation InitializeOrRefreshRapidQL {
  refreshRapidql(input: {}) {
    ok
  }
  initializeRapidql(input: {}) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InitializeOrRefreshRapidQlMutation extends Apollo.Mutation<InitializeOrRefreshRapidQlMutationResult, InitializeOrRefreshRapidQlMutationVariables> {
    document = InitializeOrRefreshRapidQlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadRapidQlViewsDocument = gql`
    query LoadRapidQlViews {
  rapidql {
    views {
      id
      gid
      name
      createdAt
      updatedAt
      timeToBuild
      timeToIndex
      timeToRefresh
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadRapidQlViewsQuery extends Apollo.Query<LoadRapidQlViewsQueryResult, LoadRapidQlViewsQueryVariables> {
    document = LoadRapidQlViewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadSavedQueriesDocument = gql`
    query LoadSavedQueries($audience: AudienceEnum!) {
  savedQueries {
    all(audience: $audience) {
      nodes {
        ...SavedQueryParts
      }
    }
  }
}
    ${SavedQueryPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadSavedQueriesQuery extends Apollo.Query<LoadSavedQueriesQueryResult, LoadSavedQueriesQueryVariables> {
    document = LoadSavedQueriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRapidqlDocumentationDocument = gql`
    query GetRapidqlDocumentation {
  rapidql {
    documentation {
      name
      comment
      updatedAt
      columns {
        name
        comment
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRapidqlDocumentationQuery extends Apollo.Query<GetRapidqlDocumentationQueryResult, GetRapidqlDocumentationQueryVariables> {
    document = GetRapidqlDocumentationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendReportNowDocument = gql`
    mutation SendReportNow($input: SendReportNowInput!) {
  sendReportNow(input: $input) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendReportNowMutation extends Apollo.Mutation<SendReportNowMutationResult, SendReportNowMutationVariables> {
    document = SendReportNowDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRapidqlScheduleDocument = gql`
    mutation UpdateRapidqlSchedule($input: UpdateRapidqlScheduleInput!) {
  updateRapidqlSchedule(input: $input) {
    rapidqlSchedule {
      ...RapidqlScheduleParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${RapidqlSchedulePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRapidqlScheduleMutation extends Apollo.Mutation<UpdateRapidqlScheduleMutationResult, UpdateRapidqlScheduleMutationVariables> {
    document = UpdateRapidqlScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSavedQueryDocument = gql`
    mutation UpdateSavedQuery($input: UpdateSavedQueryInput!) {
  updateSavedQuery(input: $input) {
    savedQuery {
      ...SavedQueryParts
    }
    errors {
      message
    }
  }
}
    ${SavedQueryPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSavedQueryMutation extends Apollo.Mutation<UpdateSavedQueryMutationResult, UpdateSavedQueryMutationVariables> {
    document = UpdateSavedQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRegulatorSubmissionDocument = gql`
    mutation CreateRegulatorSubmission($input: CreateRegulatorSubmissionInput!) {
  createRegulatorSubmission(input: $input) {
    submission {
      id
      gid
      regulatorReferenceId
      submittedAt
      notes
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRegulatorSubmissionMutation extends Apollo.Mutation<CreateRegulatorSubmissionMutationResult, CreateRegulatorSubmissionMutationVariables> {
    document = CreateRegulatorSubmissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRegulatorSubmissionDocument = gql`
    mutation UpdateRegulatorSubmission($input: UpdateRegulatorSubmissionInput!) {
  updateRegulatorSubmission(input: $input) {
    submission {
      id
      gid
      regulatorReferenceId
      submittedAt
      notes
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRegulatorSubmissionMutation extends Apollo.Mutation<UpdateRegulatorSubmissionMutationResult, UpdateRegulatorSubmissionMutationVariables> {
    document = UpdateRegulatorSubmissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegulatorSubmissionReportDocument = gql`
    query RegulatorSubmissionReport($first: Int, $after: String, $last: Int, $before: String, $completedAfter: Date, $completedBefore: Date, $submittedAfter: Date, $submittedBefore: Date, $includeSubmitted: Boolean, $licenseNumber: String, $regulatorReferenceId: String, $courses: [Int!], $learnerQuery: String) {
  reports {
    regulatorSubmissionReport(
      first: $first
      after: $after
      last: $last
      before: $before
      completedAfter: $completedAfter
      completedBefore: $completedBefore
      submittedAfter: $submittedAfter
      submittedBefore: $submittedBefore
      includeSubmitted: $includeSubmitted
      licenseNumber: $licenseNumber
      regulatorReferenceId: $regulatorReferenceId
      courses: $courses
      learnerQuery: $learnerQuery
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        id
        gid
        course {
          id
          name
        }
        user {
          id
          fullName
        }
        completedAt
        licenseNumber
        regulatorSubmission {
          id
          gid
          regulatorReferenceId
          submittedAt
          notes
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegulatorSubmissionReportQuery extends Apollo.Query<RegulatorSubmissionReportQueryResult, RegulatorSubmissionReportQueryVariables> {
    document = RegulatorSubmissionReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SalesReportDocument = gql`
    query SalesReport($first: Int, $after: String, $last: Int, $before: String, $startDate: Date, $endDate: Date, $courses: [Int!], $storefronts: [ID!], $organizations: [ID!]) {
  reports {
    salesReport(
      first: $first
      after: $after
      last: $last
      before: $before
      startDate: $startDate
      endDate: $endDate
      courses: $courses
      storefrontIds: $storefronts
      organizationIds: $organizations
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        orderId
        refundId
        orderItemId
        orderStripeChargeId
        createdAt
        storefrontName
        lineItem
        sku
        currency {
          ...CurrencyParts
        }
        unitPrice
        prePromoUnitPrice
        quantity
        subtotal
        total
        gst
        pst
        otherTax
        organization {
          id
          gid
          name
        }
        course {
          owner {
            id
            gid
            name
          }
        }
        promoCodeSavings
        promoCode {
          id
          gid
          code
        }
        consumerFullName
        consumerEmail
        consumerPhoneNumber
        billingAddress {
          address1
          address2
          city
          province {
            name
            code
          }
          country {
            name
            code
          }
          postalCode
        }
        shippingAddress {
          address1
          address2
          city
          province {
            name
          }
          country {
            name
          }
          postalCode
        }
        consumerCustomValues {
          id
          gid
          value
          customFieldId
        }
      }
    }
  }
}
    ${CurrencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SalesReportQuery extends Apollo.Query<SalesReportQueryResult, SalesReportQueryVariables> {
    document = SalesReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadSellingDashboardDocument = gql`
    query LoadSellingDashboard($storefrontId: ID!) {
  dashboard {
    selling(storefrontId: $storefrontId) {
      todayAmount
      yesterdayAmount
      thisWeekAmount
      newLearners
      newTrainingManagers
      totalTrainingManagers
      knowledgeBaseUrl
      submitBugUrl
      faqs {
        title
        url
      }
    }
    reports {
      todayRevenueReportId
      yesterdayRevenueReportId
      thisWeekRevenueReportId
      newLearnersReportId
      newTrainingManagersReportId
      totalTrainingManagersReportId
      activeLearnersReportId
      learnerTrainingReportId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadSellingDashboardQuery extends Apollo.Query<LoadSellingDashboardQueryResult, LoadSellingDashboardQueryVariables> {
    document = LoadSellingDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSharedProductDocument = gql`
    mutation CreateSharedProduct($input: CreateSharedProductInput!) {
  createSharedProduct(input: $input) {
    sharedProduct {
      ...SharedProductParts
    }
    errors {
      message
    }
  }
}
    ${SharedProductPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSharedProductMutation extends Apollo.Mutation<CreateSharedProductMutationResult, CreateSharedProductMutationVariables> {
    document = CreateSharedProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadSharedProductsListDocument = gql`
    query LoadSharedProductsList {
  sharedProducts {
    all {
      nodes {
        ...SharedProductParts
      }
    }
  }
}
    ${SharedProductPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadSharedProductsListQuery extends Apollo.Query<LoadSharedProductsListQueryResult, LoadSharedProductsListQueryVariables> {
    document = LoadSharedProductsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSharedProductDocument = gql`
    mutation UpdateSharedProduct($input: UpdateSharedProductInput!) {
  updateSharedProduct(input: $input) {
    sharedProduct {
      ...SharedProductParts
    }
    errors {
      message
    }
  }
}
    ${SharedProductPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSharedProductMutation extends Apollo.Mutation<UpdateSharedProductMutationResult, UpdateSharedProductMutationVariables> {
    document = UpdateSharedProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClaimPromoCodeDocument = gql`
    mutation ClaimPromoCode($input: ClaimPromoCodeInput!) {
  claimPromoCode(input: $input) {
    shoppingCart {
      ...ShoppingCartParts
    }
    errors {
      message
    }
  }
}
    ${ShoppingCartPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClaimPromoCodeMutation extends Apollo.Mutation<ClaimPromoCodeMutationResult, ClaimPromoCodeMutationVariables> {
    document = ClaimPromoCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    shoppingCart {
      ...ShoppingCartParts
    }
    gatewayInfo {
      clientSecret
      status
    }
    order {
      id
      gid
      channelData {
        channel
        token
        clientId
      }
    }
    errors {
      attribute
      message
    }
  }
}
    ${ShoppingCartPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderMutation extends Apollo.Mutation<CreateOrderMutationResult, CreateOrderMutationVariables> {
    document = CreateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadShoppingCartDocument = gql`
    query LoadShoppingCart {
  shoppingCart {
    ...ShoppingCartParts
  }
}
    ${ShoppingCartPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadShoppingCartQuery extends Apollo.Query<LoadShoppingCartQueryResult, LoadShoppingCartQueryVariables> {
    document = LoadShoppingCartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($input: UpdateShoppingCartAddressInput!) {
  updateShoppingCartAddress(input: $input) {
    shoppingCart {
      ...ShoppingCartParts
    }
    errors {
      message
      attribute
    }
  }
}
    ${ShoppingCartPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAddressMutation extends Apollo.Mutation<UpdateAddressMutationResult, UpdateAddressMutationVariables> {
    document = UpdateAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateShippingInformationDocument = gql`
    mutation UpdateShippingInformation($input: UpdateShoppingCartShippingInformationInput!) {
  updateShoppingCartShippingInformation(input: $input) {
    shoppingCart {
      ...ShoppingCartParts
    }
    errors {
      message
      attribute
    }
  }
}
    ${ShoppingCartPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateShippingInformationMutation extends Apollo.Mutation<UpdateShippingInformationMutationResult, UpdateShippingInformationMutationVariables> {
    document = UpdateShippingInformationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomDomainDocument = gql`
    mutation CreateCustomDomain($input: CreateCustomDomainInput!) {
  createCustomDomain(input: $input) {
    customDomain {
      id
      gid
      name
      primaryAt
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomDomainMutation extends Apollo.Mutation<CreateCustomDomainMutationResult, CreateCustomDomainMutationVariables> {
    document = CreateCustomDomainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomDomainDocument = gql`
    mutation UpdateCustomDomain($input: UpdateCustomDomainInput!) {
  updateCustomDomain(input: $input) {
    customDomain {
      id
      gid
      name
      primaryAt
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomDomainMutation extends Apollo.Mutation<UpdateCustomDomainMutationResult, UpdateCustomDomainMutationVariables> {
    document = UpdateCustomDomainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomFieldDocument = gql`
    mutation CreateCustomField($input: CreateCustomFieldInput!) {
  createCustomField(input: $input) {
    customField {
      ...CustomFieldParts
    }
    errors {
      message
    }
  }
}
    ${CustomFieldPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomFieldMutation extends Apollo.Mutation<CreateCustomFieldMutationResult, CreateCustomFieldMutationVariables> {
    document = CreateCustomFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontCustomFieldsDocument = gql`
    query LoadStorefrontCustomFields($id: Int!) {
  storefronts {
    findById(id: $id) {
      id
      gid
      customFields {
        ...CustomFieldParts
      }
    }
  }
}
    ${CustomFieldPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontCustomFieldsQuery extends Apollo.Query<LoadStorefrontCustomFieldsQueryResult, LoadStorefrontCustomFieldsQueryVariables> {
    document = LoadStorefrontCustomFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomFieldDocument = gql`
    mutation UpdateCustomField($input: UpdateCustomFieldInput!) {
  updateCustomField(input: $input) {
    customField {
      ...CustomFieldParts
    }
    errors {
      message
    }
  }
}
    ${CustomFieldPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomFieldMutation extends Apollo.Mutation<UpdateCustomFieldMutationResult, UpdateCustomFieldMutationVariables> {
    document = UpdateCustomFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDownloadableFileDocument = gql`
    mutation CreateDownloadableFile($input: CreateDownloadableFileInput!) {
  createDownloadableFile(input: $input) {
    downloadableFile {
      ...DownloadableFileParts
    }
    errors {
      message
    }
  }
}
    ${DownloadableFilePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDownloadableFileMutation extends Apollo.Mutation<CreateDownloadableFileMutationResult, CreateDownloadableFileMutationVariables> {
    document = CreateDownloadableFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontDownloadableFilesDocument = gql`
    query LoadStorefrontDownloadableFiles($id: Int!) {
  storefronts {
    findById(id: $id) {
      id
      gid
      downloadableFiles {
        ...DownloadableFileParts
      }
    }
  }
}
    ${DownloadableFilePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontDownloadableFilesQuery extends Apollo.Query<LoadStorefrontDownloadableFilesQueryResult, LoadStorefrontDownloadableFilesQueryVariables> {
    document = LoadStorefrontDownloadableFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDownloadableFileDocument = gql`
    mutation UpdateDownloadableFile($input: UpdateDownloadableFileInput!) {
  updateDownloadableFile(input: $input) {
    downloadableFile {
      ...DownloadableFileParts
    }
    errors {
      message
    }
  }
}
    ${DownloadableFilePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDownloadableFileMutation extends Apollo.Mutation<UpdateDownloadableFileMutationResult, UpdateDownloadableFileMutationVariables> {
    document = UpdateDownloadableFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCurrentStorefrontDocument = gql`
    query LoadCurrentStorefront {
  currentStorefront {
    ...StorefrontParts
  }
}
    ${StorefrontPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCurrentStorefrontQuery extends Apollo.Query<LoadCurrentStorefrontQueryResult, LoadCurrentStorefrontQueryVariables> {
    document = LoadCurrentStorefrontDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontActiveContractsDocument = gql`
    query LoadStorefrontActiveContracts($id: ID!, $startDate: ISO8601Date, $endDate: ISO8601Date) {
  storefronts {
    findByGid(id: $id) {
      id
      gid
      name
      activeContracts(startDate: $startDate, endDate: $endDate) {
        id
        gid
        name
        startDate
        endDate
        calculable {
          ... on OneTimeFeeContract {
            id
            gid
            type
            price
            feeType
          }
          ... on RecurringFlatFeeContract {
            id
            gid
            type
            price
            period
          }
          ... on MonthlyActiveUsersRateContract {
            id
            gid
            type
            tierMin
            tierMax
            rate
            flatRate
          }
          ... on MonthlyCourseDistributionRateContract {
            id
            gid
            type
            tierMin
            tierMax
            rate
            flatRate
          }
          ... on StripeTransactionFeeContract {
            id
            gid
            type
            transactionFee
          }
          ... on DynamicContract {
            id
            gid
            type
            logic
          }
          ... on ScormCourseRateContract {
            id
            gid
            type
            courseTitle
            destinationName
            rate
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontActiveContractsQuery extends Apollo.Query<LoadStorefrontActiveContractsQueryResult, LoadStorefrontActiveContractsQueryVariables> {
    document = LoadStorefrontActiveContractsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontDetailsDocument = gql`
    query LoadStorefrontDetails($id: Int!) {
  storefronts {
    findById(id: $id) {
      id
      gid
      name
      url
      currency {
        ...CurrencyParts
      }
      allowMfaTrustedDevices
      can {
        createThemes
        createPages
        createRedirects
        createProducts
        createCustomFields
        uploadFiles
        update
      }
      customDomains {
        id
        gid
        name
        primaryAt
        primary
      }
    }
  }
}
    ${CurrencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontDetailsQuery extends Apollo.Query<LoadStorefrontDetailsQueryResult, LoadStorefrontDetailsQueryVariables> {
    document = LoadStorefrontDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontListDocument = gql`
    query LoadStorefrontList {
  storefronts {
    all {
      id
      gid
      name
      url
      customFields {
        id
        gid
        name
      }
      owner {
        id
        gid
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontListQuery extends Apollo.Query<LoadStorefrontListQueryResult, LoadStorefrontListQueryVariables> {
    document = LoadStorefrontListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontRedirectablesDocument = gql`
    query LoadStorefrontRedirectables($id: Int!) {
  storefronts {
    findById(id: $id) {
      id
      gid
      pages {
        id
        gid
        name
        url
      }
      downloadableFiles {
        id
        gid
        name
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontRedirectablesQuery extends Apollo.Query<LoadStorefrontRedirectablesQueryResult, LoadStorefrontRedirectablesQueryVariables> {
    document = LoadStorefrontRedirectablesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontRevenueListDocument = gql`
    query LoadStorefrontRevenueList($sector: StorefrontSectorsEnum!, $currency: String!, $startDate: ISO8601Date, $endDate: ISO8601Date, $showAll: Boolean, $active: Boolean) {
  storefronts {
    all(sector: $sector, currency: $currency, showAll: $showAll, active: $active) {
      id
      gid
      name
      sector
      ledgerReviewed
      ledgerNotes
      currency {
        ...CurrencyParts
      }
      revenues(startDate: $startDate, endDate: $endDate) {
        startPeriod
        endPeriod
        onlineTraining {
          amount
        }
        ilTraining {
          amount
        }
        physicalProduct {
          amount
        }
        promoCodeSaving {
          amount
        }
        shipping {
          amount
        }
        platformSetup {
          amount
        }
        platformLicenses {
          amount
        }
        subscription {
          amount
        }
        courseDistribution {
          amount
        }
        thirdPartyPayout {
          amount
        }
        refunds {
          amount
        }
        federalTaxes {
          amount
        }
        provincialTaxes {
          amount
        }
      }
    }
  }
}
    ${CurrencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontRevenueListQuery extends Apollo.Query<LoadStorefrontRevenueListQueryResult, LoadStorefrontRevenueListQueryVariables> {
    document = LoadStorefrontRevenueListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontRevenueRecordsDocument = gql`
    query LoadStorefrontRevenueRecords($id: ID!, $startDate: ISO8601Date, $endDate: ISO8601Date, $onlineTraining: Boolean = false, $ilTraining: Boolean = false, $physicalProduct: Boolean = false, $promoCodeSaving: Boolean = false, $shipping: Boolean = false, $platformSetup: Boolean = false, $platformLicenses: Boolean = false, $transactionFees: Boolean = false, $subscription: Boolean = false, $thirdPartyPayout: Boolean = false, $refunds: Boolean = false, $courseDistribution: Boolean = false, $federalTaxes: Boolean = false, $provincialTaxes: Boolean = false) {
  storefronts {
    findByGid(id: $id) {
      id
      gid
      name
      revenues(startDate: $startDate, endDate: $endDate) {
        startPeriod
        endPeriod
        onlineTraining @include(if: $onlineTraining) {
          records {
            nodes {
              ...OrderItemRecordParts
            }
          }
        }
        ilTraining @include(if: $ilTraining) {
          records {
            nodes {
              ...OrderItemRecordParts
            }
          }
        }
        physicalProduct @include(if: $physicalProduct) {
          records {
            nodes {
              ...OrderItemRecordParts
            }
          }
        }
        promoCodeSaving @include(if: $promoCodeSaving) {
          amount
          records {
            nodes {
              ...OrderItemRecordParts
            }
          }
        }
        shipping @include(if: $shipping) {
          amount
          records {
            nodes {
              ...OrderItemRecordParts
            }
          }
        }
        platformSetup @include(if: $platformSetup) {
          records {
            nodes {
              ...ContractRevenueRecordParts
            }
          }
        }
        platformLicenses @include(if: $platformLicenses) {
          records {
            nodes {
              ...ContractRevenueRecordParts
            }
          }
        }
        transactionFees @include(if: $transactionFees) {
          records {
            nodes {
              ...ContractRevenueRecordParts
            }
          }
        }
        subscription @include(if: $subscription) {
          records {
            nodes {
              ...StripeInvoicePaymentRecordParts
            }
          }
        }
        courseDistribution @include(if: $courseDistribution) {
          records {
            nodes {
              ...ContractRevenueRecordParts
            }
          }
        }
        thirdPartyPayout @include(if: $thirdPartyPayout) {
          records {
            nodes {
              ...PayoutRecordParts
            }
          }
        }
        refunds @include(if: $refunds) {
          records {
            nodes {
              ...RefundRecordParts
            }
          }
        }
        federalTaxes @include(if: $federalTaxes) {
          records {
            nodes {
              ...TaxRecordParts
            }
          }
        }
        provincialTaxes @include(if: $provincialTaxes) {
          records {
            nodes {
              ...TaxRecordParts
            }
          }
        }
      }
    }
  }
}
    ${OrderItemRecordPartsFragmentDoc}
${ContractRevenueRecordPartsFragmentDoc}
${StripeInvoicePaymentRecordPartsFragmentDoc}
${PayoutRecordPartsFragmentDoc}
${RefundRecordPartsFragmentDoc}
${TaxRecordPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontRevenueRecordsQuery extends Apollo.Query<LoadStorefrontRevenueRecordsQueryResult, LoadStorefrontRevenueRecordsQueryVariables> {
    document = LoadStorefrontRevenueRecordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontRevenueTotalsDocument = gql`
    query LoadStorefrontRevenueTotals($id: ID!, $startDate: ISO8601Date, $endDate: ISO8601Date) {
  storefronts {
    findByGid(id: $id) {
      id
      gid
      name
      sector
      logoUrl
      url
      ledgerReviewed
      ledgerNotes
      currency {
        ...CurrencyParts
      }
      revenues(startDate: $startDate, endDate: $endDate) {
        ...StorefrontRevenueLineOfBusinessTotalAmountPart
      }
    }
  }
}
    ${CurrencyPartsFragmentDoc}
${StorefrontRevenueLineOfBusinessTotalAmountPartFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontRevenueTotalsQuery extends Apollo.Query<LoadStorefrontRevenueTotalsQueryResult, LoadStorefrontRevenueTotalsQueryVariables> {
    document = LoadStorefrontRevenueTotalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontSettingsDocument = gql`
    query LoadStorefrontSettings($id: Int!) {
  storefronts {
    findById(id: $id) {
      ...SettingsParts
    }
  }
}
    ${SettingsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontSettingsQuery extends Apollo.Query<LoadStorefrontSettingsQueryResult, LoadStorefrontSettingsQueryVariables> {
    document = LoadStorefrontSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontTagFieldsDocument = gql`
    query LoadStorefrontTagFields($scope: TagFieldScopeEnum) {
  currentStorefront {
    id
    gid
    name
    tagFields(scope: $scope) {
      id
      gid
      name
      required
      scope
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontTagFieldsQuery extends Apollo.Query<LoadStorefrontTagFieldsQueryResult, LoadStorefrontTagFieldsQueryVariables> {
    document = LoadStorefrontTagFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMenuItemDocument = gql`
    mutation CreateMenuItem($input: CreateMenuItemInput!) {
  createMenuItem(input: $input) {
    menuItem {
      ...MenuItemParts
    }
    errors {
      message
    }
  }
}
    ${MenuItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMenuItemMutation extends Apollo.Mutation<CreateMenuItemMutationResult, CreateMenuItemMutationVariables> {
    document = CreateMenuItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontMenuItemsDocument = gql`
    query LoadStorefrontMenuItems($id: Int!) {
  storefronts {
    findById(id: $id) {
      id
      gid
      menuItems {
        ...MenuItemParts
      }
    }
  }
}
    ${MenuItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontMenuItemsQuery extends Apollo.Query<LoadStorefrontMenuItemsQueryResult, LoadStorefrontMenuItemsQueryVariables> {
    document = LoadStorefrontMenuItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMenuItemDocument = gql`
    mutation UpdateMenuItem($input: UpdateMenuItemInput!) {
  updateMenuItem(input: $input) {
    menuItem {
      ...MenuItemParts
    }
    errors {
      message
    }
  }
}
    ${MenuItemPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMenuItemMutation extends Apollo.Mutation<UpdateMenuItemMutationResult, UpdateMenuItemMutationVariables> {
    document = UpdateMenuItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePageDocument = gql`
    mutation CreatePage($input: CreatePageInput!) {
  createPage(input: $input) {
    page {
      ...PageParts
    }
    errors {
      message
    }
  }
}
    ${PagePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePageMutation extends Apollo.Mutation<CreatePageMutationResult, CreatePageMutationVariables> {
    document = CreatePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontPagesDocument = gql`
    query LoadStorefrontPages($id: Int!) {
  storefronts {
    findById(id: $id) {
      id
      gid
      pages {
        ...PageParts
      }
    }
  }
}
    ${PagePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontPagesQuery extends Apollo.Query<LoadStorefrontPagesQueryResult, LoadStorefrontPagesQueryVariables> {
    document = LoadStorefrontPagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePageDocument = gql`
    mutation UpdatePage($input: UpdatePageInput!) {
  updatePage(input: $input) {
    page {
      ...PageParts
    }
    errors {
      message
    }
  }
}
    ${PagePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePageMutation extends Apollo.Mutation<UpdatePageMutationResult, UpdatePageMutationVariables> {
    document = UpdatePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProductDocument = gql`
    mutation CreateProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    product {
      ...ProductParts
    }
    errors {
      message
    }
  }
}
    ${ProductPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProductMutation extends Apollo.Mutation<CreateProductMutationResult, CreateProductMutationVariables> {
    document = CreateProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductDocument = gql`
    mutation UpdateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    product {
      ...ProductParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${ProductPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductMutation extends Apollo.Mutation<UpdateProductMutationResult, UpdateProductMutationVariables> {
    document = UpdateProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePromoCodeDocument = gql`
    mutation CreatePromoCode($input: CreatePromoCodeInput!) {
  createPromoCode(input: $input) {
    promoCode {
      ...PromoCodeParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${PromoCodePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePromoCodeMutation extends Apollo.Mutation<CreatePromoCodeMutationResult, CreatePromoCodeMutationVariables> {
    document = CreatePromoCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadPromoCodesListDocument = gql`
    query LoadPromoCodesList($storefrontId: ID!, $after: String, $first: Int) {
  promoCodes {
    all(storefrontId: $storefrontId, after: $after, first: $first) {
      nodes {
        ...PromoCodeParts
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${PromoCodePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadPromoCodesListQuery extends Apollo.Query<LoadPromoCodesListQueryResult, LoadPromoCodesListQueryVariables> {
    document = LoadPromoCodesListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePromoCodeDocument = gql`
    mutation UpdatePromoCode($input: UpdatePromoCodeInput!) {
  updatePromoCode(input: $input) {
    promoCode {
      ...PromoCodeParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${PromoCodePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePromoCodeMutation extends Apollo.Mutation<UpdatePromoCodeMutationResult, UpdatePromoCodeMutationVariables> {
    document = UpdatePromoCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRedirectDocument = gql`
    mutation CreateRedirect($input: CreateRedirectInput!) {
  createRedirect(input: $input) {
    redirect {
      ...RedirectParts
    }
    errors {
      message
    }
  }
}
    ${RedirectPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRedirectMutation extends Apollo.Mutation<CreateRedirectMutationResult, CreateRedirectMutationVariables> {
    document = CreateRedirectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontRedirectsDocument = gql`
    query LoadStorefrontRedirects($id: Int!) {
  storefronts {
    findById(id: $id) {
      id
      gid
      redirects {
        ...RedirectParts
      }
    }
  }
}
    ${RedirectPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontRedirectsQuery extends Apollo.Query<LoadStorefrontRedirectsQueryResult, LoadStorefrontRedirectsQueryVariables> {
    document = LoadStorefrontRedirectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRedirectDocument = gql`
    mutation UpdateRedirect($input: UpdateRedirectInput!) {
  updateRedirect(input: $input) {
    redirect {
      ...RedirectParts
    }
    errors {
      message
    }
  }
}
    ${RedirectPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRedirectMutation extends Apollo.Mutation<UpdateRedirectMutationResult, UpdateRedirectMutationVariables> {
    document = UpdateRedirectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateThemeDocument = gql`
    mutation CreateTheme($input: CreateThemeInput!) {
  createTheme(input: $input) {
    theme {
      ...ThemeParts
    }
    errors {
      message
    }
  }
}
    ${ThemePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateThemeMutation extends Apollo.Mutation<CreateThemeMutationResult, CreateThemeMutationVariables> {
    document = CreateThemeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStorefrontThemesDocument = gql`
    query LoadStorefrontThemes($id: Int!) {
  storefronts {
    findById(id: $id) {
      id
      gid
      themes {
        ...ThemeParts
      }
    }
  }
}
    ${ThemePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStorefrontThemesQuery extends Apollo.Query<LoadStorefrontThemesQueryResult, LoadStorefrontThemesQueryVariables> {
    document = LoadStorefrontThemesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateThemeDocument = gql`
    mutation UpdateTheme($input: UpdateThemeInput!) {
  updateTheme(input: $input) {
    theme {
      ...ThemeParts
    }
    errors {
      message
    }
  }
}
    ${ThemePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateThemeMutation extends Apollo.Mutation<UpdateThemeMutationResult, UpdateThemeMutationVariables> {
    document = UpdateThemeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStorefrontDocument = gql`
    mutation UpdateStorefront($input: UpdateStorefrontInput!) {
  updateStorefront(input: $input) {
    storefront {
      ...SettingsParts
    }
    errors {
      message
    }
  }
}
    ${SettingsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStorefrontMutation extends Apollo.Mutation<UpdateStorefrontMutationResult, UpdateStorefrontMutationVariables> {
    document = UpdateStorefrontDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStripePlansDocument = gql`
    query LoadStripePlans {
  stripePlans {
    all {
      nodes {
        id
        gid
        active
        aggregateUsage
        amount
        amountFormatted
        confirmation
        createdAt
        interval
        intervalCount
        name
        sku
        stripePlanId
        tiersMode
        updatedAt
        usageType
        createdBy {
          id
          gid
          fullName
        }
        currency {
          ...CurrencyParts
        }
        organization {
          id
          gid
          name
        }
        stripeProduct {
          id
          gid
          stripeProductId
        }
        tiers {
          flatAmount
          flatAmountFormatted
          unitAmount
          unitAmountFormatted
          upTo
        }
      }
    }
  }
}
    ${CurrencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStripePlansQuery extends Apollo.Query<LoadStripePlansQueryResult, LoadStripePlansQueryVariables> {
    document = LoadStripePlansDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStripeProductsDocument = gql`
    query LoadStripeProducts {
  stripeProducts {
    all {
      nodes {
        id
        gid
        active
        createdAt
        description
        name
        stripeProductId
        updatedAt
        createdBy {
          id
          gid
          fullName
        }
        currency {
          ...CurrencyParts
        }
        courses {
          id
          gid
          name
          photo {
            url
          }
        }
        stripePlans {
          id
          gid
          active
          aggregateUsage
          amount
          amountFormatted
          confirmation
          createdAt
          interval
          intervalCount
          name
          sku
          stripePlanId
          tiersMode
          updatedAt
          usageType
          createdBy {
            id
            gid
            fullName
          }
          currency {
            ...CurrencyParts
          }
          organization {
            id
            gid
            name
          }
          stripeProduct {
            id
            gid
            stripeProductId
          }
          tiers {
            flatAmount
            flatAmountFormatted
            unitAmount
            unitAmountFormatted
            upTo
          }
        }
      }
    }
  }
}
    ${CurrencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStripeProductsQuery extends Apollo.Query<LoadStripeProductsQueryResult, LoadStripeProductsQueryVariables> {
    document = LoadStripeProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStripeSubscriptionsDocument = gql`
    query LoadStripeSubscriptions {
  stripeSubscriptions {
    mine {
      id
      gid
      stripeSubscriptionId
      stripePlan {
        id
        gid
        name
      }
      accessControlled
      usageControlled
      secondsRemainingInArrears
      status
      stripePaymentMethod {
        card {
          brand
          last4
          expMonth
          expYear
        }
        billingDetails {
          name
          address {
            address1
            address2
            city
            province
            country
            postalCode
          }
        }
      }
      paths {
        id
        gid
        editPaymentMethod
      }
      ... on AccessSubscription {
        courses {
          nodes {
            id
            gid
            name
            photo {
              url
            }
            verificationServices
          }
        }
        grants {
          nodes {
            id
            gid
            status
            archived
            can {
              id
              gid
              archive
              unarchive
            }
            course {
              id
              gid
            }
          }
        }
      }
      ... on UsageSubscription {
        licenses {
          id
          gid
          isOpen @client
          seats
          availableSeats
          grantedSeats
          invitedSeats
          usedSeats
          course {
            id
            gid
            name
            photo {
              url
            }
          }
          createdBy {
            id
            gid
            fullName
          }
          expiresAt
          verificationServices
        }
        createdBy {
          id
          gid
          fullName
        }
        stripeCustomer {
          id
          gid
          owner {
            id
            gid
            fullName
          }
        }
        currentPeriodStart
        currentPeriodEnd
        currentPeriodUsage {
          id
          gid
          badgePreviewUrl
          status
          certification {
            id
            gid
            name
          }
          courseProgression {
            id
            gid
            completedAt
            percentComplete
          }
          course {
            id
            gid
            name
            photo {
              url
            }
          }
          user {
            id
            gid
            sgid
            name
            email
            mobileNumber
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStripeSubscriptionsQuery extends Apollo.Query<LoadStripeSubscriptionsQueryResult, LoadStripeSubscriptionsQueryVariables> {
    document = LoadStripeSubscriptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStripeSubscriptionDocument = gql`
    mutation UpdateStripeSubscription($input: UpdateStripeSubscriptionInput!) {
  updateStripeSubscription(input: $input) {
    success
    stripeSubscription {
      id
      gid
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStripeSubscriptionMutation extends Apollo.Mutation<UpdateStripeSubscriptionMutationResult, UpdateStripeSubscriptionMutationVariables> {
    document = UpdateStripeSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProvideSupportCertificationsDocument = gql`
    query ProvideSupportCertifications($id: Int!) {
  provideSupport(id: $id) {
    id
    certifications {
      nodes {
        id
        gid
        number
        name
        createdAt
        expiresAt
        publicUrl
        walletCardUrl
        wallCertificateUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProvideSupportCertificationsQuery extends Apollo.Query<ProvideSupportCertificationsQueryResult, ProvideSupportCertificationsQueryVariables> {
    document = ProvideSupportCertificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProvideSupportEmailsDocument = gql`
    query ProvideSupportEmails($id: Int!) {
  provideSupport(id: $id) {
    id
    sentEmails {
      nodes {
        id
        status
        emailStatusAt
        subject
        to
        from
        body
        createdAt
        can {
          id
          gid
          show
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProvideSupportEmailsQuery extends Apollo.Query<ProvideSupportEmailsQueryResult, ProvideSupportEmailsQueryVariables> {
    document = ProvideSupportEmailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProvideSupportGrantDetailsDocument = gql`
    query ProvideSupportGrantDetails($id: ID!) {
  node(id: $id) {
    ... on Grant {
      id
      gid
      courseProgression {
        id
        gid
        status
        percentComplete
        createdAt
        completedAt
        courseItemProgressions {
          id
          gid
          name
          createdAt
          completedAt
          status
          progress
          score
          type
          ilBooking {
            id
            gid
            createdAt
            ilClass {
              id
              gid
              status
              can {
                id
                gid
                show
              }
              ilCourse {
                id
                gid
                name
              }
            }
            ilClassResults {
              id
              gid
              attendance
              passed
              grade
            }
          }
          latestGradedAssignmentSubmission {
            id
            gid
            file {
              url
              contentType
            }
            points
            updatedAt
            failedAt
            passedAt
          }
          gradedAssignmentSettings {
            id
            gid
            maxPoints
          }
          scorm {
            totalSeconds
            passed
            interactions {
              correctResponses
              description
              latency
              learnerResponse
              result
              timestamp
              type
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProvideSupportGrantDetailsQuery extends Apollo.Query<ProvideSupportGrantDetailsQueryResult, ProvideSupportGrantDetailsQueryVariables> {
    document = ProvideSupportGrantDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProvideSupportGrantsDocument = gql`
    query ProvideSupportGrants($id: Int!) {
  provideSupport(id: $id) {
    id
    grants {
      nodes {
        id
        gid
        status
        license {
          id
          gid
          course {
            id
            gid
            name
          }
        }
        can {
          id
          gid
          destroy
        }
        courseProgression {
          id
          gid
          startedAt
          completedAt
          failedAt
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProvideSupportGrantsQuery extends Apollo.Query<ProvideSupportGrantsQueryResult, ProvideSupportGrantsQueryVariables> {
    document = ProvideSupportGrantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProvideSupportInvitesDocument = gql`
    query ProvideSupportInvites($id: Int!) {
  provideSupport(id: $id) {
    id
    invites {
      nodes {
        id
        gid
        name
        updatedAt
        status
        inviter {
          id
          fullName
        }
        can {
          id
          gid
          destroy
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProvideSupportInvitesQuery extends Apollo.Query<ProvideSupportInvitesQueryResult, ProvideSupportInvitesQueryVariables> {
    document = ProvideSupportInvitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProvideSupportLearnersDocument = gql`
    query ProvideSupportLearners($id: Int!) {
  provideSupport(id: $id) {
    id
    learners {
      id
      active
      fullName
      email
      mobileNumber
      loginToken
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProvideSupportLearnersQuery extends Apollo.Query<ProvideSupportLearnersQueryResult, ProvideSupportLearnersQueryVariables> {
    document = ProvideSupportLearnersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProvideSupportLicenseDetailsDocument = gql`
    query ProvideSupportLicenseDetails($id: ID!) {
  node(id: $id) {
    ... on CommonLicense {
      ...CommonLicenseParts
      grantedSeats
      invitedSeats
      course {
        id
        gid
        name
      }
      uses {
        ... on Grant {
          learner: user {
            fullName
            email
            mobileNumber
          }
          gid
          status
          updatedAt
          can {
            id
            gid
            destroy
          }
        }
        ... on Invite {
          learner {
            fullName
            email
            mobileNumber
          }
          gid
          inviteStatus: status
          updatedAt
          can {
            id
            gid
            destroy
          }
        }
      }
      enrolmentKeys {
        nodes {
          id
          gid
          token
          uses
          maxUses
          expiresAt
        }
      }
    }
  }
}
    ${CommonLicensePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProvideSupportLicenseDetailsQuery extends Apollo.Query<ProvideSupportLicenseDetailsQueryResult, ProvideSupportLicenseDetailsQueryVariables> {
    document = ProvideSupportLicenseDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProvideSupportLicensesDocument = gql`
    query ProvideSupportLicenses($after: String, $first: Int, $id: Int!) {
  provideSupport(id: $id) {
    id
    licenses(after: $after, first: $first) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...SupportLicenseParts
      }
    }
  }
}
    ${SupportLicensePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProvideSupportLicensesQuery extends Apollo.Query<ProvideSupportLicensesQueryResult, ProvideSupportLicensesQueryVariables> {
    document = ProvideSupportLicensesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProvideSupportOrdersDocument = gql`
    query ProvideSupportOrders($id: Int!) {
  provideSupport(id: $id) {
    id
    orders {
      nodes {
        id
        gid
        can {
          id
          gid
          refund
        }
        total
        tax
        shipping
        totalFormatted
        createdAt
        refundedAmount
        taxFormatted
        refundedAmountFormatted
        promoCodeUses {
          id
          promoCode {
            id
            code
          }
        }
        currency {
          ...CurrencyParts
        }
      }
    }
  }
}
    ${CurrencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProvideSupportOrdersQuery extends Apollo.Query<ProvideSupportOrdersQueryResult, ProvideSupportOrdersQueryVariables> {
    document = ProvideSupportOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProvideSupportDocument = gql`
    query ProvideSupport($id: Int!) {
  provideSupport(id: $id) {
    id
    gid
    avatarUrl
    currentSignInAt
    notificationType
    email
    mobileNumber
    firstName
    fullName
    timeZone
    locale
    userAgent {
      browser {
        name
        version
      }
      os {
        name
        version
      }
    }
    can {
      id
      gid
      impersonate
      merge
      update
      sendResetPasswordInstructions
      createOfflineOrder
    }
    address {
      ...AddressParts
    }
    customValues {
      id
      gid
      value
      customField {
        id
        gid
        name
      }
    }
    storefrontRegisteredAt {
      id
      gid
      name
      url
      customFields {
        id
        gid
        name
        required
      }
    }
  }
}
    ${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProvideSupportQuery extends Apollo.Query<ProvideSupportQueryResult, ProvideSupportQueryVariables> {
    document = ProvideSupportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSurveyResultDocument = gql`
    mutation CreateSurveyResult($input: CreateSurveyResultInput!) {
  createSurveyResult(input: $input) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSurveyResultMutation extends Apollo.Mutation<CreateSurveyResultMutationResult, CreateSurveyResultMutationVariables> {
    document = CreateSurveyResultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSurveySchemaDocument = gql`
    mutation CreateSurveySchema($input: CreateSurveySchemaInput!) {
  createSurveySchema(input: $input) {
    surveySchema {
      ...SurveySchemaParts
    }
    errors {
      message
      attribute
    }
  }
}
    ${SurveySchemaPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSurveySchemaMutation extends Apollo.Mutation<CreateSurveySchemaMutationResult, CreateSurveySchemaMutationVariables> {
    document = CreateSurveySchemaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadSurveySchemaResultsDocument = gql`
    query LoadSurveySchemaResults($id: ID!) {
  node(id: $id) {
    ... on SurveySchema {
      ...SurveySchemaResultsParts
    }
  }
}
    ${SurveySchemaResultsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadSurveySchemaResultsQuery extends Apollo.Query<LoadSurveySchemaResultsQueryResult, LoadSurveySchemaResultsQueryVariables> {
    document = LoadSurveySchemaResultsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadSurveySchemaDocument = gql`
    query LoadSurveySchema($id: ID!) {
  node(id: $id) {
    ... on SurveySchema {
      ...SurveySchemaParts
    }
  }
}
    ${SurveySchemaPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadSurveySchemaQuery extends Apollo.Query<LoadSurveySchemaQueryResult, LoadSurveySchemaQueryVariables> {
    document = LoadSurveySchemaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadSurveySchemasDocument = gql`
    query LoadSurveySchemas($organizationIds: [ID!]!, $after: String, $first: Int = 250) {
  surveySchemas {
    all(organizationIds: $organizationIds, after: $after, first: $first) {
      nodes {
        ...SurveySchemaParts
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${SurveySchemaPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadSurveySchemasQuery extends Apollo.Query<LoadSurveySchemasQueryResult, LoadSurveySchemasQueryVariables> {
    document = LoadSurveySchemasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSurveySchemaDocument = gql`
    mutation UpdateSurveySchema($input: UpdateSurveySchemaInput!) {
  updateSurveySchema(input: $input) {
    surveySchema {
      ...SurveySchemaParts
    }
    errors {
      message
      attribute
    }
  }
}
    ${SurveySchemaPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSurveySchemaMutation extends Apollo.Mutation<UpdateSurveySchemaMutationResult, UpdateSurveySchemaMutationVariables> {
    document = UpdateSurveySchemaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadManageLearnersStatsDocument = gql`
    query LoadManageLearnersStats {
  invites {
    pendingCount
  }
  learners {
    unregisteredCount
    activeCount
    withOutstandingTrainingCount
  }
  grants {
    completedCount
    incompleteCount
  }
  certifications {
    expiresSoonCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadManageLearnersStatsQuery extends Apollo.Query<LoadManageLearnersStatsQueryResult, LoadManageLearnersStatsQueryVariables> {
    document = LoadManageLearnersStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadQuickBuyLicensesDocument = gql`
    query LoadQuickBuyLicenses($limit: Int = 3) {
  licenseGroups {
    lowSeats(limit: $limit) {
      gid
      availableSeats
      course {
        id
        gid
        name
        paths {
          id
          gid
          productUrl
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadQuickBuyLicensesQuery extends Apollo.Query<LoadQuickBuyLicensesQueryResult, LoadQuickBuyLicensesQueryVariables> {
    document = LoadQuickBuyLicensesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadTrainingDashboardReportIDsDocument = gql`
    query LoadTrainingDashboardReportIDs {
  dashboard {
    reports {
      activeLearnersReportId
      certificationsReportId
      learnersPendingSignupReportId
      learnerTrainingReportId
      learnersWithOutstandingTrainingReportId
      completedCoursesReportId
      incompleteCoursesReportId
      pendingInvitesReportId
      expiringCertificationsReportId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadTrainingDashboardReportIDsQuery extends Apollo.Query<LoadTrainingDashboardReportIDsQueryResult, LoadTrainingDashboardReportIDsQueryVariables> {
    document = LoadTrainingDashboardReportIDsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApplyTrainingRoleDocument = gql`
    mutation ApplyTrainingRole($input: ApplyTrainingRoleInput!) {
  applyTrainingRole(input: $input) {
    trainingRoleApplication {
      id
      gid
      status
      trainingRole {
        id
        gid
        name
      }
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApplyTrainingRoleMutation extends Apollo.Mutation<ApplyTrainingRoleMutationResult, ApplyTrainingRoleMutationVariables> {
    document = ApplyTrainingRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignMatrixTrainingDocument = gql`
    mutation assignMatrixTraining($input: AssignMatrixTrainingInput!) {
  assignMatrixTraining(input: $input) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignMatrixTrainingMutation extends Apollo.Mutation<AssignMatrixTrainingMutationResult, AssignMatrixTrainingMutationVariables> {
    document = AssignMatrixTrainingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTrainingCompetencyDocument = gql`
    mutation CreateTrainingCompetency($input: CreateTrainingCompetencyInput!) {
  createTrainingCompetency(input: $input) {
    trainingCompetency {
      ...TrainingCompetencyParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${TrainingCompetencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTrainingCompetencyMutation extends Apollo.Mutation<CreateTrainingCompetencyMutationResult, CreateTrainingCompetencyMutationVariables> {
    document = CreateTrainingCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTrainingRoleDocument = gql`
    mutation CreateTrainingRole($input: CreateTrainingRoleInput!) {
  createTrainingRole(input: $input) {
    trainingRole {
      ...TrainingRoleParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${TrainingRolePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTrainingRoleMutation extends Apollo.Mutation<CreateTrainingRoleMutationResult, CreateTrainingRoleMutationVariables> {
    document = CreateTrainingRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCoursesAvailableForTrainingMatricesDocument = gql`
    query LoadCoursesAvailableForTrainingMatrices($organizationId: ID!, $after: String, $first: Int) {
  courses {
    availableForTrainingMatrices(
      organizationId: $organizationId
      after: $after
      first: $first
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        gid
        name
        authorName
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCoursesAvailableForTrainingMatricesQuery extends Apollo.Query<LoadCoursesAvailableForTrainingMatricesQueryResult, LoadCoursesAvailableForTrainingMatricesQueryVariables> {
    document = LoadCoursesAvailableForTrainingMatricesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadLearnersForTrainingMatricesDocument = gql`
    query LoadLearnersForTrainingMatrices($after: String, $first: Int, $organizationId: ID!, $active: Boolean) {
  learners {
    all(
      after: $after
      first: $first
      organizationIds: [$organizationId]
      active: $active
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...LearnerParts
        trainingRoleApplications {
          id
          gid
          status
          trainingRole {
            id
            gid
            name
          }
        }
      }
    }
  }
}
    ${LearnerPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadLearnersForTrainingMatricesQuery extends Apollo.Query<LoadLearnersForTrainingMatricesQueryResult, LoadLearnersForTrainingMatricesQueryVariables> {
    document = LoadLearnersForTrainingMatricesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadTrainingCompetenciesDocument = gql`
    query LoadTrainingCompetencies($organizationGID: ID!) {
  node(id: $organizationGID) {
    ... on Organization {
      id
      gid
      trainingCompetencies {
        ...TrainingCompetencyParts
      }
    }
  }
}
    ${TrainingCompetencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadTrainingCompetenciesQuery extends Apollo.Query<LoadTrainingCompetenciesQueryResult, LoadTrainingCompetenciesQueryVariables> {
    document = LoadTrainingCompetenciesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadTrainingCompetencyApplicationsDocument = gql`
    query LoadTrainingCompetencyApplications($gid: ID!) {
  node(id: $gid) {
    ... on TrainingRoleApplication {
      id
      gid
      status
      learner {
        id
        gid
        fullName
      }
      trainingRole {
        id
        gid
        name
      }
      trainingCompetencyApplications {
        id
        gid
        status
        trainingCompetencyCompliances {
          id
          gid
          status
          startedAt
          completedAt
          expiresAt
          course {
            id
            gid
            name
          }
        }
        trainingCompetency {
          id
          gid
          name
          courses {
            id
            gid
            name
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadTrainingCompetencyApplicationsQuery extends Apollo.Query<LoadTrainingCompetencyApplicationsQueryResult, LoadTrainingCompetencyApplicationsQueryVariables> {
    document = LoadTrainingCompetencyApplicationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadTrainingCompetencyDetailsDocument = gql`
    query LoadTrainingCompetencyDetails($gid: ID!) {
  node(id: $gid) {
    ... on TrainingCompetency {
      ...TrainingCompetencyParts
    }
  }
}
    ${TrainingCompetencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadTrainingCompetencyDetailsQuery extends Apollo.Query<LoadTrainingCompetencyDetailsQueryResult, LoadTrainingCompetencyDetailsQueryVariables> {
    document = LoadTrainingCompetencyDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadTrainingMatrixChannelDocument = gql`
    query LoadTrainingMatrixChannel($organizationGID: ID!) {
  organizations {
    findByGid(id: $organizationGID) {
      id
      gid
      trainingMatrixChannelData {
        clientId
        channel
        token
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadTrainingMatrixChannelQuery extends Apollo.Query<LoadTrainingMatrixChannelQueryResult, LoadTrainingMatrixChannelQueryVariables> {
    document = LoadTrainingMatrixChannelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadTrainingRoleDetailsDocument = gql`
    query LoadTrainingRoleDetails($gid: ID!) {
  node(id: $gid) {
    ... on TrainingRole {
      ...TrainingRoleParts
    }
  }
}
    ${TrainingRolePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadTrainingRoleDetailsQuery extends Apollo.Query<LoadTrainingRoleDetailsQueryResult, LoadTrainingRoleDetailsQueryVariables> {
    document = LoadTrainingRoleDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadTrainingRolesDocument = gql`
    query LoadTrainingRoles($organizationGID: ID!) {
  node(id: $organizationGID) {
    ... on Organization {
      id
      gid
      trainingRoles {
        ...TrainingRoleParts
      }
    }
  }
}
    ${TrainingRolePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadTrainingRolesQuery extends Apollo.Query<LoadTrainingRolesQueryResult, LoadTrainingRolesQueryVariables> {
    document = LoadTrainingRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshMatrixLearnerDocument = gql`
    query RefreshMatrixLearner($id: ID!) {
  learners {
    find(id: $id) {
      ...LearnerParts
      trainingRoleApplications {
        ...TrainingRoleApplicationParts
        trainingCompetencyApplications {
          ...TrainingCompetencyApplicationParts
          trainingCompetencyCompliances {
            ...TrainingCompetencyComplianceParts
            course {
              id
              gid
              name
            }
          }
        }
        trainingRole {
          ...TrainingRoleParts
        }
      }
    }
  }
}
    ${LearnerPartsFragmentDoc}
${TrainingRoleApplicationPartsFragmentDoc}
${TrainingCompetencyApplicationPartsFragmentDoc}
${TrainingCompetencyCompliancePartsFragmentDoc}
${TrainingRolePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshMatrixLearnerQuery extends Apollo.Query<RefreshMatrixLearnerQueryResult, RefreshMatrixLearnerQueryVariables> {
    document = RefreshMatrixLearnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTrainingCompetencyDocument = gql`
    mutation UpdateTrainingCompetency($input: UpdateTrainingCompetencyInput!) {
  updateTrainingCompetency(input: $input) {
    trainingCompetency {
      ...TrainingCompetencyParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${TrainingCompetencyPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTrainingCompetencyMutation extends Apollo.Mutation<UpdateTrainingCompetencyMutationResult, UpdateTrainingCompetencyMutationVariables> {
    document = UpdateTrainingCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTrainingRoleDocument = gql`
    mutation UpdateTrainingRole($input: UpdateTrainingRoleInput!) {
  updateTrainingRole(input: $input) {
    trainingRole {
      ...TrainingRoleParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${TrainingRolePartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTrainingRoleMutation extends Apollo.Mutation<UpdateTrainingRoleMutationResult, UpdateTrainingRoleMutationVariables> {
    document = UpdateTrainingRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnrolmentKeyUsageDetailsDocument = gql`
    query EnrolmentKeyUsageDetails($id: ID!) {
  node(id: $id) {
    ... on EnrolmentKey {
      id
      gid
      grants {
        nodes {
          id
          gid
          status
          createdAt
          user {
            id
            gid
            fullName
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnrolmentKeyUsageDetailsQuery extends Apollo.Query<EnrolmentKeyUsageDetailsQueryResult, EnrolmentKeyUsageDetailsQueryVariables> {
    document = EnrolmentKeyUsageDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCertificationDefaultDocument = gql`
    query LoadCertificationDefault {
  viewer {
    id
    certificationDefault {
      id
      gid
      name
      customSignature {
        url
        path
        bytes
        contentType
        geometry
        signature
      }
      customLogo {
        url
        path
        bytes
        contentType
        geometry
        signature
      }
      address {
        ...AddressParts
      }
    }
  }
}
    ${AddressPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCertificationDefaultQuery extends Apollo.Query<LoadCertificationDefaultQueryResult, LoadCertificationDefaultQueryVariables> {
    document = LoadCertificationDefaultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCertificationDefaultDocument = gql`
    mutation UpdateCertificationDefault($input: UpdateCertificationDefaultInput!) {
  updateCertificationDefault(input: $input) {
    certificationDefault {
      id
      gid
      name
      customSignature {
        url
        path
        bytes
        contentType
        geometry
        signature
      }
      customLogo {
        url
        path
        bytes
        contentType
        geometry
        signature
      }
      address {
        id
        address1
        address2
        city
        postalCode
        country {
          code
        }
        province {
          code
        }
      }
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCertificationDefaultMutation extends Apollo.Mutation<UpdateCertificationDefaultMutationResult, UpdateCertificationDefaultMutationVariables> {
    document = UpdateCertificationDefaultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateArchivedNodesDocument = gql`
    mutation UpdateArchivedNodes($input: UpdateArchivedNodesInput!) {
  updateArchivedNodes(input: $input) {
    nodes {
      id
      gid
      archived
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateArchivedNodesMutation extends Apollo.Mutation<UpdateArchivedNodesMutationResult, UpdateArchivedNodesMutationVariables> {
    document = UpdateArchivedNodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptTermsOfServiceDocument = gql`
    mutation AcceptTermsOfService($input: AcceptTermsOfServiceInput!) {
  acceptTermsOfService(input: $input) {
    termsOfServiceUserAgreement {
      id
      gid
      termsOfService {
        id
        gid
        agreed @client
        userAgreements {
          id
          gid
          createdAt
        }
      }
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptTermsOfServiceMutation extends Apollo.Mutation<AcceptTermsOfServiceMutationResult, AcceptTermsOfServiceMutationVariables> {
    document = AcceptTermsOfServiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) {
    user {
      id
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePasswordMutation extends Apollo.Mutation<ChangePasswordMutationResult, ChangePasswordMutationVariables> {
    document = ChangePasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClearImpersonationDocument = gql`
    mutation ClearImpersonation {
  clearImpersonation(input: {}) {
    success
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClearImpersonationMutation extends Apollo.Mutation<ClearImpersonationMutationResult, ClearImpersonationMutationVariables> {
    document = ClearImpersonationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmContactMethodDocument = gql`
    mutation ConfirmContactMethod($input: ConfirmContactMethodInput!) {
  confirmContactMethod(input: $input) {
    contactMethod {
      id
      gid
      value
      confirmed
      confirmedAt
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmContactMethodMutation extends Apollo.Mutation<ConfirmContactMethodMutationResult, ConfirmContactMethodMutationVariables> {
    document = ConfirmContactMethodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMfaMethodDocument = gql`
    mutation createMfaMethod($input: CreateMFAMethodInput!) {
  createMfaMethod(input: $input) {
    mfaMethod {
      id
      gid
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMfaMethodMutation extends Apollo.Mutation<CreateMfaMethodMutationResult, CreateMfaMethodMutationVariables> {
    document = CreateMfaMethodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserMemoryDocument = gql`
    mutation createUserMemory($input: CreateUserMemoryInput!) {
  createUserMemory(input: $input) {
    userMemory {
      id
      gid
      name
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserMemoryMutation extends Apollo.Mutation<CreateUserMemoryMutationResult, CreateUserMemoryMutationVariables> {
    document = CreateUserMemoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HandleInviteDocument = gql`
    mutation HandleInvite($input: HandleInviteInput!) {
  handleInvite(input: $input) {
    invite {
      id
      name
      status
      handled
      inviter {
        id
        fullName
      }
    }
    errors {
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HandleInviteMutation extends Apollo.Mutation<HandleInviteMutationResult, HandleInviteMutationVariables> {
    document = HandleInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImpersonateUserDocument = gql`
    mutation ImpersonateUser($input: ImpersonateUserInput!) {
  impersonateUser(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImpersonateUserMutation extends Apollo.Mutation<ImpersonateUserMutationResult, ImpersonateUserMutationVariables> {
    document = ImpersonateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadCurrentUserDocument = gql`
    query LoadCurrentUser {
  viewer {
    id
    gid
    firstName
    lastName
    fullName
    email
    mobileNumber
    notificationType
    timeZone
    locale
    lastSignInAt
    name @client
    roles
    persona
    allowVenomOptOut
    hasStripeSubscriptions
    mightBeTrainingManager
    currencies
    memories {
      id
      gid
      name
      value
    }
    address {
      ...AddressParts
    }
    can {
      id
      gid
      sidekiq
      admin
      trainingManager
      ilManager
      instructor
      createIlCourse
      createIlClass
      createIlLocation
      createInstructor
      provideSupport
      vend
      resell
      author
      survey
      grade
      ecommerceUpgrade
      managePaymentInformation
      reportOnRegulatorSubmissions
      reportOnPlatformUsage
      reportOnCourseCompletions
      changePassword
      createOrganization
      visitClassic
      manageTrainingMatrices
      showLedger
      exportLedger
    }
    certificationDefault {
      id
      gid
      name
    }
    contactMethods {
      id
      gid
      value
      notificationType
      confirmedAt
      confirmed
    }
    receivedInvites(onlyUnhandled: true) {
      id
      gid
      name
      status
      handled
      inviter {
        id
        gid
        fullName
      }
    }
    customValues {
      id
      gid
      customFieldId
      value
      required
    }
    courseRequirements {
      ... on CustomFieldCourseRequirement {
        id
        gid
        type
        satisfied
        customFields {
          id
          gid
          name
        }
        course {
          id
          gid
          name
        }
      }
      ... on EmailCourseRequirement {
        id
        gid
        type
        satisfied
        course {
          id
          gid
          name
        }
      }
      ... on AddressCourseRequirement {
        id
        gid
        type
        satisfied
        course {
          id
          gid
          name
        }
      }
      ... on PrerequisiteCourseRequirement {
        id
        gid
        type
        requirementType
        requirementQuantity
        courses {
          id
          gid
          name
        }
      }
    }
    pendingTermsOfServices {
      id
      gid
      name
      fileUrl
    }
    impersonatedBy {
      id
      gid
      fullName
    }
  }
  currentStorefront {
    ...StorefrontParts
  }
  timeZones
  locales
  minimumPasswordComplexity
}
    ${AddressPartsFragmentDoc}
${StorefrontPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadCurrentUserQuery extends Apollo.Query<LoadCurrentUserQueryResult, LoadCurrentUserQueryVariables> {
    document = LoadCurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadMfaMethodsDocument = gql`
    query LoadMFAMethods {
  mfaMethods {
    id
    gid
    lastUsedAt
    verifiedAt
    contactMethod {
      id
      gid
      notificationType
      value
    }
    can {
      verify
      destroy
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadMfaMethodsQuery extends Apollo.Query<LoadMfaMethodsQueryResult, LoadMfaMethodsQueryVariables> {
    document = LoadMfaMethodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadMfaTrustedDevicesDocument = gql`
    query LoadMFATrustedDevices {
  mfaTrustedDevices {
    id
    gid
    description
    createdAt
    lastUsedAt
    expiresAt
    can {
      id
      gid
      destroy
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadMfaTrustedDevicesQuery extends Apollo.Query<LoadMfaTrustedDevicesQueryResult, LoadMfaTrustedDevicesQueryVariables> {
    document = LoadMfaTrustedDevicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MakeTrainingManagerDocument = gql`
    mutation MakeTrainingManager($input: MakeTrainingManagerInput!) {
  makeTrainingManager(input: $input) {
    user {
      id
      gid
      name
      roles
      certificationDefault {
        id
        gid
        name
      }
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MakeTrainingManagerMutation extends Apollo.Mutation<MakeTrainingManagerMutationResult, MakeTrainingManagerMutationVariables> {
    document = MakeTrainingManagerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendConfirmationCodeDocument = gql`
    mutation ResendConfirmationCode($input: ResendConfirmationCodeInput!) {
  resendConfirmationCode(input: $input) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendConfirmationCodeMutation extends Apollo.Mutation<ResendConfirmationCodeMutationResult, ResendConfirmationCodeMutationVariables> {
    document = ResendConfirmationCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignOutDocument = gql`
    mutation SignOut($input: SignOutInput!) {
  signOut(input: $input) {
    success
    redirectTo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignOutMutation extends Apollo.Mutation<SignOutMutationResult, SignOutMutationVariables> {
    document = SignOutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    user {
      id
      gid
      firstName
      lastName
      fullName
      email
      mobileNumber
      notificationType
      timeZone
      locale
      allowVenomOptOut
      address {
        id
        address1
        address2
        city
        country {
          name
          code
        }
        province {
          name
          code
        }
        postalCode
      }
      contactMethods {
        id
        gid
        value
        notificationType
        confirmedAt
        confirmed
      }
      customValues {
        id
        gid
        customFieldId
        value
        required
      }
      courseRequirements {
        ... on CustomFieldCourseRequirement {
          type
          satisfied
          customFields {
            id
            gid
            name
          }
          course {
            id
            gid
            name
          }
        }
        ... on EmailCourseRequirement {
          type
          satisfied
          course {
            id
            gid
            name
          }
        }
        ... on AddressCourseRequirement {
          type
          satisfied
          course {
            id
            gid
            name
          }
        }
      }
    }
    errors {
      attribute
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserMutation extends Apollo.Mutation<UpdateUserMutationResult, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MergeUsersDocument = gql`
    mutation MergeUsers($input: MergeUsersInput!) {
  mergeUsers(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MergeUsersMutation extends Apollo.Mutation<MergeUsersMutationResult, MergeUsersMutationVariables> {
    document = MergeUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($input: RequestPasswordResetInput!) {
  requestPasswordReset(input: $input) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestPasswordResetMutation extends Apollo.Mutation<RequestPasswordResetMutationResult, RequestPasswordResetMutationVariables> {
    document = RequestPasswordResetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchUsersWithIlClassAccessDocument = gql`
    query SearchUsersWithILClassAccess($ilClassId: ID!, $query: String!) {
  users {
    searchByIlClassAccess(ilClassId: $ilClassId, query: $query) {
      nodes {
        gid
        id
        firstName
        lastName
        email
        mobileNumber
        ilBookings(ilClassId: $ilClassId) {
          id
          gid
        }
        grantsAvailableForClass(ilClassId: $ilClassId) {
          id
          gid
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUsersWithIlClassAccessQuery extends Apollo.Query<SearchUsersWithIlClassAccessQueryResult, SearchUsersWithIlClassAccessQueryVariables> {
    document = SearchUsersWithIlClassAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchUsersDocument = gql`
    query SearchUsers($query: String!, $limit: Int = 50) {
  searchUsers(query: $query, limit: $limit) {
    id
    gid
    avatarUrl
    firstName
    fullName
    email
    mobileNumber
    currentSignInAt
    roles
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUsersQuery extends Apollo.Query<SearchUsersQueryResult, SearchUsersQueryVariables> {
    document = SearchUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IssueVerifiedCredentialDocument = gql`
    mutation IssueVerifiedCredential($input: IssueVerifiedCredentialInput!) {
  issueVerifiedCredential(input: $input) {
    url
    appUrl
    channelData {
      channel
      token
      clientId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IssueVerifiedCredentialMutation extends Apollo.Mutation<IssueVerifiedCredentialMutationResult, IssueVerifiedCredentialMutationVariables> {
    document = IssueVerifiedCredentialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadVerifiedCredentialIssuersDocument = gql`
    query LoadVerifiedCredentialIssuers($id: Int!) {
  organizations {
    findById(id: $id) {
      id
      gid
      verifiedCredentialIssuers {
        ...VerifiedCredentialIssuerParts
      }
    }
  }
}
    ${VerifiedCredentialIssuerPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadVerifiedCredentialIssuersQuery extends Apollo.Query<LoadVerifiedCredentialIssuersQueryResult, LoadVerifiedCredentialIssuersQueryVariables> {
    document = LoadVerifiedCredentialIssuersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestVerifiedCredentialPresentationDocument = gql`
    mutation RequestVerifiedCredentialPresentation($input: RequestVerifiedCredentialPresentationInput!) {
  requestVerifiedCredentialPresentation(input: $input) {
    url
    appUrl
    channelData {
      channel
      token
      clientId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestVerifiedCredentialPresentationMutation extends Apollo.Mutation<RequestVerifiedCredentialPresentationMutationResult, RequestVerifiedCredentialPresentationMutationVariables> {
    document = RequestVerifiedCredentialPresentationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateVerifiedCredentialIssuerDocument = gql`
    mutation UpdateVerifiedCredentialIssuer($input: UpdateVerifiedCredentialIssuerInput!) {
  updateVerifiedCredentialIssuer(input: $input) {
    verifiedCredentialIssuer {
      ...VerifiedCredentialIssuerParts
    }
    errors {
      message
    }
  }
}
    ${VerifiedCredentialIssuerPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateVerifiedCredentialIssuerMutation extends Apollo.Mutation<UpdateVerifiedCredentialIssuerMutationResult, UpdateVerifiedCredentialIssuerMutationVariables> {
    document = UpdateVerifiedCredentialIssuerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Archivable": [
      "Certification",
      "Grant"
    ],
    "CalculableUnion": [
      "DynamicContract",
      "MonthlyActiveUsersRateContract",
      "MonthlyCourseDistributionRateContract",
      "OneTimeFeeContract",
      "RecurringFlatFeeContract",
      "ScormCourseRateContract",
      "StripeTransactionFeeContract"
    ],
    "Commentable": [
      "ILBooking",
      "User"
    ],
    "CommonLicense": [
      "License",
      "LicenseGroup"
    ],
    "ContractCalculable": [
      "DynamicContract",
      "MonthlyActiveUsersRateContract",
      "MonthlyCourseDistributionRateContract",
      "OneTimeFeeContract",
      "RecurringFlatFeeContract",
      "ScormCourseRateContract",
      "StripeTransactionFeeContract"
    ],
    "CourseRequirement": [
      "AddressCourseRequirement",
      "CustomFieldCourseRequirement",
      "EmailCourseRequirement",
      "PrerequisiteCourseRequirement"
    ],
    "CourseRequirementInterface": [
      "AddressCourseRequirement",
      "CustomFieldCourseRequirement",
      "EmailCourseRequirement",
      "PrerequisiteCourseRequirement"
    ],
    "CredentialConfiguration": [
      "MicrosoftEntraCredentialConfiguration",
      "TractionCredentialConfiguration"
    ],
    "Discussable": [
      "Course",
      "CourseItemProgression",
      "ILClass"
    ],
    "HasCustomAttributes": [
      "Course",
      "Product",
      "ProductBundle"
    ],
    "ILLocationInterface": [
      "ILLocation",
      "ILOnlineLocation",
      "ILPhysicalLocation"
    ],
    "LearnerVerifiable": [
      "Certification",
      "Grant"
    ],
    "LicenseUse": [
      "Grant",
      "Invite"
    ],
    "Ownable": [
      "Course",
      "ILCourse",
      "License",
      "LicenseGroup",
      "NitoBank",
      "NitoExam",
      "PlatformUsageItem",
      "Storefront"
    ],
    "PayoutRefundable": [
      "RefundItem",
      "StripeRefund"
    ],
    "RedirectTo": [
      "DownloadableFile",
      "Page",
      "Product",
      "ProductBundle",
      "StaticPath"
    ],
    "RelayNode": [
      "AccessSubscription",
      "Address",
      "AddressCourseRequirement",
      "AutomationConstant",
      "AutomationLog",
      "AutomationScript",
      "CartItem",
      "Certification",
      "CertificationChangeRequest",
      "CertificationDefault",
      "CertificationTemplate",
      "Comment",
      "ConnectedStripeAccount",
      "ContactMethod",
      "Contract",
      "ContractRevenue",
      "Course",
      "CourseAgreement",
      "CourseDeprecation",
      "CourseItem",
      "CourseItemProgression",
      "CourseProgression",
      "CourseProgressionResource",
      "CoursePrompt",
      "CourseUserAgreement",
      "CustomAttribute",
      "CustomDomain",
      "CustomField",
      "CustomFieldCourseRequirement",
      "CustomFieldOption",
      "CustomValue",
      "DiscussionMessage",
      "DownloadableFile",
      "DynamicContract",
      "EmailCourseRequirement",
      "EnrolmentKey",
      "GradedAssignmentSettings",
      "GradedAssignmentSubmission",
      "Grader",
      "Grant",
      "ILBooking",
      "ILClass",
      "ILClassResult",
      "ILCourse",
      "ILCourseItem",
      "ILLocation",
      "ILOnlineLocation",
      "ILPhysicalLocation",
      "ILSession",
      "Instructor",
      "InstructorCredential",
      "InstructorILCoursePermission",
      "Integration",
      "Invite",
      "LITSalesReportOrderItem",
      "LearnerVerifiedSession",
      "License",
      "LicenseGroup",
      "LicensePack",
      "LicensePackUse",
      "LightUser",
      "MFAMethod",
      "MFATrustedDevice",
      "MenuItem",
      "MicrosoftEntraCredentialConfiguration",
      "MonthlyActiveUsersRateContract",
      "MonthlyCourseDistributionRateContract",
      "NitoBank",
      "NitoExam",
      "OIDCProvider",
      "OfflineOrder",
      "OneTimeFeeContract",
      "Order",
      "OrderItem",
      "Organization",
      "OrganizationMembership",
      "Owner",
      "Page",
      "Payout",
      "PendingILBookingReservation",
      "PlatformUsageItem",
      "PrerequisiteCourseRequirement",
      "Price",
      "Product",
      "ProductBundle",
      "ProductDefault",
      "PromoCode",
      "PromoCodeClaim",
      "PromoCodeDiscount",
      "PromoCodeUse",
      "RapidqlSchedule",
      "RecurringFlatFeeContract",
      "Redirect",
      "Refund",
      "RefundItem",
      "RegulatorSubmission",
      "RegulatorSubmissionCompletion",
      "ResellerAgreement",
      "ResourceLink",
      "Rule",
      "SAMLProvider",
      "SalesReportOrderItem",
      "SavedQuery",
      "ScormCourseRateContract",
      "SentEmail",
      "SharedProduct",
      "ShippingInformation",
      "ShippingItem",
      "ShoppingCartShippingInformation",
      "StaticPath",
      "Storefront",
      "StorefrontTemplate",
      "StripeCustomer",
      "StripeInvoicePayment",
      "StripePlan",
      "StripeProduct",
      "StripeRefund",
      "StripeSubscription",
      "StripeTransactionFeeContract",
      "SupportCourse",
      "SupportCourseItemProgression",
      "SupportCourseProgression",
      "SupportGrant",
      "SupportLicense",
      "SupportedUser",
      "SurveyResult",
      "SurveySchema",
      "TagField",
      "TaxItem",
      "TermsOfService",
      "TermsOfServiceUserAgreement",
      "Theme",
      "TractionCredentialConfiguration",
      "TrainingCompetency",
      "TrainingCompetencyApplication",
      "TrainingCompetencyCompliance",
      "TrainingRole",
      "TrainingRoleApplication",
      "UsageSubscription",
      "User",
      "UserMemory",
      "VerifiedCredential",
      "VerifiedCredentialIssuer",
      "View"
    ],
    "Revenue": [
      "OrganizationCommissionsRevenue",
      "OrganizationCourseDistributionRevenue",
      "OrganizationPlatformLicensesRevenue",
      "OrganizationRoyaltiesRevenue",
      "OrganizationRoyaltiesTaxesRevenue",
      "OrganizationTransactionFeesRevenue",
      "StorefrontCourseDistributionRevenue",
      "StorefrontFederalTaxRevenue",
      "StorefrontILTrainingRevenue",
      "StorefrontOnlineTrainingRevenue",
      "StorefrontPhysicalProductRevenue",
      "StorefrontPlatformSetupRevenue",
      "StorefrontPromoCodeSavingRevenue",
      "StorefrontProvincialTaxRevenue",
      "StorefrontRecurringFlatFeeRevenue",
      "StorefrontRefundRevenue",
      "StorefrontShippingRevenue",
      "StorefrontSubscriptionRevenue",
      "StorefrontThirdPartyPayoutRevenue",
      "StorefrontTransactionFeesRevenue"
    ],
    "SchedulableUnion": [
      "SavedQuery"
    ],
    "SoftDestroyable": [
      "EnrolmentKey",
      "Grant"
    ],
    "StripeRefundRefundable": [
      "Order",
      "StripeSubscription"
    ],
    "StripeSubscriptionInterface": [
      "AccessSubscription",
      "StripeSubscription",
      "UsageSubscription"
    ],
    "Taggable": [
      "Certification",
      "Course",
      "Product",
      "ProductBundle",
      "User"
    ],
    "TermsOfServiceAgreeable": [
      "VerifiedCredentialIssuer"
    ]
  }
};
      export default result;
    